// this has some weirdness taken out to make this work as an ES6 module

/*
Copyright (c) 2003-2008 Terence Parr. All rights reserved.
Code licensed under the BSD License:
http://www.antlr.org/license.html

Some parts of the ANTLR class:
Copyright (c) 2008, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://developer.yahoo.net/yui/license.txt
*/
/*
Some portions:
Copyright (c) 2008, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://developer.yahoo.net/yui/license.txt
version: 2.5.1
*/

var org = { };
org.antlr = { };
org.antlr.global = { };
org.antlr.runtime = { };
org.antlr.runtime.tree = { };

/**
 * Returns the namespace specified and creates it if it doesn't exist.
 *
 * Be careful when naming packages. Reserved words may work in some browsers
 * and not others. For instance, the following will fail in Safari:
 * <pre>
 * org.antlr.namespace("really.long.nested.namespace");
 * </pre>
 * This fails because "long" is a future reserved word in ECMAScript
 *
 * @static
 * @param  {String*} arguments 1-n namespaces to create 
 * @return {Object}  A reference to the last namespace object created
 * @example
 * org.antlr.namespace("org.antlr.property.package");
 */
org.antlr.namespace = function() {
    var a=arguments, o=null, i, j, d;
    for (i=0; i<a.length; i=i+1) {
        d=a[i].split(".");
        o=org.antlr.global;

        // ANTLR is implied, so it is ignored if it is included
        for (j=0; j<d.length; j=j+1) {
            o[d[j]]=o[d[j]] || {};
            o=o[d[j]];
        }
    }

    return o;
};

/**
 * org.antlr.env is used to keep track of what is known about the library and
 * the browsing environment
 * @namespace org.antlr.env
 */
org.antlr.env = org.antlr.env || {};

/**
 * Do not fork for a browser if it can be avoided.  Use feature detection when
 * you can.  Use the user agent as a last resort.  org.antlr.env.ua stores a
 * version number for the browser engine, 0 otherwise.  This value may or may
 * not map to the version number of the browser using the engine.  The value is 
 * presented as a float so that it can easily be used for boolean evaluation 
 * as well as for looking for a particular range of versions.  Because of this, 
 * some of the granularity of the version info may be lost (e.g., Gecko 1.8.0.9 
 * reports 1.8).
 * @namespace org.antlr.env.ua
 */
org.antlr.env.ua = function() {
    var o= /** @lends org.antlr.env.ua */ {

        /**
         * Internet Explorer version number or 0.  Example: 6
         * @property ie
         * @type float
         */
        ie:0,

        /**
         * Opera version number or 0.  Example: 9.2
         * @property opera
         * @type float
         */
        opera:0,

        /**
         * Gecko engine revision number.  Will evaluate to 1 if Gecko 
         * is detected but the revision could not be found. Other browsers
         * will be 0.  Example: 1.8
         * <pre>
         * Firefox 1.0.0.4: 1.7.8   <-- Reports 1.7
         * Firefox 1.5.0.9: 1.8.0.9 <-- Reports 1.8
         * Firefox 2.0.0.3: 1.8.1.3 <-- Reports 1.8
         * Firefox 3 alpha: 1.9a4   <-- Reports 1.9
         * </pre>
         * @property gecko
         * @type float
         */
        gecko:0,

        /**
         * AppleWebKit version.  KHTML browsers that are not WebKit browsers 
         * will evaluate to 1, other browsers 0.  Example: 418.9.1
         * <pre>
         * Safari 1.3.2 (312.6): 312.8.1 <-- Reports 312.8 -- currently the 
         *                                   latest available for Mac OSX 10.3.
         * Safari 2.0.2:         416     <-- hasOwnProperty introduced
         * Safari 2.0.4:         418     <-- preventDefault fixed
         * Safari 2.0.4 (419.3): 418.9.1 <-- One version of Safari may run
         *                                   different versions of webkit
         * Safari 2.0.4 (419.3): 419     <-- Tiger installations that have been
         *                                   updated, but not updated
         *                                   to the latest patch.
         * Webkit 212 nightly:   522+    <-- Safari 3.0 precursor (with native SVG
         *                                   and many major issues fixed).  
         * 3.x yahoo.com, flickr:422     <-- Safari 3.x hacks the user agent
         *                                   string when hitting yahoo.com and 
         *                                   flickr.com.
         * Safari 3.0.4 (523.12):523.12  <-- First Tiger release - automatic update
         *                                   from 2.x via the 10.4.11 OS patch
         * Webkit nightly 1/2008:525+    <-- Supports DOMContentLoaded event.
         *                                   yahoo.com user agent hack removed.
         *                                   
         * </pre>
         * http://developer.apple.com/internet/safari/uamatrix.html
         * @property webkit
         * @type float
         */
        webkit: 0,

        /**
         * The mobile property will be set to a string containing any relevant
         * user agent information when a modern mobile browser is detected.
         * Currently limited to Safari on the iPhone/iPod Touch, Nokia N-series
         * devices with the WebKit-based browser, and Opera Mini.  
         * @property mobile 
         * @type string
         */
        mobile: null,

        /**
         * Adobe AIR version number or 0.  Only populated if webkit is detected.
         * Example: 1.0
         * @property air
         * @type float
         */
        air: 0,

        /**
         * Is this the Rhino interpreter?
         * @property rhino
         * @type Boolean
         */
        rhino: false

    };

    var ua, m;

    try {
        ua = navigator.userAgent;

        // Modern KHTML browsers should qualify as Safari X-Grade
        if ((/KHTML/).test(ua)) {
            o.webkit=1;
        }
        // Modern WebKit browsers are at least X-Grade
        m=ua.match(/AppleWebKit\/([^\s]*)/);
        if (m&&m[1]) {
            o.webkit=parseFloat(m[1]);

            // Mobile browser check
            if (/ Mobile\//.test(ua)) {
                o.mobile = "Apple"; // iPhone or iPod Touch
        } else {
            m=ua.match(/NokiaN[^\/]*/);
            if (m) {
                o.mobile = m[0]; // Nokia N-series, ex: NokiaN95
            }
        }

        m=ua.match(/AdobeAIR\/([^\s]*)/);
        if (m) {
            o.air = m[0]; // Adobe AIR 1.0 or better
        }

        }

        if (!o.webkit) { // not webkit
            // @todo check Opera/8.01 (J2ME/MIDP; Opera Mini/2.0.4509/1316; fi; U; ssr)
            m=ua.match(/Opera[\s\/]([^\s]*)/);
            if (m&&m[1]) {
                o.opera=parseFloat(m[1]);
                m=ua.match(/Opera Mini[^;]*/);
            if (m) {
                o.mobile = m[0]; // ex: Opera Mini/2.0.4509/1316
            }
            } else { // not opera or webkit
                m=ua.match(/MSIE\s([^;]*)/);
                if (m&&m[1]) {
                    o.ie=parseFloat(m[1]);
                } else { // not opera, webkit, or ie
                    m=ua.match(/Gecko\/([^\s]*)/);
                    if (m) {
                        o.gecko=1; // Gecko detected, look for revision
                        m=ua.match(/rv:([^\s\)]*)/);
                        if (m&&m[1]) {
                            o.gecko=parseFloat(m[1]);
                        }
                    }
                }
            }
        }
    } catch(e) {
        // ignore this if we're not in a browser
    }

    try {
        if (typeof window=="undefined" && loadClass) {
            o.rhino = true;
        }
    } catch(e) {}

    
    return o;
}();

/**
 * JavaScript runtime library code.
 * @name org.antlr.runtime
 * @namespace
 */
/**
 * JavaScript runtime library tree parser code.
 * @name org.antlr.runtime.tree
 * @namespace
 */
org.antlr.namespace("org.antlr.runtime.tree");

/**
 * Provides the language utilites and extensions used by the library
 * @namespace org.antlr.lang
 */
org.antlr.lang = org.antlr.lang || /** @lends org.antlr.lang */ {
    /**
     * Determines whether or not the provided object is an array.
     * Testing typeof/instanceof/constructor of arrays across frame 
     * boundaries isn't possible in Safari unless you have a reference
     * to the other frame to test against its Array prototype.  To
     * handle this case, we test well-known array properties instead.
     * properties.
     * @param {any} o The object being testing
     * @return {boolean} the result
     */
    isArray: function(o) { 
        if (o) {
           var l = org.antlr.lang;
           return l.isNumber(o.length) && l.isFunction(o.splice);
        }
        return false;
    },

    /**
     * Determines whether or not the provided object is a boolean
     * @param {any} o The object being testing
     * @return {boolean} the result
     */
    isBoolean: function(o) {
        return typeof o === 'boolean';
    },
    
    /**
     * Determines whether or not the provided object is a function
     * @param {any} o The object being testing
     * @return {boolean} the result
     */
    isFunction: function(o) {
        return typeof o === 'function';
    },
        
    /**
     * Determines whether or not the provided object is null
     * @param {any} o The object being testing
     * @return {boolean} the result
     */
    isNull: function(o) {
        return o === null;
    },
        
    /**
     * Determines whether or not the provided object is a legal number
     * @param {any} o The object being testing
     * @return {boolean} the result
     */
    isNumber: function(o) {
        return typeof o === 'number' && isFinite(o);
    },
      
    /**
     * Determines whether or not the provided object is of type object
     * or function
     * @param {any} o The object being testing
     * @return {boolean} the result
     */  
    isObject: function(o) {
return (o && (typeof o === 'object' || org.antlr.lang.isFunction(o))) || false;
    },
        
    /**
     * Determines whether or not the provided object is a string
     * @param {any} o The object being testing
     * @return {boolean} the result
     */
    isString: function(o) {
        return typeof o === 'string';
    },
        
    /**
     * Determines whether or not the provided object is undefined
     * @param {any} o The object being testing
     * @return {boolean} the result
     */
    isUndefined: function(o) {
        return typeof o === 'undefined';
    },
    
    /**
     * IE will not enumerate native functions in a derived object even if the
     * function was overridden.  This is a workaround for specific functions 
     * we care about on the Object prototype. 
     * @param {Function} r  the object to receive the augmentation
     * @param {Function} s  the object that supplies the properties to augment
     * @private
     */
    _IEEnumFix: function(r, s) {
        if (org.antlr.env.ua.ie) {
            var add=["toString", "valueOf"], i;
            for (i=0;i<add.length;i=i+1) {
                var fname=add[i],f=s[fname];
                if (org.antlr.lang.isFunction(f) && f!=Object.prototype[fname]) {
                    r[fname]=f;
                }
            }
        }
    },
       
    /**
     * Utility to set up the prototype, constructor and superclass properties to
     * support an inheritance strategy that can chain constructors and methods.
     * Static members will not be inherited.
     *
     * @method extend
     * @static
     * @param {Function} subc   the object to modify
     * @param {Function} superc the object to inherit
     * @param {Object} [overrides]  additional properties/methods to add to the
     *                              subclass prototype.  These will override the
     *                              matching items obtained from the superclass 
     *                              if present.
     */
    extend: function(subc, superc, overrides) {
        if (!superc||!subc) {
            throw new Error("org.antlr.lang.extend failed, please check that " +
                            "all dependencies are included.");
        }
        var F = function() {};
        F.prototype=superc.prototype;
        subc.prototype=new F();
        subc.prototype.constructor=subc;
        subc.superclass=superc.prototype;
        if (superc.prototype.constructor == Object.prototype.constructor) {
            superc.prototype.constructor=superc;
        }
    
        if (overrides) {
            for (var i in overrides) {
                subc.prototype[i]=overrides[i];
            }

            org.antlr.lang._IEEnumFix(subc.prototype, overrides);
        }
    },
   
    /**
     * Applies all properties in the supplier to the receiver if the
     * receiver does not have these properties yet.  Optionally, one or 
     * more methods/properties can be specified (as additional 
     * parameters).  This option will overwrite the property if receiver 
     * has it already.  If true is passed as the third parameter, all 
     * properties will be applied and _will_ overwrite properties in 
     * the receiver.
     *
     * @param {Function} r  the object to receive the augmentation
     * @param {Function} s  the object that supplies the properties to augment
     * @param {String*|boolean}  [arguments] zero or more properties methods 
     *        to augment the receiver with.  If none specified, everything
     *        in the supplier will be used unless it would
     *        overwrite an existing property in the receiver. If true
     *        is specified as the third parameter, all properties will
     *        be applied and will overwrite an existing property in
     *        the receiver
     */
    augmentObject: function(r, s) {
        if (!s||!r) {
            throw new Error("Absorb failed, verify dependencies.");
        }
        var a=arguments, i, p, override=a[2];
        if (override && override!==true) { // only absorb the specified properties
            for (i=2; i<a.length; i=i+1) {
                r[a[i]] = s[a[i]];
            }
        } else { // take everything, overwriting only if the third parameter is true
            for (p in s) { 
                if (override || !r[p]) {
                    r[p] = s[p];
                }
            }
            
            org.antlr.lang._IEEnumFix(r, s);
        }
    },
 
    /**
     * Same as org.antlr.lang.augmentObject, except it only applies prototype properties
     * @see org.antlr.lang.augmentObject
     * @param {Function} r  the object to receive the augmentation
     * @param {Function} s  the object that supplies the properties to augment
     * @param {String*|boolean}  [arguments] zero or more properties methods 
     *        to augment the receiver with.  If none specified, everything 
     *        in the supplier will be used unless it would overwrite an existing 
     *        property in the receiver.  if true is specified as the third 
     *        parameter, all properties will be applied and will overwrite an 
     *        existing property in the receiver
     */
    augmentProto: function(r, s) {
        if (!s||!r) {
            throw new Error("Augment failed, verify dependencies.");
        }
        //var a=[].concat(arguments);
        var a=[r.prototype,s.prototype];
        for (var i=2;i<arguments.length;i=i+1) {
            a.push(arguments[i]);
        }
        org.antlr.lang.augmentObject.apply(this, a);
    },

    /**
     * Returns a new object containing all of the properties of
     * all the supplied objects.  The properties from later objects
     * will overwrite those in earlier objects.
     * @param arguments {Object*} the objects to merge
     * @return the new merged object
     */
    merge: function() {
        var o={}, a=arguments;
        for (var i=0, l=a.length; i<l; i=i+1) {
            org.antlr.lang.augmentObject(o, a[i], true);
        }
        return o;
    },

    /**
     * A convenience method for detecting a legitimate non-null value.
     * Returns false for null/undefined/NaN, true for other values, 
     * including 0/false/''
     * @param o {any} the item to test
     * @return {boolean} true if it is not null/undefined/NaN || false
     */
    isValue: function(o) {
        var l = org.antlr.lang;
return (l.isObject(o) || l.isString(o) || l.isNumber(o) || l.isBoolean(o));
    },

    /** @namespace org.antlr.lang.array Array convenience methods. */
    array: /** @lends org.antlr.lang.array */ {
        /**
         * Retrieve the last element of an array. Throws an error if a is not
         * an array or empty.
         * @param a {Array} the array stack to peek in
         * @return the last element of the array
         */
         peek: function(a) {
            if (!org.antlr.lang.isArray(a)) {
                throw new Error("org.antlr.lang.array.peek: a is not an array.");
            }
            var l = a.length;
            if (l<=0) {
                throw new Error("org.antlr.lang.array.peek: a is empty.");
            }
            return a[l-1];
        }
    }
};
/** The set of fields needed by an abstract recognizer to recognize input
 *  and recover from errors etc...  As a separate state object, it can be
 *  shared among multiple grammars; e.g., when one grammar imports another.
 *
 *  These fields are publically visible but the actual state pointer per
 *  parser is protected.
 */
org.antlr.runtime.RecognizerSharedState = function() {
    /** Track the set of token types that can follow any rule invocation.
     *  Stack grows upwards.  When it hits the max, it grows 2x in size
     *  and keeps going.
     */
    this.following = [];

    this._fsp = -1;

    /** This is true when we see an error and before having successfully
     *  matched a token.  Prevents generation of more than one error message
     *  per error.
     */
    this.errorRecovery = false;

    /** The index into the input stream where the last error occurred.
     *  This is used to prevent infinite loops where an error is found
     *  but no token is consumed during recovery...another error is found,
     *  ad naseum.  This is a failsafe mechanism to guarantee that at least
     *  one token/tree node is consumed for two errors.
     */
    this.lastErrorIndex = -1;

    /** In lieu of a return value, this indicates that a rule or token
     *  has failed to match.  Reset to false upon valid token match.
     */
    this.failed = false;

    /** Did the recognizer encounter a syntax error?  Track how many. */
    this.syntaxErrors = 0;

    /** If 0, no backtracking is going on.  Safe to exec actions etc...
     *  If >0 then it's the level of backtracking.
     */
    this.backtracking = 0;

    /** An array[size num rules] of Map<Integer,Integer> that tracks
     *  the stop token index for each rule.  ruleMemo[ruleIndex] is
     *  the memoization table for ruleIndex.  For key ruleStartIndex, you
     *  get back the stop token for associated rule or MEMO_RULE_FAILED.
     *
     *  This is only used if rule memoization is on (which it is by default).
     */
    this.ruleMemo = null;


    // LEXER FIELDS (must be in same state object to avoid casting
    //               constantly in generated code and Lexer object) :(


    /** The goal of all lexer rules/methods is to create a token object.
     *  This is an instance variable as multiple rules may collaborate to
     *  create a single token.  nextToken will return this object after
     *  matching lexer rule(s).  If you subclass to allow multiple token
     *  emissions, then set this to the last token to be matched or
     *  something nonnull so that the auto token emit mechanism will not
     *  emit another token.
     */
    this.token = null;

    /** What character index in the stream did the current token start at?
     *  Needed, for example, to get the text for current token.  Set at
     *  the start of nextToken.
     */
    this.tokenStartCharIndex = -1;

    /** The line on which the first character of the token resides */
    // this.tokenStartLine;

    /** The character position of first character within the line */
    // this.tokenStartCharPositionInLine;

    /** The channel number for the current token */
    // this.channel;

    /** The token type for the current token */
    // this.type;

    /** You can set the text for the current token to override what is in
     *  the input char buffer.  Use setText() or can set this instance var.
     */
    this.text = null;
};
org.antlr.runtime.IndexOutOfBoundsException = function(m) {
    org.antlr.runtime.IndexOutOfBoundsException.superclass.constructor.call(this, m);
};

org.antlr.lang.extend(org.antlr.runtime.IndexOutOfBoundsException, Error, {
    name: "org.antlr.runtime.IndexOutOfBoundsException"
});
/** The root of the ANTLR exception hierarchy.
 *
 *  <p>To avoid English-only error messages and to generally make things
 *  as flexible as possible, these exceptions are not created with strings,
 *  but rather the information necessary to generate an error.  Then
 *  the various reporting methods in Parser and Lexer can be overridden
 *  to generate a localized error message.  For example, MismatchedToken
 *  exceptions are built with the expected token type.
 *  So, don't expect getMessage() to return anything.</p>
 *
 *  <p>ANTLR generates code that throws exceptions upon recognition error and
 *  also generates code to catch these exceptions in each rule.  If you
 *  want to quit upon first error, you can turn off the automatic error
 *  handling mechanism using rulecatch action, but you still need to
 *  override methods mismatch and recoverFromMismatchSet.</p>
 *
 *  <p>In general, the recognition exceptions can track where in a grammar a
 *  problem occurred and/or what was the expected input.  While the parser
 *  knows its state (such as current input symbol and line info) that
 *  state can change before the exception is reported so current token index
 *  is computed and stored at exception time.  From this info, you can
 *  perhaps print an entire line of input not just a single token, for example.
 *  Better to just say the recognizer had a problem and then let the parser
 *  figure out a fancy report.</p>
 *
 *  @class
 *  @param {org.antlr.runtime.CommonTokenStream|org.antlr.runtime.tree.TreeNodeStream|org.antlr.runtime.ANTLRStringStream} input input stream that has an exception.
 *  @extends Error
 *
 */
org.antlr.runtime.RecognitionException = function(input) {
    org.antlr.runtime.RecognitionException.superclass.constructor.call(this);
    this.input = input;
    this.index = input.index();
    if ( input instanceof org.antlr.runtime.CommonTokenStream ) {
        this.token = input.LT(1);
        this.line = this.token.getLine();
        this.charPositionInLine = this.token.getCharPositionInLine();
    }
    if ( input instanceof org.antlr.runtime.tree.TreeNodeStream ) {
        this.extractInformationFromTreeNodeStream(input);
    }
    else if ( input instanceof org.antlr.runtime.ANTLRStringStream ) {
        // Note: removed CharStream from hierarchy in JS port so checking for
        // StringStream instead
        this.c = input.LA(1);
        this.line = input.getLine();
        this.charPositionInLine = input.getCharPositionInLine();
    }
    else {
        this.c = input.LA(1);
    }

    this.message = this.toString();
};

org.antlr.lang.extend(org.antlr.runtime.RecognitionException, Error,
/** @lends org.antlr.runtime.RecognitionException.prototype */
{
	/**
     * What input stream did the error occur in?
     */
    input: null,

    /** What is index of token/char were we looking at when the error occurred?
     *  @type Number
     */
	index: null,

	/** The current Token when an error occurred.  Since not all streams
	 *  can retrieve the ith Token, we have to track the Token object.
	 *  For parsers.  Even when it's a tree parser, token might be set.
     *  @type org.antlr.runtime.CommonToken
	 */
	token: null,

	/** If this is a tree parser exception, node is set to the node with
	 *  the problem.
     *  @type Object
	 */
	node: null,

	/** The current char when an error occurred. For lexers.
     *  @type Number
     */
	c: null,

	/** Track the line at which the error occurred in case this is
	 *  generated from a lexer.  We need to track this since the
	 *  unexpected char doesn't carry the line info.
     *  @type Number
	 */
	line: null,

    /** The exception's class name.
     *  @type String
     */
    name: "org.antlr.runtime.RecognitionException",

    /** Position in the line where exception occurred.
     *  @type Number
     */
	charPositionInLine: null,

	/** If you are parsing a tree node stream, you will encounter som
	 *  imaginary nodes w/o line/col info.  We now search backwards looking
	 *  for most recent token with line/col info, but notify getErrorHeader()
	 *  that info is approximate.
     *  @type Boolean
	 */
	approximateLineInfo: null,

    /** Gather exception information from input stream.
     *  @param {org.antlr.runtime.CommonTokenStream|org.antlr.runtime.tree.TreeNodeStream|org.antlr.runtime.ANTLRStringStream} input input stream that has an exception.
     */
	extractInformationFromTreeNodeStream: function(input) {
		var nodes = input,
            priorNode,
            priorPayLoad,
            type,
            text,
            i;

		this.node = nodes.LT(1);
		var adaptor = nodes.getTreeAdaptor(),
		    payload = adaptor.getToken(this.node);
		if ( payload ) {
			this.token = payload;
			if ( payload.getLine()<= 0 ) {
				// imaginary node; no line/pos info; scan backwards
				i = -1;
				priorNode = nodes.LT(i);
				while ( priorNode ) {
					priorPayload = adaptor.getToken(priorNode);
					if ( priorPayload && priorPayload.getLine()>0 ) {
						// we found the most recent real line / pos info
						this.line = priorPayload.getLine();
						this.charPositionInLine = priorPayload.getCharPositionInLine();
						this.approximateLineInfo = true;
						break;
					}
					--i;
					priorNode = nodes.LT(i);
				}
			}
			else { // node created from real token
				this.line = payload.getLine();
				this.charPositionInLine = payload.getCharPositionInLine();
			}
		}
		else if ( this.node instanceof org.antlr.runtime.tree.CommonTree) {
			this.line = this.node.getLine();
			this.charPositionInLine = this.node.getCharPositionInLine();
			if ( this.node instanceof org.antlr.runtime.tree.CommonTree) {
				this.token = this.node.token;
			}
		}
		else {
			type = adaptor.getType(this.node);
			text = adaptor.getText(this.node);
			this.token = new org.antlr.runtime.CommonToken(type, text);
		}
	},

	/** Return the token type or char of the unexpected input element
     *  @return {Number} type of the unexpected input element.
     */
    getUnexpectedType: function() {
		if ( this.input instanceof org.antlr.runtime.CommonTokenStream ) {
			return this.token.getType();
		}
		else if ( this.input instanceof org.antlr.runtime.tree.TreeNodeStream ) {
			var nodes = this.input;
			var adaptor = nodes.getTreeAdaptor();
			return adaptor.getType(this.node);
		}
		else {
			return this.c;
		}
	}
});
org.antlr.runtime.MismatchedTokenException = function(expecting, input) {
    if (arguments.length===0) {
        this.expecting = org.antlr.runtime.Token.INVALID_TOKEN_TYPE;
    } else {
        org.antlr.runtime.MismatchedTokenException.superclass.constructor.call(
                this, input);
        this.expecting = expecting;
    }
};

org.antlr.lang.extend(
    org.antlr.runtime.MismatchedTokenException,
    org.antlr.runtime.RecognitionException, {
    toString: function() {
        return "MismatchedTokenException(" +
                this.getUnexpectedType() + "!=" + this.expecting + ")";
    },
    name: "org.antlr.runtime.MismatchedTokenException"
});
/** An extra token while parsing a TokenStream */
org.antlr.runtime.UnwantedTokenException = function(expecting, input) {
    if (arguments.length>0) {
        org.antlr.runtime.UnwantedTokenException.superclass.constructor.call(
                this, expecting, input);
    }
};

org.antlr.lang.extend(
    org.antlr.runtime.UnwantedTokenException,
    org.antlr.runtime.MismatchedTokenException, {
    getUnexpectedToken: function() {
        return this.token;
    },
    toString: function() {
        var exp = ", expected "+this.expecting;
        if ( this.expecting===org.antlr.runtime.Token.INVALID_TOKEN_TYPE ) {
            exp = "";
        }
        if ( !org.antlr.lang.isValue(this.token) ) {
            return "UnwantedTokenException(found="+exp+")";
        }
        return "UnwantedTokenException(found="+this.token.getText()+exp+")";
    },
    name: "org.antlr.runtime.UnwantedTokenException"
});
org.antlr.runtime.MissingTokenException = function(expecting, input, inserted) {
    if (arguments.length>0) {
        org.antlr.runtime.MissingTokenException.superclass.constructor.call(
                this, expecting, input);
        this.inserted = inserted;
    }
};

org.antlr.lang.extend(
    org.antlr.runtime.MissingTokenException,
    org.antlr.runtime.MismatchedTokenException, {
    getMissingType: function() {
        return this.expecting;
    },

    toString: function() {
        if (org.antlr.lang.isValue(this.inserted) &&
            org.antlr.lang.isValue(this.token))
        {
            return "MissingTokenException(inserted "+this.inserted+" at "+this.token.getText()+")";
        }
        if ( org.antlr.lang.isValue(this.token) ) {
            return "MissingTokenException(at "+this.token.getText()+")";
        }
        return "MissingTokenException";
    },
    name: "org.antlr.runtime.MissingTokenException"
});
org.antlr.runtime.NoViableAltException = function(grammarDecisionDescription,
                                            decisionNumber,
                                            stateNumber,
                                            input)
{
    org.antlr.runtime.NoViableAltException.superclass.constructor.call(this, input);
    this.grammarDecisionDescription = grammarDecisionDescription;
    this.decisionNumber = decisionNumber;
    this.stateNumber = stateNumber;
};

org.antlr.lang.extend(
    org.antlr.runtime.NoViableAltException,
    org.antlr.runtime.RecognitionException, {
    toString: function() {
        if ( this.input instanceof org.antlr.runtime.ANTLRStringStream ) {
            return "NoViableAltException('"+this.getUnexpectedType()+"'@["+this.grammarDecisionDescription+"])";
        }
        else {
            return "NoViableAltException("+this.getUnexpectedType()+"@["+this.grammarDecisionDescription+"])";
        }
    },
    name: "org.antlr.runtime.NoViableAltException"
});
/** The recognizer did not match anything for a ()+ loop.
 *
 *  @class
 *  @param {Number} decisionNumber
 *  @param {org.antlr.runtime.CommonTokenStream|org.antlr.runtime.tree.TreeNodeStream|org.antlr.runtime.ANTLRStringStream} input input stream that has an exception.
 *  @extends org.antlr.runtime.RecognitionException
 */
org.antlr.runtime.EarlyExitException = function(decisionNumber, input) {
    org.antlr.runtime.EarlyExitException.superclass.constructor.call(
            this, input);
    this.decisionNumber = decisionNumber;
};

org.antlr.lang.extend(
    org.antlr.runtime.EarlyExitException,
    org.antlr.runtime.RecognitionException,
/** @lends org.antlr.runtime.EarlyExitException.prototype */
{
    /** Name of this class.
     *  @type String
     */
    name: "org.antlr.runtime.EarlyExitException"
});
org.antlr.runtime.MismatchedSetException = function(expecting, input) {
    org.antlr.runtime.MismatchedSetException.superclass.constructor.call(
            this, input);
    this.expecting = expecting;
};

org.antlr.lang.extend(
    org.antlr.runtime.MismatchedSetException,
    org.antlr.runtime.RecognitionException, {
    toString: function() {
        return "MismatchedSetException(" +
                this.getUnexpectedType() + "!=" + this.expecting + ")";
    },
    name: "org.antlr.runtime.MismatchedSetException"
});
org.antlr.runtime.MismatchedNotSetException = function(expecting, input) {
    org.antlr.runtime.MismatchedNotSetException.superclass.constructor.call(this, expecting, input);
};

org.antlr.lang.extend(
    org.antlr.runtime.MismatchedNotSetException,
    org.antlr.runtime.MismatchedSetException, {
    toString: function() {
        return "MismatchedNotSetException(" +
                this.getUnexpectedType() + "!=" + this.expecting + ")";
    },
    name: "org.antlr.runtime.MismatchedNotSetException"
});
org.antlr.runtime.MismatchedRangeException = function(a, b, input) {
    if (arguments.length===0) {
        return this;
    }

    org.antlr.runtime.MismatchedRangeException.superclass.constructor.call(
            this, input);
    this.a = a;
    this.b = b;
};

org.antlr.lang.extend(
    org.antlr.runtime.MismatchedRangeException,
    org.antlr.runtime.RecognitionException, {
    toString: function() {
        return "MismatchedRangeException(" +
                this.getUnexpectedType()+" not in ["+this.a+","+this.b+"])";
    },
    name: "org.antlr.runtime.MismatchedRangeException"
});
/** A semantic predicate failed during validation.  Validation of predicates
 *  occurs when normally parsing the alternative just like matching a token.
 *  Disambiguating predicate evaluation occurs when we hoist a predicate into
 *  a prediction decision.
 *
 *  @class
 *  @param {org.antlr.runtime.CommonTokenStream|org.antlr.runtime.tree.TreeNodeStream|org.antlr.runtime.ANTLRStringStream} input input stream that has an exception.
 *  @param {String} ruleName name of the rule in which the exception occurred.
 *  @param {String} predicateText the predicate that failed.
 *  @extends org.antlr.runtime.RecognitionException
 */
org.antlr.runtime.FailedPredicateException = function(input, ruleName, predicateText){
    org.antlr.runtime.FailedPredicateException.superclass.constructor.call(this, input);
    this.ruleName = ruleName;
    this.predicateText = predicateText;
};

org.antlr.lang.extend(
    org.antlr.runtime.FailedPredicateException,
    org.antlr.runtime.RecognitionException,
/** @lends org.antlr.runtime.FailedPredicateException.prototype */
{
    /** Create a string representation of this exception.
     *  @returns {String}
     */ 
    toString: function() {
        return "FailedPredicateException("+this.ruleName+",{"+this.predicateText+"}?)";
    },

    /** Name of this class.
     *  @type String
     */
    name: "org.antlr.runtime.FailedPredicateException"
});
/**
 * A BitSet similar to java.util.BitSet.
 *
 * <p>JavaScript Note: There is no good way to implement something like this in 
 * JavaScript.  JS has no true int type, arrays are usually implemented as
 * hashes, etc.  This class should probably be nixed for something that is
 * similarly (in)efficient, but more clear.</p>
 *
 * @class
 * @param {Number|Array} [bits] a 32 bit number or array of 32 bit numbers
 *                              representing the bitset.  These are typically
 *                              generated by the ANTLR Tool.
 */
org.antlr.runtime.BitSet = function(bits) {
    if (!bits) {
        bits = org.antlr.runtime.BitSet.BITS;
    }

    if (org.antlr.lang.isArray(bits)) {
        /**
         * An array of Numbers representing the BitSet.
         * @type Array
         */
        this.bits = bits;
    } else if(org.antlr.lang.isNumber(bits)) {
        this.bits = [];
    }
};

org.antlr.lang.augmentObject(org.antlr.runtime.BitSet, {
    /**
     * Number of bits in each number.
     * @constant
     * @memberOf org.antlr.runtime.BitSet
     */
    BITS: 32,

    /**
     * Log (base 2) of the number of bits in each number.
     * @constant
     * @memberOf org.antlr.runtime.BitSet
     */
    LOG_BITS: 5,  // 2^5 == 32 

    /**
     * We will often need to do a mod operator (i mod nbits).  Its
     * turns out that, for powers of two, this mod operation is
     * same as (i & (nbits-1)).  Since mod is slow, we use a
     * precomputed mod mask to do the mod instead.
     * @constant
     * @memberOf org.antlr.runtime.BitSet
     */
    MOD_MASK: 31, // BITS - 1

    /**
     * Create mask for bit modded to fit in a single word.
     * @example
     * bitmask(35) => 00000000000000000000000000000100
     * bitmask(3)  => 00000000000000000000000000000100
     * @param {Number} bitNumber the bit to create a mask for.
     * @returns {Number} the bitmask.
     * @memberOf org.antlr.runtime.BitSet
     * @private
     */
    bitMask: function(bitNumber) {
        var bitPosition = bitNumber & org.antlr.runtime.BitSet.MOD_MASK;
        return 1 << bitPosition;
    },

    /**
     * Calculate the minimum number of bits needed to represent el.
     * @param {Number} el a number to be included in the BitSet.
     * @returns {Number} the number of bits need to create a BitSet with member
     *                   el.
     * @memberOf org.antlr.runtime.BitSet
     * @private
     */
    numWordsToHold: function(el) {
        return (el >> org.antlr.runtime.BitSet.LOG_BITS) + 1;
    },

    /**
     * @param {Number} bit a number to be included in the BitSet
     * @returns {Number} the index of the word in the field bits that would
     *                   hold bit.
     * @memberOf org.antlr.runtime.BitSet
     * @private
     */
    wordNumber: function(bit) {
        return bit >> org.antlr.runtime.BitSet.LOG_BITS; // bit / BITS
    },

    /**
     * BitSet factory method.
     * 
     * <p>Operates in a number of modes:
     * <ul>
     * <li>If el is a number create the BitSet containing that number.</li>
     * <li>If el is an array create the BitSet containing each number in the
     * array.</li>
     * <li>If el is a BitSet return el.</li>
     * <li>If el is an Object create the BitSet containing each numeric value
     * in el.</li>
     * <li>If el is a number and el2 is a number return a BitSet containing
     * the numbers between el and el2 (inclusive).</li>
     * </ul>
     * </p>
     * @param {Number|Array|org.antlr.runtime.BitSet|Object} el
     * @param {Number} el2
     * @returns {org.antlr.runtime.BitSet}
     * @memberOf org.antlr.runtime.BitSet
     */
    of: function(el, el2) {
        var i, n, s, keys;

        if (org.antlr.lang.isNumber(el)) {
            if (org.antlr.lang.isNumber(el2)) {
                s = new org.antlr.runtime.BitSet(el2 + 1);
                for (i = el; i <= el2; i++) {
                    n = org.antlr.runtime.BitSet.wordNumber(i);
                    s.bits[n] |= org.antlr.runtime.BitSet.bitMask(i);
                }
                return s;
            } else {
                s = new org.antlr.runtime.BitSet(el + 1);
                s.add(el);
                return s;
            }
        } else if(org.antlr.lang.isArray(el)) {
            s = new org.antlr.runtime.BitSet();
            for (i=el.length-1; i>=0; i--) {
                s.add(el[i]);
            }
            return s;
        } else if (el instanceof org.antlr.runtime.BitSet) {
            if (!el) {
                return null;
            }
            return el;
        } else if (el instanceof org.antlr.runtime.IntervalSet) {
            if (!el) {
                return null;
            }
            s = new org.antlr.runtime.BitSet();
            s.addAll(el);
            return s;
        } else if (org.antlr.lang.isObject(el)) {
            keys = [];
            for (i in el) {
                if (org.antlr.lang.isNumber(i)) {
                    keys.push(i);
                }
            }
            return org.antlr.runtime.BitSet.of(keys);
        }
    }
});



org.antlr.runtime.BitSet.prototype = {
    /**
     * Add el into this set.
     * @param {Number} el the number to add to the set.
     */
    add: function(el) {
        var n = org.antlr.runtime.BitSet.wordNumber(el);
        if (n >= this.bits.length) {
            this.growToInclude(el);
        }
        this.bits[n] |= org.antlr.runtime.BitSet.bitMask(el);
    },

    /**
     * Add multiple elements into this set.
     * @param {Array|org.antlr.runtime.BitSet} elements the elements to be added to
     *                                           this set.
     */
    addAll: function(elements) {
        var other,
            i,
            e;

        if ( elements instanceof org.antlr.runtime.BitSet ) {
            this.orInPlace(elements);
        }
		else if ( elements instanceof org.antlr.runtime.IntervalSet ) {
			other = elements;
			// walk set and add each interval
            /* @todo after implementing intervalset
			for (Iterator iter = other.intervals.iterator(); iter.hasNext();) {
				Interval I = (Interval) iter.next();
				this.orInPlace(BitSet.range(I.a,I.b));
			}*/
		} else if (org.antlr.lang.isArray(elements)) {
    		for (i = 0; i < elements.length; i++) {
	    		e = elements[i];
		    	this.add(e);
    		}
        } else {
            return;
        }
	},

    /**
     * Clone this BitSet and then {@link #andInPlace} with a.
     * @param {org.antlr.runtime.BitSet} a a bit set.
     * @returns {org.antlr.runtime.BitSet}
     */
    and: function(a) {
        var s = this.clone();
        s.andInPlace(a);
        return s;
    },

    /**
     * Perform a logical AND of this target BitSet with the argument BitSet.
     *
     * This bit set is modified so that each bit in it has the value true if 
     * and only if it both initially had the value true and the corresponding 
     * bit in the bit set argument also had the value true. 
     * @param {org.antlr.runtime.BitSet} a a bit set.
     * @returns {org.antlr.runtime.BitSet}
     */
    andInPlace: function(a) {
        var min = Math.min(this.bits.length, a.bits.length),
            i;
        for (i = min - 1; i >= 0; i--) {
            this.bits[i] &= a.bits[i];
        }
        // clear all bits in this not present in a (if this bigger than a).
        for (i = min; i < this.bits.length; i++) {
            this.bits[i] = 0;
        }
    },

    /**
     * Clear all bits or a specific bit.
     *
     * If no arguments given, sets all of the bits in this BitSet to false.
     * If one argument given, sets the bit specified by the index to false.
     * @param {Number} [el] the index of the bit to be cleared.
     */
    clear: function(el) {
        if (arguments.length===0) {
            var i;
            for (i = this.bits.length - 1; i >= 0; i--) {
                this.bits[i] = 0;
            }
            return;
        }

        var n = org.antlr.runtime.BitSet.wordNumber(el);
        if (n >= this.bits.length) {	// grow as necessary to accommodate
            this.growToInclude(el);
        }
        this.bits[n] &= ~org.antlr.runtime.BitSet.bitMask(el);
    },

    /**
     * Cloning this BitSet produces a new BitSet  that is equal to it. 
     *
     * The clone of the bit set is another bit set that has exactly the same
     * bit set to true as this bit set. 
     * @returns {org.antlr.runtime.BitSet} a clone of this BitSet.
     */
    clone: function() {
        var i, len, b=[];
        for (i=0, len=this.bits.length; i<len; i++) {
            b[i] = this.bits[i];
        }
        return new org.antlr.runtime.BitSet(b);
    },

    /**
     * Returns the number of bits of space actually in use by this BitSet to 
     * represent bit values.
     *
     * The maximum element in the set is the size - 1st element. 
     * @returns {Number} the number of bits currently in this bit set.
     */
    size: function() {
        var deg = 0, i, word, bit;
        for (i = this.bits.length - 1; i >= 0; i--) {
            word = this.bits[i];
            if (word !== 0) {
                for (bit = org.antlr.runtime.BitSet.BITS - 1; bit >= 0; bit--) {
                    if ((word & (1 << bit)) !== 0) {
                        deg++;
                    }
                }
            }
        }
        return deg;
    },

    /**
     * Compares this object against the specified object.
     *
     * The result is true if and only if the argument is not null and is a
     * BitSet object that has exactly the same set of bits set to true as
     * this bit set. That is, for every nonnegative int index k,
     * <pre><code>
     * ((BitSet)obj).get(k) == this.get(k)
     * </code></pre>
     * must be true. The current sizes of the two bit sets are not compared.
     * @param {Object} other the object to compare with.
     * @returns {Boolean} if the objects are the same; false otherwise.
     */
    equals: function(other) {
        if ( !other || !(other instanceof org.antlr.runtime.BitSet) ) {
            return false;
        }

        var otherSet = other,
            i,
            n = Math.min(this.bits.length, otherSet.bits.length);

        // for any bits in common, compare
        for (i=0; i<n; i++) {
            if (this.bits[i] != otherSet.bits[i]) {
                return false;
            }
        }

        // make sure any extra bits are off

        if (this.bits.length > n) {
            for (i = n+1; i<this.bits.length; i++) {
                if (this.bits[i] !== 0) {
                    return false;
                }
            }
        }
        else if (otherSet.bits.length > n) {
            for (i = n+1; i<otherSet.bits.length; i++) {
                if (otherSet.bits[i] !== 0) {
                    return false;
                }
            }
        }

        return true;
    },

    /**
     * Grows the set to a larger number of bits.
     * @param {Number} bit element that must fit in set
     * @private
     */
    growToInclude: function(bit) {
        var newSize = Math.max(this.bits.length << 1, org.antlr.runtime.BitSet.numWordsToHold(bit)),
            newbits = [], //new Array(newSize),
            i;
        for (i=0, len=this.bits.length; i<len; i++) {
            newbits[i] = this.bits[i];
        }
        this.bits = newbits;
    },

    /**
     * Returns the value of the bit with the specified index.
     *
     * The value is true if the bit with the index el is currently set 
     * in this BitSet; otherwise, the result is false.
     * @param {Number} el the bit index.
     * @returns {Boolean} the value of the bit with the specified index.
     */
    member: function(el) {
        var n = org.antlr.runtime.BitSet.wordNumber(el);
        if (n >= this.bits.length) { return false; }
        return (this.bits[n] & org.antlr.runtime.BitSet.bitMask(el)) !== 0;
    },

    /**
     * Returns the index of the first bit that is set to true.
     * If no such bit exists then -1 is returned.
     * @returns {Number} the index of the next set bit.
     */
    getSingleElement: function() {
        var i;
        for (i = 0; i < (this.bits.length << org.antlr.runtime.BitSet.LOG_BITS); i++) {
            if (this.member(i)) {
                return i;
            }
        }
        return -1; //Label.INVALID;
    },

    /**
     * Returns true if this BitSet contains no bits that are set to true.
     * @returns {Boolean} boolean indicating whether this BitSet is empty.
     */
    isNil: function() {
        var i;
        for (i = this.bits.length - 1; i >= 0; i--) {
            if (this.bits[i] !== 0) {
                return false;
            }
        }
        return true;
    },

    /**
     * If a bit set argument is passed performs a {@link #subtract} of this bit
     * set with the argument bit set.  If no argument is passed, clone this bit
     * set and {@link #notInPlace}.
     * @param {org.antlr.runtime.BitSet} [set]
     * @returns {org.antlr.runtime.BitSet}
     */
    complement: function(set) {
        if (set) {
            return set.subtract(this);
        } else {
            var s = this.clone();
            s.notInPlace();
            return s;
        }
    },

    /**
     * If no arguments are passed sets all bits to the complement of their
     * current values.  If one argument is passed sets each bit from the
     * beginning of the bit set to index1 (inclusive) to the complement of its
     * current value.  If two arguments are passed sets each bit from the
     * specified index1 (inclusive) to the sepcified index2 (inclusive) to the
     * complement of its current value.
     * @param {Number} index1
     * @param {Number} index2
     */
    notInPlace: function() {
        var minBit, maxBit, i, n;
        if (arguments.length===0) {
            for (i = this.bits.length - 1; i >= 0; i--) {
                this.bits[i] = ~this.bits[i];
            }
        } else {
            if (arguments.length===1) {
                minBit = 0;
                maxBit = arguments[0];
            } else {
                minBit = arguments[0];
                maxBit = arguments[1];
            }
            // make sure that we have room for maxBit
            this.growToInclude(maxBit);
            for (i = minBit; i <= maxBit; i++) {
                n = org.antlr.runtime.BitSet.wordNumber(i);
                this.bits[n] ^= org.antlr.runtime.BitSet.bitMask(i);
            }
        }

    },

    /**
     * Performs a logical OR of this bit set with the bit set argument.
     * If no argument is passed, return this bit set.  Otherwise a clone of
     * this bit set is modified so that a bit in it has the value true if and
     * only if it either already had the value true or the corresponding bit
     * in the bit set argument has the value true.
     * @param {org.antlr.runtime.BitSet} [a] a bit set.
     * @returns {org.antlr.runtime.BitSet}
     */
    or: function(a) {
		if ( !a ) {
			return this;
		}
        var s = this.clone();
        s.orInPlace(a);
        return s;
    },

    /**
     * Performs a logical {@link #or} in place.
     * @param {org.antlr.runtime.BitSet} [a]
     * @returns {org.antlr.runtime.BitSet}
     */
    orInPlace: function(a) {
		if ( !a ) {
			return;
		}
        // If this is smaller than a, grow this first
        if (a.bits.length > this.bits.length) {
            this.setSize(a.bits.length);
        }
        var min = Math.min(this.bits.length, a.bits.length),
            i;
        for (i = min - 1; i >= 0; i--) {
            this.bits[i] |= a.bits[i];
        }
    },

    /**
     * Sets the bit specified by the index to false.
     * @param {Number} bitIndex the index of the bit to be cleared.
     */
    remove: function(el) {
        var n = org.antlr.runtime.BitSet.wordNumber(el);
        if (n >= this.bits.length) {
            this.growToInclude(el);
        }
        this.bits[n] &= ~org.antlr.runtime.BitSet.bitMask(el);
    },

    /**
     * Grows the internal bits array to include at least nwords numbers.
     * @private
     * @param {Number} nwords how many words the new set should be
     * @private
     */
    setSize: function(nwords) {
        var n = nwords - this.bits.length;
        while (n>=0) {
            this.bits.push(0);
            n--;
        }
    },

    /**
     * Returns the number of bits capable of being represented by this bit set
     * given its current size.
     * @returns {Number} the maximum number of bits that can be represented at
     *                   the moment.
     * @private
     */
    numBits: function() {
        return this.bits.length << org.antlr.runtime.BitSet.LOG_BITS; // num words * bits per word
    },

    /**
     * Return how much space is being used by the bits array not
     * how many actually have member bits on.
     * @returns {Number} the length of the internal bits array.
     * @private
     */
    lengthInLongWords: function() {
        return this.bits.length;
    },

    /**
     * Is this bit set contained within a?
     * @param {org.antlr.runtime.BitSet} a bit set
     * @returns {Boolean} true if and only if a is a subset of this bit set.
     */
    subset: function(a) {
        if (!a) { return false; }
        return this.and(a).equals(this);
    },

    /**
     * Subtract the elements of the argument bit set from this bit set in place.
     * That is, for each set bit in the argument bit set, set the corresponding
     * bit in this bit set to false.
     * @param {org.antlr.runtime.BitSet} a bit set.
     */
    subtractInPlace: function(a) {
        if (!a) { return; }
        // for all words of 'a', turn off corresponding bits of 'this'
        var i;
        for (i = 0; i < this.bits.length && i < a.bits.length; i++) {
            this.bits[i] &= ~a.bits[i];
        }
    },

    /**
     * Perform a {@link #subtractInPlace} on a clone of this bit set.
     * @param {org.antlr.runtime.BitSet} a bit set.
     * @returns {org.antlr.runtime.BitSet} the new bit set.
     */
    subtract: function(a) {
        if (!a || !(a instanceof org.antlr.runtime.BitSet)) { return null; }

        var s = this.clone();
        s.subtractInPlace(a);
        return s;
    },

    /* antlr-java needs this to make its class hierarchy happy . . .
    toList: function() {
		throw new Error("BitSet.toList() unimplemented");
	},
    */

    /**
     * Creates an array of the indexes of each bit set in this bit set.
     * @returns {Array}
     */
    toArray: function() {
        var elems = [], //new Array(this.size()),
            i,
            en = 0;
        for (i = 0; i < (this.bits.length << org.antlr.runtime.BitSet.LOG_BITS); i++) {
            if (this.member(i)) {
                elems[en++] = i;
            }
        }
        return elems;
    },

    /**
     * Returns the internal representation of this bit set.
     * This representation is an array of numbers, each representing 32 bits.
     * @returns {Array}
     */
    toPackedArray: function() {
        return this.bits;
    },

    /**
     * Returns a string representation of this bit set.
     * <p>For every index for which this BitSet contains a bit in the set state,
     * the decimal representation of that index is included in the result.
     * Such indices are listed in order from lowest to highest, separated by
     * ", " (a comma and a space) and surrounded by braces, resulting in the
     * usual mathematical notation for a set of integers.</p>
     * 
     * <p>If a grammar g is passed, print g.getTokenDisplayName(i) for each set
     * index instead of the numerical index.</p>
     *
     * <>If two arguments are passed, the first will be used as a custom
     * separator string.  The second argument is an array whose i-th element
     * will be added if the corresponding bit is set.</p>
     *
     * @param {Object|String} [arg1] an Object with function property
     *      getTokenDispalyName or a String that will be used as a list
     *      separator.
     * @param {Array} [vocabulary] array from which the i-th value will be
     *      drawn if the corresponding bit is set.  Must pass a string as the
     *      first argument if using this option.
     * @return A commma-separated list of values
     */
    toString: function() {
        if (arguments.length===0) {
            return this.toString1(null);
        } else {
            if (org.antlr.lang.isString(arguments[0])) {
                if (!org.antlr.lang.isValue(arguments[1])) {
                    return this.toString1(null);
                } else {
                    return this.toString2(arguments[0], arguments[1]);
                }
            } else {
                return this.toString1(arguments[0]);
            }
        }
    },

    /**
     * Transform a bit set into a string by formatting each element as an
     * integer separator The string to put in between elements
     * @private
     * @return A commma-separated list of values
     */
    toString1: function(g) {
        var buf = "{",
            separator = ",",
            i,
		    havePrintedAnElement = false;

        for (i = 0; i < (this.bits.length << org.antlr.runtime.BitSet.LOG_BITS); i++) {
            if (this.member(i)) {
                if (i > 0 && havePrintedAnElement ) {
                    buf += separator;
                }
                if ( g ) {
                    buf += g.getTokenDisplayName(i);
                }
                else {
                    buf += i.toString();
                }
				havePrintedAnElement = true;
            }
        }
        return buf + "}";
    },

    /**
     * Create a string representation where instead of integer elements, the
     * ith element of vocabulary is displayed instead.  Vocabulary is a Vector
     * of Strings.
     * separator The string to put in between elements
     * @private
     * @return A commma-separated list of character constants.
     */
    toString2: function(separator, vocabulary) {
        var str = "",
            i;
        for (i = 0; i < (this.bits.length << org.antlr.runtime.BitSet.LOG_BITS); i++) {
            if (this.member(i)) {
                if (str.length > 0) {
                    str += separator;
                }
                if (i >= vocabulary.size()) {
                    str += "'" + i + "'";
                }
                else if (!org.antlr.lang.isValue(vocabulary.get(i))) {
                    str += "'" + i + "'";
                }
                else {
                    str += vocabulary.get(i);
                }
            }
        }
        return str;
    }

    /*
     * Dump a comma-separated list of the words making up the bit set.
     * Split each 32 bit number into two more manageable 16 bit numbers.
     * @returns {String} comma separated list view of the this.bits property.
     *
    toStringOfHalfWords: function() {
        var s = "",
            tmp,
            i;
        for (i = 0; i < this.bits.length; i++) {
            if (i !== 0) {
                s+=", ";
            }
            tmp = this.bits[i];
            tmp &= 0xFFFF;
            s += tmp + "UL, ";
            tmp = this.bits[i] >> 16;
            tmp &= 0xFFFF;
            s += tmp+"UL";
        }
		return s;
    },
    */

    /*
     * Dump a comma-separated list of the words making up the bit set.
     * This generates a comma-separated list of Java-like long int constants.
     *
    toStringOfWords: function() {
        var s="",
            i;
        for (i = 0; i < this.bits.length; i++) {
            if (i !== 0) {
                s+=", ";
            }
            s += this.bits[i]+"L";
        }
        return s;
    },

    toStringWithRanges: function() {
        return this.toString();
    }
    */
};

/*
 *
 *
org.antlr.runtime.IntervalSet = function() {
        throw new Error("not implemented");
};
*/
org.antlr.runtime.CharStream = {
    EOF: -1
};
org.antlr.runtime.CommonToken = function() {
    var oldToken;

    this.charPositionInLine = -1; // set to invalid position
    this.channel = 0; // org.antlr.runtime.CommonToken.DEFAULT_CHANNEL
    this.index = -1;

    if (arguments.length == 1) {
        if (org.antlr.lang.isNumber(arguments[0])) {
            this.type = arguments[0];
        } else {
            oldToken = arguments[0];
            this.text = oldToken.getText();
            this.type = oldToken.getType();
            this.line = oldToken.getLine();
            this.index = oldToken.getTokenIndex();
            this.charPositionInLine = oldToken.getCharPositionInLine();
            this.channel = oldToken.getChannel();
            if ( oldToken instanceof org.antlr.runtime.CommonToken ) {
                this.start = oldToken.start;
                this.stop = oldToken.stop;
            }
        }
    } else if (arguments.length == 2) {
        this.type = arguments[0];
        this.text = arguments[1];
        this.channel = 0; // org.antlr.runtime.CommonToken.DEFAULT_CHANNEL
    } else if (arguments.length == 5) {
        this.input = arguments[0];
        this.type = arguments[1];
        this.channel = arguments[2];
        this.start = arguments[3];
        this.stop = arguments[4];
    }
};

org.antlr.runtime.CommonToken.prototype = {
    getType: function() {
        return this.type;
    },

    setLine: function(line) {
        this.line = line;
    },

    getText: function() {
        if ( org.antlr.lang.isString(this.text) ) {
            return this.text;
        }
        if ( !this.input ) {
            return null;
        }
        this.text = this.input.substring(this.start,this.stop);
        return this.text;
    },

    /** Override the text for this token.  getText() will return this text
     *  rather than pulling from the buffer.  Note that this does not mean
     *  that start/stop indexes are not valid.  It means that that input
     *  was converted to a new string in the token object.
     */
    setText: function(text) {
        this.text = text;
    },

    getLine: function() {
        return this.line;
    },

    getCharPositionInLine: function() {
        return this.charPositionInLine;
    },

    setCharPositionInLine: function(charPositionInLine) {
        this.charPositionInLine = charPositionInLine;
    },

    getChannel: function() {
        return this.channel;
    },

    setChannel: function(channel) {
        this.channel = channel;
    },

    setType: function(type) {
        this.type = type;
    },

    getStartIndex: function() {
        return this.start;
    },

    setStartIndex: function(start) {
        this.start = start;
    },

    getStopIndex: function() {
        return this.stop;
    },

    setStopIndex: function(stop) {
        this.stop = stop;
    },

    getTokenIndex: function() {
        return this.index;
    },

    setTokenIndex: function(index) {
        this.index = index;
    },

    getInputStream: function() {
        return this.input;
    },

    setInputStream: function(input) {
        this.input = input;
    },

    toString: function() {
        var channelStr = "";
        if ( this.channel>0 ) {
            channelStr=",channel="+this.channel;
        }
        var txt = this.getText();
        if ( !org.antlr.lang.isNull(txt) ) {
            txt = txt.replace(/\n/g,"\\\\n");
            txt = txt.replace(/\r/g,"\\\\r");
            txt = txt.replace(/\t/g,"\\\\t");
        }
        else {
            txt = "<no text>";
        }
        return "[@"+this.getTokenIndex()+","+this.start+":"+this.stop+"='"+txt+"',<"+this.type+">"+channelStr+","+this.line+":"+this.getCharPositionInLine()+"]";
    }
};
// NB: Because Token has static members of type CommonToken, the Token dummy
// constructor is defined in CommonToken.  All methods and vars of Token are
// defined here.  Token is an interface, not a subclass in the Java runtime.

/**
 * @class Abstract base class of all token types.
 * @name Token
 * @memberOf org.antlr.runtime
 */
org.antlr.runtime.Token = function() {};
org.antlr.lang.augmentObject(org.antlr.runtime.Token, /** @lends Token */ {
    EOR_TOKEN_TYPE: 1,

    /** imaginary tree navigation type; traverse "get child" link */
    DOWN: 2,
    /** imaginary tree navigation type; finish with a child list */
    UP: 3,

    MIN_TOKEN_TYPE: 4, // UP+1,

    EOF: org.antlr.runtime.CharStream.EOF,
    EOF_TOKEN: new org.antlr.runtime.CommonToken(org.antlr.runtime.CharStream.EOF),

    INVALID_TOKEN_TYPE: 0,
    INVALID_TOKEN: new org.antlr.runtime.CommonToken(0),

    /** In an action, a lexer rule can set token to this SKIP_TOKEN and ANTLR
     *  will avoid creating a token for this symbol and try to fetch another.
     */
    SKIP_TOKEN: new org.antlr.runtime.CommonToken(0),

    /** All tokens go to the parser (unless skip() is called in that rule)
     *  on a particular "channel".  The parser tunes to a particular channel
     *  so that whitespace etc... can go to the parser on a "hidden" channel.
     */
    DEFAULT_CHANNEL: 0,

    /** Anything on different channel than DEFAULT_CHANNEL is not parsed
     *  by parser.
     */
    HIDDEN_CHANNEL: 99
});

org.antlr.lang.augmentObject(org.antlr.runtime.CommonToken, org.antlr.runtime.Token);
org.antlr.runtime.tree.RewriteCardinalityException = function(elementDescription) {
    this.elementDescription = elementDescription;
};

/** Base class for all exceptions thrown during AST rewrite construction.
 *  This signifies a case where the cardinality of two or more elements
 *  in a subrule are different: (ID INT)+ where |ID|!=|INT|
 */
org.antlr.lang.extend(org.antlr.runtime.tree.RewriteCardinalityException, Error, {
    getMessage: function() {
		if ( org.antlr.lang.isString(this.elementDescription) ) {
			return this.elementDescription;
		}
		return null;
	},
    name: function() {
        return "org.antlr.runtime.tree.RewriteCardinalityException";
    }
});
/** Ref to ID or expr but no tokens in ID stream or subtrees in expr stream */
org.antlr.runtime.tree.RewriteEmptyStreamException = function(elementDescription) {
    var sup = org.antlr.runtime.tree.RewriteEmptyStreamException.superclass; 
    sup.constructor.call(this, elementDescription);
};

org.antlr.lang.extend(org.antlr.runtime.tree.RewriteEmptyStreamException,
                  org.antlr.runtime.tree.RewriteCardinalityException, {
    name: function() {
        return "org.antlr.runtime.tree.RewriteEmptyStreamException";
    }
});
/** No elements within a (...)+ in a rewrite rule */
org.antlr.runtime.tree.RewriteEarlyExitException = function(elementDescription) {
    var sup = org.antlr.runtime.tree.RewriteEarlyExitException.superclass;
    if (org.antlr.lang.isUndefined(elementDescription)) {
        elementDescription = null;
    }
    sup.constructor.call(this, elementDescription);
};

org.antlr.lang.extend(org.antlr.runtime.tree.RewriteEarlyExitException,
                  org.antlr.runtime.tree.RewriteCardinalityException, {
    name: function() {
        return "org.antlr.runtime.tree.RewriteEarlyExitException";
    }    
});
org.antlr.runtime.MismatchedTreeNodeException = function(expecting, input) {
    if (expecting && input) {
        org.antlr.runtime.MismatchedTreeNodeException.superclass.constructor.call(
                this, input);
        this.expecting = expecting;
    }
};

org.antlr.lang.extend(
    org.antlr.runtime.MismatchedTreeNodeException,
    org.antlr.runtime.RecognitionException, {
    toString: function() {
        return "MismatchedTreeNodeException(" +
                this.getUnexpectedType() + "!=" + this.expecting + ")";
    },
    name: "org.antlr.runtime.MismatchedTreeNodeException"
});
/** A generic tree implementation with no payload.  You must subclass to
 *  actually have any user data.  ANTLR v3 uses a list of children approach
 *  instead of the child-sibling approach in v2.  A flat tree (a list) is
 *  an empty node whose children represent the list.  An empty, but
 *  non-null node is called "nil".
 */
org.antlr.runtime.tree.BaseTree = function() {};

org.antlr.runtime.tree.BaseTree.prototype = {
    getChild: function(i) {
        if ( !this.children || i>=this.children.length ) {
            return null;
        }
        return this.children[i];
    },

    /** Get the children internal List; note that if you directly mess with
     *  the list, do so at your own risk.
     */
    getChildren: function() {
        return this.children;
    },

    getFirstChildWithType: function(type) {
        var i, t;
        for (i = 0; this.children && i < this.children.length; i++) {
            t = this.children[i];
            if ( t.getType()===type ) {
                return t;
            }
        }    
        return null;
    },

    getChildCount: function() {
        if ( !this.children ) {
            return 0;
        }
        return this.children.length;
    },

    /** Add t as child of this node.
     *
     *  Warning: if t has no children, but child does
     *  and child isNil then this routine moves children to t via
     *  t.children = child.children; i.e., without copying the array.
     */
    addChild: function(t) {
        if ( !org.antlr.lang.isValue(t) ) {
            return; // do nothing upon addChild(null)
        }
        var childTree = t, n, i, c;
        if ( childTree.isNil() ) { // t is an empty node possibly with children
            if ( this.children && this.children == childTree.children ) {
                throw new Error("attempt to add child list to itself");
            }
            // just add all of childTree's children to this
            if ( childTree.children ) {
                if ( this.children ) { // must copy, this has children already
                    n = childTree.children.length;
                    for (i = 0; i < n; i++) {
                        c = childTree.children[i];
                        this.children.push(c);
                        // handle double-link stuff for each child of nil root
                        c.setParent(this);
                        c.setChildIndex(this.children.length-1);
                    }
                }
                else {
                    // no children for this but t has children; just set pointer
                    // call general freshener routine
                    this.children = childTree.children;
                    this.freshenParentAndChildIndexes();
                }
            }
        }
        else { // child is not nil (don't care about children)
            if ( !this.children ) {
                this.children = this.createChildrenList(); // create children list on demand
            }
            this.children.push(t);
            childTree.setParent(this);
            childTree.setChildIndex(this.children.length-1);
        }
    },

    /** Add all elements of kids list as children of this node */
    addChildren: function(kids) {
        var i, t;
        for (i = 0; i < kids.length; i++) {
            t = kids[i];
            this.addChild(t);
        }
    },

    setChild: function(i, t) {
        if ( !t ) {
            return;
        }
        if ( t.isNil() ) {
            throw new Error("Can't set single child to a list");
        }
        if ( !this.children ) {
            this.children = this.createChildrenList();
        }
        this.children[i] = t;
        t.setParent(this);
        t.setChildIndex(i);
    },

    deleteChild: function(i) {
        if ( !this.children ) {
            return null;
        }
        if (i<0 || i>=this.children.length) {
            throw new Error("Index out of bounds.");
        }
        var killed = this.children.splice(i, 1)[0];
        // walk rest and decrement their child indexes
        this.freshenParentAndChildIndexes(i);
        return killed;
    },

    /** Delete children from start to stop and replace with t even if t is
     *  a list (nil-root tree).  num of children can increase or decrease.
     *  For huge child lists, inserting children can force walking rest of
     *  children to set their childindex; could be slow.
     */
    replaceChildren: function(startChildIndex, stopChildIndex, t) {
        if ( !this.children ) {
            throw new Error("indexes invalid; no children in list");
        }
        var replacingHowMany = stopChildIndex - startChildIndex + 1;
        var replacingWithHowMany;
        var newTree = t;
        var newChildren = null;
        // normalize to a list of children to add: newChildren
        if ( newTree.isNil() ) {
            newChildren = newTree.children;
        }
        else {
            newChildren = [];
            newChildren.push(newTree);
        }
        replacingWithHowMany = newChildren.length;
        var numNewChildren = newChildren.length;
        var delta = replacingHowMany - replacingWithHowMany;
        var j, i, child, indexToDelete, c, killed, numToInsert;
        // if same number of nodes, do direct replace
        if ( delta === 0 ) {
            j = 0; // index into new children
            for (i=startChildIndex; i<=stopChildIndex; i++) {
                child = newChildren[j];
                this.children[i] = child;
                child.setParent(this);
                child.setChildIndex(i);
                j++;
            }
        }
        else if ( delta > 0 ) { // fewer new nodes than there were
            // set children and then delete extra
            for (j=0; j<numNewChildren; j++) {
                this.children[startChildIndex+j] = newChildren[j];
            }
            indexToDelete = startChildIndex+numNewChildren;
            for (c=indexToDelete; c<=stopChildIndex; c++) {
                // delete same index, shifting everybody down each time
                killed = this.children.splice(indexToDelete, 1)[0];
            }
            this.freshenParentAndChildIndexes(startChildIndex);
        }
        else { // more new nodes than were there before
            // fill in as many children as we can (replacingHowMany) w/o moving data
            for (j=0; j<replacingHowMany; j++) {
                this.children[startChildIndex+j] = newChildren[j];
            }
            numToInsert = replacingWithHowMany-replacingHowMany;
            for (j=replacingHowMany; j<replacingWithHowMany; j++) {
                this.children.splice(startChildIndex+j, 0, newChildren[j]);
            }
            this.freshenParentAndChildIndexes(startChildIndex);
        }
    },

    /** Override in a subclass to change the impl of children list */
    createChildrenList: function() {
        return [];
    },

    isNil: function() {
        return false;
    },

    freshenParentAndChildIndexes: function(offset) {
        if (!org.antlr.lang.isNumber(offset)) {
            offset = 0;
        }
        var n = this.getChildCount(),
            c,
            child;
        for (c = offset; c < n; c++) {
            child = this.getChild(c);
            child.setChildIndex(c);
            child.setParent(this);
        }
    },

    sanityCheckParentAndChildIndexes: function(parent, i) {
        if (arguments.length===0) {
            parent = null;
            i = -1;
        }

        if ( parent!==this.getParent() ) {
            throw new Error("parents don't match; expected "+parent+" found "+this.getParent());
        }
        if ( i!==this.getChildIndex() ) {
            throw new Error("child indexes don't match; expected "+i+" found "+this.getChildIndex());
        }
        var n = this.getChildCount(),
            c,
            child;
        for (c = 0; c < n; c++) {
            child = this.getChild(c);
            child.sanityCheckParentAndChildIndexes(this, c);
        }
    },

    /** BaseTree doesn't track child indexes. */
    getChildIndex: function() {
        return 0;
    },
    setChildIndex: function(index) {
    },

    /** BaseTree doesn't track parent pointers. */
    getParent: function() {
        return null;
    },
    setParent: function(t) {
    },

    getTree: function() {
        return this;
    },

    /** Print out a whole tree not just a node */
    toStringTree: function() {
        if ( !this.children || this.children.length===0 ) {
            return this.toString();
        }
        var buf = "",
            i,
            t;
        if ( !this.isNil() ) {
            buf += "(";
            buf += this.toString();
            buf += ' ';
        }
        for (i = 0; this.children && i < this.children.length; i++) {
            t = this.children[i];
            if ( i>0 ) {
                buf += ' ';
            }
            buf += t.toStringTree();
        }
        if ( !this.isNil() ) {
            buf += ")";
        }
        return buf;
    },

    getLine: function() {
        return 0;
    },

    getCharPositionInLine: function() {
        return 0;
    }
};
/** A tree node that is wrapper for a Token object.  After 3.0 release
 *  while building tree rewrite stuff, it became clear that computing
 *  parent and child index is very difficult and cumbersome.  Better to
 *  spend the space in every tree node.  If you don't want these extra
 *  fields, it's easy to cut them out in your own BaseTree subclass.
 */
org.antlr.runtime.tree.CommonTree = function(node) {
    /** What token indexes bracket all tokens associated with this node
     *  and below?
     */
    this.startIndex = -1;
    this.stopIndex = -1;

    /** What index is this node in the child list? Range: 0..n-1 */
    this.childIndex = -1;

    /** Who is the parent node of this node; if null, implies node is root */
    this.parent = null;

    /** A single token is the payload */
    this.token = null;

    if (node instanceof org.antlr.runtime.tree.CommonTree) {
        org.antlr.runtime.tree.CommonTree.superclass.constructor.call(this, node);
        this.token = node.token;
        this.startIndex = node.startIndex;
        this.stopIndex = node.stopIndex;
    } else if (node instanceof org.antlr.runtime.CommonToken) {
        this.token = node;
    }
};

/** A tree node that is wrapper for a Token object. */
org.antlr.lang.extend(org.antlr.runtime.tree.CommonTree, org.antlr.runtime.tree.BaseTree, {
    getToken: function() {
        return this.token;
    },

    dupNode: function() {
        return new org.antlr.runtime.tree.CommonTree(this);
    },

    isNil: function() {
        return !this.token;
    },

    getType: function() {
        if ( !this.token ) {
            return org.antlr.runtime.Token.INVALID_TOKEN_TYPE;
        }
        return this.token.getType();
    },

    getText: function() {
        if ( !this.token ) {
            return null;
        }
        return this.token.getText();
    },

    getLine: function() {
        if ( !this.token || this.token.getLine()===0 ) {
            if ( this.getChildCount()>0 ) {
                return this.getChild(0).getLine();
            }
            return 0;
        }
        return this.token.getLine();
    },

    getCharPositionInLine: function() {
        if ( !this.token || this.token.getCharPositionInLine()===-1 ) {
            if ( this.getChildCount()>0 ) {
                return this.getChild(0).getCharPositionInLine();
            }
            return 0;
        }
        return this.token.getCharPositionInLine();
    },

    getTokenStartIndex: function() {
        if ( this.token ) {
            return this.token.getTokenIndex();
        }
        return this.startIndex;
    },

    setTokenStartIndex: function(index) {
        this.startIndex = index;
    },

    getTokenStopIndex: function() {
        if ( this.token ) {
            return this.token.getTokenIndex();
        }
        return this.stopIndex;
    },

    setTokenStopIndex: function(index) {
        this.stopIndex = index;
    },

    getChildIndex: function() {
        return this.childIndex;
    },

    getParent: function() {
        return this.parent;
    },

    setParent: function(t) {
        this.parent = t;
    },

    setChildIndex: function(index) {
        this.childIndex = index;
    },

    toString: function() {
        if ( this.isNil() ) {
            return "nil";
        }
        if ( this.getType()===org.antlr.runtime.Token.INVALID_TOKEN_TYPE ) {
            return "<errornode>";
        }
        if ( !this.token ) {
            return null;
        }
        return this.token.getText();
    }
});
/** What does a tree look like?  ANTLR has a number of support classes
 *  such as CommonTreeNodeStream that work on these kinds of trees.  You
 *  don't have to make your trees implement this interface, but if you do,
 *  you'll be able to use more support code.
 *
 *  NOTE: When constructing trees, ANTLR can build any kind of tree; it can
 *  even use Token objects as trees if you add a child list to your tokens.
 *
 *  This is a tree node without any payload; just navigation and factory stuff.
 */
org.antlr.runtime.tree.Tree = {
    INVALID_NODE: new org.antlr.runtime.tree.CommonTree(org.antlr.runtime.Token.INVALID_TOKEN)
};
org.antlr.runtime.tree.CommonErrorNode = function(input, start, stop, e) {
    if ( !stop ||
            (stop.getTokenIndex() < start.getTokenIndex() &&
             stop.getType()!=org.antlr.runtime.Token.EOF) )
    {
        // sometimes resync does not consume a token (when LT(1) is
        // in follow set.  So, stop will be 1 to left to start. adjust.
        // Also handle case where start is the first token and no token
        // is consumed during recovery; LT(-1) will return null.
        stop = start;
    }
    this.input = input;
    this.start = start;
    this.stop = stop;
    this.trappedException = e;
};

org.antlr.lang.extend(org.antlr.runtime.tree.CommonErrorNode, org.antlr.runtime.tree.CommonTree, {
    isNil: function() {
        return false;
    },

    getType: function() {
        return org.antlr.runtime.Token.INVALID_TOKEN_TYPE;
    },

    getText: function() {
        var badText = null;
        if ( this.start instanceof org.antlr.runtime.CommonToken ) {
            var i = this.start.getTokenIndex();
            var j = this.stop.getTokenIndex();
            if ( this.stop.getType() === org.antlr.runtime.Token.EOF ) {
                j = this.input.size();
            }
            badText = this.input.toString(i, j);
        }
        else if ( this.start instanceof org.antlr.runtime.tree.CommonTree ) {
            badText = this.input.toString(this.start, this.stop);
        }
        else {
            // people should subclass if they alter the tree type so this
            // next one is for sure correct.
            badText = "<unknown>";
        }
        return badText;
    },

    toString: function() {
        if ( this.trappedException instanceof org.antlr.runtime.MissingTokenException ) {
            return "<missing type: "+
                   this.trappedException.getMissingType()+
                   ">";
        }
        else if ( this.trappedException instanceof org.antlr.runtime.UnwantedTokenException ) {
            return "<extraneous: "+
                   this.trappedException.getUnexpectedToken()+
                   ", resync="+this.getText()+">";
        }
        else if ( this.trappedException instanceof org.antlr.runtime.MismatchedTokenException ) {
            return "<mismatched token: "+this.trappedException.token+", resync="+this.getText()+">";
        }
        else if ( this.trappedException instanceof org.antlr.runtime.NoViableAltException ) {
            return "<unexpected: "+this.trappedException.token+
                   ", resync="+this.getText()+">";
        }
        return "<error: "+this.getText()+">";
    }
});
/** A TreeAdaptor that works with any Tree implementation. */
org.antlr.runtime.tree.BaseTreeAdaptor = function() {
    this.uniqueNodeID = 1;
};

org.antlr.runtime.tree.BaseTreeAdaptor.prototype = {
    nil: function() {
        return this.create(null);
    },

    /** create tree node that holds the start and stop tokens associated
     *  with an error.
     *
     *  If you specify your own kind of tree nodes, you will likely have to
     *  override this method. CommonTree returns Token.INVALID_TOKEN_TYPE
     *  if no token payload but you might have to set token type for diff
     *  node type.
     */
    errorNode: function(input, start, stop, e) {
        var t = new org.antlr.runtime.tree.CommonErrorNode(input, start, stop, e);
        return t;
    },

    isNil: function(tree) {
        return tree.isNil();
    },

    /** This is generic in the sense that it will work with any kind of
     *  tree (not just Tree interface).  It invokes the adaptor routines
     *  not the tree node routines to do the construction.  
     */
    dupTree: function(t, parent) {
        if (arguments.length===1) {
            parent = null;
        }
        if ( !t ) {
            return null;
        }
        var newTree = this.dupNode(t);
        // ensure new subtree root has parent/child index set
        this.setChildIndex(newTree, this.getChildIndex(t)); // same index in new tree
        this.setParent(newTree, parent);
        var n = this.getChildCount(t),
            i, child, newSubTree;
        for (i = 0; i < n; i++) {
            child = this.getChild(t, i);
            newSubTree = this.dupTree(child, t);
            this.addChild(newTree, newSubTree);
        }
        return newTree;
    },

    /** Add a child to the tree t.  If child is a flat tree (a list), make all
     *  in list children of t.  Warning: if t has no children, but child does
     *  and child isNil then you can decide it is ok to move children to t via
     *  t.children = child.children; i.e., without copying the array.  Just
     *  make sure that this is consistent with have the user will build
     *  ASTs.
     */
    addChild: function(t, child) {
        if ( t && org.antlr.lang.isValue(child) ) {
            t.addChild(child);
        }
    },

    /** If oldRoot is a nil root, just copy or move the children to newRoot.
     *  If not a nil root, make oldRoot a child of newRoot.
     *
     *    old=^(nil a b c), new=r yields ^(r a b c)
     *    old=^(a b c), new=r yields ^(r ^(a b c))
     *
     *  If newRoot is a nil-rooted single child tree, use the single
     *  child as the new root node.
     *
     *    old=^(nil a b c), new=^(nil r) yields ^(r a b c)
     *    old=^(a b c), new=^(nil r) yields ^(r ^(a b c))
     *
     *  If oldRoot was null, it's ok, just return newRoot (even if isNil).
     *
     *    old=null, new=r yields r
     *    old=null, new=^(nil r) yields ^(nil r)
     *
     *  Return newRoot.  Throw an exception if newRoot is not a
     *  simple node or nil root with a single child node--it must be a root
     *  node.  If newRoot is ^(nil x) return x as newRoot.
     *
     *  Be advised that it's ok for newRoot to point at oldRoot's
     *  children; i.e., you don't have to copy the list.  We are
     *  constructing these nodes so we should have this control for
     *  efficiency.
     */
    becomeRoot: function(newRoot, oldRoot) {
        if (newRoot instanceof org.antlr.runtime.CommonToken || !newRoot) {
            newRoot = this.create(newRoot);
        }

        var newRootTree = newRoot,
            oldRootTree = oldRoot;
        if ( !oldRoot ) {
            return newRoot;
        }
        // handle ^(nil real-node)
        if ( newRootTree.isNil() ) {
            if ( newRootTree.getChildCount()>1 ) {
                // TODO: make tree run time exceptions hierarchy
                throw new Error("more than one node as root (TODO: make exception hierarchy)");
            }
            newRootTree = newRootTree.getChild(0);
        }
        // add oldRoot to newRoot; addChild takes care of case where oldRoot
        // is a flat list (i.e., nil-rooted tree).  All children of oldRoot
        // are added to newRoot.
        newRootTree.addChild(oldRootTree);
        return newRootTree;
    },

    /** Transform ^(nil x) to x */
    rulePostProcessing: function(root) {
        var r = root;
        if ( r && r.isNil() ) {
            if ( r.getChildCount()===0 ) {
                r = null;
            }
            else if ( r.getChildCount()===1 ) {
                r = r.getChild(0);
                // whoever invokes rule will set parent and child index
                r.setParent(null);
                r.setChildIndex(-1);
            }
        }
        return r;
    },

    create: function(tokenType, fromToken) {
        var text, t;
        if (arguments.length===2) {
            if (org.antlr.lang.isString(arguments[1])) {
                text = arguments[1];
                fromToken = this.createToken(tokenType, text);
                t = this.create(fromToken);
                return t;
            } else {
                fromToken = this.createToken(fromToken);
                fromToken.setType(tokenType);
                t = this.create(fromToken);
                return t;
            }
        } else if (arguments.length===3) {
            text = arguments[2];
            fromToken = this.createToken(fromToken);
            fromToken.setType(tokenType);
            fromToken.setText(text);
            t = this.create(fromToken);
            return t;
        }
    },

    getType: function(t) {
        t.getType();
        return 0;
    },

    setType: function(t, type) {
        throw new Error("don't know enough about Tree node");
    },

    getText: function(t) {
        return t.getText();
    },

    setText: function(t, text) {
        throw new Error("don't know enough about Tree node");
    },

    getChild: function(t, i) {
        return t.getChild(i);
    },

    setChild: function(t, i, child) {
        t.setChild(i, child);
    },

    deleteChild: function(t, i) {
        return t.deleteChild(i);
    },

    getChildCount: function(t) {
        return t.getChildCount();
    },

    getUniqueID: function(node) {
        if ( !this.treeToUniqueIDMap ) {
             this.treeToUniqueIDMap = {};
        }
        var prevID = this.treeToUniqueIDMap[node];
        if ( org.antlr.lang.isValue(prevID) ) {
            return prevID;
        }
        var ID = this.uniqueNodeID;
        this.treeToUniqueIDMap[node] = ID;
        this.uniqueNodeID++;
        return ID;
        // GC makes these nonunique:
        // return System.identityHashCode(node);
    }
};
/** A TreeAdaptor that works with any Tree implementation.  It provides
 *  really just factory methods; all the work is done by BaseTreeAdaptor.
 *  If you would like to have different tokens created than ClassicToken
 *  objects, you need to override this and then set the parser tree adaptor to
 *  use your subclass.
 *
 *  To get your parser to build nodes of a different type, override
 *  create(Token).
 */
org.antlr.runtime.tree.CommonTreeAdaptor = function() {};

org.antlr.lang.extend(org.antlr.runtime.tree.CommonTreeAdaptor,
                  org.antlr.runtime.tree.BaseTreeAdaptor, {
    /** Duplicate a node.  This is part of the factory;
     *    override if you want another kind of node to be built.
     *
     *  I could use reflection to prevent having to override this
     *  but reflection is slow.
     */
    dupNode: function(t) {
        if ( !org.antlr.lang.isValue(t) ) {
            return null;
        }
        return t.dupNode();
    },

    create: function(payload) {
        if (arguments.length>1) {
            return org.antlr.runtime.tree.CommonTreeAdaptor.superclass.create.apply(this, arguments);
        }
        return new org.antlr.runtime.tree.CommonTree(payload);
    },

    /** Tell me how to create a token for use with imaginary token nodes.
     *  For example, there is probably no input symbol associated with imaginary
     *  token DECL, but you need to create it as a payload or whatever for
     *  the DECL node as in ^(DECL type ID).
     *
     *  If you care what the token payload objects' type is, you should
     *  override this method and any other createToken variant.
     *
     * Tell me how to create a token for use with imaginary token nodes.
     *  For example, there is probably no input symbol associated with imaginary
     *  token DECL, but you need to create it as a payload or whatever for
     *  the DECL node as in ^(DECL type ID).
     *
     *  This is a variant of createToken where the new token is derived from
     *  an actual real input token.  Typically this is for converting '{'
     *  tokens to BLOCK etc...  You'll see
     *
     *    r : lc='{' ID+ '}' -> ^(BLOCK[$lc] ID+) ;
     *
     *  If you care what the token payload objects' type is, you should
     *  override this method and any other createToken variant.
     */
    createToken: function(fromToken) {
        if (arguments.length===2) {
            return new org.antlr.runtime.CommonToken(arguments[0], arguments[1]);
        } else {
            return new org.antlr.runtime.CommonToken(arguments[0]);
        }
    },

    /** Track start/stop token for subtree root created for a rule.
     *  Only works with Tree nodes.  For rules that match nothing,
     *  seems like this will yield start=i and stop=i-1 in a nil node.
     *  Might be useful info so I'll not force to be i..i.
     */
    setTokenBoundaries: function(t, startToken, stopToken) {
        if ( !org.antlr.lang.isValue(t) ) {
            return;
        }
        var start = 0,
            stop = 0;
        if ( org.antlr.lang.isValue(startToken) ) {
            if (startToken.getTokenIndex) {
                start = startToken.getTokenIndex();
            } else if (startToken.getStartIndex) {
                start = startToken.getStartIndex();
            } else {
                start = startToken.getTokenStartIndex();
            }
        }
        if ( org.antlr.lang.isValue(stopToken) ) {
            if (stop.getTokenIndex) {
                stop = stopToken.getTokenIndex();
            } else if (stopToken.getStopIndex) {
                stop = stopToken.getStopIndex();
            } else {
                stop = stopToken.getTokenStopIndex();
            }
        }
        t.setTokenStartIndex(start);
        t.setTokenStopIndex(stop);
    },

    getTokenStartIndex: function(t) {
        if (!t) {
            return -1;
        }
        return t.getTokenStartIndex();
    },

    getTokenStopIndex: function(t) {
        if (!t) {
            return -1;
        }
        return t.getTokenStopIndex();
    },

    getText: function(t) {
        if (!t) {
            return null;
        }
        return t.getText();
    },

    getType: function(t) {
        if (!t) {
            return org.antlr.runtime.Token.INVALID_TOKEN_TYPE;
        }
        return t.getType();
    },

    /** What is the Token associated with this node?  If
     *  you are not using CommonTree, then you must
     *  override this in your own adaptor.
     */
    getToken: function(t) {
        if ( t instanceof org.antlr.runtime.tree.CommonTree ) {
            return t.getToken();
        }
        return null; // no idea what to do
    },

    getChild: function(t, i) {
        if (!t) {
            return null;
        }
        return t.getChild(i);
    },

    getChildCount: function(t) {
        if (!t) {
            return 0;
        }
        return t.getChildCount();
    },

    getParent: function(t) {
        return t.getParent();
    },

    setParent: function(t, parent) {
        t.setParent(parent);
    },

    getChildIndex: function(t) {
        return t.getChildIndex();
    },

    setChildIndex: function(t, index) {
        t.setChildIndex(index);
    },

    replaceChildren: function(parent, startChildIndex, stopChildIndex, t) {
        if ( parent ) {
            parent.replaceChildren(startChildIndex, stopChildIndex, t);
        }
    }
});
/**
 * A stream of characters created from a JavaScript string that in turn gets
 * fed to a lexer.
 * @class
 * @param {String} data the string from which this stream will be created.
 */
org.antlr.runtime.ANTLRStringStream = function(data) {
    /**
     * Location in the stream.
     * Ranges from 0 to (stream length - 1).
     * @private
     * @type Number
     */
    this.p = 0;

    /**
     * The current line in the input.
     * Ranges from 1 to (number of lines).
     * @private
     * @type Number
     */
    this.line = 1;

    /**
     * The index of the character relative to the beginning of the line.
     * Ranges from 0 to (length of line - 1).
     * @private
     * @type Number
     */
    this.charPositionInLine = 0;

    /**
     * Tracks how deep mark() calls are nested
     * @private
     * @type Number
     */
    this.markDepth = 0;

    /**
     * An Array of objects that tracks the stream state
     * values line, charPositionInLine, and p that can change as you
     * move through the input stream.  Indexed from 1..markDepth.
     * A null is kept at index 0.  Created upon first call to mark().
     * @private
     * @type Array
     */
    this.markers = null;

    /**
     * Track the last mark() call result value for use in rewind().
     * @private
     * @type Number
     */
    this.lastMarker = null;

    /**
     * The data being scanned.
     * @private
     * @type String
     */
    this.data = data;

    /**
     * The number of characters in the stream.
     * @private
     * @type Number
     */
    this.n = data.length;
};

org.antlr.runtime.ANTLRStringStream.prototype = {
    /**
     * Reset the stream so that it's in the same state it was
     * when the object was created *except* the data array is not
     * touched.
     */
    reset: function() {
       this.p = 0;
       this.line = 1;
       this.charPositionInLine = 0;
       this.markDepth = 0;
    },

    /**
     * Consume the next character of data in the stream.
     */
    consume: function() {
        if ( this.p < this.n ) {
            this.charPositionInLine++;
            if ( this.data.charAt(this.p)==="\n" ) {
                this.line++;
                this.charPositionInLine=0;
            }
            this.p++;
        }
    },

    /**
     * Get character at current input pointer + i ahead where i=1 is next int.
     * Negative indexes are allowed.  LA(-1) is previous token (token
     * just matched).  LA(-i) where i is before first token should
     * yield -1, invalid char / EOF.
     * @param {Number} i non-zero amount of lookahead or lookback
     * @returns {String|Number} The charcter at the specified position or -1 if
     *      you fell off either end of the stream.
     */
    LA: function(i) {
        if ( i<0 ) {
            i++; // e.g., translate LA(-1) to use offset i=0; then data[p+0-1]
        }

        var new_pos = this.p+i-1;
        if (new_pos>=this.n || new_pos<0) {
            return org.antlr.runtime.CharStream.EOF;
        }
        return this.data.charAt(new_pos);
    },


    /**
     * Return the current input symbol index 0..n where n indicates the
     * last symbol has been read.  The index is the index of char to
     * be returned from LA(1) (i.e. the one about to be consumed).
     * @returns {Number} the index of the current input symbol
     */
    index: function() {
        return this.p;
    },

    /**
     * The length of this stream.
     * @returns {Number} the length of this stream.
     */
    size: function() {
        return this.n;
    },

    /**
     * Tell the stream to start buffering if it hasn't already.  Return
     * current input position, index(), or some other marker so that
     * when passed to rewind() you get back to the same spot.
     * rewind(mark()) should not affect the input cursor.  The Lexer
     * tracks line/col info as well as input index so its markers are
     * not pure input indexes.  Same for tree node streams.
     *
     * <p>Marking is a mechanism for storing the current position of a stream
     * in a stack.  This corresponds with the predictive look-ahead mechanism
     * used in Lexers.</p>
     * @returns {Number} the current size of the mark stack.
     */
    mark: function() {
        if ( !this.markers ) {
            this.markers = [];
            this.markers.push(null); // depth 0 means no backtracking, leave blank
        }
        this.markDepth++;
        var state = null;
        if ( this.markDepth>=this.markers.length ) {
            state = {};
            this.markers.push(state);
        }
        else {
            state = this.markers[this.markDepth];
        }
        state.p = this.p;
        state.line = this.line;
        state.charPositionInLine = this.charPositionInLine;
        this.lastMarker = this.markDepth;
        return this.markDepth;
    },

    /**
     * Rewind to the input position of the last marker.
     * Used currently only after a cyclic DFA and just
     * before starting a sem/syn predicate to get the
     * input position back to the start of the decision.
     * Do not "pop" the marker off the state.  mark(i)
     * and rewind(i) should balance still. It is
     * like invoking rewind(last marker) but it should not "pop"
     * the marker off.  It's like seek(last marker's input position).
     * @param {Number} [m] the index in the mark stack to load instead of the
     *      last.
     */
    rewind: function(m) {
        if (!org.antlr.lang.isNumber(m)) {
            m = this.lastMarker;
        }

        var state = this.markers[m];
        // restore stream state
        this.seek(state.p);
        this.line = state.line;
        this.charPositionInLine = state.charPositionInLine;
        this.release(m);
    },

    /**
     * You may want to commit to a backtrack but don't want to force the
     * stream to keep bookkeeping objects around for a marker that is
     * no longer necessary.  This will have the same behavior as
     * rewind() except it releases resources without the backward seek.
     * This must throw away resources for all markers back to the marker
     * argument.  So if you're nested 5 levels of mark(), and then release(2)
     * you have to release resources for depths 2..5.
     * @param {Number} marker the mark depth above which all mark states will
     *      be released.
     */
    release: function(marker) {
        // unwind any other markers made after m and release m
        this.markDepth = marker;
        // release this marker
        this.markDepth--;
    },

    /**
     * Set the input cursor to the position indicated by index.  This is
     * normally used to seek ahead in the input stream.  No buffering is
     * required to do this unless you know your stream will use seek to
     * move backwards such as when backtracking.
     *
     * <p>This is different from rewind in its multi-directional
     * requirement and in that its argument is strictly an input cursor
     * (index).</p>
     *
     * <p>For char streams, seeking forward must update the stream state such
     * as line number.  For seeking backwards, you will be presumably
     * backtracking using the mark/rewind mechanism that restores state and
     * so this method does not need to update state when seeking backwards.</p>
     *
     * <p>Currently, this method is only used for efficient backtracking using
     * memoization, but in the future it may be used for incremental
     * parsing.</p>
     *
     * <p>The index is 0..n-1.  A seek to position i means that LA(1) will
     * return the ith symbol.  So, seeking to 0 means LA(1) will return the
     * first element in the stream.</p>
     *
     * <p>Esentially this method method moves the input position,
     * {@link #consume}-ing data if necessary.</p>
     *
     * @param {Number} index the position to seek to.
     */
    seek: function(index) {
        if ( index<=this.p ) {
            this.p = index; // just jump; don't update stream state (line, ...)
            return;
        }
        // seek forward, consume until p hits index
        while ( this.p<index ) {
            this.consume();
        }
    },

    /**
     * Retrieve a substring from this stream.
     * @param {Number} start the starting index of the substring (inclusive).
     * @param {Number} stop the last index of the substring (inclusive).
     * @returns {String}
     */
    substring: function(start, stop) {
        return this.data.substr(start,stop-start+1);
    },

    /**
     * Return the current line position in the stream.
     * @returns {Number} the current line position in the stream (1..numlines).
     */
    getLine: function() {
        return this.line;
    },

    /**
     * Get the index of the character relative to the beginning of the line.
     * Ranges from 0 to (length of line - 1).
     * @returns {Number}
     */
    getCharPositionInLine: function() {
        return this.charPositionInLine;
    },

    /**
     * Set the current line in the input stream.
     * This is used internally when performing rewinds.
     * @param {Number} line
     * @private
     */
    setLine: function(line) {
        this.line = line;
    },

    /**
     * Set the index of the character relative to the beginning of the line.
     * Ranges from 0 to (length of line - 1).
     * @param {Number} pos
     * @private
     */
    setCharPositionInLine: function(pos) {
        this.charPositionInLine = pos;
    },

    /** Where are you getting symbols from? Normally, implementations will
     *  pass the buck all the way to the lexer who can ask its input stream
     *  for the file name or whatever.
     */
    getSourceName: function() {
        return null;
    }
};

/**
 * Alias for {@link #LA}.
 * @methodOf org.antlr.runtime.ANTLRStringStream.prototype
 * @name LT
 */
org.antlr.runtime.ANTLRStringStream.LT = org.antlr.runtime.ANTLRStringStream.LA;
/** The most common stream of tokens is one where every token is buffered up
 *  and tokens are prefiltered for a certain channel (the parser will only
 *  see these tokens and cannot change the filter channel number during the
 *  parse).
 *
 *  TODO: how to access the full token stream?  How to track all tokens matched per rule?
 */
org.antlr.runtime.CommonTokenStream = function(tokenSource, channel) {
    this.p = -1;
    this.channel = org.antlr.runtime.Token.DEFAULT_CHANNEL;
    this.v_discardOffChannelTokens = false;

    this.tokens = [];
    if (arguments.length >= 2) {
        this.channel = channel;
    } else if (arguments.length === 1) {
        this.tokenSource = tokenSource;
    }
};

org.antlr.runtime.CommonTokenStream.prototype = {
    /** Reset this token stream by setting its token source. */
    setTokenSource: function(tokenSource) {
        this.tokenSource = tokenSource;
        this.tokens = [];
        this.p = -1;
        this.channel = org.antlr.runtime.Token.DEFAULT_CHANNEL;
    },

    /** Load all tokens from the token source and put in tokens.
     *  This is done upon first LT request because you might want to
     *  set some token type / channel overrides before filling buffer.
     */
    fillBuffer: function() {
        var index = 0,
            t = this.tokenSource.nextToken(),
            discard,
            channelI;
        while ( org.antlr.lang.isValue(t) && 
                t.getType()!=org.antlr.runtime.CharStream.EOF )
        {
            discard = false;
            // is there a channel override for token type?
            if ( this.channelOverrideMap ) {
                channelI = this.channelOverrideMap[t.getType()];
                if ( org.antlr.lang.isValue(channelI) ) {
                    t.setChannel(channelI);
                }
            }
            if ( this.discardSet && this.discardSet[t.getType()] )
            {
                discard = true;
            }
            else if ( this.v_discardOffChannelTokens &&
                    t.getChannel()!=this.channel )
            {
                discard = true;
            }
            if ( !discard )    {
                t.setTokenIndex(index);
                this.tokens.push(t);
                index++;
            }
            t = this.tokenSource.nextToken();
        }
        // leave p pointing at first token on channel
        this.p = 0;
        this.p = this.skipOffTokenChannels(this.p);
    },

    /** Move the input pointer to the next incoming token.  The stream
     *  must become active with LT(1) available.  consume() simply
     *  moves the input pointer so that LT(1) points at the next
     *  input symbol. Consume at least one token.
     *
     *  Walk past any token not on the channel the parser is listening to.
     */
    consume: function() {
        if ( this.p<this.tokens.length ) {
            this.p++;
            this.p = this.skipOffTokenChannels(this.p); // leave p on valid token
        }
    },

    /** Given a starting index, return the index of the first on-channel
     *  token.
     */
    skipOffTokenChannels: function(i) {
        var n = this.tokens.length;
        while ( i<n && (this.tokens[i]).getChannel()!=this.channel ) {
            i++;
        }
        return i;
    },

    skipOffTokenChannelsReverse: function(i) {
        while ( i>=0 && (this.tokens[i]).getChannel()!=this.channel ) {
            i--;
        }
        return i;
    },

    /** A simple filter mechanism whereby you can tell this token stream
     *  to force all tokens of type ttype to be on channel.  For example,
     *  when interpreting, we cannot exec actions so we need to tell
     *  the stream to force all WS and NEWLINE to be a different, ignored
     *  channel.
     */
    setTokenTypeChannel: function(ttype, channel) {
        if ( !this.channelOverrideMap ) {
            this.channelOverrideMap = {};
        }
        this.channelOverrideMap[ttype] = channel;
    },

    discardTokenType: function(ttype) {
        if ( !this.discardSet ) {
            this.discardSet = {};
        }
        this.discardSet[ttype] = true;
    },

    discardOffChannelTokens: function(b) {
        this.v_discardOffChannelTokens = b;
    },

    /** Given a start and stop index, return a List of all tokens in
     *  the token type BitSet.  Return null if no tokens were found.  This
     *  method looks at both on and off channel tokens.
     */
    getTokens: function(start, stop, types) {
        if ( this.p === -1 ) {
            this.fillBuffer();
        }

        if (arguments.length===0) {
            return this.tokens;
        }

        if (org.antlr.lang.isArray(types)) {
            types = new org.antlr.runtime.BitSet(types);
        } else if (org.antlr.lang.isNumber(types)) {
            types = org.antlr.runtime.BitSet.of(types);
        }

        if ( stop>=this.tokens.length ) {
            stop=this.tokens.length-1;
        }
        if ( start<0 ) {
            start=0;
        }
        if ( start>stop ) {
            return null;
        }

        // list = tokens[start:stop]:{Token t, t.getType() in types}
        var filteredTokens = [],
            i,
            t;
        for (i=start; i<=stop; i++) {
            t = this.tokens[i];
            if ( !this.types || types.member(t.getType()) ) {
                filteredTokens.push(t);
            }
        }
        if ( filteredTokens.length===0 ) {
            filteredTokens = null;
        }
        return filteredTokens;
    },

    /** Get the ith token from the current position 1..n where k=1 is the
     *  first symbol of lookahead.
     */
    LT: function(k) {
        if ( this.p === -1 ) {
            this.fillBuffer();
        }
        if ( k===0 ) {
            return null;
        }
        if ( k<0 ) {
            return this.LB(-1*k);
        }
        if ( (this.p+k-1) >= this.tokens.length ) {
            return org.antlr.runtime.Token.EOF_TOKEN;
        }
        var i = this.p,
            n = 1;
        // find k good tokens
        while ( n<k ) {
            // skip off-channel tokens
            i = this.skipOffTokenChannels(i+1); // leave p on valid token
            n++;
        }
        if ( i>=this.tokens.length ) {
            return org.antlr.runtime.Token.EOF_TOKEN;
        }
        return this.tokens[i];
    },

    /** Look backwards k tokens on-channel tokens */
    LB: function(k) {
        if ( this.p === -1 ) {
            this.fillBuffer();
        }
        if ( k===0 ) {
            return null;
        }
        if ( (this.p-k)<0 ) {
            return null;
        }

        var i = this.p,
            n = 1;
        // find k good tokens looking backwards
        while ( n<=k ) {
            // skip off-channel tokens
            i = this.skipOffTokenChannelsReverse(i-1); // leave p on valid token
            n++;
        }
        if ( i<0 ) {
            return null;
        }
        return this.tokens[i];
    },

    /** Return absolute token i; ignore which channel the tokens are on;
     *  that is, count all tokens not just on-channel tokens.
     */
    get: function(i) {
        return this.tokens[i];
    },

    LA: function(i) {
        return this.LT(i).getType();
    },

    mark: function() {
        if ( this.p === -1 ) {
            this.fillBuffer();
        }
        this.lastMarker = this.index();
        return this.lastMarker;
    },

    release: function(marker) {
        // no resources to release
    },

    size: function() {
        return this.tokens.length;
    },

    index: function() {
        return this.p;
    },

    rewind: function(marker) {
        if (!org.antlr.lang.isNumber(marker)) {
            marker = this.lastMarker;
        }
        this.seek(marker);
    },

    reset: function() {
        this.p = -1;
        this.lastMarker = 0;
    },

    seek: function(index) {
        this.p = index;
    },

    getTokenSource: function() {
        return this.tokenSource;
    },

    getSourceName: function() {
        return this.getTokenSource().getSourceName();
    },

    toString: function(start, stop) {
        if (arguments.length===0) {
            if ( this.p === -1 ) {
                this.fillBuffer();
            }
            start = 0;
            stop = this.tokens.length-1;
        }

        if (!org.antlr.lang.isNumber(start) && !org.antlr.lang.isNumber(stop)) {
            if ( org.antlr.lang.isValue(start) && org.antlr.lang.isValue(stop) ) {
                start = start.getTokenIndex();
                stop = stop.getTokenIndex();
            } else {
                return null;
            }
        }

        var buf = "",
            i;
 
        if ( start<0 || stop<0 ) {
            return null;
        }
        if ( this.p == -1 ) {
            this.fillBuffer();
        }
        if ( stop>=this.tokens.length ) {
            stop = this.tokens.length-1;
        }
        for (i = start; i <= stop; i++) {
            t = this.tokens[i];
            buf = buf + this.tokens[i].getText();
        }
        return buf;
    }
};
/* Useful for dumping out the input stream after doing some
 *  augmentation or other manipulations.
 *
 *  You can insert stuff, replace, and delete chunks.  Note that the
 *  operations are done lazily--only if you convert the buffer to a
 *  String.  This is very efficient because you are not moving data around
 *  all the time.  As the buffer of tokens is converted to strings, the
 *  toString() method(s) check to see if there is an operation at the
 *  current index.  If so, the operation is done and then normal String
 *  rendering continues on the buffer.  This is like having multiple Turing
 *  machine instruction streams (programs) operating on a single input tape. :)
 *
 *  Since the operations are done lazily at toString-time, operations do not
 *  screw up the token index values.  That is, an insert operation at token
 *  index i does not change the index values for tokens i+1..n-1.
 *
 *  Because operations never actually alter the buffer, you may always get
 *  the original token stream back without undoing anything.  Since
 *  the instructions are queued up, you can easily simulate transactions and
 *  roll back any changes if there is an error just by removing instructions.
 *  For example,
 *
 *   CharStream input = new ANTLRFileStream("input");
 *   TLexer lex = new TLexer(input);
 *   TokenRewriteStream tokens = new TokenRewriteStream(lex);
 *   T parser = new T(tokens);
 *   parser.startRule();
 *
 *      Then in the rules, you can execute
 *      Token t,u;
 *      ...
 *      input.insertAfter(t, "text to put after t");}
 *         input.insertAfter(u, "text after u");}
 *         System.out.println(tokens.toString());
 *
 *  Actually, you have to cast the 'input' to a TokenRewriteStream. :(
 *
 *  You can also have multiple "instruction streams" and get multiple
 *  rewrites from a single pass over the input.  Just name the instruction
 *  streams and use that name again when printing the buffer.  This could be
 *  useful for generating a C file and also its header file--all from the
 *  same buffer:
 *
 *      tokens.insertAfter("pass1", t, "text to put after t");}
 *         tokens.insertAfter("pass2", u, "text after u");}
 *         System.out.println(tokens.toString("pass1"));
 *         System.out.println(tokens.toString("pass2"));
 *
 *  If you don't use named rewrite streams, a "default" stream is used as
 *  the first example shows.
 */

org.antlr.runtime.TokenRewriteStream = function() {
    var sup = org.antlr.runtime.TokenRewriteStream.superclass;

    /** You may have multiple, named streams of rewrite operations.
     *  I'm calling these things "programs."
     *  Maps String (name) -> rewrite (List)
     */
    this.programs = null;

    /** Map String (program name) -> Integer index */
    this.lastRewriteTokenIndexes = null;


    if (arguments.length===0) {
        this.init();
    } else {
        sup.constructor.apply(this, arguments);
        this.init();
    }
};

(function(){
var trs = org.antlr.runtime.TokenRewriteStream;

org.antlr.lang.augmentObject(trs, {
    DEFAULT_PROGRAM_NAME: "default",
    PROGRAM_INIT_SIZE: 100,
    MIN_TOKEN_INDEX: 0
});

//
// Define the rewrite operation hierarchy
//

trs.RewriteOperation = function(index, text) {
    this.index = index;
    this.text = text;
};

/** Execute the rewrite operation by possibly adding to the buffer.
 *  Return the index of the next token to operate on.
 */
trs.RewriteOperation.prototype = {
    execute: function(buf) {
        return this.index;
    },
    toString: function() {
        /*String opName = getClass().getName();
        int $index = opName.indexOf('$');
        opName = opName.substring($index+1, opName.length());
        return opName+"@"+index+'"'+text+'"';*/
        return this.text;
    }
};

trs.InsertBeforeOp = function(index, text) {
    trs.InsertBeforeOp.superclass.constructor.call(this, index, text);
};
org.antlr.lang.extend(trs.InsertBeforeOp, trs.RewriteOperation, {
    execute: function(buf) {
        buf.push(this.text);
        return this.index;
    }
});

/** I'm going to try replacing range from x..y with (y-x)+1 ReplaceOp
 *  instructions.
 */
trs.ReplaceOp = function(from, to, text) {
    trs.ReplaceOp.superclass.constructor.call(this, from, text); 
    this.lastIndex = to;
};
org.antlr.lang.extend(trs.ReplaceOp, trs.RewriteOperation, {
    execute: function(buf) {
        if (org.antlr.lang.isValue(this.text)) {
            buf.push(this.text);
        }
        return this.lastIndex+1;
    }
});

trs.DeleteOp = function(from, to) {
    trs.DeleteOp.superclass.constructor.call(this, from, to); 
};
org.antlr.lang.extend(trs.DeleteOp, trs.ReplaceOp);

org.antlr.lang.extend(trs, org.antlr.runtime.CommonTokenStream, {
    init: function() {
        this.programs = {};
        this.programs[trs.DEFAULT_PROGRAM_NAME] = [];
        this.lastRewriteTokenIndexes = {};
    },

    /** Rollback the instruction stream for a program so that
     *  the indicated instruction (via instructionIndex) is no
     *  longer in the stream.  UNTESTED!
     */
    rollback: function() {
        var programName,
            instructionIndex;

        if (arguments.length===1) {
            programName = trs.DEFAULT_PROGRAM_NAME;
            instructionIndex = arguments[0];
        } else if (arguments.length===2) {
            programName = arguments[0];
            instructionIndex = arguments[1];
        }
        var is = this.programs[programName];
        if (is) {
            programs[programName] = is.slice(trs.MIN_TOKEN_INDEX, this.instructionIndex);
        }
    },

    /** Reset the program so that no instructions exist */
    deleteProgram: function(programName) {
        programName = programName || trs.DEFAULT_PROGRAM_NAME;
        this.rollback(programName, trs.MIN_TOKEN_INDEX);
    },

    /** Add an instruction to the rewrite instruction list ordered by
     *  the instruction number (use a binary search for efficiency).
     *  The list is ordered so that toString() can be done efficiently.
     *
     *  When there are multiple instructions at the same index, the instructions
     *  must be ordered to ensure proper behavior.  For example, a delete at
     *  index i must kill any replace operation at i.  Insert-before operations
     *  must come before any replace / delete instructions.  If there are
     *  multiple insert instructions for a single index, they are done in
     *  reverse insertion order so that "insert foo" then "insert bar" yields
     *  "foobar" in front rather than "barfoo".  This is convenient because
     *  I can insert new InsertOp instructions at the index returned by
     *  the binary search.  A ReplaceOp kills any previous replace op.  Since
     *  delete is the same as replace with null text, i can check for
     *  ReplaceOp and cover DeleteOp at same time. :)
     */
    addToSortedRewriteList: function() {
        var programName,
            op;
        if (arguments.length===1) {
            programName = trs.DEFAULT_PROGRAM_NAME;
            op = arguments[0];
        } else if (arguments.length===2) {
            programName = arguments[0];
            op = arguments[1];
        }

        var rewrites = this.getProgram(programName);
        var len, pos, searchOp, replaced, prevOp, i;
        for (pos=0, len=rewrites.length; pos<len; pos++) {
            searchOp = rewrites[pos];
            if (searchOp.index===op.index) {
                // now pos is the index in rewrites of first op with op.index

                // an instruction operating already on that index was found;
                // make this one happen after all the others
                if (op instanceof trs.ReplaceOp) {
                    replaced = false;
                    // look for an existing replace
                    for (i=pos; i<rewrites.length; i++) {
                        prevOp = rewrites[pos];
                        if (prevOp.index!==op.index) {
                            break;
                        }
                        if (prevOp instanceof trs.ReplaceOp) {
                            rewrites[pos] = op; // replace old with new
                            replaced=true;
                            break;
                        }
                        // keep going; must be an insert
                    }
                    if ( !replaced ) {
                        // add replace op to the end of all the inserts
                        rewrites.splice(i, 0, op);
                    }
                } else {
                    // inserts are added in front of existing inserts
                    rewrites.splice(pos, 0, op);
                }
                break;
            } else if (searchOp.index > op.index) {
                rewrites.splice(pos, 0, op);
                break;
            }
        }
        if (pos===len) {
            rewrites.push(op);
        }
    },

    insertAfter: function() {
        var index, programName, text;
        if (arguments.length===2) {
            programName = trs.DEFAULT_PROGRAM_NAME;
            index = arguments[0];
            text = arguments[1];
        } else if (arguments.length===3) {
            programName = arguments[0];
            index = arguments[1];
            text = arguments[2];
        }

        if (index instanceof org.antlr.runtime.CommonToken) {
            // index is a Token, grab it's stream index
            index = index.index; // that's ugly
        }

        // insert after is the same as insert before the next index
        this.insertBefore(programName, index+1, text);
    },

    insertBefore: function() {
        var index, programName, text;
        if (arguments.length===2) {
            programName = trs.DEFAULT_PROGRAM_NAME;
            index = arguments[0];
            text = arguments[1];
        } else if (arguments.length===3) {
            programName = arguments[0];
            index = arguments[1];
            text = arguments[2];
        }

        if (index instanceof org.antlr.runtime.CommonToken) {
            // index is a Token, grab it's stream index
            index = index.index; // that's ugly
        }

        this.addToSortedRewriteList(
                programName,
                new trs.InsertBeforeOp(index,text)
                );
    },

    replace: function() {
        var programName, first, last, text;
        if (arguments.length===2) {
            programName = trs.DEFAULT_PROGRAM_NAME;
            first = arguments[0];
            last = arguments[0];
            text = arguments[1];
        } else if (arguments.length===3) {
            programName = trs.DEFAULT_PROGRAM_NAME;
            first = arguments[0];
            last = arguments[1];
            text = arguments[2];
        } if (arguments.length===4) {
            programName = arguments[0];
            first = arguments[1];
            last = arguments[2];
            text = arguments[3];
        } 

        if (first instanceof org.antlr.runtime.CommonToken) {
            first = first.index;
        }

        if (last instanceof org.antlr.runtime.CommonToken) {
            last = last.index; // that's ugly
        }

        if ( first > last || last<0 || first<0 ) {
            return;
        }
        this.addToSortedRewriteList(
                programName,
                new trs.ReplaceOp(first, last, text));
    },

    // !!! API Break: delete is a JS keyword, so using remove instead.
    remove: function() {
        // convert arguments to a real array
        var args=[], i=arguments.length-1;
        while (i>=0) {
            args[i] = arguments[i];
            i--;
        }

        args.push("");
        this.replace.apply(this, args);
    },

    getLastRewriteTokenIndex: function(programName) {
        programName = programName || trs.DEFAULT_PROGRAM_NAME;
        return this.lastRewriteTokenIndexes[programName] || -1;
    },

    setLastRewriteTokenIndex: function(programName, i) {
        this.lastRewriteTokenIndexes[programName] = i;
    },

    getProgram: function(name) {
        var is = this.programs[name];
        if ( !is ) {
            is = this.initializeProgram(name);
        }
        return is;
    },

    initializeProgram: function(name) {
        var is = [];
        this.programs[name] = is;
        return is;
    },

    toOriginalString: function(start, end) {
        if (!org.antlr.lang.isNumber(start)) {
            start = trs.MIN_TOKEN_INDEX;
        }
        if (!org.antlr.lang.isNumber(end)) {
            end = this.size()-1;
        }

        var buf = [], i;
        for (i=start; i>=trs.MIN_TOKEN_INDEX && i<=end && i<this.tokens.length; i++) {
            buf.push(this.get(i).getText());
        }
        return buf.join("");
    },

    toString: function() {
        var programName, start, end;
        if (arguments.length===0) {
            programName = trs.DEFAULT_PROGRAM_NAME;
            start = trs.MIN_TOKEN_INDEX;
            end = this.size() - 1;
        } else if (arguments.length===1) {
            programName = arguments[0];
            start = trs.MIN_TOKEN_INDEX;
            end = this.size() - 1;
        } else if (arguments.length===2) {
            programName = trs.DEFAULT_PROGRAM_NAME;
            start = arguments[0];
            end = arguments[1];
        }

        var rewrites = this.programs[programName];
        if ( !rewrites || rewrites.length===0 ) {
            return this.toOriginalString(start,end);
        }

        /// Index of first rewrite we have not done
        var rewriteOpIndex = 0,
            tokenCursor=start,
            buf = [],
            op;
        while ( tokenCursor>=trs.MIN_TOKEN_INDEX &&
                tokenCursor<=end &&
                tokenCursor<this.tokens.length )
        {
            // execute instructions associated with this token index
            if ( rewriteOpIndex<rewrites.length ) {
                op = rewrites[rewriteOpIndex];

                // skip all ops at lower index
                while (op.index<tokenCursor && rewriteOpIndex<rewrites.length) {
                    rewriteOpIndex++;
                    if ( rewriteOpIndex<rewrites.length ) {
                        op = rewrites[rewriteOpIndex];
                    }
                }

                // while we have ops for this token index, exec them
                while (tokenCursor===op.index && rewriteOpIndex<rewrites.length) {
                    //System.out.println("execute "+op+" at instruction "+rewriteOpIndex);
                    tokenCursor = op.execute(buf);
                    //System.out.println("after execute tokenCursor = "+tokenCursor);
                    rewriteOpIndex++;
                    if ( rewriteOpIndex<rewrites.length ) {
                        op = rewrites[rewriteOpIndex];
                    }
                }
            }
            // dump the token at this index
            if ( tokenCursor<=end ) {
                buf.push(this.get(tokenCursor).getText());
                tokenCursor++;
            }
        }
        // now see if there are operations (append) beyond last token index
        var opi;
        for (opi=rewriteOpIndex; opi<rewrites.length; opi++) {
            op = rewrites[opi];
            if ( op.index>=this.size() ) {
                op.execute(buf); // must be insertions if after last token
            }
        }

        return buf.join("");
    },

    toDebugString: function(start, end) {
        if (!org.antlr.lang.isNumber(start)) {
            start = trs.MIN_TOKEN_INDEX;
        }
        if (!org.antlr.lang.isNumber(end)) {
            end = this.size()-1;
        }

        var buf = [],
            i;
        for (i=start; i>=trs.MIN_TOKEN_INDEX && i<=end && i<this.tokens.length; i++) {
            buf.push(this.get(i));
        }
        return buf.join("");
    }
});

})();
/** A stream of tree nodes, accessing nodes from a tree of some kind */
org.antlr.runtime.tree.TreeNodeStream = function() {};
/** A buffered stream of tree nodes.  Nodes can be from a tree of ANY kind.
 *
 *  This node stream sucks all nodes out of the tree specified in
 *  the constructor during construction and makes pointers into
 *  the tree using an array of Object pointers. The stream necessarily
 *  includes pointers to DOWN and UP and EOF nodes.
 *
 *  This stream knows how to mark/release for backtracking.
 *
 *  This stream is most suitable for tree interpreters that need to
 *  jump around a lot or for tree parsers requiring speed (at cost of memory).
 *  There is some duplicated functionality here with UnBufferedTreeNodeStream
 *  but just in bookkeeping, not tree walking etc...
 *
 *  @see UnBufferedTreeNodeStream
 */
org.antlr.runtime.tree.CommonTreeNodeStream = function(adaptor,
                                                    tree,
                                                    initialBufferSize)
{
    if (arguments.length===1) {
        tree = adaptor;
        adaptor = new org.antlr.runtime.tree.CommonTreeAdaptor();
    }
    if (arguments.length <= 2) {
        initialBufferSize =
            org.antlr.runtime.tree.CommonTreeNodeStream.DEFAULT_INITIAL_BUFFER_SIZE;
    }

    /** Reuse same DOWN, UP navigation nodes unless this is true */
    this.uniqueNavigationNodes = false;

    /** The index into the nodes list of the current node (next node
     *  to consume).  If -1, nodes array not filled yet.
     */
    this.p = -1;

    var Token = org.antlr.runtime.Token;
    this.root = tree;
    this.adaptor = adaptor;
    this.nodes = []; //new ArrayList(initialBufferSize);
    this.down = this.adaptor.create(Token.DOWN, "DOWN");
    this.up = this.adaptor.create(Token.UP, "UP");
    this.eof = this.adaptor.create(Token.EOF, "EOF");
};

org.antlr.lang.augmentObject(org.antlr.runtime.tree.CommonTreeNodeStream, {
    DEFAULT_INITIAL_BUFFER_SIZE: 100,
    INITIAL_CALL_STACK_SIZE: 10
});

org.antlr.lang.extend(org.antlr.runtime.tree.CommonTreeNodeStream,
                  org.antlr.runtime.tree.TreeNodeStream, 
{
    StreamIterator: function() {
        var i = 0,
            nodes = this.nodes,
            eof = this.eof;

        return {
            hasNext: function() {
                return i<nodes.length;
            },

            next: function() {
                var current = i;
                i++;
                if ( current < nodes.length ) {
                    return nodes[current];
                }
                return eof;
            },

            remove: function() {
                throw new Error("cannot remove nodes from stream");
            }
        };
    },

    /** Walk tree with depth-first-search and fill nodes buffer.
     *  Don't do DOWN, UP nodes if its a list (t is isNil).
     */
    fillBuffer: function(t) {
        var reset_p = false;
        if (org.antlr.lang.isUndefined(t)) {
            t = this.root;
            reset_p = true;
        }

        var nil = this.adaptor.isNil(t);
        if ( !nil ) {
            this.nodes.push(t); // add this node
        }
        // add DOWN node if t has children
        var n = this.adaptor.getChildCount(t);
        if ( !nil && n>0 ) {
            this.addNavigationNode(org.antlr.runtime.Token.DOWN);
        }
        // and now add all its children
        var c, child;
        for (c=0; c<n; c++) {
            child = this.adaptor.getChild(t,c);
            this.fillBuffer(child);
        }
        // add UP node if t has children
        if ( !nil && n>0 ) {
            this.addNavigationNode(org.antlr.runtime.Token.UP);
        }

        if (reset_p) {
            this.p = 0; // buffer of nodes intialized now
        }
    },

    getNodeIndex: function(node) {
        if ( this.p==-1 ) {
            this.fillBuffer();
        }
        var i, t;
        for (i=0; i<this.nodes.length; i++) {
            t = this.nodes[i];
            if ( t===node ) {
                return i;
            }
        }
        return -1;
    },

    /** As we flatten the tree, we use UP, DOWN nodes to represent
     *  the tree structure.  When debugging we need unique nodes
     *  so instantiate new ones when uniqueNavigationNodes is true.
     */
    addNavigationNode: function(ttype) {
        var navNode = null;
        if ( ttype===org.antlr.runtime.Token.DOWN ) {
            if ( this.hasUniqueNavigationNodes() ) {
                navNode = this.adaptor.create(org.antlr.runtime.Token.DOWN, "DOWN");
            }
            else {
                navNode = this.down;
            }
        }
        else {
            if ( this.hasUniqueNavigationNodes() ) {
                navNode = this.adaptor.create(org.antlr.runtime.Token.UP, "UP");
            }
            else {
                navNode = this.up;
            }
        }
        this.nodes.push(navNode);
    },

    get: function(i) {
        if ( this.p===-1 ) {
            this.fillBuffer();
        }
        return this.nodes[i];
    },

    LT: function(k) {
        if ( this.p===-1 ) {
            this.fillBuffer();
        }
        if ( k===0 ) {
            return null;
        }
        if ( k<0 ) {
            return this.LB(-1*k);
        }
        if ( (this.p+k-1) >= this.nodes.length ) {
            return this.eof;
        }
        return this.nodes[this.p+k-1];
    },

    getCurrentSymbol: function() { return this.LT(1); },

    /** Look backwards k nodes */
    LB: function(k) {
        if ( k===0 ) {
            return null;
        }
        if ( (this.p-k)<0 ) {
            return null;
        }
        return this.nodes[this.p-k];
    },

    getTreeSource: function() {
        return this.root;
    },

    getSourceName: function() {
        return this.getTokenStream().getSourceName();
    },

    getTokenStream: function() {
        return this.tokens;
    },

    setTokenStream: function(tokens) {
        this.tokens = tokens;
    },

    getTreeAdaptor: function() {
        return this.adaptor;
    },

    setTreeAdaptor: function(adaptor) {
        this.adaptor = adaptor;
    },

    hasUniqueNavigationNodes: function() {
        return this.uniqueNavigationNodes;
    },

    setUniqueNavigationNodes: function(uniqueNavigationNodes) {
        this.uniqueNavigationNodes = uniqueNavigationNodes;
    },

    consume: function() {
        if ( this.p===-1 ) {
            this.fillBuffer();
        }
        this.p++;
    },

    LA: function(i) {
        return this.adaptor.getType(this.LT(i));
    },

    mark: function() {
        if ( this.p===-1 ) {
            this.fillBuffer();
        }
        this.lastMarker = this.index();
        return this.lastMarker;
    },

    release: function(marker) {
        // no resources to release
    },

    index: function() {
        return this.p;
    },

    rewind: function(marker) {
        if (!org.antlr.lang.isNumber(marker)) {
            marker = this.lastMarker;
        }
        this.seek(marker);
    },

    seek: function(index) {
        if ( this.p===-1 ) {
            this.fillBuffer();
        }
        this.p = index;
    },

    /** Make stream jump to a new location, saving old location.
     *  Switch back with pop().
     */
    push: function(index) {
        if ( !this.calls ) {
            this.calls = [];
        }
        this.calls.push(this.p); // save current index
        this.seek(index);
    },

    /** Seek back to previous index saved during last push() call.
     *  Return top of stack (return index).
     */
    pop: function() {
        var ret = this.calls.pop();
        this.seek(ret);
        return ret;
    },

    reset: function() {
        this.p = -1;
        this.lastMarker = 0;
        if (this.calls) {
            this.calls = [];
        }
    },

    size: function() {
        if ( this.p===-1 ) {
            this.fillBuffer();
        }
        return this.nodes.length;
    },

    iterator: function() {
        if ( this.p===-1 ) {
            this.fillBuffer();
        }
        return this.StreamIterator();
    },

    replaceChildren: function(parent, startChildIndex, stopChildIndex, t) {
        if ( parent ) {
            this.adaptor.replaceChildren(parent, startChildIndex, stopChildIndex, t);
        }
    },

    /** Debugging */
    toTokenString: function(start, stop) {
        if ( this.p===-1 ) {
            this.fillBuffer();
        }
        var buf='', i, t;
        for (i = start; i < this.nodes.length && i <= stop; i++) {
            t = this.nodes[i];
            buf += " "+this.adaptor.getToken(t);
        }
        return buf;
    },

    /** Used for testing, just return the token type stream */
    toString: function(start, stop) {
        var buf = "",
            text,
            t,
            i;
        if (arguments.length===0) {
            if ( this.p===-1 ) {
                this.fillBuffer();
            }
            for (i = 0; i < this.nodes.length; i++) {
                t = this.nodes[i];
                buf += " ";
                buf += this.adaptor.getType(t);
            }
            return buf;
        } else {
            if ( !org.antlr.lang.isNumber(start) || !org.antlr.lang.isNumber(stop) ) {
                return null;
            }
            if ( this.p===-1 ) {
                this.fillBuffer();
            }
            //System.out.println("stop: "+stop);
            if ( start instanceof org.antlr.runtime.tree.CommonTree ) {
                //System.out.print("toString: "+((CommonTree)start).getToken()+", ");
            } else {
                //System.out.println(start);
            }
            if ( stop instanceof org.antlr.runtime.tree.CommonTree ) {
                //System.out.println(((CommonTree)stop).getToken());
            } else {
                //System.out.println(stop);
            }
            // if we have the token stream, use that to dump text in order
            var beginTokenIndex,
                endTokenIndex;
            if ( this.tokens ) {
                beginTokenIndex = this.adaptor.getTokenStartIndex(start);
                endTokenIndex = this.adaptor.getTokenStopIndex(stop);
                // if it's a tree, use start/stop index from start node
                // else use token range from start/stop nodes
                if ( this.adaptor.getType(stop)===org.antlr.runtime.Token.UP ) {
                    endTokenIndex = this.adaptor.getTokenStopIndex(start);
                }
                else if ( this.adaptor.getType(stop)==org.antlr.runtime.Token.EOF )
                {
                    endTokenIndex = this.size()-2; // don't use EOF
                }
                return this.tokens.toString(beginTokenIndex, endTokenIndex);
            }
            // walk nodes looking for start
            t = null;
            i = 0;
            for (; i < this.nodes.length; i++) {
                t = this.nodes[i];
                if ( t===start ) {
                    break;
                }
            }
            // now walk until we see stop, filling string buffer with text
            buf = text = "";
            t = this.nodes[i];
            while ( t!==stop ) {
                text = this.adaptor.getText(t);
                if ( !org.antlr.lang.isString(text) ) {
                    text = " "+this.adaptor.getType(t).toString();
                }
                buf += text;
                i++;
                t = nodes[i];
            }
            // include stop node too
            text = this.adaptor.getText(stop);
            if ( !org.antlr.lang.isString(text) ) {
                text = " "+this.adaptor.getType(stop).toString();
            }
            buf += text;
            return buf;
        }
    }
});
/** A generic list of elements tracked in an alternative to be used in
 *  a -> rewrite rule.  We need to subclass to fill in the next() method,
 *  which returns either an AST node wrapped around a token payload or
 *  an existing subtree.
 *
 *  Once you start next()ing, do not try to add more elements.  It will
 *  break the cursor tracking I believe.
 *
 *  @see org.antlr.runtime.tree.RewriteRuleSubtreeStream
 *  @see org.antlr.runtime.tree.RewriteRuleTokenStream
 *
 *  TODO: add mechanism to detect/puke on modification after reading from stream
 */
org.antlr.runtime.tree.RewriteRuleElementStream = function(adaptor, elementDescription, el) {
    /** Cursor 0..n-1.  If singleElement!=null, cursor is 0 until you next(),
     *  which bumps it to 1 meaning no more elements.
     */
    this.cursor = 0;

    /** Once a node / subtree has been used in a stream, it must be dup'd
     *  from then on.  Streams are reset after subrules so that the streams
     *  can be reused in future subrules.  So, reset must set a dirty bit.
     *  If dirty, then next() always returns a dup.
     *
     *  I wanted to use "naughty bit" here, but couldn't think of a way
     *  to use "naughty".
     */
    this.dirty = false;

    this.elementDescription = elementDescription;
    this.adaptor = adaptor;
    if (el) {
        if (org.antlr.lang.isArray(el)) {
            this.singleElement = null;
            this.elements = el;
        } else {
            this.add(el);
        }
    }
};

org.antlr.runtime.tree.RewriteRuleElementStream.prototype = {
    /** Reset the condition of this stream so that it appears we have
     *  not consumed any of its elements.  Elements themselves are untouched.
     *  Once we reset the stream, any future use will need duplicates.  Set
     *  the dirty bit.
     */
    reset: function() {
        this.cursor = 0;
        this.dirty = true;
    },

    add: function(el) {
        if ( !org.antlr.lang.isValue(el) ) {
            return;
        }
        if ( this.elements ) { // if in list, just add
            this.elements.push(el);
            return;
        }
        if ( !org.antlr.lang.isValue(this.singleElement) ) { // no elements yet, track w/o list
            this.singleElement = el;
            return;
        }
        // adding 2nd element, move to list
        this.elements = [];
        this.elements.push(this.singleElement);
        this.singleElement = null;
        this.elements.push(el);
    },

    /** Return the next element in the stream.  If out of elements, throw
     *  an exception unless size()==1.  If size is 1, then return elements[0].
     *  Return a duplicate node/subtree if stream is out of elements and
     *  size==1.  If we've already used the element, dup (dirty bit set).
     */
    nextTree: function() {
        var n = this.size(),
            el;
        if ( this.dirty || (this.cursor>=n && n==1) ) {
            // if out of elements and size is 1, dup
            el = this._next();
            return this.dup(el);
        }
        // test size above then fetch
        el = this._next();
        return el;
    },

    /** do the work of getting the next element, making sure that it's
     *  a tree node or subtree.  Deal with the optimization of single-
     *  element list versus list of size > 1.  Throw an exception
     *  if the stream is empty or we're out of elements and size>1.
     *  protected so you can override in a subclass if necessary.
     */
    _next: function() {
        var n = this.size();
        if (n===0) {
            throw new org.antlr.runtime.tree.RewriteEmptyStreamException(this.elementDescription);
        }
        if ( this.cursor>= n) { // out of elements?
            if ( n===1 ) {  // if size is 1, it's ok; return and we'll dup
                return this.toTree(this.singleElement);
            }
            // out of elements and size was not 1, so we can't dup
            throw new org.antlr.runtime.tree.RewriteCardinalityException(this.elementDescription);
        }
        // we have elements
        if ( org.antlr.lang.isValue(this.singleElement) ) {
            this.cursor++; // move cursor even for single element list
            return this.toTree(this.singleElement);
        }
        // must have more than one in list, pull from elements
        var o = this.toTree(this.elements[this.cursor]);
        this.cursor++;
        return o;
    },

    /** Ensure stream emits trees; tokens must be converted to AST nodes.
     *  AST nodes can be passed through unmolested.
     */
    toTree: function(el) {
        if (el && el.getTree) {
            return el.getTree();
        }
        return el;
    },

    hasNext: function() {
         return (org.antlr.lang.isValue(this.singleElement) && this.cursor < 1) ||
               (this.elements && this.cursor < this.elements.length);
    },

    size: function() {
        var n = 0;
        if ( org.antlr.lang.isValue(this.singleElement) ) {
            n = 1;
        }
        if ( this.elements ) {
            return this.elements.length;
        }
        return n;
    },

    getDescription: function() {
        return this.elementDescription;
    }
};
/** Queues up nodes matched on left side of -> in a tree parser. This is
 *  the analog of RewriteRuleTokenStream for normal parsers. 
 */
org.antlr.runtime.tree.RewriteRuleNodeStream = function(adaptor, elementDescription, el) {
    org.antlr.runtime.tree.RewriteRuleNodeStream.superclass.constructor.apply(this, arguments);
};

org.antlr.lang.extend(org.antlr.runtime.tree.RewriteRuleNodeStream,
                  org.antlr.runtime.tree.RewriteRuleElementStream,
{
    nextNode: function() {
        return this._next();
    },

    toTree: function(el) {
        return this.adaptor.dupNode(el);
    },

    dup: function() {
        // we dup every node, so don't have to worry about calling dup; short-
        // circuited next() so it doesn't call.
        throw new Error("dup can't be called for a node stream.");
    }
});
org.antlr.runtime.tree.RewriteRuleTokenStream = function(adaptor, elementDescription, el) {
    var sup = org.antlr.runtime.tree.RewriteRuleTokenStream.superclass;
    sup.constructor.apply(this, arguments);
};

org.antlr.lang.extend(org.antlr.runtime.tree.RewriteRuleTokenStream,
                  org.antlr.runtime.tree.RewriteRuleElementStream, {
    /** Get next token from stream and make a node for it */
    nextNode: function() {
        var t = this._next();
        return this.adaptor.create(t);
    },

    nextToken: function() {
        return this._next();
    },

    /** Don't convert to a tree unless they explicitly call nextTree.
     *  This way we can do hetero tree nodes in rewrite.
     */
    toTree: function(el) {
        return el;
    },

    dup: function(el) {
        throw new Error("dup can't be called for a token stream.");
    }
});
org.antlr.runtime.tree.RewriteRuleSubtreeStream = function() {
    var sup = org.antlr.runtime.tree.RewriteRuleSubtreeStream.superclass;
    sup.constructor.apply(this, arguments);
};

org.antlr.lang.extend(org.antlr.runtime.tree.RewriteRuleSubtreeStream,
                  org.antlr.runtime.tree.RewriteRuleElementStream, {
	/** Treat next element as a single node even if it's a subtree.
	 *  This is used instead of next() when the result has to be a
	 *  tree root node.  Also prevents us from duplicating recently-added
	 *  children; e.g., ^(type ID)+ adds ID to type and then 2nd iteration
	 *  must dup the type node, but ID has been added.
	 *
	 *  Referencing a rule result twice is ok; dup entire tree as
	 *  we can't be adding trees as root; e.g., expr expr.
	 *
	 *  Hideous code duplication here with super.next().  Can't think of
	 *  a proper way to refactor.  This needs to always call dup node
	 *  and super.next() doesn't know which to call: dup node or dup tree.
	 */
    nextNode: function() {
		var n = this.size(),
            el;
		if ( this.dirty || (this.cursor>=n && n===1) ) {
			// if out of elements and size is 1, dup (at most a single node
			// since this is for making root nodes).
			el = this._next();
			return this.adaptor.dupNode(el);
		}
		// test size above then fetch
		el = this._next();
		return el;
	},

    dup: function(el) {
		return this.adaptor.dupTree(el);
	}
});/** A generic recognizer that can handle recognizers generated from
 *  lexer, parser, and tree grammars.  This is all the parsing
 *  support code essentially; most of it is error recovery stuff and
 *  backtracking.
 *
 *  <p>This class should not be instantiated directly.  Instead, use one of its
 *  subclasses.</p>
 *
 *  @class
 *  @param {org.antlr.runtime.RecognizerSharedState} [state] optional state object
 *      with which to initialize this recognizer.
 */
org.antlr.runtime.BaseRecognizer = function(state) {
    /** State of a lexer, parser, or tree parser are collected into a state
     *  object so the state can be shared.  This sharing is needed to
     *  have one grammar import others and share same error variables
     *  and other state variables.  It's a kind of explicit multiple
     *  inheritance via delegation of methods and shared state.
     */
    this.state = state || new org.antlr.runtime.RecognizerSharedState();
};

/* static vars, methods */
org.antlr.lang.augmentObject(org.antlr.runtime.BaseRecognizer, {
    MEMO_RULE_FAILED: -2,
    MEMO_RULE_UNKNOWN: -1,
    INITIAL_FOLLOW_STACK_SIZE: 100,
    MEMO_RULE_FAILED_I: -2,
    DEFAULT_TOKEN_CHANNEL: org.antlr.runtime.Token.DEFAULT_CHANNEL,
    HIDDEN: org.antlr.runtime.Token.HIDDEN_CHANNEL,
    NEXT_TOKEN_RULE_NAME: "nextToken"
});

org.antlr.runtime.BaseRecognizer.prototype = {
    /** Reset the parser's state.  Subclasses must rewinds the input stream */
    reset: function() {
        var i, len;

        // wack everything related to error recovery
        if (!this.state) {
            return; // no shared state work to do
        }
        this.state._fsp = -1;
        this.state.errorRecovery = false;
        this.state.lastErrorIndex = -1;
        this.state.failed = false;
        this.state.syntaxErrors = 0;
        // wack everything related to backtracking and memoization
        this.state.backtracking = 0;
        // wipe cache
        if (this.state.ruleMemo) {
            for (i=0, len=this.state.ruleMemo.length; i<len; i++) {
                this.state.ruleMemo[i] = null;
            }
        }
    },

    /** Match current input symbol against ttype.  Attempt
     *  single token insertion or deletion error recovery.  If
     *  that fails, throw {@link org.antlr.runtime.MismatchedTokenException}.
     *
     *  <p>To turn off single token insertion or deletion error
     *  recovery, override {@link #mismatchRecover} and have it call
     *  plain {@link #mismatch}, which does not recover.  Then any error
     *  in a rule will cause an exception and immediate exit from
     *  rule.  Rule would recover by resynchronizing to the set of
     *  symbols that can follow rule ref.</p>
     *
     *  @param {org.antlr.runtime.IntStream} input input stream to match against.
     *  @param {Number} ttype  input type to match.
     *  @param {org.antlr.runtime.BitSet} [follow] set of tokens that can follow the
     *      matched token.
     *  @returns {Object} the matched symbol
     */
    match: function(input, ttype, follow) {
        var matchedSymbol = this.getCurrentInputSymbol(input);
        if ( input.LA(1)===ttype ) {
            input.consume();
            this.state.errorRecovery = false;
            this.state.failed = false;
            return matchedSymbol;
        }
        if ( this.state.backtracking>0 ) {
            this.state.failed = true;
            return matchedSymbol;
        }
        matchedSymbol = this.recoverFromMismatchedToken(input, ttype, follow);
        return matchedSymbol;
    },

    /**
     * Match any token.
     * @param {org.antlr.runtime.IntStream} input input stream to match against.
     */
    matchAny: function(input) {
        this.state.errorRecovery = false;
        this.state.failed = false;
        input.consume();
    },

    /**
     * Is the following token (LA(2)) the unwanted type (ttype)?
     * @param {org.antlr.runtime.IntStream} input input stream to match against.
     * @param {Number} ttype the undesired token type.
     * @returns {Boolean} true if and only if the following token is the
     *      unwanted type.
     */
    mismatchIsUnwantedToken: function(input, ttype) {
        return input.LA(2)===ttype;
    },

    /**
     * Does the stream appear to be missing a single token?
     * @param {org.antlr.runtime.IntStream} input input stream to match against.
     * @param {org.antlr.runtime.BitSet} [follow] set of tokens that can follow the
     *      matched token.
     * @returns {Boolean} true if and only if it appears that the stream is
     *      missing a single token.
     */
    mismatchIsMissingToken: function(input, follow) {
        if ( !follow ) {
            // we have no information about the follow; we can only consume
            // a single token and hope for the best
            return false;
        }
        // compute what can follow this grammar element reference
        if ( follow.member(org.antlr.runtime.Token.EOR_TOKEN_TYPE) ) {
            if ( this.state._fsp>=0 ) { // remove EOR if we're not the start symbol
                follow.remove(org.antlr.runtime.Token.EOR_TOKEN_TYPE);
            }
            var viableTokensFollowingThisRule = this.computeContextSensitiveRuleFOLLOW();
            follow = follow.or(this.viableTokensFollowingThisRule);
        }
        // if current token is consistent with what could come after set
        // then we know we're missing a token; error recovery is free to
        // "insert" the missing token

        // BitSet cannot handle negative numbers like -1 (EOF) so I leave EOR
        // in follow set to indicate that the fall of the start symbol is
        // in the set (EOF can follow).
        if ( follow.member(input.LA(1)) ||
             follow.member(org.antlr.runtime.Token.EOR_TOKEN_TYPE) )
        {
            return true;
        }
        return false;
    },

    /** Factor out what to do upon token mismatch so tree parsers can behave
     *  differently.  Override and call {@link #mismatchRecover}
     *  to get single token insertion and deletion.
     *
     *  @param {org.antlr.runtime.IntStream} input input stream to match against.
     *  @param {Number} ttype  input type to match.
     *  @param {org.antlr.runtime.BitSet} [follow] set of tokens that can follow the
     *      matched token.
     */
    mismatch: function(input, ttype, follow) {
        if ( this.mismatchIsUnwantedToken(input, ttype) ) {
            throw new org.antlr.runtime.UnwantedTokenException(ttype, input);
        } else if ( this.mismatchIsMissingToken(input, follow) ) {
            throw new org.antlr.runtime.MissingTokenException(ttype, input, null);
        }
        throw new org.antlr.runtime.MismatchedTokenException(ttype, input);
    },

    /** Report a recognition problem.
     *
     *  <p>This method sets errorRecovery to indicate the parser is recovering
     *  not parsing.  Once in recovery mode, no errors are generated.
     *  To get out of recovery mode, the parser must successfully match
     *  a token (after a resync).  So it will go:</p>
     *  <ol>
     *      <li>error occurs</li>
     *      <li>enter recovery mode, report error</li>
     *      <li>consume until token found in resynch set</li>
     *      <li>try to resume parsing</li>
     *      <li>next match() will reset errorRecovery mode</li>
     *  </ol>
     *
     *  <p>If you override, make sure to update this.state.syntaxErrors if you
     *  care about that.</p>
     *  @param {org.antlr.runtime.RecognitionException} e the error to be reported.
     */
    reportError: function(e) {
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if ( this.state.errorRecovery ) {
            return;
        }
        this.state.syntaxErrors++;
        this.state.errorRecovery = true;

        this.displayRecognitionError(this.getTokenNames(), e);
    },

    /**
     * Assemble recognition error message.
     * @param {Array} tokenNames array of token names (strings).
     * @param {org.antlr.runtime.RecognitionException} e the error to be reported.
     */
    displayRecognitionError: function(tokenNames, e) {
        var hdr = this.getErrorHeader(e),
            msg = this.getErrorMessage(e, tokenNames);
        this.emitErrorMessage(hdr+" "+msg);
    },

    /**
     * Create error header message.  Format is <q>line
     * lineNumber:positionInLine</q>.
     * @param {org.antlr.runtime.RecognitionException} e the error to be reported.
     * @returns {String} The error header.
     */
    getErrorHeader: function(e) {
        /* handle null input */
        if (!org.antlr.lang.isNumber(e.line)) {
            e.line = 0;
        }
        return "line "+e.line+":"+e.charPositionInLine;
    },

    /**
     * Override this method to change where error messages go.
     * Defaults to "alert"-ing the error in browsers and "print"-ing the error
     * in other environments (e.g. Rhino, SpiderMonkey).
     * @param {String} msg the error message to be displayed.
     */
    emitErrorMessage: function(msg) {
        if (typeof(window) != 'undefined' && window.alert) {
            alert(msg);
        } else {
            print(msg);
        }
    },

    /** What error message should be generated for the various
     *  exception types?
     *
     *  <p>Not very object-oriented code, but I like having all error message
     *  generation within one method rather than spread among all of the
     *  exception classes. This also makes it much easier for the exception
     *  handling because the exception classes do not have to have pointers back
     *  to this object to access utility routines and so on. Also, changing
     *  the message for an exception type would be difficult because you
     *  would have to be subclassing exceptions, but then somehow get ANTLR
     *  to make those kinds of exception objects instead of the default.</p>
     *
     *  <p>For grammar debugging, you will want to override this to add
     *  more information such as the stack frame and no viable alts.</p>
     *
     *  <p>Override this to change the message generated for one or more
     *  exception types.</p>
     *
     * @param {Array} tokenNames array of token names (strings).
     * @param {org.antlr.runtime.RecognitionException} e the error to be reported.
     * @returns {String} the error message to be emitted.
     */
    getErrorMessage: function(e, tokenNames) {
        var msg = (e && e.getMessage) ? e.getMessage() : null,
            mte,
            tokenName;
        if ( e instanceof org.antlr.runtime.UnwantedTokenException ) {
            var ute = e;
            tokenName="<unknown>";
            if ( ute.expecting== org.antlr.runtime.Token.EOF ) {
                tokenName = "EOF";
            } else {
                tokenName = tokenNames[ute.expecting];
            }
            msg = "extraneous input "+this.getTokenErrorDisplay(ute.getUnexpectedToken())+
                " expecting "+tokenName;
        }
        else if ( e instanceof org.antlr.runtime.MissingTokenException ) {
            mte = e;
            tokenName="<unknown>";
            if ( mte.expecting== org.antlr.runtime.Token.EOF ) {
                tokenName = "EOF";
            } else {
                tokenName = tokenNames[mte.expecting];
            }
            msg = "missing "+tokenName+" at "+this.getTokenErrorDisplay(e.token);
        }
        else if ( e instanceof org.antlr.runtime.MismatchedTokenException ) {
            mte = e;
            tokenName="<unknown>";
            if ( mte.expecting== org.antlr.runtime.Token.EOF ) {
                tokenName = "EOF";
            }
            else {
                tokenName = tokenNames[mte.expecting];
            }
            msg = "mismatched input "+this.getTokenErrorDisplay(e.token)+
                " expecting "+tokenName;
        }
        else if ( e instanceof org.antlr.runtime.NoViableAltException ) {
            msg = "no viable alternative at input "+this.getTokenErrorDisplay(e.token);
        }
        else if ( e instanceof org.antlr.runtime.EarlyExitException ) {
            msg = "required (...)+ loop did not match anything at input "+
                this.getTokenErrorDisplay(e.token);
        }
        else if ( e instanceof org.antlr.runtime.MismatchedSetException ) {
            msg = "mismatched input "+this.getTokenErrorDisplay(e.token)+
                " expecting set "+e.expecting;
        }
        else if ( e instanceof org.antlr.runtime.MismatchedNotSetException ) {
            msg = "mismatched input "+this.getTokenErrorDisplay(e.token)+
                " expecting set "+e.expecting;
        }
        else if ( e instanceof org.antlr.runtime.FailedPredicateException ) {
            msg = "rule "+e.ruleName+" failed predicate: {"+
                e.predicateText+"}?";
        }
        return msg;
    },

    /** Get number of recognition errors (lexer, parser, tree parser).  Each
     *  recognizer tracks its own number.  So parser and lexer each have
     *  separate count.  Does not count the spurious errors found between
     *  an error and next valid token match
     *
     *  See also reportError()
     */
    getNumberOfSyntaxErrors: function() {
        return this.state.syntaxErrors;
    },

    /** How should a token be displayed in an error message? The default
     *  is to display just the text, but during development you might
     *  want to have a lot of information spit out.  Override in that case
     *  to use t.toString() (which, for CommonToken, dumps everything about
     *  the token). This is better than forcing you to override a method in
     *  your token objects because you don't have to go modify your lexer
     *  so that it creates a new Java type.
     */
    getTokenErrorDisplay: function(t) {
        var s = t.getText();
        if ( !org.antlr.lang.isValue(s) ) {
            if ( t.getType()==org.antlr.runtime.Token.EOF ) {
                s = "<EOF>";
            }
            else {
                s = "<"+t.getType()+">";
            }
        }
        s = s.replace(/\n/g,"\\n");
        s = s.replace(/\r/g,"\\r");
        s = s.replace(/\t/g,"\\t");
        return "'"+s+"'";
    },

    /** Recover from an error found on the input stream.  This is
     *  for NoViableAlt and mismatched symbol exceptions.  If you enable
     *  single token insertion and deletion, this will usually not
     *  handle mismatched symbol exceptions but there could be a mismatched
     *  token that the match() routine could not recover from.
     */
    recover: function(input, re) {
        if ( this.state.lastErrorIndex==input.index() ) {
            // uh oh, another error at same token index; must be a case
            // where LT(1) is in the recovery token set so nothing is
            // consumed; consume a single token so at least to prevent
            // an infinite loop; this is a failsafe.
            input.consume();
        }
        this.state.lastErrorIndex = input.index();
        var followSet = this.computeErrorRecoverySet();
        this.beginResync();
        this.consumeUntil(input, followSet);
        this.endResync();
    },

    /** A hook to listen in on the token consumption during error recovery.
     *  The DebugParser subclasses this to fire events to the listenter.
     */
    beginResync: function() {
    },

    endResync: function() {
    },

    /*  Compute the error recovery set for the current rule.  During
     *  rule invocation, the parser pushes the set of tokens that can
     *  follow that rule reference on the stack; this amounts to
     *  computing FIRST of what follows the rule reference in the
     *  enclosing rule. This local follow set only includes tokens
     *  from within the rule; i.e., the FIRST computation done by
     *  ANTLR stops at the end of a rule.
     *
     *  EXAMPLE
     *
     *  When you find a "no viable alt exception", the input is not
     *  consistent with any of the alternatives for rule r.  The best
     *  thing to do is to consume tokens until you see something that
     *  can legally follow a call to r *or* any rule that called r.
     *  You don't want the exact set of viable next tokens because the
     *  input might just be missing a token--you might consume the
     *  rest of the input looking for one of the missing tokens.
     *
     *  Consider grammar:
     *
     *  a : '[' b ']'
     *    | '(' b ')'
     *    ;
     *  b : c '^' INT ;
     *  c : ID
     *    | INT
     *    ;
     *
     *  At each rule invocation, the set of tokens that could follow
     *  that rule is pushed on a stack.  Here are the various "local"
     *  follow sets:
     *
     *  FOLLOW(b1_in_a) = FIRST(']') = ']'
     *  FOLLOW(b2_in_a) = FIRST(')') = ')'
     *  FOLLOW(c_in_b) = FIRST('^') = '^'
     *
     *  Upon erroneous input "[]", the call chain is
     *
     *  a -> b -> c
     *
     *  and, hence, the follow context stack is:
     *
     *  depth  local follow set     after call to rule
     *    0         <EOF>                    a (from main())
     *    1          ']'                     b
     *    3          '^'                     c
     *
     *  Notice that ')' is not included, because b would have to have
     *  been called from a different context in rule a for ')' to be
     *  included.
     *
     *  For error recovery, we cannot consider FOLLOW(c)
     *  (context-sensitive or otherwise).  We need the combined set of
     *  all context-sensitive FOLLOW sets--the set of all tokens that
     *  could follow any reference in the call chain.  We need to
     *  resync to one of those tokens.  Note that FOLLOW(c)='^' and if
     *  we resync'd to that token, we'd consume until EOF.  We need to
     *  sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
     *  In this case, for input "[]", LA(1) is in this set so we would
     *  not consume anything and after printing an error rule c would
     *  return normally.  It would not find the required '^' though.
     *  At this point, it gets a mismatched token error and throws an
     *  exception (since LA(1) is not in the viable following token
     *  set).  The rule exception handler tries to recover, but finds
     *  the same recovery set and doesn't consume anything.  Rule b
     *  exits normally returning to rule a.  Now it finds the ']' (and
     *  with the successful match exits errorRecovery mode).
     *
     *  So, you cna see that the parser walks up call chain looking
     *  for the token that was a member of the recovery set.
     *
     *  Errors are not generated in errorRecovery mode.
     *
     *  ANTLR's error recovery mechanism is based upon original ideas:
     *
     *  "Algorithms + Data Structures = Programs" by Niklaus Wirth
     *
     *  and
     *
     *  "A note on error recovery in recursive descent parsers":
     *  http://portal.acm.org/citation.cfm?id=947902.947905
     *
     *  Later, Josef Grosch had some good ideas:
     *
     *  "Efficient and Comfortable Error Recovery in Recursive Descent
     *  Parsers":
     *  ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
     *
     *  Like Grosch I implemented local FOLLOW sets that are combined
     *  at run-time upon error to avoid overhead during parsing.
     */
    computeErrorRecoverySet: function() {
        return this.combineFollows(false);
    },


    /** Compute the context-sensitive FOLLOW set for current rule.
     *  This is set of token types that can follow a specific rule
     *  reference given a specific call chain.  You get the set of
     *  viable tokens that can possibly come next (lookahead depth 1)
     *  given the current call chain.  Contrast this with the
     *  definition of plain FOLLOW for rule r:
     *
     *   FOLLOW(r)={x | S=>*alpha r beta in G and x in FIRST(beta)}
     *
     *  where x in T* and alpha, beta in V*; T is set of terminals and
     *  V is the set of terminals and nonterminals.  In other words,
     *  FOLLOW(r) is the set of all tokens that can possibly follow
     *  references to r in *any* sentential form (context).  At
     *  runtime, however, we know precisely which context applies as
     *  we have the call chain.  We may compute the exact (rather
     *  than covering superset) set of following tokens.
     *
     *  For example, consider grammar:
     *
     *  stat : ID '=' expr ';'      // FOLLOW(stat)=={EOF}
     *       | "return" expr '.'
     *       ;
     *  expr : atom ('+' atom)* ;   // FOLLOW(expr)=={';','.',')'}
     *  atom : INT                  // FOLLOW(atom)=={'+',')',';','.'}
     *       | '(' expr ')'
     *       ;
     *
     *  The FOLLOW sets are all inclusive whereas context-sensitive
     *  FOLLOW sets are precisely what could follow a rule reference.
     *  For input input "i=(3);", here is the derivation:
     *
     *  stat => ID '=' expr ';'
     *       => ID '=' atom ('+' atom)* ';'
     *       => ID '=' '(' expr ')' ('+' atom)* ';'
     *       => ID '=' '(' atom ')' ('+' atom)* ';'
     *       => ID '=' '(' INT ')' ('+' atom)* ';'
     *       => ID '=' '(' INT ')' ';'
     *
     *  At the "3" token, you'd have a call chain of
     *
     *    stat -> expr -> atom -> expr -> atom
     *
     *  What can follow that specific nested ref to atom?  Exactly ')'
     *  as you can see by looking at the derivation of this specific
     *  input.  Contrast this with the FOLLOW(atom)={'+',')',';','.'}.
     *
     *  You want the exact viable token set when recovering from a
     *  token mismatch.  Upon token mismatch, if LA(1) is member of
     *  the viable next token set, then you know there is most likely
     *  a missing token in the input stream.  "Insert" one by just not
     *  throwing an exception.
     */
    computeContextSensitiveRuleFOLLOW: function() {
        return this.combineFollows(true);
    },

    combineFollows: function(exact) {
        var top = this.state._fsp,
            i,
            localFollowSet,
            followSet = new org.antlr.runtime.BitSet();
        for (i=top; i>=0; i--) {
            localFollowSet = this.state.following[i];
            followSet.orInPlace(localFollowSet);
            if ( exact ) {
                // can we see end of rule?
                if ( localFollowSet.member(org.antlr.runtime.Token.EOR_TOKEN_TYPE) )
                {
                    // Only leave EOR in set if at top (start rule); this lets
                    // us know if have to include follow(start rule); i.e., EOF
                    if ( i>0 ) {
                        followSet.remove(org.antlr.runtime.Token.EOR_TOKEN_TYPE);
                    }
                }
                else { // can't see end of rule, quit
                    break;
                }
            }
        }
        return followSet;
    },

    /** Attempt to recover from a single missing or extra token.
     *
     *  EXTRA TOKEN
     *
     *  LA(1) is not what we are looking for.  If LA(2) has the right token,
     *  however, then assume LA(1) is some extra spurious token.  Delete it
     *  and LA(2) as if we were doing a normal match(), which advances the
     *  input.
     *
     *  MISSING TOKEN
     *
     *  If current token is consistent with what could come after
     *  ttype then it is ok to "insert" the missing token, else throw
     *  exception For example, Input "i=(3;" is clearly missing the
     *  ')'.  When the parser returns from the nested call to expr, it
     *  will have call chain:
     *
     *    stat -> expr -> atom
     *
     *  and it will be trying to match the ')' at this point in the
     *  derivation:
     *
     *       => ID '=' '(' INT ')' ('+' atom)* ';'
     *                          ^
     *  match() will see that ';' doesn't match ')' and report a
     *  mismatched token error.  To recover, it sees that LA(1)==';'
     *  is in the set of tokens that can follow the ')' token
     *  reference in rule atom.  It can assume that you forgot the ')'.
     */
    recoverFromMismatchedToken: function(input,
                                         ttype,
                                         follow)
    {
        var e = null;
        // if next token is what we are looking for then "delete" this token
        if ( this.mismatchIsUnwantedToken(input, ttype) ) {
            e = new org.antlr.runtime.UnwantedTokenException(ttype, input);
            this.beginResync();
            input.consume(); // simply delete extra token
            this.endResync();
            this.reportError(e);  // report after consuming so AW sees the token in the exception
            // we want to return the token we're actually matching
            var matchedSymbol = this.getCurrentInputSymbol(input);
            input.consume(); // move past ttype token as if all were ok
            return matchedSymbol;
        }
        // can't recover with single token deletion, try insertion
        if ( this.mismatchIsMissingToken(input, follow) ) {
            var inserted = this.getMissingSymbol(input, e, ttype, follow);
            e = new org.antlr.runtime.MissingTokenException(ttype, input, inserted);
            this.reportError(e);  // report after inserting so AW sees the token in the exception
            return inserted;
        }
        // even that didn't work; must throw the exception
        e = new org.antlr.runtime.MismatchedTokenException(ttype, input);
        throw e;
    },

    recoverFromMismatchedSet: function(input,
                                       e,
                                       follow)
    {
        if ( this.mismatchIsMissingToken(input, follow) ) {
            // System.out.println("missing token");
            this.reportError(e);
            // we don't know how to conjure up a token for sets yet
            return this.getMissingSymbol(input, e, org.antlr.runtime.Token.INVALID_TOKEN_TYPE, follow);
        }
        throw e;
    },

    /** Match needs to return the current input symbol, which gets put
     *  into the label for the associated token ref; e.g., x=ID.  Token
     *  and tree parsers need to return different objects. Rather than test
     *  for input stream type or change the IntStream interface, I use
     *  a simple method to ask the recognizer to tell me what the current
     *  input symbol is.
     * 
     *  This is ignored for lexers.
     */
    getCurrentInputSymbol: function(input) { return null; },

    /** Conjure up a missing token during error recovery.
     *
     *  The recognizer attempts to recover from single missing
     *  symbols. But, actions might refer to that missing symbol.
     *  For example, x=ID {f($x);}. The action clearly assumes
     *  that there has been an identifier matched previously and that
     *  $x points at that token. If that token is missing, but
     *  the next token in the stream is what we want we assume that
     *  this token is missing and we keep going. Because we
     *  have to return some token to replace the missing token,
     *  we have to conjure one up. This method gives the user control
     *  over the tokens returned for missing tokens. Mostly,
     *  you will want to create something special for identifier
     *  tokens. For literals such as '{' and ',', the default
     *  action in the parser or tree parser works. It simply creates
     *  a CommonToken of the appropriate type. The text will be the token.
     *  If you change what tokens must be created by the lexer,
     *  override this method to create the appropriate tokens.
     */
    getMissingSymbol: function(input,
                               e,
                               expectedTokenType,
                               follow)
    {
        return null;
    },


    /** Consume tokens until one matches the given token set */
    consumeUntil: function(input, set) {
        var ttype = input.LA(1);
        while (ttype != org.antlr.runtime.Token.EOF && !set.member(ttype) ) {
            input.consume();
            ttype = input.LA(1);
        }
    },

    /** Push a rule's follow set using our own hardcoded stack */
    pushFollow: function(fset) {
        if ( (this.state._fsp +1)>=this.state.following.length ) {
            var f = [];
            var i;
            for (i=this.state.following.length-1; i>=0; i--) {
                f[i] = this.state.following[i];
            }
            this.state.following = f;
        }
        this.state._fsp++;
        this.state.following[this.state._fsp] = fset;
    },

    /** Return List<String> of the rules in your parser instance
     *  leading up to a call to this method.  You could override if
     *  you want more details such as the file/line info of where
     *  in the parser java code a rule is invoked.
     *
     *  This is very useful for error messages and for context-sensitive
     *  error recovery.
     *
     *  A more general version of getRuleInvocationStack where you can
     *  pass in, for example, a RecognitionException to get it's rule
     *  stack trace.  This routine is shared with all recognizers, hence,
     *  static.
     *
     *  TODO: move to a utility class or something; weird having lexer call this
     *
     *  Most JS interpreters can't do real stack reflection.  See this
     *  spidermonkey bug, for example:
     *  https://bugzilla.mozilla.org/show_bug.cgi?id=332104
     *
     *  JS is supposed to get real stack traces in v4, at which time it would
     *  be easy to implement this function.
     *
     *  Until then I'll leave this unimplemented.  If there is enough clamor
     *  it would be possible to keep track of the invocation stack using an
     *  auxillary array, but that will definitely be a performance hit.
     */
    getRuleInvocationStack: function(e, recognizerClassName)
    {
        throw new Error("Not implemented.");
    },

    getBacktrackingLevel: function() {
        return this.state.backtracking;
    },

    /** Used to print out token names like ID during debugging and
     *  error reporting.  The generated parsers implement a method
     *  that overrides this to point to their String[] tokenNames.
     */
    getTokenNames: function() {
        return null;
    },

    /** For debugging and other purposes, might want the grammar name.
     *  Have ANTLR generate an implementation for this method.
     */
    getGrammarFileName: function() {
        return null;
    },

    /** A convenience method for use most often with template rewrites.
     *  Convert a List<Token> to List<String>
     */
    toStrings: function(tokens) {
        if ( !tokens ) {
            return null;
        }
        var strings = [];
        var i;
        for (i=0; i<tokens.length; i++) {
            strings.push(tokens[i].getText());
        }
        return strings;
    },

    /** Given a rule number and a start token index number, return
     *  MEMO_RULE_UNKNOWN if the rule has not parsed input starting from
     *  start index.  If this rule has parsed input starting from the
     *  start index before, then return where the rule stopped parsing.
     *  It returns the index of the last token matched by the rule.
     *
     *  For now we use a hashtable and just the slow Object-based one.
     *  Later, we can make a special one for ints and also one that
     *  tosses out data after we commit past input position i.
     */
    getRuleMemoization: function(ruleIndex, ruleStartIndex) {
        if ( !this.state.ruleMemo[ruleIndex] ) {
            this.state.ruleMemo[ruleIndex] = {};
        }
        var stopIndexI =
            this.state.ruleMemo[ruleIndex][ruleStartIndex];
        if ( !org.antlr.lang.isNumber(stopIndexI) ) {
            return org.antlr.runtime.BaseRecognizer.MEMO_RULE_UNKNOWN;
        }
        return stopIndexI;
    },

    /** Has this rule already parsed input at the current index in the
     *  input stream?  Return the stop token index or MEMO_RULE_UNKNOWN.
     *  If we attempted but failed to parse properly before, return
     *  MEMO_RULE_FAILED.
     *
     *  This method has a side-effect: if we have seen this input for
     *  this rule and successfully parsed before, then seek ahead to
     *  1 past the stop token matched for this rule last time.
     */
    alreadyParsedRule: function(input, ruleIndex) {
        var stopIndex = this.getRuleMemoization(ruleIndex, input.index());
        if ( stopIndex==org.antlr.runtime.BaseRecognizer.MEMO_RULE_UNKNOWN ) {
            return false;
        }
        if ( stopIndex==org.antlr.runtime.BaseRecognizer.MEMO_RULE_FAILED ) {
            //System.out.println("rule "+ruleIndex+" will never succeed");
            this.state.failed=true;
        }
        else {
            input.seek(stopIndex+1); // jump to one past stop token
        }
        return true;
    },

    /** Record whether or not this rule parsed the input at this position
     *  successfully.  Use a standard java hashtable for now.
     */
    memoize: function(input,
                      ruleIndex,
                      ruleStartIndex)
    {
        var stopTokenIndex = this.state.failed ? 
            org.antlr.runtime.BaseRecognizer.MEMO_RULE_FAILED : input.index()-1;
        if ( !org.antlr.lang.isValue(this.state.ruleMemo) ) {
            throw new Error("!!!!!!!!! memo array is null for "+ this.getGrammarFileName());
        }
        if ( ruleIndex >= this.state.ruleMemo.length ) {
            throw new Error("!!!!!!!!! memo size is "+this.state.ruleMemo.length+", but rule index is "+ruleIndex);
        }
        if ( org.antlr.lang.isValue(this.state.ruleMemo[ruleIndex]) ) {
            this.state.ruleMemo[ruleIndex][ruleStartIndex] = stopTokenIndex;
        }
    },

    /** return how many rule/input-index pairs there are in total.
     *  TODO: this includes synpreds.
     */
    getRuleMemoizationCacheSize: function() {
        var n = 0, i;
        for (i = 0; this.state.ruleMemo && i < this.state.ruleMemo.length; i++) {
            var ruleMap = this.state.ruleMemo[i];
            if ( ruleMap ) {
                // @todo need to get size of rulemap?
                n += ruleMap.length; // how many input indexes are recorded?
            }
        }
        return n;
    },

    traceIn: function(ruleName, ruleIndex, inputSymbol)  {
        this.emitErrorMessage("enter "+ruleName+" "+inputSymbol);
        if ( this.state.failed ) {
            this.emitErrorMessage(" failed="+this.failed);
        }
        if ( this.state.backtracking>0 ) {
            this.emitErrorMessage(" backtracking="+this.state.backtracking);
        }
        // System.out.println();
    },

    traceOut: function(ruleName, ruleIndex, inputSymbol) {
        this.emitErrorMessage("exit "+ruleName+" "+inputSymbol);
        if ( this.state.failed ) {
            this.emitErrorMessage(" failed="+this.state.failed);
        }
        if ( this.state.backtracking>0 ) {
            this.emitErrorMessage(" backtracking="+this.state.backtracking);
        }
    }
};
/** A lexer is recognizer that draws input symbols from a character stream.
 *  lexer grammars result in a subclass of this object. A Lexer object
 *  uses simplified match() and error recovery mechanisms in the interest
 *  of speed.
 */
org.antlr.runtime.Lexer = function(input, state) {
    if (state) {
        org.antlr.runtime.Lexer.superclass.constructor.call(this, state);
    }
    if (input) {
        this.input = input;
    }
};

org.antlr.lang.extend(org.antlr.runtime.Lexer, org.antlr.runtime.BaseRecognizer, {
    reset: function() {
        // reset all recognizer state variables
        org.antlr.runtime.Lexer.superclass.reset.call(this);
        if ( org.antlr.lang.isValue(this.input) ) {
            this.input.seek(0); // rewind the input
        }
        if ( !org.antlr.lang.isValue(this.state) ) {
            return; // no shared state work to do
        }
        this.state.token = null;
        this.state.type = org.antlr.runtime.Token.INVALID_TOKEN_TYPE;
        this.state.channel = org.antlr.runtime.Token.DEFAULT_CHANNEL;
        this.state.tokenStartCharIndex = -1;
        this.state.tokenStartCharPositionInLine = -1;
        this.state.tokenStartLine = -1;
        this.state.text = null;
    },

    /** Return a token from this source; i.e., match a token on the char
     *  stream.
     */
    nextToken: function() {
        while (true) {
            this.state.token = null;
            this.state.channel = org.antlr.runtime.Token.DEFAULT_CHANNEL;
            this.state.tokenStartCharIndex = this.input.index();
            this.state.tokenStartCharPositionInLine = this.input.getCharPositionInLine();
            this.state.tokenStartLine = this.input.getLine();
            this.state.text = null;
            if ( this.input.LA(1)===org.antlr.runtime.CharStream.EOF ) {
                return org.antlr.runtime.Token.EOF_TOKEN;
            }
            try {
                this.mTokens();
                if ( !org.antlr.lang.isValue(this.state.token) ) {
                    this.emit();
                }
                else if ( this.state.token==org.antlr.runtime.Token.SKIP_TOKEN ) {
                    continue;
                }
                return this.state.token;
            }
            catch (re) {
                if ( re instanceof org.antlr.runtime.RecognitionException ) {
                    this.reportError(re);
                } else if (re instanceof org.antlr.runtime.NoViableAltException) {
                    this.reportError(re);
                    this.recover(re);
                } else {
                    throw re;
                }
            }
        }
    },

    /** Instruct the lexer to skip creating a token for current lexer rule
     *  and look for another token.  nextToken() knows to keep looking when
     *  a lexer rule finishes with token set to SKIP_TOKEN.  Recall that
     *  if token==null at end of any token rule, it creates one for you
     *  and emits it.
     */
    skip: function() {
        this.state.token = org.antlr.runtime.Token.SKIP_TOKEN;
    },

    /** Set the char stream and reset the lexer */
    setCharStream: function(input) {
        this.input = null;
        this.reset();
        this.input = input;
    },

    getCharStream: function() {
        return this.input;
    },

    getSourceName: function() {
        return this.input.getSourceName();
    },

    /** Currently does not support multiple emits per nextToken invocation
     *  for efficiency reasons.  Subclass and override this method and
     *  nextToken (to push tokens into a list and pull from that list rather
     *  than a single variable as this implementation does).
     *
     *  The standard method called to automatically emit a token at the
     *  outermost lexical rule.  The token object should point into the
     *  char buffer start..stop.  If there is a text override in 'text',
     *  use that to set the token's text.  Override this method to emit
     *  custom Token objects.
     *
     *  If you are building trees, then you should also override
     *  Parser or TreeParser.getMissingSymbol().
     */
    emit: function() {
        if (arguments.length===0) {
            var t = new org.antlr.runtime.CommonToken(this.input, this.state.type, this.state.channel, this.state.tokenStartCharIndex, this.getCharIndex()-1);
            t.setLine(this.state.tokenStartLine);
            t.setText(this.state.text);
            t.setCharPositionInLine(this.state.tokenStartCharPositionInLine);
            this.state.token = t;
            return t;
        } else {
            this.state.token = arguments[0];
        }
    },

    match: function(s) {
        var i = 0,
            mte;

        if (org.antlr.lang.isString(s)) {
            while ( i<s.length ) {
                if ( this.input.LA(1)!=s.charAt(i) ) {
                    if ( this.state.backtracking>0 ) {
                        this.state.failed = true;
                        return;
                    }
                    mte = new org.antlr.runtime.MismatchedTokenException(s.charAt(i), this.input);
                    this.recover(mte);
                    throw mte;
                }
                i++;
                this.input.consume();
                this.state.failed = false;
            }
        } else if (org.antlr.lang.isNumber(s)) {
            if ( this.input.LA(1)!=s ) {
                if ( this.state.backtracking>0 ) {
                    this.state.failed = true;
                    return;
                }
                mte = new org.antlr.runtime.MismatchedTokenException(s, this.input);
                this.recover(mte);
                throw mte;
            }
            this.input.consume();
            this.state.failed = false;
        }
    },

    matchAny: function() {
        this.input.consume();
    },

    matchRange: function(a, b) {
        if ( this.input.LA(1)<a || this.input.LA(1)>b ) {
            if ( this.state.backtracking>0 ) {
                this.state.failed = true;
                return;
            }
            mre = new org.antlr.runtime.MismatchedRangeException(a,b,this.input);
            this.recover(mre);
            throw mre;
        }
        this.input.consume();
        this.state.failed = false;
    },

    getLine: function() {
        return this.input.getLine();
    },

    getCharPositionInLine: function() {
        return this.input.getCharPositionInLine();
    },

    /** What is the index of the current character of lookahead? */
    getCharIndex: function() {
        return this.input.index();
    },

    /** Return the text matched so far for the current token or any
     *  text override.
     */
    getText: function() {
        if ( org.antlr.lang.isString(this.state.text) ) {
            return this.state.text;
        }
        return this.input.substring(this.state.tokenStartCharIndex,this.getCharIndex()-1);
    },

    /** Set the complete text of this token; it wipes any previous
     *  changes to the text.
     */
    setText: function(text) {
        this.state.text = text;
    },

    reportError: function(e) {
        /** TODO: not thought about recovery in lexer yet.
         *
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if ( errorRecovery ) {
            //System.err.print("[SPURIOUS] ");
            return;
        }
        errorRecovery = true;
         */

        this.displayRecognitionError(this.getTokenNames(), e);
    },

    getErrorMessage: function(e, tokenNames) {
        var msg = null;
        if ( e instanceof org.antlr.runtime.MismatchedTokenException ) {
            msg = "mismatched character "+this.getCharErrorDisplay(e.c)+" expecting "+this.getCharErrorDisplay(e.expecting);
        }
        else if ( e instanceof org.antlr.runtime.NoViableAltException ) {
            msg = "no viable alternative at character "+this.getCharErrorDisplay(e.c);
        }
        else if ( e instanceof org.antlr.runtime.EarlyExitException ) {
            msg = "required (...)+ loop did not match anything at character "+this.getCharErrorDisplay(e.c);
        }
        else if ( e instanceof org.antlr.runtime.MismatchedNotSetException ) {
            msg = "mismatched character "+this.getCharErrorDisplay(e.c)+" expecting set "+e.expecting;
        }
        else if ( e instanceof org.antlr.runtime.MismatchedSetException ) {
            msg = "mismatched character "+this.getCharErrorDisplay(e.c)+" expecting set "+e.expecting;
        }
        else if ( e instanceof org.antlr.runtime.MismatchedRangeException ) {
            msg = "mismatched character "+this.getCharErrorDisplay(e.c)+" expecting set "+
                this.getCharErrorDisplay(e.a)+".."+this.getCharErrorDisplay(e.b);
        }
        else {
            msg = org.antlr.runtime.Lexer.superclass.getErrorMessage.call(this, e, tokenNames);
        }
        return msg;
    },

    getCharErrorDisplay: function(c) {
        var s = c; //String.fromCharCode(c);
        switch ( s ) {
            case org.antlr.runtime.Token.EOF :
                s = "<EOF>";
                break;
            case "\n" :
                s = "\\n";
                break;
            case "\t" :
                s = "\\t";
                break;
            case "\r" :
                s = "\\r";
                break;
        }
        return "'"+s+"'";
    },

    /** Lexers can normally match any char in it's vocabulary after matching
     *  a token, so do the easy thing and just kill a character and hope
     *  it all works out.  You can instead use the rule invocation stack
     *  to do sophisticated error recovery if you are in a fragment rule.
     */
    recover: function(re) {
        this.input.consume();
    },

    traceIn: function(ruleName, ruleIndex)  {
        var inputSymbol = String.fromCharCode(this.input.LT(1))+" line="+this.getLine()+":"+this.getCharPositionInLine();
        org.antlr.runtime.Lexer.superclass.traceIn.call(this, ruleName, ruleIndex, inputSymbol);
    },

    traceOut: function(ruleName, ruleIndex)  {
		var inputSymbol = String.fromCharCode(this.input.LT(1))+" line="+this.getLine()+":"+this.getCharPositionInLine();
		org.antlr.runtime.Lexer.superclass.traceOut.call(this, ruleName, ruleIndex, inputSymbol);
	}
});
/** Rules that return more than a single value must return an object
 *  containing all the values.  Besides the properties defined in
 *  RuleLabelScope.predefinedRulePropertiesScope there may be user-defined
 *  return values.  This class simply defines the minimum properties that
 *  are always defined and methods to access the others that might be
 *  available depending on output option such as template and tree.
 *
 *  Note text is not an actual property of the return value, it is computed
 *  from start and stop using the input stream's toString() method.  I
 *  could add a ctor to this so that we can pass in and store the input
 *  stream, but I'm not sure we want to do that.  It would seem to be undefined
 *  to get the .text property anyway if the rule matches tokens from multiple
 *  input streams.
 *
 *  I do not use getters for fields of objects that are used simply to
 *  group values such as this aggregate.  The getters/setters are there to
 *  satisfy the superclass interface.
 */
org.antlr.runtime.ParserRuleReturnScope = function() {};

org.antlr.runtime.ParserRuleReturnScope.prototype = {
    getStart: function() { return this.start; },
    getStop: function() { return this.stop; }
};
/** This is identical to the ParserRuleReturnScope except that
 *  the start property is a tree nodes not Token object
 *  when you are parsing trees.  To be generic the tree node types
 *  have to be Object.
 */
org.antlr.runtime.tree.TreeRuleReturnScope = function(){};

org.antlr.runtime.tree.TreeRuleReturnScope.prototype = {
    getStart: function() { return this.start; }
};
/** A parser for TokenStreams.  "parser grammars" result in a subclass
 *  of this.
 */
org.antlr.runtime.Parser = function(input, state) {
    org.antlr.runtime.Parser.superclass.constructor.call(this, state);
    this.setTokenStream(input);
};

org.antlr.lang.extend(org.antlr.runtime.Parser, org.antlr.runtime.BaseRecognizer, {
    reset: function() {
        // reset all recognizer state variables
		org.antlr.runtime.Parser.superclass.reset.call(this);
		if ( org.antlr.lang.isValue(this.input) ) {
			this.input.seek(0); // rewind the input
		}
	},

    getCurrentInputSymbol: function(input) {
        return input.LT(1);
    },

    getMissingSymbol: function(input,
                               e,
                               expectedTokenType,
                               follow)
    {
        var tokenText =
            "<missing "+this.getTokenNames()[expectedTokenType]+">";
        var t = new org.antlr.runtime.CommonToken(expectedTokenType, tokenText);
        var current = input.LT(1);
        var old_current;
        if ( current.getType() === org.antlr.runtime.Token.EOF ) {
            old_current = current;
            current = input.LT(-1);
            // handle edge case where there are no good tokens in the stream
            if (!current) {
                current = old_current;
            }
        }
        t.line = current.getLine();
        t.charPositionInLine = current.getCharPositionInLine();
        t.channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
        return t;
    },


	/** Set the token stream and reset the parser */
    setTokenStream: function(input) {
		this.input = null;
		this.reset();
		this.input = input;
	},

    getTokenStream: function() {
		return this.input;
	},

    getSourceName: function() {
        return this.input.getSourceName();
    },

    traceIn: function(ruleName, ruleIndex)  {
		org.antlr.runtime.Parser.superclass.traceIn.call(
                this, ruleName, ruleIndex, this.input.LT(1));
	},

    traceOut: function(ruleName, ruleIndex)  {
		org.antlr.runtime.Parser.superclass.traceOut.call(
                this, ruleName, ruleIndex, this.input.LT(1));
	}
});
/** A DFA implemented as a set of transition tables.
 *
 *  Any state that has a semantic predicate edge is special; those states
 *  are generated with if-then-else structures in a specialStateTransition()
 *  which is generated by cyclicDFA template.
 *
 *  There are at most 32767 states (16-bit signed short).
 *  Could get away with byte sometimes but would have to generate different
 *  types and the simulation code too.  For a point of reference, the Java
 *  lexer's Tokens rule DFA has 326 states roughly.
 */
org.antlr.runtime.DFA = function() {};

org.antlr.runtime.DFA.prototype = {
    /** From the input stream, predict what alternative will succeed
     *  using this DFA (representing the covering regular approximation
     *  to the underlying CFL).  Return an alternative number 1..n.  Throw
     *  an exception upon error.
     */
    predict: function(input) {
        var mark = input.mark(), // remember where decision started in input
            s = 0, // we always start at s0
            specialState,
            c,
            snext;

        try {
            while ( true ) {
                specialState = this.special[s];
                if ( specialState>=0 ) {
                    s = this.specialStateTransition(specialState,input);
                    if (s===-1) {
                        this.noViableAlt(s, input);
                        return 0;
                    }
                    input.consume();
                    continue;
                }
                if ( this.accept[s] >= 1 ) {
                    return this.accept[s];
                }
                // look for a normal char transition
                c = input.LA(1); // -1 == \uFFFF, all tokens fit in 65000 space

                if (c===org.antlr.runtime.Token.EOF) {
                    c = -1;
                } else if (org.antlr.lang.isString(c)) {
                    c = c.charCodeAt(0);
                }

                if (c>=this.min[s] && c<=this.max[s]) {
                    snext = this.transition[s][c-this.min[s]]; // move to next state
                    if ( snext < 0 ) {
                        // was in range but not a normal transition
                        // must check EOT, which is like the else clause.
                        // eot[s]>=0 indicates that an EOT edge goes to another
                        // state.
                        if ( this.eot[s]>=0 ) {  // EOT Transition to accept state?
                            s = this.eot[s];
                            input.consume();
                            // TODO: I had this as return accept[eot[s]]
                            // which assumed here that the EOT edge always
                            // went to an accept...faster to do this, but
                            // what about predicated edges coming from EOT
                            // target?
                            continue;
                        }
                        this.noViableAlt(s,input);
                        return 0;
                    }
                    s = snext;
                    input.consume();
                    continue;
                }
                if ( this.eot[s]>=0 ) {  // EOT Transition?
                    s = this.eot[s];
                    input.consume();
                    continue;
                }
                if ( c==org.antlr.runtime.Token.EOF && this.eof[s]>=0 ) {  // EOF Transition to accept state?
                    return this.accept[this.eof[s]];
                }
                // not in range and not EOF/EOT, must be invalid symbol
                this.noViableAlt(s,input);
                return 0;
            }
        }
        finally {
            input.rewind(mark);
        }
    },

    noViableAlt: function(s, input) {
        if (this.recognizer.state.backtracking>0) {
            this.recognizer.state.failed=true;
            return;
        }
        var nvae =
            new org.antlr.runtime.NoViableAltException(this.getDescription(),
                                     this.decisionNumber,
                                     s,
                                     input);
        this.error(nvae);
        throw nvae;
    },

    /** A hook for debugging interface */
    error: function(nvae) { },

    specialStateTransition: function(s, input) {
        return -1;
    },

    getDescription: function() {
        return "n/a";
    }
};

org.antlr.lang.augmentObject(org.antlr.runtime.DFA, {
    /** Given a String that has a run-length-encoding of some unsigned shorts
     *  like "\1\2\3\9", convert to short[] {2,9,9,9}.
     */
    unpackEncodedString: function(encodedString) {
        // walk first to find how big it is.
        var i,
            data = [],
            di = 0,
            n,
            v,
            j;
        for (i=0; i<encodedString.length; i+=2) {
            n = encodedString.charCodeAt(i);
            v = encodedString.charCodeAt(i+1);
            if (v===0xffff) {
                v = -1; // overflow at 16 bits
            }
            // add v n times to data
            for (j=1; j<=n; j++) {
                data[di++] = v;
            }
        }
        return data;
    },

    // alias
    unpackEncodedStringToUnsignedChars: function(encodedString) {
        return org.antlr.runtime.DFA.unpackEncodedString(encodedString);
    }
});
/** A parser for a stream of tree nodes.  "tree grammars" result in a subclass
 *  of this.  All the error reporting and recovery is shared with Parser via
 *  the BaseRecognizer superclass.
*/
org.antlr.runtime.tree.TreeParser = function(input) {
    org.antlr.runtime.tree.TreeParser.superclass.constructor.call(this, arguments[1]);
    this.setTreeNodeStream(input);
};

(function(){
var TP = org.antlr.runtime.tree.TreeParser;

org.antlr.lang.augmentObject(TP, {
    DOWN: org.antlr.runtime.Token.DOWN,
    UP: org.antlr.runtime.Token.UP
});

org.antlr.lang.extend(TP, org.antlr.runtime.BaseRecognizer, {
    reset: function() {
        TP.superclass.reset.call(this); // reset all recognizer state variables
        if ( this.input ) {
            this.input.seek(0); // rewind the input
        }
    },

    /** Set the input stream */
    setTreeNodeStream: function(input) {
        this.input = input;
    },

    getTreeNodeStream: function() {
        return this.input;
    },

    getSourceName: function() {
        return this.input.getSourceName();
    },

    getCurrentInputSymbol: function(input) {
        return input.LT(1);
    },

    getMissingSymbol: function(input, e, expectedTokenType, follow) {
        var tokenText =
            "<missing "+this.getTokenNames()[expectedTokenType]+">";
        return new org.antlr.runtime.tree.CommonTree(new org.antlr.runtime.CommonToken(expectedTokenType, tokenText));
    },

    /** Match '.' in tree parser has special meaning.  Skip node or
     *  entire tree if node has children.  If children, scan until
     *  corresponding UP node.
     */
    matchAny: function(ignore) { // ignore stream, copy of this.input
        this.state.errorRecovery = false;
        this.state.failed = false;
        var look = this.input.LT(1);
        if ( this.input.getTreeAdaptor().getChildCount(look)===0 ) {
            this.input.consume(); // not subtree, consume 1 node and return
            return;
        }
        // current node is a subtree, skip to corresponding UP.
        // must count nesting level to get right UP
        var level=0,
            tokenType = this.input.getTreeAdaptor().getType(look);
        while ( tokenType!==org.antlr.runtime.Token.EOF &&
                !(tokenType===TP.UP && level===0) )
        {
            this.input.consume();
            look = this.input.LT(1);
            tokenType = this.input.getTreeAdaptor().getType(look);
            if ( tokenType === TP.DOWN ) {
                level++;
            }
            else if ( tokenType === TP.UP ) {
                level--;
            }
        }
        this.input.consume(); // consume UP
    },

    /** We have DOWN/UP nodes in the stream that have no line info; override.
     *  plus we want to alter the exception type.  Don't try to recover
     *       *  from tree parser errors inline...
     */
    mismatch: function(input, ttype, follow) {
        throw new org.antlr.runtime.MismatchedTreeNodeException(ttype, input);
    },

    /** Prefix error message with the grammar name because message is
     *  always intended for the programmer because the parser built
     *  the input tree not the user.
     */
    getErrorHeader: function(e) {
        return this.getGrammarFileName()+": node from "+
               (e.approximateLineInfo?"after ":"")+"line "+e.line+":"+e.charPositionInLine;
    },

    /** Tree parsers parse nodes they usually have a token object as
     *  payload. Set the exception token and do the default behavior.
     */
    getErrorMessage: function(e, tokenNames) {
        var adaptor;
        if ( this instanceof TP ) {
            adaptor = e.input.getTreeAdaptor();
            e.token = adaptor.getToken(e.node);
            if ( !org.antlr.lang.isValue(e.token) ) { // could be an UP/DOWN node
                e.token = new org.antlr.runtime.CommonToken(
                        adaptor.getType(e.node),
                        adaptor.getText(e.node));
            }
        }
        return TP.superclass.getErrorMessage.call(this, e, tokenNames);
    },

    traceIn: function(ruleName, ruleIndex) {
        TP.superclass.traceIn.call(this, ruleName, ruleIndex, this.input.LT(1));
    },

    traceOut: function(ruleName, ruleIndex) {
        TP.superclass.traceOut.call(this, ruleName, ruleIndex, this.input.LT(1));
    }
});

})();
// $ANTLR 3.3 Nov 30, 2010 12:46:29 /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g 2024-06-04 12:32:07


var MentionQAst = function(input, state) {
    if (!state) {
        state = new org.antlr.runtime.RecognizerSharedState();
    }

    (function(){

        this.emitErrorMessage = function(msg) { throw msg; }

    }).call(this);

    MentionQAst.superclass.constructor.call(this, input, state);




    /* @todo only create adaptor if output=AST */
    this.adaptor = new org.antlr.runtime.tree.CommonTreeAdaptor();

};

org.antlr.lang.augmentObject(MentionQAst, {
    EOF: -1,
    NEWLINE: 4,
    WHITESPACE: 5,
    O: 6,
    R: 7,
    OR: 8,
    A: 9,
    N: 10,
    D: 11,
    AND: 12,
    E: 13,
    L: 14,
    V: 15,
    C: 16,
    Y: 17,
    RELEVANCY: 18,
    B: 19,
    BRAND: 20,
    S: 21,
    T: 22,
    I: 23,
    M: 24,
    SENTIMENT: 25,
    CREDIBILITY: 26,
    MEDIA: 27,
    ACTION: 28,
    P: 29,
    PROCESS: 30,
    H: 31,
    PHRASE: 32,
    U: 33,
    PHRASE_COUNT: 34,
    F: 35,
    FEED: 36,
    TITLE: 37,
    K: 38,
    LINK: 39,
    SITE: 40,
    AUTHOR_NAME: 41,
    AUTHOR_LOCATION: 42,
    CONTENT: 43,
    G: 44,
    LANGUAGE: 45,
    PICKED_UP: 46,
    UPDATED: 47,
    LINKED: 48,
    PHRASE_MATCHES: 49,
    PAGE_RANK: 50,
    X: 51,
    ALEXA_RANK: 52,
    PUBLISHED: 53,
    PUBLISHEDTIME: 54,
    TAG: 55,
    TOPIC: 56,
    SEGMENT: 57,
    COUNTRY: 58,
    REGION: 59,
    CITY: 60,
    RELEVANCY_VERIFIED: 61,
    ASSIGNEE: 62,
    AUTHOR: 63,
    AUTHOR_ID: 64,
    EXTRACT: 65,
    SENTIMENT_VERIFIED: 66,
    W: 67,
    CROWD_VERIFIED: 68,
    DISCARDED_BY: 69,
    MENTION_ID: 70,
    CROWD_ID: 71,
    URI: 72,
    ENGAGEMENT: 73,
    REPLY_TO: 74,
    REPLY_COUNT: 75,
    GRAPH_REPLY_COUNT: 76,
    RESHARE_OF: 77,
    RESHARE_COUNT: 78,
    GRAPH_RESHARE_COUNT: 79,
    REPLY_ORDER_BY_AUTHOR: 80,
    OTS: 81,
    AVE: 82,
    REACH: 83,
    STATUS_COUNT: 84,
    FOLLOWER_COUNT: 85,
    GRAPH_FOLLOWER_COUNT: 86,
    FOLLOWING_COUNT: 87,
    CROWD_REGION: 88,
    GENDER: 89,
    RESPONSE_TIME: 90,
    UNBIASED_SAMPLE: 91,
    MENTIONED_PROFILE: 92,
    RACE: 93,
    DIRECT_MESSAGE: 94,
    VISIBILITY: 95,
    TICKET_ID: 96,
    SOCIAL_NETWORK: 97,
    AUTHOR_HANDLE: 98,
    AUTHOR_HANDLE_ID: 99,
    TO_NAME: 100,
    TO_HANDLE: 101,
    TO_HANDLE_ID: 102,
    AUTHOR_BIO: 103,
    CONVERSATION_ID: 104,
    TOMBSTONED: 105,
    SCRUBBED: 106,
    HAS_REPLY_FROM_PROFILE: 107,
    INTERACTION_ID: 108,
    INTERACTION_RESPONSE_TIME: 109,
    INTERACTION_FIRST_RESPONSE_TIME: 110,
    INTERACTION_FOLLOWUP_RESPONSE_TIME: 111,
    INTERACTION_WH_RESPONSE_TIME: 112,
    INTERACTION_WH_FIRST_RESPONSE_TIME: 113,
    INTERACTION_WH_FOLLOWUP_RESPONSE_TIME: 114,
    INTERACTION_HAS_RESPONSE: 115,
    INTERACTION_FIRST_MENTION_PUBLISHED: 116,
    INTERACTION_LAST_MENTION_PUBLISHED: 117,
    INTERACTION_FIRST_RESPONSE_PUBLISHED: 118,
    UCN: 119,
    TWITTER_SCREEN_NAME: 120,
    HANDLE_ID: 121,
    FACEBOOK_ID: 122,
    IS: 123,
    ISNT: 124,
    ISORCHILDOF: 125,
    BEFORE: 126,
    AFTER: 127,
    GREATERTHAN: 128,
    GREATERTHANEQUALS: 129,
    LESSTHAN: 130,
    LESSTHANEQUALS: 131,
    EQUALS: 132,
    NOTEQUALS: 133,
    CONTAINS: 134,
    DOESNTCONTAIN: 135,
    BEGINSWITH: 136,
    ENDSWITH: 137,
    MATCHES: 138,
    ISNTNORCHILDOF: 139,
    INTHELAST: 140,
    BEFORETHELAST: 141,
    ON: 142,
    IN: 143,
    NOTIN: 144,
    DISTINCT: 145,
    SAMPLE: 146,
    PRESS: 147,
    ENTERPRISE: 148,
    CONSUMER: 149,
    DIRECTORY: 150,
    UNSORTED: 151,
    RELEVANT: 152,
    DUPLICATE: 153,
    IRRELEVANT: 154,
    SPAM: 155,
    SORTED: 156,
    VERIFIED: 157,
    NONE: 158,
    RESOLVED: 159,
    UNRESOLVED: 160,
    TODAY: 161,
    HOUR: 162,
    DAY: 163,
    TWENTY_FOUR_HRS: 164,
    WEEK: 165,
    FORTNIGHT: 166,
    MONTH: 167,
    Q: 168,
    QUARTER: 169,
    YEAR: 170,
    EPOCH: 171,
    FALSE: 172,
    TRUE: 173,
    MALE: 174,
    FEMALE: 175,
    OTHER: 176,
    UNKNOWN: 177,
    LONG_LITERAL: 178,
    TAG_ID_LITERAL: 179,
    FLOAT_LITERAL: 180,
    DATE_SEPARATOR: 181,
    DIGIT: 182,
    UNQUOTED_DATE: 183,
    DATE_LITERAL: 184,
    STRING_LITERAL: 185,
    ANNOTATION: 186,
    LPAREN: 187,
    RPAREN: 188,
    COMMA: 189,
    DIVIDE: 190,
    LSQUARE: 191,
    RSQUARE: 192,
    ASC: 193,
    DESC: 194,
    COUNT: 195,
    UNQUOTED_STRING_LITERAL: 196,
    J: 197,
    Z: 198,
    ORDER: 199,
    GROUP: 200,
    SELECTION: 201,
    ATTRIBUTE: 202,
    OR_NODE: 203,
    AND_NODE: 204,
    TWITTER_AUTHOR: 205,
    FACTOR: 206,
    SAMPLE_FACTOR: 207,
    SET_LONG_FACTOR: 208,
    SET_MENTION_ID_FACTOR: 209,
    SUB_FILTER_FACTOR: 210
});

(function(){
// public class variables
    var EOF= -1,
        NEWLINE= 4,
        WHITESPACE= 5,
        O= 6,
        R= 7,
        OR= 8,
        A= 9,
        N= 10,
        D= 11,
        AND= 12,
        E= 13,
        L= 14,
        V= 15,
        C= 16,
        Y= 17,
        RELEVANCY= 18,
        B= 19,
        BRAND= 20,
        S= 21,
        T= 22,
        I= 23,
        M= 24,
        SENTIMENT= 25,
        CREDIBILITY= 26,
        MEDIA= 27,
        ACTION= 28,
        P= 29,
        PROCESS= 30,
        H= 31,
        PHRASE= 32,
        U= 33,
        PHRASE_COUNT= 34,
        F= 35,
        FEED= 36,
        TITLE= 37,
        K= 38,
        LINK= 39,
        SITE= 40,
        AUTHOR_NAME= 41,
        AUTHOR_LOCATION= 42,
        CONTENT= 43,
        G= 44,
        LANGUAGE= 45,
        PICKED_UP= 46,
        UPDATED= 47,
        LINKED= 48,
        PHRASE_MATCHES= 49,
        PAGE_RANK= 50,
        X= 51,
        ALEXA_RANK= 52,
        PUBLISHED= 53,
        PUBLISHEDTIME= 54,
        TAG= 55,
        TOPIC= 56,
        SEGMENT= 57,
        COUNTRY= 58,
        REGION= 59,
        CITY= 60,
        RELEVANCY_VERIFIED= 61,
        ASSIGNEE= 62,
        AUTHOR= 63,
        AUTHOR_ID= 64,
        EXTRACT= 65,
        SENTIMENT_VERIFIED= 66,
        W= 67,
        CROWD_VERIFIED= 68,
        DISCARDED_BY= 69,
        MENTION_ID= 70,
        CROWD_ID= 71,
        URI= 72,
        ENGAGEMENT= 73,
        REPLY_TO= 74,
        REPLY_COUNT= 75,
        GRAPH_REPLY_COUNT= 76,
        RESHARE_OF= 77,
        RESHARE_COUNT= 78,
        GRAPH_RESHARE_COUNT= 79,
        REPLY_ORDER_BY_AUTHOR= 80,
        OTS= 81,
        AVE= 82,
        REACH= 83,
        STATUS_COUNT= 84,
        FOLLOWER_COUNT= 85,
        GRAPH_FOLLOWER_COUNT= 86,
        FOLLOWING_COUNT= 87,
        CROWD_REGION= 88,
        GENDER= 89,
        RESPONSE_TIME= 90,
        UNBIASED_SAMPLE= 91,
        MENTIONED_PROFILE= 92,
        RACE= 93,
        DIRECT_MESSAGE= 94,
        VISIBILITY= 95,
        TICKET_ID= 96,
        SOCIAL_NETWORK= 97,
        AUTHOR_HANDLE= 98,
        AUTHOR_HANDLE_ID= 99,
        TO_NAME= 100,
        TO_HANDLE= 101,
        TO_HANDLE_ID= 102,
        AUTHOR_BIO= 103,
        CONVERSATION_ID= 104,
        TOMBSTONED= 105,
        SCRUBBED= 106,
        HAS_REPLY_FROM_PROFILE= 107,
        INTERACTION_ID= 108,
        INTERACTION_RESPONSE_TIME= 109,
        INTERACTION_FIRST_RESPONSE_TIME= 110,
        INTERACTION_FOLLOWUP_RESPONSE_TIME= 111,
        INTERACTION_WH_RESPONSE_TIME= 112,
        INTERACTION_WH_FIRST_RESPONSE_TIME= 113,
        INTERACTION_WH_FOLLOWUP_RESPONSE_TIME= 114,
        INTERACTION_HAS_RESPONSE= 115,
        INTERACTION_FIRST_MENTION_PUBLISHED= 116,
        INTERACTION_LAST_MENTION_PUBLISHED= 117,
        INTERACTION_FIRST_RESPONSE_PUBLISHED= 118,
        UCN= 119,
        TWITTER_SCREEN_NAME= 120,
        HANDLE_ID= 121,
        FACEBOOK_ID= 122,
        IS= 123,
        ISNT= 124,
        ISORCHILDOF= 125,
        BEFORE= 126,
        AFTER= 127,
        GREATERTHAN= 128,
        GREATERTHANEQUALS= 129,
        LESSTHAN= 130,
        LESSTHANEQUALS= 131,
        EQUALS= 132,
        NOTEQUALS= 133,
        CONTAINS= 134,
        DOESNTCONTAIN= 135,
        BEGINSWITH= 136,
        ENDSWITH= 137,
        MATCHES= 138,
        ISNTNORCHILDOF= 139,
        INTHELAST= 140,
        BEFORETHELAST= 141,
        ON= 142,
        IN= 143,
        NOTIN= 144,
        DISTINCT= 145,
        SAMPLE= 146,
        PRESS= 147,
        ENTERPRISE= 148,
        CONSUMER= 149,
        DIRECTORY= 150,
        UNSORTED= 151,
        RELEVANT= 152,
        DUPLICATE= 153,
        IRRELEVANT= 154,
        SPAM= 155,
        SORTED= 156,
        VERIFIED= 157,
        NONE= 158,
        RESOLVED= 159,
        UNRESOLVED= 160,
        TODAY= 161,
        HOUR= 162,
        DAY= 163,
        TWENTY_FOUR_HRS= 164,
        WEEK= 165,
        FORTNIGHT= 166,
        MONTH= 167,
        Q= 168,
        QUARTER= 169,
        YEAR= 170,
        EPOCH= 171,
        FALSE= 172,
        TRUE= 173,
        MALE= 174,
        FEMALE= 175,
        OTHER= 176,
        UNKNOWN= 177,
        LONG_LITERAL= 178,
        TAG_ID_LITERAL= 179,
        FLOAT_LITERAL= 180,
        DATE_SEPARATOR= 181,
        DIGIT= 182,
        UNQUOTED_DATE= 183,
        DATE_LITERAL= 184,
        STRING_LITERAL= 185,
        ANNOTATION= 186,
        LPAREN= 187,
        RPAREN= 188,
        COMMA= 189,
        DIVIDE= 190,
        LSQUARE= 191,
        RSQUARE= 192,
        ASC= 193,
        DESC= 194,
        COUNT= 195,
        UNQUOTED_STRING_LITERAL= 196,
        J= 197,
        Z= 198,
        ORDER= 199,
        GROUP= 200,
        SELECTION= 201,
        ATTRIBUTE= 202,
        OR_NODE= 203,
        AND_NODE= 204,
        TWITTER_AUTHOR= 205,
        FACTOR= 206,
        SAMPLE_FACTOR= 207,
        SET_LONG_FACTOR= 208,
        SET_MENTION_ID_FACTOR= 209,
        SUB_FILTER_FACTOR= 210;

// public instance methods/vars
    org.antlr.lang.extend(MentionQAst, org.antlr.runtime.Parser, {

        setTreeAdaptor: function(adaptor) {
            this.adaptor = adaptor;
        },
        getTreeAdaptor: function() {
            return this.adaptor;
        },

        getTokenNames: function() { return MentionQAst.tokenNames; },
        getGrammarFileName: function() { return "/Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g"; }
    });
    org.antlr.lang.augmentObject(MentionQAst.prototype, {

        // inline static return class
        filter_return: (function() {
            MentionQAst.filter_return = function(){};
            org.antlr.lang.extend(MentionQAst.filter_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:32:1: filter : expression EOF ;
        // $ANTLR start "filter"
        filter: function() {
            var retval = new MentionQAst.filter_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var EOF2 = null;
            var expression1 = null;

            var EOF2_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:33:5: ( expression EOF )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:33:9: expression EOF
                root_0 = this.adaptor.nil();

                this.pushFollow(MentionQAst.FOLLOW_expression_in_filter159);
                expression1=this.expression();

                this.state._fsp--;

                this.adaptor.addChild(root_0, expression1.getTree());
                EOF2=this.match(this.input,EOF,MentionQAst.FOLLOW_EOF_in_filter161);



                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        expression_return: (function() {
            MentionQAst.expression_return = function(){};
            org.antlr.lang.extend(MentionQAst.expression_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:36:1: expression : first= term ( OR second= expression )? -> ^( OR_NODE $first ( $second)? ) ;
        // $ANTLR start "expression"
        expression: function() {
            var retval = new MentionQAst.expression_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var OR3 = null;
            var first = null;
            var second = null;

            var OR3_tree=null;
            var stream_OR=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token OR");
            var stream_expression=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule expression");
            var stream_term=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule term");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:37:5: (first= term ( OR second= expression )? -> ^( OR_NODE $first ( $second)? ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:37:9: first= term ( OR second= expression )?
                this.pushFollow(MentionQAst.FOLLOW_term_in_expression183);
                first=this.term();

                this.state._fsp--;

                stream_term.add(first.getTree());
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:37:20: ( OR second= expression )?
                var alt1=2;
                var LA1_0 = this.input.LA(1);

                if ( (LA1_0==OR) ) {
                    alt1=1;
                }
                switch (alt1) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:37:22: OR second= expression
                        OR3=this.match(this.input,OR,MentionQAst.FOLLOW_OR_in_expression187);
                        stream_OR.add(OR3);

                        this.pushFollow(MentionQAst.FOLLOW_expression_in_expression191);
                        second=this.expression();

                        this.state._fsp--;

                        stream_expression.add(second.getTree());


                        break;

                }



                // AST REWRITE
                // elements: first, second
                // token labels:
                // rule labels: retval, second, first
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);
                var stream_second=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token second",second!=null?second.tree:null);
                var stream_first=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token first",first!=null?first.tree:null);

                root_0 = this.adaptor.nil();
                // 37:60: -> ^( OR_NODE $first ( $second)? )
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:37:63: ^( OR_NODE $first ( $second)? )
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(OR_NODE, "OR_NODE"), root_1);

                        this.adaptor.addChild(root_1, stream_first.nextTree());
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:37:80: ( $second)?
                        if ( stream_second.hasNext() ) {
                            this.adaptor.addChild(root_1, stream_second.nextTree());

                        }
                        stream_second.reset();

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        term_return: (function() {
            MentionQAst.term_return = function(){};
            org.antlr.lang.extend(MentionQAst.term_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:40:1: term : first= factor ( AND second= term )? -> ^( AND_NODE $first ( $second)? ) ;
        // $ANTLR start "term"
        term: function() {
            var retval = new MentionQAst.term_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var AND4 = null;
            var first = null;
            var second = null;

            var AND4_tree=null;
            var stream_AND=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AND");
            var stream_term=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule term");
            var stream_factor=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule factor");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:41:5: (first= factor ( AND second= term )? -> ^( AND_NODE $first ( $second)? ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:41:9: first= factor ( AND second= term )?
                this.pushFollow(MentionQAst.FOLLOW_factor_in_term242);
                first=this.factor();

                this.state._fsp--;

                stream_factor.add(first.getTree());
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:41:22: ( AND second= term )?
                var alt2=2;
                var LA2_0 = this.input.LA(1);

                if ( (LA2_0==AND) ) {
                    alt2=1;
                }
                switch (alt2) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:41:24: AND second= term
                        AND4=this.match(this.input,AND,MentionQAst.FOLLOW_AND_in_term246);
                        stream_AND.add(AND4);

                        this.pushFollow(MentionQAst.FOLLOW_term_in_term250);
                        second=this.term();

                        this.state._fsp--;

                        stream_term.add(second.getTree());


                        break;

                }



                // AST REWRITE
                // elements: second, first
                // token labels:
                // rule labels: retval, second, first
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);
                var stream_second=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token second",second!=null?second.tree:null);
                var stream_first=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token first",first!=null?first.tree:null);

                root_0 = this.adaptor.nil();
                // 41:60: -> ^( AND_NODE $first ( $second)? )
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:41:63: ^( AND_NODE $first ( $second)? )
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(AND_NODE, "AND_NODE"), root_1);

                        this.adaptor.addChild(root_1, stream_first.nextTree());
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:41:81: ( $second)?
                        if ( stream_second.hasNext() ) {
                            this.adaptor.addChild(root_1, stream_second.nextTree());

                        }
                        stream_second.reset();

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        factor_return: (function() {
            MentionQAst.factor_return = function(){};
            org.antlr.lang.extend(MentionQAst.factor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:44:1: factor : ( generalFactor | generalStringFactor | feedFactor | generalUnknownStringFactor | generalIsIsntStringFactor | cityIsIsntFactor | generalIsIsntLongFactor | sampleFactor | generalInLongFactor | generalInOnlyLongFactor | mentionIdFactor | interactionIdFactor | authorIdFactor | generalTreeLongFactor | generalComparisonLongFactor | replyingToFactor | reshareOfFactor | tagFactor | mediaFactor | genderFactor | raceFactor | relevancyFactor | processFactor | actionFactor | dateFactor | dateUnknownFactor | timeFactor | matchesFactor | booleanFactor | engagedProfileIsIsntLongFactor | socialNetworkFactor | visibilityFactor );
        // $ANTLR start "factor"
        factor: function() {
            var retval = new MentionQAst.factor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var generalFactor5 = null;
            var generalStringFactor6 = null;
            var feedFactor7 = null;
            var generalUnknownStringFactor8 = null;
            var generalIsIsntStringFactor9 = null;
            var cityIsIsntFactor10 = null;
            var generalIsIsntLongFactor11 = null;
            var sampleFactor12 = null;
            var generalInLongFactor13 = null;
            var generalInOnlyLongFactor14 = null;
            var mentionIdFactor15 = null;
            var interactionIdFactor16 = null;
            var authorIdFactor17 = null;
            var generalTreeLongFactor18 = null;
            var generalComparisonLongFactor19 = null;
            var replyingToFactor20 = null;
            var reshareOfFactor21 = null;
            var tagFactor22 = null;
            var mediaFactor23 = null;
            var genderFactor24 = null;
            var raceFactor25 = null;
            var relevancyFactor26 = null;
            var processFactor27 = null;
            var actionFactor28 = null;
            var dateFactor29 = null;
            var dateUnknownFactor30 = null;
            var timeFactor31 = null;
            var matchesFactor32 = null;
            var booleanFactor33 = null;
            var engagedProfileIsIsntLongFactor34 = null;
            var socialNetworkFactor35 = null;
            var visibilityFactor36 = null;


            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:45:5: ( generalFactor | generalStringFactor | feedFactor | generalUnknownStringFactor | generalIsIsntStringFactor | cityIsIsntFactor | generalIsIsntLongFactor | sampleFactor | generalInLongFactor | generalInOnlyLongFactor | mentionIdFactor | interactionIdFactor | authorIdFactor | generalTreeLongFactor | generalComparisonLongFactor | replyingToFactor | reshareOfFactor | tagFactor | mediaFactor | genderFactor | raceFactor | relevancyFactor | processFactor | actionFactor | dateFactor | dateUnknownFactor | timeFactor | matchesFactor | booleanFactor | engagedProfileIsIsntLongFactor | socialNetworkFactor | visibilityFactor )
                var alt3=32;
                switch ( this.input.LA(1) ) {
                    case LPAREN:
                        alt3=1;
                        break;
                    case TITLE:
                    case LINK:
                    case SITE:
                    case AUTHOR_LOCATION:
                    case EXTRACT:
                    case URI:
                        alt3=2;
                        break;
                    case FEED:
                        alt3=3;
                        break;
                    case AUTHOR_NAME:
                    case AUTHOR:
                    case TICKET_ID:
                    case AUTHOR_HANDLE:
                    case AUTHOR_HANDLE_ID:
                    case TO_NAME:
                    case TO_HANDLE:
                    case TO_HANDLE_ID:
                    case UCN:
                        alt3=4;
                        break;
                    case LANGUAGE:
                    case COUNTRY:
                        alt3=5;
                        break;
                    case CITY:
                        alt3=6;
                        break;
                    case PHRASE:
                    case ASSIGNEE:
                    case DISCARDED_BY:
                        alt3=7;
                        break;
                    case SAMPLE:
                        alt3=8;
                        break;
                    case CROWD_ID:
                        alt3=9;
                        break;
                    case HAS_REPLY_FROM_PROFILE:
                        alt3=10;
                        break;
                    case MENTION_ID:
                    case CONVERSATION_ID:
                        alt3=11;
                        break;
                    case INTERACTION_ID:
                        alt3=12;
                        break;
                    case AUTHOR_ID:
                        alt3=13;
                        break;
                    case BRAND:
                        alt3=14;
                        break;
                    case SENTIMENT:
                    case CREDIBILITY:
                    case PHRASE_COUNT:
                    case PHRASE_MATCHES:
                    case PAGE_RANK:
                    case ALEXA_RANK:
                    case ENGAGEMENT:
                    case REPLY_COUNT:
                    case GRAPH_REPLY_COUNT:
                    case RESHARE_COUNT:
                    case GRAPH_RESHARE_COUNT:
                    case REPLY_ORDER_BY_AUTHOR:
                    case OTS:
                    case AVE:
                    case REACH:
                    case STATUS_COUNT:
                    case FOLLOWER_COUNT:
                    case GRAPH_FOLLOWER_COUNT:
                    case FOLLOWING_COUNT:
                    case RESPONSE_TIME:
                    case INTERACTION_RESPONSE_TIME:
                    case INTERACTION_FIRST_RESPONSE_TIME:
                    case INTERACTION_FOLLOWUP_RESPONSE_TIME:
                    case INTERACTION_WH_RESPONSE_TIME:
                    case INTERACTION_WH_FIRST_RESPONSE_TIME:
                    case INTERACTION_WH_FOLLOWUP_RESPONSE_TIME:
                        alt3=15;
                        break;
                    case REPLY_TO:
                        alt3=16;
                        break;
                    case RESHARE_OF:
                        alt3=17;
                        break;
                    case TAG:
                    case TOPIC:
                    case SEGMENT:
                        alt3=18;
                        break;
                    case MEDIA:
                        alt3=19;
                        break;
                    case GENDER:
                        alt3=20;
                        break;
                    case RACE:
                        alt3=21;
                        break;
                    case RELEVANCY:
                        alt3=22;
                        break;
                    case PROCESS:
                        alt3=23;
                        break;
                    case ACTION:
                        alt3=24;
                        break;
                    case PICKED_UP:
                    case UPDATED:
                    case PUBLISHED:
                        alt3=25;
                        break;
                    case TOMBSTONED:
                    case SCRUBBED:
                    case INTERACTION_FIRST_MENTION_PUBLISHED:
                    case INTERACTION_LAST_MENTION_PUBLISHED:
                    case INTERACTION_FIRST_RESPONSE_PUBLISHED:
                        alt3=26;
                        break;
                    case PUBLISHEDTIME:
                        alt3=27;
                        break;
                    case CONTENT:
                    case AUTHOR_BIO:
                        alt3=28;
                        break;
                    case LINKED:
                    case RELEVANCY_VERIFIED:
                    case SENTIMENT_VERIFIED:
                    case CROWD_VERIFIED:
                    case UNBIASED_SAMPLE:
                    case DIRECT_MESSAGE:
                    case INTERACTION_HAS_RESPONSE:
                        alt3=29;
                        break;
                    case MENTIONED_PROFILE:
                        alt3=30;
                        break;
                    case SOCIAL_NETWORK:
                        alt3=31;
                        break;
                    case VISIBILITY:
                        alt3=32;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 3, 0, this.input);

                        throw nvae;
                }

                switch (alt3) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:45:9: generalFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalFactor_in_factor302);
                        generalFactor5=this.generalFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalFactor5.getTree());


                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:46:9: generalStringFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalStringFactor_in_factor312);
                        generalStringFactor6=this.generalStringFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalStringFactor6.getTree());


                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:47:9: feedFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_feedFactor_in_factor322);
                        feedFactor7=this.feedFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, feedFactor7.getTree());


                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:48:9: generalUnknownStringFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalUnknownStringFactor_in_factor332);
                        generalUnknownStringFactor8=this.generalUnknownStringFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalUnknownStringFactor8.getTree());


                        break;
                    case 5 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:49:9: generalIsIsntStringFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalIsIsntStringFactor_in_factor342);
                        generalIsIsntStringFactor9=this.generalIsIsntStringFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalIsIsntStringFactor9.getTree());


                        break;
                    case 6 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:50:9: cityIsIsntFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_cityIsIsntFactor_in_factor352);
                        cityIsIsntFactor10=this.cityIsIsntFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, cityIsIsntFactor10.getTree());


                        break;
                    case 7 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:51:9: generalIsIsntLongFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalIsIsntLongFactor_in_factor362);
                        generalIsIsntLongFactor11=this.generalIsIsntLongFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalIsIsntLongFactor11.getTree());


                        break;
                    case 8 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:52:9: sampleFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_sampleFactor_in_factor372);
                        sampleFactor12=this.sampleFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, sampleFactor12.getTree());


                        break;
                    case 9 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:53:9: generalInLongFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalInLongFactor_in_factor382);
                        generalInLongFactor13=this.generalInLongFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalInLongFactor13.getTree());


                        break;
                    case 10 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:54:9: generalInOnlyLongFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalInOnlyLongFactor_in_factor392);
                        generalInOnlyLongFactor14=this.generalInOnlyLongFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalInOnlyLongFactor14.getTree());


                        break;
                    case 11 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:55:9: mentionIdFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_mentionIdFactor_in_factor402);
                        mentionIdFactor15=this.mentionIdFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, mentionIdFactor15.getTree());


                        break;
                    case 12 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:56:9: interactionIdFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_interactionIdFactor_in_factor412);
                        interactionIdFactor16=this.interactionIdFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, interactionIdFactor16.getTree());


                        break;
                    case 13 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:57:9: authorIdFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_authorIdFactor_in_factor422);
                        authorIdFactor17=this.authorIdFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, authorIdFactor17.getTree());


                        break;
                    case 14 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:58:9: generalTreeLongFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalTreeLongFactor_in_factor432);
                        generalTreeLongFactor18=this.generalTreeLongFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalTreeLongFactor18.getTree());


                        break;
                    case 15 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:59:9: generalComparisonLongFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalComparisonLongFactor_in_factor442);
                        generalComparisonLongFactor19=this.generalComparisonLongFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalComparisonLongFactor19.getTree());


                        break;
                    case 16 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:60:9: replyingToFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_replyingToFactor_in_factor452);
                        replyingToFactor20=this.replyingToFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, replyingToFactor20.getTree());


                        break;
                    case 17 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:61:9: reshareOfFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_reshareOfFactor_in_factor462);
                        reshareOfFactor21=this.reshareOfFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, reshareOfFactor21.getTree());


                        break;
                    case 18 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:62:9: tagFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_tagFactor_in_factor472);
                        tagFactor22=this.tagFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, tagFactor22.getTree());


                        break;
                    case 19 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:63:9: mediaFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_mediaFactor_in_factor482);
                        mediaFactor23=this.mediaFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, mediaFactor23.getTree());


                        break;
                    case 20 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:64:9: genderFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_genderFactor_in_factor492);
                        genderFactor24=this.genderFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, genderFactor24.getTree());


                        break;
                    case 21 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:65:9: raceFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_raceFactor_in_factor502);
                        raceFactor25=this.raceFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, raceFactor25.getTree());


                        break;
                    case 22 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:66:9: relevancyFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_relevancyFactor_in_factor512);
                        relevancyFactor26=this.relevancyFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, relevancyFactor26.getTree());


                        break;
                    case 23 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:67:9: processFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_processFactor_in_factor522);
                        processFactor27=this.processFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, processFactor27.getTree());


                        break;
                    case 24 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:68:9: actionFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_actionFactor_in_factor532);
                        actionFactor28=this.actionFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, actionFactor28.getTree());


                        break;
                    case 25 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:69:9: dateFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_dateFactor_in_factor542);
                        dateFactor29=this.dateFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, dateFactor29.getTree());


                        break;
                    case 26 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:70:9: dateUnknownFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_dateUnknownFactor_in_factor552);
                        dateUnknownFactor30=this.dateUnknownFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, dateUnknownFactor30.getTree());


                        break;
                    case 27 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:71:9: timeFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_timeFactor_in_factor562);
                        timeFactor31=this.timeFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, timeFactor31.getTree());


                        break;
                    case 28 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:72:9: matchesFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_matchesFactor_in_factor572);
                        matchesFactor32=this.matchesFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, matchesFactor32.getTree());


                        break;
                    case 29 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:73:9: booleanFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_booleanFactor_in_factor582);
                        booleanFactor33=this.booleanFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, booleanFactor33.getTree());


                        break;
                    case 30 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:74:9: engagedProfileIsIsntLongFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_engagedProfileIsIsntLongFactor_in_factor592);
                        engagedProfileIsIsntLongFactor34=this.engagedProfileIsIsntLongFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, engagedProfileIsIsntLongFactor34.getTree());


                        break;
                    case 31 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:75:9: socialNetworkFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_socialNetworkFactor_in_factor602);
                        socialNetworkFactor35=this.socialNetworkFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, socialNetworkFactor35.getTree());


                        break;
                    case 32 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:76:9: visibilityFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_visibilityFactor_in_factor612);
                        visibilityFactor36=this.visibilityFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, visibilityFactor36.getTree());


                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalFactor_return: (function() {
            MentionQAst.generalFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:79:1: generalFactor : LPAREN expression RPAREN ;
        // $ANTLR start "generalFactor"
        generalFactor: function() {
            var retval = new MentionQAst.generalFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var LPAREN37 = null;
            var RPAREN39 = null;
            var expression38 = null;

            var LPAREN37_tree=null;
            var RPAREN39_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:80:5: ( LPAREN expression RPAREN )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:80:9: LPAREN expression RPAREN
                root_0 = this.adaptor.nil();

                LPAREN37=this.match(this.input,LPAREN,MentionQAst.FOLLOW_LPAREN_in_generalFactor631);
                this.pushFollow(MentionQAst.FOLLOW_expression_in_generalFactor634);
                expression38=this.expression();

                this.state._fsp--;

                this.adaptor.addChild(root_0, expression38.getTree());
                RPAREN39=this.match(this.input,RPAREN,MentionQAst.FOLLOW_RPAREN_in_generalFactor636);



                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalStringFactor_return: (function() {
            MentionQAst.generalStringFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalStringFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:83:1: generalStringFactor : (o= TITLE | o= LINK | o= SITE | o= EXTRACT | o= URI | o= AUTHOR_LOCATION ) ops= stringOperator lit= STRING_LITERAL -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "generalStringFactor"
        generalStringFactor: function() {
            var retval = new MentionQAst.generalStringFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var lit = null;
            var ops = null;

            var o_tree=null;
            var lit_tree=null;
            var stream_SITE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token SITE");
            var stream_AUTHOR_LOCATION=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AUTHOR_LOCATION");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_LINK=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LINK");
            var stream_EXTRACT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token EXTRACT");
            var stream_TITLE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TITLE");
            var stream_URI=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token URI");
            var stream_stringOperator=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule stringOperator");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:84:5: ( (o= TITLE | o= LINK | o= SITE | o= EXTRACT | o= URI | o= AUTHOR_LOCATION ) ops= stringOperator lit= STRING_LITERAL -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:84:9: (o= TITLE | o= LINK | o= SITE | o= EXTRACT | o= URI | o= AUTHOR_LOCATION ) ops= stringOperator lit= STRING_LITERAL
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:84:9: (o= TITLE | o= LINK | o= SITE | o= EXTRACT | o= URI | o= AUTHOR_LOCATION )
                var alt4=6;
                switch ( this.input.LA(1) ) {
                    case TITLE:
                        alt4=1;
                        break;
                    case LINK:
                        alt4=2;
                        break;
                    case SITE:
                        alt4=3;
                        break;
                    case EXTRACT:
                        alt4=4;
                        break;
                    case URI:
                        alt4=5;
                        break;
                    case AUTHOR_LOCATION:
                        alt4=6;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 4, 0, this.input);

                        throw nvae;
                }

                switch (alt4) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:84:11: o= TITLE
                        o=this.match(this.input,TITLE,MentionQAst.FOLLOW_TITLE_in_generalStringFactor660);
                        stream_TITLE.add(o);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:84:21: o= LINK
                        o=this.match(this.input,LINK,MentionQAst.FOLLOW_LINK_in_generalStringFactor666);
                        stream_LINK.add(o);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:84:30: o= SITE
                        o=this.match(this.input,SITE,MentionQAst.FOLLOW_SITE_in_generalStringFactor672);
                        stream_SITE.add(o);



                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:84:39: o= EXTRACT
                        o=this.match(this.input,EXTRACT,MentionQAst.FOLLOW_EXTRACT_in_generalStringFactor678);
                        stream_EXTRACT.add(o);



                        break;
                    case 5 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:84:51: o= URI
                        o=this.match(this.input,URI,MentionQAst.FOLLOW_URI_in_generalStringFactor684);
                        stream_URI.add(o);



                        break;
                    case 6 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:84:59: o= AUTHOR_LOCATION
                        o=this.match(this.input,AUTHOR_LOCATION,MentionQAst.FOLLOW_AUTHOR_LOCATION_in_generalStringFactor690);
                        stream_AUTHOR_LOCATION.add(o);



                        break;

                }

                this.pushFollow(MentionQAst.FOLLOW_stringOperator_in_generalStringFactor697);
                ops=this.stringOperator();

                this.state._fsp--;

                stream_stringOperator.add(ops.getTree());
                lit=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_generalStringFactor701);
                stream_STRING_LITERAL.add(lit);



                // AST REWRITE
                // elements: o, lit, ops
                // token labels: lit, o
                // rule labels: retval, ops
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token ops",ops!=null?ops.tree:null);

                root_0 = this.adaptor.nil();
                // 85:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:85:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextTree());
                        this.adaptor.addChild(root_1, stream_lit.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalUnknownStringFactor_return: (function() {
            MentionQAst.generalUnknownStringFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalUnknownStringFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:88:1: generalUnknownStringFactor : ( (o= AUTHOR | o= AUTHOR_NAME | o= AUTHOR_HANDLE | o= AUTHOR_HANDLE_ID | o= TO_NAME | o= TO_HANDLE | o= TO_HANDLE_ID | o= TICKET_ID | o= UCN ) ( ( (ops= CONTAINS | ops= DOESNTCONTAIN | ops= BEGINSWITH | ops= ENDSWITH ) lit= STRING_LITERAL ) | ( (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= UNKNOWN ) ) ) ) -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "generalUnknownStringFactor"
        generalUnknownStringFactor: function() {
            var retval = new MentionQAst.generalUnknownStringFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_AUTHOR=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AUTHOR");
            var stream_TICKET_ID=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TICKET_ID");
            var stream_ENDSWITH=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ENDSWITH");
            var stream_TO_NAME=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TO_NAME");
            var stream_TO_HANDLE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TO_HANDLE");
            var stream_UCN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UCN");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_BEGINSWITH=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token BEGINSWITH");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_AUTHOR_HANDLE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AUTHOR_HANDLE");
            var stream_DOESNTCONTAIN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token DOESNTCONTAIN");
            var stream_CONTAINS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CONTAINS");
            var stream_AUTHOR_HANDLE_ID=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AUTHOR_HANDLE_ID");
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_AUTHOR_NAME=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AUTHOR_NAME");
            var stream_TO_HANDLE_ID=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TO_HANDLE_ID");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:5: ( ( (o= AUTHOR | o= AUTHOR_NAME | o= AUTHOR_HANDLE | o= AUTHOR_HANDLE_ID | o= TO_NAME | o= TO_HANDLE | o= TO_HANDLE_ID | o= TICKET_ID | o= UCN ) ( ( (ops= CONTAINS | ops= DOESNTCONTAIN | ops= BEGINSWITH | ops= ENDSWITH ) lit= STRING_LITERAL ) | ( (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= UNKNOWN ) ) ) ) -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:9: ( (o= AUTHOR | o= AUTHOR_NAME | o= AUTHOR_HANDLE | o= AUTHOR_HANDLE_ID | o= TO_NAME | o= TO_HANDLE | o= TO_HANDLE_ID | o= TICKET_ID | o= UCN ) ( ( (ops= CONTAINS | ops= DOESNTCONTAIN | ops= BEGINSWITH | ops= ENDSWITH ) lit= STRING_LITERAL ) | ( (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= UNKNOWN ) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:9: ( (o= AUTHOR | o= AUTHOR_NAME | o= AUTHOR_HANDLE | o= AUTHOR_HANDLE_ID | o= TO_NAME | o= TO_HANDLE | o= TO_HANDLE_ID | o= TICKET_ID | o= UCN ) ( ( (ops= CONTAINS | ops= DOESNTCONTAIN | ops= BEGINSWITH | ops= ENDSWITH ) lit= STRING_LITERAL ) | ( (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= UNKNOWN ) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:10: (o= AUTHOR | o= AUTHOR_NAME | o= AUTHOR_HANDLE | o= AUTHOR_HANDLE_ID | o= TO_NAME | o= TO_HANDLE | o= TO_HANDLE_ID | o= TICKET_ID | o= UCN ) ( ( (ops= CONTAINS | ops= DOESNTCONTAIN | ops= BEGINSWITH | ops= ENDSWITH ) lit= STRING_LITERAL ) | ( (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= UNKNOWN ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:10: (o= AUTHOR | o= AUTHOR_NAME | o= AUTHOR_HANDLE | o= AUTHOR_HANDLE_ID | o= TO_NAME | o= TO_HANDLE | o= TO_HANDLE_ID | o= TICKET_ID | o= UCN )
                var alt5=9;
                switch ( this.input.LA(1) ) {
                    case AUTHOR:
                        alt5=1;
                        break;
                    case AUTHOR_NAME:
                        alt5=2;
                        break;
                    case AUTHOR_HANDLE:
                        alt5=3;
                        break;
                    case AUTHOR_HANDLE_ID:
                        alt5=4;
                        break;
                    case TO_NAME:
                        alt5=5;
                        break;
                    case TO_HANDLE:
                        alt5=6;
                        break;
                    case TO_HANDLE_ID:
                        alt5=7;
                        break;
                    case TICKET_ID:
                        alt5=8;
                        break;
                    case UCN:
                        alt5=9;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 5, 0, this.input);

                        throw nvae;
                }

                switch (alt5) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:12: o= AUTHOR
                        o=this.match(this.input,AUTHOR,MentionQAst.FOLLOW_AUTHOR_in_generalUnknownStringFactor745);
                        stream_AUTHOR.add(o);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:23: o= AUTHOR_NAME
                        o=this.match(this.input,AUTHOR_NAME,MentionQAst.FOLLOW_AUTHOR_NAME_in_generalUnknownStringFactor751);
                        stream_AUTHOR_NAME.add(o);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:39: o= AUTHOR_HANDLE
                        o=this.match(this.input,AUTHOR_HANDLE,MentionQAst.FOLLOW_AUTHOR_HANDLE_in_generalUnknownStringFactor757);
                        stream_AUTHOR_HANDLE.add(o);



                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:57: o= AUTHOR_HANDLE_ID
                        o=this.match(this.input,AUTHOR_HANDLE_ID,MentionQAst.FOLLOW_AUTHOR_HANDLE_ID_in_generalUnknownStringFactor763);
                        stream_AUTHOR_HANDLE_ID.add(o);



                        break;
                    case 5 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:78: o= TO_NAME
                        o=this.match(this.input,TO_NAME,MentionQAst.FOLLOW_TO_NAME_in_generalUnknownStringFactor769);
                        stream_TO_NAME.add(o);



                        break;
                    case 6 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:90: o= TO_HANDLE
                        o=this.match(this.input,TO_HANDLE,MentionQAst.FOLLOW_TO_HANDLE_in_generalUnknownStringFactor775);
                        stream_TO_HANDLE.add(o);



                        break;
                    case 7 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:104: o= TO_HANDLE_ID
                        o=this.match(this.input,TO_HANDLE_ID,MentionQAst.FOLLOW_TO_HANDLE_ID_in_generalUnknownStringFactor781);
                        stream_TO_HANDLE_ID.add(o);



                        break;
                    case 8 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:121: o= TICKET_ID
                        o=this.match(this.input,TICKET_ID,MentionQAst.FOLLOW_TICKET_ID_in_generalUnknownStringFactor787);
                        stream_TICKET_ID.add(o);



                        break;
                    case 9 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:89:135: o= UCN
                        o=this.match(this.input,UCN,MentionQAst.FOLLOW_UCN_in_generalUnknownStringFactor793);
                        stream_UCN.add(o);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:90:10: ( ( (ops= CONTAINS | ops= DOESNTCONTAIN | ops= BEGINSWITH | ops= ENDSWITH ) lit= STRING_LITERAL ) | ( (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= UNKNOWN ) ) )
                var alt9=2;
                var LA9_0 = this.input.LA(1);

                if ( ((LA9_0>=CONTAINS && LA9_0<=ENDSWITH)) ) {
                    alt9=1;
                }
                else if ( ((LA9_0>=IS && LA9_0<=ISNT)) ) {
                    alt9=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 9, 0, this.input);

                    throw nvae;
                }
                switch (alt9) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:90:11: ( (ops= CONTAINS | ops= DOESNTCONTAIN | ops= BEGINSWITH | ops= ENDSWITH ) lit= STRING_LITERAL )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:90:11: ( (ops= CONTAINS | ops= DOESNTCONTAIN | ops= BEGINSWITH | ops= ENDSWITH ) lit= STRING_LITERAL )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:90:12: (ops= CONTAINS | ops= DOESNTCONTAIN | ops= BEGINSWITH | ops= ENDSWITH ) lit= STRING_LITERAL
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:90:12: (ops= CONTAINS | ops= DOESNTCONTAIN | ops= BEGINSWITH | ops= ENDSWITH )
                        var alt6=4;
                        switch ( this.input.LA(1) ) {
                            case CONTAINS:
                                alt6=1;
                                break;
                            case DOESNTCONTAIN:
                                alt6=2;
                                break;
                            case BEGINSWITH:
                                alt6=3;
                                break;
                            case ENDSWITH:
                                alt6=4;
                                break;
                            default:
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 6, 0, this.input);

                                throw nvae;
                        }

                        switch (alt6) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:90:13: ops= CONTAINS
                                ops=this.match(this.input,CONTAINS,MentionQAst.FOLLOW_CONTAINS_in_generalUnknownStringFactor811);
                                stream_CONTAINS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:90:28: ops= DOESNTCONTAIN
                                ops=this.match(this.input,DOESNTCONTAIN,MentionQAst.FOLLOW_DOESNTCONTAIN_in_generalUnknownStringFactor817);
                                stream_DOESNTCONTAIN.add(ops);



                                break;
                            case 3 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:90:48: ops= BEGINSWITH
                                ops=this.match(this.input,BEGINSWITH,MentionQAst.FOLLOW_BEGINSWITH_in_generalUnknownStringFactor823);
                                stream_BEGINSWITH.add(ops);



                                break;
                            case 4 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:90:65: ops= ENDSWITH
                                ops=this.match(this.input,ENDSWITH,MentionQAst.FOLLOW_ENDSWITH_in_generalUnknownStringFactor829);
                                stream_ENDSWITH.add(ops);



                                break;

                        }

                        lit=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_generalUnknownStringFactor834);
                        stream_STRING_LITERAL.add(lit);






                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:92:11: ( (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= UNKNOWN ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:92:11: ( (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= UNKNOWN ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:92:12: (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= UNKNOWN )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:92:12: (ops= IS | ops= ISNT )
                        var alt7=2;
                        var LA7_0 = this.input.LA(1);

                        if ( (LA7_0==IS) ) {
                            alt7=1;
                        }
                        else if ( (LA7_0==ISNT) ) {
                            alt7=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 7, 0, this.input);

                            throw nvae;
                        }
                        switch (alt7) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:92:13: ops= IS
                                ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_generalUnknownStringFactor863);
                                stream_IS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:92:22: ops= ISNT
                                ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_generalUnknownStringFactor869);
                                stream_ISNT.add(ops);



                                break;

                        }

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:92:32: (lit= STRING_LITERAL | lit= UNKNOWN )
                        var alt8=2;
                        var LA8_0 = this.input.LA(1);

                        if ( (LA8_0==STRING_LITERAL) ) {
                            alt8=1;
                        }
                        else if ( (LA8_0==UNKNOWN) ) {
                            alt8=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 8, 0, this.input);

                            throw nvae;
                        }
                        switch (alt8) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:92:33: lit= STRING_LITERAL
                                lit=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_generalUnknownStringFactor875);
                                stream_STRING_LITERAL.add(lit);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:92:54: lit= UNKNOWN
                                lit=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_generalUnknownStringFactor881);
                                stream_UNKNOWN.add(lit);



                                break;

                        }






                        break;

                }






                // AST REWRITE
                // elements: o, lit, ops
                // token labels: lit, o, ops
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 93:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:93:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        feedFactor_return: (function() {
            MentionQAst.feedFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.feedFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:96:1: feedFactor : (o= FEED ) (ops= IS | ops= ISNT ) (lit= STRING_LITERAL ) -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "feedFactor"
        feedFactor: function() {
            var retval = new MentionQAst.feedFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_FEED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token FEED");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:97:5: ( (o= FEED ) (ops= IS | ops= ISNT ) (lit= STRING_LITERAL ) -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:97:9: (o= FEED ) (ops= IS | ops= ISNT ) (lit= STRING_LITERAL )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:97:9: (o= FEED )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:97:11: o= FEED
                o=this.match(this.input,FEED,MentionQAst.FOLLOW_FEED_in_feedFactor928);
                stream_FEED.add(o);




                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:97:21: (ops= IS | ops= ISNT )
                var alt10=2;
                var LA10_0 = this.input.LA(1);

                if ( (LA10_0==IS) ) {
                    alt10=1;
                }
                else if ( (LA10_0==ISNT) ) {
                    alt10=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 10, 0, this.input);

                    throw nvae;
                }
                switch (alt10) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:97:23: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_feedFactor937);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:97:32: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_feedFactor943);
                        stream_ISNT.add(ops);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:97:43: (lit= STRING_LITERAL )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:97:44: lit= STRING_LITERAL
                lit=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_feedFactor950);
                stream_STRING_LITERAL.add(lit);






                // AST REWRITE
                // elements: o, ops, lit
                // token labels: lit, o, ops
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 98:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:98:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalIsIsntStringFactor_return: (function() {
            MentionQAst.generalIsIsntStringFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalIsIsntStringFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:101:1: generalIsIsntStringFactor : (o= COUNTRY | o= LANGUAGE ) (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= UNKNOWN ) -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "generalIsIsntStringFactor"
        generalIsIsntStringFactor: function() {
            var retval = new MentionQAst.generalIsIsntStringFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_LANGUAGE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LANGUAGE");
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_COUNTRY=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token COUNTRY");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:102:5: ( (o= COUNTRY | o= LANGUAGE ) (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= UNKNOWN ) -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:102:9: (o= COUNTRY | o= LANGUAGE ) (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= UNKNOWN )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:102:9: (o= COUNTRY | o= LANGUAGE )
                var alt11=2;
                var LA11_0 = this.input.LA(1);

                if ( (LA11_0==COUNTRY) ) {
                    alt11=1;
                }
                else if ( (LA11_0==LANGUAGE) ) {
                    alt11=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 11, 0, this.input);

                    throw nvae;
                }
                switch (alt11) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:102:11: o= COUNTRY
                        o=this.match(this.input,COUNTRY,MentionQAst.FOLLOW_COUNTRY_in_generalIsIsntStringFactor995);
                        stream_COUNTRY.add(o);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:102:23: o= LANGUAGE
                        o=this.match(this.input,LANGUAGE,MentionQAst.FOLLOW_LANGUAGE_in_generalIsIsntStringFactor1001);
                        stream_LANGUAGE.add(o);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:102:37: (ops= IS | ops= ISNT )
                var alt12=2;
                var LA12_0 = this.input.LA(1);

                if ( (LA12_0==IS) ) {
                    alt12=1;
                }
                else if ( (LA12_0==ISNT) ) {
                    alt12=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 12, 0, this.input);

                    throw nvae;
                }
                switch (alt12) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:102:39: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_generalIsIsntStringFactor1010);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:102:48: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_generalIsIsntStringFactor1016);
                        stream_ISNT.add(ops);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:102:59: (lit= STRING_LITERAL | lit= UNKNOWN )
                var alt13=2;
                var LA13_0 = this.input.LA(1);

                if ( (LA13_0==STRING_LITERAL) ) {
                    alt13=1;
                }
                else if ( (LA13_0==UNKNOWN) ) {
                    alt13=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 13, 0, this.input);

                    throw nvae;
                }
                switch (alt13) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:102:60: lit= STRING_LITERAL
                        lit=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_generalIsIsntStringFactor1023);
                        stream_STRING_LITERAL.add(lit);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:102:81: lit= UNKNOWN
                        lit=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_generalIsIsntStringFactor1029);
                        stream_UNKNOWN.add(lit);



                        break;

                }



                // AST REWRITE
                // elements: lit, ops, o
                // token labels: lit, o, ops
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 103:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:103:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        cityIsIsntFactor_return: (function() {
            MentionQAst.cityIsIsntFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.cityIsIsntFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:106:1: cityIsIsntFactor : (o= CITY ) (ops= IS | ops= ISNT ) (lit= UNKNOWN ) -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "cityIsIsntFactor"
        cityIsIsntFactor: function() {
            var retval = new MentionQAst.cityIsIsntFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_CITY=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CITY");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:107:5: ( (o= CITY ) (ops= IS | ops= ISNT ) (lit= UNKNOWN ) -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:107:9: (o= CITY ) (ops= IS | ops= ISNT ) (lit= UNKNOWN )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:107:9: (o= CITY )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:107:11: o= CITY
                o=this.match(this.input,CITY,MentionQAst.FOLLOW_CITY_in_cityIsIsntFactor1073);
                stream_CITY.add(o);




                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:107:21: (ops= IS | ops= ISNT )
                var alt14=2;
                var LA14_0 = this.input.LA(1);

                if ( (LA14_0==IS) ) {
                    alt14=1;
                }
                else if ( (LA14_0==ISNT) ) {
                    alt14=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 14, 0, this.input);

                    throw nvae;
                }
                switch (alt14) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:107:23: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_cityIsIsntFactor1082);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:107:32: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_cityIsIsntFactor1088);
                        stream_ISNT.add(ops);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:107:43: (lit= UNKNOWN )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:107:44: lit= UNKNOWN
                lit=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_cityIsIsntFactor1095);
                stream_UNKNOWN.add(lit);






                // AST REWRITE
                // elements: o, lit, ops
                // token labels: lit, o, ops
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 108:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:108:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalIsIsntLongFactor_return: (function() {
            MentionQAst.generalIsIsntLongFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalIsIsntLongFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:111:1: generalIsIsntLongFactor : (o= ASSIGNEE | o= PHRASE | o= DISCARDED_BY ) (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= UNKNOWN ) -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "generalIsIsntLongFactor"
        generalIsIsntLongFactor: function() {
            var retval = new MentionQAst.generalIsIsntLongFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_DISCARDED_BY=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token DISCARDED_BY");
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_LONG_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LONG_LITERAL");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_PHRASE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token PHRASE");
            var stream_ASSIGNEE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ASSIGNEE");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:112:5: ( (o= ASSIGNEE | o= PHRASE | o= DISCARDED_BY ) (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= UNKNOWN ) -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:112:9: (o= ASSIGNEE | o= PHRASE | o= DISCARDED_BY ) (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= UNKNOWN )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:112:9: (o= ASSIGNEE | o= PHRASE | o= DISCARDED_BY )
                var alt15=3;
                switch ( this.input.LA(1) ) {
                    case ASSIGNEE:
                        alt15=1;
                        break;
                    case PHRASE:
                        alt15=2;
                        break;
                    case DISCARDED_BY:
                        alt15=3;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 15, 0, this.input);

                        throw nvae;
                }

                switch (alt15) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:112:11: o= ASSIGNEE
                        o=this.match(this.input,ASSIGNEE,MentionQAst.FOLLOW_ASSIGNEE_in_generalIsIsntLongFactor1139);
                        stream_ASSIGNEE.add(o);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:112:24: o= PHRASE
                        o=this.match(this.input,PHRASE,MentionQAst.FOLLOW_PHRASE_in_generalIsIsntLongFactor1145);
                        stream_PHRASE.add(o);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:112:35: o= DISCARDED_BY
                        o=this.match(this.input,DISCARDED_BY,MentionQAst.FOLLOW_DISCARDED_BY_in_generalIsIsntLongFactor1151);
                        stream_DISCARDED_BY.add(o);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:112:51: (ops= IS | ops= ISNT )
                var alt16=2;
                var LA16_0 = this.input.LA(1);

                if ( (LA16_0==IS) ) {
                    alt16=1;
                }
                else if ( (LA16_0==ISNT) ) {
                    alt16=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 16, 0, this.input);

                    throw nvae;
                }
                switch (alt16) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:112:53: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_generalIsIsntLongFactor1158);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:112:62: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_generalIsIsntLongFactor1164);
                        stream_ISNT.add(ops);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:112:74: (lit= LONG_LITERAL | lit= UNKNOWN )
                var alt17=2;
                var LA17_0 = this.input.LA(1);

                if ( (LA17_0==LONG_LITERAL) ) {
                    alt17=1;
                }
                else if ( (LA17_0==UNKNOWN) ) {
                    alt17=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 17, 0, this.input);

                    throw nvae;
                }
                switch (alt17) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:112:76: lit= LONG_LITERAL
                        lit=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_generalIsIsntLongFactor1173);
                        stream_LONG_LITERAL.add(lit);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:112:95: lit= UNKNOWN
                        lit=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_generalIsIsntLongFactor1179);
                        stream_UNKNOWN.add(lit);



                        break;

                }



                // AST REWRITE
                // elements: o, ops, lit
                // token labels: lit, o, ops
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 113:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:113:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        engagedProfileIsIsntLongFactor_return: (function() {
            MentionQAst.engagedProfileIsIsntLongFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.engagedProfileIsIsntLongFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:116:1: engagedProfileIsIsntLongFactor : (o= MENTIONED_PROFILE ) (ops= IS | ops= ISNT ) (lit= LONG_LITERAL ) -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "engagedProfileIsIsntLongFactor"
        engagedProfileIsIsntLongFactor: function() {
            var retval = new MentionQAst.engagedProfileIsIsntLongFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_MENTIONED_PROFILE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token MENTIONED_PROFILE");
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_LONG_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LONG_LITERAL");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:117:5: ( (o= MENTIONED_PROFILE ) (ops= IS | ops= ISNT ) (lit= LONG_LITERAL ) -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:117:9: (o= MENTIONED_PROFILE ) (ops= IS | ops= ISNT ) (lit= LONG_LITERAL )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:117:9: (o= MENTIONED_PROFILE )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:117:11: o= MENTIONED_PROFILE
                o=this.match(this.input,MENTIONED_PROFILE,MentionQAst.FOLLOW_MENTIONED_PROFILE_in_engagedProfileIsIsntLongFactor1224);
                stream_MENTIONED_PROFILE.add(o);




                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:117:32: (ops= IS | ops= ISNT )
                var alt18=2;
                var LA18_0 = this.input.LA(1);

                if ( (LA18_0==IS) ) {
                    alt18=1;
                }
                else if ( (LA18_0==ISNT) ) {
                    alt18=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 18, 0, this.input);

                    throw nvae;
                }
                switch (alt18) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:117:34: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_engagedProfileIsIsntLongFactor1231);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:117:43: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_engagedProfileIsIsntLongFactor1237);
                        stream_ISNT.add(ops);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:117:55: (lit= LONG_LITERAL )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:117:57: lit= LONG_LITERAL
                lit=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_engagedProfileIsIsntLongFactor1246);
                stream_LONG_LITERAL.add(lit);






                // AST REWRITE
                // elements: o, lit, ops
                // token labels: lit, o, ops
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 118:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:118:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        sampleFactor_return: (function() {
            MentionQAst.sampleFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.sampleFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:121:1: sampleFactor : ( SAMPLE LPAREN p= FLOAT_LITERAL COMMA seed= LONG_LITERAL RPAREN -> ^( SAMPLE_FACTOR $p $seed) | SAMPLE LPAREN p= FLOAT_LITERAL RPAREN -> ^( SAMPLE_FACTOR $p) );
        // $ANTLR start "sampleFactor"
        sampleFactor: function() {
            var retval = new MentionQAst.sampleFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var p = null;
            var seed = null;
            var SAMPLE40 = null;
            var LPAREN41 = null;
            var COMMA42 = null;
            var RPAREN43 = null;
            var SAMPLE44 = null;
            var LPAREN45 = null;
            var RPAREN46 = null;

            var p_tree=null;
            var seed_tree=null;
            var SAMPLE40_tree=null;
            var LPAREN41_tree=null;
            var COMMA42_tree=null;
            var RPAREN43_tree=null;
            var SAMPLE44_tree=null;
            var LPAREN45_tree=null;
            var RPAREN46_tree=null;
            var stream_FLOAT_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token FLOAT_LITERAL");
            var stream_SAMPLE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token SAMPLE");
            var stream_RPAREN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RPAREN");
            var stream_COMMA=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token COMMA");
            var stream_LONG_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LONG_LITERAL");
            var stream_LPAREN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LPAREN");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:122:5: ( SAMPLE LPAREN p= FLOAT_LITERAL COMMA seed= LONG_LITERAL RPAREN -> ^( SAMPLE_FACTOR $p $seed) | SAMPLE LPAREN p= FLOAT_LITERAL RPAREN -> ^( SAMPLE_FACTOR $p) )
                var alt19=2;
                var LA19_0 = this.input.LA(1);

                if ( (LA19_0==SAMPLE) ) {
                    var LA19_1 = this.input.LA(2);

                    if ( (LA19_1==LPAREN) ) {
                        var LA19_2 = this.input.LA(3);

                        if ( (LA19_2==FLOAT_LITERAL) ) {
                            var LA19_3 = this.input.LA(4);

                            if ( (LA19_3==COMMA) ) {
                                alt19=1;
                            }
                            else if ( (LA19_3==RPAREN) ) {
                                alt19=2;
                            }
                            else {
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 19, 3, this.input);

                                throw nvae;
                            }
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 19, 2, this.input);

                            throw nvae;
                        }
                    }
                    else {
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 19, 1, this.input);

                        throw nvae;
                    }
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 19, 0, this.input);

                    throw nvae;
                }
                switch (alt19) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:122:9: SAMPLE LPAREN p= FLOAT_LITERAL COMMA seed= LONG_LITERAL RPAREN
                        SAMPLE40=this.match(this.input,SAMPLE,MentionQAst.FOLLOW_SAMPLE_in_sampleFactor1287);
                        stream_SAMPLE.add(SAMPLE40);

                        LPAREN41=this.match(this.input,LPAREN,MentionQAst.FOLLOW_LPAREN_in_sampleFactor1289);
                        stream_LPAREN.add(LPAREN41);

                        p=this.match(this.input,FLOAT_LITERAL,MentionQAst.FOLLOW_FLOAT_LITERAL_in_sampleFactor1293);
                        stream_FLOAT_LITERAL.add(p);

                        COMMA42=this.match(this.input,COMMA,MentionQAst.FOLLOW_COMMA_in_sampleFactor1295);
                        stream_COMMA.add(COMMA42);

                        seed=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_sampleFactor1299);
                        stream_LONG_LITERAL.add(seed);

                        RPAREN43=this.match(this.input,RPAREN,MentionQAst.FOLLOW_RPAREN_in_sampleFactor1301);
                        stream_RPAREN.add(RPAREN43);



                        // AST REWRITE
                        // elements: p, seed
                        // token labels: seed, p
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_seed=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token seed",seed);
                        var stream_p=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token p",p);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 123:5: -> ^( SAMPLE_FACTOR $p $seed)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:123:8: ^( SAMPLE_FACTOR $p $seed)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SAMPLE_FACTOR, "SAMPLE_FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_p.nextNode());
                            this.adaptor.addChild(root_1, stream_seed.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:124:9: SAMPLE LPAREN p= FLOAT_LITERAL RPAREN
                        SAMPLE44=this.match(this.input,SAMPLE,MentionQAst.FOLLOW_SAMPLE_in_sampleFactor1327);
                        stream_SAMPLE.add(SAMPLE44);

                        LPAREN45=this.match(this.input,LPAREN,MentionQAst.FOLLOW_LPAREN_in_sampleFactor1329);
                        stream_LPAREN.add(LPAREN45);

                        p=this.match(this.input,FLOAT_LITERAL,MentionQAst.FOLLOW_FLOAT_LITERAL_in_sampleFactor1333);
                        stream_FLOAT_LITERAL.add(p);

                        RPAREN46=this.match(this.input,RPAREN,MentionQAst.FOLLOW_RPAREN_in_sampleFactor1335);
                        stream_RPAREN.add(RPAREN46);



                        // AST REWRITE
                        // elements: p
                        // token labels: p
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_p=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token p",p);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 125:5: -> ^( SAMPLE_FACTOR $p)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:125:8: ^( SAMPLE_FACTOR $p)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SAMPLE_FACTOR, "SAMPLE_FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_p.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalInLongFactor_return: (function() {
            MentionQAst.generalInLongFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalInLongFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:128:1: generalInLongFactor : ( (o= CROWD_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) ) | ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) ) ) ;
        // $ANTLR start "generalInLongFactor"
        generalInLongFactor: function() {
            var retval = new MentionQAst.generalInLongFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var longVal = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var longVal_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_IN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IN");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_LONG_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LONG_LITERAL");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_CROWD_ID=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CROWD_ID");
            var stream_NOTIN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token NOTIN");
            var stream_longIdSet=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule longIdSet");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:129:5: ( ( (o= CROWD_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) ) | ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:129:9: ( (o= CROWD_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) ) | ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:129:9: ( (o= CROWD_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) ) | ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:129:11: (o= CROWD_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) ) | ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:129:11: (o= CROWD_ID )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:129:12: o= CROWD_ID
                o=this.match(this.input,CROWD_ID,MentionQAst.FOLLOW_CROWD_ID_in_generalInLongFactor1372);
                stream_CROWD_ID.add(o);




                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:130:10: ( ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) ) | ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) )
                var alt23=2;
                var LA23_0 = this.input.LA(1);

                if ( ((LA23_0>=IN && LA23_0<=NOTIN)) ) {
                    alt23=1;
                }
                else if ( ((LA23_0>=IS && LA23_0<=ISNT)) ) {
                    alt23=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 23, 0, this.input);

                    throw nvae;
                }
                switch (alt23) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:130:11: ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:130:11: ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:130:12: (ops= IN | ops= NOTIN ) lit= longIdSet
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:130:12: (ops= IN | ops= NOTIN )
                        var alt20=2;
                        var LA20_0 = this.input.LA(1);

                        if ( (LA20_0==IN) ) {
                            alt20=1;
                        }
                        else if ( (LA20_0==NOTIN) ) {
                            alt20=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 20, 0, this.input);

                            throw nvae;
                        }
                        switch (alt20) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:130:14: ops= IN
                                ops=this.match(this.input,IN,MentionQAst.FOLLOW_IN_in_generalInLongFactor1390);
                                stream_IN.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:130:23: ops= NOTIN
                                ops=this.match(this.input,NOTIN,MentionQAst.FOLLOW_NOTIN_in_generalInLongFactor1396);
                                stream_NOTIN.add(ops);



                                break;

                        }

                        this.pushFollow(MentionQAst.FOLLOW_longIdSet_in_generalInLongFactor1402);
                        lit=this.longIdSet();

                        this.state._fsp--;

                        stream_longIdSet.add(lit.getTree());


                        // AST REWRITE
                        // elements: o, lit, ops
                        // token labels: o, ops
                        // rule labels: lit, retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_lit=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit",lit!=null?lit.tree:null);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 130:49: -> ^( SET_LONG_FACTOR $o $ops $lit)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:130:52: ^( SET_LONG_FACTOR $o $ops $lit)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SET_LONG_FACTOR, "SET_LONG_FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:132:11: ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:132:11: ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:132:12: (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= UNKNOWN )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:132:12: (ops= IS | ops= ISNT )
                        var alt21=2;
                        var LA21_0 = this.input.LA(1);

                        if ( (LA21_0==IS) ) {
                            alt21=1;
                        }
                        else if ( (LA21_0==ISNT) ) {
                            alt21=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 21, 0, this.input);

                            throw nvae;
                        }
                        switch (alt21) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:132:14: ops= IS
                                ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_generalInLongFactor1449);
                                stream_IS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:132:25: ops= ISNT
                                ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_generalInLongFactor1457);
                                stream_ISNT.add(ops);



                                break;

                        }

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:132:37: (longVal= LONG_LITERAL | longVal= UNKNOWN )
                        var alt22=2;
                        var LA22_0 = this.input.LA(1);

                        if ( (LA22_0==LONG_LITERAL) ) {
                            alt22=1;
                        }
                        else if ( (LA22_0==UNKNOWN) ) {
                            alt22=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 22, 0, this.input);

                            throw nvae;
                        }
                        switch (alt22) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:132:39: longVal= LONG_LITERAL
                                longVal=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_generalInLongFactor1464);
                                stream_LONG_LITERAL.add(longVal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:132:62: longVal= UNKNOWN
                                longVal=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_generalInLongFactor1470);
                                stream_UNKNOWN.add(longVal);



                                break;

                        }



                        // AST REWRITE
                        // elements: o, longVal, ops
                        // token labels: longVal, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_longVal=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token longVal",longVal);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 132:85: -> ^( FACTOR $o $ops $longVal)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:132:88: ^( FACTOR $o $ops $longVal)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_longVal.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;

                }







                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalInOnlyLongFactor_return: (function() {
            MentionQAst.generalInOnlyLongFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalInOnlyLongFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:135:1: generalInOnlyLongFactor : ( (o= HAS_REPLY_FROM_PROFILE ) ( ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) ) ) ) ;
        // $ANTLR start "generalInOnlyLongFactor"
        generalInOnlyLongFactor: function() {
            var retval = new MentionQAst.generalInOnlyLongFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var stream_IN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IN");
            var stream_HAS_REPLY_FROM_PROFILE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token HAS_REPLY_FROM_PROFILE");
            var stream_NOTIN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token NOTIN");
            var stream_longIdSet=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule longIdSet");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:136:5: ( ( (o= HAS_REPLY_FROM_PROFILE ) ( ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) ) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:136:9: ( (o= HAS_REPLY_FROM_PROFILE ) ( ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:136:9: ( (o= HAS_REPLY_FROM_PROFILE ) ( ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:136:11: (o= HAS_REPLY_FROM_PROFILE ) ( ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:136:11: (o= HAS_REPLY_FROM_PROFILE )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:136:12: o= HAS_REPLY_FROM_PROFILE
                o=this.match(this.input,HAS_REPLY_FROM_PROFILE,MentionQAst.FOLLOW_HAS_REPLY_FROM_PROFILE_in_generalInOnlyLongFactor1519);
                stream_HAS_REPLY_FROM_PROFILE.add(o);




                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:137:10: ( ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:137:11: ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:137:11: ( (ops= IN | ops= NOTIN ) lit= longIdSet -> ^( SET_LONG_FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:137:12: (ops= IN | ops= NOTIN ) lit= longIdSet
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:137:12: (ops= IN | ops= NOTIN )
                var alt24=2;
                var LA24_0 = this.input.LA(1);

                if ( (LA24_0==IN) ) {
                    alt24=1;
                }
                else if ( (LA24_0==NOTIN) ) {
                    alt24=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 24, 0, this.input);

                    throw nvae;
                }
                switch (alt24) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:137:14: ops= IN
                        ops=this.match(this.input,IN,MentionQAst.FOLLOW_IN_in_generalInOnlyLongFactor1537);
                        stream_IN.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:137:23: ops= NOTIN
                        ops=this.match(this.input,NOTIN,MentionQAst.FOLLOW_NOTIN_in_generalInOnlyLongFactor1543);
                        stream_NOTIN.add(ops);



                        break;

                }

                this.pushFollow(MentionQAst.FOLLOW_longIdSet_in_generalInOnlyLongFactor1549);
                lit=this.longIdSet();

                this.state._fsp--;

                stream_longIdSet.add(lit.getTree());


                // AST REWRITE
                // elements: lit, ops, o
                // token labels: o, ops
                // rule labels: lit, retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit",lit!=null?lit.tree:null);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 137:49: -> ^( SET_LONG_FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:137:52: ^( SET_LONG_FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(SET_LONG_FACTOR, "SET_LONG_FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextTree());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;











                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        longIdSet_return: (function() {
            MentionQAst.longIdSet_return = function(){};
            org.antlr.lang.extend(MentionQAst.longIdSet_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:141:1: longIdSet : ( ANNOTATION )? LPAREN LONG_LITERAL ( COMMA LONG_LITERAL )* RPAREN ;
        // $ANTLR start "longIdSet"
        longIdSet: function() {
            var retval = new MentionQAst.longIdSet_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var ANNOTATION47 = null;
            var LPAREN48 = null;
            var LONG_LITERAL49 = null;
            var COMMA50 = null;
            var LONG_LITERAL51 = null;
            var RPAREN52 = null;

            var ANNOTATION47_tree=null;
            var LPAREN48_tree=null;
            var LONG_LITERAL49_tree=null;
            var COMMA50_tree=null;
            var LONG_LITERAL51_tree=null;
            var RPAREN52_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:142:5: ( ( ANNOTATION )? LPAREN LONG_LITERAL ( COMMA LONG_LITERAL )* RPAREN )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:142:8: ( ANNOTATION )? LPAREN LONG_LITERAL ( COMMA LONG_LITERAL )* RPAREN
                root_0 = this.adaptor.nil();

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:142:8: ( ANNOTATION )?
                var alt25=2;
                var LA25_0 = this.input.LA(1);

                if ( (LA25_0==ANNOTATION) ) {
                    alt25=1;
                }
                switch (alt25) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:142:9: ANNOTATION
                        ANNOTATION47=this.match(this.input,ANNOTATION,MentionQAst.FOLLOW_ANNOTATION_in_longIdSet1597);
                        ANNOTATION47_tree = this.adaptor.create(ANNOTATION47);
                        this.adaptor.addChild(root_0, ANNOTATION47_tree);



                        break;

                }

                LPAREN48=this.match(this.input,LPAREN,MentionQAst.FOLLOW_LPAREN_in_longIdSet1601);
                LONG_LITERAL49=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_longIdSet1604);
                LONG_LITERAL49_tree = this.adaptor.create(LONG_LITERAL49);
                this.adaptor.addChild(root_0, LONG_LITERAL49_tree);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:142:43: ( COMMA LONG_LITERAL )*
                loop26:
                    do {
                        var alt26=2;
                        var LA26_0 = this.input.LA(1);

                        if ( (LA26_0==COMMA) ) {
                            alt26=1;
                        }


                        switch (alt26) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:142:45: COMMA LONG_LITERAL
                                COMMA50=this.match(this.input,COMMA,MentionQAst.FOLLOW_COMMA_in_longIdSet1608);
                                LONG_LITERAL51=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_longIdSet1611);
                                LONG_LITERAL51_tree = this.adaptor.create(LONG_LITERAL51);
                                this.adaptor.addChild(root_0, LONG_LITERAL51_tree);



                                break;

                            default :
                                break loop26;
                        }
                    } while (true);

                RPAREN52=this.match(this.input,RPAREN,MentionQAst.FOLLOW_RPAREN_in_longIdSet1617);



                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        interactionIdFactor_return: (function() {
            MentionQAst.interactionIdFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.interactionIdFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:145:1: interactionIdFactor : ( (o= INTERACTION_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) ) | ( (ops= IS | ops= ISNT ) (longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) ) ) ;
        // $ANTLR start "interactionIdFactor"
        interactionIdFactor: function() {
            var retval = new MentionQAst.interactionIdFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var longVal = null;
            var LPAREN53 = null;
            var RPAREN54 = null;
            var lit = null;
            var sub = null;

            var o_tree=null;
            var ops_tree=null;
            var longVal_tree=null;
            var LPAREN53_tree=null;
            var RPAREN54_tree=null;
            var stream_RPAREN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RPAREN");
            var stream_INTERACTION_ID=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTERACTION_ID");
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_IN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IN");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_LPAREN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LPAREN");
            var stream_NOTIN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token NOTIN");
            var stream_expression=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule expression");
            var stream_longOrStringIdSet=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule longOrStringIdSet");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:146:5: ( ( (o= INTERACTION_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) ) | ( (ops= IS | ops= ISNT ) (longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:146:9: ( (o= INTERACTION_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) ) | ( (ops= IS | ops= ISNT ) (longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:146:9: ( (o= INTERACTION_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) ) | ( (ops= IS | ops= ISNT ) (longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:146:11: (o= INTERACTION_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) ) | ( (ops= IS | ops= ISNT ) (longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:146:11: (o= INTERACTION_ID )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:146:12: o= INTERACTION_ID
                o=this.match(this.input,INTERACTION_ID,MentionQAst.FOLLOW_INTERACTION_ID_in_interactionIdFactor1642);
                stream_INTERACTION_ID.add(o);




                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:147:10: ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) ) | ( (ops= IS | ops= ISNT ) (longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) )
                var alt31=3;
                switch ( this.input.LA(1) ) {
                    case IN:
                        var LA31_1 = this.input.LA(2);

                        if ( (LA31_1==ANNOTATION) ) {
                            alt31=1;
                        }
                        else if ( (LA31_1==LPAREN) ) {
                            var LA31_5 = this.input.LA(3);

                            if ( (LA31_5==LONG_LITERAL||LA31_5==STRING_LITERAL) ) {
                                alt31=1;
                            }
                            else if ( (LA31_5==RELEVANCY||LA31_5==BRAND||(LA31_5>=SENTIMENT && LA31_5<=ACTION)||LA31_5==PROCESS||LA31_5==PHRASE||LA31_5==PHRASE_COUNT||(LA31_5>=FEED && LA31_5<=TITLE)||(LA31_5>=LINK && LA31_5<=CONTENT)||(LA31_5>=LANGUAGE && LA31_5<=PAGE_RANK)||(LA31_5>=ALEXA_RANK && LA31_5<=COUNTRY)||(LA31_5>=CITY && LA31_5<=SENTIMENT_VERIFIED)||(LA31_5>=CROWD_VERIFIED && LA31_5<=FOLLOWING_COUNT)||(LA31_5>=GENDER && LA31_5<=UCN)||LA31_5==SAMPLE||LA31_5==LPAREN) ) {
                                alt31=2;
                            }
                            else {
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 31, 5, this.input);

                                throw nvae;
                            }
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 31, 1, this.input);

                            throw nvae;
                        }
                        break;
                    case NOTIN:
                        var LA31_2 = this.input.LA(2);

                        if ( (LA31_2==ANNOTATION) ) {
                            alt31=1;
                        }
                        else if ( (LA31_2==LPAREN) ) {
                            var LA31_5 = this.input.LA(3);

                            if ( (LA31_5==LONG_LITERAL||LA31_5==STRING_LITERAL) ) {
                                alt31=1;
                            }
                            else if ( (LA31_5==RELEVANCY||LA31_5==BRAND||(LA31_5>=SENTIMENT && LA31_5<=ACTION)||LA31_5==PROCESS||LA31_5==PHRASE||LA31_5==PHRASE_COUNT||(LA31_5>=FEED && LA31_5<=TITLE)||(LA31_5>=LINK && LA31_5<=CONTENT)||(LA31_5>=LANGUAGE && LA31_5<=PAGE_RANK)||(LA31_5>=ALEXA_RANK && LA31_5<=COUNTRY)||(LA31_5>=CITY && LA31_5<=SENTIMENT_VERIFIED)||(LA31_5>=CROWD_VERIFIED && LA31_5<=FOLLOWING_COUNT)||(LA31_5>=GENDER && LA31_5<=UCN)||LA31_5==SAMPLE||LA31_5==LPAREN) ) {
                                alt31=2;
                            }
                            else {
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 31, 5, this.input);

                                throw nvae;
                            }
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 31, 2, this.input);

                            throw nvae;
                        }
                        break;
                    case IS:
                    case ISNT:
                        alt31=3;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 31, 0, this.input);

                        throw nvae;
                }

                switch (alt31) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:148:11: ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:148:11: ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:148:12: (ops= IN | ops= NOTIN ) lit= longOrStringIdSet
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:148:12: (ops= IN | ops= NOTIN )
                        var alt27=2;
                        var LA27_0 = this.input.LA(1);

                        if ( (LA27_0==IN) ) {
                            alt27=1;
                        }
                        else if ( (LA27_0==NOTIN) ) {
                            alt27=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 27, 0, this.input);

                            throw nvae;
                        }
                        switch (alt27) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:148:14: ops= IN
                                ops=this.match(this.input,IN,MentionQAst.FOLLOW_IN_in_interactionIdFactor1671);
                                stream_IN.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:148:23: ops= NOTIN
                                ops=this.match(this.input,NOTIN,MentionQAst.FOLLOW_NOTIN_in_interactionIdFactor1677);
                                stream_NOTIN.add(ops);



                                break;

                        }

                        this.pushFollow(MentionQAst.FOLLOW_longOrStringIdSet_in_interactionIdFactor1683);
                        lit=this.longOrStringIdSet();

                        this.state._fsp--;

                        stream_longOrStringIdSet.add(lit.getTree());


                        // AST REWRITE
                        // elements: o, ops, lit
                        // token labels: o, ops
                        // rule labels: lit, retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_lit=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit",lit!=null?lit.tree:null);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 148:57: -> ^( SET_MENTION_ID_FACTOR $o $ops $lit)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:148:60: ^( SET_MENTION_ID_FACTOR $o $ops $lit)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SET_MENTION_ID_FACTOR, "SET_MENTION_ID_FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:150:11: ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:150:11: ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:150:12: (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:150:12: (ops= IN | ops= NOTIN )
                        var alt28=2;
                        var LA28_0 = this.input.LA(1);

                        if ( (LA28_0==IN) ) {
                            alt28=1;
                        }
                        else if ( (LA28_0==NOTIN) ) {
                            alt28=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 28, 0, this.input);

                            throw nvae;
                        }
                        switch (alt28) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:150:14: ops= IN
                                ops=this.match(this.input,IN,MentionQAst.FOLLOW_IN_in_interactionIdFactor1728);
                                stream_IN.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:150:23: ops= NOTIN
                                ops=this.match(this.input,NOTIN,MentionQAst.FOLLOW_NOTIN_in_interactionIdFactor1734);
                                stream_NOTIN.add(ops);



                                break;

                        }

                        LPAREN53=this.match(this.input,LPAREN,MentionQAst.FOLLOW_LPAREN_in_interactionIdFactor1738);
                        stream_LPAREN.add(LPAREN53);

                        this.pushFollow(MentionQAst.FOLLOW_expression_in_interactionIdFactor1742);
                        sub=this.expression();

                        this.state._fsp--;

                        stream_expression.add(sub.getTree());
                        RPAREN54=this.match(this.input,RPAREN,MentionQAst.FOLLOW_RPAREN_in_interactionIdFactor1744);
                        stream_RPAREN.add(RPAREN54);



                        // AST REWRITE
                        // elements: o, ops, sub
                        // token labels: o, ops
                        // rule labels: retval, sub
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);
                        var stream_sub=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token sub",sub!=null?sub.tree:null);

                        root_0 = this.adaptor.nil();
                        // 150:64: -> ^( SUB_FILTER_FACTOR $o $ops $sub)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:150:67: ^( SUB_FILTER_FACTOR $o $ops $sub)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SUB_FILTER_FACTOR, "SUB_FILTER_FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_sub.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:152:11: ( (ops= IS | ops= ISNT ) (longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:152:11: ( (ops= IS | ops= ISNT ) (longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:152:12: (ops= IS | ops= ISNT ) (longVal= STRING_LITERAL | longVal= UNKNOWN )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:152:12: (ops= IS | ops= ISNT )
                        var alt29=2;
                        var LA29_0 = this.input.LA(1);

                        if ( (LA29_0==IS) ) {
                            alt29=1;
                        }
                        else if ( (LA29_0==ISNT) ) {
                            alt29=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 29, 0, this.input);

                            throw nvae;
                        }
                        switch (alt29) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:152:14: ops= IS
                                ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_interactionIdFactor1791);
                                stream_IS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:152:25: ops= ISNT
                                ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_interactionIdFactor1799);
                                stream_ISNT.add(ops);



                                break;

                        }

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:152:37: (longVal= STRING_LITERAL | longVal= UNKNOWN )
                        var alt30=2;
                        var LA30_0 = this.input.LA(1);

                        if ( (LA30_0==STRING_LITERAL) ) {
                            alt30=1;
                        }
                        else if ( (LA30_0==UNKNOWN) ) {
                            alt30=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 30, 0, this.input);

                            throw nvae;
                        }
                        switch (alt30) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:152:39: longVal= STRING_LITERAL
                                longVal=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_interactionIdFactor1806);
                                stream_STRING_LITERAL.add(longVal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:152:64: longVal= UNKNOWN
                                longVal=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_interactionIdFactor1812);
                                stream_UNKNOWN.add(longVal);



                                break;

                        }



                        // AST REWRITE
                        // elements: longVal, ops, o
                        // token labels: longVal, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_longVal=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token longVal",longVal);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 152:82: -> ^( FACTOR $o $ops $longVal)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:152:85: ^( FACTOR $o $ops $longVal)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_longVal.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;

                }







                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        mentionIdFactor_return: (function() {
            MentionQAst.mentionIdFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.mentionIdFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:156:1: mentionIdFactor : ( (o= MENTION_ID | o= CONVERSATION_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) ) | ( (ops= IS | ops= ISNT | ops= GREATERTHAN | ops= LESSTHAN | ops= GREATERTHANEQUALS | ops= LESSTHANEQUALS ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL ) -> ^( FACTOR $o $ops $longVal) ) ) ) ;
        // $ANTLR start "mentionIdFactor"
        mentionIdFactor: function() {
            var retval = new MentionQAst.mentionIdFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var longVal = null;
            var LPAREN55 = null;
            var RPAREN56 = null;
            var lit = null;
            var sub = null;

            var o_tree=null;
            var ops_tree=null;
            var longVal_tree=null;
            var LPAREN55_tree=null;
            var RPAREN56_tree=null;
            var stream_RPAREN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RPAREN");
            var stream_LESSTHAN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LESSTHAN");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_MENTION_ID=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token MENTION_ID");
            var stream_IN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IN");
            var stream_LESSTHANEQUALS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LESSTHANEQUALS");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_GREATERTHANEQUALS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token GREATERTHANEQUALS");
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_LONG_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LONG_LITERAL");
            var stream_CONVERSATION_ID=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CONVERSATION_ID");
            var stream_LPAREN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LPAREN");
            var stream_GREATERTHAN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token GREATERTHAN");
            var stream_NOTIN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token NOTIN");
            var stream_expression=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule expression");
            var stream_longOrStringIdSet=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule longOrStringIdSet");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:157:5: ( ( (o= MENTION_ID | o= CONVERSATION_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) ) | ( (ops= IS | ops= ISNT | ops= GREATERTHAN | ops= LESSTHAN | ops= GREATERTHANEQUALS | ops= LESSTHANEQUALS ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL ) -> ^( FACTOR $o $ops $longVal) ) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:157:9: ( (o= MENTION_ID | o= CONVERSATION_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) ) | ( (ops= IS | ops= ISNT | ops= GREATERTHAN | ops= LESSTHAN | ops= GREATERTHANEQUALS | ops= LESSTHANEQUALS ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL ) -> ^( FACTOR $o $ops $longVal) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:157:9: ( (o= MENTION_ID | o= CONVERSATION_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) ) | ( (ops= IS | ops= ISNT | ops= GREATERTHAN | ops= LESSTHAN | ops= GREATERTHANEQUALS | ops= LESSTHANEQUALS ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL ) -> ^( FACTOR $o $ops $longVal) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:157:11: (o= MENTION_ID | o= CONVERSATION_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) ) | ( (ops= IS | ops= ISNT | ops= GREATERTHAN | ops= LESSTHAN | ops= GREATERTHANEQUALS | ops= LESSTHANEQUALS ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL ) -> ^( FACTOR $o $ops $longVal) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:157:11: (o= MENTION_ID | o= CONVERSATION_ID )
                var alt32=2;
                var LA32_0 = this.input.LA(1);

                if ( (LA32_0==MENTION_ID) ) {
                    alt32=1;
                }
                else if ( (LA32_0==CONVERSATION_ID) ) {
                    alt32=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 32, 0, this.input);

                    throw nvae;
                }
                switch (alt32) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:157:12: o= MENTION_ID
                        o=this.match(this.input,MENTION_ID,MentionQAst.FOLLOW_MENTION_ID_in_mentionIdFactor1865);
                        stream_MENTION_ID.add(o);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:157:27: o= CONVERSATION_ID
                        o=this.match(this.input,CONVERSATION_ID,MentionQAst.FOLLOW_CONVERSATION_ID_in_mentionIdFactor1871);
                        stream_CONVERSATION_ID.add(o);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:158:10: ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) ) | ( (ops= IS | ops= ISNT | ops= GREATERTHAN | ops= LESSTHAN | ops= GREATERTHANEQUALS | ops= LESSTHANEQUALS ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL ) -> ^( FACTOR $o $ops $longVal) ) )
                var alt37=3;
                switch ( this.input.LA(1) ) {
                    case IN:
                        var LA37_1 = this.input.LA(2);

                        if ( (LA37_1==ANNOTATION) ) {
                            alt37=1;
                        }
                        else if ( (LA37_1==LPAREN) ) {
                            var LA37_5 = this.input.LA(3);

                            if ( (LA37_5==LONG_LITERAL||LA37_5==STRING_LITERAL) ) {
                                alt37=1;
                            }
                            else if ( (LA37_5==RELEVANCY||LA37_5==BRAND||(LA37_5>=SENTIMENT && LA37_5<=ACTION)||LA37_5==PROCESS||LA37_5==PHRASE||LA37_5==PHRASE_COUNT||(LA37_5>=FEED && LA37_5<=TITLE)||(LA37_5>=LINK && LA37_5<=CONTENT)||(LA37_5>=LANGUAGE && LA37_5<=PAGE_RANK)||(LA37_5>=ALEXA_RANK && LA37_5<=COUNTRY)||(LA37_5>=CITY && LA37_5<=SENTIMENT_VERIFIED)||(LA37_5>=CROWD_VERIFIED && LA37_5<=FOLLOWING_COUNT)||(LA37_5>=GENDER && LA37_5<=UCN)||LA37_5==SAMPLE||LA37_5==LPAREN) ) {
                                alt37=2;
                            }
                            else {
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 37, 5, this.input);

                                throw nvae;
                            }
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 37, 1, this.input);

                            throw nvae;
                        }
                        break;
                    case NOTIN:
                        var LA37_2 = this.input.LA(2);

                        if ( (LA37_2==ANNOTATION) ) {
                            alt37=1;
                        }
                        else if ( (LA37_2==LPAREN) ) {
                            var LA37_5 = this.input.LA(3);

                            if ( (LA37_5==LONG_LITERAL||LA37_5==STRING_LITERAL) ) {
                                alt37=1;
                            }
                            else if ( (LA37_5==RELEVANCY||LA37_5==BRAND||(LA37_5>=SENTIMENT && LA37_5<=ACTION)||LA37_5==PROCESS||LA37_5==PHRASE||LA37_5==PHRASE_COUNT||(LA37_5>=FEED && LA37_5<=TITLE)||(LA37_5>=LINK && LA37_5<=CONTENT)||(LA37_5>=LANGUAGE && LA37_5<=PAGE_RANK)||(LA37_5>=ALEXA_RANK && LA37_5<=COUNTRY)||(LA37_5>=CITY && LA37_5<=SENTIMENT_VERIFIED)||(LA37_5>=CROWD_VERIFIED && LA37_5<=FOLLOWING_COUNT)||(LA37_5>=GENDER && LA37_5<=UCN)||LA37_5==SAMPLE||LA37_5==LPAREN) ) {
                                alt37=2;
                            }
                            else {
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 37, 5, this.input);

                                throw nvae;
                            }
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 37, 2, this.input);

                            throw nvae;
                        }
                        break;
                    case IS:
                    case ISNT:
                    case GREATERTHAN:
                    case GREATERTHANEQUALS:
                    case LESSTHAN:
                    case LESSTHANEQUALS:
                        alt37=3;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 37, 0, this.input);

                        throw nvae;
                }

                switch (alt37) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:159:11: ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:159:11: ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:159:12: (ops= IN | ops= NOTIN ) lit= longOrStringIdSet
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:159:12: (ops= IN | ops= NOTIN )
                        var alt33=2;
                        var LA33_0 = this.input.LA(1);

                        if ( (LA33_0==IN) ) {
                            alt33=1;
                        }
                        else if ( (LA33_0==NOTIN) ) {
                            alt33=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 33, 0, this.input);

                            throw nvae;
                        }
                        switch (alt33) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:159:14: ops= IN
                                ops=this.match(this.input,IN,MentionQAst.FOLLOW_IN_in_mentionIdFactor1900);
                                stream_IN.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:159:23: ops= NOTIN
                                ops=this.match(this.input,NOTIN,MentionQAst.FOLLOW_NOTIN_in_mentionIdFactor1906);
                                stream_NOTIN.add(ops);



                                break;

                        }

                        this.pushFollow(MentionQAst.FOLLOW_longOrStringIdSet_in_mentionIdFactor1912);
                        lit=this.longOrStringIdSet();

                        this.state._fsp--;

                        stream_longOrStringIdSet.add(lit.getTree());


                        // AST REWRITE
                        // elements: ops, o, lit
                        // token labels: o, ops
                        // rule labels: lit, retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_lit=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit",lit!=null?lit.tree:null);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 159:57: -> ^( SET_MENTION_ID_FACTOR $o $ops $lit)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:159:60: ^( SET_MENTION_ID_FACTOR $o $ops $lit)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SET_MENTION_ID_FACTOR, "SET_MENTION_ID_FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:161:11: ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:161:11: ( (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN -> ^( SUB_FILTER_FACTOR $o $ops $sub) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:161:12: (ops= IN | ops= NOTIN ) LPAREN sub= expression RPAREN
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:161:12: (ops= IN | ops= NOTIN )
                        var alt34=2;
                        var LA34_0 = this.input.LA(1);

                        if ( (LA34_0==IN) ) {
                            alt34=1;
                        }
                        else if ( (LA34_0==NOTIN) ) {
                            alt34=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 34, 0, this.input);

                            throw nvae;
                        }
                        switch (alt34) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:161:14: ops= IN
                                ops=this.match(this.input,IN,MentionQAst.FOLLOW_IN_in_mentionIdFactor1957);
                                stream_IN.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:161:23: ops= NOTIN
                                ops=this.match(this.input,NOTIN,MentionQAst.FOLLOW_NOTIN_in_mentionIdFactor1963);
                                stream_NOTIN.add(ops);



                                break;

                        }

                        LPAREN55=this.match(this.input,LPAREN,MentionQAst.FOLLOW_LPAREN_in_mentionIdFactor1967);
                        stream_LPAREN.add(LPAREN55);

                        this.pushFollow(MentionQAst.FOLLOW_expression_in_mentionIdFactor1971);
                        sub=this.expression();

                        this.state._fsp--;

                        stream_expression.add(sub.getTree());
                        RPAREN56=this.match(this.input,RPAREN,MentionQAst.FOLLOW_RPAREN_in_mentionIdFactor1973);
                        stream_RPAREN.add(RPAREN56);



                        // AST REWRITE
                        // elements: sub, o, ops
                        // token labels: o, ops
                        // rule labels: retval, sub
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);
                        var stream_sub=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token sub",sub!=null?sub.tree:null);

                        root_0 = this.adaptor.nil();
                        // 161:64: -> ^( SUB_FILTER_FACTOR $o $ops $sub)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:161:67: ^( SUB_FILTER_FACTOR $o $ops $sub)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SUB_FILTER_FACTOR, "SUB_FILTER_FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_sub.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:11: ( (ops= IS | ops= ISNT | ops= GREATERTHAN | ops= LESSTHAN | ops= GREATERTHANEQUALS | ops= LESSTHANEQUALS ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL ) -> ^( FACTOR $o $ops $longVal) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:11: ( (ops= IS | ops= ISNT | ops= GREATERTHAN | ops= LESSTHAN | ops= GREATERTHANEQUALS | ops= LESSTHANEQUALS ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL ) -> ^( FACTOR $o $ops $longVal) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:12: (ops= IS | ops= ISNT | ops= GREATERTHAN | ops= LESSTHAN | ops= GREATERTHANEQUALS | ops= LESSTHANEQUALS ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:12: (ops= IS | ops= ISNT | ops= GREATERTHAN | ops= LESSTHAN | ops= GREATERTHANEQUALS | ops= LESSTHANEQUALS )
                        var alt35=6;
                        switch ( this.input.LA(1) ) {
                            case IS:
                                alt35=1;
                                break;
                            case ISNT:
                                alt35=2;
                                break;
                            case GREATERTHAN:
                                alt35=3;
                                break;
                            case LESSTHAN:
                                alt35=4;
                                break;
                            case GREATERTHANEQUALS:
                                alt35=5;
                                break;
                            case LESSTHANEQUALS:
                                alt35=6;
                                break;
                            default:
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 35, 0, this.input);

                                throw nvae;
                        }

                        switch (alt35) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:14: ops= IS
                                ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_mentionIdFactor2020);
                                stream_IS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:25: ops= ISNT
                                ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_mentionIdFactor2028);
                                stream_ISNT.add(ops);



                                break;
                            case 3 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:38: ops= GREATERTHAN
                                ops=this.match(this.input,GREATERTHAN,MentionQAst.FOLLOW_GREATERTHAN_in_mentionIdFactor2036);
                                stream_GREATERTHAN.add(ops);



                                break;
                            case 4 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:58: ops= LESSTHAN
                                ops=this.match(this.input,LESSTHAN,MentionQAst.FOLLOW_LESSTHAN_in_mentionIdFactor2044);
                                stream_LESSTHAN.add(ops);



                                break;
                            case 5 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:75: ops= GREATERTHANEQUALS
                                ops=this.match(this.input,GREATERTHANEQUALS,MentionQAst.FOLLOW_GREATERTHANEQUALS_in_mentionIdFactor2052);
                                stream_GREATERTHANEQUALS.add(ops);



                                break;
                            case 6 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:101: ops= LESSTHANEQUALS
                                ops=this.match(this.input,LESSTHANEQUALS,MentionQAst.FOLLOW_LESSTHANEQUALS_in_mentionIdFactor2060);
                                stream_LESSTHANEQUALS.add(ops);



                                break;

                        }

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:123: (longVal= LONG_LITERAL | longVal= STRING_LITERAL )
                        var alt36=2;
                        var LA36_0 = this.input.LA(1);

                        if ( (LA36_0==LONG_LITERAL) ) {
                            alt36=1;
                        }
                        else if ( (LA36_0==STRING_LITERAL) ) {
                            alt36=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 36, 0, this.input);

                            throw nvae;
                        }
                        switch (alt36) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:125: longVal= LONG_LITERAL
                                longVal=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_mentionIdFactor2067);
                                stream_LONG_LITERAL.add(longVal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:148: longVal= STRING_LITERAL
                                longVal=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_mentionIdFactor2073);
                                stream_STRING_LITERAL.add(longVal);



                                break;

                        }



                        // AST REWRITE
                        // elements: longVal, o, ops
                        // token labels: longVal, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_longVal=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token longVal",longVal);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 163:174: -> ^( FACTOR $o $ops $longVal)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:163:177: ^( FACTOR $o $ops $longVal)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_longVal.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;

                }







                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        longOrStringIdSet_return: (function() {
            MentionQAst.longOrStringIdSet_return = function(){};
            org.antlr.lang.extend(MentionQAst.longOrStringIdSet_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:168:1: longOrStringIdSet : ( ANNOTATION )? LPAREN ( LONG_LITERAL | STRING_LITERAL ) ( COMMA ( LONG_LITERAL | STRING_LITERAL ) )* RPAREN ;
        // $ANTLR start "longOrStringIdSet"
        longOrStringIdSet: function() {
            var retval = new MentionQAst.longOrStringIdSet_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var ANNOTATION57 = null;
            var LPAREN58 = null;
            var set59 = null;
            var COMMA60 = null;
            var set61 = null;
            var RPAREN62 = null;

            var ANNOTATION57_tree=null;
            var LPAREN58_tree=null;
            var set59_tree=null;
            var COMMA60_tree=null;
            var set61_tree=null;
            var RPAREN62_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:169:5: ( ( ANNOTATION )? LPAREN ( LONG_LITERAL | STRING_LITERAL ) ( COMMA ( LONG_LITERAL | STRING_LITERAL ) )* RPAREN )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:169:8: ( ANNOTATION )? LPAREN ( LONG_LITERAL | STRING_LITERAL ) ( COMMA ( LONG_LITERAL | STRING_LITERAL ) )* RPAREN
                root_0 = this.adaptor.nil();

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:169:8: ( ANNOTATION )?
                var alt38=2;
                var LA38_0 = this.input.LA(1);

                if ( (LA38_0==ANNOTATION) ) {
                    alt38=1;
                }
                switch (alt38) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:169:9: ANNOTATION
                        ANNOTATION57=this.match(this.input,ANNOTATION,MentionQAst.FOLLOW_ANNOTATION_in_longOrStringIdSet2133);
                        ANNOTATION57_tree = this.adaptor.create(ANNOTATION57);
                        this.adaptor.addChild(root_0, ANNOTATION57_tree);



                        break;

                }

                LPAREN58=this.match(this.input,LPAREN,MentionQAst.FOLLOW_LPAREN_in_longOrStringIdSet2137);
                set59=this.input.LT(1);
                if ( this.input.LA(1)==LONG_LITERAL||this.input.LA(1)==STRING_LITERAL ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set59));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:169:64: ( COMMA ( LONG_LITERAL | STRING_LITERAL ) )*
                loop39:
                    do {
                        var alt39=2;
                        var LA39_0 = this.input.LA(1);

                        if ( (LA39_0==COMMA) ) {
                            alt39=1;
                        }


                        switch (alt39) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:169:66: COMMA ( LONG_LITERAL | STRING_LITERAL )
                                COMMA60=this.match(this.input,COMMA,MentionQAst.FOLLOW_COMMA_in_longOrStringIdSet2152);
                                set61=this.input.LT(1);
                                if ( this.input.LA(1)==LONG_LITERAL||this.input.LA(1)==STRING_LITERAL ) {
                                    this.input.consume();
                                    this.adaptor.addChild(root_0, this.adaptor.create(set61));
                                    this.state.errorRecovery=false;
                                }
                                else {
                                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                                    throw mse;
                                }



                                break;

                            default :
                                break loop39;
                        }
                    } while (true);

                RPAREN62=this.match(this.input,RPAREN,MentionQAst.FOLLOW_RPAREN_in_longOrStringIdSet2169);



                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        authorIdFactor_return: (function() {
            MentionQAst.authorIdFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.authorIdFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:172:1: authorIdFactor : ( (o= AUTHOR_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) ) ) ;
        // $ANTLR start "authorIdFactor"
        authorIdFactor: function() {
            var retval = new MentionQAst.authorIdFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var longVal = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var longVal_tree=null;
            var stream_AUTHOR_ID=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AUTHOR_ID");
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_IN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IN");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_LONG_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LONG_LITERAL");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_NOTIN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token NOTIN");
            var stream_longOrStringIdSet=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule longOrStringIdSet");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:173:5: ( ( (o= AUTHOR_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:173:9: ( (o= AUTHOR_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:173:9: ( (o= AUTHOR_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:173:11: (o= AUTHOR_ID ) ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:173:11: (o= AUTHOR_ID )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:173:12: o= AUTHOR_ID
                o=this.match(this.input,AUTHOR_ID,MentionQAst.FOLLOW_AUTHOR_ID_in_authorIdFactor2194);
                stream_AUTHOR_ID.add(o);




                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:174:10: ( ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) ) | ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) ) )
                var alt43=2;
                var LA43_0 = this.input.LA(1);

                if ( ((LA43_0>=IN && LA43_0<=NOTIN)) ) {
                    alt43=1;
                }
                else if ( ((LA43_0>=IS && LA43_0<=ISNT)) ) {
                    alt43=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 43, 0, this.input);

                    throw nvae;
                }
                switch (alt43) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:174:11: ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:174:11: ( (ops= IN | ops= NOTIN ) lit= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:174:12: (ops= IN | ops= NOTIN ) lit= longOrStringIdSet
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:174:12: (ops= IN | ops= NOTIN )
                        var alt40=2;
                        var LA40_0 = this.input.LA(1);

                        if ( (LA40_0==IN) ) {
                            alt40=1;
                        }
                        else if ( (LA40_0==NOTIN) ) {
                            alt40=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 40, 0, this.input);

                            throw nvae;
                        }
                        switch (alt40) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:174:14: ops= IN
                                ops=this.match(this.input,IN,MentionQAst.FOLLOW_IN_in_authorIdFactor2212);
                                stream_IN.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:174:23: ops= NOTIN
                                ops=this.match(this.input,NOTIN,MentionQAst.FOLLOW_NOTIN_in_authorIdFactor2218);
                                stream_NOTIN.add(ops);



                                break;

                        }

                        this.pushFollow(MentionQAst.FOLLOW_longOrStringIdSet_in_authorIdFactor2224);
                        lit=this.longOrStringIdSet();

                        this.state._fsp--;

                        stream_longOrStringIdSet.add(lit.getTree());


                        // AST REWRITE
                        // elements: o, lit, ops
                        // token labels: o, ops
                        // rule labels: lit, retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_lit=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit",lit!=null?lit.tree:null);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 174:57: -> ^( SET_MENTION_ID_FACTOR $o $ops $lit)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:174:60: ^( SET_MENTION_ID_FACTOR $o $ops $lit)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SET_MENTION_ID_FACTOR, "SET_MENTION_ID_FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:176:11: ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:176:11: ( (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL | longVal= UNKNOWN ) -> ^( FACTOR $o $ops $longVal) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:176:12: (ops= IS | ops= ISNT ) (longVal= LONG_LITERAL | longVal= STRING_LITERAL | longVal= UNKNOWN )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:176:12: (ops= IS | ops= ISNT )
                        var alt41=2;
                        var LA41_0 = this.input.LA(1);

                        if ( (LA41_0==IS) ) {
                            alt41=1;
                        }
                        else if ( (LA41_0==ISNT) ) {
                            alt41=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 41, 0, this.input);

                            throw nvae;
                        }
                        switch (alt41) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:176:14: ops= IS
                                ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_authorIdFactor2271);
                                stream_IS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:176:25: ops= ISNT
                                ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_authorIdFactor2279);
                                stream_ISNT.add(ops);



                                break;

                        }

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:176:37: (longVal= LONG_LITERAL | longVal= STRING_LITERAL | longVal= UNKNOWN )
                        var alt42=3;
                        switch ( this.input.LA(1) ) {
                            case LONG_LITERAL:
                                alt42=1;
                                break;
                            case STRING_LITERAL:
                                alt42=2;
                                break;
                            case UNKNOWN:
                                alt42=3;
                                break;
                            default:
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 42, 0, this.input);

                                throw nvae;
                        }

                        switch (alt42) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:176:39: longVal= LONG_LITERAL
                                longVal=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_authorIdFactor2286);
                                stream_LONG_LITERAL.add(longVal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:176:62: longVal= STRING_LITERAL
                                longVal=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_authorIdFactor2292);
                                stream_STRING_LITERAL.add(longVal);



                                break;
                            case 3 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:176:87: longVal= UNKNOWN
                                longVal=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_authorIdFactor2298);
                                stream_UNKNOWN.add(longVal);



                                break;

                        }



                        // AST REWRITE
                        // elements: longVal, ops, o
                        // token labels: longVal, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_longVal=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token longVal",longVal);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 176:106: -> ^( FACTOR $o $ops $longVal)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:176:109: ^( FACTOR $o $ops $longVal)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_longVal.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;

                }







                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalTreeLongFactor_return: (function() {
            MentionQAst.generalTreeLongFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalTreeLongFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:179:1: generalTreeLongFactor : o= BRAND (ops= IS | ops= ISNT | ops= ISORCHILDOF | ops= ISNTNORCHILDOF ) lit= LONG_LITERAL -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "generalTreeLongFactor"
        generalTreeLongFactor: function() {
            var retval = new MentionQAst.generalTreeLongFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_LONG_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LONG_LITERAL");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_ISORCHILDOF=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISORCHILDOF");
            var stream_BRAND=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token BRAND");
            var stream_ISNTNORCHILDOF=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNTNORCHILDOF");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:180:5: (o= BRAND (ops= IS | ops= ISNT | ops= ISORCHILDOF | ops= ISNTNORCHILDOF ) lit= LONG_LITERAL -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:180:9: o= BRAND (ops= IS | ops= ISNT | ops= ISORCHILDOF | ops= ISNTNORCHILDOF ) lit= LONG_LITERAL
                o=this.match(this.input,BRAND,MentionQAst.FOLLOW_BRAND_in_generalTreeLongFactor2340);
                stream_BRAND.add(o);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:180:17: (ops= IS | ops= ISNT | ops= ISORCHILDOF | ops= ISNTNORCHILDOF )
                var alt44=4;
                switch ( this.input.LA(1) ) {
                    case IS:
                        alt44=1;
                        break;
                    case ISNT:
                        alt44=2;
                        break;
                    case ISORCHILDOF:
                        alt44=3;
                        break;
                    case ISNTNORCHILDOF:
                        alt44=4;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 44, 0, this.input);

                        throw nvae;
                }

                switch (alt44) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:180:19: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_generalTreeLongFactor2346);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:180:28: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_generalTreeLongFactor2352);
                        stream_ISNT.add(ops);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:180:39: ops= ISORCHILDOF
                        ops=this.match(this.input,ISORCHILDOF,MentionQAst.FOLLOW_ISORCHILDOF_in_generalTreeLongFactor2358);
                        stream_ISORCHILDOF.add(ops);



                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:180:57: ops= ISNTNORCHILDOF
                        ops=this.match(this.input,ISNTNORCHILDOF,MentionQAst.FOLLOW_ISNTNORCHILDOF_in_generalTreeLongFactor2364);
                        stream_ISNTNORCHILDOF.add(ops);



                        break;

                }

                lit=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_generalTreeLongFactor2370);
                stream_LONG_LITERAL.add(lit);



                // AST REWRITE
                // elements: lit, o, ops
                // token labels: lit, o, ops
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 181:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:181:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalComparisonLongFactor_return: (function() {
            MentionQAst.generalComparisonLongFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalComparisonLongFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:185:1: generalComparisonLongFactor : ( (o= SENTIMENT | o= CREDIBILITY | o= PAGE_RANK | o= ALEXA_RANK | o= PHRASE_MATCHES | o= AVE | o= OTS | o= ENGAGEMENT | o= REPLY_COUNT | o= GRAPH_REPLY_COUNT | o= RESHARE_COUNT | o= GRAPH_RESHARE_COUNT | o= REACH | o= PHRASE_COUNT | o= STATUS_COUNT | o= FOLLOWER_COUNT | o= GRAPH_FOLLOWER_COUNT | o= FOLLOWING_COUNT | o= RESPONSE_TIME | o= REPLY_ORDER_BY_AUTHOR | o= INTERACTION_FIRST_RESPONSE_TIME | o= INTERACTION_FOLLOWUP_RESPONSE_TIME | o= INTERACTION_RESPONSE_TIME | o= INTERACTION_WH_FIRST_RESPONSE_TIME | o= INTERACTION_WH_FOLLOWUP_RESPONSE_TIME | o= INTERACTION_WH_RESPONSE_TIME ) ( ( (ops= EQUALS | ops= NOTEQUALS | ops= LESSTHAN | ops= LESSTHANEQUALS | ops= GREATERTHAN | ops= GREATERTHANEQUALS ) lit= LONG_LITERAL ) | ( (ops= IS | ops= ISNT ) lit= UNKNOWN ) ) ) -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "generalComparisonLongFactor"
        generalComparisonLongFactor: function() {
            var retval = new MentionQAst.generalComparisonLongFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_INTERACTION_WH_FIRST_RESPONSE_TIME=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTERACTION_WH_FIRST_RESPONSE_TIME");
            var stream_REPLY_ORDER_BY_AUTHOR=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token REPLY_ORDER_BY_AUTHOR");
            var stream_LESSTHAN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LESSTHAN");
            var stream_REACH=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token REACH");
            var stream_INTERACTION_FIRST_RESPONSE_TIME=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTERACTION_FIRST_RESPONSE_TIME");
            var stream_INTERACTION_WH_FOLLOWUP_RESPONSE_TIME=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTERACTION_WH_FOLLOWUP_RESPONSE_TIME");
            var stream_REPLY_COUNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token REPLY_COUNT");
            var stream_LESSTHANEQUALS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LESSTHANEQUALS");
            var stream_OTS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token OTS");
            var stream_SENTIMENT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token SENTIMENT");
            var stream_ENGAGEMENT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ENGAGEMENT");
            var stream_INTERACTION_RESPONSE_TIME=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTERACTION_RESPONSE_TIME");
            var stream_NOTEQUALS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token NOTEQUALS");
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_EQUALS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token EQUALS");
            var stream_RESPONSE_TIME=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RESPONSE_TIME");
            var stream_INTERACTION_FOLLOWUP_RESPONSE_TIME=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTERACTION_FOLLOWUP_RESPONSE_TIME");
            var stream_LONG_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LONG_LITERAL");
            var stream_ALEXA_RANK=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ALEXA_RANK");
            var stream_CREDIBILITY=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CREDIBILITY");
            var stream_FOLLOWING_COUNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token FOLLOWING_COUNT");
            var stream_GRAPH_RESHARE_COUNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token GRAPH_RESHARE_COUNT");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_INTERACTION_WH_RESPONSE_TIME=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTERACTION_WH_RESPONSE_TIME");
            var stream_AVE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AVE");
            var stream_PHRASE_COUNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token PHRASE_COUNT");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_GRAPH_REPLY_COUNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token GRAPH_REPLY_COUNT");
            var stream_GREATERTHANEQUALS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token GREATERTHANEQUALS");
            var stream_GRAPH_FOLLOWER_COUNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token GRAPH_FOLLOWER_COUNT");
            var stream_FOLLOWER_COUNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token FOLLOWER_COUNT");
            var stream_STATUS_COUNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STATUS_COUNT");
            var stream_RESHARE_COUNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RESHARE_COUNT");
            var stream_PAGE_RANK=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token PAGE_RANK");
            var stream_PHRASE_MATCHES=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token PHRASE_MATCHES");
            var stream_GREATERTHAN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token GREATERTHAN");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:5: ( ( (o= SENTIMENT | o= CREDIBILITY | o= PAGE_RANK | o= ALEXA_RANK | o= PHRASE_MATCHES | o= AVE | o= OTS | o= ENGAGEMENT | o= REPLY_COUNT | o= GRAPH_REPLY_COUNT | o= RESHARE_COUNT | o= GRAPH_RESHARE_COUNT | o= REACH | o= PHRASE_COUNT | o= STATUS_COUNT | o= FOLLOWER_COUNT | o= GRAPH_FOLLOWER_COUNT | o= FOLLOWING_COUNT | o= RESPONSE_TIME | o= REPLY_ORDER_BY_AUTHOR | o= INTERACTION_FIRST_RESPONSE_TIME | o= INTERACTION_FOLLOWUP_RESPONSE_TIME | o= INTERACTION_RESPONSE_TIME | o= INTERACTION_WH_FIRST_RESPONSE_TIME | o= INTERACTION_WH_FOLLOWUP_RESPONSE_TIME | o= INTERACTION_WH_RESPONSE_TIME ) ( ( (ops= EQUALS | ops= NOTEQUALS | ops= LESSTHAN | ops= LESSTHANEQUALS | ops= GREATERTHAN | ops= GREATERTHANEQUALS ) lit= LONG_LITERAL ) | ( (ops= IS | ops= ISNT ) lit= UNKNOWN ) ) ) -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:9: ( (o= SENTIMENT | o= CREDIBILITY | o= PAGE_RANK | o= ALEXA_RANK | o= PHRASE_MATCHES | o= AVE | o= OTS | o= ENGAGEMENT | o= REPLY_COUNT | o= GRAPH_REPLY_COUNT | o= RESHARE_COUNT | o= GRAPH_RESHARE_COUNT | o= REACH | o= PHRASE_COUNT | o= STATUS_COUNT | o= FOLLOWER_COUNT | o= GRAPH_FOLLOWER_COUNT | o= FOLLOWING_COUNT | o= RESPONSE_TIME | o= REPLY_ORDER_BY_AUTHOR | o= INTERACTION_FIRST_RESPONSE_TIME | o= INTERACTION_FOLLOWUP_RESPONSE_TIME | o= INTERACTION_RESPONSE_TIME | o= INTERACTION_WH_FIRST_RESPONSE_TIME | o= INTERACTION_WH_FOLLOWUP_RESPONSE_TIME | o= INTERACTION_WH_RESPONSE_TIME ) ( ( (ops= EQUALS | ops= NOTEQUALS | ops= LESSTHAN | ops= LESSTHANEQUALS | ops= GREATERTHAN | ops= GREATERTHANEQUALS ) lit= LONG_LITERAL ) | ( (ops= IS | ops= ISNT ) lit= UNKNOWN ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:9: ( (o= SENTIMENT | o= CREDIBILITY | o= PAGE_RANK | o= ALEXA_RANK | o= PHRASE_MATCHES | o= AVE | o= OTS | o= ENGAGEMENT | o= REPLY_COUNT | o= GRAPH_REPLY_COUNT | o= RESHARE_COUNT | o= GRAPH_RESHARE_COUNT | o= REACH | o= PHRASE_COUNT | o= STATUS_COUNT | o= FOLLOWER_COUNT | o= GRAPH_FOLLOWER_COUNT | o= FOLLOWING_COUNT | o= RESPONSE_TIME | o= REPLY_ORDER_BY_AUTHOR | o= INTERACTION_FIRST_RESPONSE_TIME | o= INTERACTION_FOLLOWUP_RESPONSE_TIME | o= INTERACTION_RESPONSE_TIME | o= INTERACTION_WH_FIRST_RESPONSE_TIME | o= INTERACTION_WH_FOLLOWUP_RESPONSE_TIME | o= INTERACTION_WH_RESPONSE_TIME ) ( ( (ops= EQUALS | ops= NOTEQUALS | ops= LESSTHAN | ops= LESSTHANEQUALS | ops= GREATERTHAN | ops= GREATERTHANEQUALS ) lit= LONG_LITERAL ) | ( (ops= IS | ops= ISNT ) lit= UNKNOWN ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:10: (o= SENTIMENT | o= CREDIBILITY | o= PAGE_RANK | o= ALEXA_RANK | o= PHRASE_MATCHES | o= AVE | o= OTS | o= ENGAGEMENT | o= REPLY_COUNT | o= GRAPH_REPLY_COUNT | o= RESHARE_COUNT | o= GRAPH_RESHARE_COUNT | o= REACH | o= PHRASE_COUNT | o= STATUS_COUNT | o= FOLLOWER_COUNT | o= GRAPH_FOLLOWER_COUNT | o= FOLLOWING_COUNT | o= RESPONSE_TIME | o= REPLY_ORDER_BY_AUTHOR | o= INTERACTION_FIRST_RESPONSE_TIME | o= INTERACTION_FOLLOWUP_RESPONSE_TIME | o= INTERACTION_RESPONSE_TIME | o= INTERACTION_WH_FIRST_RESPONSE_TIME | o= INTERACTION_WH_FOLLOWUP_RESPONSE_TIME | o= INTERACTION_WH_RESPONSE_TIME ) ( ( (ops= EQUALS | ops= NOTEQUALS | ops= LESSTHAN | ops= LESSTHANEQUALS | ops= GREATERTHAN | ops= GREATERTHANEQUALS ) lit= LONG_LITERAL ) | ( (ops= IS | ops= ISNT ) lit= UNKNOWN ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:10: (o= SENTIMENT | o= CREDIBILITY | o= PAGE_RANK | o= ALEXA_RANK | o= PHRASE_MATCHES | o= AVE | o= OTS | o= ENGAGEMENT | o= REPLY_COUNT | o= GRAPH_REPLY_COUNT | o= RESHARE_COUNT | o= GRAPH_RESHARE_COUNT | o= REACH | o= PHRASE_COUNT | o= STATUS_COUNT | o= FOLLOWER_COUNT | o= GRAPH_FOLLOWER_COUNT | o= FOLLOWING_COUNT | o= RESPONSE_TIME | o= REPLY_ORDER_BY_AUTHOR | o= INTERACTION_FIRST_RESPONSE_TIME | o= INTERACTION_FOLLOWUP_RESPONSE_TIME | o= INTERACTION_RESPONSE_TIME | o= INTERACTION_WH_FIRST_RESPONSE_TIME | o= INTERACTION_WH_FOLLOWUP_RESPONSE_TIME | o= INTERACTION_WH_RESPONSE_TIME )
                var alt45=26;
                switch ( this.input.LA(1) ) {
                    case SENTIMENT:
                        alt45=1;
                        break;
                    case CREDIBILITY:
                        alt45=2;
                        break;
                    case PAGE_RANK:
                        alt45=3;
                        break;
                    case ALEXA_RANK:
                        alt45=4;
                        break;
                    case PHRASE_MATCHES:
                        alt45=5;
                        break;
                    case AVE:
                        alt45=6;
                        break;
                    case OTS:
                        alt45=7;
                        break;
                    case ENGAGEMENT:
                        alt45=8;
                        break;
                    case REPLY_COUNT:
                        alt45=9;
                        break;
                    case GRAPH_REPLY_COUNT:
                        alt45=10;
                        break;
                    case RESHARE_COUNT:
                        alt45=11;
                        break;
                    case GRAPH_RESHARE_COUNT:
                        alt45=12;
                        break;
                    case REACH:
                        alt45=13;
                        break;
                    case PHRASE_COUNT:
                        alt45=14;
                        break;
                    case STATUS_COUNT:
                        alt45=15;
                        break;
                    case FOLLOWER_COUNT:
                        alt45=16;
                        break;
                    case GRAPH_FOLLOWER_COUNT:
                        alt45=17;
                        break;
                    case FOLLOWING_COUNT:
                        alt45=18;
                        break;
                    case RESPONSE_TIME:
                        alt45=19;
                        break;
                    case REPLY_ORDER_BY_AUTHOR:
                        alt45=20;
                        break;
                    case INTERACTION_FIRST_RESPONSE_TIME:
                        alt45=21;
                        break;
                    case INTERACTION_FOLLOWUP_RESPONSE_TIME:
                        alt45=22;
                        break;
                    case INTERACTION_RESPONSE_TIME:
                        alt45=23;
                        break;
                    case INTERACTION_WH_FIRST_RESPONSE_TIME:
                        alt45=24;
                        break;
                    case INTERACTION_WH_FOLLOWUP_RESPONSE_TIME:
                        alt45=25;
                        break;
                    case INTERACTION_WH_RESPONSE_TIME:
                        alt45=26;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 45, 0, this.input);

                        throw nvae;
                }

                switch (alt45) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:12: o= SENTIMENT
                        o=this.match(this.input,SENTIMENT,MentionQAst.FOLLOW_SENTIMENT_in_generalComparisonLongFactor2415);
                        stream_SENTIMENT.add(o);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:26: o= CREDIBILITY
                        o=this.match(this.input,CREDIBILITY,MentionQAst.FOLLOW_CREDIBILITY_in_generalComparisonLongFactor2421);
                        stream_CREDIBILITY.add(o);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:42: o= PAGE_RANK
                        o=this.match(this.input,PAGE_RANK,MentionQAst.FOLLOW_PAGE_RANK_in_generalComparisonLongFactor2427);
                        stream_PAGE_RANK.add(o);



                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:56: o= ALEXA_RANK
                        o=this.match(this.input,ALEXA_RANK,MentionQAst.FOLLOW_ALEXA_RANK_in_generalComparisonLongFactor2433);
                        stream_ALEXA_RANK.add(o);



                        break;
                    case 5 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:71: o= PHRASE_MATCHES
                        o=this.match(this.input,PHRASE_MATCHES,MentionQAst.FOLLOW_PHRASE_MATCHES_in_generalComparisonLongFactor2439);
                        stream_PHRASE_MATCHES.add(o);



                        break;
                    case 6 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:90: o= AVE
                        o=this.match(this.input,AVE,MentionQAst.FOLLOW_AVE_in_generalComparisonLongFactor2445);
                        stream_AVE.add(o);



                        break;
                    case 7 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:98: o= OTS
                        o=this.match(this.input,OTS,MentionQAst.FOLLOW_OTS_in_generalComparisonLongFactor2451);
                        stream_OTS.add(o);



                        break;
                    case 8 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:186:106: o= ENGAGEMENT
                        o=this.match(this.input,ENGAGEMENT,MentionQAst.FOLLOW_ENGAGEMENT_in_generalComparisonLongFactor2457);
                        stream_ENGAGEMENT.add(o);



                        break;
                    case 9 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:187:15: o= REPLY_COUNT
                        o=this.match(this.input,REPLY_COUNT,MentionQAst.FOLLOW_REPLY_COUNT_in_generalComparisonLongFactor2475);
                        stream_REPLY_COUNT.add(o);



                        break;
                    case 10 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:187:31: o= GRAPH_REPLY_COUNT
                        o=this.match(this.input,GRAPH_REPLY_COUNT,MentionQAst.FOLLOW_GRAPH_REPLY_COUNT_in_generalComparisonLongFactor2481);
                        stream_GRAPH_REPLY_COUNT.add(o);



                        break;
                    case 11 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:187:53: o= RESHARE_COUNT
                        o=this.match(this.input,RESHARE_COUNT,MentionQAst.FOLLOW_RESHARE_COUNT_in_generalComparisonLongFactor2487);
                        stream_RESHARE_COUNT.add(o);



                        break;
                    case 12 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:187:71: o= GRAPH_RESHARE_COUNT
                        o=this.match(this.input,GRAPH_RESHARE_COUNT,MentionQAst.FOLLOW_GRAPH_RESHARE_COUNT_in_generalComparisonLongFactor2493);
                        stream_GRAPH_RESHARE_COUNT.add(o);



                        break;
                    case 13 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:187:95: o= REACH
                        o=this.match(this.input,REACH,MentionQAst.FOLLOW_REACH_in_generalComparisonLongFactor2499);
                        stream_REACH.add(o);



                        break;
                    case 14 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:187:105: o= PHRASE_COUNT
                        o=this.match(this.input,PHRASE_COUNT,MentionQAst.FOLLOW_PHRASE_COUNT_in_generalComparisonLongFactor2505);
                        stream_PHRASE_COUNT.add(o);



                        break;
                    case 15 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:188:15: o= STATUS_COUNT
                        o=this.match(this.input,STATUS_COUNT,MentionQAst.FOLLOW_STATUS_COUNT_in_generalComparisonLongFactor2523);
                        stream_STATUS_COUNT.add(o);



                        break;
                    case 16 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:188:32: o= FOLLOWER_COUNT
                        o=this.match(this.input,FOLLOWER_COUNT,MentionQAst.FOLLOW_FOLLOWER_COUNT_in_generalComparisonLongFactor2529);
                        stream_FOLLOWER_COUNT.add(o);



                        break;
                    case 17 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:188:51: o= GRAPH_FOLLOWER_COUNT
                        o=this.match(this.input,GRAPH_FOLLOWER_COUNT,MentionQAst.FOLLOW_GRAPH_FOLLOWER_COUNT_in_generalComparisonLongFactor2535);
                        stream_GRAPH_FOLLOWER_COUNT.add(o);



                        break;
                    case 18 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:188:76: o= FOLLOWING_COUNT
                        o=this.match(this.input,FOLLOWING_COUNT,MentionQAst.FOLLOW_FOLLOWING_COUNT_in_generalComparisonLongFactor2541);
                        stream_FOLLOWING_COUNT.add(o);



                        break;
                    case 19 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:188:96: o= RESPONSE_TIME
                        o=this.match(this.input,RESPONSE_TIME,MentionQAst.FOLLOW_RESPONSE_TIME_in_generalComparisonLongFactor2547);
                        stream_RESPONSE_TIME.add(o);



                        break;
                    case 20 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:188:114: o= REPLY_ORDER_BY_AUTHOR
                        o=this.match(this.input,REPLY_ORDER_BY_AUTHOR,MentionQAst.FOLLOW_REPLY_ORDER_BY_AUTHOR_in_generalComparisonLongFactor2553);
                        stream_REPLY_ORDER_BY_AUTHOR.add(o);



                        break;
                    case 21 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:189:15: o= INTERACTION_FIRST_RESPONSE_TIME
                        o=this.match(this.input,INTERACTION_FIRST_RESPONSE_TIME,MentionQAst.FOLLOW_INTERACTION_FIRST_RESPONSE_TIME_in_generalComparisonLongFactor2571);
                        stream_INTERACTION_FIRST_RESPONSE_TIME.add(o);



                        break;
                    case 22 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:189:51: o= INTERACTION_FOLLOWUP_RESPONSE_TIME
                        o=this.match(this.input,INTERACTION_FOLLOWUP_RESPONSE_TIME,MentionQAst.FOLLOW_INTERACTION_FOLLOWUP_RESPONSE_TIME_in_generalComparisonLongFactor2577);
                        stream_INTERACTION_FOLLOWUP_RESPONSE_TIME.add(o);



                        break;
                    case 23 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:189:90: o= INTERACTION_RESPONSE_TIME
                        o=this.match(this.input,INTERACTION_RESPONSE_TIME,MentionQAst.FOLLOW_INTERACTION_RESPONSE_TIME_in_generalComparisonLongFactor2583);
                        stream_INTERACTION_RESPONSE_TIME.add(o);



                        break;
                    case 24 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:190:15: o= INTERACTION_WH_FIRST_RESPONSE_TIME
                        o=this.match(this.input,INTERACTION_WH_FIRST_RESPONSE_TIME,MentionQAst.FOLLOW_INTERACTION_WH_FIRST_RESPONSE_TIME_in_generalComparisonLongFactor2601);
                        stream_INTERACTION_WH_FIRST_RESPONSE_TIME.add(o);



                        break;
                    case 25 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:190:54: o= INTERACTION_WH_FOLLOWUP_RESPONSE_TIME
                        o=this.match(this.input,INTERACTION_WH_FOLLOWUP_RESPONSE_TIME,MentionQAst.FOLLOW_INTERACTION_WH_FOLLOWUP_RESPONSE_TIME_in_generalComparisonLongFactor2607);
                        stream_INTERACTION_WH_FOLLOWUP_RESPONSE_TIME.add(o);



                        break;
                    case 26 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:190:96: o= INTERACTION_WH_RESPONSE_TIME
                        o=this.match(this.input,INTERACTION_WH_RESPONSE_TIME,MentionQAst.FOLLOW_INTERACTION_WH_RESPONSE_TIME_in_generalComparisonLongFactor2613);
                        stream_INTERACTION_WH_RESPONSE_TIME.add(o);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:192:10: ( ( (ops= EQUALS | ops= NOTEQUALS | ops= LESSTHAN | ops= LESSTHANEQUALS | ops= GREATERTHAN | ops= GREATERTHANEQUALS ) lit= LONG_LITERAL ) | ( (ops= IS | ops= ISNT ) lit= UNKNOWN ) )
                var alt48=2;
                var LA48_0 = this.input.LA(1);

                if ( ((LA48_0>=GREATERTHAN && LA48_0<=NOTEQUALS)) ) {
                    alt48=1;
                }
                else if ( ((LA48_0>=IS && LA48_0<=ISNT)) ) {
                    alt48=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 48, 0, this.input);

                    throw nvae;
                }
                switch (alt48) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:192:11: ( (ops= EQUALS | ops= NOTEQUALS | ops= LESSTHAN | ops= LESSTHANEQUALS | ops= GREATERTHAN | ops= GREATERTHANEQUALS ) lit= LONG_LITERAL )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:192:11: ( (ops= EQUALS | ops= NOTEQUALS | ops= LESSTHAN | ops= LESSTHANEQUALS | ops= GREATERTHAN | ops= GREATERTHANEQUALS ) lit= LONG_LITERAL )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:192:12: (ops= EQUALS | ops= NOTEQUALS | ops= LESSTHAN | ops= LESSTHANEQUALS | ops= GREATERTHAN | ops= GREATERTHANEQUALS ) lit= LONG_LITERAL
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:192:12: (ops= EQUALS | ops= NOTEQUALS | ops= LESSTHAN | ops= LESSTHANEQUALS | ops= GREATERTHAN | ops= GREATERTHANEQUALS )
                        var alt46=6;
                        switch ( this.input.LA(1) ) {
                            case EQUALS:
                                alt46=1;
                                break;
                            case NOTEQUALS:
                                alt46=2;
                                break;
                            case LESSTHAN:
                                alt46=3;
                                break;
                            case LESSTHANEQUALS:
                                alt46=4;
                                break;
                            case GREATERTHAN:
                                alt46=5;
                                break;
                            case GREATERTHANEQUALS:
                                alt46=6;
                                break;
                            default:
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 46, 0, this.input);

                                throw nvae;
                        }

                        switch (alt46) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:192:14: ops= EQUALS
                                ops=this.match(this.input,EQUALS,MentionQAst.FOLLOW_EQUALS_in_generalComparisonLongFactor2641);
                                stream_EQUALS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:192:27: ops= NOTEQUALS
                                ops=this.match(this.input,NOTEQUALS,MentionQAst.FOLLOW_NOTEQUALS_in_generalComparisonLongFactor2647);
                                stream_NOTEQUALS.add(ops);



                                break;
                            case 3 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:192:43: ops= LESSTHAN
                                ops=this.match(this.input,LESSTHAN,MentionQAst.FOLLOW_LESSTHAN_in_generalComparisonLongFactor2653);
                                stream_LESSTHAN.add(ops);



                                break;
                            case 4 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:192:58: ops= LESSTHANEQUALS
                                ops=this.match(this.input,LESSTHANEQUALS,MentionQAst.FOLLOW_LESSTHANEQUALS_in_generalComparisonLongFactor2659);
                                stream_LESSTHANEQUALS.add(ops);



                                break;
                            case 5 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:192:79: ops= GREATERTHAN
                                ops=this.match(this.input,GREATERTHAN,MentionQAst.FOLLOW_GREATERTHAN_in_generalComparisonLongFactor2665);
                                stream_GREATERTHAN.add(ops);



                                break;
                            case 6 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:192:97: ops= GREATERTHANEQUALS
                                ops=this.match(this.input,GREATERTHANEQUALS,MentionQAst.FOLLOW_GREATERTHANEQUALS_in_generalComparisonLongFactor2671);
                                stream_GREATERTHANEQUALS.add(ops);



                                break;

                        }

                        lit=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_generalComparisonLongFactor2677);
                        stream_LONG_LITERAL.add(lit);






                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:194:11: ( (ops= IS | ops= ISNT ) lit= UNKNOWN )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:194:11: ( (ops= IS | ops= ISNT ) lit= UNKNOWN )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:194:12: (ops= IS | ops= ISNT ) lit= UNKNOWN
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:194:12: (ops= IS | ops= ISNT )
                        var alt47=2;
                        var LA47_0 = this.input.LA(1);

                        if ( (LA47_0==IS) ) {
                            alt47=1;
                        }
                        else if ( (LA47_0==ISNT) ) {
                            alt47=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 47, 0, this.input);

                            throw nvae;
                        }
                        switch (alt47) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:194:14: ops= IS
                                ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_generalComparisonLongFactor2708);
                                stream_IS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:194:23: ops= ISNT
                                ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_generalComparisonLongFactor2714);
                                stream_ISNT.add(ops);



                                break;

                        }

                        lit=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_generalComparisonLongFactor2720);
                        stream_UNKNOWN.add(lit);






                        break;

                }






                // AST REWRITE
                // elements: o, lit, ops
                // token labels: lit, o, ops
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 195:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:195:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        replyingToFactor_return: (function() {
            MentionQAst.replyingToFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.replyingToFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:198:1: replyingToFactor : o= REPLY_TO ( ( (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN ) ) -> ^( FACTOR $o $ops $lit) | ( (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2) ) | ( (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL ) ) -> ^( FACTOR $o $ops $lit) ) ;
        // $ANTLR start "replyingToFactor"
        replyingToFactor: function() {
            var retval = new MentionQAst.replyingToFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;
            var lit2 = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_REPLY_TO=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token REPLY_TO");
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_IN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IN");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_LONG_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LONG_LITERAL");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_DOESNTCONTAIN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token DOESNTCONTAIN");
            var stream_CONTAINS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CONTAINS");
            var stream_NOTIN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token NOTIN");
            var stream_longOrStringIdSet=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule longOrStringIdSet");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:199:5: (o= REPLY_TO ( ( (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN ) ) -> ^( FACTOR $o $ops $lit) | ( (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2) ) | ( (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL ) ) -> ^( FACTOR $o $ops $lit) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:199:9: o= REPLY_TO ( ( (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN ) ) -> ^( FACTOR $o $ops $lit) | ( (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2) ) | ( (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL ) ) -> ^( FACTOR $o $ops $lit) )
                o=this.match(this.input,REPLY_TO,MentionQAst.FOLLOW_REPLY_TO_in_replyingToFactor2765);
                stream_REPLY_TO.add(o);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:199:20: ( ( (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN ) ) -> ^( FACTOR $o $ops $lit) | ( (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2) ) | ( (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL ) ) -> ^( FACTOR $o $ops $lit) )
                var alt53=3;
                switch ( this.input.LA(1) ) {
                    case IS:
                    case ISNT:
                        alt53=1;
                        break;
                    case IN:
                    case NOTIN:
                        alt53=2;
                        break;
                    case CONTAINS:
                    case DOESNTCONTAIN:
                        alt53=3;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 53, 0, this.input);

                        throw nvae;
                }

                switch (alt53) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:200:13: ( (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:200:13: ( (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:200:14: (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:200:14: (ops= IS | ops= ISNT )
                        var alt49=2;
                        var LA49_0 = this.input.LA(1);

                        if ( (LA49_0==IS) ) {
                            alt49=1;
                        }
                        else if ( (LA49_0==ISNT) ) {
                            alt49=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 49, 0, this.input);

                            throw nvae;
                        }
                        switch (alt49) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:200:16: ops= IS
                                ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_replyingToFactor2786);
                                stream_IS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:200:25: ops= ISNT
                                ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_replyingToFactor2792);
                                stream_ISNT.add(ops);



                                break;

                        }

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:200:36: (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN )
                        var alt50=3;
                        switch ( this.input.LA(1) ) {
                            case LONG_LITERAL:
                                alt50=1;
                                break;
                            case STRING_LITERAL:
                                alt50=2;
                                break;
                            case UNKNOWN:
                                alt50=3;
                                break;
                            default:
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 50, 0, this.input);

                                throw nvae;
                        }

                        switch (alt50) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:200:37: lit= LONG_LITERAL
                                lit=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_replyingToFactor2799);
                                stream_LONG_LITERAL.add(lit);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:200:56: lit= STRING_LITERAL
                                lit=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_replyingToFactor2805);
                                stream_STRING_LITERAL.add(lit);



                                break;
                            case 3 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:200:77: lit= UNKNOWN
                                lit=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_replyingToFactor2811);
                                stream_UNKNOWN.add(lit);



                                break;

                        }






                        // AST REWRITE
                        // elements: lit, o, ops
                        // token labels: lit, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 200:92: -> ^( FACTOR $o $ops $lit)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:200:96: ^( FACTOR $o $ops $lit)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:201:15: ( (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:201:15: ( (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:201:16: (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:201:16: (ops= IN | ops= NOTIN )
                        var alt51=2;
                        var LA51_0 = this.input.LA(1);

                        if ( (LA51_0==IN) ) {
                            alt51=1;
                        }
                        else if ( (LA51_0==NOTIN) ) {
                            alt51=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 51, 0, this.input);

                            throw nvae;
                        }
                        switch (alt51) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:201:18: ops= IN
                                ops=this.match(this.input,IN,MentionQAst.FOLLOW_IN_in_replyingToFactor2851);
                                stream_IN.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:201:27: ops= NOTIN
                                ops=this.match(this.input,NOTIN,MentionQAst.FOLLOW_NOTIN_in_replyingToFactor2857);
                                stream_NOTIN.add(ops);



                                break;

                        }

                        this.pushFollow(MentionQAst.FOLLOW_longOrStringIdSet_in_replyingToFactor2863);
                        lit2=this.longOrStringIdSet();

                        this.state._fsp--;

                        stream_longOrStringIdSet.add(lit2.getTree());


                        // AST REWRITE
                        // elements: ops, lit2, o
                        // token labels: o, ops
                        // rule labels: lit2, retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_lit2=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit2",lit2!=null?lit2.tree:null);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 201:62: -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:201:65: ^( SET_MENTION_ID_FACTOR $o $ops $lit2)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SET_MENTION_ID_FACTOR, "SET_MENTION_ID_FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit2.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:202:15: ( (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:202:15: ( (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:202:16: (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:202:16: (ops= CONTAINS | ops= DOESNTCONTAIN )
                        var alt52=2;
                        var LA52_0 = this.input.LA(1);

                        if ( (LA52_0==CONTAINS) ) {
                            alt52=1;
                        }
                        else if ( (LA52_0==DOESNTCONTAIN) ) {
                            alt52=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 52, 0, this.input);

                            throw nvae;
                        }
                        switch (alt52) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:202:18: ops= CONTAINS
                                ops=this.match(this.input,CONTAINS,MentionQAst.FOLLOW_CONTAINS_in_replyingToFactor2900);
                                stream_CONTAINS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:202:33: ops= DOESNTCONTAIN
                                ops=this.match(this.input,DOESNTCONTAIN,MentionQAst.FOLLOW_DOESNTCONTAIN_in_replyingToFactor2906);
                                stream_DOESNTCONTAIN.add(ops);



                                break;

                        }

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:202:53: (lit= STRING_LITERAL )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:202:55: lit= STRING_LITERAL
                        lit=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_replyingToFactor2914);
                        stream_STRING_LITERAL.add(lit);









                        // AST REWRITE
                        // elements: o, lit, ops
                        // token labels: lit, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 202:77: -> ^( FACTOR $o $ops $lit)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:202:81: ^( FACTOR $o $ops $lit)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;

                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        reshareOfFactor_return: (function() {
            MentionQAst.reshareOfFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.reshareOfFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:206:1: reshareOfFactor : o= RESHARE_OF ( ( (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN ) ) -> ^( FACTOR $o $ops $lit) | ( (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2) ) | ( (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL ) ) -> ^( FACTOR $o $ops $lit) ) ;
        // $ANTLR start "reshareOfFactor"
        reshareOfFactor: function() {
            var retval = new MentionQAst.reshareOfFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;
            var lit2 = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_RESHARE_OF=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RESHARE_OF");
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_IN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IN");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_LONG_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LONG_LITERAL");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_DOESNTCONTAIN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token DOESNTCONTAIN");
            var stream_CONTAINS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CONTAINS");
            var stream_NOTIN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token NOTIN");
            var stream_longOrStringIdSet=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule longOrStringIdSet");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:207:5: (o= RESHARE_OF ( ( (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN ) ) -> ^( FACTOR $o $ops $lit) | ( (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2) ) | ( (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL ) ) -> ^( FACTOR $o $ops $lit) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:207:9: o= RESHARE_OF ( ( (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN ) ) -> ^( FACTOR $o $ops $lit) | ( (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2) ) | ( (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL ) ) -> ^( FACTOR $o $ops $lit) )
                o=this.match(this.input,RESHARE_OF,MentionQAst.FOLLOW_RESHARE_OF_in_reshareOfFactor2960);
                stream_RESHARE_OF.add(o);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:207:22: ( ( (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN ) ) -> ^( FACTOR $o $ops $lit) | ( (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2) ) | ( (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL ) ) -> ^( FACTOR $o $ops $lit) )
                var alt58=3;
                switch ( this.input.LA(1) ) {
                    case IS:
                    case ISNT:
                        alt58=1;
                        break;
                    case IN:
                    case NOTIN:
                        alt58=2;
                        break;
                    case CONTAINS:
                    case DOESNTCONTAIN:
                        alt58=3;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 58, 0, this.input);

                        throw nvae;
                }

                switch (alt58) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:208:13: ( (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:208:13: ( (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:208:14: (ops= IS | ops= ISNT ) (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:208:14: (ops= IS | ops= ISNT )
                        var alt54=2;
                        var LA54_0 = this.input.LA(1);

                        if ( (LA54_0==IS) ) {
                            alt54=1;
                        }
                        else if ( (LA54_0==ISNT) ) {
                            alt54=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 54, 0, this.input);

                            throw nvae;
                        }
                        switch (alt54) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:208:16: ops= IS
                                ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_reshareOfFactor2981);
                                stream_IS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:208:25: ops= ISNT
                                ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_reshareOfFactor2987);
                                stream_ISNT.add(ops);



                                break;

                        }

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:208:36: (lit= LONG_LITERAL | lit= STRING_LITERAL | lit= UNKNOWN )
                        var alt55=3;
                        switch ( this.input.LA(1) ) {
                            case LONG_LITERAL:
                                alt55=1;
                                break;
                            case STRING_LITERAL:
                                alt55=2;
                                break;
                            case UNKNOWN:
                                alt55=3;
                                break;
                            default:
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 55, 0, this.input);

                                throw nvae;
                        }

                        switch (alt55) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:208:37: lit= LONG_LITERAL
                                lit=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_reshareOfFactor2994);
                                stream_LONG_LITERAL.add(lit);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:208:56: lit= STRING_LITERAL
                                lit=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_reshareOfFactor3000);
                                stream_STRING_LITERAL.add(lit);



                                break;
                            case 3 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:208:77: lit= UNKNOWN
                                lit=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_reshareOfFactor3006);
                                stream_UNKNOWN.add(lit);



                                break;

                        }






                        // AST REWRITE
                        // elements: lit, o, ops
                        // token labels: lit, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 208:92: -> ^( FACTOR $o $ops $lit)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:208:96: ^( FACTOR $o $ops $lit)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:209:15: ( (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:209:15: ( (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:209:16: (ops= IN | ops= NOTIN ) lit2= longOrStringIdSet
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:209:16: (ops= IN | ops= NOTIN )
                        var alt56=2;
                        var LA56_0 = this.input.LA(1);

                        if ( (LA56_0==IN) ) {
                            alt56=1;
                        }
                        else if ( (LA56_0==NOTIN) ) {
                            alt56=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 56, 0, this.input);

                            throw nvae;
                        }
                        switch (alt56) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:209:18: ops= IN
                                ops=this.match(this.input,IN,MentionQAst.FOLLOW_IN_in_reshareOfFactor3046);
                                stream_IN.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:209:27: ops= NOTIN
                                ops=this.match(this.input,NOTIN,MentionQAst.FOLLOW_NOTIN_in_reshareOfFactor3052);
                                stream_NOTIN.add(ops);



                                break;

                        }

                        this.pushFollow(MentionQAst.FOLLOW_longOrStringIdSet_in_reshareOfFactor3058);
                        lit2=this.longOrStringIdSet();

                        this.state._fsp--;

                        stream_longOrStringIdSet.add(lit2.getTree());


                        // AST REWRITE
                        // elements: lit2, o, ops
                        // token labels: o, ops
                        // rule labels: lit2, retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_lit2=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit2",lit2!=null?lit2.tree:null);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 209:62: -> ^( SET_MENTION_ID_FACTOR $o $ops $lit2)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:209:65: ^( SET_MENTION_ID_FACTOR $o $ops $lit2)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SET_MENTION_ID_FACTOR, "SET_MENTION_ID_FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit2.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:210:15: ( (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:210:15: ( (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:210:16: (ops= CONTAINS | ops= DOESNTCONTAIN ) (lit= STRING_LITERAL )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:210:16: (ops= CONTAINS | ops= DOESNTCONTAIN )
                        var alt57=2;
                        var LA57_0 = this.input.LA(1);

                        if ( (LA57_0==CONTAINS) ) {
                            alt57=1;
                        }
                        else if ( (LA57_0==DOESNTCONTAIN) ) {
                            alt57=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 57, 0, this.input);

                            throw nvae;
                        }
                        switch (alt57) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:210:18: ops= CONTAINS
                                ops=this.match(this.input,CONTAINS,MentionQAst.FOLLOW_CONTAINS_in_reshareOfFactor3095);
                                stream_CONTAINS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:210:33: ops= DOESNTCONTAIN
                                ops=this.match(this.input,DOESNTCONTAIN,MentionQAst.FOLLOW_DOESNTCONTAIN_in_reshareOfFactor3101);
                                stream_DOESNTCONTAIN.add(ops);



                                break;

                        }

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:210:53: (lit= STRING_LITERAL )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:210:55: lit= STRING_LITERAL
                        lit=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_reshareOfFactor3109);
                        stream_STRING_LITERAL.add(lit);









                        // AST REWRITE
                        // elements: ops, o, lit
                        // token labels: lit, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 210:77: -> ^( FACTOR $o $ops $lit)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:210:81: ^( FACTOR $o $ops $lit)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;

                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        tagFactor_return: (function() {
            MentionQAst.tagFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.tagFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:214:1: tagFactor : (o= TAG | o= TOPIC | o= SEGMENT ) (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= LONG_LITERAL | lit= TAG_ID_LITERAL | lit= UNKNOWN ) -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "tagFactor"
        tagFactor: function() {
            var retval = new MentionQAst.tagFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_TAG_ID_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TAG_ID_LITERAL");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_LONG_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LONG_LITERAL");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_SEGMENT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token SEGMENT");
            var stream_TOPIC=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TOPIC");
            var stream_TAG=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TAG");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:5: ( (o= TAG | o= TOPIC | o= SEGMENT ) (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= LONG_LITERAL | lit= TAG_ID_LITERAL | lit= UNKNOWN ) -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:9: (o= TAG | o= TOPIC | o= SEGMENT ) (ops= IS | ops= ISNT ) (lit= STRING_LITERAL | lit= LONG_LITERAL | lit= TAG_ID_LITERAL | lit= UNKNOWN )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:9: (o= TAG | o= TOPIC | o= SEGMENT )
                var alt59=3;
                switch ( this.input.LA(1) ) {
                    case TAG:
                        alt59=1;
                        break;
                    case TOPIC:
                        alt59=2;
                        break;
                    case SEGMENT:
                        alt59=3;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 59, 0, this.input);

                        throw nvae;
                }

                switch (alt59) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:10: o= TAG
                        o=this.match(this.input,TAG,MentionQAst.FOLLOW_TAG_in_tagFactor3156);
                        stream_TAG.add(o);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:18: o= TOPIC
                        o=this.match(this.input,TOPIC,MentionQAst.FOLLOW_TOPIC_in_tagFactor3162);
                        stream_TOPIC.add(o);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:28: o= SEGMENT
                        o=this.match(this.input,SEGMENT,MentionQAst.FOLLOW_SEGMENT_in_tagFactor3168);
                        stream_SEGMENT.add(o);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:39: (ops= IS | ops= ISNT )
                var alt60=2;
                var LA60_0 = this.input.LA(1);

                if ( (LA60_0==IS) ) {
                    alt60=1;
                }
                else if ( (LA60_0==ISNT) ) {
                    alt60=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 60, 0, this.input);

                    throw nvae;
                }
                switch (alt60) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:41: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_tagFactor3175);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:50: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_tagFactor3181);
                        stream_ISNT.add(ops);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:61: (lit= STRING_LITERAL | lit= LONG_LITERAL | lit= TAG_ID_LITERAL | lit= UNKNOWN )
                var alt61=4;
                switch ( this.input.LA(1) ) {
                    case STRING_LITERAL:
                        alt61=1;
                        break;
                    case LONG_LITERAL:
                        alt61=2;
                        break;
                    case TAG_ID_LITERAL:
                        alt61=3;
                        break;
                    case UNKNOWN:
                        alt61=4;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 61, 0, this.input);

                        throw nvae;
                }

                switch (alt61) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:63: lit= STRING_LITERAL
                        lit=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_tagFactor3189);
                        stream_STRING_LITERAL.add(lit);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:84: lit= LONG_LITERAL
                        lit=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_tagFactor3195);
                        stream_LONG_LITERAL.add(lit);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:103: lit= TAG_ID_LITERAL
                        lit=this.match(this.input,TAG_ID_LITERAL,MentionQAst.FOLLOW_TAG_ID_LITERAL_in_tagFactor3201);
                        stream_TAG_ID_LITERAL.add(lit);



                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:215:124: lit= UNKNOWN
                        lit=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_tagFactor3207);
                        stream_UNKNOWN.add(lit);



                        break;

                }



                // AST REWRITE
                // elements: o, lit, ops
                // token labels: lit, o, ops
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 216:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:216:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        mediaFactor_return: (function() {
            MentionQAst.mediaFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.mediaFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:219:1: mediaFactor : o= MEDIA (ops= IS | ops= ISNT ) lit= mediaLiteralAndUnknown -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "mediaFactor"
        mediaFactor: function() {
            var retval = new MentionQAst.mediaFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_MEDIA=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token MEDIA");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_mediaLiteralAndUnknown=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule mediaLiteralAndUnknown");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:220:5: (o= MEDIA (ops= IS | ops= ISNT ) lit= mediaLiteralAndUnknown -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:220:10: o= MEDIA (ops= IS | ops= ISNT ) lit= mediaLiteralAndUnknown
                o=this.match(this.input,MEDIA,MentionQAst.FOLLOW_MEDIA_in_mediaFactor3251);
                stream_MEDIA.add(o);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:220:18: (ops= IS | ops= ISNT )
                var alt62=2;
                var LA62_0 = this.input.LA(1);

                if ( (LA62_0==IS) ) {
                    alt62=1;
                }
                else if ( (LA62_0==ISNT) ) {
                    alt62=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 62, 0, this.input);

                    throw nvae;
                }
                switch (alt62) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:220:20: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_mediaFactor3257);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:220:29: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_mediaFactor3263);
                        stream_ISNT.add(ops);



                        break;

                }

                this.pushFollow(MentionQAst.FOLLOW_mediaLiteralAndUnknown_in_mediaFactor3269);
                lit=this.mediaLiteralAndUnknown();

                this.state._fsp--;

                stream_mediaLiteralAndUnknown.add(lit.getTree());


                // AST REWRITE
                // elements: ops, o, lit
                // token labels: o, ops
                // rule labels: lit, retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit",lit!=null?lit.tree:null);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 221:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:221:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextTree());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        genderFactor_return: (function() {
            MentionQAst.genderFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.genderFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:224:1: genderFactor : o= GENDER (ops= IS | ops= ISNT ) lit= genderLiteralAndUnknown -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "genderFactor"
        genderFactor: function() {
            var retval = new MentionQAst.genderFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_GENDER=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token GENDER");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_genderLiteralAndUnknown=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule genderLiteralAndUnknown");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:225:5: (o= GENDER (ops= IS | ops= ISNT ) lit= genderLiteralAndUnknown -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:225:9: o= GENDER (ops= IS | ops= ISNT ) lit= genderLiteralAndUnknown
                o=this.match(this.input,GENDER,MentionQAst.FOLLOW_GENDER_in_genderFactor3310);
                stream_GENDER.add(o);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:225:18: (ops= IS | ops= ISNT )
                var alt63=2;
                var LA63_0 = this.input.LA(1);

                if ( (LA63_0==IS) ) {
                    alt63=1;
                }
                else if ( (LA63_0==ISNT) ) {
                    alt63=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 63, 0, this.input);

                    throw nvae;
                }
                switch (alt63) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:225:20: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_genderFactor3316);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:225:29: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_genderFactor3322);
                        stream_ISNT.add(ops);



                        break;

                }

                this.pushFollow(MentionQAst.FOLLOW_genderLiteralAndUnknown_in_genderFactor3328);
                lit=this.genderLiteralAndUnknown();

                this.state._fsp--;

                stream_genderLiteralAndUnknown.add(lit.getTree());


                // AST REWRITE
                // elements: lit, o, ops
                // token labels: o, ops
                // rule labels: lit, retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit",lit!=null?lit.tree:null);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 226:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:226:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextTree());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        raceFactor_return: (function() {
            MentionQAst.raceFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.raceFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:229:1: raceFactor : o= RACE (ops= IS | ops= ISNT ) lit= unknownOrUnquotedString -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "raceFactor"
        raceFactor: function() {
            var retval = new MentionQAst.raceFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_RACE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RACE");
            var stream_unknownOrUnquotedString=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule unknownOrUnquotedString");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:230:5: (o= RACE (ops= IS | ops= ISNT ) lit= unknownOrUnquotedString -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:230:9: o= RACE (ops= IS | ops= ISNT ) lit= unknownOrUnquotedString
                o=this.match(this.input,RACE,MentionQAst.FOLLOW_RACE_in_raceFactor3369);
                stream_RACE.add(o);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:230:16: (ops= IS | ops= ISNT )
                var alt64=2;
                var LA64_0 = this.input.LA(1);

                if ( (LA64_0==IS) ) {
                    alt64=1;
                }
                else if ( (LA64_0==ISNT) ) {
                    alt64=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 64, 0, this.input);

                    throw nvae;
                }
                switch (alt64) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:230:18: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_raceFactor3375);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:230:27: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_raceFactor3381);
                        stream_ISNT.add(ops);



                        break;

                }

                this.pushFollow(MentionQAst.FOLLOW_unknownOrUnquotedString_in_raceFactor3387);
                lit=this.unknownOrUnquotedString();

                this.state._fsp--;

                stream_unknownOrUnquotedString.add(lit.getTree());


                // AST REWRITE
                // elements: lit, o, ops
                // token labels: o, ops
                // rule labels: lit, retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit",lit!=null?lit.tree:null);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 231:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:231:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextTree());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        socialNetworkFactor_return: (function() {
            MentionQAst.socialNetworkFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.socialNetworkFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:234:1: socialNetworkFactor : o= SOCIAL_NETWORK (ops= IS | ops= ISNT ) lit= unknownOrUnquotedString -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "socialNetworkFactor"
        socialNetworkFactor: function() {
            var retval = new MentionQAst.socialNetworkFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_SOCIAL_NETWORK=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token SOCIAL_NETWORK");
            var stream_unknownOrUnquotedString=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule unknownOrUnquotedString");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:235:5: (o= SOCIAL_NETWORK (ops= IS | ops= ISNT ) lit= unknownOrUnquotedString -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:235:9: o= SOCIAL_NETWORK (ops= IS | ops= ISNT ) lit= unknownOrUnquotedString
                o=this.match(this.input,SOCIAL_NETWORK,MentionQAst.FOLLOW_SOCIAL_NETWORK_in_socialNetworkFactor3428);
                stream_SOCIAL_NETWORK.add(o);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:235:26: (ops= IS | ops= ISNT )
                var alt65=2;
                var LA65_0 = this.input.LA(1);

                if ( (LA65_0==IS) ) {
                    alt65=1;
                }
                else if ( (LA65_0==ISNT) ) {
                    alt65=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 65, 0, this.input);

                    throw nvae;
                }
                switch (alt65) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:235:28: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_socialNetworkFactor3434);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:235:37: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_socialNetworkFactor3440);
                        stream_ISNT.add(ops);



                        break;

                }

                this.pushFollow(MentionQAst.FOLLOW_unknownOrUnquotedString_in_socialNetworkFactor3446);
                lit=this.unknownOrUnquotedString();

                this.state._fsp--;

                stream_unknownOrUnquotedString.add(lit.getTree());


                // AST REWRITE
                // elements: o, ops, lit
                // token labels: o, ops
                // rule labels: lit, retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit",lit!=null?lit.tree:null);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 236:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:236:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextTree());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        visibilityFactor_return: (function() {
            MentionQAst.visibilityFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.visibilityFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:239:1: visibilityFactor : o= VISIBILITY (ops= IS | ops= ISNT ) lit= UNQUOTED_STRING_LITERAL -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "visibilityFactor"
        visibilityFactor: function() {
            var retval = new MentionQAst.visibilityFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_VISIBILITY=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token VISIBILITY");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_UNQUOTED_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNQUOTED_STRING_LITERAL");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:240:5: (o= VISIBILITY (ops= IS | ops= ISNT ) lit= UNQUOTED_STRING_LITERAL -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:240:9: o= VISIBILITY (ops= IS | ops= ISNT ) lit= UNQUOTED_STRING_LITERAL
                o=this.match(this.input,VISIBILITY,MentionQAst.FOLLOW_VISIBILITY_in_visibilityFactor3487);
                stream_VISIBILITY.add(o);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:240:22: (ops= IS | ops= ISNT )
                var alt66=2;
                var LA66_0 = this.input.LA(1);

                if ( (LA66_0==IS) ) {
                    alt66=1;
                }
                else if ( (LA66_0==ISNT) ) {
                    alt66=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 66, 0, this.input);

                    throw nvae;
                }
                switch (alt66) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:240:24: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_visibilityFactor3493);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:240:33: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_visibilityFactor3499);
                        stream_ISNT.add(ops);



                        break;

                }

                lit=this.match(this.input,UNQUOTED_STRING_LITERAL,MentionQAst.FOLLOW_UNQUOTED_STRING_LITERAL_in_visibilityFactor3505);
                stream_UNQUOTED_STRING_LITERAL.add(lit);



                // AST REWRITE
                // elements: lit, ops, o
                // token labels: lit, o, ops
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 241:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:241:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        relevancyFactor_return: (function() {
            MentionQAst.relevancyFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.relevancyFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:244:1: relevancyFactor : o= RELEVANCY (ops= IS | ops= ISNT ) lit= relevancyLiteral -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "relevancyFactor"
        relevancyFactor: function() {
            var retval = new MentionQAst.relevancyFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_RELEVANCY=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RELEVANCY");
            var stream_relevancyLiteral=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule relevancyLiteral");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:245:5: (o= RELEVANCY (ops= IS | ops= ISNT ) lit= relevancyLiteral -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:245:9: o= RELEVANCY (ops= IS | ops= ISNT ) lit= relevancyLiteral
                o=this.match(this.input,RELEVANCY,MentionQAst.FOLLOW_RELEVANCY_in_relevancyFactor3546);
                stream_RELEVANCY.add(o);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:245:21: (ops= IS | ops= ISNT )
                var alt67=2;
                var LA67_0 = this.input.LA(1);

                if ( (LA67_0==IS) ) {
                    alt67=1;
                }
                else if ( (LA67_0==ISNT) ) {
                    alt67=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 67, 0, this.input);

                    throw nvae;
                }
                switch (alt67) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:245:23: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_relevancyFactor3552);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:245:32: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_relevancyFactor3558);
                        stream_ISNT.add(ops);



                        break;

                }

                this.pushFollow(MentionQAst.FOLLOW_relevancyLiteral_in_relevancyFactor3564);
                lit=this.relevancyLiteral();

                this.state._fsp--;

                stream_relevancyLiteral.add(lit.getTree());


                // AST REWRITE
                // elements: lit, ops, o
                // token labels: o, ops
                // rule labels: lit, retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit",lit!=null?lit.tree:null);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 246:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:246:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextTree());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        processFactor_return: (function() {
            MentionQAst.processFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.processFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:250:1: processFactor : o= PROCESS (ops= IS | ops= ISNT ) lit= processLiteral -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "processFactor"
        processFactor: function() {
            var retval = new MentionQAst.processFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_PROCESS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token PROCESS");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_processLiteral=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule processLiteral");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:251:5: (o= PROCESS (ops= IS | ops= ISNT ) lit= processLiteral -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:251:9: o= PROCESS (ops= IS | ops= ISNT ) lit= processLiteral
                o=this.match(this.input,PROCESS,MentionQAst.FOLLOW_PROCESS_in_processFactor3606);
                stream_PROCESS.add(o);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:251:19: (ops= IS | ops= ISNT )
                var alt68=2;
                var LA68_0 = this.input.LA(1);

                if ( (LA68_0==IS) ) {
                    alt68=1;
                }
                else if ( (LA68_0==ISNT) ) {
                    alt68=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 68, 0, this.input);

                    throw nvae;
                }
                switch (alt68) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:251:21: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_processFactor3612);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:251:30: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_processFactor3618);
                        stream_ISNT.add(ops);



                        break;

                }

                this.pushFollow(MentionQAst.FOLLOW_processLiteral_in_processFactor3624);
                lit=this.processLiteral();

                this.state._fsp--;

                stream_processLiteral.add(lit.getTree());


                // AST REWRITE
                // elements: ops, lit, o
                // token labels: o, ops
                // rule labels: lit, retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit",lit!=null?lit.tree:null);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 252:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:252:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextTree());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        actionFactor_return: (function() {
            MentionQAst.actionFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.actionFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:255:1: actionFactor : o= ACTION (ops= IS | ops= ISNT ) lit= actionLiteralAndUnknown () -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "actionFactor"
        actionFactor: function() {
            var retval = new MentionQAst.actionFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_ACTION=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ACTION");
            var stream_actionLiteralAndUnknown=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule actionLiteralAndUnknown");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:256:5: (o= ACTION (ops= IS | ops= ISNT ) lit= actionLiteralAndUnknown () -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:256:9: o= ACTION (ops= IS | ops= ISNT ) lit= actionLiteralAndUnknown ()
                o=this.match(this.input,ACTION,MentionQAst.FOLLOW_ACTION_in_actionFactor3665);
                stream_ACTION.add(o);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:256:18: (ops= IS | ops= ISNT )
                var alt69=2;
                var LA69_0 = this.input.LA(1);

                if ( (LA69_0==IS) ) {
                    alt69=1;
                }
                else if ( (LA69_0==ISNT) ) {
                    alt69=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 69, 0, this.input);

                    throw nvae;
                }
                switch (alt69) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:256:20: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_actionFactor3671);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:256:29: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_actionFactor3677);
                        stream_ISNT.add(ops);



                        break;

                }

                this.pushFollow(MentionQAst.FOLLOW_actionLiteralAndUnknown_in_actionFactor3684);
                lit=this.actionLiteralAndUnknown();

                this.state._fsp--;

                stream_actionLiteralAndUnknown.add(lit.getTree());
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:256:68: ()
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:256:69:




                // AST REWRITE
                // elements: o, ops, lit
                // token labels: o, ops
                // rule labels: lit, retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit",lit!=null?lit.tree:null);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 257:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:257:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextTree());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        dateFactor_return: (function() {
            MentionQAst.dateFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.dateFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:260:1: dateFactor : (o= PUBLISHED | o= PICKED_UP | o= UPDATED ) ( ( (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral -> ^( FACTOR $o $ops $lit1) ) | ( (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL -> ^( FACTOR $o $ops $lit2) ) | (ops= ON lit3= TODAY ) -> ^( FACTOR $o $ops $lit3) ) ;
        // $ANTLR start "dateFactor"
        dateFactor: function() {
            var retval = new MentionQAst.dateFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit2 = null;
            var lit3 = null;
            var lit1 = null;

            var o_tree=null;
            var ops_tree=null;
            var lit2_tree=null;
            var lit3_tree=null;
            var stream_ON=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ON");
            var stream_BEFORE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token BEFORE");
            var stream_TODAY=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TODAY");
            var stream_UPDATED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UPDATED");
            var stream_AFTER=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AFTER");
            var stream_DATE_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token DATE_LITERAL");
            var stream_PUBLISHED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token PUBLISHED");
            var stream_PICKED_UP=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token PICKED_UP");
            var stream_BEFORETHELAST=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token BEFORETHELAST");
            var stream_INTHELAST=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTHELAST");
            var stream_periodLiteral=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule periodLiteral");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:261:5: ( (o= PUBLISHED | o= PICKED_UP | o= UPDATED ) ( ( (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral -> ^( FACTOR $o $ops $lit1) ) | ( (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL -> ^( FACTOR $o $ops $lit2) ) | (ops= ON lit3= TODAY ) -> ^( FACTOR $o $ops $lit3) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:261:9: (o= PUBLISHED | o= PICKED_UP | o= UPDATED ) ( ( (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral -> ^( FACTOR $o $ops $lit1) ) | ( (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL -> ^( FACTOR $o $ops $lit2) ) | (ops= ON lit3= TODAY ) -> ^( FACTOR $o $ops $lit3) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:261:9: (o= PUBLISHED | o= PICKED_UP | o= UPDATED )
                var alt70=3;
                switch ( this.input.LA(1) ) {
                    case PUBLISHED:
                        alt70=1;
                        break;
                    case PICKED_UP:
                        alt70=2;
                        break;
                    case UPDATED:
                        alt70=3;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 70, 0, this.input);

                        throw nvae;
                }

                switch (alt70) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:261:11: o= PUBLISHED
                        o=this.match(this.input,PUBLISHED,MentionQAst.FOLLOW_PUBLISHED_in_dateFactor3729);
                        stream_PUBLISHED.add(o);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:261:25: o= PICKED_UP
                        o=this.match(this.input,PICKED_UP,MentionQAst.FOLLOW_PICKED_UP_in_dateFactor3735);
                        stream_PICKED_UP.add(o);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:261:39: o= UPDATED
                        o=this.match(this.input,UPDATED,MentionQAst.FOLLOW_UPDATED_in_dateFactor3741);
                        stream_UPDATED.add(o);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:262:9: ( ( (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral -> ^( FACTOR $o $ops $lit1) ) | ( (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL -> ^( FACTOR $o $ops $lit2) ) | (ops= ON lit3= TODAY ) -> ^( FACTOR $o $ops $lit3) )
                var alt73=3;
                switch ( this.input.LA(1) ) {
                    case INTHELAST:
                    case BEFORETHELAST:
                        alt73=1;
                        break;
                    case BEFORE:
                    case AFTER:
                        alt73=2;
                        break;
                    case ON:
                        var LA73_3 = this.input.LA(2);

                        if ( (LA73_3==TODAY) ) {
                            alt73=3;
                        }
                        else if ( (LA73_3==DATE_LITERAL) ) {
                            alt73=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 73, 3, this.input);

                            throw nvae;
                        }
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 73, 0, this.input);

                        throw nvae;
                }

                switch (alt73) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:262:10: ( (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral -> ^( FACTOR $o $ops $lit1) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:262:10: ( (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral -> ^( FACTOR $o $ops $lit1) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:262:11: (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:262:11: (ops= INTHELAST | ops= BEFORETHELAST )
                        var alt71=2;
                        var LA71_0 = this.input.LA(1);

                        if ( (LA71_0==INTHELAST) ) {
                            alt71=1;
                        }
                        else if ( (LA71_0==BEFORETHELAST) ) {
                            alt71=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 71, 0, this.input);

                            throw nvae;
                        }
                        switch (alt71) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:262:13: ops= INTHELAST
                                ops=this.match(this.input,INTHELAST,MentionQAst.FOLLOW_INTHELAST_in_dateFactor3759);
                                stream_INTHELAST.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:262:29: ops= BEFORETHELAST
                                ops=this.match(this.input,BEFORETHELAST,MentionQAst.FOLLOW_BEFORETHELAST_in_dateFactor3765);
                                stream_BEFORETHELAST.add(ops);



                                break;

                        }

                        this.pushFollow(MentionQAst.FOLLOW_periodLiteral_in_dateFactor3771);
                        lit1=this.periodLiteral();

                        this.state._fsp--;

                        stream_periodLiteral.add(lit1.getTree());


                        // AST REWRITE
                        // elements: lit1, o, ops
                        // token labels: o, ops
                        // rule labels: lit1, retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_lit1=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit1",lit1!=null?lit1.tree:null);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 262:81: -> ^( FACTOR $o $ops $lit1)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:262:85: ^( FACTOR $o $ops $lit1)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit1.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:263:12: ( (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL -> ^( FACTOR $o $ops $lit2) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:263:12: ( (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL -> ^( FACTOR $o $ops $lit2) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:263:13: (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:263:13: (ops= BEFORE | ops= AFTER | ops= ON )
                        var alt72=3;
                        switch ( this.input.LA(1) ) {
                            case BEFORE:
                                alt72=1;
                                break;
                            case AFTER:
                                alt72=2;
                                break;
                            case ON:
                                alt72=3;
                                break;
                            default:
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 72, 0, this.input);

                                throw nvae;
                        }

                        switch (alt72) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:263:15: ops= BEFORE
                                ops=this.match(this.input,BEFORE,MentionQAst.FOLLOW_BEFORE_in_dateFactor3819);
                                stream_BEFORE.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:263:28: ops= AFTER
                                ops=this.match(this.input,AFTER,MentionQAst.FOLLOW_AFTER_in_dateFactor3825);
                                stream_AFTER.add(ops);



                                break;
                            case 3 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:263:40: ops= ON
                                ops=this.match(this.input,ON,MentionQAst.FOLLOW_ON_in_dateFactor3831);
                                stream_ON.add(ops);



                                break;

                        }

                        lit2=this.match(this.input,DATE_LITERAL,MentionQAst.FOLLOW_DATE_LITERAL_in_dateFactor3837);
                        stream_DATE_LITERAL.add(lit2);



                        // AST REWRITE
                        // elements: ops, lit2, o
                        // token labels: lit2, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_lit2=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit2",lit2);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 263:81: -> ^( FACTOR $o $ops $lit2)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:263:85: ^( FACTOR $o $ops $lit2)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit2.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:264:12: (ops= ON lit3= TODAY )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:264:12: (ops= ON lit3= TODAY )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:264:14: ops= ON lit3= TODAY
                        ops=this.match(this.input,ON,MentionQAst.FOLLOW_ON_in_dateFactor3885);
                        stream_ON.add(ops);

                        lit3=this.match(this.input,TODAY,MentionQAst.FOLLOW_TODAY_in_dateFactor3889);
                        stream_TODAY.add(lit3);






                        // AST REWRITE
                        // elements: lit3, o, ops
                        // token labels: lit3, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_lit3=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit3",lit3);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 264:81: -> ^( FACTOR $o $ops $lit3)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:264:85: ^( FACTOR $o $ops $lit3)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit3.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;

                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        dateUnknownFactor_return: (function() {
            MentionQAst.dateUnknownFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.dateUnknownFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:267:1: dateUnknownFactor : (o= TOMBSTONED | o= SCRUBBED | o= INTERACTION_FIRST_MENTION_PUBLISHED | o= INTERACTION_FIRST_RESPONSE_PUBLISHED | o= INTERACTION_LAST_MENTION_PUBLISHED ) ( ( (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral -> ^( FACTOR $o $ops $lit1) ) | ( (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL -> ^( FACTOR $o $ops $lit2) ) | ( (ops= IS | ops= ISNT ) lit3= UNKNOWN -> ^( FACTOR $o $ops $lit3) ) | (ops= ON lit4= TODAY ) -> ^( FACTOR $o $ops $lit4) ) ;
        // $ANTLR start "dateUnknownFactor"
        dateUnknownFactor: function() {
            var retval = new MentionQAst.dateUnknownFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit2 = null;
            var lit3 = null;
            var lit4 = null;
            var lit1 = null;

            var o_tree=null;
            var ops_tree=null;
            var lit2_tree=null;
            var lit3_tree=null;
            var lit4_tree=null;
            var stream_TODAY=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TODAY");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_TOMBSTONED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TOMBSTONED");
            var stream_INTERACTION_FIRST_RESPONSE_PUBLISHED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTERACTION_FIRST_RESPONSE_PUBLISHED");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_BEFORETHELAST=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token BEFORETHELAST");
            var stream_INTERACTION_FIRST_MENTION_PUBLISHED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTERACTION_FIRST_MENTION_PUBLISHED");
            var stream_INTHELAST=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTHELAST");
            var stream_ON=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ON");
            var stream_INTERACTION_LAST_MENTION_PUBLISHED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTERACTION_LAST_MENTION_PUBLISHED");
            var stream_BEFORE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token BEFORE");
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_AFTER=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AFTER");
            var stream_DATE_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token DATE_LITERAL");
            var stream_SCRUBBED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token SCRUBBED");
            var stream_periodLiteral=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule periodLiteral");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:268:5: ( (o= TOMBSTONED | o= SCRUBBED | o= INTERACTION_FIRST_MENTION_PUBLISHED | o= INTERACTION_FIRST_RESPONSE_PUBLISHED | o= INTERACTION_LAST_MENTION_PUBLISHED ) ( ( (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral -> ^( FACTOR $o $ops $lit1) ) | ( (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL -> ^( FACTOR $o $ops $lit2) ) | ( (ops= IS | ops= ISNT ) lit3= UNKNOWN -> ^( FACTOR $o $ops $lit3) ) | (ops= ON lit4= TODAY ) -> ^( FACTOR $o $ops $lit4) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:268:9: (o= TOMBSTONED | o= SCRUBBED | o= INTERACTION_FIRST_MENTION_PUBLISHED | o= INTERACTION_FIRST_RESPONSE_PUBLISHED | o= INTERACTION_LAST_MENTION_PUBLISHED ) ( ( (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral -> ^( FACTOR $o $ops $lit1) ) | ( (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL -> ^( FACTOR $o $ops $lit2) ) | ( (ops= IS | ops= ISNT ) lit3= UNKNOWN -> ^( FACTOR $o $ops $lit3) ) | (ops= ON lit4= TODAY ) -> ^( FACTOR $o $ops $lit4) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:268:9: (o= TOMBSTONED | o= SCRUBBED | o= INTERACTION_FIRST_MENTION_PUBLISHED | o= INTERACTION_FIRST_RESPONSE_PUBLISHED | o= INTERACTION_LAST_MENTION_PUBLISHED )
                var alt74=5;
                switch ( this.input.LA(1) ) {
                    case TOMBSTONED:
                        alt74=1;
                        break;
                    case SCRUBBED:
                        alt74=2;
                        break;
                    case INTERACTION_FIRST_MENTION_PUBLISHED:
                        alt74=3;
                        break;
                    case INTERACTION_FIRST_RESPONSE_PUBLISHED:
                        alt74=4;
                        break;
                    case INTERACTION_LAST_MENTION_PUBLISHED:
                        alt74=5;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 74, 0, this.input);

                        throw nvae;
                }

                switch (alt74) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:268:11: o= TOMBSTONED
                        o=this.match(this.input,TOMBSTONED,MentionQAst.FOLLOW_TOMBSTONED_in_dateUnknownFactor3978);
                        stream_TOMBSTONED.add(o);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:268:26: o= SCRUBBED
                        o=this.match(this.input,SCRUBBED,MentionQAst.FOLLOW_SCRUBBED_in_dateUnknownFactor3984);
                        stream_SCRUBBED.add(o);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:268:39: o= INTERACTION_FIRST_MENTION_PUBLISHED
                        o=this.match(this.input,INTERACTION_FIRST_MENTION_PUBLISHED,MentionQAst.FOLLOW_INTERACTION_FIRST_MENTION_PUBLISHED_in_dateUnknownFactor3990);
                        stream_INTERACTION_FIRST_MENTION_PUBLISHED.add(o);



                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:268:79: o= INTERACTION_FIRST_RESPONSE_PUBLISHED
                        o=this.match(this.input,INTERACTION_FIRST_RESPONSE_PUBLISHED,MentionQAst.FOLLOW_INTERACTION_FIRST_RESPONSE_PUBLISHED_in_dateUnknownFactor3996);
                        stream_INTERACTION_FIRST_RESPONSE_PUBLISHED.add(o);



                        break;
                    case 5 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:268:120: o= INTERACTION_LAST_MENTION_PUBLISHED
                        o=this.match(this.input,INTERACTION_LAST_MENTION_PUBLISHED,MentionQAst.FOLLOW_INTERACTION_LAST_MENTION_PUBLISHED_in_dateUnknownFactor4002);
                        stream_INTERACTION_LAST_MENTION_PUBLISHED.add(o);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:269:9: ( ( (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral -> ^( FACTOR $o $ops $lit1) ) | ( (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL -> ^( FACTOR $o $ops $lit2) ) | ( (ops= IS | ops= ISNT ) lit3= UNKNOWN -> ^( FACTOR $o $ops $lit3) ) | (ops= ON lit4= TODAY ) -> ^( FACTOR $o $ops $lit4) )
                var alt78=4;
                switch ( this.input.LA(1) ) {
                    case INTHELAST:
                    case BEFORETHELAST:
                        alt78=1;
                        break;
                    case BEFORE:
                    case AFTER:
                        alt78=2;
                        break;
                    case ON:
                        var LA78_3 = this.input.LA(2);

                        if ( (LA78_3==TODAY) ) {
                            alt78=4;
                        }
                        else if ( (LA78_3==DATE_LITERAL) ) {
                            alt78=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 78, 3, this.input);

                            throw nvae;
                        }
                        break;
                    case IS:
                    case ISNT:
                        alt78=3;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 78, 0, this.input);

                        throw nvae;
                }

                switch (alt78) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:269:10: ( (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral -> ^( FACTOR $o $ops $lit1) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:269:10: ( (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral -> ^( FACTOR $o $ops $lit1) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:269:11: (ops= INTHELAST | ops= BEFORETHELAST ) lit1= periodLiteral
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:269:11: (ops= INTHELAST | ops= BEFORETHELAST )
                        var alt75=2;
                        var LA75_0 = this.input.LA(1);

                        if ( (LA75_0==INTHELAST) ) {
                            alt75=1;
                        }
                        else if ( (LA75_0==BEFORETHELAST) ) {
                            alt75=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 75, 0, this.input);

                            throw nvae;
                        }
                        switch (alt75) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:269:13: ops= INTHELAST
                                ops=this.match(this.input,INTHELAST,MentionQAst.FOLLOW_INTHELAST_in_dateUnknownFactor4020);
                                stream_INTHELAST.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:269:29: ops= BEFORETHELAST
                                ops=this.match(this.input,BEFORETHELAST,MentionQAst.FOLLOW_BEFORETHELAST_in_dateUnknownFactor4026);
                                stream_BEFORETHELAST.add(ops);



                                break;

                        }

                        this.pushFollow(MentionQAst.FOLLOW_periodLiteral_in_dateUnknownFactor4032);
                        lit1=this.periodLiteral();

                        this.state._fsp--;

                        stream_periodLiteral.add(lit1.getTree());


                        // AST REWRITE
                        // elements: ops, lit1, o
                        // token labels: o, ops
                        // rule labels: lit1, retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_lit1=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token lit1",lit1!=null?lit1.tree:null);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 269:81: -> ^( FACTOR $o $ops $lit1)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:269:85: ^( FACTOR $o $ops $lit1)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit1.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:270:12: ( (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL -> ^( FACTOR $o $ops $lit2) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:270:12: ( (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL -> ^( FACTOR $o $ops $lit2) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:270:13: (ops= BEFORE | ops= AFTER | ops= ON ) lit2= DATE_LITERAL
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:270:13: (ops= BEFORE | ops= AFTER | ops= ON )
                        var alt76=3;
                        switch ( this.input.LA(1) ) {
                            case BEFORE:
                                alt76=1;
                                break;
                            case AFTER:
                                alt76=2;
                                break;
                            case ON:
                                alt76=3;
                                break;
                            default:
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 76, 0, this.input);

                                throw nvae;
                        }

                        switch (alt76) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:270:15: ops= BEFORE
                                ops=this.match(this.input,BEFORE,MentionQAst.FOLLOW_BEFORE_in_dateUnknownFactor4080);
                                stream_BEFORE.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:270:28: ops= AFTER
                                ops=this.match(this.input,AFTER,MentionQAst.FOLLOW_AFTER_in_dateUnknownFactor4086);
                                stream_AFTER.add(ops);



                                break;
                            case 3 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:270:40: ops= ON
                                ops=this.match(this.input,ON,MentionQAst.FOLLOW_ON_in_dateUnknownFactor4092);
                                stream_ON.add(ops);



                                break;

                        }

                        lit2=this.match(this.input,DATE_LITERAL,MentionQAst.FOLLOW_DATE_LITERAL_in_dateUnknownFactor4098);
                        stream_DATE_LITERAL.add(lit2);



                        // AST REWRITE
                        // elements: o, lit2, ops
                        // token labels: lit2, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_lit2=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit2",lit2);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 270:81: -> ^( FACTOR $o $ops $lit2)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:270:85: ^( FACTOR $o $ops $lit2)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit2.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:271:12: ( (ops= IS | ops= ISNT ) lit3= UNKNOWN -> ^( FACTOR $o $ops $lit3) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:271:12: ( (ops= IS | ops= ISNT ) lit3= UNKNOWN -> ^( FACTOR $o $ops $lit3) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:271:13: (ops= IS | ops= ISNT ) lit3= UNKNOWN
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:271:13: (ops= IS | ops= ISNT )
                        var alt77=2;
                        var LA77_0 = this.input.LA(1);

                        if ( (LA77_0==IS) ) {
                            alt77=1;
                        }
                        else if ( (LA77_0==ISNT) ) {
                            alt77=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 77, 0, this.input);

                            throw nvae;
                        }
                        switch (alt77) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:271:15: ops= IS
                                ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_dateUnknownFactor4147);
                                stream_IS.add(ops);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:271:24: ops= ISNT
                                ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_dateUnknownFactor4153);
                                stream_ISNT.add(ops);



                                break;

                        }

                        lit3=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_dateUnknownFactor4159);
                        stream_UNKNOWN.add(lit3);



                        // AST REWRITE
                        // elements: lit3, ops, o
                        // token labels: lit3, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_lit3=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit3",lit3);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 271:81: -> ^( FACTOR $o $ops $lit3)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:271:85: ^( FACTOR $o $ops $lit3)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit3.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:272:12: (ops= ON lit4= TODAY )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:272:12: (ops= ON lit4= TODAY )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:272:14: ops= ON lit4= TODAY
                        ops=this.match(this.input,ON,MentionQAst.FOLLOW_ON_in_dateUnknownFactor4226);
                        stream_ON.add(ops);

                        lit4=this.match(this.input,TODAY,MentionQAst.FOLLOW_TODAY_in_dateUnknownFactor4230);
                        stream_TODAY.add(lit4);






                        // AST REWRITE
                        // elements: o, ops, lit4
                        // token labels: lit4, o, ops
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_lit4=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit4",lit4);
                        var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                        var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 272:81: -> ^( FACTOR $o $ops $lit4)
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:272:85: ^( FACTOR $o $ops $lit4)
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                            this.adaptor.addChild(root_1, stream_o.nextNode());
                            this.adaptor.addChild(root_1, stream_ops.nextNode());
                            this.adaptor.addChild(root_1, stream_lit4.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;

                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        timeFactor_return: (function() {
            MentionQAst.timeFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.timeFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:275:1: timeFactor : (o= PUBLISHEDTIME ) (ops= BEFORE | ops= AFTER ) STRING_LITERAL -> ^( FACTOR $o $ops STRING_LITERAL ) ;
        // $ANTLR start "timeFactor"
        timeFactor: function() {
            var retval = new MentionQAst.timeFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var STRING_LITERAL63 = null;

            var o_tree=null;
            var ops_tree=null;
            var STRING_LITERAL63_tree=null;
            var stream_BEFORE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token BEFORE");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_AFTER=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AFTER");
            var stream_PUBLISHEDTIME=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token PUBLISHEDTIME");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:276:5: ( (o= PUBLISHEDTIME ) (ops= BEFORE | ops= AFTER ) STRING_LITERAL -> ^( FACTOR $o $ops STRING_LITERAL ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:276:9: (o= PUBLISHEDTIME ) (ops= BEFORE | ops= AFTER ) STRING_LITERAL
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:276:9: (o= PUBLISHEDTIME )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:276:10: o= PUBLISHEDTIME
                o=this.match(this.input,PUBLISHEDTIME,MentionQAst.FOLLOW_PUBLISHEDTIME_in_timeFactor4318);
                stream_PUBLISHEDTIME.add(o);




                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:276:27: (ops= BEFORE | ops= AFTER )
                var alt79=2;
                var LA79_0 = this.input.LA(1);

                if ( (LA79_0==BEFORE) ) {
                    alt79=1;
                }
                else if ( (LA79_0==AFTER) ) {
                    alt79=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 79, 0, this.input);

                    throw nvae;
                }
                switch (alt79) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:276:28: ops= BEFORE
                        ops=this.match(this.input,BEFORE,MentionQAst.FOLLOW_BEFORE_in_timeFactor4324);
                        stream_BEFORE.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:276:41: ops= AFTER
                        ops=this.match(this.input,AFTER,MentionQAst.FOLLOW_AFTER_in_timeFactor4330);
                        stream_AFTER.add(ops);



                        break;

                }

                STRING_LITERAL63=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_timeFactor4333);
                stream_STRING_LITERAL.add(STRING_LITERAL63);



                // AST REWRITE
                // elements: o, ops, STRING_LITERAL
                // token labels: o, ops
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 276:67: -> ^( FACTOR $o $ops STRING_LITERAL )
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:276:71: ^( FACTOR $o $ops STRING_LITERAL )
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_STRING_LITERAL.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        matchesFactor_return: (function() {
            MentionQAst.matchesFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.matchesFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:279:1: matchesFactor : (o= CONTENT | o= AUTHOR_BIO ) MATCHES STRING_LITERAL -> ^( FACTOR $o MATCHES STRING_LITERAL ) ;
        // $ANTLR start "matchesFactor"
        matchesFactor: function() {
            var retval = new MentionQAst.matchesFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var MATCHES64 = null;
            var STRING_LITERAL65 = null;

            var o_tree=null;
            var MATCHES64_tree=null;
            var STRING_LITERAL65_tree=null;
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_CONTENT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CONTENT");
            var stream_MATCHES=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token MATCHES");
            var stream_AUTHOR_BIO=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AUTHOR_BIO");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:280:5: ( (o= CONTENT | o= AUTHOR_BIO ) MATCHES STRING_LITERAL -> ^( FACTOR $o MATCHES STRING_LITERAL ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:280:9: (o= CONTENT | o= AUTHOR_BIO ) MATCHES STRING_LITERAL
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:280:9: (o= CONTENT | o= AUTHOR_BIO )
                var alt80=2;
                var LA80_0 = this.input.LA(1);

                if ( (LA80_0==CONTENT) ) {
                    alt80=1;
                }
                else if ( (LA80_0==AUTHOR_BIO) ) {
                    alt80=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 80, 0, this.input);

                    throw nvae;
                }
                switch (alt80) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:280:10: o= CONTENT
                        o=this.match(this.input,CONTENT,MentionQAst.FOLLOW_CONTENT_in_matchesFactor4370);
                        stream_CONTENT.add(o);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:280:22: o= AUTHOR_BIO
                        o=this.match(this.input,AUTHOR_BIO,MentionQAst.FOLLOW_AUTHOR_BIO_in_matchesFactor4376);
                        stream_AUTHOR_BIO.add(o);



                        break;

                }

                MATCHES64=this.match(this.input,MATCHES,MentionQAst.FOLLOW_MATCHES_in_matchesFactor4379);
                stream_MATCHES.add(MATCHES64);

                STRING_LITERAL65=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_matchesFactor4381);
                stream_STRING_LITERAL.add(STRING_LITERAL65);



                // AST REWRITE
                // elements: MATCHES, STRING_LITERAL, o
                // token labels: o
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 281:5: -> ^( FACTOR $o MATCHES STRING_LITERAL )
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:281:9: ^( FACTOR $o MATCHES STRING_LITERAL )
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_MATCHES.nextNode());
                        this.adaptor.addChild(root_1, stream_STRING_LITERAL.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        booleanFactor_return: (function() {
            MentionQAst.booleanFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.booleanFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:284:1: booleanFactor : (o= LINKED | o= RELEVANCY_VERIFIED | o= SENTIMENT_VERIFIED | o= CROWD_VERIFIED | o= UNBIASED_SAMPLE | o= DIRECT_MESSAGE | o= INTERACTION_HAS_RESPONSE ) (ops= IS | ops= ISNT ) (lit= TRUE | lit= FALSE ) -> ^( FACTOR $o $ops $lit) ;
        // $ANTLR start "booleanFactor"
        booleanFactor: function() {
            var retval = new MentionQAst.booleanFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var o = null;
            var ops = null;
            var lit = null;

            var o_tree=null;
            var ops_tree=null;
            var lit_tree=null;
            var stream_DIRECT_MESSAGE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token DIRECT_MESSAGE");
            var stream_INTERACTION_HAS_RESPONSE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token INTERACTION_HAS_RESPONSE");
            var stream_ISNT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ISNT");
            var stream_SENTIMENT_VERIFIED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token SENTIMENT_VERIFIED");
            var stream_RELEVANCY_VERIFIED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RELEVANCY_VERIFIED");
            var stream_FALSE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token FALSE");
            var stream_CROWD_VERIFIED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CROWD_VERIFIED");
            var stream_UNBIASED_SAMPLE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNBIASED_SAMPLE");
            var stream_IS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IS");
            var stream_TRUE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TRUE");
            var stream_LINKED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LINKED");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:285:5: ( (o= LINKED | o= RELEVANCY_VERIFIED | o= SENTIMENT_VERIFIED | o= CROWD_VERIFIED | o= UNBIASED_SAMPLE | o= DIRECT_MESSAGE | o= INTERACTION_HAS_RESPONSE ) (ops= IS | ops= ISNT ) (lit= TRUE | lit= FALSE ) -> ^( FACTOR $o $ops $lit) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:285:9: (o= LINKED | o= RELEVANCY_VERIFIED | o= SENTIMENT_VERIFIED | o= CROWD_VERIFIED | o= UNBIASED_SAMPLE | o= DIRECT_MESSAGE | o= INTERACTION_HAS_RESPONSE ) (ops= IS | ops= ISNT ) (lit= TRUE | lit= FALSE )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:285:9: (o= LINKED | o= RELEVANCY_VERIFIED | o= SENTIMENT_VERIFIED | o= CROWD_VERIFIED | o= UNBIASED_SAMPLE | o= DIRECT_MESSAGE | o= INTERACTION_HAS_RESPONSE )
                var alt81=7;
                switch ( this.input.LA(1) ) {
                    case LINKED:
                        alt81=1;
                        break;
                    case RELEVANCY_VERIFIED:
                        alt81=2;
                        break;
                    case SENTIMENT_VERIFIED:
                        alt81=3;
                        break;
                    case CROWD_VERIFIED:
                        alt81=4;
                        break;
                    case UNBIASED_SAMPLE:
                        alt81=5;
                        break;
                    case DIRECT_MESSAGE:
                        alt81=6;
                        break;
                    case INTERACTION_HAS_RESPONSE:
                        alt81=7;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 81, 0, this.input);

                        throw nvae;
                }

                switch (alt81) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:285:11: o= LINKED
                        o=this.match(this.input,LINKED,MentionQAst.FOLLOW_LINKED_in_booleanFactor4422);
                        stream_LINKED.add(o);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:285:22: o= RELEVANCY_VERIFIED
                        o=this.match(this.input,RELEVANCY_VERIFIED,MentionQAst.FOLLOW_RELEVANCY_VERIFIED_in_booleanFactor4428);
                        stream_RELEVANCY_VERIFIED.add(o);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:285:45: o= SENTIMENT_VERIFIED
                        o=this.match(this.input,SENTIMENT_VERIFIED,MentionQAst.FOLLOW_SENTIMENT_VERIFIED_in_booleanFactor4434);
                        stream_SENTIMENT_VERIFIED.add(o);



                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:285:68: o= CROWD_VERIFIED
                        o=this.match(this.input,CROWD_VERIFIED,MentionQAst.FOLLOW_CROWD_VERIFIED_in_booleanFactor4440);
                        stream_CROWD_VERIFIED.add(o);



                        break;
                    case 5 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:285:87: o= UNBIASED_SAMPLE
                        o=this.match(this.input,UNBIASED_SAMPLE,MentionQAst.FOLLOW_UNBIASED_SAMPLE_in_booleanFactor4446);
                        stream_UNBIASED_SAMPLE.add(o);



                        break;
                    case 6 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:285:107: o= DIRECT_MESSAGE
                        o=this.match(this.input,DIRECT_MESSAGE,MentionQAst.FOLLOW_DIRECT_MESSAGE_in_booleanFactor4452);
                        stream_DIRECT_MESSAGE.add(o);



                        break;
                    case 7 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:285:126: o= INTERACTION_HAS_RESPONSE
                        o=this.match(this.input,INTERACTION_HAS_RESPONSE,MentionQAst.FOLLOW_INTERACTION_HAS_RESPONSE_in_booleanFactor4458);
                        stream_INTERACTION_HAS_RESPONSE.add(o);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:286:9: (ops= IS | ops= ISNT )
                var alt82=2;
                var LA82_0 = this.input.LA(1);

                if ( (LA82_0==IS) ) {
                    alt82=1;
                }
                else if ( (LA82_0==ISNT) ) {
                    alt82=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 82, 0, this.input);

                    throw nvae;
                }
                switch (alt82) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:286:11: ops= IS
                        ops=this.match(this.input,IS,MentionQAst.FOLLOW_IS_in_booleanFactor4473);
                        stream_IS.add(ops);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:286:20: ops= ISNT
                        ops=this.match(this.input,ISNT,MentionQAst.FOLLOW_ISNT_in_booleanFactor4479);
                        stream_ISNT.add(ops);



                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:287:9: (lit= TRUE | lit= FALSE )
                var alt83=2;
                var LA83_0 = this.input.LA(1);

                if ( (LA83_0==TRUE) ) {
                    alt83=1;
                }
                else if ( (LA83_0==FALSE) ) {
                    alt83=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 83, 0, this.input);

                    throw nvae;
                }
                switch (alt83) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:287:11: lit= TRUE
                        lit=this.match(this.input,TRUE,MentionQAst.FOLLOW_TRUE_in_booleanFactor4495);
                        stream_TRUE.add(lit);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:287:22: lit= FALSE
                        lit=this.match(this.input,FALSE,MentionQAst.FOLLOW_FALSE_in_booleanFactor4501);
                        stream_FALSE.add(lit);



                        break;

                }



                // AST REWRITE
                // elements: o, lit, ops
                // token labels: lit, o, ops
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_lit=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token lit",lit);
                var stream_o=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token o",o);
                var stream_ops=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ops",ops);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 288:5: -> ^( FACTOR $o $ops $lit)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:288:9: ^( FACTOR $o $ops $lit)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(FACTOR, "FACTOR"), root_1);

                        this.adaptor.addChild(root_1, stream_o.nextNode());
                        this.adaptor.addChild(root_1, stream_ops.nextNode());
                        this.adaptor.addChild(root_1, stream_lit.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        stringOperator_return: (function() {
            MentionQAst.stringOperator_return = function(){};
            org.antlr.lang.extend(MentionQAst.stringOperator_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:292:1: stringOperator : ( CONTAINS | DOESNTCONTAIN | BEGINSWITH | ENDSWITH | IS | ISNT );
        // $ANTLR start "stringOperator"
        stringOperator: function() {
            var retval = new MentionQAst.stringOperator_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set66 = null;

            var set66_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:293:6: ( CONTAINS | DOESNTCONTAIN | BEGINSWITH | ENDSWITH | IS | ISNT )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set66=this.input.LT(1);
                if ( (this.input.LA(1)>=IS && this.input.LA(1)<=ISNT)||(this.input.LA(1)>=CONTAINS && this.input.LA(1)<=ENDSWITH) ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set66));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        isIsntOperator_return: (function() {
            MentionQAst.isIsntOperator_return = function(){};
            org.antlr.lang.extend(MentionQAst.isIsntOperator_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:296:1: isIsntOperator : ( IS | ISNT );
        // $ANTLR start "isIsntOperator"
        isIsntOperator: function() {
            var retval = new MentionQAst.isIsntOperator_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set67 = null;

            var set67_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:297:5: ( IS | ISNT )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set67=this.input.LT(1);
                if ( (this.input.LA(1)>=IS && this.input.LA(1)<=ISNT) ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set67));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        mediaLiteral_return: (function() {
            MentionQAst.mediaLiteral_return = function(){};
            org.antlr.lang.extend(MentionQAst.mediaLiteral_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:300:1: mediaLiteral : ( PRESS | ENTERPRISE | CONSUMER | DIRECTORY );
        // $ANTLR start "mediaLiteral"
        mediaLiteral: function() {
            var retval = new MentionQAst.mediaLiteral_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set68 = null;

            var set68_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:301:5: ( PRESS | ENTERPRISE | CONSUMER | DIRECTORY )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set68=this.input.LT(1);
                if ( (this.input.LA(1)>=PRESS && this.input.LA(1)<=DIRECTORY) ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set68));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        mediaLiteralAndUnknown_return: (function() {
            MentionQAst.mediaLiteralAndUnknown_return = function(){};
            org.antlr.lang.extend(MentionQAst.mediaLiteralAndUnknown_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:304:1: mediaLiteralAndUnknown : ( mediaLiteral | UNKNOWN );
        // $ANTLR start "mediaLiteralAndUnknown"
        mediaLiteralAndUnknown: function() {
            var retval = new MentionQAst.mediaLiteralAndUnknown_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var UNKNOWN70 = null;
            var mediaLiteral69 = null;

            var UNKNOWN70_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:305:5: ( mediaLiteral | UNKNOWN )
                var alt84=2;
                var LA84_0 = this.input.LA(1);

                if ( ((LA84_0>=PRESS && LA84_0<=DIRECTORY)) ) {
                    alt84=1;
                }
                else if ( (LA84_0==UNKNOWN) ) {
                    alt84=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 84, 0, this.input);

                    throw nvae;
                }
                switch (alt84) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:305:9: mediaLiteral
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_mediaLiteral_in_mediaLiteralAndUnknown4636);
                        mediaLiteral69=this.mediaLiteral();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, mediaLiteral69.getTree());


                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:305:24: UNKNOWN
                        root_0 = this.adaptor.nil();

                        UNKNOWN70=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_mediaLiteralAndUnknown4640);
                        UNKNOWN70_tree = this.adaptor.create(UNKNOWN70);
                        this.adaptor.addChild(root_0, UNKNOWN70_tree);



                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        unknownOrUnquotedString_return: (function() {
            MentionQAst.unknownOrUnquotedString_return = function(){};
            org.antlr.lang.extend(MentionQAst.unknownOrUnquotedString_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:308:1: unknownOrUnquotedString : ( UNKNOWN | UNQUOTED_STRING_LITERAL );
        // $ANTLR start "unknownOrUnquotedString"
        unknownOrUnquotedString: function() {
            var retval = new MentionQAst.unknownOrUnquotedString_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set71 = null;

            var set71_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:309:5: ( UNKNOWN | UNQUOTED_STRING_LITERAL )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set71=this.input.LT(1);
                if ( this.input.LA(1)==UNKNOWN||this.input.LA(1)==UNQUOTED_STRING_LITERAL ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set71));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        genderLiteral_return: (function() {
            MentionQAst.genderLiteral_return = function(){};
            org.antlr.lang.extend(MentionQAst.genderLiteral_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:311:1: genderLiteral : ( MALE | FEMALE | OTHER );
        // $ANTLR start "genderLiteral"
        genderLiteral: function() {
            var retval = new MentionQAst.genderLiteral_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set72 = null;

            var set72_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:312:5: ( MALE | FEMALE | OTHER )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set72=this.input.LT(1);
                if ( (this.input.LA(1)>=MALE && this.input.LA(1)<=OTHER) ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set72));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        genderLiteralAndUnknown_return: (function() {
            MentionQAst.genderLiteralAndUnknown_return = function(){};
            org.antlr.lang.extend(MentionQAst.genderLiteralAndUnknown_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:315:1: genderLiteralAndUnknown : ( genderLiteral | UNKNOWN );
        // $ANTLR start "genderLiteralAndUnknown"
        genderLiteralAndUnknown: function() {
            var retval = new MentionQAst.genderLiteralAndUnknown_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var UNKNOWN74 = null;
            var genderLiteral73 = null;

            var UNKNOWN74_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:316:5: ( genderLiteral | UNKNOWN )
                var alt85=2;
                var LA85_0 = this.input.LA(1);

                if ( ((LA85_0>=MALE && LA85_0<=OTHER)) ) {
                    alt85=1;
                }
                else if ( (LA85_0==UNKNOWN) ) {
                    alt85=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 85, 0, this.input);

                    throw nvae;
                }
                switch (alt85) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:316:7: genderLiteral
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_genderLiteral_in_genderLiteralAndUnknown4698);
                        genderLiteral73=this.genderLiteral();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, genderLiteral73.getTree());


                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:316:23: UNKNOWN
                        root_0 = this.adaptor.nil();

                        UNKNOWN74=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_genderLiteralAndUnknown4702);
                        UNKNOWN74_tree = this.adaptor.create(UNKNOWN74);
                        this.adaptor.addChild(root_0, UNKNOWN74_tree);



                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        relevancyLiteral_return: (function() {
            MentionQAst.relevancyLiteral_return = function(){};
            org.antlr.lang.extend(MentionQAst.relevancyLiteral_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:319:1: relevancyLiteral : ( UNSORTED | RELEVANT | DUPLICATE | IRRELEVANT | SPAM );
        // $ANTLR start "relevancyLiteral"
        relevancyLiteral: function() {
            var retval = new MentionQAst.relevancyLiteral_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set75 = null;

            var set75_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:320:5: ( UNSORTED | RELEVANT | DUPLICATE | IRRELEVANT | SPAM )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set75=this.input.LT(1);
                if ( (this.input.LA(1)>=UNSORTED && this.input.LA(1)<=SPAM) ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set75));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        processLiteral_return: (function() {
            MentionQAst.processLiteral_return = function(){};
            org.antlr.lang.extend(MentionQAst.processLiteral_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:323:1: processLiteral : ( UNSORTED | SORTED | VERIFIED );
        // $ANTLR start "processLiteral"
        processLiteral: function() {
            var retval = new MentionQAst.processLiteral_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set76 = null;

            var set76_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:324:5: ( UNSORTED | SORTED | VERIFIED )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set76=this.input.LT(1);
                if ( this.input.LA(1)==UNSORTED||(this.input.LA(1)>=SORTED && this.input.LA(1)<=VERIFIED) ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set76));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        actionLiteral_return: (function() {
            MentionQAst.actionLiteral_return = function(){};
            org.antlr.lang.extend(MentionQAst.actionLiteral_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:327:1: actionLiteral : ( NONE | RESOLVED | UNRESOLVED );
        // $ANTLR start "actionLiteral"
        actionLiteral: function() {
            var retval = new MentionQAst.actionLiteral_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set77 = null;

            var set77_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:328:5: ( NONE | RESOLVED | UNRESOLVED )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set77=this.input.LT(1);
                if ( (this.input.LA(1)>=NONE && this.input.LA(1)<=UNRESOLVED) ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set77));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        actionLiteralAndUnknown_return: (function() {
            MentionQAst.actionLiteralAndUnknown_return = function(){};
            org.antlr.lang.extend(MentionQAst.actionLiteralAndUnknown_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:331:1: actionLiteralAndUnknown : ( actionLiteral | UNKNOWN );
        // $ANTLR start "actionLiteralAndUnknown"
        actionLiteralAndUnknown: function() {
            var retval = new MentionQAst.actionLiteralAndUnknown_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var UNKNOWN79 = null;
            var actionLiteral78 = null;

            var UNKNOWN79_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:332:5: ( actionLiteral | UNKNOWN )
                var alt86=2;
                var LA86_0 = this.input.LA(1);

                if ( ((LA86_0>=NONE && LA86_0<=UNRESOLVED)) ) {
                    alt86=1;
                }
                else if ( (LA86_0==UNKNOWN) ) {
                    alt86=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 86, 0, this.input);

                    throw nvae;
                }
                switch (alt86) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:332:9: actionLiteral
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_actionLiteral_in_actionLiteralAndUnknown4810);
                        actionLiteral78=this.actionLiteral();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, actionLiteral78.getTree());


                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:332:25: UNKNOWN
                        root_0 = this.adaptor.nil();

                        UNKNOWN79=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_actionLiteralAndUnknown4814);
                        UNKNOWN79_tree = this.adaptor.create(UNKNOWN79);
                        this.adaptor.addChild(root_0, UNKNOWN79_tree);



                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        periodLiteral_return: (function() {
            MentionQAst.periodLiteral_return = function(){};
            org.antlr.lang.extend(MentionQAst.periodLiteral_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:335:1: periodLiteral : ( HOUR | DAY | TWENTY_FOUR_HRS | WEEK | FORTNIGHT | MONTH | QUARTER | YEAR | EPOCH );
        // $ANTLR start "periodLiteral"
        periodLiteral: function() {
            var retval = new MentionQAst.periodLiteral_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set80 = null;

            var set80_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:336:5: ( HOUR | DAY | TWENTY_FOUR_HRS | WEEK | FORTNIGHT | MONTH | QUARTER | YEAR | EPOCH )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set80=this.input.LT(1);
                if ( (this.input.LA(1)>=HOUR && this.input.LA(1)<=MONTH)||(this.input.LA(1)>=QUARTER && this.input.LA(1)<=EPOCH) ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set80));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        groupPeriodLiteral_return: (function() {
            MentionQAst.groupPeriodLiteral_return = function(){};
            org.antlr.lang.extend(MentionQAst.groupPeriodLiteral_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:339:1: groupPeriodLiteral : ( hourPeriod | DAY | WEEK | FORTNIGHT | MONTH | QUARTER | YEAR );
        // $ANTLR start "groupPeriodLiteral"
        groupPeriodLiteral: function() {
            var retval = new MentionQAst.groupPeriodLiteral_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var DAY82 = null;
            var WEEK83 = null;
            var FORTNIGHT84 = null;
            var MONTH85 = null;
            var QUARTER86 = null;
            var YEAR87 = null;
            var hourPeriod81 = null;

            var DAY82_tree=null;
            var WEEK83_tree=null;
            var FORTNIGHT84_tree=null;
            var MONTH85_tree=null;
            var QUARTER86_tree=null;
            var YEAR87_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:340:5: ( hourPeriod | DAY | WEEK | FORTNIGHT | MONTH | QUARTER | YEAR )
                var alt87=7;
                switch ( this.input.LA(1) ) {
                    case HOUR:
                        alt87=1;
                        break;
                    case DAY:
                        alt87=2;
                        break;
                    case WEEK:
                        alt87=3;
                        break;
                    case FORTNIGHT:
                        alt87=4;
                        break;
                    case MONTH:
                        alt87=5;
                        break;
                    case QUARTER:
                        alt87=6;
                        break;
                    case YEAR:
                        alt87=7;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 87, 0, this.input);

                        throw nvae;
                }

                switch (alt87) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:340:9: hourPeriod
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_hourPeriod_in_groupPeriodLiteral4884);
                        hourPeriod81=this.hourPeriod();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, hourPeriod81.getTree());


                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:340:22: DAY
                        root_0 = this.adaptor.nil();

                        DAY82=this.match(this.input,DAY,MentionQAst.FOLLOW_DAY_in_groupPeriodLiteral4888);
                        DAY82_tree = this.adaptor.create(DAY82);
                        this.adaptor.addChild(root_0, DAY82_tree);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:340:28: WEEK
                        root_0 = this.adaptor.nil();

                        WEEK83=this.match(this.input,WEEK,MentionQAst.FOLLOW_WEEK_in_groupPeriodLiteral4892);
                        WEEK83_tree = this.adaptor.create(WEEK83);
                        this.adaptor.addChild(root_0, WEEK83_tree);



                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:340:35: FORTNIGHT
                        root_0 = this.adaptor.nil();

                        FORTNIGHT84=this.match(this.input,FORTNIGHT,MentionQAst.FOLLOW_FORTNIGHT_in_groupPeriodLiteral4896);
                        FORTNIGHT84_tree = this.adaptor.create(FORTNIGHT84);
                        this.adaptor.addChild(root_0, FORTNIGHT84_tree);



                        break;
                    case 5 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:340:47: MONTH
                        root_0 = this.adaptor.nil();

                        MONTH85=this.match(this.input,MONTH,MentionQAst.FOLLOW_MONTH_in_groupPeriodLiteral4900);
                        MONTH85_tree = this.adaptor.create(MONTH85);
                        this.adaptor.addChild(root_0, MONTH85_tree);



                        break;
                    case 6 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:340:55: QUARTER
                        root_0 = this.adaptor.nil();

                        QUARTER86=this.match(this.input,QUARTER,MentionQAst.FOLLOW_QUARTER_in_groupPeriodLiteral4904);
                        QUARTER86_tree = this.adaptor.create(QUARTER86);
                        this.adaptor.addChild(root_0, QUARTER86_tree);



                        break;
                    case 7 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:340:65: YEAR
                        root_0 = this.adaptor.nil();

                        YEAR87=this.match(this.input,YEAR,MentionQAst.FOLLOW_YEAR_in_groupPeriodLiteral4908);
                        YEAR87_tree = this.adaptor.create(YEAR87);
                        this.adaptor.addChild(root_0, YEAR87_tree);



                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        hourPeriod_return: (function() {
            MentionQAst.hourPeriod_return = function(){};
            org.antlr.lang.extend(MentionQAst.hourPeriod_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:343:1: hourPeriod : ( HOUR | HOUR DIVIDE LONG_LITERAL );
        // $ANTLR start "hourPeriod"
        hourPeriod: function() {
            var retval = new MentionQAst.hourPeriod_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var HOUR88 = null;
            var HOUR89 = null;
            var DIVIDE90 = null;
            var LONG_LITERAL91 = null;

            var HOUR88_tree=null;
            var HOUR89_tree=null;
            var DIVIDE90_tree=null;
            var LONG_LITERAL91_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:344:5: ( HOUR | HOUR DIVIDE LONG_LITERAL )
                var alt88=2;
                var LA88_0 = this.input.LA(1);

                if ( (LA88_0==HOUR) ) {
                    var LA88_1 = this.input.LA(2);

                    if ( (LA88_1==DIVIDE) ) {
                        alt88=2;
                    }
                    else if ( (LA88_1==RSQUARE) ) {
                        alt88=1;
                    }
                    else {
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 88, 1, this.input);

                        throw nvae;
                    }
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 88, 0, this.input);

                    throw nvae;
                }
                switch (alt88) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:344:9: HOUR
                        root_0 = this.adaptor.nil();

                        HOUR88=this.match(this.input,HOUR,MentionQAst.FOLLOW_HOUR_in_hourPeriod4927);
                        HOUR88_tree = this.adaptor.create(HOUR88);
                        this.adaptor.addChild(root_0, HOUR88_tree);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:345:9: HOUR DIVIDE LONG_LITERAL
                        root_0 = this.adaptor.nil();

                        HOUR89=this.match(this.input,HOUR,MentionQAst.FOLLOW_HOUR_in_hourPeriod4937);
                        DIVIDE90=this.match(this.input,DIVIDE,MentionQAst.FOLLOW_DIVIDE_in_hourPeriod4940);
                        LONG_LITERAL91=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_hourPeriod4943);
                        LONG_LITERAL91_tree = this.adaptor.create(LONG_LITERAL91);
                        this.adaptor.addChild(root_0, LONG_LITERAL91_tree);



                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        authors_return: (function() {
            MentionQAst.authors_return = function(){};
            org.antlr.lang.extend(MentionQAst.authors_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:351:1: authors : authorsExpression EOF ;
        // $ANTLR start "authors"
        authors: function() {
            var retval = new MentionQAst.authors_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var EOF93 = null;
            var authorsExpression92 = null;

            var EOF93_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:352:5: ( authorsExpression EOF )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:352:9: authorsExpression EOF
                root_0 = this.adaptor.nil();

                this.pushFollow(MentionQAst.FOLLOW_authorsExpression_in_authors4965);
                authorsExpression92=this.authorsExpression();

                this.state._fsp--;

                this.adaptor.addChild(root_0, authorsExpression92.getTree());
                EOF93=this.match(this.input,EOF,MentionQAst.FOLLOW_EOF_in_authors4967);



                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        authorsExpression_return: (function() {
            MentionQAst.authorsExpression_return = function(){};
            org.antlr.lang.extend(MentionQAst.authorsExpression_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:355:1: authorsExpression : first= authorsTerm ( OR second= authorsExpression )? -> ^( OR_NODE $first ( $second)? ) ;
        // $ANTLR start "authorsExpression"
        authorsExpression: function() {
            var retval = new MentionQAst.authorsExpression_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var OR94 = null;
            var first = null;
            var second = null;

            var OR94_tree=null;
            var stream_OR=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token OR");
            var stream_authorsExpression=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule authorsExpression");
            var stream_authorsTerm=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule authorsTerm");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:356:5: (first= authorsTerm ( OR second= authorsExpression )? -> ^( OR_NODE $first ( $second)? ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:356:9: first= authorsTerm ( OR second= authorsExpression )?
                this.pushFollow(MentionQAst.FOLLOW_authorsTerm_in_authorsExpression4989);
                first=this.authorsTerm();

                this.state._fsp--;

                stream_authorsTerm.add(first.getTree());
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:356:27: ( OR second= authorsExpression )?
                var alt89=2;
                var LA89_0 = this.input.LA(1);

                if ( (LA89_0==OR) ) {
                    alt89=1;
                }
                switch (alt89) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:356:29: OR second= authorsExpression
                        OR94=this.match(this.input,OR,MentionQAst.FOLLOW_OR_in_authorsExpression4993);
                        stream_OR.add(OR94);

                        this.pushFollow(MentionQAst.FOLLOW_authorsExpression_in_authorsExpression4997);
                        second=this.authorsExpression();

                        this.state._fsp--;

                        stream_authorsExpression.add(second.getTree());


                        break;

                }



                // AST REWRITE
                // elements: first, second
                // token labels:
                // rule labels: retval, second, first
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);
                var stream_second=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token second",second!=null?second.tree:null);
                var stream_first=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token first",first!=null?first.tree:null);

                root_0 = this.adaptor.nil();
                // 356:74: -> ^( OR_NODE $first ( $second)? )
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:356:77: ^( OR_NODE $first ( $second)? )
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(OR_NODE, "OR_NODE"), root_1);

                        this.adaptor.addChild(root_1, stream_first.nextTree());
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:356:94: ( $second)?
                        if ( stream_second.hasNext() ) {
                            this.adaptor.addChild(root_1, stream_second.nextTree());

                        }
                        stream_second.reset();

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        authorsTerm_return: (function() {
            MentionQAst.authorsTerm_return = function(){};
            org.antlr.lang.extend(MentionQAst.authorsTerm_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:359:1: authorsTerm : first= authorsFactor ( AND second= authorsTerm )? -> ^( AND_NODE $first ( $second)? ) ;
        // $ANTLR start "authorsTerm"
        authorsTerm: function() {
            var retval = new MentionQAst.authorsTerm_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var AND95 = null;
            var first = null;
            var second = null;

            var AND95_tree=null;
            var stream_AND=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token AND");
            var stream_authorsFactor=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule authorsFactor");
            var stream_authorsTerm=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule authorsTerm");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:360:5: (first= authorsFactor ( AND second= authorsTerm )? -> ^( AND_NODE $first ( $second)? ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:360:9: first= authorsFactor ( AND second= authorsTerm )?
                this.pushFollow(MentionQAst.FOLLOW_authorsFactor_in_authorsTerm5048);
                first=this.authorsFactor();

                this.state._fsp--;

                stream_authorsFactor.add(first.getTree());
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:360:29: ( AND second= authorsTerm )?
                var alt90=2;
                var LA90_0 = this.input.LA(1);

                if ( (LA90_0==AND) ) {
                    alt90=1;
                }
                switch (alt90) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:360:31: AND second= authorsTerm
                        AND95=this.match(this.input,AND,MentionQAst.FOLLOW_AND_in_authorsTerm5052);
                        stream_AND.add(AND95);

                        this.pushFollow(MentionQAst.FOLLOW_authorsTerm_in_authorsTerm5056);
                        second=this.authorsTerm();

                        this.state._fsp--;

                        stream_authorsTerm.add(second.getTree());


                        break;

                }



                // AST REWRITE
                // elements: first, second
                // token labels:
                // rule labels: retval, second, first
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);
                var stream_second=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token second",second!=null?second.tree:null);
                var stream_first=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token first",first!=null?first.tree:null);

                root_0 = this.adaptor.nil();
                // 360:74: -> ^( AND_NODE $first ( $second)? )
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:360:77: ^( AND_NODE $first ( $second)? )
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(AND_NODE, "AND_NODE"), root_1);

                        this.adaptor.addChild(root_1, stream_first.nextTree());
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:360:95: ( $second)?
                        if ( stream_second.hasNext() ) {
                            this.adaptor.addChild(root_1, stream_second.nextTree());

                        }
                        stream_second.reset();

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        authorsFactor_return: (function() {
            MentionQAst.authorsFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.authorsFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:363:1: authorsFactor : ( generalTwitterScreenNameFactor | generalFacebookIdFactor | generalHandleIdFactor );
        // $ANTLR start "authorsFactor"
        authorsFactor: function() {
            var retval = new MentionQAst.authorsFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var generalTwitterScreenNameFactor96 = null;
            var generalFacebookIdFactor97 = null;
            var generalHandleIdFactor98 = null;


            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:364:5: ( generalTwitterScreenNameFactor | generalFacebookIdFactor | generalHandleIdFactor )
                var alt91=3;
                switch ( this.input.LA(1) ) {
                    case TWITTER_SCREEN_NAME:
                        alt91=1;
                        break;
                    case FACEBOOK_ID:
                        alt91=2;
                        break;
                    case HANDLE_ID:
                        alt91=3;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 91, 0, this.input);

                        throw nvae;
                }

                switch (alt91) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:364:9: generalTwitterScreenNameFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalTwitterScreenNameFactor_in_authorsFactor5108);
                        generalTwitterScreenNameFactor96=this.generalTwitterScreenNameFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalTwitterScreenNameFactor96.getTree());


                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:365:9: generalFacebookIdFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalFacebookIdFactor_in_authorsFactor5118);
                        generalFacebookIdFactor97=this.generalFacebookIdFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalFacebookIdFactor97.getTree());


                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:366:9: generalHandleIdFactor
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalHandleIdFactor_in_authorsFactor5128);
                        generalHandleIdFactor98=this.generalHandleIdFactor();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalHandleIdFactor98.getTree());


                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalTwitterScreenNameFactor_return: (function() {
            MentionQAst.generalTwitterScreenNameFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalTwitterScreenNameFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:369:1: generalTwitterScreenNameFactor : TWITTER_SCREEN_NAME ( ( stringOperator STRING_LITERAL -> ^( AUTHOR TWITTER_SCREEN_NAME stringOperator STRING_LITERAL ) ) | ( IN stringList -> ^( AUTHOR TWITTER_SCREEN_NAME IN stringList ) ) ) ;
        // $ANTLR start "generalTwitterScreenNameFactor"
        generalTwitterScreenNameFactor: function() {
            var retval = new MentionQAst.generalTwitterScreenNameFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var TWITTER_SCREEN_NAME99 = null;
            var STRING_LITERAL101 = null;
            var IN102 = null;
            var stringOperator100 = null;
            var stringList103 = null;

            var TWITTER_SCREEN_NAME99_tree=null;
            var STRING_LITERAL101_tree=null;
            var IN102_tree=null;
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_IN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IN");
            var stream_TWITTER_SCREEN_NAME=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TWITTER_SCREEN_NAME");
            var stream_stringOperator=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule stringOperator");
            var stream_stringList=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule stringList");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:370:5: ( TWITTER_SCREEN_NAME ( ( stringOperator STRING_LITERAL -> ^( AUTHOR TWITTER_SCREEN_NAME stringOperator STRING_LITERAL ) ) | ( IN stringList -> ^( AUTHOR TWITTER_SCREEN_NAME IN stringList ) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:370:9: TWITTER_SCREEN_NAME ( ( stringOperator STRING_LITERAL -> ^( AUTHOR TWITTER_SCREEN_NAME stringOperator STRING_LITERAL ) ) | ( IN stringList -> ^( AUTHOR TWITTER_SCREEN_NAME IN stringList ) ) )
                TWITTER_SCREEN_NAME99=this.match(this.input,TWITTER_SCREEN_NAME,MentionQAst.FOLLOW_TWITTER_SCREEN_NAME_in_generalTwitterScreenNameFactor5147);
                stream_TWITTER_SCREEN_NAME.add(TWITTER_SCREEN_NAME99);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:370:29: ( ( stringOperator STRING_LITERAL -> ^( AUTHOR TWITTER_SCREEN_NAME stringOperator STRING_LITERAL ) ) | ( IN stringList -> ^( AUTHOR TWITTER_SCREEN_NAME IN stringList ) ) )
                var alt92=2;
                var LA92_0 = this.input.LA(1);

                if ( ((LA92_0>=IS && LA92_0<=ISNT)||(LA92_0>=CONTAINS && LA92_0<=ENDSWITH)) ) {
                    alt92=1;
                }
                else if ( (LA92_0==IN) ) {
                    alt92=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 92, 0, this.input);

                    throw nvae;
                }
                switch (alt92) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:370:30: ( stringOperator STRING_LITERAL -> ^( AUTHOR TWITTER_SCREEN_NAME stringOperator STRING_LITERAL ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:370:30: ( stringOperator STRING_LITERAL -> ^( AUTHOR TWITTER_SCREEN_NAME stringOperator STRING_LITERAL ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:370:31: stringOperator STRING_LITERAL
                        this.pushFollow(MentionQAst.FOLLOW_stringOperator_in_generalTwitterScreenNameFactor5151);
                        stringOperator100=this.stringOperator();

                        this.state._fsp--;

                        stream_stringOperator.add(stringOperator100.getTree());
                        STRING_LITERAL101=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_generalTwitterScreenNameFactor5153);
                        stream_STRING_LITERAL.add(STRING_LITERAL101);



                        // AST REWRITE
                        // elements: STRING_LITERAL, stringOperator, TWITTER_SCREEN_NAME
                        // token labels:
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 370:61: -> ^( AUTHOR TWITTER_SCREEN_NAME stringOperator STRING_LITERAL )
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:370:64: ^( AUTHOR TWITTER_SCREEN_NAME stringOperator STRING_LITERAL )
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(AUTHOR, "AUTHOR"), root_1);

                            this.adaptor.addChild(root_1, stream_TWITTER_SCREEN_NAME.nextNode());
                            this.adaptor.addChild(root_1, stream_stringOperator.nextTree());
                            this.adaptor.addChild(root_1, stream_STRING_LITERAL.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:372:29: ( IN stringList -> ^( AUTHOR TWITTER_SCREEN_NAME IN stringList ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:372:29: ( IN stringList -> ^( AUTHOR TWITTER_SCREEN_NAME IN stringList ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:372:31: IN stringList
                        IN102=this.match(this.input,IN,MentionQAst.FOLLOW_IN_in_generalTwitterScreenNameFactor5230);
                        stream_IN.add(IN102);

                        this.pushFollow(MentionQAst.FOLLOW_stringList_in_generalTwitterScreenNameFactor5232);
                        stringList103=this.stringList();

                        this.state._fsp--;

                        stream_stringList.add(stringList103.getTree());


                        // AST REWRITE
                        // elements: stringList, IN, TWITTER_SCREEN_NAME
                        // token labels:
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 372:61: -> ^( AUTHOR TWITTER_SCREEN_NAME IN stringList )
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:372:64: ^( AUTHOR TWITTER_SCREEN_NAME IN stringList )
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(AUTHOR, "AUTHOR"), root_1);

                            this.adaptor.addChild(root_1, stream_TWITTER_SCREEN_NAME.nextNode());
                            this.adaptor.addChild(root_1, stream_IN.nextNode());
                            this.adaptor.addChild(root_1, stream_stringList.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;

                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalFacebookIdFactor_return: (function() {
            MentionQAst.generalFacebookIdFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalFacebookIdFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:375:1: generalFacebookIdFactor : FACEBOOK_ID ( ( stringOperator STRING_LITERAL -> ^( AUTHOR FACEBOOK_ID stringOperator STRING_LITERAL ) ) | ( IN stringList -> ^( AUTHOR FACEBOOK_ID IN stringList ) ) ) ;
        // $ANTLR start "generalFacebookIdFactor"
        generalFacebookIdFactor: function() {
            var retval = new MentionQAst.generalFacebookIdFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var FACEBOOK_ID104 = null;
            var STRING_LITERAL106 = null;
            var IN107 = null;
            var stringOperator105 = null;
            var stringList108 = null;

            var FACEBOOK_ID104_tree=null;
            var STRING_LITERAL106_tree=null;
            var IN107_tree=null;
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_IN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IN");
            var stream_FACEBOOK_ID=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token FACEBOOK_ID");
            var stream_stringOperator=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule stringOperator");
            var stream_stringList=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule stringList");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:376:5: ( FACEBOOK_ID ( ( stringOperator STRING_LITERAL -> ^( AUTHOR FACEBOOK_ID stringOperator STRING_LITERAL ) ) | ( IN stringList -> ^( AUTHOR FACEBOOK_ID IN stringList ) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:376:9: FACEBOOK_ID ( ( stringOperator STRING_LITERAL -> ^( AUTHOR FACEBOOK_ID stringOperator STRING_LITERAL ) ) | ( IN stringList -> ^( AUTHOR FACEBOOK_ID IN stringList ) ) )
                FACEBOOK_ID104=this.match(this.input,FACEBOOK_ID,MentionQAst.FOLLOW_FACEBOOK_ID_in_generalFacebookIdFactor5281);
                stream_FACEBOOK_ID.add(FACEBOOK_ID104);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:376:21: ( ( stringOperator STRING_LITERAL -> ^( AUTHOR FACEBOOK_ID stringOperator STRING_LITERAL ) ) | ( IN stringList -> ^( AUTHOR FACEBOOK_ID IN stringList ) ) )
                var alt93=2;
                var LA93_0 = this.input.LA(1);

                if ( ((LA93_0>=IS && LA93_0<=ISNT)||(LA93_0>=CONTAINS && LA93_0<=ENDSWITH)) ) {
                    alt93=1;
                }
                else if ( (LA93_0==IN) ) {
                    alt93=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 93, 0, this.input);

                    throw nvae;
                }
                switch (alt93) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:376:22: ( stringOperator STRING_LITERAL -> ^( AUTHOR FACEBOOK_ID stringOperator STRING_LITERAL ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:376:22: ( stringOperator STRING_LITERAL -> ^( AUTHOR FACEBOOK_ID stringOperator STRING_LITERAL ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:376:23: stringOperator STRING_LITERAL
                        this.pushFollow(MentionQAst.FOLLOW_stringOperator_in_generalFacebookIdFactor5285);
                        stringOperator105=this.stringOperator();

                        this.state._fsp--;

                        stream_stringOperator.add(stringOperator105.getTree());
                        STRING_LITERAL106=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_generalFacebookIdFactor5287);
                        stream_STRING_LITERAL.add(STRING_LITERAL106);



                        // AST REWRITE
                        // elements: FACEBOOK_ID, stringOperator, STRING_LITERAL
                        // token labels:
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 376:53: -> ^( AUTHOR FACEBOOK_ID stringOperator STRING_LITERAL )
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:376:56: ^( AUTHOR FACEBOOK_ID stringOperator STRING_LITERAL )
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(AUTHOR, "AUTHOR"), root_1);

                            this.adaptor.addChild(root_1, stream_FACEBOOK_ID.nextNode());
                            this.adaptor.addChild(root_1, stream_stringOperator.nextTree());
                            this.adaptor.addChild(root_1, stream_STRING_LITERAL.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:378:29: ( IN stringList -> ^( AUTHOR FACEBOOK_ID IN stringList ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:378:29: ( IN stringList -> ^( AUTHOR FACEBOOK_ID IN stringList ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:378:31: IN stringList
                        IN107=this.match(this.input,IN,MentionQAst.FOLLOW_IN_in_generalFacebookIdFactor5364);
                        stream_IN.add(IN107);

                        this.pushFollow(MentionQAst.FOLLOW_stringList_in_generalFacebookIdFactor5366);
                        stringList108=this.stringList();

                        this.state._fsp--;

                        stream_stringList.add(stringList108.getTree());


                        // AST REWRITE
                        // elements: stringList, FACEBOOK_ID, IN
                        // token labels:
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 378:61: -> ^( AUTHOR FACEBOOK_ID IN stringList )
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:378:64: ^( AUTHOR FACEBOOK_ID IN stringList )
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(AUTHOR, "AUTHOR"), root_1);

                            this.adaptor.addChild(root_1, stream_FACEBOOK_ID.nextNode());
                            this.adaptor.addChild(root_1, stream_IN.nextNode());
                            this.adaptor.addChild(root_1, stream_stringList.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;

                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalHandleIdFactor_return: (function() {
            MentionQAst.generalHandleIdFactor_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalHandleIdFactor_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:381:1: generalHandleIdFactor : HANDLE_ID ( ( stringOperator STRING_LITERAL -> ^( AUTHOR HANDLE_ID stringOperator STRING_LITERAL ) ) | ( IN stringList -> ^( AUTHOR HANDLE_ID IN stringList ) ) ) ;
        // $ANTLR start "generalHandleIdFactor"
        generalHandleIdFactor: function() {
            var retval = new MentionQAst.generalHandleIdFactor_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var HANDLE_ID109 = null;
            var STRING_LITERAL111 = null;
            var IN112 = null;
            var stringOperator110 = null;
            var stringList113 = null;

            var HANDLE_ID109_tree=null;
            var STRING_LITERAL111_tree=null;
            var IN112_tree=null;
            var stream_HANDLE_ID=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token HANDLE_ID");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_IN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IN");
            var stream_stringOperator=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule stringOperator");
            var stream_stringList=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule stringList");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:382:5: ( HANDLE_ID ( ( stringOperator STRING_LITERAL -> ^( AUTHOR HANDLE_ID stringOperator STRING_LITERAL ) ) | ( IN stringList -> ^( AUTHOR HANDLE_ID IN stringList ) ) ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:382:9: HANDLE_ID ( ( stringOperator STRING_LITERAL -> ^( AUTHOR HANDLE_ID stringOperator STRING_LITERAL ) ) | ( IN stringList -> ^( AUTHOR HANDLE_ID IN stringList ) ) )
                HANDLE_ID109=this.match(this.input,HANDLE_ID,MentionQAst.FOLLOW_HANDLE_ID_in_generalHandleIdFactor5415);
                stream_HANDLE_ID.add(HANDLE_ID109);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:382:19: ( ( stringOperator STRING_LITERAL -> ^( AUTHOR HANDLE_ID stringOperator STRING_LITERAL ) ) | ( IN stringList -> ^( AUTHOR HANDLE_ID IN stringList ) ) )
                var alt94=2;
                var LA94_0 = this.input.LA(1);

                if ( ((LA94_0>=IS && LA94_0<=ISNT)||(LA94_0>=CONTAINS && LA94_0<=ENDSWITH)) ) {
                    alt94=1;
                }
                else if ( (LA94_0==IN) ) {
                    alt94=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 94, 0, this.input);

                    throw nvae;
                }
                switch (alt94) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:382:20: ( stringOperator STRING_LITERAL -> ^( AUTHOR HANDLE_ID stringOperator STRING_LITERAL ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:382:20: ( stringOperator STRING_LITERAL -> ^( AUTHOR HANDLE_ID stringOperator STRING_LITERAL ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:382:21: stringOperator STRING_LITERAL
                        this.pushFollow(MentionQAst.FOLLOW_stringOperator_in_generalHandleIdFactor5419);
                        stringOperator110=this.stringOperator();

                        this.state._fsp--;

                        stream_stringOperator.add(stringOperator110.getTree());
                        STRING_LITERAL111=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_generalHandleIdFactor5421);
                        stream_STRING_LITERAL.add(STRING_LITERAL111);



                        // AST REWRITE
                        // elements: HANDLE_ID, stringOperator, STRING_LITERAL
                        // token labels:
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 382:51: -> ^( AUTHOR HANDLE_ID stringOperator STRING_LITERAL )
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:382:54: ^( AUTHOR HANDLE_ID stringOperator STRING_LITERAL )
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(AUTHOR, "AUTHOR"), root_1);

                            this.adaptor.addChild(root_1, stream_HANDLE_ID.nextNode());
                            this.adaptor.addChild(root_1, stream_stringOperator.nextTree());
                            this.adaptor.addChild(root_1, stream_STRING_LITERAL.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:384:29: ( IN stringList -> ^( AUTHOR HANDLE_ID IN stringList ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:384:29: ( IN stringList -> ^( AUTHOR HANDLE_ID IN stringList ) )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:384:31: IN stringList
                        IN112=this.match(this.input,IN,MentionQAst.FOLLOW_IN_in_generalHandleIdFactor5498);
                        stream_IN.add(IN112);

                        this.pushFollow(MentionQAst.FOLLOW_stringList_in_generalHandleIdFactor5500);
                        stringList113=this.stringList();

                        this.state._fsp--;

                        stream_stringList.add(stringList113.getTree());


                        // AST REWRITE
                        // elements: HANDLE_ID, IN, stringList
                        // token labels:
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 384:61: -> ^( AUTHOR HANDLE_ID IN stringList )
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:384:64: ^( AUTHOR HANDLE_ID IN stringList )
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(AUTHOR, "AUTHOR"), root_1);

                            this.adaptor.addChild(root_1, stream_HANDLE_ID.nextNode());
                            this.adaptor.addChild(root_1, stream_IN.nextNode());
                            this.adaptor.addChild(root_1, stream_stringList.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;




                        break;

                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        stringList_return: (function() {
            MentionQAst.stringList_return = function(){};
            org.antlr.lang.extend(MentionQAst.stringList_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:387:1: stringList : LPAREN STRING_LITERAL ( COMMA STRING_LITERAL )* RPAREN ;
        // $ANTLR start "stringList"
        stringList: function() {
            var retval = new MentionQAst.stringList_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var LPAREN114 = null;
            var STRING_LITERAL115 = null;
            var COMMA116 = null;
            var STRING_LITERAL117 = null;
            var RPAREN118 = null;

            var LPAREN114_tree=null;
            var STRING_LITERAL115_tree=null;
            var COMMA116_tree=null;
            var STRING_LITERAL117_tree=null;
            var RPAREN118_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:388:5: ( LPAREN STRING_LITERAL ( COMMA STRING_LITERAL )* RPAREN )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:388:9: LPAREN STRING_LITERAL ( COMMA STRING_LITERAL )* RPAREN
                root_0 = this.adaptor.nil();

                LPAREN114=this.match(this.input,LPAREN,MentionQAst.FOLLOW_LPAREN_in_stringList5549);
                STRING_LITERAL115=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_stringList5552);
                STRING_LITERAL115_tree = this.adaptor.create(STRING_LITERAL115);
                this.adaptor.addChild(root_0, STRING_LITERAL115_tree);

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:388:32: ( COMMA STRING_LITERAL )*
                loop95:
                    do {
                        var alt95=2;
                        var LA95_0 = this.input.LA(1);

                        if ( (LA95_0==COMMA) ) {
                            alt95=1;
                        }


                        switch (alt95) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:388:34: COMMA STRING_LITERAL
                                COMMA116=this.match(this.input,COMMA,MentionQAst.FOLLOW_COMMA_in_stringList5556);
                                STRING_LITERAL117=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_stringList5559);
                                STRING_LITERAL117_tree = this.adaptor.create(STRING_LITERAL117);
                                this.adaptor.addChild(root_0, STRING_LITERAL117_tree);



                                break;

                            default :
                                break loop95;
                        }
                    } while (true);

                RPAREN118=this.match(this.input,RPAREN,MentionQAst.FOLLOW_RPAREN_in_stringList5565);



                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        attributes_return: (function() {
            MentionQAst.attributes_return = function(){};
            org.antlr.lang.extend(MentionQAst.attributes_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:395:1: attributes : attributeNode ( COMMA attributeNode )* EOF ;
        // $ANTLR start "attributes"
        attributes: function() {
            var retval = new MentionQAst.attributes_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var COMMA120 = null;
            var EOF122 = null;
            var attributeNode119 = null;
            var attributeNode121 = null;

            var COMMA120_tree=null;
            var EOF122_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:396:5: ( attributeNode ( COMMA attributeNode )* EOF )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:396:9: attributeNode ( COMMA attributeNode )* EOF
                root_0 = this.adaptor.nil();

                this.pushFollow(MentionQAst.FOLLOW_attributeNode_in_attributes5589);
                attributeNode119=this.attributeNode();

                this.state._fsp--;

                this.adaptor.addChild(root_0, attributeNode119.getTree());
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:396:23: ( COMMA attributeNode )*
                loop96:
                    do {
                        var alt96=2;
                        var LA96_0 = this.input.LA(1);

                        if ( (LA96_0==COMMA) ) {
                            alt96=1;
                        }


                        switch (alt96) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:396:25: COMMA attributeNode
                                COMMA120=this.match(this.input,COMMA,MentionQAst.FOLLOW_COMMA_in_attributes5593);
                                this.pushFollow(MentionQAst.FOLLOW_attributeNode_in_attributes5596);
                                attributeNode121=this.attributeNode();

                                this.state._fsp--;

                                this.adaptor.addChild(root_0, attributeNode121.getTree());


                                break;

                            default :
                                break loop96;
                        }
                    } while (true);

                EOF122=this.match(this.input,EOF,MentionQAst.FOLLOW_EOF_in_attributes5601);



                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        attributeNode_return: (function() {
            MentionQAst.attributeNode_return = function(){};
            org.antlr.lang.extend(MentionQAst.attributeNode_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:399:1: attributeNode : (operand= RELEVANCY EQUALS (literal= UNSORTED | literal= RELEVANT | literal= DUPLICATE | literal= IRRELEVANT | literal= SPAM ) | operand= MEDIA EQUALS (literal= PRESS | literal= ENTERPRISE | literal= CONSUMER | literal= DIRECTORY ) | operand= ACTION EQUALS (literal= NONE | literal= UNRESOLVED | literal= RESOLVED ) | (operand= SENTIMENT | operand= CROWD_REGION ) EQUALS literal= LONG_LITERAL | (operand= CREDIBILITY | operand= ASSIGNEE ) EQUALS (literal= LONG_LITERAL | literal= UNKNOWN ) | (operand= LANGUAGE | operand= COUNTRY ) EQUALS (literal= STRING_LITERAL | literal= UNKNOWN ) | (operand= TAG ) EQUALS (literal= STRING_LITERAL | literal= LONG_LITERAL ) | (operand= RELEVANCY_VERIFIED ) EQUALS (literal= TRUE | literal= FALSE ) | (operand= GENDER ) EQUALS (literal= MALE | literal= FEMALE | literal= OTHER | literal= UNKNOWN ) | (operand= RACE ) EQUALS (literal= UNKNOWN | literal= UNQUOTED_STRING_LITERAL ) ) -> ^( ATTRIBUTE $operand $literal) ;
        // $ANTLR start "attributeNode"
        attributeNode: function() {
            var retval = new MentionQAst.attributeNode_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var operand = null;
            var literal = null;
            var EQUALS123 = null;
            var EQUALS124 = null;
            var EQUALS125 = null;
            var EQUALS126 = null;
            var EQUALS127 = null;
            var EQUALS128 = null;
            var EQUALS129 = null;
            var EQUALS130 = null;
            var EQUALS131 = null;
            var EQUALS132 = null;

            var operand_tree=null;
            var literal_tree=null;
            var EQUALS123_tree=null;
            var EQUALS124_tree=null;
            var EQUALS125_tree=null;
            var EQUALS126_tree=null;
            var EQUALS127_tree=null;
            var EQUALS128_tree=null;
            var EQUALS129_tree=null;
            var EQUALS130_tree=null;
            var EQUALS131_tree=null;
            var EQUALS132_tree=null;
            var stream_OTHER=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token OTHER");
            var stream_MALE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token MALE");
            var stream_UNQUOTED_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNQUOTED_STRING_LITERAL");
            var stream_SENTIMENT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token SENTIMENT");
            var stream_IRRELEVANT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token IRRELEVANT");
            var stream_FEMALE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token FEMALE");
            var stream_EQUALS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token EQUALS");
            var stream_MEDIA=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token MEDIA");
            var stream_RELEVANT=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RELEVANT");
            var stream_RELEVANCY_VERIFIED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RELEVANCY_VERIFIED");
            var stream_LONG_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LONG_LITERAL");
            var stream_TRUE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TRUE");
            var stream_RELEVANCY=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RELEVANCY");
            var stream_ACTION=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ACTION");
            var stream_TAG=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token TAG");
            var stream_CONSUMER=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CONSUMER");
            var stream_UNRESOLVED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNRESOLVED");
            var stream_CREDIBILITY=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CREDIBILITY");
            var stream_STRING_LITERAL=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token STRING_LITERAL");
            var stream_LANGUAGE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LANGUAGE");
            var stream_COUNTRY=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token COUNTRY");
            var stream_UNKNOWN=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNKNOWN");
            var stream_ENTERPRISE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ENTERPRISE");
            var stream_NONE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token NONE");
            var stream_SPAM=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token SPAM");
            var stream_ASSIGNEE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token ASSIGNEE");
            var stream_DIRECTORY=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token DIRECTORY");
            var stream_RESOLVED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RESOLVED");
            var stream_PRESS=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token PRESS");
            var stream_UNSORTED=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token UNSORTED");
            var stream_GENDER=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token GENDER");
            var stream_FALSE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token FALSE");
            var stream_DUPLICATE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token DUPLICATE");
            var stream_RACE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RACE");
            var stream_CROWD_REGION=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CROWD_REGION");

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:400:5: ( (operand= RELEVANCY EQUALS (literal= UNSORTED | literal= RELEVANT | literal= DUPLICATE | literal= IRRELEVANT | literal= SPAM ) | operand= MEDIA EQUALS (literal= PRESS | literal= ENTERPRISE | literal= CONSUMER | literal= DIRECTORY ) | operand= ACTION EQUALS (literal= NONE | literal= UNRESOLVED | literal= RESOLVED ) | (operand= SENTIMENT | operand= CROWD_REGION ) EQUALS literal= LONG_LITERAL | (operand= CREDIBILITY | operand= ASSIGNEE ) EQUALS (literal= LONG_LITERAL | literal= UNKNOWN ) | (operand= LANGUAGE | operand= COUNTRY ) EQUALS (literal= STRING_LITERAL | literal= UNKNOWN ) | (operand= TAG ) EQUALS (literal= STRING_LITERAL | literal= LONG_LITERAL ) | (operand= RELEVANCY_VERIFIED ) EQUALS (literal= TRUE | literal= FALSE ) | (operand= GENDER ) EQUALS (literal= MALE | literal= FEMALE | literal= OTHER | literal= UNKNOWN ) | (operand= RACE ) EQUALS (literal= UNKNOWN | literal= UNQUOTED_STRING_LITERAL ) ) -> ^( ATTRIBUTE $operand $literal) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:400:9: (operand= RELEVANCY EQUALS (literal= UNSORTED | literal= RELEVANT | literal= DUPLICATE | literal= IRRELEVANT | literal= SPAM ) | operand= MEDIA EQUALS (literal= PRESS | literal= ENTERPRISE | literal= CONSUMER | literal= DIRECTORY ) | operand= ACTION EQUALS (literal= NONE | literal= UNRESOLVED | literal= RESOLVED ) | (operand= SENTIMENT | operand= CROWD_REGION ) EQUALS literal= LONG_LITERAL | (operand= CREDIBILITY | operand= ASSIGNEE ) EQUALS (literal= LONG_LITERAL | literal= UNKNOWN ) | (operand= LANGUAGE | operand= COUNTRY ) EQUALS (literal= STRING_LITERAL | literal= UNKNOWN ) | (operand= TAG ) EQUALS (literal= STRING_LITERAL | literal= LONG_LITERAL ) | (operand= RELEVANCY_VERIFIED ) EQUALS (literal= TRUE | literal= FALSE ) | (operand= GENDER ) EQUALS (literal= MALE | literal= FEMALE | literal= OTHER | literal= UNKNOWN ) | (operand= RACE ) EQUALS (literal= UNKNOWN | literal= UNQUOTED_STRING_LITERAL ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:400:9: (operand= RELEVANCY EQUALS (literal= UNSORTED | literal= RELEVANT | literal= DUPLICATE | literal= IRRELEVANT | literal= SPAM ) | operand= MEDIA EQUALS (literal= PRESS | literal= ENTERPRISE | literal= CONSUMER | literal= DIRECTORY ) | operand= ACTION EQUALS (literal= NONE | literal= UNRESOLVED | literal= RESOLVED ) | (operand= SENTIMENT | operand= CROWD_REGION ) EQUALS literal= LONG_LITERAL | (operand= CREDIBILITY | operand= ASSIGNEE ) EQUALS (literal= LONG_LITERAL | literal= UNKNOWN ) | (operand= LANGUAGE | operand= COUNTRY ) EQUALS (literal= STRING_LITERAL | literal= UNKNOWN ) | (operand= TAG ) EQUALS (literal= STRING_LITERAL | literal= LONG_LITERAL ) | (operand= RELEVANCY_VERIFIED ) EQUALS (literal= TRUE | literal= FALSE ) | (operand= GENDER ) EQUALS (literal= MALE | literal= FEMALE | literal= OTHER | literal= UNKNOWN ) | (operand= RACE ) EQUALS (literal= UNKNOWN | literal= UNQUOTED_STRING_LITERAL ) )
                var alt109=10;
                switch ( this.input.LA(1) ) {
                    case RELEVANCY:
                        alt109=1;
                        break;
                    case MEDIA:
                        alt109=2;
                        break;
                    case ACTION:
                        alt109=3;
                        break;
                    case SENTIMENT:
                    case CROWD_REGION:
                        alt109=4;
                        break;
                    case CREDIBILITY:
                    case ASSIGNEE:
                        alt109=5;
                        break;
                    case LANGUAGE:
                    case COUNTRY:
                        alt109=6;
                        break;
                    case TAG:
                        alt109=7;
                        break;
                    case RELEVANCY_VERIFIED:
                        alt109=8;
                        break;
                    case GENDER:
                        alt109=9;
                        break;
                    case RACE:
                        alt109=10;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 109, 0, this.input);

                        throw nvae;
                }

                switch (alt109) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:400:13: operand= RELEVANCY EQUALS (literal= UNSORTED | literal= RELEVANT | literal= DUPLICATE | literal= IRRELEVANT | literal= SPAM )
                        operand=this.match(this.input,RELEVANCY,MentionQAst.FOLLOW_RELEVANCY_in_attributeNode5627);
                        stream_RELEVANCY.add(operand);

                        EQUALS123=this.match(this.input,EQUALS,MentionQAst.FOLLOW_EQUALS_in_attributeNode5674);
                        stream_EQUALS.add(EQUALS123);

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:400:88: (literal= UNSORTED | literal= RELEVANT | literal= DUPLICATE | literal= IRRELEVANT | literal= SPAM )
                        var alt97=5;
                        switch ( this.input.LA(1) ) {
                            case UNSORTED:
                                alt97=1;
                                break;
                            case RELEVANT:
                                alt97=2;
                                break;
                            case DUPLICATE:
                                alt97=3;
                                break;
                            case IRRELEVANT:
                                alt97=4;
                                break;
                            case SPAM:
                                alt97=5;
                                break;
                            default:
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 97, 0, this.input);

                                throw nvae;
                        }

                        switch (alt97) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:400:90: literal= UNSORTED
                                literal=this.match(this.input,UNSORTED,MentionQAst.FOLLOW_UNSORTED_in_attributeNode5685);
                                stream_UNSORTED.add(literal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:400:109: literal= RELEVANT
                                literal=this.match(this.input,RELEVANT,MentionQAst.FOLLOW_RELEVANT_in_attributeNode5691);
                                stream_RELEVANT.add(literal);



                                break;
                            case 3 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:400:128: literal= DUPLICATE
                                literal=this.match(this.input,DUPLICATE,MentionQAst.FOLLOW_DUPLICATE_in_attributeNode5697);
                                stream_DUPLICATE.add(literal);



                                break;
                            case 4 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:400:148: literal= IRRELEVANT
                                literal=this.match(this.input,IRRELEVANT,MentionQAst.FOLLOW_IRRELEVANT_in_attributeNode5703);
                                stream_IRRELEVANT.add(literal);



                                break;
                            case 5 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:400:169: literal= SPAM
                                literal=this.match(this.input,SPAM,MentionQAst.FOLLOW_SPAM_in_attributeNode5709);
                                stream_SPAM.add(literal);



                                break;

                        }



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:401:13: operand= MEDIA EQUALS (literal= PRESS | literal= ENTERPRISE | literal= CONSUMER | literal= DIRECTORY )
                        operand=this.match(this.input,MEDIA,MentionQAst.FOLLOW_MEDIA_in_attributeNode5727);
                        stream_MEDIA.add(operand);

                        EQUALS124=this.match(this.input,EQUALS,MentionQAst.FOLLOW_EQUALS_in_attributeNode5778);
                        stream_EQUALS.add(EQUALS124);

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:401:88: (literal= PRESS | literal= ENTERPRISE | literal= CONSUMER | literal= DIRECTORY )
                        var alt98=4;
                        switch ( this.input.LA(1) ) {
                            case PRESS:
                                alt98=1;
                                break;
                            case ENTERPRISE:
                                alt98=2;
                                break;
                            case CONSUMER:
                                alt98=3;
                                break;
                            case DIRECTORY:
                                alt98=4;
                                break;
                            default:
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 98, 0, this.input);

                                throw nvae;
                        }

                        switch (alt98) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:401:90: literal= PRESS
                                literal=this.match(this.input,PRESS,MentionQAst.FOLLOW_PRESS_in_attributeNode5789);
                                stream_PRESS.add(literal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:401:106: literal= ENTERPRISE
                                literal=this.match(this.input,ENTERPRISE,MentionQAst.FOLLOW_ENTERPRISE_in_attributeNode5795);
                                stream_ENTERPRISE.add(literal);



                                break;
                            case 3 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:401:127: literal= CONSUMER
                                literal=this.match(this.input,CONSUMER,MentionQAst.FOLLOW_CONSUMER_in_attributeNode5801);
                                stream_CONSUMER.add(literal);



                                break;
                            case 4 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:401:146: literal= DIRECTORY
                                literal=this.match(this.input,DIRECTORY,MentionQAst.FOLLOW_DIRECTORY_in_attributeNode5807);
                                stream_DIRECTORY.add(literal);



                                break;

                        }



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:402:13: operand= ACTION EQUALS (literal= NONE | literal= UNRESOLVED | literal= RESOLVED )
                        operand=this.match(this.input,ACTION,MentionQAst.FOLLOW_ACTION_in_attributeNode5825);
                        stream_ACTION.add(operand);

                        EQUALS125=this.match(this.input,EQUALS,MentionQAst.FOLLOW_EQUALS_in_attributeNode5875);
                        stream_EQUALS.add(EQUALS125);

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:402:88: (literal= NONE | literal= UNRESOLVED | literal= RESOLVED )
                        var alt99=3;
                        switch ( this.input.LA(1) ) {
                            case NONE:
                                alt99=1;
                                break;
                            case UNRESOLVED:
                                alt99=2;
                                break;
                            case RESOLVED:
                                alt99=3;
                                break;
                            default:
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 99, 0, this.input);

                                throw nvae;
                        }

                        switch (alt99) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:402:90: literal= NONE
                                literal=this.match(this.input,NONE,MentionQAst.FOLLOW_NONE_in_attributeNode5886);
                                stream_NONE.add(literal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:402:105: literal= UNRESOLVED
                                literal=this.match(this.input,UNRESOLVED,MentionQAst.FOLLOW_UNRESOLVED_in_attributeNode5892);
                                stream_UNRESOLVED.add(literal);



                                break;
                            case 3 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:402:126: literal= RESOLVED
                                literal=this.match(this.input,RESOLVED,MentionQAst.FOLLOW_RESOLVED_in_attributeNode5898);
                                stream_RESOLVED.add(literal);



                                break;

                        }



                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:403:13: (operand= SENTIMENT | operand= CROWD_REGION ) EQUALS literal= LONG_LITERAL
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:403:13: (operand= SENTIMENT | operand= CROWD_REGION )
                        var alt100=2;
                        var LA100_0 = this.input.LA(1);

                        if ( (LA100_0==SENTIMENT) ) {
                            alt100=1;
                        }
                        else if ( (LA100_0==CROWD_REGION) ) {
                            alt100=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 100, 0, this.input);

                            throw nvae;
                        }
                        switch (alt100) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:403:15: operand= SENTIMENT
                                operand=this.match(this.input,SENTIMENT,MentionQAst.FOLLOW_SENTIMENT_in_attributeNode5918);
                                stream_SENTIMENT.add(operand);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:403:35: operand= CROWD_REGION
                                operand=this.match(this.input,CROWD_REGION,MentionQAst.FOLLOW_CROWD_REGION_in_attributeNode5924);
                                stream_CROWD_REGION.add(operand);



                                break;

                        }

                        EQUALS126=this.match(this.input,EQUALS,MentionQAst.FOLLOW_EQUALS_in_attributeNode5946);
                        stream_EQUALS.add(EQUALS126);

                        literal=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_attributeNode5955);
                        stream_LONG_LITERAL.add(literal);



                        break;
                    case 5 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:404:13: (operand= CREDIBILITY | operand= ASSIGNEE ) EQUALS (literal= LONG_LITERAL | literal= UNKNOWN )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:404:13: (operand= CREDIBILITY | operand= ASSIGNEE )
                        var alt101=2;
                        var LA101_0 = this.input.LA(1);

                        if ( (LA101_0==CREDIBILITY) ) {
                            alt101=1;
                        }
                        else if ( (LA101_0==ASSIGNEE) ) {
                            alt101=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 101, 0, this.input);

                            throw nvae;
                        }
                        switch (alt101) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:404:15: operand= CREDIBILITY
                                operand=this.match(this.input,CREDIBILITY,MentionQAst.FOLLOW_CREDIBILITY_in_attributeNode5973);
                                stream_CREDIBILITY.add(operand);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:404:37: operand= ASSIGNEE
                                operand=this.match(this.input,ASSIGNEE,MentionQAst.FOLLOW_ASSIGNEE_in_attributeNode5979);
                                stream_ASSIGNEE.add(operand);



                                break;

                        }

                        EQUALS127=this.match(this.input,EQUALS,MentionQAst.FOLLOW_EQUALS_in_attributeNode6003);
                        stream_EQUALS.add(EQUALS127);

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:404:88: (literal= LONG_LITERAL | literal= UNKNOWN )
                        var alt102=2;
                        var LA102_0 = this.input.LA(1);

                        if ( (LA102_0==LONG_LITERAL) ) {
                            alt102=1;
                        }
                        else if ( (LA102_0==UNKNOWN) ) {
                            alt102=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 102, 0, this.input);

                            throw nvae;
                        }
                        switch (alt102) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:404:90: literal= LONG_LITERAL
                                literal=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_attributeNode6014);
                                stream_LONG_LITERAL.add(literal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:404:113: literal= UNKNOWN
                                literal=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_attributeNode6020);
                                stream_UNKNOWN.add(literal);



                                break;

                        }



                        break;
                    case 6 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:405:13: (operand= LANGUAGE | operand= COUNTRY ) EQUALS (literal= STRING_LITERAL | literal= UNKNOWN )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:405:13: (operand= LANGUAGE | operand= COUNTRY )
                        var alt103=2;
                        var LA103_0 = this.input.LA(1);

                        if ( (LA103_0==LANGUAGE) ) {
                            alt103=1;
                        }
                        else if ( (LA103_0==COUNTRY) ) {
                            alt103=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 103, 0, this.input);

                            throw nvae;
                        }
                        switch (alt103) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:405:15: operand= LANGUAGE
                                operand=this.match(this.input,LANGUAGE,MentionQAst.FOLLOW_LANGUAGE_in_attributeNode6040);
                                stream_LANGUAGE.add(operand);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:405:34: operand= COUNTRY
                                operand=this.match(this.input,COUNTRY,MentionQAst.FOLLOW_COUNTRY_in_attributeNode6046);
                                stream_COUNTRY.add(operand);



                                break;

                        }

                        EQUALS128=this.match(this.input,EQUALS,MentionQAst.FOLLOW_EQUALS_in_attributeNode6074);
                        stream_EQUALS.add(EQUALS128);

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:405:88: (literal= STRING_LITERAL | literal= UNKNOWN )
                        var alt104=2;
                        var LA104_0 = this.input.LA(1);

                        if ( (LA104_0==STRING_LITERAL) ) {
                            alt104=1;
                        }
                        else if ( (LA104_0==UNKNOWN) ) {
                            alt104=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 104, 0, this.input);

                            throw nvae;
                        }
                        switch (alt104) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:405:90: literal= STRING_LITERAL
                                literal=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_attributeNode6085);
                                stream_STRING_LITERAL.add(literal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:405:115: literal= UNKNOWN
                                literal=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_attributeNode6091);
                                stream_UNKNOWN.add(literal);



                                break;

                        }



                        break;
                    case 7 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:406:13: (operand= TAG ) EQUALS (literal= STRING_LITERAL | literal= LONG_LITERAL )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:406:13: (operand= TAG )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:406:15: operand= TAG
                        operand=this.match(this.input,TAG,MentionQAst.FOLLOW_TAG_in_attributeNode6111);
                        stream_TAG.add(operand);




                        EQUALS129=this.match(this.input,EQUALS,MentionQAst.FOLLOW_EQUALS_in_attributeNode6162);
                        stream_EQUALS.add(EQUALS129);

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:406:88: (literal= STRING_LITERAL | literal= LONG_LITERAL )
                        var alt105=2;
                        var LA105_0 = this.input.LA(1);

                        if ( (LA105_0==STRING_LITERAL) ) {
                            alt105=1;
                        }
                        else if ( (LA105_0==LONG_LITERAL) ) {
                            alt105=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 105, 0, this.input);

                            throw nvae;
                        }
                        switch (alt105) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:406:90: literal= STRING_LITERAL
                                literal=this.match(this.input,STRING_LITERAL,MentionQAst.FOLLOW_STRING_LITERAL_in_attributeNode6175);
                                stream_STRING_LITERAL.add(literal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:406:117: literal= LONG_LITERAL
                                literal=this.match(this.input,LONG_LITERAL,MentionQAst.FOLLOW_LONG_LITERAL_in_attributeNode6183);
                                stream_LONG_LITERAL.add(literal);



                                break;

                        }



                        break;
                    case 8 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:407:13: (operand= RELEVANCY_VERIFIED ) EQUALS (literal= TRUE | literal= FALSE )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:407:13: (operand= RELEVANCY_VERIFIED )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:407:15: operand= RELEVANCY_VERIFIED
                        operand=this.match(this.input,RELEVANCY_VERIFIED,MentionQAst.FOLLOW_RELEVANCY_VERIFIED_in_attributeNode6203);
                        stream_RELEVANCY_VERIFIED.add(operand);




                        EQUALS130=this.match(this.input,EQUALS,MentionQAst.FOLLOW_EQUALS_in_attributeNode6239);
                        stream_EQUALS.add(EQUALS130);

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:407:88: (literal= TRUE | literal= FALSE )
                        var alt106=2;
                        var LA106_0 = this.input.LA(1);

                        if ( (LA106_0==TRUE) ) {
                            alt106=1;
                        }
                        else if ( (LA106_0==FALSE) ) {
                            alt106=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 106, 0, this.input);

                            throw nvae;
                        }
                        switch (alt106) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:407:90: literal= TRUE
                                literal=this.match(this.input,TRUE,MentionQAst.FOLLOW_TRUE_in_attributeNode6250);
                                stream_TRUE.add(literal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:407:105: literal= FALSE
                                literal=this.match(this.input,FALSE,MentionQAst.FOLLOW_FALSE_in_attributeNode6256);
                                stream_FALSE.add(literal);



                                break;

                        }



                        break;
                    case 9 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:408:13: (operand= GENDER ) EQUALS (literal= MALE | literal= FEMALE | literal= OTHER | literal= UNKNOWN )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:408:13: (operand= GENDER )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:408:15: operand= GENDER
                        operand=this.match(this.input,GENDER,MentionQAst.FOLLOW_GENDER_in_attributeNode6276);
                        stream_GENDER.add(operand);




                        EQUALS131=this.match(this.input,EQUALS,MentionQAst.FOLLOW_EQUALS_in_attributeNode6324);
                        stream_EQUALS.add(EQUALS131);

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:408:88: (literal= MALE | literal= FEMALE | literal= OTHER | literal= UNKNOWN )
                        var alt107=4;
                        switch ( this.input.LA(1) ) {
                            case MALE:
                                alt107=1;
                                break;
                            case FEMALE:
                                alt107=2;
                                break;
                            case OTHER:
                                alt107=3;
                                break;
                            case UNKNOWN:
                                alt107=4;
                                break;
                            default:
                                var nvae =
                                    new org.antlr.runtime.NoViableAltException("", 107, 0, this.input);

                                throw nvae;
                        }

                        switch (alt107) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:408:90: literal= MALE
                                literal=this.match(this.input,MALE,MentionQAst.FOLLOW_MALE_in_attributeNode6335);
                                stream_MALE.add(literal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:408:105: literal= FEMALE
                                literal=this.match(this.input,FEMALE,MentionQAst.FOLLOW_FEMALE_in_attributeNode6341);
                                stream_FEMALE.add(literal);



                                break;
                            case 3 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:408:122: literal= OTHER
                                literal=this.match(this.input,OTHER,MentionQAst.FOLLOW_OTHER_in_attributeNode6347);
                                stream_OTHER.add(literal);



                                break;
                            case 4 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:408:138: literal= UNKNOWN
                                literal=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_attributeNode6353);
                                stream_UNKNOWN.add(literal);



                                break;

                        }



                        break;
                    case 10 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:409:13: (operand= RACE ) EQUALS (literal= UNKNOWN | literal= UNQUOTED_STRING_LITERAL )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:409:13: (operand= RACE )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:409:15: operand= RACE
                        operand=this.match(this.input,RACE,MentionQAst.FOLLOW_RACE_in_attributeNode6373);
                        stream_RACE.add(operand);




                        EQUALS132=this.match(this.input,EQUALS,MentionQAst.FOLLOW_EQUALS_in_attributeNode6423);
                        stream_EQUALS.add(EQUALS132);

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:409:88: (literal= UNKNOWN | literal= UNQUOTED_STRING_LITERAL )
                        var alt108=2;
                        var LA108_0 = this.input.LA(1);

                        if ( (LA108_0==UNKNOWN) ) {
                            alt108=1;
                        }
                        else if ( (LA108_0==UNQUOTED_STRING_LITERAL) ) {
                            alt108=2;
                        }
                        else {
                            var nvae =
                                new org.antlr.runtime.NoViableAltException("", 108, 0, this.input);

                            throw nvae;
                        }
                        switch (alt108) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:409:90: literal= UNKNOWN
                                literal=this.match(this.input,UNKNOWN,MentionQAst.FOLLOW_UNKNOWN_in_attributeNode6434);
                                stream_UNKNOWN.add(literal);



                                break;
                            case 2 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:409:108: literal= UNQUOTED_STRING_LITERAL
                                literal=this.match(this.input,UNQUOTED_STRING_LITERAL,MentionQAst.FOLLOW_UNQUOTED_STRING_LITERAL_in_attributeNode6440);
                                stream_UNQUOTED_STRING_LITERAL.add(literal);



                                break;

                        }



                        break;

                }



                // AST REWRITE
                // elements: literal, operand
                // token labels: operand, literal
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_operand=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token operand",operand);
                var stream_literal=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token literal",literal);
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 411:5: -> ^( ATTRIBUTE $operand $literal)
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:411:9: ^( ATTRIBUTE $operand $literal)
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(ATTRIBUTE, "ATTRIBUTE"), root_1);

                        this.adaptor.addChild(root_1, stream_operand.nextNode());
                        this.adaptor.addChild(root_1, stream_literal.nextNode());

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        count_return: (function() {
            MentionQAst.count_return = function(){};
            org.antlr.lang.extend(MentionQAst.count_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:416:1: count : countNode ( COMMA countNode )* EOF ;
        // $ANTLR start "count"
        count: function() {
            var retval = new MentionQAst.count_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var COMMA134 = null;
            var EOF136 = null;
            var countNode133 = null;
            var countNode135 = null;

            var COMMA134_tree=null;
            var EOF136_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:416:6: ( countNode ( COMMA countNode )* EOF )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:416:8: countNode ( COMMA countNode )* EOF
                root_0 = this.adaptor.nil();

                this.pushFollow(MentionQAst.FOLLOW_countNode_in_count6483);
                countNode133=this.countNode();

                this.state._fsp--;

                this.adaptor.addChild(root_0, countNode133.getTree());
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:416:18: ( COMMA countNode )*
                loop110:
                    do {
                        var alt110=2;
                        var LA110_0 = this.input.LA(1);

                        if ( (LA110_0==COMMA) ) {
                            alt110=1;
                        }


                        switch (alt110) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:416:19: COMMA countNode
                                COMMA134=this.match(this.input,COMMA,MentionQAst.FOLLOW_COMMA_in_count6486);
                                this.pushFollow(MentionQAst.FOLLOW_countNode_in_count6489);
                                countNode135=this.countNode();

                                this.state._fsp--;

                                this.adaptor.addChild(root_0, countNode135.getTree());


                                break;

                            default :
                                break loop110;
                        }
                    } while (true);

                EOF136=this.match(this.input,EOF,MentionQAst.FOLLOW_EOF_in_count6493);



                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        countNode_return: (function() {
            MentionQAst.countNode_return = function(){};
            org.antlr.lang.extend(MentionQAst.countNode_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:418:1: countNode : ( distinctKeyword )? countNodeOperand -> ^( COUNT countNodeOperand ( distinctKeyword )? ) ;
        // $ANTLR start "countNode"
        countNode: function() {
            var retval = new MentionQAst.countNode_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var distinctKeyword137 = null;
            var countNodeOperand138 = null;

            var stream_countNodeOperand=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule countNodeOperand");
            var stream_distinctKeyword=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule distinctKeyword");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:418:10: ( ( distinctKeyword )? countNodeOperand -> ^( COUNT countNodeOperand ( distinctKeyword )? ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:418:12: ( distinctKeyword )? countNodeOperand
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:418:12: ( distinctKeyword )?
                var alt111=2;
                var LA111_0 = this.input.LA(1);

                if ( (LA111_0==DISTINCT) ) {
                    alt111=1;
                }
                switch (alt111) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:418:12: distinctKeyword
                        this.pushFollow(MentionQAst.FOLLOW_distinctKeyword_in_countNode6501);
                        distinctKeyword137=this.distinctKeyword();

                        this.state._fsp--;

                        stream_distinctKeyword.add(distinctKeyword137.getTree());


                        break;

                }

                this.pushFollow(MentionQAst.FOLLOW_countNodeOperand_in_countNode6504);
                countNodeOperand138=this.countNodeOperand();

                this.state._fsp--;

                stream_countNodeOperand.add(countNodeOperand138.getTree());


                // AST REWRITE
                // elements: countNodeOperand, distinctKeyword
                // token labels:
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 418:46: -> ^( COUNT countNodeOperand ( distinctKeyword )? )
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:418:49: ^( COUNT countNodeOperand ( distinctKeyword )? )
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(COUNT, "COUNT"), root_1);

                        this.adaptor.addChild(root_1, stream_countNodeOperand.nextTree());
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:418:74: ( distinctKeyword )?
                        if ( stream_distinctKeyword.hasNext() ) {
                            this.adaptor.addChild(root_1, stream_distinctKeyword.nextTree());

                        }
                        stream_distinctKeyword.reset();

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        countNodeOperand_return: (function() {
            MentionQAst.countNodeOperand_return = function(){};
            org.antlr.lang.extend(MentionQAst.countNodeOperand_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:420:1: countNodeOperand : ( MENTION_ID | CREDIBILITY | MEDIA | ACTION | SITE | AUTHOR_NAME | LANGUAGE | COUNTRY | REGION | CITY | ASSIGNEE | AUTHOR | GENDER );
        // $ANTLR start "countNodeOperand"
        countNodeOperand: function() {
            var retval = new MentionQAst.countNodeOperand_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set139 = null;

            var set139_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:420:17: ( MENTION_ID | CREDIBILITY | MEDIA | ACTION | SITE | AUTHOR_NAME | LANGUAGE | COUNTRY | REGION | CITY | ASSIGNEE | AUTHOR | GENDER )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set139=this.input.LT(1);
                if ( (this.input.LA(1)>=CREDIBILITY && this.input.LA(1)<=ACTION)||(this.input.LA(1)>=SITE && this.input.LA(1)<=AUTHOR_NAME)||this.input.LA(1)==LANGUAGE||(this.input.LA(1)>=COUNTRY && this.input.LA(1)<=CITY)||(this.input.LA(1)>=ASSIGNEE && this.input.LA(1)<=AUTHOR)||this.input.LA(1)==MENTION_ID||this.input.LA(1)==GENDER ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set139));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        distinctKeyword_return: (function() {
            MentionQAst.distinctKeyword_return = function(){};
            org.antlr.lang.extend(MentionQAst.distinctKeyword_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:423:1: distinctKeyword : DISTINCT ;
        // $ANTLR start "distinctKeyword"
        distinctKeyword: function() {
            var retval = new MentionQAst.distinctKeyword_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var DISTINCT140 = null;

            var DISTINCT140_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:423:16: ( DISTINCT )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:423:18: DISTINCT
                root_0 = this.adaptor.nil();

                DISTINCT140=this.match(this.input,DISTINCT,MentionQAst.FOLLOW_DISTINCT_in_distinctKeyword6585);
                DISTINCT140_tree = this.adaptor.create(DISTINCT140);
                this.adaptor.addChild(root_0, DISTINCT140_tree);




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        selections_return: (function() {
            MentionQAst.selections_return = function(){};
            org.antlr.lang.extend(MentionQAst.selections_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:427:1: selections : selectionOperand ( COMMA selectionOperand )* EOF ;
        // $ANTLR start "selections"
        selections: function() {
            var retval = new MentionQAst.selections_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var COMMA142 = null;
            var EOF144 = null;
            var selectionOperand141 = null;
            var selectionOperand143 = null;

            var COMMA142_tree=null;
            var EOF144_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:428:5: ( selectionOperand ( COMMA selectionOperand )* EOF )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:428:7: selectionOperand ( COMMA selectionOperand )* EOF
                root_0 = this.adaptor.nil();

                this.pushFollow(MentionQAst.FOLLOW_selectionOperand_in_selections6599);
                selectionOperand141=this.selectionOperand();

                this.state._fsp--;

                this.adaptor.addChild(root_0, selectionOperand141.getTree());
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:428:24: ( COMMA selectionOperand )*
                loop112:
                    do {
                        var alt112=2;
                        var LA112_0 = this.input.LA(1);

                        if ( (LA112_0==COMMA) ) {
                            alt112=1;
                        }


                        switch (alt112) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:428:26: COMMA selectionOperand
                                COMMA142=this.match(this.input,COMMA,MentionQAst.FOLLOW_COMMA_in_selections6603);
                                this.pushFollow(MentionQAst.FOLLOW_selectionOperand_in_selections6606);
                                selectionOperand143=this.selectionOperand();

                                this.state._fsp--;

                                this.adaptor.addChild(root_0, selectionOperand143.getTree());


                                break;

                            default :
                                break loop112;
                        }
                    } while (true);

                EOF144=this.match(this.input,EOF,MentionQAst.FOLLOW_EOF_in_selections6611);



                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        selectionOperand_return: (function() {
            MentionQAst.selectionOperand_return = function(){};
            org.antlr.lang.extend(MentionQAst.selectionOperand_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:432:1: selectionOperand : ( MENTION_ID -> ^( SELECTION MENTION_ID ) | CROWD_ID -> ^( SELECTION CROWD_ID ) | selectionNodeOperand -> ^( SELECTION selectionNodeOperand ) );
        // $ANTLR start "selectionOperand"
        selectionOperand: function() {
            var retval = new MentionQAst.selectionOperand_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var MENTION_ID145 = null;
            var CROWD_ID146 = null;
            var selectionNodeOperand147 = null;

            var MENTION_ID145_tree=null;
            var CROWD_ID146_tree=null;
            var stream_MENTION_ID=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token MENTION_ID");
            var stream_CROWD_ID=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token CROWD_ID");
            var stream_selectionNodeOperand=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule selectionNodeOperand");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:433:5: ( MENTION_ID -> ^( SELECTION MENTION_ID ) | CROWD_ID -> ^( SELECTION CROWD_ID ) | selectionNodeOperand -> ^( SELECTION selectionNodeOperand ) )
                var alt113=3;
                switch ( this.input.LA(1) ) {
                    case MENTION_ID:
                        alt113=1;
                        break;
                    case CROWD_ID:
                        alt113=2;
                        break;
                    case RELEVANCY:
                    case BRAND:
                    case SENTIMENT:
                    case CREDIBILITY:
                    case MEDIA:
                    case ACTION:
                    case PROCESS:
                    case PHRASE:
                    case FEED:
                    case TITLE:
                    case LINK:
                    case SITE:
                    case AUTHOR_NAME:
                    case CONTENT:
                    case LANGUAGE:
                    case PICKED_UP:
                    case UPDATED:
                    case LINKED:
                    case PHRASE_MATCHES:
                    case PAGE_RANK:
                    case ALEXA_RANK:
                    case PUBLISHED:
                    case TAG:
                    case TOPIC:
                    case SEGMENT:
                    case COUNTRY:
                    case REGION:
                    case CITY:
                    case RELEVANCY_VERIFIED:
                    case ASSIGNEE:
                    case AUTHOR:
                    case EXTRACT:
                    case SENTIMENT_VERIFIED:
                    case URI:
                    case ENGAGEMENT:
                    case REPLY_TO:
                    case REPLY_COUNT:
                    case RESHARE_OF:
                    case RESHARE_COUNT:
                    case REPLY_ORDER_BY_AUTHOR:
                    case OTS:
                    case AVE:
                    case REACH:
                    case CROWD_REGION:
                    case GENDER:
                    case RESPONSE_TIME:
                    case RACE:
                    case INTERACTION_RESPONSE_TIME:
                    case INTERACTION_FIRST_RESPONSE_TIME:
                    case INTERACTION_FOLLOWUP_RESPONSE_TIME:
                    case INTERACTION_WH_RESPONSE_TIME:
                    case INTERACTION_WH_FIRST_RESPONSE_TIME:
                    case INTERACTION_WH_FOLLOWUP_RESPONSE_TIME:
                    case INTERACTION_HAS_RESPONSE:
                    case INTERACTION_FIRST_MENTION_PUBLISHED:
                    case INTERACTION_LAST_MENTION_PUBLISHED:
                    case INTERACTION_FIRST_RESPONSE_PUBLISHED:
                        alt113=3;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 113, 0, this.input);

                        throw nvae;
                }

                switch (alt113) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:433:9: MENTION_ID
                        MENTION_ID145=this.match(this.input,MENTION_ID,MentionQAst.FOLLOW_MENTION_ID_in_selectionOperand6632);
                        stream_MENTION_ID.add(MENTION_ID145);



                        // AST REWRITE
                        // elements: MENTION_ID
                        // token labels:
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 433:33: -> ^( SELECTION MENTION_ID )
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:433:36: ^( SELECTION MENTION_ID )
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SELECTION, "SELECTION"), root_1);

                            this.adaptor.addChild(root_1, stream_MENTION_ID.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:434:9: CROWD_ID
                        CROWD_ID146=this.match(this.input,CROWD_ID,MentionQAst.FOLLOW_CROWD_ID_in_selectionOperand6663);
                        stream_CROWD_ID.add(CROWD_ID146);



                        // AST REWRITE
                        // elements: CROWD_ID
                        // token labels:
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 434:33: -> ^( SELECTION CROWD_ID )
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:434:36: ^( SELECTION CROWD_ID )
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SELECTION, "SELECTION"), root_1);

                            this.adaptor.addChild(root_1, stream_CROWD_ID.nextNode());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:435:9: selectionNodeOperand
                        this.pushFollow(MentionQAst.FOLLOW_selectionNodeOperand_in_selectionOperand6696);
                        selectionNodeOperand147=this.selectionNodeOperand();

                        this.state._fsp--;

                        stream_selectionNodeOperand.add(selectionNodeOperand147.getTree());


                        // AST REWRITE
                        // elements: selectionNodeOperand
                        // token labels:
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 435:33: -> ^( SELECTION selectionNodeOperand )
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:435:36: ^( SELECTION selectionNodeOperand )
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(SELECTION, "SELECTION"), root_1);

                            this.adaptor.addChild(root_1, stream_selectionNodeOperand.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        selectionNodeOperand_return: (function() {
            MentionQAst.selectionNodeOperand_return = function(){};
            org.antlr.lang.extend(MentionQAst.selectionNodeOperand_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:438:1: selectionNodeOperand : ( generalNodeOperand | OTS | AVE | REACH );
        // $ANTLR start "selectionNodeOperand"
        selectionNodeOperand: function() {
            var retval = new MentionQAst.selectionNodeOperand_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var OTS149 = null;
            var AVE150 = null;
            var REACH151 = null;
            var generalNodeOperand148 = null;

            var OTS149_tree=null;
            var AVE150_tree=null;
            var REACH151_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:438:21: ( generalNodeOperand | OTS | AVE | REACH )
                var alt114=4;
                switch ( this.input.LA(1) ) {
                    case RELEVANCY:
                    case BRAND:
                    case SENTIMENT:
                    case CREDIBILITY:
                    case MEDIA:
                    case ACTION:
                    case PROCESS:
                    case PHRASE:
                    case FEED:
                    case TITLE:
                    case LINK:
                    case SITE:
                    case AUTHOR_NAME:
                    case CONTENT:
                    case LANGUAGE:
                    case PICKED_UP:
                    case UPDATED:
                    case LINKED:
                    case PHRASE_MATCHES:
                    case PAGE_RANK:
                    case ALEXA_RANK:
                    case PUBLISHED:
                    case TAG:
                    case TOPIC:
                    case SEGMENT:
                    case COUNTRY:
                    case REGION:
                    case CITY:
                    case RELEVANCY_VERIFIED:
                    case ASSIGNEE:
                    case AUTHOR:
                    case EXTRACT:
                    case SENTIMENT_VERIFIED:
                    case URI:
                    case ENGAGEMENT:
                    case REPLY_TO:
                    case REPLY_COUNT:
                    case RESHARE_OF:
                    case RESHARE_COUNT:
                    case REPLY_ORDER_BY_AUTHOR:
                    case CROWD_REGION:
                    case GENDER:
                    case RESPONSE_TIME:
                    case RACE:
                    case INTERACTION_RESPONSE_TIME:
                    case INTERACTION_FIRST_RESPONSE_TIME:
                    case INTERACTION_FOLLOWUP_RESPONSE_TIME:
                    case INTERACTION_WH_RESPONSE_TIME:
                    case INTERACTION_WH_FIRST_RESPONSE_TIME:
                    case INTERACTION_WH_FOLLOWUP_RESPONSE_TIME:
                    case INTERACTION_HAS_RESPONSE:
                    case INTERACTION_FIRST_MENTION_PUBLISHED:
                    case INTERACTION_LAST_MENTION_PUBLISHED:
                    case INTERACTION_FIRST_RESPONSE_PUBLISHED:
                        alt114=1;
                        break;
                    case OTS:
                        alt114=2;
                        break;
                    case AVE:
                        alt114=3;
                        break;
                    case REACH:
                        alt114=4;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 114, 0, this.input);

                        throw nvae;
                }

                switch (alt114) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:438:23: generalNodeOperand
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalNodeOperand_in_selectionNodeOperand6719);
                        generalNodeOperand148=this.generalNodeOperand();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalNodeOperand148.getTree());


                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:438:44: OTS
                        root_0 = this.adaptor.nil();

                        OTS149=this.match(this.input,OTS,MentionQAst.FOLLOW_OTS_in_selectionNodeOperand6723);
                        OTS149_tree = this.adaptor.create(OTS149);
                        this.adaptor.addChild(root_0, OTS149_tree);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:438:50: AVE
                        root_0 = this.adaptor.nil();

                        AVE150=this.match(this.input,AVE,MentionQAst.FOLLOW_AVE_in_selectionNodeOperand6727);
                        AVE150_tree = this.adaptor.create(AVE150);
                        this.adaptor.addChild(root_0, AVE150_tree);



                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:438:56: REACH
                        root_0 = this.adaptor.nil();

                        REACH151=this.match(this.input,REACH,MentionQAst.FOLLOW_REACH_in_selectionNodeOperand6731);
                        REACH151_tree = this.adaptor.create(REACH151);
                        this.adaptor.addChild(root_0, REACH151_tree);



                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        groupby_return: (function() {
            MentionQAst.groupby_return = function(){};
            org.antlr.lang.extend(MentionQAst.groupby_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:442:1: groupby : groupSelectNode ( COMMA groupSelectNode )* EOF ;
        // $ANTLR start "groupby"
        groupby: function() {
            var retval = new MentionQAst.groupby_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var COMMA153 = null;
            var EOF155 = null;
            var groupSelectNode152 = null;
            var groupSelectNode154 = null;

            var COMMA153_tree=null;
            var EOF155_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:443:5: ( groupSelectNode ( COMMA groupSelectNode )* EOF )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:443:9: groupSelectNode ( COMMA groupSelectNode )* EOF
                root_0 = this.adaptor.nil();

                this.pushFollow(MentionQAst.FOLLOW_groupSelectNode_in_groupby6747);
                groupSelectNode152=this.groupSelectNode();

                this.state._fsp--;

                this.adaptor.addChild(root_0, groupSelectNode152.getTree());
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:443:25: ( COMMA groupSelectNode )*
                loop115:
                    do {
                        var alt115=2;
                        var LA115_0 = this.input.LA(1);

                        if ( (LA115_0==COMMA) ) {
                            alt115=1;
                        }


                        switch (alt115) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:443:27: COMMA groupSelectNode
                                COMMA153=this.match(this.input,COMMA,MentionQAst.FOLLOW_COMMA_in_groupby6751);
                                this.pushFollow(MentionQAst.FOLLOW_groupSelectNode_in_groupby6754);
                                groupSelectNode154=this.groupSelectNode();

                                this.state._fsp--;

                                this.adaptor.addChild(root_0, groupSelectNode154.getTree());


                                break;

                            default :
                                break loop115;
                        }
                    } while (true);

                EOF155=this.match(this.input,EOF,MentionQAst.FOLLOW_EOF_in_groupby6759);



                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        groupSelectNode_return: (function() {
            MentionQAst.groupSelectNode_return = function(){};
            org.antlr.lang.extend(MentionQAst.groupSelectNode_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:446:1: groupSelectNode : ( nonDateNodeOperand -> ^( GROUP nonDateNodeOperand ) | dateNodeOperand ( LSQUARE groupPeriodLiteral RSQUARE )? -> ^( GROUP dateNodeOperand ( groupPeriodLiteral )? ) );
        // $ANTLR start "groupSelectNode"
        groupSelectNode: function() {
            var retval = new MentionQAst.groupSelectNode_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var LSQUARE158 = null;
            var RSQUARE160 = null;
            var nonDateNodeOperand156 = null;
            var dateNodeOperand157 = null;
            var groupPeriodLiteral159 = null;

            var LSQUARE158_tree=null;
            var RSQUARE160_tree=null;
            var stream_LSQUARE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token LSQUARE");
            var stream_RSQUARE=new org.antlr.runtime.tree.RewriteRuleTokenStream(this.adaptor,"token RSQUARE");
            var stream_groupPeriodLiteral=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule groupPeriodLiteral");
            var stream_nonDateNodeOperand=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule nonDateNodeOperand");
            var stream_dateNodeOperand=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule dateNodeOperand");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:447:5: ( nonDateNodeOperand -> ^( GROUP nonDateNodeOperand ) | dateNodeOperand ( LSQUARE groupPeriodLiteral RSQUARE )? -> ^( GROUP dateNodeOperand ( groupPeriodLiteral )? ) )
                var alt117=2;
                var LA117_0 = this.input.LA(1);

                if ( (LA117_0==RELEVANCY||LA117_0==BRAND||(LA117_0>=SENTIMENT && LA117_0<=ACTION)||LA117_0==PROCESS||LA117_0==PHRASE||(LA117_0>=FEED && LA117_0<=TITLE)||(LA117_0>=LINK && LA117_0<=AUTHOR_NAME)||LA117_0==CONTENT||LA117_0==LANGUAGE||(LA117_0>=LINKED && LA117_0<=PAGE_RANK)||LA117_0==ALEXA_RANK||(LA117_0>=TAG && LA117_0<=AUTHOR)||(LA117_0>=EXTRACT && LA117_0<=SENTIMENT_VERIFIED)||(LA117_0>=URI && LA117_0<=REPLY_COUNT)||(LA117_0>=RESHARE_OF && LA117_0<=RESHARE_COUNT)||LA117_0==REPLY_ORDER_BY_AUTHOR||(LA117_0>=CROWD_REGION && LA117_0<=RESPONSE_TIME)||LA117_0==RACE||(LA117_0>=INTERACTION_RESPONSE_TIME && LA117_0<=INTERACTION_HAS_RESPONSE)) ) {
                    alt117=1;
                }
                else if ( ((LA117_0>=PICKED_UP && LA117_0<=UPDATED)||LA117_0==PUBLISHED||(LA117_0>=INTERACTION_FIRST_MENTION_PUBLISHED && LA117_0<=INTERACTION_FIRST_RESPONSE_PUBLISHED)) ) {
                    alt117=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 117, 0, this.input);

                    throw nvae;
                }
                switch (alt117) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:447:9: nonDateNodeOperand
                        this.pushFollow(MentionQAst.FOLLOW_nonDateNodeOperand_in_groupSelectNode6779);
                        nonDateNodeOperand156=this.nonDateNodeOperand();

                        this.state._fsp--;

                        stream_nonDateNodeOperand.add(nonDateNodeOperand156.getTree());


                        // AST REWRITE
                        // elements: nonDateNodeOperand
                        // token labels:
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 447:28: -> ^( GROUP nonDateNodeOperand )
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:447:31: ^( GROUP nonDateNodeOperand )
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(GROUP, "GROUP"), root_1);

                            this.adaptor.addChild(root_1, stream_nonDateNodeOperand.nextTree());

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:448:9: dateNodeOperand ( LSQUARE groupPeriodLiteral RSQUARE )?
                        this.pushFollow(MentionQAst.FOLLOW_dateNodeOperand_in_groupSelectNode6797);
                        dateNodeOperand157=this.dateNodeOperand();

                        this.state._fsp--;

                        stream_dateNodeOperand.add(dateNodeOperand157.getTree());
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:448:25: ( LSQUARE groupPeriodLiteral RSQUARE )?
                        var alt116=2;
                        var LA116_0 = this.input.LA(1);

                        if ( (LA116_0==LSQUARE) ) {
                            alt116=1;
                        }
                        switch (alt116) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:448:27: LSQUARE groupPeriodLiteral RSQUARE
                                LSQUARE158=this.match(this.input,LSQUARE,MentionQAst.FOLLOW_LSQUARE_in_groupSelectNode6801);
                                stream_LSQUARE.add(LSQUARE158);

                                this.pushFollow(MentionQAst.FOLLOW_groupPeriodLiteral_in_groupSelectNode6803);
                                groupPeriodLiteral159=this.groupPeriodLiteral();

                                this.state._fsp--;

                                stream_groupPeriodLiteral.add(groupPeriodLiteral159.getTree());
                                RSQUARE160=this.match(this.input,RSQUARE,MentionQAst.FOLLOW_RSQUARE_in_groupSelectNode6805);
                                stream_RSQUARE.add(RSQUARE160);



                                break;

                        }



                        // AST REWRITE
                        // elements: groupPeriodLiteral, dateNodeOperand
                        // token labels:
                        // rule labels: retval
                        // token list labels:
                        // rule list labels:
                        retval.tree = root_0;
                        var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                        root_0 = this.adaptor.nil();
                        // 448:65: -> ^( GROUP dateNodeOperand ( groupPeriodLiteral )? )
                    {
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:448:68: ^( GROUP dateNodeOperand ( groupPeriodLiteral )? )
                        {
                            var root_1 = this.adaptor.nil();
                            root_1 = this.adaptor.becomeRoot(this.adaptor.create(GROUP, "GROUP"), root_1);

                            this.adaptor.addChild(root_1, stream_dateNodeOperand.nextTree());
                            // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:448:92: ( groupPeriodLiteral )?
                            if ( stream_groupPeriodLiteral.hasNext() ) {
                                this.adaptor.addChild(root_1, stream_groupPeriodLiteral.nextTree());

                            }
                            stream_groupPeriodLiteral.reset();

                            this.adaptor.addChild(root_0, root_1);
                        }

                    }

                        retval.tree = root_0;

                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        order_return: (function() {
            MentionQAst.order_return = function(){};
            org.antlr.lang.extend(MentionQAst.order_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:453:1: order : orderNode ( COMMA orderNode )* EOF ;
        // $ANTLR start "order"
        order: function() {
            var retval = new MentionQAst.order_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var COMMA162 = null;
            var EOF164 = null;
            var orderNode161 = null;
            var orderNode163 = null;

            var COMMA162_tree=null;
            var EOF164_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:453:6: ( orderNode ( COMMA orderNode )* EOF )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:453:8: orderNode ( COMMA orderNode )* EOF
                root_0 = this.adaptor.nil();

                this.pushFollow(MentionQAst.FOLLOW_orderNode_in_order6833);
                orderNode161=this.orderNode();

                this.state._fsp--;

                this.adaptor.addChild(root_0, orderNode161.getTree());
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:453:18: ( COMMA orderNode )*
                loop118:
                    do {
                        var alt118=2;
                        var LA118_0 = this.input.LA(1);

                        if ( (LA118_0==COMMA) ) {
                            alt118=1;
                        }


                        switch (alt118) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:453:19: COMMA orderNode
                                COMMA162=this.match(this.input,COMMA,MentionQAst.FOLLOW_COMMA_in_order6836);
                                this.pushFollow(MentionQAst.FOLLOW_orderNode_in_order6839);
                                orderNode163=this.orderNode();

                                this.state._fsp--;

                                this.adaptor.addChild(root_0, orderNode163.getTree());


                                break;

                            default :
                                break loop118;
                        }
                    } while (true);

                EOF164=this.match(this.input,EOF,MentionQAst.FOLLOW_EOF_in_order6843);



                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        orderNode_return: (function() {
            MentionQAst.orderNode_return = function(){};
            org.antlr.lang.extend(MentionQAst.orderNode_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:455:1: orderNode : orderNodeOperand ( orderKeyword )? -> ^( ORDER orderNodeOperand ( orderKeyword )? ) ;
        // $ANTLR start "orderNode"
        orderNode: function() {
            var retval = new MentionQAst.orderNode_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var orderNodeOperand165 = null;
            var orderKeyword166 = null;

            var stream_orderNodeOperand=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule orderNodeOperand");
            var stream_orderKeyword=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"rule orderKeyword");
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:455:10: ( orderNodeOperand ( orderKeyword )? -> ^( ORDER orderNodeOperand ( orderKeyword )? ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:455:12: orderNodeOperand ( orderKeyword )?
                this.pushFollow(MentionQAst.FOLLOW_orderNodeOperand_in_orderNode6851);
                orderNodeOperand165=this.orderNodeOperand();

                this.state._fsp--;

                stream_orderNodeOperand.add(orderNodeOperand165.getTree());
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:455:29: ( orderKeyword )?
                var alt119=2;
                var LA119_0 = this.input.LA(1);

                if ( ((LA119_0>=ASC && LA119_0<=DESC)) ) {
                    alt119=1;
                }
                switch (alt119) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:455:29: orderKeyword
                        this.pushFollow(MentionQAst.FOLLOW_orderKeyword_in_orderNode6853);
                        orderKeyword166=this.orderKeyword();

                        this.state._fsp--;

                        stream_orderKeyword.add(orderKeyword166.getTree());


                        break;

                }



                // AST REWRITE
                // elements: orderKeyword, orderNodeOperand
                // token labels:
                // rule labels: retval
                // token list labels:
                // rule list labels:
                retval.tree = root_0;
                var stream_retval=new org.antlr.runtime.tree.RewriteRuleSubtreeStream(this.adaptor,"token retval",retval!=null?retval.tree:null);

                root_0 = this.adaptor.nil();
                // 455:43: -> ^( ORDER orderNodeOperand ( orderKeyword )? )
                {
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:455:46: ^( ORDER orderNodeOperand ( orderKeyword )? )
                    {
                        var root_1 = this.adaptor.nil();
                        root_1 = this.adaptor.becomeRoot(this.adaptor.create(ORDER, "ORDER"), root_1);

                        this.adaptor.addChild(root_1, stream_orderNodeOperand.nextTree());
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:455:71: ( orderKeyword )?
                        if ( stream_orderKeyword.hasNext() ) {
                            this.adaptor.addChild(root_1, stream_orderKeyword.nextTree());

                        }
                        stream_orderKeyword.reset();

                        this.adaptor.addChild(root_0, root_1);
                    }

                }

                retval.tree = root_0;


                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        orderKeyword_return: (function() {
            MentionQAst.orderKeyword_return = function(){};
            org.antlr.lang.extend(MentionQAst.orderKeyword_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:457:1: orderKeyword : ( ASC | DESC );
        // $ANTLR start "orderKeyword"
        orderKeyword: function() {
            var retval = new MentionQAst.orderKeyword_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set167 = null;

            var set167_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:457:13: ( ASC | DESC )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set167=this.input.LT(1);
                if ( (this.input.LA(1)>=ASC && this.input.LA(1)<=DESC) ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set167));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        orderNodeOperand_return: (function() {
            MentionQAst.orderNodeOperand_return = function(){};
            org.antlr.lang.extend(MentionQAst.orderNodeOperand_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:461:1: orderNodeOperand : ( COUNT | MENTION_ID | generalNodeOperand | OTS | AVE | REACH );
        // $ANTLR start "orderNodeOperand"
        orderNodeOperand: function() {
            var retval = new MentionQAst.orderNodeOperand_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var COUNT168 = null;
            var MENTION_ID169 = null;
            var OTS171 = null;
            var AVE172 = null;
            var REACH173 = null;
            var generalNodeOperand170 = null;

            var COUNT168_tree=null;
            var MENTION_ID169_tree=null;
            var OTS171_tree=null;
            var AVE172_tree=null;
            var REACH173_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:461:17: ( COUNT | MENTION_ID | generalNodeOperand | OTS | AVE | REACH )
                var alt120=6;
                switch ( this.input.LA(1) ) {
                    case COUNT:
                        alt120=1;
                        break;
                    case MENTION_ID:
                        alt120=2;
                        break;
                    case RELEVANCY:
                    case BRAND:
                    case SENTIMENT:
                    case CREDIBILITY:
                    case MEDIA:
                    case ACTION:
                    case PROCESS:
                    case PHRASE:
                    case FEED:
                    case TITLE:
                    case LINK:
                    case SITE:
                    case AUTHOR_NAME:
                    case CONTENT:
                    case LANGUAGE:
                    case PICKED_UP:
                    case UPDATED:
                    case LINKED:
                    case PHRASE_MATCHES:
                    case PAGE_RANK:
                    case ALEXA_RANK:
                    case PUBLISHED:
                    case TAG:
                    case TOPIC:
                    case SEGMENT:
                    case COUNTRY:
                    case REGION:
                    case CITY:
                    case RELEVANCY_VERIFIED:
                    case ASSIGNEE:
                    case AUTHOR:
                    case EXTRACT:
                    case SENTIMENT_VERIFIED:
                    case URI:
                    case ENGAGEMENT:
                    case REPLY_TO:
                    case REPLY_COUNT:
                    case RESHARE_OF:
                    case RESHARE_COUNT:
                    case REPLY_ORDER_BY_AUTHOR:
                    case CROWD_REGION:
                    case GENDER:
                    case RESPONSE_TIME:
                    case RACE:
                    case INTERACTION_RESPONSE_TIME:
                    case INTERACTION_FIRST_RESPONSE_TIME:
                    case INTERACTION_FOLLOWUP_RESPONSE_TIME:
                    case INTERACTION_WH_RESPONSE_TIME:
                    case INTERACTION_WH_FIRST_RESPONSE_TIME:
                    case INTERACTION_WH_FOLLOWUP_RESPONSE_TIME:
                    case INTERACTION_HAS_RESPONSE:
                    case INTERACTION_FIRST_MENTION_PUBLISHED:
                    case INTERACTION_LAST_MENTION_PUBLISHED:
                    case INTERACTION_FIRST_RESPONSE_PUBLISHED:
                        alt120=3;
                        break;
                    case OTS:
                        alt120=4;
                        break;
                    case AVE:
                        alt120=5;
                        break;
                    case REACH:
                        alt120=6;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 120, 0, this.input);

                        throw nvae;
                }

                switch (alt120) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:461:19: COUNT
                        root_0 = this.adaptor.nil();

                        COUNT168=this.match(this.input,COUNT,MentionQAst.FOLLOW_COUNT_in_orderNodeOperand6885);
                        COUNT168_tree = this.adaptor.create(COUNT168);
                        this.adaptor.addChild(root_0, COUNT168_tree);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:461:27: MENTION_ID
                        root_0 = this.adaptor.nil();

                        MENTION_ID169=this.match(this.input,MENTION_ID,MentionQAst.FOLLOW_MENTION_ID_in_orderNodeOperand6889);
                        MENTION_ID169_tree = this.adaptor.create(MENTION_ID169);
                        this.adaptor.addChild(root_0, MENTION_ID169_tree);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:461:40: generalNodeOperand
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_generalNodeOperand_in_orderNodeOperand6893);
                        generalNodeOperand170=this.generalNodeOperand();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, generalNodeOperand170.getTree());


                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:461:61: OTS
                        root_0 = this.adaptor.nil();

                        OTS171=this.match(this.input,OTS,MentionQAst.FOLLOW_OTS_in_orderNodeOperand6897);
                        OTS171_tree = this.adaptor.create(OTS171);
                        this.adaptor.addChild(root_0, OTS171_tree);



                        break;
                    case 5 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:461:67: AVE
                        root_0 = this.adaptor.nil();

                        AVE172=this.match(this.input,AVE,MentionQAst.FOLLOW_AVE_in_orderNodeOperand6901);
                        AVE172_tree = this.adaptor.create(AVE172);
                        this.adaptor.addChild(root_0, AVE172_tree);



                        break;
                    case 6 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:461:73: REACH
                        root_0 = this.adaptor.nil();

                        REACH173=this.match(this.input,REACH,MentionQAst.FOLLOW_REACH_in_orderNodeOperand6905);
                        REACH173_tree = this.adaptor.create(REACH173);
                        this.adaptor.addChild(root_0, REACH173_tree);



                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        generalNodeOperand_return: (function() {
            MentionQAst.generalNodeOperand_return = function(){};
            org.antlr.lang.extend(MentionQAst.generalNodeOperand_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:463:1: generalNodeOperand : ( dateNodeOperand | nonDateNodeOperand );
        // $ANTLR start "generalNodeOperand"
        generalNodeOperand: function() {
            var retval = new MentionQAst.generalNodeOperand_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var dateNodeOperand174 = null;
            var nonDateNodeOperand175 = null;


            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:463:19: ( dateNodeOperand | nonDateNodeOperand )
                var alt121=2;
                var LA121_0 = this.input.LA(1);

                if ( ((LA121_0>=PICKED_UP && LA121_0<=UPDATED)||LA121_0==PUBLISHED||(LA121_0>=INTERACTION_FIRST_MENTION_PUBLISHED && LA121_0<=INTERACTION_FIRST_RESPONSE_PUBLISHED)) ) {
                    alt121=1;
                }
                else if ( (LA121_0==RELEVANCY||LA121_0==BRAND||(LA121_0>=SENTIMENT && LA121_0<=ACTION)||LA121_0==PROCESS||LA121_0==PHRASE||(LA121_0>=FEED && LA121_0<=TITLE)||(LA121_0>=LINK && LA121_0<=AUTHOR_NAME)||LA121_0==CONTENT||LA121_0==LANGUAGE||(LA121_0>=LINKED && LA121_0<=PAGE_RANK)||LA121_0==ALEXA_RANK||(LA121_0>=TAG && LA121_0<=AUTHOR)||(LA121_0>=EXTRACT && LA121_0<=SENTIMENT_VERIFIED)||(LA121_0>=URI && LA121_0<=REPLY_COUNT)||(LA121_0>=RESHARE_OF && LA121_0<=RESHARE_COUNT)||LA121_0==REPLY_ORDER_BY_AUTHOR||(LA121_0>=CROWD_REGION && LA121_0<=RESPONSE_TIME)||LA121_0==RACE||(LA121_0>=INTERACTION_RESPONSE_TIME && LA121_0<=INTERACTION_HAS_RESPONSE)) ) {
                    alt121=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 121, 0, this.input);

                    throw nvae;
                }
                switch (alt121) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:463:21: dateNodeOperand
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_dateNodeOperand_in_generalNodeOperand6912);
                        dateNodeOperand174=this.dateNodeOperand();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, dateNodeOperand174.getTree());


                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:463:39: nonDateNodeOperand
                        root_0 = this.adaptor.nil();

                        this.pushFollow(MentionQAst.FOLLOW_nonDateNodeOperand_in_generalNodeOperand6916);
                        nonDateNodeOperand175=this.nonDateNodeOperand();

                        this.state._fsp--;

                        this.adaptor.addChild(root_0, nonDateNodeOperand175.getTree());


                        break;

                }
                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        dateNodeOperand_return: (function() {
            MentionQAst.dateNodeOperand_return = function(){};
            org.antlr.lang.extend(MentionQAst.dateNodeOperand_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:465:1: dateNodeOperand : ( PUBLISHED | PICKED_UP | UPDATED | INTERACTION_FIRST_MENTION_PUBLISHED | INTERACTION_FIRST_RESPONSE_PUBLISHED | INTERACTION_LAST_MENTION_PUBLISHED );
        // $ANTLR start "dateNodeOperand"
        dateNodeOperand: function() {
            var retval = new MentionQAst.dateNodeOperand_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set176 = null;

            var set176_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:465:16: ( PUBLISHED | PICKED_UP | UPDATED | INTERACTION_FIRST_MENTION_PUBLISHED | INTERACTION_FIRST_RESPONSE_PUBLISHED | INTERACTION_LAST_MENTION_PUBLISHED )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set176=this.input.LT(1);
                if ( (this.input.LA(1)>=PICKED_UP && this.input.LA(1)<=UPDATED)||this.input.LA(1)==PUBLISHED||(this.input.LA(1)>=INTERACTION_FIRST_MENTION_PUBLISHED && this.input.LA(1)<=INTERACTION_FIRST_RESPONSE_PUBLISHED) ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set176));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        },

        // inline static return class
        nonDateNodeOperand_return: (function() {
            MentionQAst.nonDateNodeOperand_return = function(){};
            org.antlr.lang.extend(MentionQAst.nonDateNodeOperand_return,
                org.antlr.runtime.ParserRuleReturnScope,
                {
                    getTree: function() { return this.tree; }
                });
            return;
        })(),

        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:467:1: nonDateNodeOperand : ( RELEVANCY | BRAND | SENTIMENT | CROWD_REGION | CREDIBILITY | MEDIA | ACTION | PROCESS | PHRASE | URI | FEED | TITLE | LINK | SITE | AUTHOR_NAME | CONTENT | LANGUAGE | LINKED | PHRASE_MATCHES | PAGE_RANK | ALEXA_RANK | TAG | COUNTRY | REGION | CITY | RELEVANCY_VERIFIED | ASSIGNEE | AUTHOR | EXTRACT | SENTIMENT_VERIFIED | ENGAGEMENT | REPLY_TO | RESHARE_OF | RESHARE_COUNT | REPLY_COUNT | GENDER | RESPONSE_TIME | REPLY_ORDER_BY_AUTHOR | RACE | TOPIC | SEGMENT | INTERACTION_RESPONSE_TIME | INTERACTION_FIRST_RESPONSE_TIME | INTERACTION_FOLLOWUP_RESPONSE_TIME | INTERACTION_WH_RESPONSE_TIME | INTERACTION_WH_FIRST_RESPONSE_TIME | INTERACTION_WH_FOLLOWUP_RESPONSE_TIME | INTERACTION_HAS_RESPONSE );
        // $ANTLR start "nonDateNodeOperand"
        nonDateNodeOperand: function() {
            var retval = new MentionQAst.nonDateNodeOperand_return();
            retval.start = this.input.LT(1);

            var root_0 = null;

            var set177 = null;

            var set177_tree=null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:468:5: ( RELEVANCY | BRAND | SENTIMENT | CROWD_REGION | CREDIBILITY | MEDIA | ACTION | PROCESS | PHRASE | URI | FEED | TITLE | LINK | SITE | AUTHOR_NAME | CONTENT | LANGUAGE | LINKED | PHRASE_MATCHES | PAGE_RANK | ALEXA_RANK | TAG | COUNTRY | REGION | CITY | RELEVANCY_VERIFIED | ASSIGNEE | AUTHOR | EXTRACT | SENTIMENT_VERIFIED | ENGAGEMENT | REPLY_TO | RESHARE_OF | RESHARE_COUNT | REPLY_COUNT | GENDER | RESPONSE_TIME | REPLY_ORDER_BY_AUTHOR | RACE | TOPIC | SEGMENT | INTERACTION_RESPONSE_TIME | INTERACTION_FIRST_RESPONSE_TIME | INTERACTION_FOLLOWUP_RESPONSE_TIME | INTERACTION_WH_RESPONSE_TIME | INTERACTION_WH_FIRST_RESPONSE_TIME | INTERACTION_WH_FOLLOWUP_RESPONSE_TIME | INTERACTION_HAS_RESPONSE )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAst.g:
                root_0 = this.adaptor.nil();

                set177=this.input.LT(1);
                if ( this.input.LA(1)==RELEVANCY||this.input.LA(1)==BRAND||(this.input.LA(1)>=SENTIMENT && this.input.LA(1)<=ACTION)||this.input.LA(1)==PROCESS||this.input.LA(1)==PHRASE||(this.input.LA(1)>=FEED && this.input.LA(1)<=TITLE)||(this.input.LA(1)>=LINK && this.input.LA(1)<=AUTHOR_NAME)||this.input.LA(1)==CONTENT||this.input.LA(1)==LANGUAGE||(this.input.LA(1)>=LINKED && this.input.LA(1)<=PAGE_RANK)||this.input.LA(1)==ALEXA_RANK||(this.input.LA(1)>=TAG && this.input.LA(1)<=AUTHOR)||(this.input.LA(1)>=EXTRACT && this.input.LA(1)<=SENTIMENT_VERIFIED)||(this.input.LA(1)>=URI && this.input.LA(1)<=REPLY_COUNT)||(this.input.LA(1)>=RESHARE_OF && this.input.LA(1)<=RESHARE_COUNT)||this.input.LA(1)==REPLY_ORDER_BY_AUTHOR||(this.input.LA(1)>=CROWD_REGION && this.input.LA(1)<=RESPONSE_TIME)||this.input.LA(1)==RACE||(this.input.LA(1)>=INTERACTION_RESPONSE_TIME && this.input.LA(1)<=INTERACTION_HAS_RESPONSE) ) {
                    this.input.consume();
                    this.adaptor.addChild(root_0, this.adaptor.create(set177));
                    this.state.errorRecovery=false;
                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    throw mse;
                }




                retval.stop = this.input.LT(-1);

                retval.tree = this.adaptor.rulePostProcessing(root_0);
                this.adaptor.setTokenBoundaries(retval.tree, retval.start, retval.stop);

            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                    retval.tree = this.adaptor.errorNode(this.input, retval.start, this.input.LT(-1), re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return retval;
        }

        // Delegated rules




    }, true); // important to pass true to overwrite default implementations



// public class variables
    org.antlr.lang.augmentObject(MentionQAst, {
        tokenNames: ["<invalid>", "<EOR>", "<DOWN>", "<UP>", "NEWLINE", "WHITESPACE", "O", "R", "OR", "A", "N", "D", "AND", "E", "L", "V", "C", "Y", "RELEVANCY", "B", "BRAND", "S", "T", "I", "M", "SENTIMENT", "CREDIBILITY", "MEDIA", "ACTION", "P", "PROCESS", "H", "PHRASE", "U", "PHRASE_COUNT", "F", "FEED", "TITLE", "K", "LINK", "SITE", "AUTHOR_NAME", "AUTHOR_LOCATION", "CONTENT", "G", "LANGUAGE", "PICKED_UP", "UPDATED", "LINKED", "PHRASE_MATCHES", "PAGE_RANK", "X", "ALEXA_RANK", "PUBLISHED", "PUBLISHEDTIME", "TAG", "TOPIC", "SEGMENT", "COUNTRY", "REGION", "CITY", "RELEVANCY_VERIFIED", "ASSIGNEE", "AUTHOR", "AUTHOR_ID", "EXTRACT", "SENTIMENT_VERIFIED", "W", "CROWD_VERIFIED", "DISCARDED_BY", "MENTION_ID", "CROWD_ID", "URI", "ENGAGEMENT", "REPLY_TO", "REPLY_COUNT", "GRAPH_REPLY_COUNT", "RESHARE_OF", "RESHARE_COUNT", "GRAPH_RESHARE_COUNT", "REPLY_ORDER_BY_AUTHOR", "OTS", "AVE", "REACH", "STATUS_COUNT", "FOLLOWER_COUNT", "GRAPH_FOLLOWER_COUNT", "FOLLOWING_COUNT", "CROWD_REGION", "GENDER", "RESPONSE_TIME", "UNBIASED_SAMPLE", "MENTIONED_PROFILE", "RACE", "DIRECT_MESSAGE", "VISIBILITY", "TICKET_ID", "SOCIAL_NETWORK", "AUTHOR_HANDLE", "AUTHOR_HANDLE_ID", "TO_NAME", "TO_HANDLE", "TO_HANDLE_ID", "AUTHOR_BIO", "CONVERSATION_ID", "TOMBSTONED", "SCRUBBED", "HAS_REPLY_FROM_PROFILE", "INTERACTION_ID", "INTERACTION_RESPONSE_TIME", "INTERACTION_FIRST_RESPONSE_TIME", "INTERACTION_FOLLOWUP_RESPONSE_TIME", "INTERACTION_WH_RESPONSE_TIME", "INTERACTION_WH_FIRST_RESPONSE_TIME", "INTERACTION_WH_FOLLOWUP_RESPONSE_TIME", "INTERACTION_HAS_RESPONSE", "INTERACTION_FIRST_MENTION_PUBLISHED", "INTERACTION_LAST_MENTION_PUBLISHED", "INTERACTION_FIRST_RESPONSE_PUBLISHED", "UCN", "TWITTER_SCREEN_NAME", "HANDLE_ID", "FACEBOOK_ID", "IS", "ISNT", "ISORCHILDOF", "BEFORE", "AFTER", "GREATERTHAN", "GREATERTHANEQUALS", "LESSTHAN", "LESSTHANEQUALS", "EQUALS", "NOTEQUALS", "CONTAINS", "DOESNTCONTAIN", "BEGINSWITH", "ENDSWITH", "MATCHES", "ISNTNORCHILDOF", "INTHELAST", "BEFORETHELAST", "ON", "IN", "NOTIN", "DISTINCT", "SAMPLE", "PRESS", "ENTERPRISE", "CONSUMER", "DIRECTORY", "UNSORTED", "RELEVANT", "DUPLICATE", "IRRELEVANT", "SPAM", "SORTED", "VERIFIED", "NONE", "RESOLVED", "UNRESOLVED", "TODAY", "HOUR", "DAY", "TWENTY_FOUR_HRS", "WEEK", "FORTNIGHT", "MONTH", "Q", "QUARTER", "YEAR", "EPOCH", "FALSE", "TRUE", "MALE", "FEMALE", "OTHER", "UNKNOWN", "LONG_LITERAL", "TAG_ID_LITERAL", "FLOAT_LITERAL", "DATE_SEPARATOR", "DIGIT", "UNQUOTED_DATE", "DATE_LITERAL", "STRING_LITERAL", "ANNOTATION", "LPAREN", "RPAREN", "COMMA", "DIVIDE", "LSQUARE", "RSQUARE", "ASC", "DESC", "COUNT", "UNQUOTED_STRING_LITERAL", "J", "Z", "ORDER", "GROUP", "SELECTION", "ATTRIBUTE", "OR_NODE", "AND_NODE", "TWITTER_AUTHOR", "FACTOR", "SAMPLE_FACTOR", "SET_LONG_FACTOR", "SET_MENTION_ID_FACTOR", "SUB_FILTER_FACTOR"],
        FOLLOW_expression_in_filter159: new org.antlr.runtime.BitSet([0x00000000, 0x00000000]),
        FOLLOW_EOF_in_filter161: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_term_in_expression183: new org.antlr.runtime.BitSet([0x00000102, 0x00000000]),
        FOLLOW_OR_in_expression187: new org.antlr.runtime.BitSet([0x5E140000, 0xF7F7EFB5,0xFEFFFFF7, 0x00FFFFFF,0x00040000, 0x08000000]),
        FOLLOW_expression_in_expression191: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_factor_in_term242: new org.antlr.runtime.BitSet([0x00001002, 0x00000000]),
        FOLLOW_AND_in_term246: new org.antlr.runtime.BitSet([0x5E140000, 0xF7F7EFB5,0xFEFFFFF7, 0x00FFFFFF,0x00040000, 0x08000000]),
        FOLLOW_term_in_term250: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalFactor_in_factor302: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalStringFactor_in_factor312: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_feedFactor_in_factor322: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalUnknownStringFactor_in_factor332: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalIsIsntStringFactor_in_factor342: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_cityIsIsntFactor_in_factor352: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalIsIsntLongFactor_in_factor362: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_sampleFactor_in_factor372: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalInLongFactor_in_factor382: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalInOnlyLongFactor_in_factor392: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_mentionIdFactor_in_factor402: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_interactionIdFactor_in_factor412: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_authorIdFactor_in_factor422: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalTreeLongFactor_in_factor432: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalComparisonLongFactor_in_factor442: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_replyingToFactor_in_factor452: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_reshareOfFactor_in_factor462: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_tagFactor_in_factor472: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_mediaFactor_in_factor482: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_genderFactor_in_factor492: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_raceFactor_in_factor502: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_relevancyFactor_in_factor512: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_processFactor_in_factor522: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_actionFactor_in_factor532: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_dateFactor_in_factor542: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_dateUnknownFactor_in_factor552: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_timeFactor_in_factor562: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_matchesFactor_in_factor572: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_booleanFactor_in_factor582: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_engagedProfileIsIsntLongFactor_in_factor592: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_socialNetworkFactor_in_factor602: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_visibilityFactor_in_factor612: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_LPAREN_in_generalFactor631: new org.antlr.runtime.BitSet([0x5E140000, 0xF7F7EFB5,0xFEFFFFF7, 0x00FFFFFF,0x00040000, 0x08000000]),
        FOLLOW_expression_in_generalFactor634: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x10000000]),
        FOLLOW_RPAREN_in_generalFactor636: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_TITLE_in_generalStringFactor660: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_LINK_in_generalStringFactor666: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_SITE_in_generalStringFactor672: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_EXTRACT_in_generalStringFactor678: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_URI_in_generalStringFactor684: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_AUTHOR_LOCATION_in_generalStringFactor690: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_stringOperator_in_generalStringFactor697: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_STRING_LITERAL_in_generalStringFactor701: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_AUTHOR_in_generalUnknownStringFactor745: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_AUTHOR_NAME_in_generalUnknownStringFactor751: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_AUTHOR_HANDLE_in_generalUnknownStringFactor757: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_AUTHOR_HANDLE_ID_in_generalUnknownStringFactor763: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_TO_NAME_in_generalUnknownStringFactor769: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_TO_HANDLE_in_generalUnknownStringFactor775: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_TO_HANDLE_ID_in_generalUnknownStringFactor781: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_TICKET_ID_in_generalUnknownStringFactor787: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_UCN_in_generalUnknownStringFactor793: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000003C0, 0x00000000]),
        FOLLOW_CONTAINS_in_generalUnknownStringFactor811: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_DOESNTCONTAIN_in_generalUnknownStringFactor817: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_BEGINSWITH_in_generalUnknownStringFactor823: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_ENDSWITH_in_generalUnknownStringFactor829: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_STRING_LITERAL_in_generalUnknownStringFactor834: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IS_in_generalUnknownStringFactor863: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02020000]),
        FOLLOW_ISNT_in_generalUnknownStringFactor869: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02020000]),
        FOLLOW_STRING_LITERAL_in_generalUnknownStringFactor875: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_generalUnknownStringFactor881: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_FEED_in_feedFactor928: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_feedFactor937: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_ISNT_in_feedFactor943: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_STRING_LITERAL_in_feedFactor950: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_COUNTRY_in_generalIsIsntStringFactor995: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_LANGUAGE_in_generalIsIsntStringFactor1001: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_generalIsIsntStringFactor1010: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02020000]),
        FOLLOW_ISNT_in_generalIsIsntStringFactor1016: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02020000]),
        FOLLOW_STRING_LITERAL_in_generalIsIsntStringFactor1023: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_generalIsIsntStringFactor1029: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_CITY_in_cityIsIsntFactor1073: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_cityIsIsntFactor1082: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00020000]),
        FOLLOW_ISNT_in_cityIsIsntFactor1088: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00020000]),
        FOLLOW_UNKNOWN_in_cityIsIsntFactor1095: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_ASSIGNEE_in_generalIsIsntLongFactor1139: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_PHRASE_in_generalIsIsntLongFactor1145: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_DISCARDED_BY_in_generalIsIsntLongFactor1151: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_generalIsIsntLongFactor1158: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00060000]),
        FOLLOW_ISNT_in_generalIsIsntLongFactor1164: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00060000]),
        FOLLOW_LONG_LITERAL_in_generalIsIsntLongFactor1173: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_generalIsIsntLongFactor1179: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_MENTIONED_PROFILE_in_engagedProfileIsIsntLongFactor1224: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_engagedProfileIsIsntLongFactor1231: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_ISNT_in_engagedProfileIsIsntLongFactor1237: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_LONG_LITERAL_in_engagedProfileIsIsntLongFactor1246: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_SAMPLE_in_sampleFactor1287: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x08000000]),
        FOLLOW_LPAREN_in_sampleFactor1289: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00100000]),
        FOLLOW_FLOAT_LITERAL_in_sampleFactor1293: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x20000000]),
        FOLLOW_COMMA_in_sampleFactor1295: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_LONG_LITERAL_in_sampleFactor1299: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x10000000]),
        FOLLOW_RPAREN_in_sampleFactor1301: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_SAMPLE_in_sampleFactor1327: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x08000000]),
        FOLLOW_LPAREN_in_sampleFactor1329: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00100000]),
        FOLLOW_FLOAT_LITERAL_in_sampleFactor1333: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x10000000]),
        FOLLOW_RPAREN_in_sampleFactor1335: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_CROWD_ID_in_generalInLongFactor1372: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x00018000, 0x00000000]),
        FOLLOW_IN_in_generalInLongFactor1390: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_NOTIN_in_generalInLongFactor1396: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_longIdSet_in_generalInLongFactor1402: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IS_in_generalInLongFactor1449: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00060000]),
        FOLLOW_ISNT_in_generalInLongFactor1457: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00060000]),
        FOLLOW_LONG_LITERAL_in_generalInLongFactor1464: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_generalInLongFactor1470: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_HAS_REPLY_FROM_PROFILE_in_generalInOnlyLongFactor1519: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00018000, 0x00000000]),
        FOLLOW_IN_in_generalInOnlyLongFactor1537: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_NOTIN_in_generalInOnlyLongFactor1543: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_longIdSet_in_generalInOnlyLongFactor1549: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_ANNOTATION_in_longIdSet1597: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x08000000]),
        FOLLOW_LPAREN_in_longIdSet1601: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_LONG_LITERAL_in_longIdSet1604: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x30000000]),
        FOLLOW_COMMA_in_longIdSet1608: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_LONG_LITERAL_in_longIdSet1611: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x30000000]),
        FOLLOW_RPAREN_in_longIdSet1617: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_INTERACTION_ID_in_interactionIdFactor1642: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x00018000, 0x00000000]),
        FOLLOW_IN_in_interactionIdFactor1671: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_NOTIN_in_interactionIdFactor1677: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_longOrStringIdSet_in_interactionIdFactor1683: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IN_in_interactionIdFactor1728: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x08000000]),
        FOLLOW_NOTIN_in_interactionIdFactor1734: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x08000000]),
        FOLLOW_LPAREN_in_interactionIdFactor1738: new org.antlr.runtime.BitSet([0x5E140000, 0xF7F7EFB5,0xFEFFFFF7, 0x00FFFFFF,0x00040000, 0x08000000]),
        FOLLOW_expression_in_interactionIdFactor1742: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x10000000]),
        FOLLOW_RPAREN_in_interactionIdFactor1744: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IS_in_interactionIdFactor1791: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02020000]),
        FOLLOW_ISNT_in_interactionIdFactor1799: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02020000]),
        FOLLOW_STRING_LITERAL_in_interactionIdFactor1806: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_interactionIdFactor1812: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_MENTION_ID_in_mentionIdFactor1865: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0001800F, 0x00000000]),
        FOLLOW_CONVERSATION_ID_in_mentionIdFactor1871: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0001800F, 0x00000000]),
        FOLLOW_IN_in_mentionIdFactor1900: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_NOTIN_in_mentionIdFactor1906: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_longOrStringIdSet_in_mentionIdFactor1912: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IN_in_mentionIdFactor1957: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x08000000]),
        FOLLOW_NOTIN_in_mentionIdFactor1963: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x08000000]),
        FOLLOW_LPAREN_in_mentionIdFactor1967: new org.antlr.runtime.BitSet([0x5E140000, 0xF7F7EFB5,0xFEFFFFF7, 0x00FFFFFF,0x00040000, 0x08000000]),
        FOLLOW_expression_in_mentionIdFactor1971: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x10000000]),
        FOLLOW_RPAREN_in_mentionIdFactor1973: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IS_in_mentionIdFactor2020: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02040000]),
        FOLLOW_ISNT_in_mentionIdFactor2028: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02040000]),
        FOLLOW_GREATERTHAN_in_mentionIdFactor2036: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02040000]),
        FOLLOW_LESSTHAN_in_mentionIdFactor2044: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02040000]),
        FOLLOW_GREATERTHANEQUALS_in_mentionIdFactor2052: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02040000]),
        FOLLOW_LESSTHANEQUALS_in_mentionIdFactor2060: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02040000]),
        FOLLOW_LONG_LITERAL_in_mentionIdFactor2067: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_STRING_LITERAL_in_mentionIdFactor2073: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_ANNOTATION_in_longOrStringIdSet2133: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x08000000]),
        FOLLOW_LPAREN_in_longOrStringIdSet2137: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02040000]),
        FOLLOW_set_in_longOrStringIdSet2140: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x30000000]),
        FOLLOW_COMMA_in_longOrStringIdSet2152: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02040000]),
        FOLLOW_set_in_longOrStringIdSet2155: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x30000000]),
        FOLLOW_RPAREN_in_longOrStringIdSet2169: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_AUTHOR_ID_in_authorIdFactor2194: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x00018000, 0x00000000]),
        FOLLOW_IN_in_authorIdFactor2212: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_NOTIN_in_authorIdFactor2218: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_longOrStringIdSet_in_authorIdFactor2224: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IS_in_authorIdFactor2271: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02060000]),
        FOLLOW_ISNT_in_authorIdFactor2279: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02060000]),
        FOLLOW_LONG_LITERAL_in_authorIdFactor2286: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_STRING_LITERAL_in_authorIdFactor2292: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_authorIdFactor2298: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_BRAND_in_generalTreeLongFactor2340: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x38000000,0x00000800, 0x00000000]),
        FOLLOW_IS_in_generalTreeLongFactor2346: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_ISNT_in_generalTreeLongFactor2352: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_ISORCHILDOF_in_generalTreeLongFactor2358: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_ISNTNORCHILDOF_in_generalTreeLongFactor2364: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_LONG_LITERAL_in_generalTreeLongFactor2370: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_SENTIMENT_in_generalComparisonLongFactor2415: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_CREDIBILITY_in_generalComparisonLongFactor2421: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_PAGE_RANK_in_generalComparisonLongFactor2427: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_ALEXA_RANK_in_generalComparisonLongFactor2433: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_PHRASE_MATCHES_in_generalComparisonLongFactor2439: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_AVE_in_generalComparisonLongFactor2445: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_OTS_in_generalComparisonLongFactor2451: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_ENGAGEMENT_in_generalComparisonLongFactor2457: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_REPLY_COUNT_in_generalComparisonLongFactor2475: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_GRAPH_REPLY_COUNT_in_generalComparisonLongFactor2481: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_RESHARE_COUNT_in_generalComparisonLongFactor2487: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_GRAPH_RESHARE_COUNT_in_generalComparisonLongFactor2493: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_REACH_in_generalComparisonLongFactor2499: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_PHRASE_COUNT_in_generalComparisonLongFactor2505: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_STATUS_COUNT_in_generalComparisonLongFactor2523: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_FOLLOWER_COUNT_in_generalComparisonLongFactor2529: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_GRAPH_FOLLOWER_COUNT_in_generalComparisonLongFactor2535: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_FOLLOWING_COUNT_in_generalComparisonLongFactor2541: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_RESPONSE_TIME_in_generalComparisonLongFactor2547: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_REPLY_ORDER_BY_AUTHOR_in_generalComparisonLongFactor2553: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_INTERACTION_FIRST_RESPONSE_TIME_in_generalComparisonLongFactor2571: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_INTERACTION_FOLLOWUP_RESPONSE_TIME_in_generalComparisonLongFactor2577: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_INTERACTION_RESPONSE_TIME_in_generalComparisonLongFactor2583: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_INTERACTION_WH_FIRST_RESPONSE_TIME_in_generalComparisonLongFactor2601: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_INTERACTION_WH_FOLLOWUP_RESPONSE_TIME_in_generalComparisonLongFactor2607: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_INTERACTION_WH_RESPONSE_TIME_in_generalComparisonLongFactor2613: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x0000003F, 0x00000000]),
        FOLLOW_EQUALS_in_generalComparisonLongFactor2641: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_NOTEQUALS_in_generalComparisonLongFactor2647: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_LESSTHAN_in_generalComparisonLongFactor2653: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_LESSTHANEQUALS_in_generalComparisonLongFactor2659: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_GREATERTHAN_in_generalComparisonLongFactor2665: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_GREATERTHANEQUALS_in_generalComparisonLongFactor2671: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_LONG_LITERAL_in_generalComparisonLongFactor2677: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IS_in_generalComparisonLongFactor2708: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00020000]),
        FOLLOW_ISNT_in_generalComparisonLongFactor2714: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00020000]),
        FOLLOW_UNKNOWN_in_generalComparisonLongFactor2720: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_REPLY_TO_in_replyingToFactor2765: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000180C0, 0x00000000]),
        FOLLOW_IS_in_replyingToFactor2786: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02060000]),
        FOLLOW_ISNT_in_replyingToFactor2792: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02060000]),
        FOLLOW_LONG_LITERAL_in_replyingToFactor2799: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_STRING_LITERAL_in_replyingToFactor2805: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_replyingToFactor2811: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IN_in_replyingToFactor2851: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_NOTIN_in_replyingToFactor2857: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_longOrStringIdSet_in_replyingToFactor2863: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_CONTAINS_in_replyingToFactor2900: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_DOESNTCONTAIN_in_replyingToFactor2906: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_STRING_LITERAL_in_replyingToFactor2914: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_RESHARE_OF_in_reshareOfFactor2960: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000180C0, 0x00000000]),
        FOLLOW_IS_in_reshareOfFactor2981: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02060000]),
        FOLLOW_ISNT_in_reshareOfFactor2987: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02060000]),
        FOLLOW_LONG_LITERAL_in_reshareOfFactor2994: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_STRING_LITERAL_in_reshareOfFactor3000: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_reshareOfFactor3006: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IN_in_reshareOfFactor3046: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_NOTIN_in_reshareOfFactor3052: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0C000000]),
        FOLLOW_longOrStringIdSet_in_reshareOfFactor3058: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_CONTAINS_in_reshareOfFactor3095: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_DOESNTCONTAIN_in_reshareOfFactor3101: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_STRING_LITERAL_in_reshareOfFactor3109: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_TAG_in_tagFactor3156: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_TOPIC_in_tagFactor3162: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_SEGMENT_in_tagFactor3168: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_tagFactor3175: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x020E0000]),
        FOLLOW_ISNT_in_tagFactor3181: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x020E0000]),
        FOLLOW_STRING_LITERAL_in_tagFactor3189: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_LONG_LITERAL_in_tagFactor3195: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_TAG_ID_LITERAL_in_tagFactor3201: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_tagFactor3207: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_MEDIA_in_mediaFactor3251: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_mediaFactor3257: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00780000, 0x00020000]),
        FOLLOW_ISNT_in_mediaFactor3263: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00780000, 0x00020000]),
        FOLLOW_mediaLiteralAndUnknown_in_mediaFactor3269: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_GENDER_in_genderFactor3310: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_genderFactor3316: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0003C000]),
        FOLLOW_ISNT_in_genderFactor3322: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0003C000]),
        FOLLOW_genderLiteralAndUnknown_in_genderFactor3328: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_RACE_in_raceFactor3369: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_raceFactor3375: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00020000,0x00000010, 0x00000000]),
        FOLLOW_ISNT_in_raceFactor3381: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00020000,0x00000010, 0x00000000]),
        FOLLOW_unknownOrUnquotedString_in_raceFactor3387: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_SOCIAL_NETWORK_in_socialNetworkFactor3428: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_socialNetworkFactor3434: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00020000,0x00000010, 0x00000000]),
        FOLLOW_ISNT_in_socialNetworkFactor3440: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00020000,0x00000010, 0x00000000]),
        FOLLOW_unknownOrUnquotedString_in_socialNetworkFactor3446: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_VISIBILITY_in_visibilityFactor3487: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_visibilityFactor3493: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_ISNT_in_visibilityFactor3499: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_UNQUOTED_STRING_LITERAL_in_visibilityFactor3505: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_RELEVANCY_in_relevancyFactor3546: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_relevancyFactor3552: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x0F800000, 0x00000000]),
        FOLLOW_ISNT_in_relevancyFactor3558: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x0F800000, 0x00000000]),
        FOLLOW_relevancyLiteral_in_relevancyFactor3564: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_PROCESS_in_processFactor3606: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_processFactor3612: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x30800000, 0x00000000]),
        FOLLOW_ISNT_in_processFactor3618: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x30800000, 0x00000000]),
        FOLLOW_processLiteral_in_processFactor3624: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_ACTION_in_actionFactor3665: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_actionFactor3671: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0xC0000000, 0x00020001]),
        FOLLOW_ISNT_in_actionFactor3677: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0xC0000000, 0x00020001]),
        FOLLOW_actionLiteralAndUnknown_in_actionFactor3684: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_PUBLISHED_in_dateFactor3729: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0xC0000000,0x00007000, 0x00000000]),
        FOLLOW_PICKED_UP_in_dateFactor3735: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0xC0000000,0x00007000, 0x00000000]),
        FOLLOW_UPDATED_in_dateFactor3741: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0xC0000000,0x00007000, 0x00000000]),
        FOLLOW_INTHELAST_in_dateFactor3759: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000EFC]),
        FOLLOW_BEFORETHELAST_in_dateFactor3765: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000EFC]),
        FOLLOW_periodLiteral_in_dateFactor3771: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_BEFORE_in_dateFactor3819: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x01000000]),
        FOLLOW_AFTER_in_dateFactor3825: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x01000000]),
        FOLLOW_ON_in_dateFactor3831: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x01000000]),
        FOLLOW_DATE_LITERAL_in_dateFactor3837: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_ON_in_dateFactor3885: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000002]),
        FOLLOW_TODAY_in_dateFactor3889: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_TOMBSTONED_in_dateUnknownFactor3978: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0xD8000000,0x00007000, 0x00000000]),
        FOLLOW_SCRUBBED_in_dateUnknownFactor3984: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0xD8000000,0x00007000, 0x00000000]),
        FOLLOW_INTERACTION_FIRST_MENTION_PUBLISHED_in_dateUnknownFactor3990: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0xD8000000,0x00007000, 0x00000000]),
        FOLLOW_INTERACTION_FIRST_RESPONSE_PUBLISHED_in_dateUnknownFactor3996: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0xD8000000,0x00007000, 0x00000000]),
        FOLLOW_INTERACTION_LAST_MENTION_PUBLISHED_in_dateUnknownFactor4002: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0xD8000000,0x00007000, 0x00000000]),
        FOLLOW_INTHELAST_in_dateUnknownFactor4020: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000EFC]),
        FOLLOW_BEFORETHELAST_in_dateUnknownFactor4026: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000EFC]),
        FOLLOW_periodLiteral_in_dateUnknownFactor4032: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_BEFORE_in_dateUnknownFactor4080: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x01000000]),
        FOLLOW_AFTER_in_dateUnknownFactor4086: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x01000000]),
        FOLLOW_ON_in_dateUnknownFactor4092: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x01000000]),
        FOLLOW_DATE_LITERAL_in_dateUnknownFactor4098: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IS_in_dateUnknownFactor4147: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00020000]),
        FOLLOW_ISNT_in_dateUnknownFactor4153: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00020000]),
        FOLLOW_UNKNOWN_in_dateUnknownFactor4159: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_ON_in_dateUnknownFactor4226: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000002]),
        FOLLOW_TODAY_in_dateUnknownFactor4230: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_PUBLISHEDTIME_in_timeFactor4318: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0xC0000000]),
        FOLLOW_BEFORE_in_timeFactor4324: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_AFTER_in_timeFactor4330: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_STRING_LITERAL_in_timeFactor4333: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_CONTENT_in_matchesFactor4370: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000400, 0x00000000]),
        FOLLOW_AUTHOR_BIO_in_matchesFactor4376: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000400, 0x00000000]),
        FOLLOW_MATCHES_in_matchesFactor4379: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_STRING_LITERAL_in_matchesFactor4381: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_LINKED_in_booleanFactor4422: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_RELEVANCY_VERIFIED_in_booleanFactor4428: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_SENTIMENT_VERIFIED_in_booleanFactor4434: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_CROWD_VERIFIED_in_booleanFactor4440: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_UNBIASED_SAMPLE_in_booleanFactor4446: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_DIRECT_MESSAGE_in_booleanFactor4452: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_INTERACTION_HAS_RESPONSE_in_booleanFactor4458: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000]),
        FOLLOW_IS_in_booleanFactor4473: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00003000]),
        FOLLOW_ISNT_in_booleanFactor4479: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00003000]),
        FOLLOW_TRUE_in_booleanFactor4495: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_FALSE_in_booleanFactor4501: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_stringOperator0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_isIsntOperator0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_mediaLiteral0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_mediaLiteral_in_mediaLiteralAndUnknown4636: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_mediaLiteralAndUnknown4640: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_unknownOrUnquotedString0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_genderLiteral0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_genderLiteral_in_genderLiteralAndUnknown4698: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_genderLiteralAndUnknown4702: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_relevancyLiteral0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_processLiteral0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_actionLiteral0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_actionLiteral_in_actionLiteralAndUnknown4810: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_actionLiteralAndUnknown4814: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_periodLiteral0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_hourPeriod_in_groupPeriodLiteral4884: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_DAY_in_groupPeriodLiteral4888: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_WEEK_in_groupPeriodLiteral4892: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_FORTNIGHT_in_groupPeriodLiteral4896: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_MONTH_in_groupPeriodLiteral4900: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_QUARTER_in_groupPeriodLiteral4904: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_YEAR_in_groupPeriodLiteral4908: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_HOUR_in_hourPeriod4927: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_HOUR_in_hourPeriod4937: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x40000000]),
        FOLLOW_DIVIDE_in_hourPeriod4940: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_LONG_LITERAL_in_hourPeriod4943: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_authorsExpression_in_authors4965: new org.antlr.runtime.BitSet([0x00000000, 0x00000000]),
        FOLLOW_EOF_in_authors4967: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_authorsTerm_in_authorsExpression4989: new org.antlr.runtime.BitSet([0x00000102, 0x00000000]),
        FOLLOW_OR_in_authorsExpression4993: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x07000000]),
        FOLLOW_authorsExpression_in_authorsExpression4997: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_authorsFactor_in_authorsTerm5048: new org.antlr.runtime.BitSet([0x00001002, 0x00000000]),
        FOLLOW_AND_in_authorsTerm5052: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x07000000]),
        FOLLOW_authorsTerm_in_authorsTerm5056: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalTwitterScreenNameFactor_in_authorsFactor5108: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalFacebookIdFactor_in_authorsFactor5118: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalHandleIdFactor_in_authorsFactor5128: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_TWITTER_SCREEN_NAME_in_generalTwitterScreenNameFactor5147: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000083C0, 0x00000000]),
        FOLLOW_stringOperator_in_generalTwitterScreenNameFactor5151: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_STRING_LITERAL_in_generalTwitterScreenNameFactor5153: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IN_in_generalTwitterScreenNameFactor5230: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x08000000]),
        FOLLOW_stringList_in_generalTwitterScreenNameFactor5232: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_FACEBOOK_ID_in_generalFacebookIdFactor5281: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000083C0, 0x00000000]),
        FOLLOW_stringOperator_in_generalFacebookIdFactor5285: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_STRING_LITERAL_in_generalFacebookIdFactor5287: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IN_in_generalFacebookIdFactor5364: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x08000000]),
        FOLLOW_stringList_in_generalFacebookIdFactor5366: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_HANDLE_ID_in_generalHandleIdFactor5415: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x18000000,0x000083C0, 0x00000000]),
        FOLLOW_stringOperator_in_generalHandleIdFactor5419: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_STRING_LITERAL_in_generalHandleIdFactor5421: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IN_in_generalHandleIdFactor5498: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x08000000]),
        FOLLOW_stringList_in_generalHandleIdFactor5500: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_LPAREN_in_stringList5549: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_STRING_LITERAL_in_stringList5552: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x30000000]),
        FOLLOW_COMMA_in_stringList5556: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02000000]),
        FOLLOW_STRING_LITERAL_in_stringList5559: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x30000000]),
        FOLLOW_RPAREN_in_stringList5565: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_attributeNode_in_attributes5589: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x20000000]),
        FOLLOW_COMMA_in_attributes5593: new org.antlr.runtime.BitSet([0x1E040000, 0x64802000,0x23000000, 0x00000000]),
        FOLLOW_attributeNode_in_attributes5596: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x20000000]),
        FOLLOW_EOF_in_attributes5601: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_RELEVANCY_in_attributeNode5627: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_EQUALS_in_attributeNode5674: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x0F800000, 0x00000000]),
        FOLLOW_UNSORTED_in_attributeNode5685: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_RELEVANT_in_attributeNode5691: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_DUPLICATE_in_attributeNode5697: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_IRRELEVANT_in_attributeNode5703: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_SPAM_in_attributeNode5709: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_MEDIA_in_attributeNode5727: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_EQUALS_in_attributeNode5778: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00780000, 0x00000000]),
        FOLLOW_PRESS_in_attributeNode5789: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_ENTERPRISE_in_attributeNode5795: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_CONSUMER_in_attributeNode5801: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_DIRECTORY_in_attributeNode5807: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_ACTION_in_attributeNode5825: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_EQUALS_in_attributeNode5875: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0xC0000000, 0x00000001]),
        FOLLOW_NONE_in_attributeNode5886: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNRESOLVED_in_attributeNode5892: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_RESOLVED_in_attributeNode5898: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_SENTIMENT_in_attributeNode5918: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_CROWD_REGION_in_attributeNode5924: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_EQUALS_in_attributeNode5946: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_LONG_LITERAL_in_attributeNode5955: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_CREDIBILITY_in_attributeNode5973: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_ASSIGNEE_in_attributeNode5979: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_EQUALS_in_attributeNode6003: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00060000]),
        FOLLOW_LONG_LITERAL_in_attributeNode6014: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_attributeNode6020: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_LANGUAGE_in_attributeNode6040: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_COUNTRY_in_attributeNode6046: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_EQUALS_in_attributeNode6074: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02020000]),
        FOLLOW_STRING_LITERAL_in_attributeNode6085: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_attributeNode6091: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_TAG_in_attributeNode6111: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_EQUALS_in_attributeNode6162: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02040000]),
        FOLLOW_STRING_LITERAL_in_attributeNode6175: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_LONG_LITERAL_in_attributeNode6183: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_RELEVANCY_VERIFIED_in_attributeNode6203: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_EQUALS_in_attributeNode6239: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00003000]),
        FOLLOW_TRUE_in_attributeNode6250: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_FALSE_in_attributeNode6256: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_GENDER_in_attributeNode6276: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_EQUALS_in_attributeNode6324: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x0003C000]),
        FOLLOW_MALE_in_attributeNode6335: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_FEMALE_in_attributeNode6341: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_OTHER_in_attributeNode6347: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNKNOWN_in_attributeNode6353: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_RACE_in_attributeNode6373: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000010, 0x00000000]),
        FOLLOW_EQUALS_in_attributeNode6423: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00020000,0x00000010, 0x00000000]),
        FOLLOW_UNKNOWN_in_attributeNode6434: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_UNQUOTED_STRING_LITERAL_in_attributeNode6440: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_countNode_in_count6483: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x20000000]),
        FOLLOW_COMMA_in_count6486: new org.antlr.runtime.BitSet([0x1C000000, 0xDC002300,0x02000040, 0x00000000,0x00020000, 0x00000000]),
        FOLLOW_countNode_in_count6489: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x20000000]),
        FOLLOW_EOF_in_count6493: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_distinctKeyword_in_countNode6501: new org.antlr.runtime.BitSet([0x1C000000, 0xDC002300,0x02000040, 0x00000000,0x00020000, 0x00000000]),
        FOLLOW_countNodeOperand_in_countNode6504: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_countNodeOperand0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_DISTINCT_in_distinctKeyword6585: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_selectionOperand_in_selections6599: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x20000000]),
        FOLLOW_COMMA_in_selections6603: new org.antlr.runtime.BitSet([0x5E140000, 0xFFB7EBB1,0x270F6FC6, 0x007FE000]),
        FOLLOW_selectionOperand_in_selections6606: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x20000000]),
        FOLLOW_EOF_in_selections6611: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_MENTION_ID_in_selectionOperand6632: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_CROWD_ID_in_selectionOperand6663: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_selectionNodeOperand_in_selectionOperand6696: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalNodeOperand_in_selectionNodeOperand6719: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_OTS_in_selectionNodeOperand6723: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_AVE_in_selectionNodeOperand6727: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_REACH_in_selectionNodeOperand6731: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_groupSelectNode_in_groupby6747: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x20000000]),
        FOLLOW_COMMA_in_groupby6751: new org.antlr.runtime.BitSet([0x5E140000, 0xFFB7EBB1,0x27016F06, 0x007FE000]),
        FOLLOW_groupSelectNode_in_groupby6754: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x20000000]),
        FOLLOW_EOF_in_groupby6759: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_nonDateNodeOperand_in_groupSelectNode6779: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_dateNodeOperand_in_groupSelectNode6797: new org.antlr.runtime.BitSet([0x00000002, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x80000000]),
        FOLLOW_LSQUARE_in_groupSelectNode6801: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x000006EC]),
        FOLLOW_groupPeriodLiteral_in_groupSelectNode6803: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000001, 0x00000000]),
        FOLLOW_RSQUARE_in_groupSelectNode6805: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_orderNode_in_order6833: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x20000000]),
        FOLLOW_COMMA_in_order6836: new org.antlr.runtime.BitSet([0x5E140000, 0xFFB7EBB1,0x270F6F46, 0x007FE000,0x00000000, 0x00000000,0x00000008, 0x00000000]),
        FOLLOW_orderNode_in_order6839: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x20000000]),
        FOLLOW_EOF_in_order6843: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_orderNodeOperand_in_orderNode6851: new org.antlr.runtime.BitSet([0x00000002, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000006, 0x00000000]),
        FOLLOW_orderKeyword_in_orderNode6853: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_orderKeyword0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_COUNT_in_orderNodeOperand6885: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_MENTION_ID_in_orderNodeOperand6889: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_generalNodeOperand_in_orderNodeOperand6893: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_OTS_in_orderNodeOperand6897: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_AVE_in_orderNodeOperand6901: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_REACH_in_orderNodeOperand6905: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_dateNodeOperand_in_generalNodeOperand6912: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_nonDateNodeOperand_in_generalNodeOperand6916: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_dateNodeOperand0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_set_in_nonDateNodeOperand0: new org.antlr.runtime.BitSet([0x00000002, 0x00000000])
    });

})();

// $ANTLR 3.3 Nov 30, 2010 12:46:29 /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAttributeParser.g 2024-06-04 12:32:07

var MentionQAttributeParser = function(input, state) {
    if (!state) {
        state = new org.antlr.runtime.RecognizerSharedState();
    }

    (function(){

        this.emitErrorMessage = function(msg) {
            throw msg;
        }

    }).call(this);

    MentionQAttributeParser.superclass.constructor.call(this, input, state);




    /* @todo only create adaptor if output=AST */
    this.adaptor = new org.antlr.runtime.tree.CommonTreeAdaptor();

};

org.antlr.lang.augmentObject(MentionQAttributeParser, {
    EOF: -1,
    NEWLINE: 4,
    WHITESPACE: 5,
    O: 6,
    R: 7,
    OR: 8,
    A: 9,
    N: 10,
    D: 11,
    AND: 12,
    E: 13,
    L: 14,
    V: 15,
    C: 16,
    Y: 17,
    RELEVANCY: 18,
    B: 19,
    BRAND: 20,
    S: 21,
    T: 22,
    I: 23,
    M: 24,
    SENTIMENT: 25,
    CREDIBILITY: 26,
    MEDIA: 27,
    ACTION: 28,
    P: 29,
    PROCESS: 30,
    H: 31,
    PHRASE: 32,
    U: 33,
    PHRASE_COUNT: 34,
    F: 35,
    FEED: 36,
    TITLE: 37,
    K: 38,
    LINK: 39,
    SITE: 40,
    AUTHOR_NAME: 41,
    AUTHOR_LOCATION: 42,
    CONTENT: 43,
    G: 44,
    LANGUAGE: 45,
    PICKED_UP: 46,
    UPDATED: 47,
    LINKED: 48,
    PHRASE_MATCHES: 49,
    PAGE_RANK: 50,
    X: 51,
    ALEXA_RANK: 52,
    PUBLISHED: 53,
    PUBLISHEDTIME: 54,
    TAG: 55,
    TOPIC: 56,
    SEGMENT: 57,
    COUNTRY: 58,
    REGION: 59,
    CITY: 60,
    RELEVANCY_VERIFIED: 61,
    ASSIGNEE: 62,
    AUTHOR: 63,
    AUTHOR_ID: 64,
    EXTRACT: 65,
    SENTIMENT_VERIFIED: 66,
    W: 67,
    CROWD_VERIFIED: 68,
    DISCARDED_BY: 69,
    MENTION_ID: 70,
    CROWD_ID: 71,
    URI: 72,
    ENGAGEMENT: 73,
    REPLY_TO: 74,
    REPLY_COUNT: 75,
    GRAPH_REPLY_COUNT: 76,
    RESHARE_OF: 77,
    RESHARE_COUNT: 78,
    GRAPH_RESHARE_COUNT: 79,
    REPLY_ORDER_BY_AUTHOR: 80,
    OTS: 81,
    AVE: 82,
    REACH: 83,
    STATUS_COUNT: 84,
    FOLLOWER_COUNT: 85,
    GRAPH_FOLLOWER_COUNT: 86,
    FOLLOWING_COUNT: 87,
    CROWD_REGION: 88,
    GENDER: 89,
    RESPONSE_TIME: 90,
    UNBIASED_SAMPLE: 91,
    MENTIONED_PROFILE: 92,
    RACE: 93,
    DIRECT_MESSAGE: 94,
    VISIBILITY: 95,
    TICKET_ID: 96,
    SOCIAL_NETWORK: 97,
    AUTHOR_HANDLE: 98,
    AUTHOR_HANDLE_ID: 99,
    TO_NAME: 100,
    TO_HANDLE: 101,
    TO_HANDLE_ID: 102,
    AUTHOR_BIO: 103,
    CONVERSATION_ID: 104,
    TOMBSTONED: 105,
    SCRUBBED: 106,
    HAS_REPLY_FROM_PROFILE: 107,
    INTERACTION_ID: 108,
    INTERACTION_RESPONSE_TIME: 109,
    INTERACTION_FIRST_RESPONSE_TIME: 110,
    INTERACTION_FOLLOWUP_RESPONSE_TIME: 111,
    INTERACTION_WH_RESPONSE_TIME: 112,
    INTERACTION_WH_FIRST_RESPONSE_TIME: 113,
    INTERACTION_WH_FOLLOWUP_RESPONSE_TIME: 114,
    INTERACTION_HAS_RESPONSE: 115,
    INTERACTION_FIRST_MENTION_PUBLISHED: 116,
    INTERACTION_LAST_MENTION_PUBLISHED: 117,
    INTERACTION_FIRST_RESPONSE_PUBLISHED: 118,
    UCN: 119,
    TWITTER_SCREEN_NAME: 120,
    HANDLE_ID: 121,
    FACEBOOK_ID: 122,
    IS: 123,
    ISNT: 124,
    ISORCHILDOF: 125,
    BEFORE: 126,
    AFTER: 127,
    GREATERTHAN: 128,
    GREATERTHANEQUALS: 129,
    LESSTHAN: 130,
    LESSTHANEQUALS: 131,
    EQUALS: 132,
    NOTEQUALS: 133,
    CONTAINS: 134,
    DOESNTCONTAIN: 135,
    BEGINSWITH: 136,
    ENDSWITH: 137,
    MATCHES: 138,
    ISNTNORCHILDOF: 139,
    INTHELAST: 140,
    BEFORETHELAST: 141,
    ON: 142,
    IN: 143,
    NOTIN: 144,
    DISTINCT: 145,
    SAMPLE: 146,
    PRESS: 147,
    ENTERPRISE: 148,
    CONSUMER: 149,
    DIRECTORY: 150,
    UNSORTED: 151,
    RELEVANT: 152,
    DUPLICATE: 153,
    IRRELEVANT: 154,
    SPAM: 155,
    SORTED: 156,
    VERIFIED: 157,
    NONE: 158,
    RESOLVED: 159,
    UNRESOLVED: 160,
    TODAY: 161,
    HOUR: 162,
    DAY: 163,
    TWENTY_FOUR_HRS: 164,
    WEEK: 165,
    FORTNIGHT: 166,
    MONTH: 167,
    Q: 168,
    QUARTER: 169,
    YEAR: 170,
    EPOCH: 171,
    FALSE: 172,
    TRUE: 173,
    MALE: 174,
    FEMALE: 175,
    OTHER: 176,
    UNKNOWN: 177,
    LONG_LITERAL: 178,
    TAG_ID_LITERAL: 179,
    FLOAT_LITERAL: 180,
    DATE_SEPARATOR: 181,
    DIGIT: 182,
    UNQUOTED_DATE: 183,
    DATE_LITERAL: 184,
    STRING_LITERAL: 185,
    ANNOTATION: 186,
    LPAREN: 187,
    RPAREN: 188,
    COMMA: 189,
    DIVIDE: 190,
    LSQUARE: 191,
    RSQUARE: 192,
    ASC: 193,
    DESC: 194,
    COUNT: 195,
    UNQUOTED_STRING_LITERAL: 196,
    J: 197,
    Z: 198,
    ORDER: 199,
    GROUP: 200,
    SELECTION: 201,
    ATTRIBUTE: 202,
    OR_NODE: 203,
    AND_NODE: 204,
    TWITTER_AUTHOR: 205,
    FACTOR: 206,
    SAMPLE_FACTOR: 207,
    SET_LONG_FACTOR: 208,
    SET_MENTION_ID_FACTOR: 209,
    SUB_FILTER_FACTOR: 210
});

(function(){
// public class variables
    var EOF= -1,
        NEWLINE= 4,
        WHITESPACE= 5,
        O= 6,
        R= 7,
        OR= 8,
        A= 9,
        N= 10,
        D= 11,
        AND= 12,
        E= 13,
        L= 14,
        V= 15,
        C= 16,
        Y= 17,
        RELEVANCY= 18,
        B= 19,
        BRAND= 20,
        S= 21,
        T= 22,
        I= 23,
        M= 24,
        SENTIMENT= 25,
        CREDIBILITY= 26,
        MEDIA= 27,
        ACTION= 28,
        P= 29,
        PROCESS= 30,
        H= 31,
        PHRASE= 32,
        U= 33,
        PHRASE_COUNT= 34,
        F= 35,
        FEED= 36,
        TITLE= 37,
        K= 38,
        LINK= 39,
        SITE= 40,
        AUTHOR_NAME= 41,
        AUTHOR_LOCATION= 42,
        CONTENT= 43,
        G= 44,
        LANGUAGE= 45,
        PICKED_UP= 46,
        UPDATED= 47,
        LINKED= 48,
        PHRASE_MATCHES= 49,
        PAGE_RANK= 50,
        X= 51,
        ALEXA_RANK= 52,
        PUBLISHED= 53,
        PUBLISHEDTIME= 54,
        TAG= 55,
        TOPIC= 56,
        SEGMENT= 57,
        COUNTRY= 58,
        REGION= 59,
        CITY= 60,
        RELEVANCY_VERIFIED= 61,
        ASSIGNEE= 62,
        AUTHOR= 63,
        AUTHOR_ID= 64,
        EXTRACT= 65,
        SENTIMENT_VERIFIED= 66,
        W= 67,
        CROWD_VERIFIED= 68,
        DISCARDED_BY= 69,
        MENTION_ID= 70,
        CROWD_ID= 71,
        URI= 72,
        ENGAGEMENT= 73,
        REPLY_TO= 74,
        REPLY_COUNT= 75,
        GRAPH_REPLY_COUNT= 76,
        RESHARE_OF= 77,
        RESHARE_COUNT= 78,
        GRAPH_RESHARE_COUNT= 79,
        REPLY_ORDER_BY_AUTHOR= 80,
        OTS= 81,
        AVE= 82,
        REACH= 83,
        STATUS_COUNT= 84,
        FOLLOWER_COUNT= 85,
        GRAPH_FOLLOWER_COUNT= 86,
        FOLLOWING_COUNT= 87,
        CROWD_REGION= 88,
        GENDER= 89,
        RESPONSE_TIME= 90,
        UNBIASED_SAMPLE= 91,
        MENTIONED_PROFILE= 92,
        RACE= 93,
        DIRECT_MESSAGE= 94,
        VISIBILITY= 95,
        TICKET_ID= 96,
        SOCIAL_NETWORK= 97,
        AUTHOR_HANDLE= 98,
        AUTHOR_HANDLE_ID= 99,
        TO_NAME= 100,
        TO_HANDLE= 101,
        TO_HANDLE_ID= 102,
        AUTHOR_BIO= 103,
        CONVERSATION_ID= 104,
        TOMBSTONED= 105,
        SCRUBBED= 106,
        HAS_REPLY_FROM_PROFILE= 107,
        INTERACTION_ID= 108,
        INTERACTION_RESPONSE_TIME= 109,
        INTERACTION_FIRST_RESPONSE_TIME= 110,
        INTERACTION_FOLLOWUP_RESPONSE_TIME= 111,
        INTERACTION_WH_RESPONSE_TIME= 112,
        INTERACTION_WH_FIRST_RESPONSE_TIME= 113,
        INTERACTION_WH_FOLLOWUP_RESPONSE_TIME= 114,
        INTERACTION_HAS_RESPONSE= 115,
        INTERACTION_FIRST_MENTION_PUBLISHED= 116,
        INTERACTION_LAST_MENTION_PUBLISHED= 117,
        INTERACTION_FIRST_RESPONSE_PUBLISHED= 118,
        UCN= 119,
        TWITTER_SCREEN_NAME= 120,
        HANDLE_ID= 121,
        FACEBOOK_ID= 122,
        IS= 123,
        ISNT= 124,
        ISORCHILDOF= 125,
        BEFORE= 126,
        AFTER= 127,
        GREATERTHAN= 128,
        GREATERTHANEQUALS= 129,
        LESSTHAN= 130,
        LESSTHANEQUALS= 131,
        EQUALS= 132,
        NOTEQUALS= 133,
        CONTAINS= 134,
        DOESNTCONTAIN= 135,
        BEGINSWITH= 136,
        ENDSWITH= 137,
        MATCHES= 138,
        ISNTNORCHILDOF= 139,
        INTHELAST= 140,
        BEFORETHELAST= 141,
        ON= 142,
        IN= 143,
        NOTIN= 144,
        DISTINCT= 145,
        SAMPLE= 146,
        PRESS= 147,
        ENTERPRISE= 148,
        CONSUMER= 149,
        DIRECTORY= 150,
        UNSORTED= 151,
        RELEVANT= 152,
        DUPLICATE= 153,
        IRRELEVANT= 154,
        SPAM= 155,
        SORTED= 156,
        VERIFIED= 157,
        NONE= 158,
        RESOLVED= 159,
        UNRESOLVED= 160,
        TODAY= 161,
        HOUR= 162,
        DAY= 163,
        TWENTY_FOUR_HRS= 164,
        WEEK= 165,
        FORTNIGHT= 166,
        MONTH= 167,
        Q= 168,
        QUARTER= 169,
        YEAR= 170,
        EPOCH= 171,
        FALSE= 172,
        TRUE= 173,
        MALE= 174,
        FEMALE= 175,
        OTHER= 176,
        UNKNOWN= 177,
        LONG_LITERAL= 178,
        TAG_ID_LITERAL= 179,
        FLOAT_LITERAL= 180,
        DATE_SEPARATOR= 181,
        DIGIT= 182,
        UNQUOTED_DATE= 183,
        DATE_LITERAL= 184,
        STRING_LITERAL= 185,
        ANNOTATION= 186,
        LPAREN= 187,
        RPAREN= 188,
        COMMA= 189,
        DIVIDE= 190,
        LSQUARE= 191,
        RSQUARE= 192,
        ASC= 193,
        DESC= 194,
        COUNT= 195,
        UNQUOTED_STRING_LITERAL= 196,
        J= 197,
        Z= 198,
        ORDER= 199,
        GROUP= 200,
        SELECTION= 201,
        ATTRIBUTE= 202,
        OR_NODE= 203,
        AND_NODE= 204,
        TWITTER_AUTHOR= 205,
        FACTOR= 206,
        SAMPLE_FACTOR= 207,
        SET_LONG_FACTOR= 208,
        SET_MENTION_ID_FACTOR= 209,
        SUB_FILTER_FACTOR= 210;
    var UP = org.antlr.runtime.Token.UP,
        DOWN = org.antlr.runtime.Token.DOWN;

// public instance methods/vars
    org.antlr.lang.extend(MentionQAttributeParser, org.antlr.runtime.tree.TreeParser, {


        getTokenNames: function() { return MentionQAttributeParser.tokenNames; },
        getGrammarFileName: function() { return "/Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAttributeParser.g"; }
    });
    org.antlr.lang.augmentObject(MentionQAttributeParser.prototype, {


        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAttributeParser.g:17:1: attributes returns [attributes] : ( attributeNode )* ;
        // $ANTLR start "attributes"
        attributes: function() {
            var attributes = null;

            var attributeNode1 = null;

            attributes = [];
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAttributeParser.g:19:5: ( ( attributeNode )* )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAttributeParser.g:19:9: ( attributeNode )*
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAttributeParser.g:19:9: ( attributeNode )*
                loop1:
                    do {
                        var alt1=2;
                        var LA1_0 = this.input.LA(1);

                        if ( (LA1_0==ATTRIBUTE) ) {
                            alt1=1;
                        }


                        switch (alt1) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAttributeParser.g:19:11: attributeNode
                                this.pushFollow(MentionQAttributeParser.FOLLOW_attributeNode_in_attributes69);
                                attributeNode1=this.attributeNode();

                                this.state._fsp--;

                                attributes.push(attributeNode1);


                                break;

                            default :
                                break loop1;
                        }
                    } while (true);




            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return attributes;
        },


        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAttributeParser.g:22:1: attributeNode returns [node] : ^( ATTRIBUTE operand= . literal= . ) ;
        // $ANTLR start "attributeNode"
        attributeNode: function() {
            var node = null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAttributeParser.g:23:5: ( ^( ATTRIBUTE operand= . literal= . ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQAttributeParser.g:24:9: ^( ATTRIBUTE operand= . literal= . )
                this.match(this.input,ATTRIBUTE,MentionQAttributeParser.FOLLOW_ATTRIBUTE_in_attributeNode104);

                this.match(this.input, org.antlr.runtime.Token.DOWN, null);
                operand=this.input.LT(1);
                this.matchAny(this.input);
                literal=this.input.LT(1);
                this.matchAny(this.input);

                this.match(this.input, org.antlr.runtime.Token.UP, null);

                var operandToken = operand.token;
                var literalToken = literal.token;
                node = createAttrExpNode(operandToken, literalToken);
                verifyUpdateProperties(node);




            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return node;
        }

        // Delegated rules




    }, true); // important to pass true to overwrite default implementations



// public class variables
    org.antlr.lang.augmentObject(MentionQAttributeParser, {
        tokenNames: ["<invalid>", "<EOR>", "<DOWN>", "<UP>", "NEWLINE", "WHITESPACE", "O", "R", "OR", "A", "N", "D", "AND", "E", "L", "V", "C", "Y", "RELEVANCY", "B", "BRAND", "S", "T", "I", "M", "SENTIMENT", "CREDIBILITY", "MEDIA", "ACTION", "P", "PROCESS", "H", "PHRASE", "U", "PHRASE_COUNT", "F", "FEED", "TITLE", "K", "LINK", "SITE", "AUTHOR_NAME", "AUTHOR_LOCATION", "CONTENT", "G", "LANGUAGE", "PICKED_UP", "UPDATED", "LINKED", "PHRASE_MATCHES", "PAGE_RANK", "X", "ALEXA_RANK", "PUBLISHED", "PUBLISHEDTIME", "TAG", "TOPIC", "SEGMENT", "COUNTRY", "REGION", "CITY", "RELEVANCY_VERIFIED", "ASSIGNEE", "AUTHOR", "AUTHOR_ID", "EXTRACT", "SENTIMENT_VERIFIED", "W", "CROWD_VERIFIED", "DISCARDED_BY", "MENTION_ID", "CROWD_ID", "URI", "ENGAGEMENT", "REPLY_TO", "REPLY_COUNT", "GRAPH_REPLY_COUNT", "RESHARE_OF", "RESHARE_COUNT", "GRAPH_RESHARE_COUNT", "REPLY_ORDER_BY_AUTHOR", "OTS", "AVE", "REACH", "STATUS_COUNT", "FOLLOWER_COUNT", "GRAPH_FOLLOWER_COUNT", "FOLLOWING_COUNT", "CROWD_REGION", "GENDER", "RESPONSE_TIME", "UNBIASED_SAMPLE", "MENTIONED_PROFILE", "RACE", "DIRECT_MESSAGE", "VISIBILITY", "TICKET_ID", "SOCIAL_NETWORK", "AUTHOR_HANDLE", "AUTHOR_HANDLE_ID", "TO_NAME", "TO_HANDLE", "TO_HANDLE_ID", "AUTHOR_BIO", "CONVERSATION_ID", "TOMBSTONED", "SCRUBBED", "HAS_REPLY_FROM_PROFILE", "INTERACTION_ID", "INTERACTION_RESPONSE_TIME", "INTERACTION_FIRST_RESPONSE_TIME", "INTERACTION_FOLLOWUP_RESPONSE_TIME", "INTERACTION_WH_RESPONSE_TIME", "INTERACTION_WH_FIRST_RESPONSE_TIME", "INTERACTION_WH_FOLLOWUP_RESPONSE_TIME", "INTERACTION_HAS_RESPONSE", "INTERACTION_FIRST_MENTION_PUBLISHED", "INTERACTION_LAST_MENTION_PUBLISHED", "INTERACTION_FIRST_RESPONSE_PUBLISHED", "UCN", "TWITTER_SCREEN_NAME", "HANDLE_ID", "FACEBOOK_ID", "IS", "ISNT", "ISORCHILDOF", "BEFORE", "AFTER", "GREATERTHAN", "GREATERTHANEQUALS", "LESSTHAN", "LESSTHANEQUALS", "EQUALS", "NOTEQUALS", "CONTAINS", "DOESNTCONTAIN", "BEGINSWITH", "ENDSWITH", "MATCHES", "ISNTNORCHILDOF", "INTHELAST", "BEFORETHELAST", "ON", "IN", "NOTIN", "DISTINCT", "SAMPLE", "PRESS", "ENTERPRISE", "CONSUMER", "DIRECTORY", "UNSORTED", "RELEVANT", "DUPLICATE", "IRRELEVANT", "SPAM", "SORTED", "VERIFIED", "NONE", "RESOLVED", "UNRESOLVED", "TODAY", "HOUR", "DAY", "TWENTY_FOUR_HRS", "WEEK", "FORTNIGHT", "MONTH", "Q", "QUARTER", "YEAR", "EPOCH", "FALSE", "TRUE", "MALE", "FEMALE", "OTHER", "UNKNOWN", "LONG_LITERAL", "TAG_ID_LITERAL", "FLOAT_LITERAL", "DATE_SEPARATOR", "DIGIT", "UNQUOTED_DATE", "DATE_LITERAL", "STRING_LITERAL", "ANNOTATION", "LPAREN", "RPAREN", "COMMA", "DIVIDE", "LSQUARE", "RSQUARE", "ASC", "DESC", "COUNT", "UNQUOTED_STRING_LITERAL", "J", "Z", "ORDER", "GROUP", "SELECTION", "ATTRIBUTE", "OR_NODE", "AND_NODE", "TWITTER_AUTHOR", "FACTOR", "SAMPLE_FACTOR", "SET_LONG_FACTOR", "SET_MENTION_ID_FACTOR", "SUB_FILTER_FACTOR"],
        FOLLOW_attributeNode_in_attributes69: new org.antlr.runtime.BitSet([0x00000002, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000400, 0x00000000]),
        FOLLOW_ATTRIBUTE_in_attributeNode104: new org.antlr.runtime.BitSet([0x00000004, 0x00000000])
    });

})();

// $ANTLR 3.3 Nov 30, 2010 12:46:29 /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g 2024-06-04 12:32:07

var MentionQFilterParser = function(input, state) {
    if (!state) {
        state = new org.antlr.runtime.RecognizerSharedState();
    }

    (function(){

        this.emitErrorMessage = function(msg) {
            throw msg;
        }

    }).call(this);

    MentionQFilterParser.superclass.constructor.call(this, input, state);

    this.dfa4 = new MentionQFilterParser.DFA4(this);



    /* @todo only create adaptor if output=AST */
    this.adaptor = new org.antlr.runtime.tree.CommonTreeAdaptor();

};

org.antlr.lang.augmentObject(MentionQFilterParser, {
    EOF: -1,
    NEWLINE: 4,
    WHITESPACE: 5,
    O: 6,
    R: 7,
    OR: 8,
    A: 9,
    N: 10,
    D: 11,
    AND: 12,
    E: 13,
    L: 14,
    V: 15,
    C: 16,
    Y: 17,
    RELEVANCY: 18,
    B: 19,
    BRAND: 20,
    S: 21,
    T: 22,
    I: 23,
    M: 24,
    SENTIMENT: 25,
    CREDIBILITY: 26,
    MEDIA: 27,
    ACTION: 28,
    P: 29,
    PROCESS: 30,
    H: 31,
    PHRASE: 32,
    U: 33,
    PHRASE_COUNT: 34,
    F: 35,
    FEED: 36,
    TITLE: 37,
    K: 38,
    LINK: 39,
    SITE: 40,
    AUTHOR_NAME: 41,
    AUTHOR_LOCATION: 42,
    CONTENT: 43,
    G: 44,
    LANGUAGE: 45,
    PICKED_UP: 46,
    UPDATED: 47,
    LINKED: 48,
    PHRASE_MATCHES: 49,
    PAGE_RANK: 50,
    X: 51,
    ALEXA_RANK: 52,
    PUBLISHED: 53,
    PUBLISHEDTIME: 54,
    TAG: 55,
    TOPIC: 56,
    SEGMENT: 57,
    COUNTRY: 58,
    REGION: 59,
    CITY: 60,
    RELEVANCY_VERIFIED: 61,
    ASSIGNEE: 62,
    AUTHOR: 63,
    AUTHOR_ID: 64,
    EXTRACT: 65,
    SENTIMENT_VERIFIED: 66,
    W: 67,
    CROWD_VERIFIED: 68,
    DISCARDED_BY: 69,
    MENTION_ID: 70,
    CROWD_ID: 71,
    URI: 72,
    ENGAGEMENT: 73,
    REPLY_TO: 74,
    REPLY_COUNT: 75,
    GRAPH_REPLY_COUNT: 76,
    RESHARE_OF: 77,
    RESHARE_COUNT: 78,
    GRAPH_RESHARE_COUNT: 79,
    REPLY_ORDER_BY_AUTHOR: 80,
    OTS: 81,
    AVE: 82,
    REACH: 83,
    STATUS_COUNT: 84,
    FOLLOWER_COUNT: 85,
    GRAPH_FOLLOWER_COUNT: 86,
    FOLLOWING_COUNT: 87,
    CROWD_REGION: 88,
    GENDER: 89,
    RESPONSE_TIME: 90,
    UNBIASED_SAMPLE: 91,
    MENTIONED_PROFILE: 92,
    RACE: 93,
    DIRECT_MESSAGE: 94,
    VISIBILITY: 95,
    TICKET_ID: 96,
    SOCIAL_NETWORK: 97,
    AUTHOR_HANDLE: 98,
    AUTHOR_HANDLE_ID: 99,
    TO_NAME: 100,
    TO_HANDLE: 101,
    TO_HANDLE_ID: 102,
    AUTHOR_BIO: 103,
    CONVERSATION_ID: 104,
    TOMBSTONED: 105,
    SCRUBBED: 106,
    HAS_REPLY_FROM_PROFILE: 107,
    INTERACTION_ID: 108,
    INTERACTION_RESPONSE_TIME: 109,
    INTERACTION_FIRST_RESPONSE_TIME: 110,
    INTERACTION_FOLLOWUP_RESPONSE_TIME: 111,
    INTERACTION_WH_RESPONSE_TIME: 112,
    INTERACTION_WH_FIRST_RESPONSE_TIME: 113,
    INTERACTION_WH_FOLLOWUP_RESPONSE_TIME: 114,
    INTERACTION_HAS_RESPONSE: 115,
    INTERACTION_FIRST_MENTION_PUBLISHED: 116,
    INTERACTION_LAST_MENTION_PUBLISHED: 117,
    INTERACTION_FIRST_RESPONSE_PUBLISHED: 118,
    UCN: 119,
    TWITTER_SCREEN_NAME: 120,
    HANDLE_ID: 121,
    FACEBOOK_ID: 122,
    IS: 123,
    ISNT: 124,
    ISORCHILDOF: 125,
    BEFORE: 126,
    AFTER: 127,
    GREATERTHAN: 128,
    GREATERTHANEQUALS: 129,
    LESSTHAN: 130,
    LESSTHANEQUALS: 131,
    EQUALS: 132,
    NOTEQUALS: 133,
    CONTAINS: 134,
    DOESNTCONTAIN: 135,
    BEGINSWITH: 136,
    ENDSWITH: 137,
    MATCHES: 138,
    ISNTNORCHILDOF: 139,
    INTHELAST: 140,
    BEFORETHELAST: 141,
    ON: 142,
    IN: 143,
    NOTIN: 144,
    DISTINCT: 145,
    SAMPLE: 146,
    PRESS: 147,
    ENTERPRISE: 148,
    CONSUMER: 149,
    DIRECTORY: 150,
    UNSORTED: 151,
    RELEVANT: 152,
    DUPLICATE: 153,
    IRRELEVANT: 154,
    SPAM: 155,
    SORTED: 156,
    VERIFIED: 157,
    NONE: 158,
    RESOLVED: 159,
    UNRESOLVED: 160,
    TODAY: 161,
    HOUR: 162,
    DAY: 163,
    TWENTY_FOUR_HRS: 164,
    WEEK: 165,
    FORTNIGHT: 166,
    MONTH: 167,
    Q: 168,
    QUARTER: 169,
    YEAR: 170,
    EPOCH: 171,
    FALSE: 172,
    TRUE: 173,
    MALE: 174,
    FEMALE: 175,
    OTHER: 176,
    UNKNOWN: 177,
    LONG_LITERAL: 178,
    TAG_ID_LITERAL: 179,
    FLOAT_LITERAL: 180,
    DATE_SEPARATOR: 181,
    DIGIT: 182,
    UNQUOTED_DATE: 183,
    DATE_LITERAL: 184,
    STRING_LITERAL: 185,
    ANNOTATION: 186,
    LPAREN: 187,
    RPAREN: 188,
    COMMA: 189,
    DIVIDE: 190,
    LSQUARE: 191,
    RSQUARE: 192,
    ASC: 193,
    DESC: 194,
    COUNT: 195,
    UNQUOTED_STRING_LITERAL: 196,
    J: 197,
    Z: 198,
    ORDER: 199,
    GROUP: 200,
    SELECTION: 201,
    ATTRIBUTE: 202,
    OR_NODE: 203,
    AND_NODE: 204,
    TWITTER_AUTHOR: 205,
    FACTOR: 206,
    SAMPLE_FACTOR: 207,
    SET_LONG_FACTOR: 208,
    SET_MENTION_ID_FACTOR: 209,
    SUB_FILTER_FACTOR: 210
});

(function(){
// public class variables
    var EOF= -1,
        NEWLINE= 4,
        WHITESPACE= 5,
        O= 6,
        R= 7,
        OR= 8,
        A= 9,
        N= 10,
        D= 11,
        AND= 12,
        E= 13,
        L= 14,
        V= 15,
        C= 16,
        Y= 17,
        RELEVANCY= 18,
        B= 19,
        BRAND= 20,
        S= 21,
        T= 22,
        I= 23,
        M= 24,
        SENTIMENT= 25,
        CREDIBILITY= 26,
        MEDIA= 27,
        ACTION= 28,
        P= 29,
        PROCESS= 30,
        H= 31,
        PHRASE= 32,
        U= 33,
        PHRASE_COUNT= 34,
        F= 35,
        FEED= 36,
        TITLE= 37,
        K= 38,
        LINK= 39,
        SITE= 40,
        AUTHOR_NAME= 41,
        AUTHOR_LOCATION= 42,
        CONTENT= 43,
        G= 44,
        LANGUAGE= 45,
        PICKED_UP= 46,
        UPDATED= 47,
        LINKED= 48,
        PHRASE_MATCHES= 49,
        PAGE_RANK= 50,
        X= 51,
        ALEXA_RANK= 52,
        PUBLISHED= 53,
        PUBLISHEDTIME= 54,
        TAG= 55,
        TOPIC= 56,
        SEGMENT= 57,
        COUNTRY= 58,
        REGION= 59,
        CITY= 60,
        RELEVANCY_VERIFIED= 61,
        ASSIGNEE= 62,
        AUTHOR= 63,
        AUTHOR_ID= 64,
        EXTRACT= 65,
        SENTIMENT_VERIFIED= 66,
        W= 67,
        CROWD_VERIFIED= 68,
        DISCARDED_BY= 69,
        MENTION_ID= 70,
        CROWD_ID= 71,
        URI= 72,
        ENGAGEMENT= 73,
        REPLY_TO= 74,
        REPLY_COUNT= 75,
        GRAPH_REPLY_COUNT= 76,
        RESHARE_OF= 77,
        RESHARE_COUNT= 78,
        GRAPH_RESHARE_COUNT= 79,
        REPLY_ORDER_BY_AUTHOR= 80,
        OTS= 81,
        AVE= 82,
        REACH= 83,
        STATUS_COUNT= 84,
        FOLLOWER_COUNT= 85,
        GRAPH_FOLLOWER_COUNT= 86,
        FOLLOWING_COUNT= 87,
        CROWD_REGION= 88,
        GENDER= 89,
        RESPONSE_TIME= 90,
        UNBIASED_SAMPLE= 91,
        MENTIONED_PROFILE= 92,
        RACE= 93,
        DIRECT_MESSAGE= 94,
        VISIBILITY= 95,
        TICKET_ID= 96,
        SOCIAL_NETWORK= 97,
        AUTHOR_HANDLE= 98,
        AUTHOR_HANDLE_ID= 99,
        TO_NAME= 100,
        TO_HANDLE= 101,
        TO_HANDLE_ID= 102,
        AUTHOR_BIO= 103,
        CONVERSATION_ID= 104,
        TOMBSTONED= 105,
        SCRUBBED= 106,
        HAS_REPLY_FROM_PROFILE= 107,
        INTERACTION_ID= 108,
        INTERACTION_RESPONSE_TIME= 109,
        INTERACTION_FIRST_RESPONSE_TIME= 110,
        INTERACTION_FOLLOWUP_RESPONSE_TIME= 111,
        INTERACTION_WH_RESPONSE_TIME= 112,
        INTERACTION_WH_FIRST_RESPONSE_TIME= 113,
        INTERACTION_WH_FOLLOWUP_RESPONSE_TIME= 114,
        INTERACTION_HAS_RESPONSE= 115,
        INTERACTION_FIRST_MENTION_PUBLISHED= 116,
        INTERACTION_LAST_MENTION_PUBLISHED= 117,
        INTERACTION_FIRST_RESPONSE_PUBLISHED= 118,
        UCN= 119,
        TWITTER_SCREEN_NAME= 120,
        HANDLE_ID= 121,
        FACEBOOK_ID= 122,
        IS= 123,
        ISNT= 124,
        ISORCHILDOF= 125,
        BEFORE= 126,
        AFTER= 127,
        GREATERTHAN= 128,
        GREATERTHANEQUALS= 129,
        LESSTHAN= 130,
        LESSTHANEQUALS= 131,
        EQUALS= 132,
        NOTEQUALS= 133,
        CONTAINS= 134,
        DOESNTCONTAIN= 135,
        BEGINSWITH= 136,
        ENDSWITH= 137,
        MATCHES= 138,
        ISNTNORCHILDOF= 139,
        INTHELAST= 140,
        BEFORETHELAST= 141,
        ON= 142,
        IN= 143,
        NOTIN= 144,
        DISTINCT= 145,
        SAMPLE= 146,
        PRESS= 147,
        ENTERPRISE= 148,
        CONSUMER= 149,
        DIRECTORY= 150,
        UNSORTED= 151,
        RELEVANT= 152,
        DUPLICATE= 153,
        IRRELEVANT= 154,
        SPAM= 155,
        SORTED= 156,
        VERIFIED= 157,
        NONE= 158,
        RESOLVED= 159,
        UNRESOLVED= 160,
        TODAY= 161,
        HOUR= 162,
        DAY= 163,
        TWENTY_FOUR_HRS= 164,
        WEEK= 165,
        FORTNIGHT= 166,
        MONTH= 167,
        Q= 168,
        QUARTER= 169,
        YEAR= 170,
        EPOCH= 171,
        FALSE= 172,
        TRUE= 173,
        MALE= 174,
        FEMALE= 175,
        OTHER= 176,
        UNKNOWN= 177,
        LONG_LITERAL= 178,
        TAG_ID_LITERAL= 179,
        FLOAT_LITERAL= 180,
        DATE_SEPARATOR= 181,
        DIGIT= 182,
        UNQUOTED_DATE= 183,
        DATE_LITERAL= 184,
        STRING_LITERAL= 185,
        ANNOTATION= 186,
        LPAREN= 187,
        RPAREN= 188,
        COMMA= 189,
        DIVIDE= 190,
        LSQUARE= 191,
        RSQUARE= 192,
        ASC= 193,
        DESC= 194,
        COUNT= 195,
        UNQUOTED_STRING_LITERAL= 196,
        J= 197,
        Z= 198,
        ORDER= 199,
        GROUP= 200,
        SELECTION= 201,
        ATTRIBUTE= 202,
        OR_NODE= 203,
        AND_NODE= 204,
        TWITTER_AUTHOR= 205,
        FACTOR= 206,
        SAMPLE_FACTOR= 207,
        SET_LONG_FACTOR= 208,
        SET_MENTION_ID_FACTOR= 209,
        SUB_FILTER_FACTOR= 210;
    var UP = org.antlr.runtime.Token.UP,
        DOWN = org.antlr.runtime.Token.DOWN;

// public instance methods/vars
    org.antlr.lang.extend(MentionQFilterParser, org.antlr.runtime.tree.TreeParser, {


        getTokenNames: function() { return MentionQFilterParser.tokenNames; },
        getGrammarFileName: function() { return "/Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g"; }
    });
    org.antlr.lang.augmentObject(MentionQFilterParser.prototype, {


        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:17:1: filter returns [node] : filterNode ;
        // $ANTLR start "filter"
        filter: function() {
            var node = null;

            var filterNode1 = null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:18:5: ( filterNode )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:18:9: filterNode
                this.pushFollow(MentionQFilterParser.FOLLOW_filterNode_in_filter62);
                filterNode1=this.filterNode();

                this.state._fsp--;

                node = filterNode1;



            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return node;
        },


        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:22:1: filterNode returns [node] : ( ^( OR_NODE lhs= filterNode (rhs= filterNode )? ) | ^( AND_NODE lhs= filterNode (rhs= filterNode )? ) | factor );
        // $ANTLR start "filterNode"
        filterNode: function() {
            var node = null;

            var lhs = null;
            var rhs = null;
            var factor2 = null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:23:5: ( ^( OR_NODE lhs= filterNode (rhs= filterNode )? ) | ^( AND_NODE lhs= filterNode (rhs= filterNode )? ) | factor )
                var alt3=3;
                switch ( this.input.LA(1) ) {
                    case OR_NODE:
                        alt3=1;
                        break;
                    case AND_NODE:
                        alt3=2;
                        break;
                    case FACTOR:
                    case SAMPLE_FACTOR:
                    case SET_LONG_FACTOR:
                    case SET_MENTION_ID_FACTOR:
                    case SUB_FILTER_FACTOR:
                        alt3=3;
                        break;
                    default:
                        var nvae =
                            new org.antlr.runtime.NoViableAltException("", 3, 0, this.input);

                        throw nvae;
                }

                switch (alt3) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:23:9: ^( OR_NODE lhs= filterNode (rhs= filterNode )? )
                        this.match(this.input,OR_NODE,MentionQFilterParser.FOLLOW_OR_NODE_in_filterNode89);

                        this.match(this.input, org.antlr.runtime.Token.DOWN, null);
                        this.pushFollow(MentionQFilterParser.FOLLOW_filterNode_in_filterNode93);
                        lhs=this.filterNode();

                        this.state._fsp--;

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:23:37: (rhs= filterNode )?
                        var alt1=2;
                        var LA1_0 = this.input.LA(1);

                        if ( ((LA1_0>=OR_NODE && LA1_0<=AND_NODE)||(LA1_0>=FACTOR && LA1_0<=SUB_FILTER_FACTOR)) ) {
                            alt1=1;
                        }
                        switch (alt1) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:23:37: rhs= filterNode
                                this.pushFollow(MentionQFilterParser.FOLLOW_filterNode_in_filterNode97);
                                rhs=this.filterNode();

                                this.state._fsp--;



                                break;

                        }


                        this.match(this.input, org.antlr.runtime.Token.UP, null);

                        node = rhs === null ? lhs : new OrNode(lhs, rhs);



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:27:9: ^( AND_NODE lhs= filterNode (rhs= filterNode )? )
                        this.match(this.input,AND_NODE,MentionQFilterParser.FOLLOW_AND_NODE_in_filterNode120);

                        this.match(this.input, org.antlr.runtime.Token.DOWN, null);
                        this.pushFollow(MentionQFilterParser.FOLLOW_filterNode_in_filterNode124);
                        lhs=this.filterNode();

                        this.state._fsp--;

                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:27:38: (rhs= filterNode )?
                        var alt2=2;
                        var LA2_0 = this.input.LA(1);

                        if ( ((LA2_0>=OR_NODE && LA2_0<=AND_NODE)||(LA2_0>=FACTOR && LA2_0<=SUB_FILTER_FACTOR)) ) {
                            alt2=1;
                        }
                        switch (alt2) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:27:38: rhs= filterNode
                                this.pushFollow(MentionQFilterParser.FOLLOW_filterNode_in_filterNode128);
                                rhs=this.filterNode();

                                this.state._fsp--;



                                break;

                        }


                        this.match(this.input, org.antlr.runtime.Token.UP, null);

                        node = rhs === null ? lhs : new AndNode(lhs, rhs);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:31:9: factor
                        this.pushFollow(MentionQFilterParser.FOLLOW_factor_in_filterNode150);
                        factor2=this.factor();

                        this.state._fsp--;

                        node = factor2;


                        break;

                }
            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return node;
        },


        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:37:1: factor returns [node] : ( ^( FACTOR operand= . operation= . literal= . ) | ^( SAMPLE_FACTOR proportion= . seed= . ) | ^( SAMPLE_FACTOR proportion= . ) | ^( SET_LONG_FACTOR operand= . operation= . longListNode ) | ^( SUB_FILTER_FACTOR sf_operand= . sf_operation= . filterNode ) | ^( SET_MENTION_ID_FACTOR operand= . operation= . mentionIdListNode ) );
        // $ANTLR start "factor"
        factor: function() {
            var node = null;

            var longListNode3 = null;
            var filterNode4 = null;
            var mentionIdListNode5 = null;

            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:38:5: ( ^( FACTOR operand= . operation= . literal= . ) | ^( SAMPLE_FACTOR proportion= . seed= . ) | ^( SAMPLE_FACTOR proportion= . ) | ^( SET_LONG_FACTOR operand= . operation= . longListNode ) | ^( SUB_FILTER_FACTOR sf_operand= . sf_operation= . filterNode ) | ^( SET_MENTION_ID_FACTOR operand= . operation= . mentionIdListNode ) )
                var alt4=6;
                alt4 = this.dfa4.predict(this.input);
                switch (alt4) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:38:9: ^( FACTOR operand= . operation= . literal= . )
                        this.match(this.input,FACTOR,MentionQFilterParser.FOLLOW_FACTOR_in_factor179);

                        this.match(this.input, org.antlr.runtime.Token.DOWN, null);
                        operand=this.input.LT(1);
                        this.matchAny(this.input);
                        operation=this.input.LT(1);
                        this.matchAny(this.input);
                        literal=this.input.LT(1);
                        this.matchAny(this.input);

                        this.match(this.input, org.antlr.runtime.Token.UP, null);

                        node = createExpNode(operand, operation, literal);;



                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:42:9: ^( SAMPLE_FACTOR proportion= . seed= . )
                        this.match(this.input,SAMPLE_FACTOR,MentionQFilterParser.FOLLOW_SAMPLE_FACTOR_in_factor213);

                        this.match(this.input, org.antlr.runtime.Token.DOWN, null);
                        proportion=this.input.LT(1);
                        this.matchAny(this.input);
                        seed=this.input.LT(1);
                        this.matchAny(this.input);

                        this.match(this.input, org.antlr.runtime.Token.UP, null);

                        node = createSampleNode(proportion.token, seed.token);



                        break;
                    case 3 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:46:9: ^( SAMPLE_FACTOR proportion= . )
                        this.match(this.input,SAMPLE_FACTOR,MentionQFilterParser.FOLLOW_SAMPLE_FACTOR_in_factor243);

                        this.match(this.input, org.antlr.runtime.Token.DOWN, null);
                        proportion=this.input.LT(1);
                        this.matchAny(this.input);

                        this.match(this.input, org.antlr.runtime.Token.UP, null);

                        node = createSampleNode(proportion.token);



                        break;
                    case 4 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:50:9: ^( SET_LONG_FACTOR operand= . operation= . longListNode )
                        this.match(this.input,SET_LONG_FACTOR,MentionQFilterParser.FOLLOW_SET_LONG_FACTOR_in_factor269);

                        this.match(this.input, org.antlr.runtime.Token.DOWN, null);
                        operand=this.input.LT(1);
                        this.matchAny(this.input);
                        operation=this.input.LT(1);
                        this.matchAny(this.input);
                        this.pushFollow(MentionQFilterParser.FOLLOW_longListNode_in_factor279);
                        longListNode3=this.longListNode();

                        this.state._fsp--;


                        this.match(this.input, org.antlr.runtime.Token.UP, null);

                        node = new ExpNode(operand.getType(), operand.getText(),
                            operation.getType(), operation.getText(),
                            MentionQLexer.LONG_LITERAL, longListNode3.longs.join(","));
                        node.annotation = getAnnotationValue(longListNode3.annotation);



                        break;
                    case 5 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:57:9: ^( SUB_FILTER_FACTOR sf_operand= . sf_operation= . filterNode )
                        this.match(this.input,SUB_FILTER_FACTOR,MentionQFilterParser.FOLLOW_SUB_FILTER_FACTOR_in_factor301);

                        this.match(this.input, org.antlr.runtime.Token.DOWN, null);
                        sf_operand=this.input.LT(1);
                        this.matchAny(this.input);
                        sf_operation=this.input.LT(1);
                        this.matchAny(this.input);
                        this.pushFollow(MentionQFilterParser.FOLLOW_filterNode_in_factor311);
                        filterNode4=this.filterNode();

                        this.state._fsp--;


                        this.match(this.input, org.antlr.runtime.Token.UP, null);

                        node = new ExpNode(sf_operand.getType(), sf_operand.getText(),
                            sf_operation.getType(), sf_operation.getText(),
                            filterNode4, "(" + filterNode4 + ")");



                        break;
                    case 6 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:63:9: ^( SET_MENTION_ID_FACTOR operand= . operation= . mentionIdListNode )
                        this.match(this.input,SET_MENTION_ID_FACTOR,MentionQFilterParser.FOLLOW_SET_MENTION_ID_FACTOR_in_factor333);

                        this.match(this.input, org.antlr.runtime.Token.DOWN, null);
                        operand=this.input.LT(1);
                        this.matchAny(this.input);
                        operation=this.input.LT(1);
                        this.matchAny(this.input);
                        this.pushFollow(MentionQFilterParser.FOLLOW_mentionIdListNode_in_factor343);
                        mentionIdListNode5=this.mentionIdListNode();

                        this.state._fsp--;


                        this.match(this.input, org.antlr.runtime.Token.UP, null);

                        node = new ExpNode(operand.getType(), operand.getText(),
                            operation.getType(), operation.getText(),
                            MentionQLexer.LONG_LITERAL, mentionIdListNode5.ids.join(","));
                        node.annotation = getAnnotationValue(mentionIdListNode5.annotation);



                        break;

                }
            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return node;
        },


        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:72:1: longListNode returns [data] : (annotation= ANNOTATION )? (longToken= LONG_LITERAL )+ ;
        // $ANTLR start "longListNode"
        longListNode: function() {
            var data = null;

            var annotation = null;
            var longToken = null;

            data = {longs: []};
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:74:5: ( (annotation= ANNOTATION )? (longToken= LONG_LITERAL )+ )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:74:8: (annotation= ANNOTATION )? (longToken= LONG_LITERAL )+
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:74:8: (annotation= ANNOTATION )?
                var alt5=2;
                var LA5_0 = this.input.LA(1);

                if ( (LA5_0==ANNOTATION) ) {
                    alt5=1;
                }
                switch (alt5) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:74:9: annotation= ANNOTATION
                        annotation=this.match(this.input,ANNOTATION,MentionQFilterParser.FOLLOW_ANNOTATION_in_longListNode384);


                        break;

                }

                if(annotation) data.annotation = annotation.token.getText();
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:75:9: (longToken= LONG_LITERAL )+
                var cnt6=0;
                loop6:
                    do {
                        var alt6=2;
                        var LA6_0 = this.input.LA(1);

                        if ( (LA6_0==LONG_LITERAL) ) {
                            alt6=1;
                        }


                        switch (alt6) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:75:10: longToken= LONG_LITERAL
                                longToken=this.match(this.input,LONG_LITERAL,MentionQFilterParser.FOLLOW_LONG_LITERAL_in_longListNode401);
                                data.longs.push(longToken.token.getText());


                                break;

                            default :
                                if ( cnt6 >= 1 ) {
                                    break loop6;
                                }
                                var eee = new org.antlr.runtime.EarlyExitException(6, this.input);
                                throw eee;
                        }
                        cnt6++;
                    } while (true);




            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return data;
        },


        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:78:1: mentionIdListNode returns [data] : (annotation= ANNOTATION )? ( (idToken= LONG_LITERAL | idToken= STRING_LITERAL ) )+ ;
        // $ANTLR start "mentionIdListNode"
        mentionIdListNode: function() {
            var data = null;

            var annotation = null;
            var idToken = null;

            data = {ids: []};
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:80:5: ( (annotation= ANNOTATION )? ( (idToken= LONG_LITERAL | idToken= STRING_LITERAL ) )+ )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:80:8: (annotation= ANNOTATION )? ( (idToken= LONG_LITERAL | idToken= STRING_LITERAL ) )+
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:80:8: (annotation= ANNOTATION )?
                var alt7=2;
                var LA7_0 = this.input.LA(1);

                if ( (LA7_0==ANNOTATION) ) {
                    alt7=1;
                }
                switch (alt7) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:80:9: annotation= ANNOTATION
                        annotation=this.match(this.input,ANNOTATION,MentionQFilterParser.FOLLOW_ANNOTATION_in_mentionIdListNode436);


                        break;

                }

                if(annotation) data.annotation = annotation.token.getText();
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:81:9: ( (idToken= LONG_LITERAL | idToken= STRING_LITERAL ) )+
                var cnt9=0;
                loop9:
                    do {
                        var alt9=2;
                        var LA9_0 = this.input.LA(1);

                        if ( (LA9_0==LONG_LITERAL||LA9_0==STRING_LITERAL) ) {
                            alt9=1;
                        }


                        switch (alt9) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:81:10: (idToken= LONG_LITERAL | idToken= STRING_LITERAL )
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:81:10: (idToken= LONG_LITERAL | idToken= STRING_LITERAL )
                                var alt8=2;
                                var LA8_0 = this.input.LA(1);

                                if ( (LA8_0==LONG_LITERAL) ) {
                                    alt8=1;
                                }
                                else if ( (LA8_0==STRING_LITERAL) ) {
                                    alt8=2;
                                }
                                else {
                                    var nvae =
                                        new org.antlr.runtime.NoViableAltException("", 8, 0, this.input);

                                    throw nvae;
                                }
                                switch (alt8) {
                                    case 1 :
                                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:81:11: idToken= LONG_LITERAL
                                        idToken=this.match(this.input,LONG_LITERAL,MentionQFilterParser.FOLLOW_LONG_LITERAL_in_mentionIdListNode454);


                                        break;
                                    case 2 :
                                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQFilterParser.g:81:34: idToken= STRING_LITERAL
                                        idToken=this.match(this.input,STRING_LITERAL,MentionQFilterParser.FOLLOW_STRING_LITERAL_in_mentionIdListNode460);


                                        break;

                                }

                                data.ids.push(idToken.token.getText());


                                break;

                            default :
                                if ( cnt9 >= 1 ) {
                                    break loop9;
                                }
                                var eee = new org.antlr.runtime.EarlyExitException(9, this.input);
                                throw eee;
                        }
                        cnt9++;
                    } while (true);




            }
            catch (re) {
                if (re instanceof org.antlr.runtime.RecognitionException) {
                    this.reportError(re);
                    this.recover(this.input,re);
                } else {
                    throw re;
                }
            }
            finally {
            }
            return data;
        }

        // Delegated rules




    }, true); // important to pass true to overwrite default implementations

    org.antlr.lang.augmentObject(MentionQFilterParser, {
        DFA4_eotS:
            "\u000d\uffff",
        DFA4_eofS:
            "\u000d\uffff",
        DFA4_minS:
            "\u0001\u00ce\u0001\uffff\u0001\u0002\u0003\uffff\u0001\u0004\u0001"+
            "\u0002\u0001\u0004\u0002\uffff\u0002\u0003",
        DFA4_maxS:
            "\u0001\u00d2\u0001\uffff\u0001\u0002\u0003\uffff\u0003\u00d2\u0002"+
            "\uffff\u0002\u00d2",
        DFA4_acceptS:
            "\u0001\uffff\u0001\u0001\u0001\uffff\u0001\u0004\u0001\u0005\u0001"+
            "\u0006\u0003\uffff\u0001\u0002\u0001\u0003\u0002\uffff",
        DFA4_specialS:
            "\u000d\uffff}>",
        DFA4_transitionS: [
            "\u0001\u0001\u0001\u0002\u0001\u0003\u0001\u0005\u0001\u0004",
            "",
            "\u0001\u0006",
            "",
            "",
            "",
            "\u00cf\u0007",
            "\u0001\u0008\u0001\u000a\u00cf\u0009",
            "\u00cf\u000b",
            "",
            "",
            "\u0001\u000c\u00cf\u000b",
            "\u0001\u000a\u00cf\u0009"
        ]
    });

    org.antlr.lang.augmentObject(MentionQFilterParser, {
        DFA4_eot:
            org.antlr.runtime.DFA.unpackEncodedString(MentionQFilterParser.DFA4_eotS),
        DFA4_eof:
            org.antlr.runtime.DFA.unpackEncodedString(MentionQFilterParser.DFA4_eofS),
        DFA4_min:
            org.antlr.runtime.DFA.unpackEncodedStringToUnsignedChars(MentionQFilterParser.DFA4_minS),
        DFA4_max:
            org.antlr.runtime.DFA.unpackEncodedStringToUnsignedChars(MentionQFilterParser.DFA4_maxS),
        DFA4_accept:
            org.antlr.runtime.DFA.unpackEncodedString(MentionQFilterParser.DFA4_acceptS),
        DFA4_special:
            org.antlr.runtime.DFA.unpackEncodedString(MentionQFilterParser.DFA4_specialS),
        DFA4_transition: (function() {
            var a = [],
                i,
                numStates = MentionQFilterParser.DFA4_transitionS.length;
            for (i=0; i<numStates; i++) {
                a.push(org.antlr.runtime.DFA.unpackEncodedString(MentionQFilterParser.DFA4_transitionS[i]));
            }
            return a;
        })()
    });

    MentionQFilterParser.DFA4 = function(recognizer) {
        this.recognizer = recognizer;
        this.decisionNumber = 4;
        this.eot = MentionQFilterParser.DFA4_eot;
        this.eof = MentionQFilterParser.DFA4_eof;
        this.min = MentionQFilterParser.DFA4_min;
        this.max = MentionQFilterParser.DFA4_max;
        this.accept = MentionQFilterParser.DFA4_accept;
        this.special = MentionQFilterParser.DFA4_special;
        this.transition = MentionQFilterParser.DFA4_transition;
    };

    org.antlr.lang.extend(MentionQFilterParser.DFA4, org.antlr.runtime.DFA, {
        getDescription: function() {
            return "37:1: factor returns [node] : ( ^( FACTOR operand= . operation= . literal= . ) | ^( SAMPLE_FACTOR proportion= . seed= . ) | ^( SAMPLE_FACTOR proportion= . ) | ^( SET_LONG_FACTOR operand= . operation= . longListNode ) | ^( SUB_FILTER_FACTOR sf_operand= . sf_operation= . filterNode ) | ^( SET_MENTION_ID_FACTOR operand= . operation= . mentionIdListNode ) );";
        },
        dummy: null
    });


// public class variables
    org.antlr.lang.augmentObject(MentionQFilterParser, {
        tokenNames: ["<invalid>", "<EOR>", "<DOWN>", "<UP>", "NEWLINE", "WHITESPACE", "O", "R", "OR", "A", "N", "D", "AND", "E", "L", "V", "C", "Y", "RELEVANCY", "B", "BRAND", "S", "T", "I", "M", "SENTIMENT", "CREDIBILITY", "MEDIA", "ACTION", "P", "PROCESS", "H", "PHRASE", "U", "PHRASE_COUNT", "F", "FEED", "TITLE", "K", "LINK", "SITE", "AUTHOR_NAME", "AUTHOR_LOCATION", "CONTENT", "G", "LANGUAGE", "PICKED_UP", "UPDATED", "LINKED", "PHRASE_MATCHES", "PAGE_RANK", "X", "ALEXA_RANK", "PUBLISHED", "PUBLISHEDTIME", "TAG", "TOPIC", "SEGMENT", "COUNTRY", "REGION", "CITY", "RELEVANCY_VERIFIED", "ASSIGNEE", "AUTHOR", "AUTHOR_ID", "EXTRACT", "SENTIMENT_VERIFIED", "W", "CROWD_VERIFIED", "DISCARDED_BY", "MENTION_ID", "CROWD_ID", "URI", "ENGAGEMENT", "REPLY_TO", "REPLY_COUNT", "GRAPH_REPLY_COUNT", "RESHARE_OF", "RESHARE_COUNT", "GRAPH_RESHARE_COUNT", "REPLY_ORDER_BY_AUTHOR", "OTS", "AVE", "REACH", "STATUS_COUNT", "FOLLOWER_COUNT", "GRAPH_FOLLOWER_COUNT", "FOLLOWING_COUNT", "CROWD_REGION", "GENDER", "RESPONSE_TIME", "UNBIASED_SAMPLE", "MENTIONED_PROFILE", "RACE", "DIRECT_MESSAGE", "VISIBILITY", "TICKET_ID", "SOCIAL_NETWORK", "AUTHOR_HANDLE", "AUTHOR_HANDLE_ID", "TO_NAME", "TO_HANDLE", "TO_HANDLE_ID", "AUTHOR_BIO", "CONVERSATION_ID", "TOMBSTONED", "SCRUBBED", "HAS_REPLY_FROM_PROFILE", "INTERACTION_ID", "INTERACTION_RESPONSE_TIME", "INTERACTION_FIRST_RESPONSE_TIME", "INTERACTION_FOLLOWUP_RESPONSE_TIME", "INTERACTION_WH_RESPONSE_TIME", "INTERACTION_WH_FIRST_RESPONSE_TIME", "INTERACTION_WH_FOLLOWUP_RESPONSE_TIME", "INTERACTION_HAS_RESPONSE", "INTERACTION_FIRST_MENTION_PUBLISHED", "INTERACTION_LAST_MENTION_PUBLISHED", "INTERACTION_FIRST_RESPONSE_PUBLISHED", "UCN", "TWITTER_SCREEN_NAME", "HANDLE_ID", "FACEBOOK_ID", "IS", "ISNT", "ISORCHILDOF", "BEFORE", "AFTER", "GREATERTHAN", "GREATERTHANEQUALS", "LESSTHAN", "LESSTHANEQUALS", "EQUALS", "NOTEQUALS", "CONTAINS", "DOESNTCONTAIN", "BEGINSWITH", "ENDSWITH", "MATCHES", "ISNTNORCHILDOF", "INTHELAST", "BEFORETHELAST", "ON", "IN", "NOTIN", "DISTINCT", "SAMPLE", "PRESS", "ENTERPRISE", "CONSUMER", "DIRECTORY", "UNSORTED", "RELEVANT", "DUPLICATE", "IRRELEVANT", "SPAM", "SORTED", "VERIFIED", "NONE", "RESOLVED", "UNRESOLVED", "TODAY", "HOUR", "DAY", "TWENTY_FOUR_HRS", "WEEK", "FORTNIGHT", "MONTH", "Q", "QUARTER", "YEAR", "EPOCH", "FALSE", "TRUE", "MALE", "FEMALE", "OTHER", "UNKNOWN", "LONG_LITERAL", "TAG_ID_LITERAL", "FLOAT_LITERAL", "DATE_SEPARATOR", "DIGIT", "UNQUOTED_DATE", "DATE_LITERAL", "STRING_LITERAL", "ANNOTATION", "LPAREN", "RPAREN", "COMMA", "DIVIDE", "LSQUARE", "RSQUARE", "ASC", "DESC", "COUNT", "UNQUOTED_STRING_LITERAL", "J", "Z", "ORDER", "GROUP", "SELECTION", "ATTRIBUTE", "OR_NODE", "AND_NODE", "TWITTER_AUTHOR", "FACTOR", "SAMPLE_FACTOR", "SET_LONG_FACTOR", "SET_MENTION_ID_FACTOR", "SUB_FILTER_FACTOR"],
        FOLLOW_filterNode_in_filter62: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_OR_NODE_in_filterNode89: new org.antlr.runtime.BitSet([0x00000004, 0x00000000]),
        FOLLOW_filterNode_in_filterNode93: new org.antlr.runtime.BitSet([0x00000008, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000000,0x0007D800, 0x00000000]),
        FOLLOW_filterNode_in_filterNode97: new org.antlr.runtime.BitSet([0x00000008, 0x00000000]),
        FOLLOW_AND_NODE_in_filterNode120: new org.antlr.runtime.BitSet([0x00000004, 0x00000000]),
        FOLLOW_filterNode_in_filterNode124: new org.antlr.runtime.BitSet([0x00000008, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00000000,0x0007D800, 0x00000000]),
        FOLLOW_filterNode_in_filterNode128: new org.antlr.runtime.BitSet([0x00000008, 0x00000000]),
        FOLLOW_factor_in_filterNode150: new org.antlr.runtime.BitSet([0x00000002, 0x00000000]),
        FOLLOW_FACTOR_in_factor179: new org.antlr.runtime.BitSet([0x00000004, 0x00000000]),
        FOLLOW_SAMPLE_FACTOR_in_factor213: new org.antlr.runtime.BitSet([0x00000004, 0x00000000]),
        FOLLOW_SAMPLE_FACTOR_in_factor243: new org.antlr.runtime.BitSet([0x00000004, 0x00000000]),
        FOLLOW_SET_LONG_FACTOR_in_factor269: new org.antlr.runtime.BitSet([0x00000004, 0x00000000]),
        FOLLOW_longListNode_in_factor279: new org.antlr.runtime.BitSet([0x00000008, 0x00000000]),
        FOLLOW_SUB_FILTER_FACTOR_in_factor301: new org.antlr.runtime.BitSet([0x00000004, 0x00000000]),
        FOLLOW_filterNode_in_factor311: new org.antlr.runtime.BitSet([0x00000008, 0x00000000]),
        FOLLOW_SET_MENTION_ID_FACTOR_in_factor333: new org.antlr.runtime.BitSet([0x00000004, 0x00000000]),
        FOLLOW_mentionIdListNode_in_factor343: new org.antlr.runtime.BitSet([0x00000008, 0x00000000]),
        FOLLOW_ANNOTATION_in_longListNode384: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_LONG_LITERAL_in_longListNode401: new org.antlr.runtime.BitSet([0x00000002, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x00040000]),
        FOLLOW_ANNOTATION_in_mentionIdListNode436: new org.antlr.runtime.BitSet([0x00000000, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02040000]),
        FOLLOW_LONG_LITERAL_in_mentionIdListNode454: new org.antlr.runtime.BitSet([0x00000002, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02040000]),
        FOLLOW_STRING_LITERAL_in_mentionIdListNode460: new org.antlr.runtime.BitSet([0x00000002, 0x00000000,0x00000000, 0x00000000,0x00000000, 0x02040000])
    });

})();

// $ANTLR 3.3 Nov 30, 2010 12:46:29 /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g 2024-06-04 12:32:06


var MentionQLexer = function(input, state) {
// alternate constructor @todo
// public MentionQLexer(CharStream input)
// public MentionQLexer(CharStream input, RecognizerSharedState state) {
    if (!state) {
        state = new org.antlr.runtime.RecognizerSharedState();
    }

    (function(){

        this.emitErrorMessage = function(msg) { throw msg; }

    }).call(this);

    this.dfa18 = new MentionQLexer.DFA18(this);
    MentionQLexer.superclass.constructor.call(this, input, state);


};

org.antlr.lang.augmentObject(MentionQLexer, {
    EOF: -1,
    NEWLINE: 4,
    WHITESPACE: 5,
    O: 6,
    R: 7,
    OR: 8,
    A: 9,
    N: 10,
    D: 11,
    AND: 12,
    E: 13,
    L: 14,
    V: 15,
    C: 16,
    Y: 17,
    RELEVANCY: 18,
    B: 19,
    BRAND: 20,
    S: 21,
    T: 22,
    I: 23,
    M: 24,
    SENTIMENT: 25,
    CREDIBILITY: 26,
    MEDIA: 27,
    ACTION: 28,
    P: 29,
    PROCESS: 30,
    H: 31,
    PHRASE: 32,
    U: 33,
    PHRASE_COUNT: 34,
    F: 35,
    FEED: 36,
    TITLE: 37,
    K: 38,
    LINK: 39,
    SITE: 40,
    AUTHOR_NAME: 41,
    AUTHOR_LOCATION: 42,
    CONTENT: 43,
    G: 44,
    LANGUAGE: 45,
    PICKED_UP: 46,
    UPDATED: 47,
    LINKED: 48,
    PHRASE_MATCHES: 49,
    PAGE_RANK: 50,
    X: 51,
    ALEXA_RANK: 52,
    PUBLISHED: 53,
    PUBLISHEDTIME: 54,
    TAG: 55,
    TOPIC: 56,
    SEGMENT: 57,
    COUNTRY: 58,
    REGION: 59,
    CITY: 60,
    RELEVANCY_VERIFIED: 61,
    ASSIGNEE: 62,
    AUTHOR: 63,
    AUTHOR_ID: 64,
    EXTRACT: 65,
    SENTIMENT_VERIFIED: 66,
    W: 67,
    CROWD_VERIFIED: 68,
    DISCARDED_BY: 69,
    MENTION_ID: 70,
    CROWD_ID: 71,
    URI: 72,
    ENGAGEMENT: 73,
    REPLY_TO: 74,
    REPLY_COUNT: 75,
    GRAPH_REPLY_COUNT: 76,
    RESHARE_OF: 77,
    RESHARE_COUNT: 78,
    GRAPH_RESHARE_COUNT: 79,
    REPLY_ORDER_BY_AUTHOR: 80,
    OTS: 81,
    AVE: 82,
    REACH: 83,
    STATUS_COUNT: 84,
    FOLLOWER_COUNT: 85,
    GRAPH_FOLLOWER_COUNT: 86,
    FOLLOWING_COUNT: 87,
    CROWD_REGION: 88,
    GENDER: 89,
    RESPONSE_TIME: 90,
    UNBIASED_SAMPLE: 91,
    MENTIONED_PROFILE: 92,
    RACE: 93,
    DIRECT_MESSAGE: 94,
    VISIBILITY: 95,
    TICKET_ID: 96,
    SOCIAL_NETWORK: 97,
    AUTHOR_HANDLE: 98,
    AUTHOR_HANDLE_ID: 99,
    TO_NAME: 100,
    TO_HANDLE: 101,
    TO_HANDLE_ID: 102,
    AUTHOR_BIO: 103,
    CONVERSATION_ID: 104,
    TOMBSTONED: 105,
    SCRUBBED: 106,
    HAS_REPLY_FROM_PROFILE: 107,
    INTERACTION_ID: 108,
    INTERACTION_RESPONSE_TIME: 109,
    INTERACTION_FIRST_RESPONSE_TIME: 110,
    INTERACTION_FOLLOWUP_RESPONSE_TIME: 111,
    INTERACTION_WH_RESPONSE_TIME: 112,
    INTERACTION_WH_FIRST_RESPONSE_TIME: 113,
    INTERACTION_WH_FOLLOWUP_RESPONSE_TIME: 114,
    INTERACTION_HAS_RESPONSE: 115,
    INTERACTION_FIRST_MENTION_PUBLISHED: 116,
    INTERACTION_LAST_MENTION_PUBLISHED: 117,
    INTERACTION_FIRST_RESPONSE_PUBLISHED: 118,
    UCN: 119,
    TWITTER_SCREEN_NAME: 120,
    HANDLE_ID: 121,
    FACEBOOK_ID: 122,
    IS: 123,
    ISNT: 124,
    ISORCHILDOF: 125,
    BEFORE: 126,
    AFTER: 127,
    GREATERTHAN: 128,
    GREATERTHANEQUALS: 129,
    LESSTHAN: 130,
    LESSTHANEQUALS: 131,
    EQUALS: 132,
    NOTEQUALS: 133,
    CONTAINS: 134,
    DOESNTCONTAIN: 135,
    BEGINSWITH: 136,
    ENDSWITH: 137,
    MATCHES: 138,
    ISNTNORCHILDOF: 139,
    INTHELAST: 140,
    BEFORETHELAST: 141,
    ON: 142,
    IN: 143,
    NOTIN: 144,
    DISTINCT: 145,
    SAMPLE: 146,
    PRESS: 147,
    ENTERPRISE: 148,
    CONSUMER: 149,
    DIRECTORY: 150,
    UNSORTED: 151,
    RELEVANT: 152,
    DUPLICATE: 153,
    IRRELEVANT: 154,
    SPAM: 155,
    SORTED: 156,
    VERIFIED: 157,
    NONE: 158,
    RESOLVED: 159,
    UNRESOLVED: 160,
    TODAY: 161,
    HOUR: 162,
    DAY: 163,
    TWENTY_FOUR_HRS: 164,
    WEEK: 165,
    FORTNIGHT: 166,
    MONTH: 167,
    Q: 168,
    QUARTER: 169,
    YEAR: 170,
    EPOCH: 171,
    FALSE: 172,
    TRUE: 173,
    MALE: 174,
    FEMALE: 175,
    OTHER: 176,
    UNKNOWN: 177,
    LONG_LITERAL: 178,
    TAG_ID_LITERAL: 179,
    FLOAT_LITERAL: 180,
    DATE_SEPARATOR: 181,
    DIGIT: 182,
    UNQUOTED_DATE: 183,
    DATE_LITERAL: 184,
    STRING_LITERAL: 185,
    ANNOTATION: 186,
    LPAREN: 187,
    RPAREN: 188,
    COMMA: 189,
    DIVIDE: 190,
    LSQUARE: 191,
    RSQUARE: 192,
    ASC: 193,
    DESC: 194,
    COUNT: 195,
    UNQUOTED_STRING_LITERAL: 196,
    J: 197,
    Z: 198
});

(function(){
    var HIDDEN = org.antlr.runtime.Token.HIDDEN_CHANNEL,
        EOF = org.antlr.runtime.Token.EOF;
    org.antlr.lang.extend(MentionQLexer, org.antlr.runtime.Lexer, {
        EOF : -1,
        NEWLINE : 4,
        WHITESPACE : 5,
        O : 6,
        R : 7,
        OR : 8,
        A : 9,
        N : 10,
        D : 11,
        AND : 12,
        E : 13,
        L : 14,
        V : 15,
        C : 16,
        Y : 17,
        RELEVANCY : 18,
        B : 19,
        BRAND : 20,
        S : 21,
        T : 22,
        I : 23,
        M : 24,
        SENTIMENT : 25,
        CREDIBILITY : 26,
        MEDIA : 27,
        ACTION : 28,
        P : 29,
        PROCESS : 30,
        H : 31,
        PHRASE : 32,
        U : 33,
        PHRASE_COUNT : 34,
        F : 35,
        FEED : 36,
        TITLE : 37,
        K : 38,
        LINK : 39,
        SITE : 40,
        AUTHOR_NAME : 41,
        AUTHOR_LOCATION : 42,
        CONTENT : 43,
        G : 44,
        LANGUAGE : 45,
        PICKED_UP : 46,
        UPDATED : 47,
        LINKED : 48,
        PHRASE_MATCHES : 49,
        PAGE_RANK : 50,
        X : 51,
        ALEXA_RANK : 52,
        PUBLISHED : 53,
        PUBLISHEDTIME : 54,
        TAG : 55,
        TOPIC : 56,
        SEGMENT : 57,
        COUNTRY : 58,
        REGION : 59,
        CITY : 60,
        RELEVANCY_VERIFIED : 61,
        ASSIGNEE : 62,
        AUTHOR : 63,
        AUTHOR_ID : 64,
        EXTRACT : 65,
        SENTIMENT_VERIFIED : 66,
        W : 67,
        CROWD_VERIFIED : 68,
        DISCARDED_BY : 69,
        MENTION_ID : 70,
        CROWD_ID : 71,
        URI : 72,
        ENGAGEMENT : 73,
        REPLY_TO : 74,
        REPLY_COUNT : 75,
        GRAPH_REPLY_COUNT : 76,
        RESHARE_OF : 77,
        RESHARE_COUNT : 78,
        GRAPH_RESHARE_COUNT : 79,
        REPLY_ORDER_BY_AUTHOR : 80,
        OTS : 81,
        AVE : 82,
        REACH : 83,
        STATUS_COUNT : 84,
        FOLLOWER_COUNT : 85,
        GRAPH_FOLLOWER_COUNT : 86,
        FOLLOWING_COUNT : 87,
        CROWD_REGION : 88,
        GENDER : 89,
        RESPONSE_TIME : 90,
        UNBIASED_SAMPLE : 91,
        MENTIONED_PROFILE : 92,
        RACE : 93,
        DIRECT_MESSAGE : 94,
        VISIBILITY : 95,
        TICKET_ID : 96,
        SOCIAL_NETWORK : 97,
        AUTHOR_HANDLE : 98,
        AUTHOR_HANDLE_ID : 99,
        TO_NAME : 100,
        TO_HANDLE : 101,
        TO_HANDLE_ID : 102,
        AUTHOR_BIO : 103,
        CONVERSATION_ID : 104,
        TOMBSTONED : 105,
        SCRUBBED : 106,
        HAS_REPLY_FROM_PROFILE : 107,
        INTERACTION_ID : 108,
        INTERACTION_RESPONSE_TIME : 109,
        INTERACTION_FIRST_RESPONSE_TIME : 110,
        INTERACTION_FOLLOWUP_RESPONSE_TIME : 111,
        INTERACTION_WH_RESPONSE_TIME : 112,
        INTERACTION_WH_FIRST_RESPONSE_TIME : 113,
        INTERACTION_WH_FOLLOWUP_RESPONSE_TIME : 114,
        INTERACTION_HAS_RESPONSE : 115,
        INTERACTION_FIRST_MENTION_PUBLISHED : 116,
        INTERACTION_LAST_MENTION_PUBLISHED : 117,
        INTERACTION_FIRST_RESPONSE_PUBLISHED : 118,
        UCN : 119,
        TWITTER_SCREEN_NAME : 120,
        HANDLE_ID : 121,
        FACEBOOK_ID : 122,
        IS : 123,
        ISNT : 124,
        ISORCHILDOF : 125,
        BEFORE : 126,
        AFTER : 127,
        GREATERTHAN : 128,
        GREATERTHANEQUALS : 129,
        LESSTHAN : 130,
        LESSTHANEQUALS : 131,
        EQUALS : 132,
        NOTEQUALS : 133,
        CONTAINS : 134,
        DOESNTCONTAIN : 135,
        BEGINSWITH : 136,
        ENDSWITH : 137,
        MATCHES : 138,
        ISNTNORCHILDOF : 139,
        INTHELAST : 140,
        BEFORETHELAST : 141,
        ON : 142,
        IN : 143,
        NOTIN : 144,
        DISTINCT : 145,
        SAMPLE : 146,
        PRESS : 147,
        ENTERPRISE : 148,
        CONSUMER : 149,
        DIRECTORY : 150,
        UNSORTED : 151,
        RELEVANT : 152,
        DUPLICATE : 153,
        IRRELEVANT : 154,
        SPAM : 155,
        SORTED : 156,
        VERIFIED : 157,
        NONE : 158,
        RESOLVED : 159,
        UNRESOLVED : 160,
        TODAY : 161,
        HOUR : 162,
        DAY : 163,
        TWENTY_FOUR_HRS : 164,
        WEEK : 165,
        FORTNIGHT : 166,
        MONTH : 167,
        Q : 168,
        QUARTER : 169,
        YEAR : 170,
        EPOCH : 171,
        FALSE : 172,
        TRUE : 173,
        MALE : 174,
        FEMALE : 175,
        OTHER : 176,
        UNKNOWN : 177,
        LONG_LITERAL : 178,
        TAG_ID_LITERAL : 179,
        FLOAT_LITERAL : 180,
        DATE_SEPARATOR : 181,
        DIGIT : 182,
        UNQUOTED_DATE : 183,
        DATE_LITERAL : 184,
        STRING_LITERAL : 185,
        ANNOTATION : 186,
        LPAREN : 187,
        RPAREN : 188,
        COMMA : 189,
        DIVIDE : 190,
        LSQUARE : 191,
        RSQUARE : 192,
        ASC : 193,
        DESC : 194,
        COUNT : 195,
        UNQUOTED_STRING_LITERAL : 196,
        J : 197,
        Z : 198,
        getGrammarFileName: function() { return "/Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g"; }
    });
    org.antlr.lang.augmentObject(MentionQLexer.prototype, {
        // $ANTLR start NEWLINE
        mNEWLINE: function()  {
            try {
                var _type = this.NEWLINE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:19:8: ( ( ( '\\r' )? '\\n' )+ )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:19:10: ( ( '\\r' )? '\\n' )+
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:19:10: ( ( '\\r' )? '\\n' )+
                var cnt2=0;
                loop2:
                    do {
                        var alt2=2;
                        var LA2_0 = this.input.LA(1);

                        if ( (LA2_0=='\n'||LA2_0=='\r') ) {
                            alt2=1;
                        }


                        switch (alt2) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:19:11: ( '\\r' )? '\\n'
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:19:11: ( '\\r' )?
                                var alt1=2;
                                var LA1_0 = this.input.LA(1);

                                if ( (LA1_0=='\r') ) {
                                    alt1=1;
                                }
                                switch (alt1) {
                                    case 1 :
                                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:19:11: '\\r'
                                        this.match('\r');


                                        break;

                                }

                                this.match('\n');


                                break;

                            default :
                                if ( cnt2 >= 1 ) {
                                    break loop2;
                                }
                                var eee = new org.antlr.runtime.EarlyExitException(2, this.input);
                                throw eee;
                        }
                        cnt2++;
                    } while (true);

                this.skip();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "NEWLINE",

        // $ANTLR start WHITESPACE
        mWHITESPACE: function()  {
            try {
                var _type = this.WHITESPACE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:20:11: ( ( ' ' | '\\t' )+ )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:20:13: ( ' ' | '\\t' )+
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:20:13: ( ' ' | '\\t' )+
                var cnt3=0;
                loop3:
                    do {
                        var alt3=2;
                        var LA3_0 = this.input.LA(1);

                        if ( (LA3_0=='\t'||LA3_0==' ') ) {
                            alt3=1;
                        }


                        switch (alt3) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:
                                if ( this.input.LA(1)=='\t'||this.input.LA(1)==' ' ) {
                                    this.input.consume();

                                }
                                else {
                                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                                    this.recover(mse);
                                    throw mse;}



                                break;

                            default :
                                if ( cnt3 >= 1 ) {
                                    break loop3;
                                }
                                var eee = new org.antlr.runtime.EarlyExitException(3, this.input);
                                throw eee;
                        }
                        cnt3++;
                    } while (true);

                this.skip();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "WHITESPACE",

        // $ANTLR start OR
        mOR: function()  {
            try {
                var _type = this.OR;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:23:3: ( O R )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:23:9: O R
                this.mO();
                this.mR();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "OR",

        // $ANTLR start AND
        mAND: function()  {
            try {
                var _type = this.AND;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:24:4: ( A N D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:24:9: A N D
                this.mA();
                this.mN();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "AND",

        // $ANTLR start RELEVANCY
        mRELEVANCY: function()  {
            try {
                var _type = this.RELEVANCY;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:28:10: ( R E L E V A N C Y )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:28:25: R E L E V A N C Y
                this.mR();
                this.mE();
                this.mL();
                this.mE();
                this.mV();
                this.mA();
                this.mN();
                this.mC();
                this.mY();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "RELEVANCY",

        // $ANTLR start BRAND
        mBRAND: function()  {
            try {
                var _type = this.BRAND;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:29:6: ( B R A N D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:29:25: B R A N D
                this.mB();
                this.mR();
                this.mA();
                this.mN();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "BRAND",

        // $ANTLR start SENTIMENT
        mSENTIMENT: function()  {
            try {
                var _type = this.SENTIMENT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:30:10: ( S E N T I M E N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:30:25: S E N T I M E N T
                this.mS();
                this.mE();
                this.mN();
                this.mT();
                this.mI();
                this.mM();
                this.mE();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "SENTIMENT",

        // $ANTLR start CREDIBILITY
        mCREDIBILITY: function()  {
            try {
                var _type = this.CREDIBILITY;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:31:12: ( C R E D I B I L I T Y )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:31:25: C R E D I B I L I T Y
                this.mC();
                this.mR();
                this.mE();
                this.mD();
                this.mI();
                this.mB();
                this.mI();
                this.mL();
                this.mI();
                this.mT();
                this.mY();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "CREDIBILITY",

        // $ANTLR start MEDIA
        mMEDIA: function()  {
            try {
                var _type = this.MEDIA;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:32:6: ( M E D I A )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:32:25: M E D I A
                this.mM();
                this.mE();
                this.mD();
                this.mI();
                this.mA();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "MEDIA",

        // $ANTLR start ACTION
        mACTION: function()  {
            try {
                var _type = this.ACTION;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:33:7: ( A C T I O N )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:33:25: A C T I O N
                this.mA();
                this.mC();
                this.mT();
                this.mI();
                this.mO();
                this.mN();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "ACTION",

        // $ANTLR start PROCESS
        mPROCESS: function()  {
            try {
                var _type = this.PROCESS;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:34:8: ( P R O C E S S )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:34:25: P R O C E S S
                this.mP();
                this.mR();
                this.mO();
                this.mC();
                this.mE();
                this.mS();
                this.mS();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "PROCESS",

        // $ANTLR start PHRASE
        mPHRASE: function()  {
            try {
                var _type = this.PHRASE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:35:7: ( P H R A S E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:35:25: P H R A S E
                this.mP();
                this.mH();
                this.mR();
                this.mA();
                this.mS();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "PHRASE",

        // $ANTLR start PHRASE_COUNT
        mPHRASE_COUNT: function()  {
            try {
                var _type = this.PHRASE_COUNT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:36:13: ( P H R A S E C O U N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:36:25: P H R A S E C O U N T
                this.mP();
                this.mH();
                this.mR();
                this.mA();
                this.mS();
                this.mE();
                this.mC();
                this.mO();
                this.mU();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "PHRASE_COUNT",

        // $ANTLR start FEED
        mFEED: function()  {
            try {
                var _type = this.FEED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:37:5: ( F E E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:37:25: F E E D
                this.mF();
                this.mE();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "FEED",

        // $ANTLR start TITLE
        mTITLE: function()  {
            try {
                var _type = this.TITLE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:38:6: ( T I T L E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:38:25: T I T L E
                this.mT();
                this.mI();
                this.mT();
                this.mL();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TITLE",

        // $ANTLR start LINK
        mLINK: function()  {
            try {
                var _type = this.LINK;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:39:5: ( L I N K )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:39:25: L I N K
                this.mL();
                this.mI();
                this.mN();
                this.mK();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "LINK",

        // $ANTLR start SITE
        mSITE: function()  {
            try {
                var _type = this.SITE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:40:5: ( S I T E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:40:25: S I T E
                this.mS();
                this.mI();
                this.mT();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "SITE",

        // $ANTLR start AUTHOR_NAME
        mAUTHOR_NAME: function()  {
            try {
                var _type = this.AUTHOR_NAME;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:41:12: ( A U T H O R N A M E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:41:25: A U T H O R N A M E
                this.mA();
                this.mU();
                this.mT();
                this.mH();
                this.mO();
                this.mR();
                this.mN();
                this.mA();
                this.mM();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "AUTHOR_NAME",

        // $ANTLR start AUTHOR_LOCATION
        mAUTHOR_LOCATION: function()  {
            try {
                var _type = this.AUTHOR_LOCATION;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:42:16: ( A U T H O R L O C A T I O N )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:42:25: A U T H O R L O C A T I O N
                this.mA();
                this.mU();
                this.mT();
                this.mH();
                this.mO();
                this.mR();
                this.mL();
                this.mO();
                this.mC();
                this.mA();
                this.mT();
                this.mI();
                this.mO();
                this.mN();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "AUTHOR_LOCATION",

        // $ANTLR start CONTENT
        mCONTENT: function()  {
            try {
                var _type = this.CONTENT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:43:8: ( C O N T E N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:43:25: C O N T E N T
                this.mC();
                this.mO();
                this.mN();
                this.mT();
                this.mE();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "CONTENT",

        // $ANTLR start LANGUAGE
        mLANGUAGE: function()  {
            try {
                var _type = this.LANGUAGE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:44:9: ( L A N G U A G E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:44:25: L A N G U A G E
                this.mL();
                this.mA();
                this.mN();
                this.mG();
                this.mU();
                this.mA();
                this.mG();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "LANGUAGE",

        // $ANTLR start PICKED_UP
        mPICKED_UP: function()  {
            try {
                var _type = this.PICKED_UP;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:45:10: ( P I C K E D U P )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:45:25: P I C K E D U P
                this.mP();
                this.mI();
                this.mC();
                this.mK();
                this.mE();
                this.mD();
                this.mU();
                this.mP();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "PICKED_UP",

        // $ANTLR start UPDATED
        mUPDATED: function()  {
            try {
                var _type = this.UPDATED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:46:8: ( U P D A T E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:46:25: U P D A T E D
                this.mU();
                this.mP();
                this.mD();
                this.mA();
                this.mT();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "UPDATED",

        // $ANTLR start LINKED
        mLINKED: function()  {
            try {
                var _type = this.LINKED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:47:7: ( L I N K E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:47:25: L I N K E D
                this.mL();
                this.mI();
                this.mN();
                this.mK();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "LINKED",

        // $ANTLR start PHRASE_MATCHES
        mPHRASE_MATCHES: function()  {
            try {
                var _type = this.PHRASE_MATCHES;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:48:15: ( P H R A S E M A T C H E S )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:48:25: P H R A S E M A T C H E S
                this.mP();
                this.mH();
                this.mR();
                this.mA();
                this.mS();
                this.mE();
                this.mM();
                this.mA();
                this.mT();
                this.mC();
                this.mH();
                this.mE();
                this.mS();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "PHRASE_MATCHES",

        // $ANTLR start PAGE_RANK
        mPAGE_RANK: function()  {
            try {
                var _type = this.PAGE_RANK;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:49:10: ( P A G E R A N K )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:49:25: P A G E R A N K
                this.mP();
                this.mA();
                this.mG();
                this.mE();
                this.mR();
                this.mA();
                this.mN();
                this.mK();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "PAGE_RANK",

        // $ANTLR start ALEXA_RANK
        mALEXA_RANK: function()  {
            try {
                var _type = this.ALEXA_RANK;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:50:11: ( A L E X A R A N K )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:50:25: A L E X A R A N K
                this.mA();
                this.mL();
                this.mE();
                this.mX();
                this.mA();
                this.mR();
                this.mA();
                this.mN();
                this.mK();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "ALEXA_RANK",

        // $ANTLR start PUBLISHED
        mPUBLISHED: function()  {
            try {
                var _type = this.PUBLISHED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:51:10: ( P U B L I S H E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:51:25: P U B L I S H E D
                this.mP();
                this.mU();
                this.mB();
                this.mL();
                this.mI();
                this.mS();
                this.mH();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "PUBLISHED",

        // $ANTLR start PUBLISHEDTIME
        mPUBLISHEDTIME: function()  {
            try {
                var _type = this.PUBLISHEDTIME;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:52:14: ( P U B L I S H E D T I M E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:52:25: P U B L I S H E D T I M E
                this.mP();
                this.mU();
                this.mB();
                this.mL();
                this.mI();
                this.mS();
                this.mH();
                this.mE();
                this.mD();
                this.mT();
                this.mI();
                this.mM();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "PUBLISHEDTIME",

        // $ANTLR start TAG
        mTAG: function()  {
            try {
                var _type = this.TAG;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:53:4: ( T A G )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:53:25: T A G
                this.mT();
                this.mA();
                this.mG();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TAG",

        // $ANTLR start TOPIC
        mTOPIC: function()  {
            try {
                var _type = this.TOPIC;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:54:6: ( T O P I C )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:54:25: T O P I C
                this.mT();
                this.mO();
                this.mP();
                this.mI();
                this.mC();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TOPIC",

        // $ANTLR start SEGMENT
        mSEGMENT: function()  {
            try {
                var _type = this.SEGMENT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:55:8: ( S E G M E N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:55:25: S E G M E N T
                this.mS();
                this.mE();
                this.mG();
                this.mM();
                this.mE();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "SEGMENT",

        // $ANTLR start COUNTRY
        mCOUNTRY: function()  {
            try {
                var _type = this.COUNTRY;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:56:8: ( ( C O U N T R Y | L O C A T I O N ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:56:25: ( C O U N T R Y | L O C A T I O N )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:56:25: ( C O U N T R Y | L O C A T I O N )
                var alt4=2;
                var LA4_0 = this.input.LA(1);

                if ( (LA4_0=='C'||LA4_0=='c') ) {
                    alt4=1;
                }
                else if ( (LA4_0=='L'||LA4_0=='l') ) {
                    alt4=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 4, 0, this.input);

                    throw nvae;
                }
                switch (alt4) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:56:27: C O U N T R Y
                        this.mC();
                        this.mO();
                        this.mU();
                        this.mN();
                        this.mT();
                        this.mR();
                        this.mY();


                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:56:43: L O C A T I O N
                        this.mL();
                        this.mO();
                        this.mC();
                        this.mA();
                        this.mT();
                        this.mI();
                        this.mO();
                        this.mN();


                        break;

                }




                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "COUNTRY",

        // $ANTLR start REGION
        mREGION: function()  {
            try {
                var _type = this.REGION;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:57:7: ( R E G I O N )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:57:25: R E G I O N
                this.mR();
                this.mE();
                this.mG();
                this.mI();
                this.mO();
                this.mN();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "REGION",

        // $ANTLR start CITY
        mCITY: function()  {
            try {
                var _type = this.CITY;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:58:5: ( C I T Y )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:58:25: C I T Y
                this.mC();
                this.mI();
                this.mT();
                this.mY();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "CITY",

        // $ANTLR start RELEVANCY_VERIFIED
        mRELEVANCY_VERIFIED: function()  {
            try {
                var _type = this.RELEVANCY_VERIFIED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:59:19: ( R E L E V A N C Y V E R I F I E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:59:25: R E L E V A N C Y V E R I F I E D
                this.mR();
                this.mE();
                this.mL();
                this.mE();
                this.mV();
                this.mA();
                this.mN();
                this.mC();
                this.mY();
                this.mV();
                this.mE();
                this.mR();
                this.mI();
                this.mF();
                this.mI();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "RELEVANCY_VERIFIED",

        // $ANTLR start ASSIGNEE
        mASSIGNEE: function()  {
            try {
                var _type = this.ASSIGNEE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:60:9: ( A S S I G N E E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:60:25: A S S I G N E E
                this.mA();
                this.mS();
                this.mS();
                this.mI();
                this.mG();
                this.mN();
                this.mE();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "ASSIGNEE",

        // $ANTLR start AUTHOR
        mAUTHOR: function()  {
            try {
                var _type = this.AUTHOR;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:61:7: ( A U T H O R )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:61:25: A U T H O R
                this.mA();
                this.mU();
                this.mT();
                this.mH();
                this.mO();
                this.mR();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "AUTHOR",

        // $ANTLR start AUTHOR_ID
        mAUTHOR_ID: function()  {
            try {
                var _type = this.AUTHOR_ID;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:62:10: ( A U T H O R I D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:62:25: A U T H O R I D
                this.mA();
                this.mU();
                this.mT();
                this.mH();
                this.mO();
                this.mR();
                this.mI();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "AUTHOR_ID",

        // $ANTLR start EXTRACT
        mEXTRACT: function()  {
            try {
                var _type = this.EXTRACT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:63:8: ( E X T R A C T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:63:25: E X T R A C T
                this.mE();
                this.mX();
                this.mT();
                this.mR();
                this.mA();
                this.mC();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "EXTRACT",

        // $ANTLR start SENTIMENT_VERIFIED
        mSENTIMENT_VERIFIED: function()  {
            try {
                var _type = this.SENTIMENT_VERIFIED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:64:19: ( S E N T I M E N T V E R I F I E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:64:25: S E N T I M E N T V E R I F I E D
                this.mS();
                this.mE();
                this.mN();
                this.mT();
                this.mI();
                this.mM();
                this.mE();
                this.mN();
                this.mT();
                this.mV();
                this.mE();
                this.mR();
                this.mI();
                this.mF();
                this.mI();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "SENTIMENT_VERIFIED",

        // $ANTLR start CROWD_VERIFIED
        mCROWD_VERIFIED: function()  {
            try {
                var _type = this.CROWD_VERIFIED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:65:15: ( C R O W D V E R I F I E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:65:25: C R O W D V E R I F I E D
                this.mC();
                this.mR();
                this.mO();
                this.mW();
                this.mD();
                this.mV();
                this.mE();
                this.mR();
                this.mI();
                this.mF();
                this.mI();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "CROWD_VERIFIED",

        // $ANTLR start DISCARDED_BY
        mDISCARDED_BY: function()  {
            try {
                var _type = this.DISCARDED_BY;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:66:13: ( D I S C A R D E D B Y )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:66:25: D I S C A R D E D B Y
                this.mD();
                this.mI();
                this.mS();
                this.mC();
                this.mA();
                this.mR();
                this.mD();
                this.mE();
                this.mD();
                this.mB();
                this.mY();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "DISCARDED_BY",

        // $ANTLR start MENTION_ID
        mMENTION_ID: function()  {
            try {
                var _type = this.MENTION_ID;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:67:11: ( I D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:67:25: I D
                this.mI();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "MENTION_ID",

        // $ANTLR start CROWD_ID
        mCROWD_ID: function()  {
            try {
                var _type = this.CROWD_ID;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:68:9: ( C R O W D I D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:68:25: C R O W D I D
                this.mC();
                this.mR();
                this.mO();
                this.mW();
                this.mD();
                this.mI();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "CROWD_ID",

        // $ANTLR start URI
        mURI: function()  {
            try {
                var _type = this.URI;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:69:4: ( U R I )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:69:25: U R I
                this.mU();
                this.mR();
                this.mI();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "URI",

        // $ANTLR start ENGAGEMENT
        mENGAGEMENT: function()  {
            try {
                var _type = this.ENGAGEMENT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:70:11: ( E N G A G E M E N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:70:25: E N G A G E M E N T
                this.mE();
                this.mN();
                this.mG();
                this.mA();
                this.mG();
                this.mE();
                this.mM();
                this.mE();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "ENGAGEMENT",

        // $ANTLR start REPLY_TO
        mREPLY_TO: function()  {
            try {
                var _type = this.REPLY_TO;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:71:9: ( R E P L Y T O )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:71:25: R E P L Y T O
                this.mR();
                this.mE();
                this.mP();
                this.mL();
                this.mY();
                this.mT();
                this.mO();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "REPLY_TO",

        // $ANTLR start REPLY_COUNT
        mREPLY_COUNT: function()  {
            try {
                var _type = this.REPLY_COUNT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:72:12: ( R E P L Y C O U N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:72:25: R E P L Y C O U N T
                this.mR();
                this.mE();
                this.mP();
                this.mL();
                this.mY();
                this.mC();
                this.mO();
                this.mU();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "REPLY_COUNT",

        // $ANTLR start GRAPH_REPLY_COUNT
        mGRAPH_REPLY_COUNT: function()  {
            try {
                var _type = this.GRAPH_REPLY_COUNT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:73:18: ( G R A P H R E P L Y C O U N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:73:25: G R A P H R E P L Y C O U N T
                this.mG();
                this.mR();
                this.mA();
                this.mP();
                this.mH();
                this.mR();
                this.mE();
                this.mP();
                this.mL();
                this.mY();
                this.mC();
                this.mO();
                this.mU();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "GRAPH_REPLY_COUNT",

        // $ANTLR start RESHARE_OF
        mRESHARE_OF: function()  {
            try {
                var _type = this.RESHARE_OF;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:74:11: ( R E S H A R E O F )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:74:25: R E S H A R E O F
                this.mR();
                this.mE();
                this.mS();
                this.mH();
                this.mA();
                this.mR();
                this.mE();
                this.mO();
                this.mF();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "RESHARE_OF",

        // $ANTLR start RESHARE_COUNT
        mRESHARE_COUNT: function()  {
            try {
                var _type = this.RESHARE_COUNT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:75:14: ( R E S H A R E C O U N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:75:25: R E S H A R E C O U N T
                this.mR();
                this.mE();
                this.mS();
                this.mH();
                this.mA();
                this.mR();
                this.mE();
                this.mC();
                this.mO();
                this.mU();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "RESHARE_COUNT",

        // $ANTLR start GRAPH_RESHARE_COUNT
        mGRAPH_RESHARE_COUNT: function()  {
            try {
                var _type = this.GRAPH_RESHARE_COUNT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:76:20: ( G R A P H R E S H A R E C O U N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:76:25: G R A P H R E S H A R E C O U N T
                this.mG();
                this.mR();
                this.mA();
                this.mP();
                this.mH();
                this.mR();
                this.mE();
                this.mS();
                this.mH();
                this.mA();
                this.mR();
                this.mE();
                this.mC();
                this.mO();
                this.mU();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "GRAPH_RESHARE_COUNT",

        // $ANTLR start REPLY_ORDER_BY_AUTHOR
        mREPLY_ORDER_BY_AUTHOR: function()  {
            try {
                var _type = this.REPLY_ORDER_BY_AUTHOR;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:77:22: ( R E P L Y O R D E R B Y A U T H O R )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:77:25: R E P L Y O R D E R B Y A U T H O R
                this.mR();
                this.mE();
                this.mP();
                this.mL();
                this.mY();
                this.mO();
                this.mR();
                this.mD();
                this.mE();
                this.mR();
                this.mB();
                this.mY();
                this.mA();
                this.mU();
                this.mT();
                this.mH();
                this.mO();
                this.mR();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "REPLY_ORDER_BY_AUTHOR",

        // $ANTLR start OTS
        mOTS: function()  {
            try {
                var _type = this.OTS;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:78:4: ( O T S )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:78:25: O T S
                this.mO();
                this.mT();
                this.mS();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "OTS",

        // $ANTLR start AVE
        mAVE: function()  {
            try {
                var _type = this.AVE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:79:4: ( A V E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:79:25: A V E
                this.mA();
                this.mV();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "AVE",

        // $ANTLR start REACH
        mREACH: function()  {
            try {
                var _type = this.REACH;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:80:6: ( R E A C H )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:80:25: R E A C H
                this.mR();
                this.mE();
                this.mA();
                this.mC();
                this.mH();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "REACH",

        // $ANTLR start STATUS_COUNT
        mSTATUS_COUNT: function()  {
            try {
                var _type = this.STATUS_COUNT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:81:13: ( S T A T U S C O U N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:81:25: S T A T U S C O U N T
                this.mS();
                this.mT();
                this.mA();
                this.mT();
                this.mU();
                this.mS();
                this.mC();
                this.mO();
                this.mU();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "STATUS_COUNT",

        // $ANTLR start FOLLOWER_COUNT
        mFOLLOWER_COUNT: function()  {
            try {
                var _type = this.FOLLOWER_COUNT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:82:15: ( F O L L O W E R C O U N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:82:25: F O L L O W E R C O U N T
                this.mF();
                this.mO();
                this.mL();
                this.mL();
                this.mO();
                this.mW();
                this.mE();
                this.mR();
                this.mC();
                this.mO();
                this.mU();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "FOLLOWER_COUNT",

        // $ANTLR start GRAPH_FOLLOWER_COUNT
        mGRAPH_FOLLOWER_COUNT: function()  {
            try {
                var _type = this.GRAPH_FOLLOWER_COUNT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:83:21: ( G R A P H F O L L O W E R C O U N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:83:25: G R A P H F O L L O W E R C O U N T
                this.mG();
                this.mR();
                this.mA();
                this.mP();
                this.mH();
                this.mF();
                this.mO();
                this.mL();
                this.mL();
                this.mO();
                this.mW();
                this.mE();
                this.mR();
                this.mC();
                this.mO();
                this.mU();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "GRAPH_FOLLOWER_COUNT",

        // $ANTLR start FOLLOWING_COUNT
        mFOLLOWING_COUNT: function()  {
            try {
                var _type = this.FOLLOWING_COUNT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:84:16: ( F O L L O W I N G C O U N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:84:25: F O L L O W I N G C O U N T
                this.mF();
                this.mO();
                this.mL();
                this.mL();
                this.mO();
                this.mW();
                this.mI();
                this.mN();
                this.mG();
                this.mC();
                this.mO();
                this.mU();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "FOLLOWING_COUNT",

        // $ANTLR start CROWD_REGION
        mCROWD_REGION: function()  {
            try {
                var _type = this.CROWD_REGION;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:85:13: ( C R O W D R E G I O N )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:85:25: C R O W D R E G I O N
                this.mC();
                this.mR();
                this.mO();
                this.mW();
                this.mD();
                this.mR();
                this.mE();
                this.mG();
                this.mI();
                this.mO();
                this.mN();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "CROWD_REGION",

        // $ANTLR start GENDER
        mGENDER: function()  {
            try {
                var _type = this.GENDER;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:86:7: ( G E N D E R )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:86:25: G E N D E R
                this.mG();
                this.mE();
                this.mN();
                this.mD();
                this.mE();
                this.mR();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "GENDER",

        // $ANTLR start RESPONSE_TIME
        mRESPONSE_TIME: function()  {
            try {
                var _type = this.RESPONSE_TIME;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:87:14: ( R E S P O N S E T I M E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:87:25: R E S P O N S E T I M E
                this.mR();
                this.mE();
                this.mS();
                this.mP();
                this.mO();
                this.mN();
                this.mS();
                this.mE();
                this.mT();
                this.mI();
                this.mM();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "RESPONSE_TIME",

        // $ANTLR start UNBIASED_SAMPLE
        mUNBIASED_SAMPLE: function()  {
            try {
                var _type = this.UNBIASED_SAMPLE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:88:16: ( U N B I A S E D S A M P L E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:88:25: U N B I A S E D S A M P L E
                this.mU();
                this.mN();
                this.mB();
                this.mI();
                this.mA();
                this.mS();
                this.mE();
                this.mD();
                this.mS();
                this.mA();
                this.mM();
                this.mP();
                this.mL();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "UNBIASED_SAMPLE",

        // $ANTLR start MENTIONED_PROFILE
        mMENTIONED_PROFILE: function()  {
            try {
                var _type = this.MENTIONED_PROFILE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:89:18: ( M E N T I O N E D P R O F I L E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:89:25: M E N T I O N E D P R O F I L E
                this.mM();
                this.mE();
                this.mN();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mE();
                this.mD();
                this.mP();
                this.mR();
                this.mO();
                this.mF();
                this.mI();
                this.mL();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "MENTIONED_PROFILE",

        // $ANTLR start RACE
        mRACE: function()  {
            try {
                var _type = this.RACE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:90:5: ( R A C E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:90:25: R A C E
                this.mR();
                this.mA();
                this.mC();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "RACE",

        // $ANTLR start DIRECT_MESSAGE
        mDIRECT_MESSAGE: function()  {
            try {
                var _type = this.DIRECT_MESSAGE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:91:15: ( D I R E C T M E S S A G E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:91:25: D I R E C T M E S S A G E
                this.mD();
                this.mI();
                this.mR();
                this.mE();
                this.mC();
                this.mT();
                this.mM();
                this.mE();
                this.mS();
                this.mS();
                this.mA();
                this.mG();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "DIRECT_MESSAGE",

        // $ANTLR start VISIBILITY
        mVISIBILITY: function()  {
            try {
                var _type = this.VISIBILITY;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:92:11: ( V I S I B I L I T Y )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:92:25: V I S I B I L I T Y
                this.mV();
                this.mI();
                this.mS();
                this.mI();
                this.mB();
                this.mI();
                this.mL();
                this.mI();
                this.mT();
                this.mY();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "VISIBILITY",

        // $ANTLR start TICKET_ID
        mTICKET_ID: function()  {
            try {
                var _type = this.TICKET_ID;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:93:10: ( T I C K E T I D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:93:25: T I C K E T I D
                this.mT();
                this.mI();
                this.mC();
                this.mK();
                this.mE();
                this.mT();
                this.mI();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TICKET_ID",

        // $ANTLR start SOCIAL_NETWORK
        mSOCIAL_NETWORK: function()  {
            try {
                var _type = this.SOCIAL_NETWORK;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:94:15: ( S O C I A L N E T W O R K )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:94:25: S O C I A L N E T W O R K
                this.mS();
                this.mO();
                this.mC();
                this.mI();
                this.mA();
                this.mL();
                this.mN();
                this.mE();
                this.mT();
                this.mW();
                this.mO();
                this.mR();
                this.mK();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "SOCIAL_NETWORK",

        // $ANTLR start AUTHOR_HANDLE
        mAUTHOR_HANDLE: function()  {
            try {
                var _type = this.AUTHOR_HANDLE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:95:14: ( A U T H O R H A N D L E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:95:25: A U T H O R H A N D L E
                this.mA();
                this.mU();
                this.mT();
                this.mH();
                this.mO();
                this.mR();
                this.mH();
                this.mA();
                this.mN();
                this.mD();
                this.mL();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "AUTHOR_HANDLE",

        // $ANTLR start AUTHOR_HANDLE_ID
        mAUTHOR_HANDLE_ID: function()  {
            try {
                var _type = this.AUTHOR_HANDLE_ID;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:96:17: ( A U T H O R H A N D L E I D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:96:25: A U T H O R H A N D L E I D
                this.mA();
                this.mU();
                this.mT();
                this.mH();
                this.mO();
                this.mR();
                this.mH();
                this.mA();
                this.mN();
                this.mD();
                this.mL();
                this.mE();
                this.mI();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "AUTHOR_HANDLE_ID",

        // $ANTLR start TO_NAME
        mTO_NAME: function()  {
            try {
                var _type = this.TO_NAME;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:97:8: ( T O N A M E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:97:25: T O N A M E
                this.mT();
                this.mO();
                this.mN();
                this.mA();
                this.mM();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TO_NAME",

        // $ANTLR start TO_HANDLE
        mTO_HANDLE: function()  {
            try {
                var _type = this.TO_HANDLE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:98:10: ( T O H A N D L E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:98:25: T O H A N D L E
                this.mT();
                this.mO();
                this.mH();
                this.mA();
                this.mN();
                this.mD();
                this.mL();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TO_HANDLE",

        // $ANTLR start TO_HANDLE_ID
        mTO_HANDLE_ID: function()  {
            try {
                var _type = this.TO_HANDLE_ID;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:99:13: ( T O H A N D L E I D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:99:25: T O H A N D L E I D
                this.mT();
                this.mO();
                this.mH();
                this.mA();
                this.mN();
                this.mD();
                this.mL();
                this.mE();
                this.mI();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TO_HANDLE_ID",

        // $ANTLR start AUTHOR_BIO
        mAUTHOR_BIO: function()  {
            try {
                var _type = this.AUTHOR_BIO;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:100:11: ( A U T H O R B I O )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:100:25: A U T H O R B I O
                this.mA();
                this.mU();
                this.mT();
                this.mH();
                this.mO();
                this.mR();
                this.mB();
                this.mI();
                this.mO();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "AUTHOR_BIO",

        // $ANTLR start CONVERSATION_ID
        mCONVERSATION_ID: function()  {
            try {
                var _type = this.CONVERSATION_ID;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:101:16: ( C O N V E R S A T I O N I D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:101:25: C O N V E R S A T I O N I D
                this.mC();
                this.mO();
                this.mN();
                this.mV();
                this.mE();
                this.mR();
                this.mS();
                this.mA();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mI();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "CONVERSATION_ID",

        // $ANTLR start TOMBSTONED
        mTOMBSTONED: function()  {
            try {
                var _type = this.TOMBSTONED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:102:11: ( T O M B S T O N E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:102:25: T O M B S T O N E D
                this.mT();
                this.mO();
                this.mM();
                this.mB();
                this.mS();
                this.mT();
                this.mO();
                this.mN();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TOMBSTONED",

        // $ANTLR start SCRUBBED
        mSCRUBBED: function()  {
            try {
                var _type = this.SCRUBBED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:103:9: ( S C R U B B E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:103:25: S C R U B B E D
                this.mS();
                this.mC();
                this.mR();
                this.mU();
                this.mB();
                this.mB();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "SCRUBBED",

        // $ANTLR start HAS_REPLY_FROM_PROFILE
        mHAS_REPLY_FROM_PROFILE: function()  {
            try {
                var _type = this.HAS_REPLY_FROM_PROFILE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:104:23: ( H A S R E P L Y F R O M P R O F I L E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:104:25: H A S R E P L Y F R O M P R O F I L E
                this.mH();
                this.mA();
                this.mS();
                this.mR();
                this.mE();
                this.mP();
                this.mL();
                this.mY();
                this.mF();
                this.mR();
                this.mO();
                this.mM();
                this.mP();
                this.mR();
                this.mO();
                this.mF();
                this.mI();
                this.mL();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "HAS_REPLY_FROM_PROFILE",

        // $ANTLR start INTERACTION_ID
        mINTERACTION_ID: function()  {
            try {
                var _type = this.INTERACTION_ID;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:105:15: ( I N T E R A C T I O N I D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:105:25: I N T E R A C T I O N I D
                this.mI();
                this.mN();
                this.mT();
                this.mE();
                this.mR();
                this.mA();
                this.mC();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mI();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "INTERACTION_ID",

        // $ANTLR start INTERACTION_RESPONSE_TIME
        mINTERACTION_RESPONSE_TIME: function()  {
            try {
                var _type = this.INTERACTION_RESPONSE_TIME;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:106:26: ( I N T E R A C T I O N R E S P O N S E T I M E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:106:30: I N T E R A C T I O N R E S P O N S E T I M E
                this.mI();
                this.mN();
                this.mT();
                this.mE();
                this.mR();
                this.mA();
                this.mC();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mR();
                this.mE();
                this.mS();
                this.mP();
                this.mO();
                this.mN();
                this.mS();
                this.mE();
                this.mT();
                this.mI();
                this.mM();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "INTERACTION_RESPONSE_TIME",

        // $ANTLR start INTERACTION_FIRST_RESPONSE_TIME
        mINTERACTION_FIRST_RESPONSE_TIME: function()  {
            try {
                var _type = this.INTERACTION_FIRST_RESPONSE_TIME;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:107:32: ( I N T E R A C T I O N F I R S T R E S P O N S E T I M E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:107:34: I N T E R A C T I O N F I R S T R E S P O N S E T I M E
                this.mI();
                this.mN();
                this.mT();
                this.mE();
                this.mR();
                this.mA();
                this.mC();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mF();
                this.mI();
                this.mR();
                this.mS();
                this.mT();
                this.mR();
                this.mE();
                this.mS();
                this.mP();
                this.mO();
                this.mN();
                this.mS();
                this.mE();
                this.mT();
                this.mI();
                this.mM();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "INTERACTION_FIRST_RESPONSE_TIME",

        // $ANTLR start INTERACTION_FOLLOWUP_RESPONSE_TIME
        mINTERACTION_FOLLOWUP_RESPONSE_TIME: function()  {
            try {
                var _type = this.INTERACTION_FOLLOWUP_RESPONSE_TIME;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:108:35: ( I N T E R A C T I O N F O L L O W U P R E S P O N S E T I M E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:108:37: I N T E R A C T I O N F O L L O W U P R E S P O N S E T I M E
                this.mI();
                this.mN();
                this.mT();
                this.mE();
                this.mR();
                this.mA();
                this.mC();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mF();
                this.mO();
                this.mL();
                this.mL();
                this.mO();
                this.mW();
                this.mU();
                this.mP();
                this.mR();
                this.mE();
                this.mS();
                this.mP();
                this.mO();
                this.mN();
                this.mS();
                this.mE();
                this.mT();
                this.mI();
                this.mM();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "INTERACTION_FOLLOWUP_RESPONSE_TIME",

        // $ANTLR start INTERACTION_WH_RESPONSE_TIME
        mINTERACTION_WH_RESPONSE_TIME: function()  {
            try {
                var _type = this.INTERACTION_WH_RESPONSE_TIME;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:109:29: ( I N T E R A C T I O N W H R E S P O N S E T I M E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:109:33: I N T E R A C T I O N W H R E S P O N S E T I M E
                this.mI();
                this.mN();
                this.mT();
                this.mE();
                this.mR();
                this.mA();
                this.mC();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mW();
                this.mH();
                this.mR();
                this.mE();
                this.mS();
                this.mP();
                this.mO();
                this.mN();
                this.mS();
                this.mE();
                this.mT();
                this.mI();
                this.mM();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "INTERACTION_WH_RESPONSE_TIME",

        // $ANTLR start INTERACTION_WH_FIRST_RESPONSE_TIME
        mINTERACTION_WH_FIRST_RESPONSE_TIME: function()  {
            try {
                var _type = this.INTERACTION_WH_FIRST_RESPONSE_TIME;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:110:35: ( I N T E R A C T I O N W H F I R S T R E S P O N S E T I M E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:110:37: I N T E R A C T I O N W H F I R S T R E S P O N S E T I M E
                this.mI();
                this.mN();
                this.mT();
                this.mE();
                this.mR();
                this.mA();
                this.mC();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mW();
                this.mH();
                this.mF();
                this.mI();
                this.mR();
                this.mS();
                this.mT();
                this.mR();
                this.mE();
                this.mS();
                this.mP();
                this.mO();
                this.mN();
                this.mS();
                this.mE();
                this.mT();
                this.mI();
                this.mM();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "INTERACTION_WH_FIRST_RESPONSE_TIME",

        // $ANTLR start INTERACTION_WH_FOLLOWUP_RESPONSE_TIME
        mINTERACTION_WH_FOLLOWUP_RESPONSE_TIME: function()  {
            try {
                var _type = this.INTERACTION_WH_FOLLOWUP_RESPONSE_TIME;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:111:38: ( I N T E R A C T I O N W H F O L L O W U P R E S P O N S E T I M E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:111:40: I N T E R A C T I O N W H F O L L O W U P R E S P O N S E T I M E
                this.mI();
                this.mN();
                this.mT();
                this.mE();
                this.mR();
                this.mA();
                this.mC();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mW();
                this.mH();
                this.mF();
                this.mO();
                this.mL();
                this.mL();
                this.mO();
                this.mW();
                this.mU();
                this.mP();
                this.mR();
                this.mE();
                this.mS();
                this.mP();
                this.mO();
                this.mN();
                this.mS();
                this.mE();
                this.mT();
                this.mI();
                this.mM();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "INTERACTION_WH_FOLLOWUP_RESPONSE_TIME",

        // $ANTLR start INTERACTION_HAS_RESPONSE
        mINTERACTION_HAS_RESPONSE: function()  {
            try {
                var _type = this.INTERACTION_HAS_RESPONSE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:112:25: ( I N T E R A C T I O N H A S R E S P O N S E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:112:27: I N T E R A C T I O N H A S R E S P O N S E
                this.mI();
                this.mN();
                this.mT();
                this.mE();
                this.mR();
                this.mA();
                this.mC();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mH();
                this.mA();
                this.mS();
                this.mR();
                this.mE();
                this.mS();
                this.mP();
                this.mO();
                this.mN();
                this.mS();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "INTERACTION_HAS_RESPONSE",

        // $ANTLR start INTERACTION_FIRST_MENTION_PUBLISHED
        mINTERACTION_FIRST_MENTION_PUBLISHED: function()  {
            try {
                var _type = this.INTERACTION_FIRST_MENTION_PUBLISHED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:113:36: ( I N T E R A C T I O N F I R S T M E N T I O N P U B L I S H E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:113:38: I N T E R A C T I O N F I R S T M E N T I O N P U B L I S H E D
                this.mI();
                this.mN();
                this.mT();
                this.mE();
                this.mR();
                this.mA();
                this.mC();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mF();
                this.mI();
                this.mR();
                this.mS();
                this.mT();
                this.mM();
                this.mE();
                this.mN();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mP();
                this.mU();
                this.mB();
                this.mL();
                this.mI();
                this.mS();
                this.mH();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "INTERACTION_FIRST_MENTION_PUBLISHED",

        // $ANTLR start INTERACTION_LAST_MENTION_PUBLISHED
        mINTERACTION_LAST_MENTION_PUBLISHED: function()  {
            try {
                var _type = this.INTERACTION_LAST_MENTION_PUBLISHED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:114:35: ( I N T E R A C T I O N L A S T M E N T I O N P U B L I S H E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:114:37: I N T E R A C T I O N L A S T M E N T I O N P U B L I S H E D
                this.mI();
                this.mN();
                this.mT();
                this.mE();
                this.mR();
                this.mA();
                this.mC();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mL();
                this.mA();
                this.mS();
                this.mT();
                this.mM();
                this.mE();
                this.mN();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mP();
                this.mU();
                this.mB();
                this.mL();
                this.mI();
                this.mS();
                this.mH();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "INTERACTION_LAST_MENTION_PUBLISHED",

        // $ANTLR start INTERACTION_FIRST_RESPONSE_PUBLISHED
        mINTERACTION_FIRST_RESPONSE_PUBLISHED: function()  {
            try {
                var _type = this.INTERACTION_FIRST_RESPONSE_PUBLISHED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:115:37: ( I N T E R A C T I O N F I R S T R E S P O N S E P U B L I S H E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:115:39: I N T E R A C T I O N F I R S T R E S P O N S E P U B L I S H E D
                this.mI();
                this.mN();
                this.mT();
                this.mE();
                this.mR();
                this.mA();
                this.mC();
                this.mT();
                this.mI();
                this.mO();
                this.mN();
                this.mF();
                this.mI();
                this.mR();
                this.mS();
                this.mT();
                this.mR();
                this.mE();
                this.mS();
                this.mP();
                this.mO();
                this.mN();
                this.mS();
                this.mE();
                this.mP();
                this.mU();
                this.mB();
                this.mL();
                this.mI();
                this.mS();
                this.mH();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "INTERACTION_FIRST_RESPONSE_PUBLISHED",

        // $ANTLR start UCN
        mUCN: function()  {
            try {
                var _type = this.UCN;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:116:4: ( U C N )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:116:25: U C N
                this.mU();
                this.mC();
                this.mN();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "UCN",

        // $ANTLR start TWITTER_SCREEN_NAME
        mTWITTER_SCREEN_NAME: function()  {
            try {
                var _type = this.TWITTER_SCREEN_NAME;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:119:20: ( T W I T T E R S C R E E N N A M E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:119:25: T W I T T E R S C R E E N N A M E
                this.mT();
                this.mW();
                this.mI();
                this.mT();
                this.mT();
                this.mE();
                this.mR();
                this.mS();
                this.mC();
                this.mR();
                this.mE();
                this.mE();
                this.mN();
                this.mN();
                this.mA();
                this.mM();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TWITTER_SCREEN_NAME",

        // $ANTLR start HANDLE_ID
        mHANDLE_ID: function()  {
            try {
                var _type = this.HANDLE_ID;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:120:10: ( H A N D L E I D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:120:25: H A N D L E I D
                this.mH();
                this.mA();
                this.mN();
                this.mD();
                this.mL();
                this.mE();
                this.mI();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "HANDLE_ID",

        // $ANTLR start FACEBOOK_ID
        mFACEBOOK_ID: function()  {
            try {
                var _type = this.FACEBOOK_ID;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:121:12: ( F A C E B O O K I D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:121:25: F A C E B O O K I D
                this.mF();
                this.mA();
                this.mC();
                this.mE();
                this.mB();
                this.mO();
                this.mO();
                this.mK();
                this.mI();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "FACEBOOK_ID",

        // $ANTLR start IS
        mIS: function()  {
            try {
                var _type = this.IS;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:125:3: ( I S )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:125:25: I S
                this.mI();
                this.mS();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "IS",

        // $ANTLR start ISNT
        mISNT: function()  {
            try {
                var _type = this.ISNT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:126:5: ( I S N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:126:25: I S N T
                this.mI();
                this.mS();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "ISNT",

        // $ANTLR start ISORCHILDOF
        mISORCHILDOF: function()  {
            try {
                var _type = this.ISORCHILDOF;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:127:12: ( I S O R C H I L D O F )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:127:25: I S O R C H I L D O F
                this.mI();
                this.mS();
                this.mO();
                this.mR();
                this.mC();
                this.mH();
                this.mI();
                this.mL();
                this.mD();
                this.mO();
                this.mF();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "ISORCHILDOF",

        // $ANTLR start BEFORE
        mBEFORE: function()  {
            try {
                var _type = this.BEFORE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:128:7: ( B E F O R E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:128:25: B E F O R E
                this.mB();
                this.mE();
                this.mF();
                this.mO();
                this.mR();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "BEFORE",

        // $ANTLR start AFTER
        mAFTER: function()  {
            try {
                var _type = this.AFTER;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:129:6: ( A F T E R )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:129:25: A F T E R
                this.mA();
                this.mF();
                this.mT();
                this.mE();
                this.mR();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "AFTER",

        // $ANTLR start GREATERTHAN
        mGREATERTHAN: function()  {
            try {
                var _type = this.GREATERTHAN;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:130:12: ( '>' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:130:25: '>'
                this.match('>');



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "GREATERTHAN",

        // $ANTLR start GREATERTHANEQUALS
        mGREATERTHANEQUALS: function()  {
            try {
                var _type = this.GREATERTHANEQUALS;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:131:18: ( '>=' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:131:25: '>='
                this.match(">=");




                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "GREATERTHANEQUALS",

        // $ANTLR start LESSTHAN
        mLESSTHAN: function()  {
            try {
                var _type = this.LESSTHAN;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:132:9: ( '<' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:132:25: '<'
                this.match('<');



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "LESSTHAN",

        // $ANTLR start LESSTHANEQUALS
        mLESSTHANEQUALS: function()  {
            try {
                var _type = this.LESSTHANEQUALS;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:133:15: ( '<=' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:133:25: '<='
                this.match("<=");




                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "LESSTHANEQUALS",

        // $ANTLR start EQUALS
        mEQUALS: function()  {
            try {
                var _type = this.EQUALS;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:134:7: ( '=' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:134:25: '='
                this.match('=');



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "EQUALS",

        // $ANTLR start NOTEQUALS
        mNOTEQUALS: function()  {
            try {
                var _type = this.NOTEQUALS;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:135:10: ( '!=' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:135:25: '!='
                this.match("!=");




                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "NOTEQUALS",

        // $ANTLR start CONTAINS
        mCONTAINS: function()  {
            try {
                var _type = this.CONTAINS;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:136:9: ( C O N T A I N S )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:136:25: C O N T A I N S
                this.mC();
                this.mO();
                this.mN();
                this.mT();
                this.mA();
                this.mI();
                this.mN();
                this.mS();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "CONTAINS",

        // $ANTLR start DOESNTCONTAIN
        mDOESNTCONTAIN: function()  {
            try {
                var _type = this.DOESNTCONTAIN;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:137:14: ( D O E S N T C O N T A I N )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:137:25: D O E S N T C O N T A I N
                this.mD();
                this.mO();
                this.mE();
                this.mS();
                this.mN();
                this.mT();
                this.mC();
                this.mO();
                this.mN();
                this.mT();
                this.mA();
                this.mI();
                this.mN();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "DOESNTCONTAIN",

        // $ANTLR start BEGINSWITH
        mBEGINSWITH: function()  {
            try {
                var _type = this.BEGINSWITH;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:138:11: ( B E G I N S W I T H )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:138:25: B E G I N S W I T H
                this.mB();
                this.mE();
                this.mG();
                this.mI();
                this.mN();
                this.mS();
                this.mW();
                this.mI();
                this.mT();
                this.mH();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "BEGINSWITH",

        // $ANTLR start ENDSWITH
        mENDSWITH: function()  {
            try {
                var _type = this.ENDSWITH;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:139:9: ( E N D S W I T H )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:139:25: E N D S W I T H
                this.mE();
                this.mN();
                this.mD();
                this.mS();
                this.mW();
                this.mI();
                this.mT();
                this.mH();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "ENDSWITH",

        // $ANTLR start MATCHES
        mMATCHES: function()  {
            try {
                var _type = this.MATCHES;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:140:8: ( M A T C H E S )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:140:25: M A T C H E S
                this.mM();
                this.mA();
                this.mT();
                this.mC();
                this.mH();
                this.mE();
                this.mS();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "MATCHES",

        // $ANTLR start ISNTNORCHILDOF
        mISNTNORCHILDOF: function()  {
            try {
                var _type = this.ISNTNORCHILDOF;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:141:15: ( I S N T N O R C H I L D O F )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:141:25: I S N T N O R C H I L D O F
                this.mI();
                this.mS();
                this.mN();
                this.mT();
                this.mN();
                this.mO();
                this.mR();
                this.mC();
                this.mH();
                this.mI();
                this.mL();
                this.mD();
                this.mO();
                this.mF();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "ISNTNORCHILDOF",

        // $ANTLR start INTHELAST
        mINTHELAST: function()  {
            try {
                var _type = this.INTHELAST;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:142:10: ( I N T H E L A S T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:142:25: I N T H E L A S T
                this.mI();
                this.mN();
                this.mT();
                this.mH();
                this.mE();
                this.mL();
                this.mA();
                this.mS();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "INTHELAST",

        // $ANTLR start BEFORETHELAST
        mBEFORETHELAST: function()  {
            try {
                var _type = this.BEFORETHELAST;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:143:14: ( B E F O R E T H E L A S T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:143:25: B E F O R E T H E L A S T
                this.mB();
                this.mE();
                this.mF();
                this.mO();
                this.mR();
                this.mE();
                this.mT();
                this.mH();
                this.mE();
                this.mL();
                this.mA();
                this.mS();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "BEFORETHELAST",

        // $ANTLR start ON
        mON: function()  {
            try {
                var _type = this.ON;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:144:3: ( O N )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:144:25: O N
                this.mO();
                this.mN();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "ON",

        // $ANTLR start IN
        mIN: function()  {
            try {
                var _type = this.IN;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:145:3: ( I N )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:145:25: I N
                this.mI();
                this.mN();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "IN",

        // $ANTLR start NOTIN
        mNOTIN: function()  {
            try {
                var _type = this.NOTIN;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:146:6: ( N O T I N )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:146:25: N O T I N
                this.mN();
                this.mO();
                this.mT();
                this.mI();
                this.mN();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "NOTIN",

        // $ANTLR start DISTINCT
        mDISTINCT: function()  {
            try {
                var _type = this.DISTINCT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:147:9: ( D I S T I N C T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:147:25: D I S T I N C T
                this.mD();
                this.mI();
                this.mS();
                this.mT();
                this.mI();
                this.mN();
                this.mC();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "DISTINCT",

        // $ANTLR start SAMPLE
        mSAMPLE: function()  {
            try {
                var _type = this.SAMPLE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:148:7: ( S A M P L E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:148:25: S A M P L E
                this.mS();
                this.mA();
                this.mM();
                this.mP();
                this.mL();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "SAMPLE",

        // $ANTLR start PRESS
        mPRESS: function()  {
            try {
                var _type = this.PRESS;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:152:6: ( P R E S S )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:152:25: P R E S S
                this.mP();
                this.mR();
                this.mE();
                this.mS();
                this.mS();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "PRESS",

        // $ANTLR start ENTERPRISE
        mENTERPRISE: function()  {
            try {
                var _type = this.ENTERPRISE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:153:11: ( E N T E R P R I S E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:153:25: E N T E R P R I S E
                this.mE();
                this.mN();
                this.mT();
                this.mE();
                this.mR();
                this.mP();
                this.mR();
                this.mI();
                this.mS();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "ENTERPRISE",

        // $ANTLR start CONSUMER
        mCONSUMER: function()  {
            try {
                var _type = this.CONSUMER;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:154:9: ( C O N S U M E R )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:154:25: C O N S U M E R
                this.mC();
                this.mO();
                this.mN();
                this.mS();
                this.mU();
                this.mM();
                this.mE();
                this.mR();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "CONSUMER",

        // $ANTLR start DIRECTORY
        mDIRECTORY: function()  {
            try {
                var _type = this.DIRECTORY;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:155:10: ( D I R E C T O R Y )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:155:25: D I R E C T O R Y
                this.mD();
                this.mI();
                this.mR();
                this.mE();
                this.mC();
                this.mT();
                this.mO();
                this.mR();
                this.mY();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "DIRECTORY",

        // $ANTLR start UNSORTED
        mUNSORTED: function()  {
            try {
                var _type = this.UNSORTED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:156:9: ( U N S O R T E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:156:25: U N S O R T E D
                this.mU();
                this.mN();
                this.mS();
                this.mO();
                this.mR();
                this.mT();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "UNSORTED",

        // $ANTLR start RELEVANT
        mRELEVANT: function()  {
            try {
                var _type = this.RELEVANT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:157:9: ( R E L E V A N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:157:25: R E L E V A N T
                this.mR();
                this.mE();
                this.mL();
                this.mE();
                this.mV();
                this.mA();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "RELEVANT",

        // $ANTLR start DUPLICATE
        mDUPLICATE: function()  {
            try {
                var _type = this.DUPLICATE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:158:10: ( D U P L I C A T E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:158:25: D U P L I C A T E
                this.mD();
                this.mU();
                this.mP();
                this.mL();
                this.mI();
                this.mC();
                this.mA();
                this.mT();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "DUPLICATE",

        // $ANTLR start IRRELEVANT
        mIRRELEVANT: function()  {
            try {
                var _type = this.IRRELEVANT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:159:11: ( I R R E L E V A N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:159:25: I R R E L E V A N T
                this.mI();
                this.mR();
                this.mR();
                this.mE();
                this.mL();
                this.mE();
                this.mV();
                this.mA();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "IRRELEVANT",

        // $ANTLR start SPAM
        mSPAM: function()  {
            try {
                var _type = this.SPAM;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:160:5: ( S P A M )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:160:25: S P A M
                this.mS();
                this.mP();
                this.mA();
                this.mM();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "SPAM",

        // $ANTLR start SORTED
        mSORTED: function()  {
            try {
                var _type = this.SORTED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:161:7: ( S O R T E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:161:25: S O R T E D
                this.mS();
                this.mO();
                this.mR();
                this.mT();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "SORTED",

        // $ANTLR start VERIFIED
        mVERIFIED: function()  {
            try {
                var _type = this.VERIFIED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:162:9: ( V E R I F I E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:162:25: V E R I F I E D
                this.mV();
                this.mE();
                this.mR();
                this.mI();
                this.mF();
                this.mI();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "VERIFIED",

        // $ANTLR start NONE
        mNONE: function()  {
            try {
                var _type = this.NONE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:163:5: ( N O N E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:163:25: N O N E
                this.mN();
                this.mO();
                this.mN();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "NONE",

        // $ANTLR start RESOLVED
        mRESOLVED: function()  {
            try {
                var _type = this.RESOLVED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:164:9: ( R E S O L V E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:164:25: R E S O L V E D
                this.mR();
                this.mE();
                this.mS();
                this.mO();
                this.mL();
                this.mV();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "RESOLVED",

        // $ANTLR start UNRESOLVED
        mUNRESOLVED: function()  {
            try {
                var _type = this.UNRESOLVED;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:165:11: ( U N R E S O L V E D )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:165:25: U N R E S O L V E D
                this.mU();
                this.mN();
                this.mR();
                this.mE();
                this.mS();
                this.mO();
                this.mL();
                this.mV();
                this.mE();
                this.mD();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "UNRESOLVED",

        // $ANTLR start TODAY
        mTODAY: function()  {
            try {
                var _type = this.TODAY;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:166:6: ( T O D A Y )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:166:25: T O D A Y
                this.mT();
                this.mO();
                this.mD();
                this.mA();
                this.mY();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TODAY",

        // $ANTLR start HOUR
        mHOUR: function()  {
            try {
                var _type = this.HOUR;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:167:5: ( H O U R )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:167:25: H O U R
                this.mH();
                this.mO();
                this.mU();
                this.mR();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "HOUR",

        // $ANTLR start DAY
        mDAY: function()  {
            try {
                var _type = this.DAY;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:168:4: ( D A Y )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:168:25: D A Y
                this.mD();
                this.mA();
                this.mY();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "DAY",

        // $ANTLR start TWENTY_FOUR_HRS
        mTWENTY_FOUR_HRS: function()  {
            try {
                var _type = this.TWENTY_FOUR_HRS;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:169:16: ( '24' H O U R S )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:169:25: '24' H O U R S
                this.match("24");

                this.mH();
                this.mO();
                this.mU();
                this.mR();
                this.mS();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TWENTY_FOUR_HRS",

        // $ANTLR start WEEK
        mWEEK: function()  {
            try {
                var _type = this.WEEK;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:170:5: ( W E E K )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:170:25: W E E K
                this.mW();
                this.mE();
                this.mE();
                this.mK();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "WEEK",

        // $ANTLR start FORTNIGHT
        mFORTNIGHT: function()  {
            try {
                var _type = this.FORTNIGHT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:171:10: ( F O R T N I G H T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:171:25: F O R T N I G H T
                this.mF();
                this.mO();
                this.mR();
                this.mT();
                this.mN();
                this.mI();
                this.mG();
                this.mH();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "FORTNIGHT",

        // $ANTLR start MONTH
        mMONTH: function()  {
            try {
                var _type = this.MONTH;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:172:6: ( M O N T H )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:172:25: M O N T H
                this.mM();
                this.mO();
                this.mN();
                this.mT();
                this.mH();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "MONTH",

        // $ANTLR start QUARTER
        mQUARTER: function()  {
            try {
                var _type = this.QUARTER;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:173:8: ( Q U A R T E R )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:173:25: Q U A R T E R
                this.mQ();
                this.mU();
                this.mA();
                this.mR();
                this.mT();
                this.mE();
                this.mR();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "QUARTER",

        // $ANTLR start YEAR
        mYEAR: function()  {
            try {
                var _type = this.YEAR;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:174:5: ( Y E A R )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:174:25: Y E A R
                this.mY();
                this.mE();
                this.mA();
                this.mR();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "YEAR",

        // $ANTLR start EPOCH
        mEPOCH: function()  {
            try {
                var _type = this.EPOCH;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:175:6: ( E P O C H )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:175:25: E P O C H
                this.mE();
                this.mP();
                this.mO();
                this.mC();
                this.mH();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "EPOCH",

        // $ANTLR start FALSE
        mFALSE: function()  {
            try {
                var _type = this.FALSE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:176:6: ( F A L S E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:176:25: F A L S E
                this.mF();
                this.mA();
                this.mL();
                this.mS();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "FALSE",

        // $ANTLR start TRUE
        mTRUE: function()  {
            try {
                var _type = this.TRUE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:177:5: ( T R U E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:177:25: T R U E
                this.mT();
                this.mR();
                this.mU();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TRUE",

        // $ANTLR start MALE
        mMALE: function()  {
            try {
                var _type = this.MALE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:178:5: ( M A L E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:178:25: M A L E
                this.mM();
                this.mA();
                this.mL();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "MALE",

        // $ANTLR start FEMALE
        mFEMALE: function()  {
            try {
                var _type = this.FEMALE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:179:7: ( F E M A L E )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:179:25: F E M A L E
                this.mF();
                this.mE();
                this.mM();
                this.mA();
                this.mL();
                this.mE();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "FEMALE",

        // $ANTLR start OTHER
        mOTHER: function()  {
            try {
                var _type = this.OTHER;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:180:6: ( O T H E R )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:180:25: O T H E R
                this.mO();
                this.mT();
                this.mH();
                this.mE();
                this.mR();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "OTHER",

        // $ANTLR start UNKNOWN
        mUNKNOWN: function()  {
            try {
                var _type = this.UNKNOWN;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:181:8: ( U N K N O W N )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:181:25: U N K N O W N
                this.mU();
                this.mN();
                this.mK();
                this.mN();
                this.mO();
                this.mW();
                this.mN();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "UNKNOWN",

        // $ANTLR start LONG_LITERAL
        mLONG_LITERAL: function()  {
            try {
                var _type = this.LONG_LITERAL;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:183:13: ( ( '-' )? ( '0' .. '9' )+ )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:183:15: ( '-' )? ( '0' .. '9' )+
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:183:15: ( '-' )?
                var alt5=2;
                var LA5_0 = this.input.LA(1);

                if ( (LA5_0=='-') ) {
                    alt5=1;
                }
                switch (alt5) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:183:15: '-'
                        this.match('-');


                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:183:20: ( '0' .. '9' )+
                var cnt6=0;
                loop6:
                    do {
                        var alt6=2;
                        var LA6_0 = this.input.LA(1);

                        if ( ((LA6_0>='0' && LA6_0<='9')) ) {
                            alt6=1;
                        }


                        switch (alt6) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:183:20: '0' .. '9'
                                this.matchRange('0','9');


                                break;

                            default :
                                if ( cnt6 >= 1 ) {
                                    break loop6;
                                }
                                var eee = new org.antlr.runtime.EarlyExitException(6, this.input);
                                throw eee;
                        }
                        cnt6++;
                    } while (true);




                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "LONG_LITERAL",

        // $ANTLR start TAG_ID_LITERAL
        mTAG_ID_LITERAL: function()  {
            try {
                var _type = this.TAG_ID_LITERAL;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:185:15: ( ( 'v' | 'n' ) ( '0' .. '9' )+ )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:185:17: ( 'v' | 'n' ) ( '0' .. '9' )+
                if ( this.input.LA(1)=='n'||this.input.LA(1)=='v' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:185:29: ( '0' .. '9' )+
                var cnt7=0;
                loop7:
                    do {
                        var alt7=2;
                        var LA7_0 = this.input.LA(1);

                        if ( ((LA7_0>='0' && LA7_0<='9')) ) {
                            alt7=1;
                        }


                        switch (alt7) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:185:29: '0' .. '9'
                                this.matchRange('0','9');


                                break;

                            default :
                                if ( cnt7 >= 1 ) {
                                    break loop7;
                                }
                                var eee = new org.antlr.runtime.EarlyExitException(7, this.input);
                                throw eee;
                        }
                        cnt7++;
                    } while (true);




                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "TAG_ID_LITERAL",

        // $ANTLR start FLOAT_LITERAL
        mFLOAT_LITERAL: function()  {
            try {
                var _type = this.FLOAT_LITERAL;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:187:14: ( ( '-' )? ( '0' .. '9' )+ '.' ( '0' .. '9' )+ )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:187:16: ( '-' )? ( '0' .. '9' )+ '.' ( '0' .. '9' )+
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:187:16: ( '-' )?
                var alt8=2;
                var LA8_0 = this.input.LA(1);

                if ( (LA8_0=='-') ) {
                    alt8=1;
                }
                switch (alt8) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:187:16: '-'
                        this.match('-');


                        break;

                }

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:187:21: ( '0' .. '9' )+
                var cnt9=0;
                loop9:
                    do {
                        var alt9=2;
                        var LA9_0 = this.input.LA(1);

                        if ( ((LA9_0>='0' && LA9_0<='9')) ) {
                            alt9=1;
                        }


                        switch (alt9) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:187:21: '0' .. '9'
                                this.matchRange('0','9');


                                break;

                            default :
                                if ( cnt9 >= 1 ) {
                                    break loop9;
                                }
                                var eee = new org.antlr.runtime.EarlyExitException(9, this.input);
                                throw eee;
                        }
                        cnt9++;
                    } while (true);

                this.match('.');
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:187:35: ( '0' .. '9' )+
                var cnt10=0;
                loop10:
                    do {
                        var alt10=2;
                        var LA10_0 = this.input.LA(1);

                        if ( ((LA10_0>='0' && LA10_0<='9')) ) {
                            alt10=1;
                        }


                        switch (alt10) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:187:35: '0' .. '9'
                                this.matchRange('0','9');


                                break;

                            default :
                                if ( cnt10 >= 1 ) {
                                    break loop10;
                                }
                                var eee = new org.antlr.runtime.EarlyExitException(10, this.input);
                                throw eee;
                        }
                        cnt10++;
                    } while (true);




                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "FLOAT_LITERAL",

        // $ANTLR start DATE_SEPARATOR
        mDATE_SEPARATOR: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:189:24: ( ( '/' | '-' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:189:26: ( '/' | '-' )
                if ( this.input.LA(1)=='-'||this.input.LA(1)=='/' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "DATE_SEPARATOR",

        // $ANTLR start DIGIT
        mDIGIT: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:190:15: ( '0' .. '9' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:190:17: '0' .. '9'
                this.matchRange('0','9');



            }
            finally {
            }
        },
        // $ANTLR end "DIGIT",

        // $ANTLR start UNQUOTED_DATE
        mUNQUOTED_DATE: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:191:23: ( DIGIT DIGIT DIGIT DIGIT DATE_SEPARATOR DIGIT DIGIT DATE_SEPARATOR DIGIT DIGIT ( ' ' DIGIT DIGIT ':' DIGIT DIGIT ( ':' DIGIT DIGIT )? )? )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:191:25: DIGIT DIGIT DIGIT DIGIT DATE_SEPARATOR DIGIT DIGIT DATE_SEPARATOR DIGIT DIGIT ( ' ' DIGIT DIGIT ':' DIGIT DIGIT ( ':' DIGIT DIGIT )? )?
                this.mDIGIT();
                this.mDIGIT();
                this.mDIGIT();
                this.mDIGIT();
                this.mDATE_SEPARATOR();
                this.mDIGIT();
                this.mDIGIT();
                this.mDATE_SEPARATOR();
                this.mDIGIT();
                this.mDIGIT();
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:192:25: ( ' ' DIGIT DIGIT ':' DIGIT DIGIT ( ':' DIGIT DIGIT )? )?
                var alt12=2;
                var LA12_0 = this.input.LA(1);

                if ( (LA12_0==' ') ) {
                    alt12=1;
                }
                switch (alt12) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:192:26: ' ' DIGIT DIGIT ':' DIGIT DIGIT ( ':' DIGIT DIGIT )?
                        this.match(' ');
                        this.mDIGIT();
                        this.mDIGIT();
                        this.match(':');
                        this.mDIGIT();
                        this.mDIGIT();
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:192:58: ( ':' DIGIT DIGIT )?
                        var alt11=2;
                        var LA11_0 = this.input.LA(1);

                        if ( (LA11_0==':') ) {
                            alt11=1;
                        }
                        switch (alt11) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:192:59: ':' DIGIT DIGIT
                                this.match(':');
                                this.mDIGIT();
                                this.mDIGIT();


                                break;

                        }



                        break;

                }




            }
            finally {
            }
        },
        // $ANTLR end "UNQUOTED_DATE",

        // $ANTLR start DATE_LITERAL
        mDATE_LITERAL: function()  {
            try {
                var _type = this.DATE_LITERAL;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:193:13: ( ( '\"' UNQUOTED_DATE '\"' ) | ( '\\'' UNQUOTED_DATE '\\'' ) )
                var alt13=2;
                var LA13_0 = this.input.LA(1);

                if ( (LA13_0=='\"') ) {
                    alt13=1;
                }
                else if ( (LA13_0=='\'') ) {
                    alt13=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 13, 0, this.input);

                    throw nvae;
                }
                switch (alt13) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:193:15: ( '\"' UNQUOTED_DATE '\"' )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:193:15: ( '\"' UNQUOTED_DATE '\"' )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:193:17: '\"' UNQUOTED_DATE '\"'
                        this.match('\"');
                        this.mUNQUOTED_DATE();
                        this.match('\"');





                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:193:43: ( '\\'' UNQUOTED_DATE '\\'' )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:193:43: ( '\\'' UNQUOTED_DATE '\\'' )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:193:45: '\\'' UNQUOTED_DATE '\\''
                        this.match('\'');
                        this.mUNQUOTED_DATE();
                        this.match('\'');





                        break;

                }
                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "DATE_LITERAL",

        // $ANTLR start STRING_LITERAL
        mSTRING_LITERAL: function()  {
            try {
                var _type = this.STRING_LITERAL;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:196:15: ( ( '\\'' (~ ( '\\'' | '\\\\' ) | ( '\\\\' ( '\\\\' | '\\'' ) ) )* '\\'' ) | ( '\"' (~ ( '\"' | '\\\\' ) | ( '\\\\' ( '\\\\' | '\"' ) ) )* '\"' ) )
                var alt16=2;
                var LA16_0 = this.input.LA(1);

                if ( (LA16_0=='\'') ) {
                    alt16=1;
                }
                else if ( (LA16_0=='\"') ) {
                    alt16=2;
                }
                else {
                    var nvae =
                        new org.antlr.runtime.NoViableAltException("", 16, 0, this.input);

                    throw nvae;
                }
                switch (alt16) {
                    case 1 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:196:18: ( '\\'' (~ ( '\\'' | '\\\\' ) | ( '\\\\' ( '\\\\' | '\\'' ) ) )* '\\'' )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:196:18: ( '\\'' (~ ( '\\'' | '\\\\' ) | ( '\\\\' ( '\\\\' | '\\'' ) ) )* '\\'' )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:196:20: '\\'' (~ ( '\\'' | '\\\\' ) | ( '\\\\' ( '\\\\' | '\\'' ) ) )* '\\''
                        this.match('\'');
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:196:25: (~ ( '\\'' | '\\\\' ) | ( '\\\\' ( '\\\\' | '\\'' ) ) )*
                        loop14:
                            do {
                                var alt14=3;
                                var LA14_0 = this.input.LA(1);

                                if ( ((LA14_0>='\u0000' && LA14_0<='&')||(LA14_0>='(' && LA14_0<='[')||(LA14_0>=']' && LA14_0<='\uFFFF')) ) {
                                    alt14=1;
                                }
                                else if ( (LA14_0=='\\') ) {
                                    alt14=2;
                                }


                                switch (alt14) {
                                    case 1 :
                                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:196:27: ~ ( '\\'' | '\\\\' )
                                        if ( (this.input.LA(1)>='\u0000' && this.input.LA(1)<='&')||(this.input.LA(1)>='(' && this.input.LA(1)<='[')||(this.input.LA(1)>=']' && this.input.LA(1)<='\uFFFF') ) {
                                            this.input.consume();

                                        }
                                        else {
                                            var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                                            this.recover(mse);
                                            throw mse;}



                                        break;
                                    case 2 :
                                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:196:44: ( '\\\\' ( '\\\\' | '\\'' ) )
                                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:196:44: ( '\\\\' ( '\\\\' | '\\'' ) )
                                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:196:45: '\\\\' ( '\\\\' | '\\'' )
                                        this.match('\\');
                                        if ( this.input.LA(1)=='\''||this.input.LA(1)=='\\' ) {
                                            this.input.consume();

                                        }
                                        else {
                                            var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                                            this.recover(mse);
                                            throw mse;}






                                        break;

                                    default :
                                        break loop14;
                                }
                            } while (true);

                        this.match('\'');





                        break;
                    case 2 :
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:197:19: ( '\"' (~ ( '\"' | '\\\\' ) | ( '\\\\' ( '\\\\' | '\"' ) ) )* '\"' )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:197:19: ( '\"' (~ ( '\"' | '\\\\' ) | ( '\\\\' ( '\\\\' | '\"' ) ) )* '\"' )
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:197:21: '\"' (~ ( '\"' | '\\\\' ) | ( '\\\\' ( '\\\\' | '\"' ) ) )* '\"'
                        this.match('\"');
                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:197:25: (~ ( '\"' | '\\\\' ) | ( '\\\\' ( '\\\\' | '\"' ) ) )*
                        loop15:
                            do {
                                var alt15=3;
                                var LA15_0 = this.input.LA(1);

                                if ( ((LA15_0>='\u0000' && LA15_0<='!')||(LA15_0>='#' && LA15_0<='[')||(LA15_0>=']' && LA15_0<='\uFFFF')) ) {
                                    alt15=1;
                                }
                                else if ( (LA15_0=='\\') ) {
                                    alt15=2;
                                }


                                switch (alt15) {
                                    case 1 :
                                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:197:27: ~ ( '\"' | '\\\\' )
                                        if ( (this.input.LA(1)>='\u0000' && this.input.LA(1)<='!')||(this.input.LA(1)>='#' && this.input.LA(1)<='[')||(this.input.LA(1)>=']' && this.input.LA(1)<='\uFFFF') ) {
                                            this.input.consume();

                                        }
                                        else {
                                            var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                                            this.recover(mse);
                                            throw mse;}



                                        break;
                                    case 2 :
                                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:197:43: ( '\\\\' ( '\\\\' | '\"' ) )
                                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:197:43: ( '\\\\' ( '\\\\' | '\"' ) )
                                        // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:197:44: '\\\\' ( '\\\\' | '\"' )
                                        this.match('\\');
                                        if ( this.input.LA(1)=='\"'||this.input.LA(1)=='\\' ) {
                                            this.input.consume();

                                        }
                                        else {
                                            var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                                            this.recover(mse);
                                            throw mse;}






                                        break;

                                    default :
                                        break loop15;
                                }
                            } while (true);

                        this.match('\"');





                        break;

                }
                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "STRING_LITERAL",

        // $ANTLR start ANNOTATION
        mANNOTATION: function()  {
            try {
                var _type = this.ANNOTATION;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:199:11: ( '@' STRING_LITERAL )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:199:13: '@' STRING_LITERAL
                this.match('@');
                this.mSTRING_LITERAL();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "ANNOTATION",

        // $ANTLR start LPAREN
        mLPAREN: function()  {
            try {
                var _type = this.LPAREN;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:202:7: ( '(' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:202:25: '('
                this.match('(');



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "LPAREN",

        // $ANTLR start RPAREN
        mRPAREN: function()  {
            try {
                var _type = this.RPAREN;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:203:7: ( ')' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:203:25: ')'
                this.match(')');



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "RPAREN",

        // $ANTLR start COMMA
        mCOMMA: function()  {
            try {
                var _type = this.COMMA;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:204:6: ( ',' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:204:25: ','
                this.match(',');



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "COMMA",

        // $ANTLR start DIVIDE
        mDIVIDE: function()  {
            try {
                var _type = this.DIVIDE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:205:7: ( '/' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:205:25: '/'
                this.match('/');



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "DIVIDE",

        // $ANTLR start LSQUARE
        mLSQUARE: function()  {
            try {
                var _type = this.LSQUARE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:206:8: ( '[' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:206:25: '['
                this.match('[');



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "LSQUARE",

        // $ANTLR start RSQUARE
        mRSQUARE: function()  {
            try {
                var _type = this.RSQUARE;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:207:8: ( ']' )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:207:25: ']'
                this.match(']');



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "RSQUARE",

        // $ANTLR start ASC
        mASC: function()  {
            try {
                var _type = this.ASC;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:212:4: ( A S C )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:212:25: A S C
                this.mA();
                this.mS();
                this.mC();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "ASC",

        // $ANTLR start DESC
        mDESC: function()  {
            try {
                var _type = this.DESC;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:213:5: ( D E S C )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:213:25: D E S C
                this.mD();
                this.mE();
                this.mS();
                this.mC();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "DESC",

        // $ANTLR start COUNT
        mCOUNT: function()  {
            try {
                var _type = this.COUNT;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:214:6: ( C O U N T )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:214:25: C O U N T
                this.mC();
                this.mO();
                this.mU();
                this.mN();
                this.mT();



                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "COUNT",

        // $ANTLR start UNQUOTED_STRING_LITERAL
        mUNQUOTED_STRING_LITERAL: function()  {
            try {
                var _type = this.UNQUOTED_STRING_LITERAL;
                var _channel = org.antlr.runtime.BaseRecognizer.DEFAULT_TOKEN_CHANNEL;
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:216:24: ( ( 'a' .. 'z' | 'A' .. 'Z' | '_' ) ( 'a' .. 'z' | 'A' .. 'Z' | '_' | DIGIT )* )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:216:26: ( 'a' .. 'z' | 'A' .. 'Z' | '_' ) ( 'a' .. 'z' | 'A' .. 'Z' | '_' | DIGIT )*
                if ( (this.input.LA(1)>='A' && this.input.LA(1)<='Z')||this.input.LA(1)=='_'||(this.input.LA(1)>='a' && this.input.LA(1)<='z') ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}

                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:216:54: ( 'a' .. 'z' | 'A' .. 'Z' | '_' | DIGIT )*
                loop17:
                    do {
                        var alt17=2;
                        var LA17_0 = this.input.LA(1);

                        if ( ((LA17_0>='0' && LA17_0<='9')||(LA17_0>='A' && LA17_0<='Z')||LA17_0=='_'||(LA17_0>='a' && LA17_0<='z')) ) {
                            alt17=1;
                        }


                        switch (alt17) {
                            case 1 :
                                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:
                                if ( (this.input.LA(1)>='0' && this.input.LA(1)<='9')||(this.input.LA(1)>='A' && this.input.LA(1)<='Z')||this.input.LA(1)=='_'||(this.input.LA(1)>='a' && this.input.LA(1)<='z') ) {
                                    this.input.consume();

                                }
                                else {
                                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                                    this.recover(mse);
                                    throw mse;}



                                break;

                            default :
                                break loop17;
                        }
                    } while (true);




                this.state.type = _type;
                this.state.channel = _channel;
            }
            finally {
            }
        },
        // $ANTLR end "UNQUOTED_STRING_LITERAL",

        // $ANTLR start A
        mA: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:219:11: ( ( 'a' | 'A' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:219:25: ( 'a' | 'A' )
                if ( this.input.LA(1)=='A'||this.input.LA(1)=='a' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "A",

        // $ANTLR start B
        mB: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:220:11: ( ( 'b' | 'B' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:220:25: ( 'b' | 'B' )
                if ( this.input.LA(1)=='B'||this.input.LA(1)=='b' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "B",

        // $ANTLR start C
        mC: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:221:11: ( ( 'c' | 'C' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:221:25: ( 'c' | 'C' )
                if ( this.input.LA(1)=='C'||this.input.LA(1)=='c' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "C",

        // $ANTLR start D
        mD: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:222:11: ( ( 'd' | 'D' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:222:25: ( 'd' | 'D' )
                if ( this.input.LA(1)=='D'||this.input.LA(1)=='d' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "D",

        // $ANTLR start E
        mE: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:223:11: ( ( 'e' | 'E' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:223:25: ( 'e' | 'E' )
                if ( this.input.LA(1)=='E'||this.input.LA(1)=='e' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "E",

        // $ANTLR start F
        mF: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:224:11: ( ( 'f' | 'F' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:224:25: ( 'f' | 'F' )
                if ( this.input.LA(1)=='F'||this.input.LA(1)=='f' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "F",

        // $ANTLR start G
        mG: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:225:11: ( ( 'g' | 'G' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:225:25: ( 'g' | 'G' )
                if ( this.input.LA(1)=='G'||this.input.LA(1)=='g' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "G",

        // $ANTLR start H
        mH: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:226:11: ( ( 'h' | 'H' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:226:25: ( 'h' | 'H' )
                if ( this.input.LA(1)=='H'||this.input.LA(1)=='h' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "H",

        // $ANTLR start I
        mI: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:227:11: ( ( 'i' | 'I' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:227:25: ( 'i' | 'I' )
                if ( this.input.LA(1)=='I'||this.input.LA(1)=='i' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "I",

        // $ANTLR start J
        mJ: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:228:11: ( ( 'j' | 'J' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:228:25: ( 'j' | 'J' )
                if ( this.input.LA(1)=='J'||this.input.LA(1)=='j' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "J",

        // $ANTLR start K
        mK: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:229:11: ( ( 'k' | 'K' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:229:25: ( 'k' | 'K' )
                if ( this.input.LA(1)=='K'||this.input.LA(1)=='k' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "K",

        // $ANTLR start L
        mL: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:230:11: ( ( 'l' | 'L' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:230:25: ( 'l' | 'L' )
                if ( this.input.LA(1)=='L'||this.input.LA(1)=='l' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "L",

        // $ANTLR start M
        mM: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:231:11: ( ( 'm' | 'M' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:231:25: ( 'm' | 'M' )
                if ( this.input.LA(1)=='M'||this.input.LA(1)=='m' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "M",

        // $ANTLR start N
        mN: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:232:11: ( ( 'n' | 'N' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:232:25: ( 'n' | 'N' )
                if ( this.input.LA(1)=='N'||this.input.LA(1)=='n' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "N",

        // $ANTLR start O
        mO: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:233:11: ( ( 'o' | 'O' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:233:25: ( 'o' | 'O' )
                if ( this.input.LA(1)=='O'||this.input.LA(1)=='o' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "O",

        // $ANTLR start P
        mP: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:234:11: ( ( 'p' | 'P' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:234:25: ( 'p' | 'P' )
                if ( this.input.LA(1)=='P'||this.input.LA(1)=='p' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "P",

        // $ANTLR start Q
        mQ: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:235:11: ( ( 'q' | 'Q' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:235:25: ( 'q' | 'Q' )
                if ( this.input.LA(1)=='Q'||this.input.LA(1)=='q' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "Q",

        // $ANTLR start R
        mR: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:236:11: ( ( 'r' | 'R' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:236:25: ( 'r' | 'R' )
                if ( this.input.LA(1)=='R'||this.input.LA(1)=='r' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "R",

        // $ANTLR start S
        mS: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:237:11: ( ( 's' | 'S' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:237:25: ( 's' | 'S' )
                if ( this.input.LA(1)=='S'||this.input.LA(1)=='s' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "S",

        // $ANTLR start T
        mT: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:238:11: ( ( 't' | 'T' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:238:25: ( 't' | 'T' )
                if ( this.input.LA(1)=='T'||this.input.LA(1)=='t' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "T",

        // $ANTLR start U
        mU: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:239:11: ( ( 'u' | 'U' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:239:25: ( 'u' | 'U' )
                if ( this.input.LA(1)=='U'||this.input.LA(1)=='u' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "U",

        // $ANTLR start V
        mV: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:240:11: ( ( 'v' | 'V' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:240:25: ( 'v' | 'V' )
                if ( this.input.LA(1)=='V'||this.input.LA(1)=='v' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "V",

        // $ANTLR start W
        mW: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:241:11: ( ( 'w' | 'W' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:241:25: ( 'w' | 'W' )
                if ( this.input.LA(1)=='W'||this.input.LA(1)=='w' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "W",

        // $ANTLR start X
        mX: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:242:11: ( ( 'x' | 'X' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:242:25: ( 'x' | 'X' )
                if ( this.input.LA(1)=='X'||this.input.LA(1)=='x' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "X",

        // $ANTLR start Y
        mY: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:243:11: ( ( 'y' | 'Y' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:243:25: ( 'y' | 'Y' )
                if ( this.input.LA(1)=='Y'||this.input.LA(1)=='y' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "Y",

        // $ANTLR start Z
        mZ: function()  {
            try {
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:244:11: ( ( 'z' | 'Z' ) )
                // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:244:25: ( 'z' | 'Z' )
                if ( this.input.LA(1)=='Z'||this.input.LA(1)=='z' ) {
                    this.input.consume();

                }
                else {
                    var mse = new org.antlr.runtime.MismatchedSetException(null,this.input);
                    this.recover(mse);
                    throw mse;}




            }
            finally {
            }
        },
        // $ANTLR end "Z",

        mTokens: function() {
            // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:8: ( NEWLINE | WHITESPACE | OR | AND | RELEVANCY | BRAND | SENTIMENT | CREDIBILITY | MEDIA | ACTION | PROCESS | PHRASE | PHRASE_COUNT | FEED | TITLE | LINK | SITE | AUTHOR_NAME | AUTHOR_LOCATION | CONTENT | LANGUAGE | PICKED_UP | UPDATED | LINKED | PHRASE_MATCHES | PAGE_RANK | ALEXA_RANK | PUBLISHED | PUBLISHEDTIME | TAG | TOPIC | SEGMENT | COUNTRY | REGION | CITY | RELEVANCY_VERIFIED | ASSIGNEE | AUTHOR | AUTHOR_ID | EXTRACT | SENTIMENT_VERIFIED | CROWD_VERIFIED | DISCARDED_BY | MENTION_ID | CROWD_ID | URI | ENGAGEMENT | REPLY_TO | REPLY_COUNT | GRAPH_REPLY_COUNT | RESHARE_OF | RESHARE_COUNT | GRAPH_RESHARE_COUNT | REPLY_ORDER_BY_AUTHOR | OTS | AVE | REACH | STATUS_COUNT | FOLLOWER_COUNT | GRAPH_FOLLOWER_COUNT | FOLLOWING_COUNT | CROWD_REGION | GENDER | RESPONSE_TIME | UNBIASED_SAMPLE | MENTIONED_PROFILE | RACE | DIRECT_MESSAGE | VISIBILITY | TICKET_ID | SOCIAL_NETWORK | AUTHOR_HANDLE | AUTHOR_HANDLE_ID | TO_NAME | TO_HANDLE | TO_HANDLE_ID | AUTHOR_BIO | CONVERSATION_ID | TOMBSTONED | SCRUBBED | HAS_REPLY_FROM_PROFILE | INTERACTION_ID | INTERACTION_RESPONSE_TIME | INTERACTION_FIRST_RESPONSE_TIME | INTERACTION_FOLLOWUP_RESPONSE_TIME | INTERACTION_WH_RESPONSE_TIME | INTERACTION_WH_FIRST_RESPONSE_TIME | INTERACTION_WH_FOLLOWUP_RESPONSE_TIME | INTERACTION_HAS_RESPONSE | INTERACTION_FIRST_MENTION_PUBLISHED | INTERACTION_LAST_MENTION_PUBLISHED | INTERACTION_FIRST_RESPONSE_PUBLISHED | UCN | TWITTER_SCREEN_NAME | HANDLE_ID | FACEBOOK_ID | IS | ISNT | ISORCHILDOF | BEFORE | AFTER | GREATERTHAN | GREATERTHANEQUALS | LESSTHAN | LESSTHANEQUALS | EQUALS | NOTEQUALS | CONTAINS | DOESNTCONTAIN | BEGINSWITH | ENDSWITH | MATCHES | ISNTNORCHILDOF | INTHELAST | BEFORETHELAST | ON | IN | NOTIN | DISTINCT | SAMPLE | PRESS | ENTERPRISE | CONSUMER | DIRECTORY | UNSORTED | RELEVANT | DUPLICATE | IRRELEVANT | SPAM | SORTED | VERIFIED | NONE | RESOLVED | UNRESOLVED | TODAY | HOUR | DAY | TWENTY_FOUR_HRS | WEEK | FORTNIGHT | MONTH | QUARTER | YEAR | EPOCH | FALSE | TRUE | MALE | FEMALE | OTHER | UNKNOWN | LONG_LITERAL | TAG_ID_LITERAL | FLOAT_LITERAL | DATE_LITERAL | STRING_LITERAL | ANNOTATION | LPAREN | RPAREN | COMMA | DIVIDE | LSQUARE | RSQUARE | ASC | DESC | COUNT | UNQUOTED_STRING_LITERAL )
            var alt18=166;
            alt18 = this.dfa18.predict(this.input);
            switch (alt18) {
                case 1 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:10: NEWLINE
                    this.mNEWLINE();


                    break;
                case 2 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:18: WHITESPACE
                    this.mWHITESPACE();


                    break;
                case 3 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:29: OR
                    this.mOR();


                    break;
                case 4 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:32: AND
                    this.mAND();


                    break;
                case 5 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:36: RELEVANCY
                    this.mRELEVANCY();


                    break;
                case 6 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:46: BRAND
                    this.mBRAND();


                    break;
                case 7 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:52: SENTIMENT
                    this.mSENTIMENT();


                    break;
                case 8 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:62: CREDIBILITY
                    this.mCREDIBILITY();


                    break;
                case 9 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:74: MEDIA
                    this.mMEDIA();


                    break;
                case 10 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:80: ACTION
                    this.mACTION();


                    break;
                case 11 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:87: PROCESS
                    this.mPROCESS();


                    break;
                case 12 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:95: PHRASE
                    this.mPHRASE();


                    break;
                case 13 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:102: PHRASE_COUNT
                    this.mPHRASE_COUNT();


                    break;
                case 14 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:115: FEED
                    this.mFEED();


                    break;
                case 15 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:120: TITLE
                    this.mTITLE();


                    break;
                case 16 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:126: LINK
                    this.mLINK();


                    break;
                case 17 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:131: SITE
                    this.mSITE();


                    break;
                case 18 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:136: AUTHOR_NAME
                    this.mAUTHOR_NAME();


                    break;
                case 19 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:148: AUTHOR_LOCATION
                    this.mAUTHOR_LOCATION();


                    break;
                case 20 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:164: CONTENT
                    this.mCONTENT();


                    break;
                case 21 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:172: LANGUAGE
                    this.mLANGUAGE();


                    break;
                case 22 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:181: PICKED_UP
                    this.mPICKED_UP();


                    break;
                case 23 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:191: UPDATED
                    this.mUPDATED();


                    break;
                case 24 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:199: LINKED
                    this.mLINKED();


                    break;
                case 25 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:206: PHRASE_MATCHES
                    this.mPHRASE_MATCHES();


                    break;
                case 26 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:221: PAGE_RANK
                    this.mPAGE_RANK();


                    break;
                case 27 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:231: ALEXA_RANK
                    this.mALEXA_RANK();


                    break;
                case 28 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:242: PUBLISHED
                    this.mPUBLISHED();


                    break;
                case 29 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:252: PUBLISHEDTIME
                    this.mPUBLISHEDTIME();


                    break;
                case 30 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:266: TAG
                    this.mTAG();


                    break;
                case 31 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:270: TOPIC
                    this.mTOPIC();


                    break;
                case 32 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:276: SEGMENT
                    this.mSEGMENT();


                    break;
                case 33 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:284: COUNTRY
                    this.mCOUNTRY();


                    break;
                case 34 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:292: REGION
                    this.mREGION();


                    break;
                case 35 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:299: CITY
                    this.mCITY();


                    break;
                case 36 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:304: RELEVANCY_VERIFIED
                    this.mRELEVANCY_VERIFIED();


                    break;
                case 37 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:323: ASSIGNEE
                    this.mASSIGNEE();


                    break;
                case 38 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:332: AUTHOR
                    this.mAUTHOR();


                    break;
                case 39 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:339: AUTHOR_ID
                    this.mAUTHOR_ID();


                    break;
                case 40 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:349: EXTRACT
                    this.mEXTRACT();


                    break;
                case 41 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:357: SENTIMENT_VERIFIED
                    this.mSENTIMENT_VERIFIED();


                    break;
                case 42 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:376: CROWD_VERIFIED
                    this.mCROWD_VERIFIED();


                    break;
                case 43 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:391: DISCARDED_BY
                    this.mDISCARDED_BY();


                    break;
                case 44 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:404: MENTION_ID
                    this.mMENTION_ID();


                    break;
                case 45 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:415: CROWD_ID
                    this.mCROWD_ID();


                    break;
                case 46 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:424: URI
                    this.mURI();


                    break;
                case 47 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:428: ENGAGEMENT
                    this.mENGAGEMENT();


                    break;
                case 48 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:439: REPLY_TO
                    this.mREPLY_TO();


                    break;
                case 49 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:448: REPLY_COUNT
                    this.mREPLY_COUNT();


                    break;
                case 50 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:460: GRAPH_REPLY_COUNT
                    this.mGRAPH_REPLY_COUNT();


                    break;
                case 51 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:478: RESHARE_OF
                    this.mRESHARE_OF();


                    break;
                case 52 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:489: RESHARE_COUNT
                    this.mRESHARE_COUNT();


                    break;
                case 53 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:503: GRAPH_RESHARE_COUNT
                    this.mGRAPH_RESHARE_COUNT();


                    break;
                case 54 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:523: REPLY_ORDER_BY_AUTHOR
                    this.mREPLY_ORDER_BY_AUTHOR();


                    break;
                case 55 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:545: OTS
                    this.mOTS();


                    break;
                case 56 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:549: AVE
                    this.mAVE();


                    break;
                case 57 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:553: REACH
                    this.mREACH();


                    break;
                case 58 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:559: STATUS_COUNT
                    this.mSTATUS_COUNT();


                    break;
                case 59 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:572: FOLLOWER_COUNT
                    this.mFOLLOWER_COUNT();


                    break;
                case 60 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:587: GRAPH_FOLLOWER_COUNT
                    this.mGRAPH_FOLLOWER_COUNT();


                    break;
                case 61 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:608: FOLLOWING_COUNT
                    this.mFOLLOWING_COUNT();


                    break;
                case 62 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:624: CROWD_REGION
                    this.mCROWD_REGION();


                    break;
                case 63 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:637: GENDER
                    this.mGENDER();


                    break;
                case 64 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:644: RESPONSE_TIME
                    this.mRESPONSE_TIME();


                    break;
                case 65 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:658: UNBIASED_SAMPLE
                    this.mUNBIASED_SAMPLE();


                    break;
                case 66 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:674: MENTIONED_PROFILE
                    this.mMENTIONED_PROFILE();


                    break;
                case 67 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:692: RACE
                    this.mRACE();


                    break;
                case 68 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:697: DIRECT_MESSAGE
                    this.mDIRECT_MESSAGE();


                    break;
                case 69 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:712: VISIBILITY
                    this.mVISIBILITY();


                    break;
                case 70 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:723: TICKET_ID
                    this.mTICKET_ID();


                    break;
                case 71 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:733: SOCIAL_NETWORK
                    this.mSOCIAL_NETWORK();


                    break;
                case 72 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:748: AUTHOR_HANDLE
                    this.mAUTHOR_HANDLE();


                    break;
                case 73 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:762: AUTHOR_HANDLE_ID
                    this.mAUTHOR_HANDLE_ID();


                    break;
                case 74 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:779: TO_NAME
                    this.mTO_NAME();


                    break;
                case 75 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:787: TO_HANDLE
                    this.mTO_HANDLE();


                    break;
                case 76 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:797: TO_HANDLE_ID
                    this.mTO_HANDLE_ID();


                    break;
                case 77 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:810: AUTHOR_BIO
                    this.mAUTHOR_BIO();


                    break;
                case 78 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:821: CONVERSATION_ID
                    this.mCONVERSATION_ID();


                    break;
                case 79 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:837: TOMBSTONED
                    this.mTOMBSTONED();


                    break;
                case 80 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:848: SCRUBBED
                    this.mSCRUBBED();


                    break;
                case 81 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:857: HAS_REPLY_FROM_PROFILE
                    this.mHAS_REPLY_FROM_PROFILE();


                    break;
                case 82 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:880: INTERACTION_ID
                    this.mINTERACTION_ID();


                    break;
                case 83 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:895: INTERACTION_RESPONSE_TIME
                    this.mINTERACTION_RESPONSE_TIME();


                    break;
                case 84 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:921: INTERACTION_FIRST_RESPONSE_TIME
                    this.mINTERACTION_FIRST_RESPONSE_TIME();


                    break;
                case 85 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:953: INTERACTION_FOLLOWUP_RESPONSE_TIME
                    this.mINTERACTION_FOLLOWUP_RESPONSE_TIME();


                    break;
                case 86 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:988: INTERACTION_WH_RESPONSE_TIME
                    this.mINTERACTION_WH_RESPONSE_TIME();


                    break;
                case 87 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1017: INTERACTION_WH_FIRST_RESPONSE_TIME
                    this.mINTERACTION_WH_FIRST_RESPONSE_TIME();


                    break;
                case 88 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1052: INTERACTION_WH_FOLLOWUP_RESPONSE_TIME
                    this.mINTERACTION_WH_FOLLOWUP_RESPONSE_TIME();


                    break;
                case 89 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1090: INTERACTION_HAS_RESPONSE
                    this.mINTERACTION_HAS_RESPONSE();


                    break;
                case 90 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1115: INTERACTION_FIRST_MENTION_PUBLISHED
                    this.mINTERACTION_FIRST_MENTION_PUBLISHED();


                    break;
                case 91 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1151: INTERACTION_LAST_MENTION_PUBLISHED
                    this.mINTERACTION_LAST_MENTION_PUBLISHED();


                    break;
                case 92 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1186: INTERACTION_FIRST_RESPONSE_PUBLISHED
                    this.mINTERACTION_FIRST_RESPONSE_PUBLISHED();


                    break;
                case 93 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1223: UCN
                    this.mUCN();


                    break;
                case 94 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1227: TWITTER_SCREEN_NAME
                    this.mTWITTER_SCREEN_NAME();


                    break;
                case 95 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1247: HANDLE_ID
                    this.mHANDLE_ID();


                    break;
                case 96 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1257: FACEBOOK_ID
                    this.mFACEBOOK_ID();


                    break;
                case 97 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1269: IS
                    this.mIS();


                    break;
                case 98 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1272: ISNT
                    this.mISNT();


                    break;
                case 99 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1277: ISORCHILDOF
                    this.mISORCHILDOF();


                    break;
                case 100 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1289: BEFORE
                    this.mBEFORE();


                    break;
                case 101 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1296: AFTER
                    this.mAFTER();


                    break;
                case 102 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1302: GREATERTHAN
                    this.mGREATERTHAN();


                    break;
                case 103 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1314: GREATERTHANEQUALS
                    this.mGREATERTHANEQUALS();


                    break;
                case 104 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1332: LESSTHAN
                    this.mLESSTHAN();


                    break;
                case 105 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1341: LESSTHANEQUALS
                    this.mLESSTHANEQUALS();


                    break;
                case 106 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1356: EQUALS
                    this.mEQUALS();


                    break;
                case 107 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1363: NOTEQUALS
                    this.mNOTEQUALS();


                    break;
                case 108 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1373: CONTAINS
                    this.mCONTAINS();


                    break;
                case 109 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1382: DOESNTCONTAIN
                    this.mDOESNTCONTAIN();


                    break;
                case 110 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1396: BEGINSWITH
                    this.mBEGINSWITH();


                    break;
                case 111 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1407: ENDSWITH
                    this.mENDSWITH();


                    break;
                case 112 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1416: MATCHES
                    this.mMATCHES();


                    break;
                case 113 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1424: ISNTNORCHILDOF
                    this.mISNTNORCHILDOF();


                    break;
                case 114 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1439: INTHELAST
                    this.mINTHELAST();


                    break;
                case 115 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1449: BEFORETHELAST
                    this.mBEFORETHELAST();


                    break;
                case 116 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1463: ON
                    this.mON();


                    break;
                case 117 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1466: IN
                    this.mIN();


                    break;
                case 118 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1469: NOTIN
                    this.mNOTIN();


                    break;
                case 119 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1475: DISTINCT
                    this.mDISTINCT();


                    break;
                case 120 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1484: SAMPLE
                    this.mSAMPLE();


                    break;
                case 121 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1491: PRESS
                    this.mPRESS();


                    break;
                case 122 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1497: ENTERPRISE
                    this.mENTERPRISE();


                    break;
                case 123 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1508: CONSUMER
                    this.mCONSUMER();


                    break;
                case 124 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1517: DIRECTORY
                    this.mDIRECTORY();


                    break;
                case 125 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1527: UNSORTED
                    this.mUNSORTED();


                    break;
                case 126 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1536: RELEVANT
                    this.mRELEVANT();


                    break;
                case 127 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1545: DUPLICATE
                    this.mDUPLICATE();


                    break;
                case 128 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1555: IRRELEVANT
                    this.mIRRELEVANT();


                    break;
                case 129 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1566: SPAM
                    this.mSPAM();


                    break;
                case 130 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1571: SORTED
                    this.mSORTED();


                    break;
                case 131 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1578: VERIFIED
                    this.mVERIFIED();


                    break;
                case 132 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1587: NONE
                    this.mNONE();


                    break;
                case 133 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1592: RESOLVED
                    this.mRESOLVED();


                    break;
                case 134 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1601: UNRESOLVED
                    this.mUNRESOLVED();


                    break;
                case 135 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1612: TODAY
                    this.mTODAY();


                    break;
                case 136 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1618: HOUR
                    this.mHOUR();


                    break;
                case 137 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1623: DAY
                    this.mDAY();


                    break;
                case 138 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1627: TWENTY_FOUR_HRS
                    this.mTWENTY_FOUR_HRS();


                    break;
                case 139 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1643: WEEK
                    this.mWEEK();


                    break;
                case 140 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1648: FORTNIGHT
                    this.mFORTNIGHT();


                    break;
                case 141 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1658: MONTH
                    this.mMONTH();


                    break;
                case 142 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1664: QUARTER
                    this.mQUARTER();


                    break;
                case 143 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1672: YEAR
                    this.mYEAR();


                    break;
                case 144 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1677: EPOCH
                    this.mEPOCH();


                    break;
                case 145 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1683: FALSE
                    this.mFALSE();


                    break;
                case 146 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1689: TRUE
                    this.mTRUE();


                    break;
                case 147 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1694: MALE
                    this.mMALE();


                    break;
                case 148 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1699: FEMALE
                    this.mFEMALE();


                    break;
                case 149 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1706: OTHER
                    this.mOTHER();


                    break;
                case 150 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1712: UNKNOWN
                    this.mUNKNOWN();


                    break;
                case 151 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1720: LONG_LITERAL
                    this.mLONG_LITERAL();


                    break;
                case 152 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1733: TAG_ID_LITERAL
                    this.mTAG_ID_LITERAL();


                    break;
                case 153 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1748: FLOAT_LITERAL
                    this.mFLOAT_LITERAL();


                    break;
                case 154 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1762: DATE_LITERAL
                    this.mDATE_LITERAL();


                    break;
                case 155 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1775: STRING_LITERAL
                    this.mSTRING_LITERAL();


                    break;
                case 156 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1790: ANNOTATION
                    this.mANNOTATION();


                    break;
                case 157 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1801: LPAREN
                    this.mLPAREN();


                    break;
                case 158 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1808: RPAREN
                    this.mRPAREN();


                    break;
                case 159 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1815: COMMA
                    this.mCOMMA();


                    break;
                case 160 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1821: DIVIDE
                    this.mDIVIDE();


                    break;
                case 161 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1828: LSQUARE
                    this.mLSQUARE();


                    break;
                case 162 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1836: RSQUARE
                    this.mRSQUARE();


                    break;
                case 163 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1844: ASC
                    this.mASC();


                    break;
                case 164 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1848: DESC
                    this.mDESC();


                    break;
                case 165 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1853: COUNT
                    this.mCOUNT();


                    break;
                case 166 :
                    // /Users/connie/Development/BrandsEye/mentionq/build/javascript-antlr/MentionQLexer.g:1:1859: UNQUOTED_STRING_LITERAL
                    this.mUNQUOTED_STRING_LITERAL();


                    break;

            }

        }

    }, true); // important to pass true to overwrite default implementations

    org.antlr.lang.augmentObject(MentionQLexer, {
        DFA18_eotS:
            "\u0003\uffff\u0012\u002b\u0001\u006f\u0001\u0071\u0002\uffff\u0001"+
            "\u002b\u0001\u0074\u0003\u002b\u0001\uffff\u0001\u0074\u0002\u002b\u000a"+
            "\uffff\u0001\u007c\u0001\u002b\u0001\u007f\u0034\u002b\u0001\u00cf\u0001"+
            "\u00d0\u0001\u00d2\u0005\u002b\u0001\u00da\u0002\u002b\u0004\uffff\u0001"+
            "\u002b\u0001\u0074\u0002\uffff\u0003\u002b\u0004\uffff\u0001\u00e6\u0001"+
            "\u002b\u0001\uffff\u0001\u00e8\u0004\u002b\u0001\u00ed\u0001\u00ee\u002b"+
            "\u002b\u0001\u011e\u000b\u002b\u0001\u012a\u0004\u002b\u0001\u012f\u0009"+
            "\u002b\u0001\u013a\u0001\u002b\u0002\uffff\u0001\u002b\u0001\uffff\u0007"+
            "\u002b\u0001\uffff\u0005\u002b\u0001\uffff\u0003\u002b\u0003\uffff\u0001"+
            "\u002b\u0001\uffff\u0004\u002b\u0002\uffff\u0008\u002b\u0001\u015c\u0005"+
            "\u002b\u0001\u0162\u0005\u002b\u0001\u0168\u0006\u002b\u0001\u0170\u0003"+
            "\u002b\u0001\u0174\u0007\u002b\u0001\u017c\u0007\u002b\u0001\uffff\u0006"+
            "\u002b\u0001\u018a\u0001\u018b\u0003\u002b\u0001\uffff\u0004\u002b\u0001"+
            "\uffff\u000a\u002b\u0001\uffff\u0001\u019e\u0002\u002b\u0001\u01a1\u0008"+
            "\u002b\u0001\u01ab\u0001\u002b\u0001\u01ad\u0001\u01ae\u0001\u002b\u0001"+
            "\u01b0\u0002\uffff\u0001\u01b3\u0004\u002b\u0001\u01b8\u0006\u002b\u0001"+
            "\u01c1\u0001\uffff\u0001\u01c2\u0004\u002b\u0001\uffff\u0005\u002b\u0001"+
            "\uffff\u0006\u002b\u0001\u01d4\u0001\uffff\u0001\u01d6\u0002\u002b\u0001"+
            "\uffff\u0001\u01d9\u0001\u002b\u0001\u01db\u0004\u002b\u0001\uffff\u0004"+
            "\u002b\u0001\u01e4\u0001\u01e5\u0001\u002b\u0001\u01e7\u0003\u002b\u0001"+
            "\u01eb\u0001\u002b\u0002\uffff\u000c\u002b\u0001\u01f9\u0005\u002b\u0001"+
            "\uffff\u0002\u002b\u0001\uffff\u0009\u002b\u0001\uffff\u0001\u020b\u0002"+
            "\uffff\u0001\u002b\u0004\uffff\u0001\u020f\u0001\u0210\u0002\u002b\u0001"+
            "\uffff\u0001\u002b\u0001\u0219\u0006\u002b\u0002\uffff\u0001\u0220\u0005"+
            "\u002b\u0001\u0227\u0001\u002b\u0001\u0229\u0008\u002b\u0001\uffff\u0001"+
            "\u002b\u0001\uffff\u0002\u002b\u0001\uffff\u0001\u002b\u0001\uffff\u0001"+
            "\u0236\u0003\u002b\u0001\u023c\u0003\u002b\u0002\uffff\u0001\u002b\u0001"+
            "\uffff\u0001\u0242\u0002\u002b\u0001\uffff\u0001\u002b\u0001\u0246\u000b"+
            "\u002b\u0001\uffff\u000c\u002b\u0001\u025f\u0004\u002b\u0001\uffff\u0001"+
            "\u002b\u0004\uffff\u0008\u002b\u0001\uffff\u0001\u0270\u0005\u002b\u0001"+
            "\uffff\u0003\u002b\u0001\u027a\u0002\u002b\u0001\uffff\u0001\u002b\u0001"+
            "\uffff\u0002\u002b\u0001\u0280\u0001\u002b\u0001\u0282\u0003\u002b\u0001"+
            "\u0286\u0001\u002b\u0001\u0288\u0001\u0289\u0001\uffff\u0005\u002b\u0001"+
            "\uffff\u0005\u002b\u0001\uffff\u0003\u002b\u0001\uffff\u0002\u002b\u0001"+
            "\u0299\u0003\u002b\u0001\u029d\u0001\u029e\u0010\u002b\u0001\uffff\u0004"+
            "\u002b\u0001\u02b4\u0002\uffff\u0002\u002b\u0001\u02b9\u0003\u002b\u0001"+
            "\u02bd\u0001\u002b\u0001\u02bf\u0001\uffff\u0005\u002b\u0001\u02c5\u0003"+
            "\u002b\u0001\uffff\u0002\u002b\u0001\u02cb\u0002\u002b\u0001\uffff\u0001"+
            "\u002b\u0001\uffff\u0001\u02cf\u0001\u002b\u0001\u02d1\u0001\uffff\u0001"+
            "\u002b\u0002\uffff\u0002\u002b\u0001\u02d5\u0001\u02d6\u0005\u002b\u0001"+
            "\u02dc\u0001\u02dd\u0002\u002b\u0001\u02e1\u0001\u0286\u0001\uffff\u0001"+
            "\u002b\u0001\u02e3\u0001\u002b\u0002\uffff\u0001\u002b\u0001\u02e6\u0002"+
            "\u002b\u0001\u02e9\u000d\u002b\u0001\u02f7\u0001\u002b\u0001\u02f9\u0003"+
            "\uffff\u0002\u002b\u0001\uffff\u0001\u002b\u0001\u02ff\u0001\u0300\u0001"+
            "\uffff\u0001\u0301\u0001\uffff\u0002\u002b\u0001\u0305\u0002\u002b\u0001"+
            "\uffff\u0002\u002b\u0001\u030a\u0002\u002b\u0001\uffff\u0003\u002b\u0001"+
            "\uffff\u0001\u002b\u0001\uffff\u0003\u002b\u0002\uffff\u0001\u0315\u0002"+
            "\u002b\u0001\u0319\u0001\u002b\u0002\uffff\u0003\u002b\u0001\uffff\u0001"+
            "\u002b\u0001\uffff\u0002\u002b\u0001\uffff\u0002\u002b\u0001\uffff\u0001"+
            "\u002b\u0001\u0324\u0001\u002b\u0001\u0326\u0001\u002b\u0001\u0328\u0007"+
            "\u002b\u0001\uffff\u0001\u002b\u0003\uffff\u0001\u0333\u0002\u002b\u0003"+
            "\uffff\u0001\u002b\u0001\u0337\u0001\u002b\u0001\uffff\u0003\u002b\u0001"+
            "\u033c\u0001\uffff\u000a\u002b\u0001\uffff\u0003\u002b\u0001\uffff\u0001"+
            "\u034a\u0001\u034b\u0001\u034c\u0002\u002b\u0001\u034f\u0001\u0350\u0001"+
            "\u0351\u0002\u002b\u0001\uffff\u0001\u002b\u0001\uffff\u0001\u002b\u0001"+
            "\uffff\u0002\u002b\u0001\u0358\u0003\u002b\u0001\u035c\u0001\u002b\u0003"+
            "\uffff\u0003\u002b\u0001\uffff\u0004\u002b\u0001\uffff\u0001\u002b\u0001"+
            "\u0368\u0001\u002b\u0001\u036a\u0001\u002b\u0001\u036c\u0002\u002b\u0001"+
            "\u036f\u0004\u002b\u0003\uffff\u0002\u002b\u0003\uffff\u0001\u0376\u0004"+
            "\u002b\u0001\u0380\u0001\uffff\u0003\u002b\u0001\uffff\u0001\u002b\u0002"+
            "\uffff\u0001\u002b\u0001\u038a\u0002\u002b\u0001\u038e\u0001\u038f\u0002"+
            "\u002b\u0001\uffff\u0001\u002b\u0001\uffff\u0001\u002b\u0001\uffff\u0002"+
            "\u002b\u0001\uffff\u0006\u002b\u0001\uffff\u0009\u002b\u0001\uffff\u0004"+
            "\u002b\u0004\uffff\u0001\u002b\u0001\uffff\u0003\u002b\u0002\uffff\u0001"+
            "\u03b1\u0001\u002b\u0001\u03b3\u0001\u03b4\u0002\u002b\u0001\u03b7\u0001"+
            "\u03b8\u0001\u03b9\u0003\u002b\u0001\u03bd\u0001\u03be\u0001\u03bf\u000b"+
            "\u002b\u0003\uffff\u0001\u03ce\u0001\u03cf\u0002\u002b\u0001\uffff\u0001"+
            "\u002b\u0002\uffff\u0001\u03d3\u0001\u002b\u0003\uffff\u0001\u03d5\u0001"+
            "\u002b\u0001\u03d7\u0003\uffff\u0007\u002b\u0001\u03e0\u0004\u002b\u0004"+
            "\uffff\u0003\u002b\u0001\uffff\u0001\u002b\u0001\uffff\u0001\u002b\u0001"+
            "\uffff\u0008\u002b\u0001\uffff\u0001\u03f4\u0003\u002b\u0002\uffff\u0003"+
            "\u002b\u0001\u03fd\u0009\u002b\u0001\uffff\u0003\u002b\u0002\uffff\u0001"+
            "\u040d\u0001\u002b\u0001\u040f\u0001\uffff\u0001\u0410\u0009\u002b\u0001"+
            "\u041a\u0002\u002b\u0003\uffff\u0001\u041f\u0002\uffff\u0009\u002b\u0001"+
            "\uffff\u0001\u0429\u0001\u002b\u0003\uffff\u0009\u002b\u0001\uffff\u0001"+
            "\u0436\u0002\uffff\u0009\u002b\u0003\uffff\u0010\u002b\u0001\u0452\u0001"+
            "\u002b\u0001\u0454\u0006\u002b\u0001\uffff\u0001\u002b\u0001\uffff\u000b"+
            "\u002b\u0001\u0468\u0007\u002b\u0001\uffff\u000a\u002b\u0001\u047a\u0006"+
            "\u002b\u0001\uffff\u0009\u002b\u0001\u048a\u0004\u002b\u0001\u048f\u0001"+
            "\uffff\u0001\u002b\u0001\u0491\u0001\u002b\u0001\u0493\u0001\uffff\u0001"+
            "\u002b\u0001\uffff\u0001\u0495\u0001\uffff\u0001\u0496\u0002\uffff",
        DFA18_eofS:
            "\u0497\uffff",
        DFA18_minS:
            "\u0001\u0009\u0002\uffff\u0001\u004e\u0001\u0043\u0001\u0041\u0001"+
            "\u0045\u0001\u0041\u0001\u0049\u0005\u0041\u0001\u0043\u0001\u004e\u0001"+
            "\u0041\u0001\u0044\u0001\u0045\u0001\u0030\u0001\u0041\u0002\u003d\u0002"+
            "\uffff\u0001\u0030\u0001\u002e\u0001\u0045\u0001\u0055\u0001\u0045\u0001"+
            "\u0030\u0001\u002e\u0001\u0045\u0001\u004f\u0002\u0000\u0008\uffff\u0001"+
            "\u0030\u0001\u0048\u0001\u0030\u0001\u0044\u0002\u0054\u0001\u0045\u0001"+
            "\u0043\u0001\u0045\u0001\u0054\u0001\u0041\u0001\u0043\u0001\u0041\u0001"+
            "\u0046\u0001\u0047\u0001\u0054\u0001\u0041\u0001\u0043\u0001\u0052\u0001"+
            "\u004d\u0001\u0041\u0001\u0045\u0001\u004e\u0001\u0054\u0001\u0044\u0001"+
            "\u004c\u0001\u004e\u0001\u0045\u0001\u0052\u0001\u0043\u0001\u0047\u0001"+
            "\u0042\u0001\u0045\u0001\u004c\u0002\u0043\u0001\u0047\u0001\u0044\u0001"+
            "\u0049\u0001\u0055\u0002\u004e\u0001\u0043\u0001\u0044\u0001\u0049\u0001"+
            "\u0042\u0001\u004e\u0001\u0054\u0001\u0044\u0001\u004f\u0001\u0052\u0001"+
            "\u0045\u0001\u0050\u0001\u0059\u0001\u0053\u0003\u0030\u0001\u0052\u0001"+
            "\u0041\u0001\u004e\u0001\u0053\u0001\u0052\u0001\u0030\u0001\u004e\u0001"+
            "\u0055\u0004\uffff\u0001\u004e\u0001\u002e\u0002\uffff\u0001\u0045\u0002"+
            "\u0041\u0001\u0000\u0001\uffff\u0001\u0000\u0001\uffff\u0001\u0030\u0001"+
            "\u0045\u0001\uffff\u0001\u0030\u0001\u0049\u0001\u0048\u0001\u0058\u0001"+
            "\u0049\u0002\u0030\u0002\u0045\u0001\u0049\u0001\u004c\u0001\u0048\u0001"+
            "\u0043\u0001\u0045\u0001\u004e\u0001\u004f\u0001\u0049\u0001\u0054\u0001"+
            "\u004d\u0001\u0045\u0001\u0054\u0001\u0049\u0001\u0054\u0001\u0055\u0001"+
            "\u0050\u0001\u004d\u0001\u0044\u0001\u0057\u0001\u0053\u0001\u004e\u0001"+
            "\u0059\u0001\u0049\u0001\u0054\u0001\u0043\u0001\u0045\u0001\u0054\u0001"+
            "\u0043\u0001\u0053\u0001\u0041\u0001\u004b\u0001\u0045\u0001\u004c\u0001"+
            "\u0044\u0001\u0041\u0001\u004c\u0001\u0054\u0001\u0045\u0001\u0053\u0001"+
            "\u004c\u0001\u004b\u0001\u0030\u0001\u0049\u0002\u0041\u0001\u0042\u0001"+
            "\u0041\u0001\u0054\u0001\u0045\u0001\u004b\u0001\u0047\u0002\u0041\u0001"+
            "\u0030\u0001\u0049\u0001\u004f\u0001\u0045\u0001\u004e\u0001\u0030\u0001"+
            "\u0052\u0001\u0041\u0001\u0053\u0001\u0045\u0002\u0043\u0001\u0045\u0001"+
            "\u0053\u0001\u004c\u0001\u0030\u0001\u0043\u0002\uffff\u0001\u0045\u0001"+
            "\uffff\u0001\u0054\u0001\u0052\u0001\u0045\u0001\u0050\u0001\u0044\u0002"+
            "\u0049\u0001\uffff\u0001\u0052\u0001\u0044\u0001\u0052\u0001\u0049\u0001"+
            "\u0045\u0001\uffff\u0001\u004b\u0002\u0052\u0002\u0000\u0001\uffff\u0001"+
            "\u0052\u0001\uffff\u0002\u004f\u0001\u0041\u0001\u0047\u0002\uffff\u0001"+
            "\u0052\u0001\u0056\u0001\u004f\u0001\u0059\u0001\u0041\u0001\u004f\u0001"+
            "\u004c\u0001\u0048\u0001\u0030\u0001\u0044\u0001\u0052\u0001\u004e\u0001"+
            "\u0049\u0001\u0045\u0001\u0030\u0001\u0055\u0001\u0041\u0001\u0045\u0001"+
            "\u0042\u0001\u004c\u0001\u0030\u0001\u0049\u0001\u0044\u0001\u0041\u0001"+
            "\u0045\u0001\u0055\u0001\u0054\u0001\u0030\u0001\u0041\u0001\u0049\u0001"+
            "\u0048\u0001\u0030\u0001\u0048\u0001\u0045\u0002\u0053\u0001\u0045\u0001"+
            "\u0052\u0001\u0049\u0001\u0030\u0001\u004c\u0001\u004f\u0001\u004e\u0001"+
            "\u0042\u0003\u0045\u0001\uffff\u0001\u0043\u0001\u004d\u0001\u004e\u0001"+
            "\u0053\u0001\u0059\u0001\u0054\u0002\u0030\u0001\u0055\u0002\u0054\u0001"+
            "\uffff\u0001\u0041\u0001\u0052\u0001\u0053\u0001\u004f\u0001\uffff\u0001"+
            "\u0041\u0001\u0047\u0001\u0057\u0001\u0052\u0001\u0048\u0001\u0041\u0001"+
            "\u0049\u0001\u0043\u0001\u004e\u0001\u0049\u0001\uffff\u0001\u0030\u0001"+
            "\u0052\u0001\u0045\u0001\u0030\u0001\u0043\u0001\u004c\u0001\u0048\u0001"+
            "\u0045\u0001\u0042\u0001\u0046\u0001\u0045\u0001\u004c\u0001\u0030\u0001"+
            "\u004e\u0002\u0030\u0001\u0054\u0001\u0030\u0002\u0000\u0001\u0030\u0001"+
            "\u004e\u0002\u0052\u0001\u004e\u0001\u0030\u0001\u0041\u0001\u004e\u0001"+
            "\u0043\u0001\u0052\u0001\u004e\u0001\u0056\u0001\u0030\u0001\uffff\u0001"+
            "\u0030\u0001\u0045\u0001\u0053\u0001\u004d\u0001\u004e\u0001\uffff\u0001"+
            "\u0053\u0001\u004c\u0001\u0044\u0001\u0042\u0001\u0045\u0001\uffff\u0001"+
            "\u0042\u0001\u0049\u0001\u004e\u0001\u0049\u0001\u0052\u0001\u004d\u0001"+
            "\u0030\u0001\uffff\u0001\u0030\u0001\u004f\u0001\u0045\u0001\uffff\u0001"+
            "\u0030\u0001\u0053\u0001\u0030\u0001\u0045\u0001\u0044\u0001\u0041\u0001"+
            "\u0053\u0001\uffff\u0001\u0045\u0001\u0057\u0001\u0049\u0001\u004f\u0002"+
            "\u0030\u0001\u0054\u0001\u0030\u0001\u0045\u0001\u0044\u0001\u0054\u0001"+
            "\u0030\u0001\u0045\u0002\uffff\u0001\u0044\u0001\u0041\u0001\u0049\u0001"+
            "\u0045\u0001\u0053\u0001\u0054\u0001\u004f\u0001\u0057\u0001\u0043\u0001"+
            "\u0045\u0001\u0049\u0001\u0050\u0001\u0030\u0001\u0052\u0001\u004e\u0002"+
            "\u0054\u0001\u0043\u0001\uffff\u0001\u0041\u0001\u004c\u0001\uffff\u0001"+
            "\u004f\u0001\u0048\u0001\u0045\u0001\u0046\u0001\u0052\u0002\u0049\u0001"+
            "\u0050\u0001\u0045\u0001\uffff\u0001\u0030\u0002\uffff\u0001\u0045\u0001"+
            "\uffff\u0002\u0000\u0001\uffff\u0002\u0030\u0001\u0041\u0001\u0045\u0001"+
            "\uffff\u0001\u004e\u0001\u0030\u0002\u004f\u0001\u0052\u0001\u0045\u0001"+
            "\u0053\u0001\u0045\u0002\uffff\u0001\u0030\u0001\u0057\u0001\u0045\u0001"+
            "\u0054\u0001\u0043\u0001\u004e\u0001\u0030\u0001\u0045\u0001\u0030\u0001"+
            "\u0049\u0001\u0045\u0001\u0044\u0001\u0045\u0001\u0054\u0001\u004e\u0001"+
            "\u0053\u0001\u0045\u0001\uffff\u0001\u0059\u0001\uffff\u0001\u004e\u0001"+
            "\u0053\u0001\uffff\u0001\u0053\u0001\uffff\u0001\u0030\u0001\u0055\u0001"+
            "\u004e\u0001\u0048\u0001\u0030\u0001\u0045\u0001\u0047\u0001\u004f\u0002"+
            "\uffff\u0001\u0049\u0001\uffff\u0001\u0030\u0001\u004c\u0001\u004f\u0001"+
            "\uffff\u0001\u0052\u0001\u0030\u0001\u0047\u0001\u004f\u0001\u0044\u0002"+
            "\u0045\u0001\u004c\u0001\u004e\u0001\u0054\u0001\u004d\u0001\u0054\u0001"+
            "\u0052\u0001\uffff\u0001\u0044\u0001\u0043\u0001\u004d\u0001\u0043\u0001"+
            "\u0041\u0001\u0043\u0001\u0041\u0001\u0052\u0001\u0049\u0001\u0056\u0001"+
            "\u0045\u0001\u004f\u0001\u0030\u0001\u004c\u0001\u0045\u0001\u004c\u0001"+
            "\u0049\u0001\uffff\u0001\u0052\u0002\u0000\u0002\uffff\u0001\u0041\u0001"+
            "\u004f\u0001\u0044\u0001\u0041\u0001\u0049\u0001\u004e\u0001\u0045\u0001"+
            "\u0043\u0001\uffff\u0001\u0030\u0001\u0055\u0001\u0044\u0001\u0043\u0001"+
            "\u0045\u0001\u0044\u0001\uffff\u0001\u0048\u0001\u0049\u0001\u004e\u0001"+
            "\u0030\u0001\u004f\u0001\u0045\u0001\uffff\u0001\u0044\u0001\uffff\u0001"+
            "\u004c\u0001\u0052\u0001\u0030\u0001\u0047\u0001\u0030\u0001\u0053\u0001"+
            "\u0041\u0001\u0052\u0001\u0030\u0001\u0045\u0002\u0030\u0001\uffff\u0001"+
            "\u004f\u0001\u0041\u0001\u0050\u0001\u004b\u0001\u0045\u0001\uffff\u0001"+
            "\u0052\u0001\u004e\u0001\u0048\u0001\u004b\u0001\u0044\u0001\uffff\u0001"+
            "\u0045\u0001\u004e\u0001\u0053\u0001\uffff\u0001\u0045\u0001\u004e\u0001"+
            "\u0030\u0002\u0044\u0001\u0056\u0002\u0030\u0001\u0045\u0001\u0048\u0001"+
            "\u0049\u0001\u0045\u0001\u0054\u0001\u0045\u0001\u0052\u0001\u004f\u0002"+
            "\u0054\u0001\u0053\u0001\u0043\u0001\u004c\u0001\u0041\u0001\u0050\u0001"+
            "\u004c\u0001\uffff\u0001\u0049\u0001\u0044\u0001\u0059\u0001\u0044\u0001"+
            "\u0030\u0002\u0000\u0001\u004d\u0001\u0043\u0001\u0030\u0001\u004e\u0001"+
            "\u004f\u0001\u004b\u0001\u0030\u0001\u0059\u0001\u0030\u0001\uffff\u0001"+
            "\u004e\u0001\u0045\u0001\u0046\u0001\u004f\u0001\u0054\u0001\u0030\u0001"+
            "\u0045\u0002\u0054\u0001\uffff\u0001\u0055\u0001\u0054\u0001\u0030\u0002"+
            "\u0049\u0001\uffff\u0001\u0049\u0001\uffff\u0001\u0030\u0001\u0054\u0001"+
            "\u0030\u0001\uffff\u0001\u0044\u0002\uffff\u0001\u0055\u0001\u0054\u0002"+
            "\u0030\u0001\u0044\u0001\u0043\u0001\u0047\u0001\u0054\u0001\u0049\u0002"+
            "\u0030\u0001\u0045\u0001\u0043\u0002\u0030\u0001\uffff\u0001\u0053\u0001"+
            "\u0030\u0001\u0045\u0002\uffff\u0001\u004e\u0001\u0030\u0001\u0053\u0001"+
            "\u0044\u0001\u0030\u0001\u0053\u0001\u0059\u0001\u004e\u0001\u0045\u0001"+
            "\u0049\u0001\u0054\u0001\u0048\u0001\u0044\u0001\u004e\u0001\u004c\u0001"+
            "\u0048\u0001\u004c\u0001\u0054\u0001\u0030\u0001\u0046\u0001\u0030\u0001"+
            "\uffff\u0002\u0000\u0001\u0045\u0001\u0041\u0001\uffff\u0001\u0044\u0002"+
            "\u0030\u0001\uffff\u0001\u0030\u0001\uffff\u0001\u0054\u0001\u0052\u0001"+
            "\u0030\u0001\u0055\u0001\u0049\u0001\uffff\u0001\u004c\u0001\u0048\u0001"+
            "\u0030\u0001\u004e\u0001\u0057\u0001\uffff\u0001\u0054\u0001\u0046\u0001"+
            "\u004f\u0001\uffff\u0001\u0049\u0001\uffff\u0001\u0050\u0001\u004e\u0001"+
            "\u0043\u0002\uffff\u0001\u0030\u0001\u004f\u0001\u0043\u0001\u0030\u0001"+
            "\u0044\u0002\uffff\u0002\u0044\u0001\u0052\u0001\uffff\u0001\u0041\u0001"+
            "\uffff\u0001\u0044\u0001\u0054\u0001\uffff\u0001\u0045\u0001\u0042\u0001"+
            "\uffff\u0001\u0053\u0001\u0030\u0001\u0054\u0001\u0030\u0001\u004f\u0001"+
            "\u0030\u0001\u0049\u0001\u004f\u0001\u0054\u0001\u0059\u0001\u0041\u0001"+
            "\u004f\u0001\u0059\u0001\uffff\u0001\u0052\u0001\uffff\u0002\u0000\u0001"+
            "\u0030\u0001\u0054\u0001\u004c\u0003\uffff\u0001\u0045\u0001\u0030\u0001"+
            "\u0042\u0001\uffff\u0001\u004e\u0001\u004d\u0001\u0041\u0001\u0030\u0001"+
            "\uffff\u0001\u0045\u0001\u0054\u0001\u004f\u0001\u0059\u0001\u0049\u0001"+
            "\u004e\u0001\u004f\u0001\u0052\u0001\u0054\u0001\u0048\u0001\uffff\u0001"+
            "\u0049\u0001\u0055\u0001\u004f\u0001\uffff\u0003\u0030\u0001\u0045\u0001"+
            "\u004d\u0003\u0030\u0001\u0059\u0001\u0041\u0001\uffff\u0001\u0041\u0001"+
            "\uffff\u0001\u004e\u0001\uffff\u0001\u004c\u0001\u0046\u0001\u0030\u0001"+
            "\u0043\u0001\u0052\u0001\u0057\u0001\u0030\u0001\u004f\u0002\u0000\u0001"+
            "\uffff\u0001\u0049\u0001\u0045\u0001\u0052\u0001\uffff\u0001\u0059\u0001"+
            "\u0054\u0001\u0045\u0001\u0053\u0001\uffff\u0001\u0052\u0001\u0030\u0001"+
            "\u0052\u0001\u0030\u0001\u0045\u0001\u0030\u0001\u004e\u0001\u004f\u0001"+
            "\u0030\u0001\u0045\u0001\u004d\u0001\u004e\u0001\u0055\u0003\uffff\u0001"+
            "\u0045\u0001\u0050\u0003\uffff\u0001\u0030\u0001\u0047\u0001\u0049\u0001"+
            "\u0046\u0001\u0044\u0001\u0030\u0001\uffff\u0001\u004f\u0002\u0045\u0001"+
            "\uffff\u0001\u004d\u0002\u0000\u0001\u004f\u0001\u0030\u0001\u0049\u0001"+
            "\u0041\u0002\u0030\u0001\u0054\u0001\u0049\u0001\uffff\u0001\u004b\u0001"+
            "\uffff\u0001\u0044\u0001\uffff\u0001\u0049\u0001\u0046\u0001\uffff\u0001"+
            "\u0053\u0001\u0045\u0001\u0054\u0002\u004e\u0001\u004c\u0001\uffff\u0001"+
            "\u0045\u0001\u004e\u0001\u0044\u0001\u0045\u0001\u0049\u0001\u0048\u0002"+
            "\u0041\u0001\u004f\u0001\uffff\u0001\u0055\u0001\u0043\u0001\u0052\u0001"+
            "\u0050\u0001\u0000\u0001\uffff\u0001\u0000\u0001\uffff\u0001\u004e\u0001"+
            "\uffff\u0001\u0044\u0001\u0046\u0001\u0055\u0002\uffff\u0001\u0030\u0001"+
            "\u0046\u0002\u0030\u0001\u0044\u0001\u0049\u0003\u0030\u0001\u0054\u0001"+
            "\u004e\u0001\u0045\u0003\u0030\u0001\u0053\u0001\u0052\u0001\u004c\u0001"+
            "\u0046\u0002\u0053\u0001\u0046\u0001\u004e\u0001\u004f\u0001\u0043\u0001"+
            "\u0052\u0001\u0000\u0001\uffff\u0001\u0000\u0002\u0030\u0001\u0049\u0001"+
            "\u0054\u0001\uffff\u0001\u0049\u0002\uffff\u0001\u0030\u0001\u004c\u0003"+
            "\uffff\u0001\u0030\u0001\u0041\u0001\u0030\u0003\uffff\u0001\u0050\u0001"+
            "\u0053\u0001\u004c\u0001\u0045\u0001\u0049\u0001\u0052\u0001\u0054\u0001"+
            "\u0030\u0001\u0054\u0001\u0055\u0002\u004f\u0002\u0000\u0002\uffff\u0001"+
            "\u0045\u0001\u0048\u0001\u0045\u0001\uffff\u0001\u0045\u0001\uffff\u0001"+
            "\u004d\u0001\uffff\u0001\u004f\u0001\u0054\u0001\u004f\u0001\u0053\u0001"+
            "\u0052\u0001\u004c\u0001\u0045\u0001\u004d\u0001\uffff\u0001\u0030\u0001"+
            "\u004e\u0001\u0055\u0001\u0046\u0002\u0000\u0001\u0044\u0001\u004f\u0001"+
            "\u0044\u0001\u0030\u0001\u0045\u0001\u004e\u0001\u004d\u0001\u0057\u0001"+
            "\u0050\u0001\u0053\u0001\u004c\u0001\u0053\u0001\u0045\u0001\uffff\u0001"+
            "\u0054\u0001\u004e\u0001\u0049\u0002\u0000\u0001\u0030\u0001\u0052\u0001"+
            "\u0030\u0001\uffff\u0001\u0030\u0001\u0053\u0002\u0045\u0001\u0055\u0001"+
            "\u004f\u0001\u0054\u0001\u004f\u0001\u0050\u0001\u004e\u0001\u0030\u0001"+
            "\u0054\u0001\u004c\u0002\u0000\u0001\uffff\u0001\u0030\u0002\uffff\u0001"+
            "\u0045\u0001\u0053\u0001\u004e\u0001\u0050\u0001\u004e\u0001\u0052\u0001"+
            "\u0057\u0001\u004f\u0001\u0054\u0001\uffff\u0001\u0030\u0001\u0045\u0002"+
            "\u0000\u0001\uffff\u0001\u0054\u0001\u0050\u0001\u0054\u0001\u0052\u0001"+
            "\u0053\u0001\u0045\u0001\u0055\u0001\u004e\u0001\u0049\u0001\uffff\u0001"+
            "\u0030\u0002\u0000\u0001\u0049\u0001\u004f\u0001\u0049\u0002\u0045\u0001"+
            "\u0053\u0001\u0050\u0001\u0053\u0001\u004f\u0001\uffff\u0002\u0000\u0001"+
            "\u004d\u0001\u004e\u0001\u004f\u0001\u0053\u0001\u0054\u0001\u0050\u0001"+
            "\u0052\u0001\u0045\u0001\u004e\u0001\u0045\u0001\u0053\u0001\u004e\u0001"+
            "\u0050\u0001\u0049\u0001\u004f\u0001\u0045\u0001\u0030\u0001\u0050\u0001"+
            "\u0030\u0001\u0045\u0001\u0050\u0001\u004f\u0001\u004d\u0001\u004e\u0001"+
            "\u0053\u0001\uffff\u0001\u0055\u0001\uffff\u0001\u0050\u0001\u0055\u0001"+
            "\u004e\u0001\u0045\u0001\u0053\u0001\u0050\u0001\u0042\u0001\u0049\u0001"+
            "\u0055\u0001\u0042\u0001\u0053\u0001\u0030\u0001\u0045\u0001\u004f\u0001"+
            "\u004c\u0001\u004d\u0001\u0042\u0001\u004c\u0001\u0045\u0001\uffff\u0001"+
            "\u0054\u0001\u004e\u0001\u0049\u0001\u0045\u0001\u004c\u0001\u0049\u0001"+
            "\u0054\u0001\u0049\u0002\u0053\u0001\u0030\u0001\u0049\u0001\u0053\u0001"+
            "\u0049\u0001\u004d\u0001\u0045\u0001\u0048\u0001\uffff\u0001\u0053\u0001"+
            "\u0048\u0001\u004d\u0001\u0045\u0001\u0054\u0001\u0045\u0001\u0048\u0002"+
            "\u0045\u0001\u0030\u0001\u0049\u0001\u0044\u0001\u0045\u0001\u0044\u0001"+
            "\u0030\u0001\uffff\u0001\u004d\u0001\u0030\u0001\u0044\u0001\u0030\u0001"+
            "\uffff\u0001\u0045\u0001\uffff\u0001\u0030\u0001\uffff\u0001\u0030\u0002"+
            "\uffff",
        DFA18_maxS:
            "\u0001\u007a\u0002\uffff\u0001\u0074\u0001\u0076\u0001\u0065\u0001"+
            "\u0072\u0001\u0074\u0001\u0072\u0001\u006f\u0001\u0075\u0001\u006f\u0001"+
            "\u0077\u0001\u006f\u0001\u0072\u0001\u0078\u0001\u0075\u0001\u0073\u0001"+
            "\u0072\u0001\u0069\u0001\u006f\u0002\u003d\u0002\uffff\u0001\u006f\u0001"+
            "\u0039\u0001\u0065\u0001\u0075\u0001\u0065\u0002\u0039\u0001\u0069\u0001"+
            "\u006f\u0002\uffff\u0008\uffff\u0001\u007a\u0001\u0073\u0001\u007a\u0001"+
            "\u0064\u0002\u0074\u0001\u0065\u0001\u0073\u0001\u0065\u0001\u0074\u0001"+
            "\u0073\u0001\u0063\u0001\u0061\u0001\u0067\u0001\u006e\u0001\u0074\u0001"+
            "\u0061\u0002\u0072\u0001\u006d\u0001\u0061\u0001\u006f\u0001\u0075\u0001"+
            "\u0074\u0001\u006e\u0001\u0074\u0001\u006e\u0001\u006f\u0001\u0072\u0001"+
            "\u0063\u0001\u0067\u0001\u0062\u0001\u006d\u0001\u0072\u0001\u006c\u0001"+
            "\u0074\u0001\u0067\u0001\u0070\u0001\u0069\u0001\u0075\u0002\u006e\u0001"+
            "\u0063\u0001\u0064\u0001\u0069\u0001\u0073\u0001\u006e\u0002\u0074\u0001"+
            "\u006f\u0001\u0073\u0001\u0065\u0001\u0070\u0001\u0079\u0001\u0073\u0003"+
            "\u007a\u0001\u0072\u0001\u0061\u0001\u006e\u0001\u0073\u0001\u0072\u0001"+
            "\u007a\u0001\u0073\u0001\u0075\u0004\uffff\u0001\u0074\u0001\u0068\u0002"+
            "\uffff\u0001\u0065\u0002\u0061\u0001\uffff\u0001\uffff\u0001\uffff\u0001"+
            "\uffff\u0001\u007a\u0001\u0065\u0001\uffff\u0001\u007a\u0001\u0069\u0001"+
            "\u0068\u0001\u0078\u0001\u0069\u0002\u007a\u0002\u0065\u0001\u0069\u0001"+
            "\u006c\u0001\u0070\u0001\u0063\u0001\u0065\u0001\u006e\u0001\u006f\u0001"+
            "\u0069\u0001\u0074\u0001\u006d\u0001\u0065\u0001\u0074\u0001\u0069\u0001"+
            "\u0074\u0001\u0075\u0001\u0070\u0001\u006d\u0001\u0064\u0001\u0077\u0001"+
            "\u0076\u0001\u006e\u0001\u0079\u0001\u0069\u0001\u0074\u0001\u0063\u0001"+
            "\u0065\u0001\u0074\u0001\u0063\u0001\u0073\u0001\u0061\u0001\u006b\u0001"+
            "\u0065\u0001\u006c\u0001\u0064\u0001\u0061\u0001\u006c\u0001\u0074\u0001"+
            "\u0065\u0001\u0073\u0001\u006c\u0001\u006b\u0001\u007a\u0001\u0069\u0002"+
            "\u0061\u0001\u0062\u0001\u0061\u0001\u0074\u0001\u0065\u0001\u006b\u0001"+
            "\u0067\u0002\u0061\u0001\u007a\u0001\u0069\u0001\u006f\u0001\u0065\u0001"+
            "\u006e\u0001\u007a\u0001\u0072\u0001\u0061\u0001\u0073\u0001\u0065\u0001"+
            "\u0063\u0001\u0074\u0001\u0065\u0001\u0073\u0001\u006c\u0001\u007a\u0001"+
            "\u0063\u0002\uffff\u0001\u0068\u0001\uffff\u0001\u0074\u0001\u0072\u0001"+
            "\u0065\u0001\u0070\u0001\u0064\u0002\u0069\u0001\uffff\u0001\u0072\u0001"+
            "\u0064\u0001\u0072\u0001\u0069\u0001\u0065\u0001\uffff\u0001\u006b\u0002"+
            "\u0072\u0002\uffff\u0001\uffff\u0001\u0072\u0001\uffff\u0002\u006f\u0001"+
            "\u0061\u0001\u0067\u0002\uffff\u0001\u0072\u0001\u0076\u0001\u006f\u0001"+
            "\u0079\u0001\u0061\u0001\u006f\u0001\u006c\u0001\u0068\u0001\u007a\u0001"+
            "\u0064\u0001\u0072\u0001\u006e\u0001\u0069\u0001\u0065\u0001\u007a\u0001"+
            "\u0075\u0001\u0061\u0001\u0065\u0001\u0062\u0001\u006c\u0001\u007a\u0001"+
            "\u0069\u0001\u0064\u0002\u0065\u0001\u0075\u0001\u0074\u0001\u007a\u0001"+
            "\u0061\u0001\u0069\u0001\u0068\u0001\u007a\u0001\u0068\u0001\u0065\u0002"+
            "\u0073\u0001\u0065\u0001\u0072\u0001\u0069\u0001\u007a\u0001\u006c\u0001"+
            "\u006f\u0001\u006e\u0001\u0062\u0003\u0065\u0001\uffff\u0001\u0063\u0001"+
            "\u006d\u0001\u006e\u0001\u0073\u0001\u0079\u0001\u0074\u0002\u007a\u0001"+
            "\u0075\u0002\u0074\u0001\uffff\u0001\u0061\u0001\u0072\u0001\u0073\u0001"+
            "\u006f\u0001\uffff\u0001\u0061\u0001\u0067\u0001\u0077\u0001\u0072\u0001"+
            "\u0068\u0001\u0061\u0001\u0069\u0001\u0063\u0001\u006e\u0001\u0069\u0001"+
            "\uffff\u0001\u007a\u0001\u0072\u0001\u0065\u0001\u007a\u0001\u0063\u0001"+
            "\u006c\u0001\u0068\u0001\u0065\u0001\u0062\u0001\u0066\u0001\u0065\u0001"+
            "\u006c\u0001\u007a\u0001\u006e\u0002\u007a\u0001\u0074\u0001\u007a\u0002"+
            "\uffff\u0001\u007a\u0001\u006e\u0002\u0072\u0001\u006e\u0001\u007a\u0001"+
            "\u0061\u0001\u006e\u0001\u0074\u0001\u0072\u0001\u006e\u0001\u0076\u0001"+
            "\u007a\u0001\uffff\u0001\u007a\u0001\u0065\u0001\u0073\u0001\u006d\u0001"+
            "\u006e\u0001\uffff\u0001\u0073\u0001\u006c\u0001\u0064\u0001\u0062\u0001"+
            "\u0065\u0001\uffff\u0001\u0062\u0001\u0076\u0001\u006e\u0001\u0069\u0001"+
            "\u0072\u0001\u006d\u0001\u007a\u0001\uffff\u0001\u007a\u0001\u006f\u0001"+
            "\u0065\u0001\uffff\u0001\u007a\u0001\u0073\u0001\u007a\u0001\u0065\u0001"+
            "\u0064\u0001\u0061\u0001\u0073\u0001\uffff\u0001\u0065\u0001\u0077\u0001"+
            "\u0069\u0001\u006f\u0002\u007a\u0001\u0074\u0001\u007a\u0001\u0065\u0001"+
            "\u0064\u0001\u0074\u0001\u007a\u0001\u0065\u0002\uffff\u0001\u0064\u0001"+
            "\u0061\u0001\u0069\u0001\u0065\u0001\u0073\u0001\u0074\u0001\u006f\u0001"+
            "\u0077\u0001\u0063\u0001\u0065\u0001\u0069\u0001\u0070\u0001\u007a\u0001"+
            "\u0072\u0001\u006e\u0002\u0074\u0001\u0063\u0001\uffff\u0001\u0061\u0001"+
            "\u006c\u0001\uffff\u0001\u006f\u0001\u0068\u0001\u0065\u0002\u0072\u0002"+
            "\u0069\u0001\u0070\u0001\u0065\u0001\uffff\u0001\u007a\u0002\uffff\u0001"+
            "\u0065\u0001\uffff\u0002\uffff\u0001\uffff\u0002\u007a\u0001\u0061\u0001"+
            "\u0065\u0001\uffff\u0001\u006e\u0001\u007a\u0002\u006f\u0001\u0072\u0001"+
            "\u0065\u0001\u0073\u0001\u0065\u0002\uffff\u0001\u007a\u0001\u0077\u0001"+
            "\u0065\u0001\u0074\u0001\u0063\u0001\u006e\u0001\u007a\u0001\u0065\u0001"+
            "\u007a\u0001\u0069\u0001\u0065\u0001\u0064\u0001\u0065\u0001\u0074\u0001"+
            "\u006e\u0001\u0073\u0001\u0065\u0001\uffff\u0001\u0079\u0001\uffff\u0001"+
            "\u006e\u0001\u0073\u0001\uffff\u0001\u0073\u0001\uffff\u0001\u007a\u0001"+
            "\u0075\u0001\u006e\u0001\u0068\u0001\u007a\u0001\u0069\u0001\u0067\u0001"+
            "\u006f\u0002\uffff\u0001\u0069\u0001\uffff\u0001\u007a\u0001\u006c\u0001"+
            "\u006f\u0001\uffff\u0001\u0072\u0001\u007a\u0001\u0067\u0001\u006f\u0001"+
            "\u0064\u0002\u0065\u0001\u006c\u0001\u006e\u0001\u0074\u0001\u006d\u0001"+
            "\u0074\u0001\u0072\u0001\uffff\u0001\u0064\u0001\u0063\u0001\u006f\u0001"+
            "\u0063\u0001\u0061\u0001\u0063\u0001\u0061\u0001\u0072\u0001\u0069\u0001"+
            "\u0076\u0001\u0065\u0001\u006f\u0001\u007a\u0001\u006c\u0001\u0065\u0001"+
            "\u006c\u0001\u0069\u0001\uffff\u0001\u0072\u0002\uffff\u0002\uffff\u0001"+
            "\u0061\u0001\u006f\u0001\u0064\u0001\u0061\u0001\u0069\u0001\u006e\u0001"+
            "\u0065\u0001\u0074\u0001\uffff\u0001\u007a\u0001\u0075\u0001\u0064\u0001"+
            "\u006f\u0001\u0065\u0001\u0064\u0001\uffff\u0001\u0068\u0001\u0069\u0001"+
            "\u006e\u0001\u007a\u0001\u006f\u0001\u0065\u0001\uffff\u0001\u0064\u0001"+
            "\uffff\u0001\u006c\u0001\u0072\u0001\u007a\u0001\u0067\u0001\u007a\u0001"+
            "\u0073\u0001\u0061\u0001\u0072\u0001\u007a\u0001\u0065\u0002\u007a\u0001"+
            "\uffff\u0001\u006f\u0001\u0061\u0001\u0070\u0001\u006b\u0001\u0065\u0001"+
            "\uffff\u0001\u0072\u0001\u006e\u0001\u0068\u0001\u006b\u0001\u0064\u0001"+
            "\uffff\u0001\u0065\u0001\u006e\u0001\u0073\u0001\uffff\u0001\u0065\u0001"+
            "\u006e\u0001\u007a\u0002\u0064\u0001\u0076\u0002\u007a\u0001\u0065\u0001"+
            "\u0068\u0001\u0069\u0001\u0065\u0001\u0074\u0001\u0065\u0001\u0072\u0001"+
            "\u006f\u0002\u0074\u0001\u0073\u0001\u0063\u0001\u006c\u0001\u0061\u0001"+
            "\u0073\u0001\u006c\u0001\uffff\u0001\u0069\u0001\u0064\u0001\u0079\u0001"+
            "\u0064\u0001\u007a\u0002\uffff\u0001\u006d\u0001\u0063\u0001\u007a\u0001"+
            "\u006e\u0001\u006f\u0001\u006b\u0001\u007a\u0001\u0079\u0001\u007a\u0001"+
            "\uffff\u0001\u006e\u0001\u0065\u0001\u0066\u0001\u006f\u0001\u0074\u0001"+
            "\u007a\u0001\u0065\u0002\u0074\u0001\uffff\u0001\u0075\u0001\u0074\u0001"+
            "\u007a\u0002\u0069\u0001\uffff\u0001\u0069\u0001\uffff\u0001\u007a\u0001"+
            "\u0074\u0001\u007a\u0001\uffff\u0001\u0064\u0002\uffff\u0001\u0075\u0001"+
            "\u0074\u0002\u007a\u0001\u0064\u0001\u0063\u0001\u0067\u0001\u0074\u0001"+
            "\u0069\u0002\u007a\u0001\u0065\u0001\u0063\u0002\u007a\u0001\uffff\u0001"+
            "\u0073\u0001\u007a\u0001\u0065\u0002\uffff\u0001\u006e\u0001\u007a\u0001"+
            "\u0073\u0001\u0064\u0001\u007a\u0001\u0073\u0001\u0079\u0001\u006e\u0001"+
            "\u0065\u0001\u0069\u0001\u0074\u0001\u0068\u0001\u0064\u0001\u006e\u0001"+
            "\u006c\u0001\u0068\u0001\u006c\u0001\u0074\u0001\u007a\u0001\u0066\u0001"+
            "\u007a\u0001\uffff\u0002\uffff\u0001\u0065\u0001\u0061\u0001\uffff\u0001"+
            "\u0064\u0002\u007a\u0001\uffff\u0001\u007a\u0001\uffff\u0001\u0074\u0001"+
            "\u0072\u0001\u007a\u0001\u0075\u0001\u0069\u0001\uffff\u0001\u006c\u0001"+
            "\u0068\u0001\u007a\u0001\u006e\u0001\u0077\u0001\uffff\u0001\u0074\u0001"+
            "\u0066\u0001\u006f\u0001\uffff\u0001\u0069\u0001\uffff\u0001\u0070\u0001"+
            "\u006e\u0001\u0063\u0002\uffff\u0001\u007a\u0001\u006f\u0001\u0063\u0001"+
            "\u007a\u0001\u0064\u0002\uffff\u0002\u0064\u0001\u0072\u0001\uffff\u0001"+
            "\u0061\u0001\uffff\u0001\u0064\u0001\u0074\u0001\uffff\u0001\u0065\u0001"+
            "\u0062\u0001\uffff\u0001\u0073\u0001\u007a\u0001\u0074\u0001\u007a\u0001"+
            "\u006f\u0001\u007a\u0001\u0069\u0001\u006f\u0001\u0074\u0001\u0079\u0001"+
            "\u0061\u0001\u006f\u0001\u0079\u0001\uffff\u0001\u0072\u0001\uffff\u0002"+
            "\uffff\u0001\u007a\u0001\u0074\u0001\u006c\u0003\uffff\u0001\u0065\u0001"+
            "\u007a\u0001\u0062\u0001\uffff\u0001\u006e\u0001\u006d\u0001\u0061\u0001"+
            "\u007a\u0001\uffff\u0001\u0065\u0001\u0074\u0001\u006f\u0001\u0079\u0001"+
            "\u0069\u0001\u006e\u0001\u006f\u0001\u0072\u0001\u0074\u0001\u0068\u0001"+
            "\uffff\u0001\u0069\u0001\u0075\u0001\u006f\u0001\uffff\u0003\u007a\u0001"+
            "\u0065\u0001\u006d\u0003\u007a\u0001\u0079\u0001\u0061\u0001\uffff\u0001"+
            "\u0061\u0001\uffff\u0001\u006e\u0001\uffff\u0001\u006c\u0001\u0066\u0001"+
            "\u007a\u0001\u0063\u0001\u0072\u0001\u0077\u0001\u007a\u0001\u006f\u0002"+
            "\uffff\u0001\uffff\u0001\u0069\u0001\u0065\u0001\u0072\u0001\uffff\u0001"+
            "\u0079\u0001\u0074\u0001\u0065\u0001\u0073\u0001\uffff\u0001\u0072\u0001"+
            "\u007a\u0001\u0072\u0001\u007a\u0001\u0065\u0001\u007a\u0001\u006e\u0001"+
            "\u006f\u0001\u007a\u0001\u0065\u0001\u006d\u0001\u006e\u0001\u0075\u0003"+
            "\uffff\u0001\u0065\u0001\u0070\u0003\uffff\u0001\u007a\u0001\u0067\u0001"+
            "\u0069\u0001\u0077\u0001\u0064\u0001\u007a\u0001\uffff\u0001\u006f\u0002"+
            "\u0065\u0001\uffff\u0001\u006d\u0002\uffff\u0001\u006f\u0001\u007a\u0001"+
            "\u0069\u0001\u0061\u0002\u007a\u0001\u0074\u0001\u0069\u0001\uffff\u0001"+
            "\u006b\u0001\uffff\u0001\u0064\u0001\uffff\u0001\u0069\u0001\u0066\u0001"+
            "\uffff\u0001\u0073\u0001\u0065\u0001\u0074\u0002\u006e\u0001\u006c\u0001"+
            "\uffff\u0001\u0065\u0001\u006e\u0001\u0064\u0001\u0065\u0001\u006f\u0001"+
            "\u0068\u0002\u0061\u0001\u006f\u0001\uffff\u0001\u0075\u0001\u0063\u0001"+
            "\u0072\u0001\u0070\u0001\uffff\u0001\uffff\u0001\uffff\u0001\uffff\u0001"+
            "\u006e\u0001\uffff\u0001\u0064\u0001\u0066\u0001\u0075\u0002\uffff\u0001"+
            "\u007a\u0001\u0066\u0002\u007a\u0001\u0064\u0001\u0069\u0003\u007a\u0001"+
            "\u0074\u0001\u006e\u0001\u0065\u0003\u007a\u0001\u0073\u0001\u0072\u0001"+
            "\u006c\u0001\u0072\u0002\u0073\u0001\u0066\u0001\u006e\u0001\u006f\u0001"+
            "\u0063\u0001\u0072\u0001\uffff\u0001\uffff\u0001\uffff\u0002\u007a\u0001"+
            "\u0069\u0001\u0074\u0001\uffff\u0001\u0069\u0002\uffff\u0001\u007a\u0001"+
            "\u006c\u0003\uffff\u0001\u007a\u0001\u0061\u0001\u007a\u0003\uffff\u0001"+
            "\u0070\u0001\u0073\u0001\u006c\u0001\u0065\u0001\u006f\u0001\u0072\u0001"+
            "\u0074\u0001\u007a\u0001\u0074\u0001\u0075\u0002\u006f\u0002\uffff\u0002"+
            "\uffff\u0001\u0065\u0001\u0068\u0001\u0065\u0001\uffff\u0001\u0065\u0001"+
            "\uffff\u0001\u006d\u0001\uffff\u0001\u006f\u0001\u0074\u0001\u006f\u0001"+
            "\u0073\u0001\u0072\u0001\u006c\u0001\u0065\u0001\u006d\u0001\uffff\u0001"+
            "\u007a\u0001\u006e\u0001\u0075\u0001\u0066\u0002\uffff\u0001\u0064\u0001"+
            "\u006f\u0001\u0064\u0001\u007a\u0001\u0065\u0001\u006e\u0001\u0072\u0001"+
            "\u0077\u0001\u0070\u0001\u0073\u0001\u006c\u0001\u0073\u0001\u0065\u0001"+
            "\uffff\u0001\u0074\u0001\u006e\u0001\u0069\u0002\uffff\u0001\u007a\u0001"+
            "\u0072\u0001\u007a\u0001\uffff\u0001\u007a\u0001\u0073\u0002\u0065\u0001"+
            "\u0075\u0001\u006f\u0001\u0074\u0001\u006f\u0001\u0070\u0001\u006e\u0001"+
            "\u007a\u0001\u0074\u0001\u006c\u0002\uffff\u0001\uffff\u0001\u007a\u0002"+
            "\uffff\u0001\u0065\u0001\u0073\u0001\u006e\u0001\u0070\u0001\u006e\u0001"+
            "\u0072\u0001\u0077\u0001\u006f\u0001\u0074\u0001\uffff\u0001\u007a\u0001"+
            "\u0065\u0002\uffff\u0001\uffff\u0001\u0074\u0001\u0070\u0001\u0074\u0001"+
            "\u0072\u0001\u0073\u0001\u0065\u0001\u0075\u0001\u006e\u0001\u0069\u0001"+
            "\uffff\u0001\u007a\u0002\uffff\u0001\u0069\u0001\u006f\u0001\u0069\u0002"+
            "\u0065\u0001\u0073\u0001\u0070\u0001\u0073\u0001\u006f\u0001\uffff\u0002"+
            "\uffff\u0001\u006d\u0001\u006e\u0001\u006f\u0001\u0073\u0001\u0074\u0001"+
            "\u0070\u0001\u0072\u0001\u0065\u0001\u006e\u0001\u0065\u0001\u0073\u0001"+
            "\u006e\u0001\u0070\u0001\u0069\u0001\u006f\u0001\u0065\u0001\u007a\u0001"+
            "\u0070\u0001\u007a\u0001\u0065\u0001\u0070\u0001\u006f\u0001\u006d\u0001"+
            "\u006e\u0001\u0073\u0001\uffff\u0001\u0075\u0001\uffff\u0001\u0074\u0001"+
            "\u0075\u0001\u006e\u0001\u0065\u0001\u0073\u0001\u0070\u0001\u0062\u0001"+
            "\u0069\u0001\u0075\u0001\u0062\u0001\u0073\u0001\u007a\u0001\u0065\u0001"+
            "\u006f\u0001\u006c\u0001\u006d\u0001\u0062\u0001\u006c\u0001\u0065\u0001"+
            "\uffff\u0001\u0074\u0001\u006e\u0001\u0069\u0001\u0065\u0001\u006c\u0001"+
            "\u0069\u0001\u0074\u0001\u0069\u0002\u0073\u0001\u007a\u0001\u0069\u0001"+
            "\u0073\u0001\u0069\u0001\u006d\u0001\u0065\u0001\u0068\u0001\uffff\u0001"+
            "\u0073\u0001\u0068\u0001\u006d\u0001\u0065\u0001\u0074\u0001\u0065\u0001"+
            "\u0068\u0002\u0065\u0001\u007a\u0001\u0069\u0001\u0064\u0001\u0065\u0001"+
            "\u0064\u0001\u007a\u0001\uffff\u0001\u006d\u0001\u007a\u0001\u0064\u0001"+
            "\u007a\u0001\uffff\u0001\u0065\u0001\uffff\u0001\u007a\u0001\uffff\u0001"+
            "\u007a\u0002\uffff",
        DFA18_acceptS:
            "\u0001\uffff\u0001\u0001\u0001\u0002\u0014\uffff\u0001\u006a\u0001"+
            "\u006b\u000b\uffff\u0001\u009c\u0001\u009d\u0001\u009e\u0001\u009f\u0001"+
            "\u00a0\u0001\u00a1\u0001\u00a2\u0001\u00a6\u0042\uffff\u0001\u0067\u0001"+
            "\u0066\u0001\u0069\u0001\u0068\u0002\uffff\u0001\u0097\u0001\u0099\u0004"+
            "\uffff\u0001\u009b\u0001\uffff\u0001\u0003\u0002\uffff\u0001\u0074\u004f"+
            "\uffff\u0001\u002c\u0001\u0075\u0001\uffff\u0001\u0061\u0007\uffff\u0001"+
            "\u0098\u0005\uffff\u0001\u008a\u0005\uffff\u0001\u0037\u0001\uffff\u0001"+
            "\u0004\u0004\uffff\u0001\u00a3\u0001\u0038\u002f\uffff\u0001\u001e\u000b"+
            "\uffff\u0001\u002e\u0004\uffff\u0001\u005d\u000a\uffff\u0001\u0089\u0021"+
            "\uffff\u0001\u0043\u0005\uffff\u0001\u0011\u0005\uffff\u0001\u0081\u0007"+
            "\uffff\u0001\u0023\u0003\uffff\u0001\u0093\u0007\uffff\u0001\u000e\u000d"+
            "\uffff\u0001\u0092\u0001\u0010\u0012\uffff\u0001\u00a4\u0002\uffff\u0001"+
            "\u0062\u0009\uffff\u0001\u0088\u0001\uffff\u0001\u0084\u0001\u008b\u0001"+
            "\uffff\u0001\u008f\u0002\uffff\u0001\u0095\u0004\uffff\u0001\u0065\u0008"+
            "\uffff\u0001\u0039\u0001\u0006\u0011\uffff\u0001\u00a5\u0001\uffff\u0001"+
            "\u0009\u0002\uffff\u0001\u008d\u0001\uffff\u0001\u0079\u0008\uffff\u0001"+
            "\u0091\u0001\u000f\u0001\uffff\u0001\u001f\u0003\uffff\u0001\u0087\u000d"+
            "\uffff\u0001\u0090\u0011\uffff\u0001\u0076\u0003\uffff\u0001\u000a\u0001"+
            "\u0026\u0008\uffff\u0001\u0022\u0006\uffff\u0001\u0064\u0006\uffff\u0001"+
            "\u0082\u0001\uffff\u0001\u0078\u000c\uffff\u0001\u000c\u0005\uffff\u0001"+
            "\u0094\u0005\uffff\u0001\u004a\u0003\uffff\u0001\u0018\u0018\uffff\u0001"+
            "\u003f\u0010\uffff\u0001\u0030\u0009\uffff\u0001\u0020\u0005\uffff\u0001"+
            "\u002d\u0001\uffff\u0001\u0014\u0003\uffff\u0001\u0021\u0001\uffff\u0001"+
            "\u0070\u0001\u000b\u000f\uffff\u0001\u0017\u0003\uffff\u0001\u0096\u0001"+
            "\u0028\u0015\uffff\u0001\u008e\u0004\uffff\u0001\u0027\u0003\uffff\u0001"+
            "\u0025\u0001\uffff\u0001\u007e\u0005\uffff\u0001\u0085\u0005\uffff\u0001"+
            "\u0050\u0003\uffff\u0001\u006c\u0001\uffff\u0001\u007b\u0003\uffff\u0001"+
            "\u0016\u0001\u001a\u0005\uffff\u0001\u0046\u0001\u004b\u0003\uffff\u0001"+
            "\u0015\u0001\uffff\u0001\u007d\u0002\uffff\u0001\u006f\u0002\uffff\u0001"+
            "\u0077\u000d\uffff\u0001\u0083\u0001\uffff\u0001\u005f\u0005\uffff\u0001"+
            "\u004d\u0001\u001b\u0001\u0005\u0003\uffff\u0001\u0033\u0004\uffff\u0001"+
            "\u0007\u000a\uffff\u0001\u001c\u0003\uffff\u0001\u008c\u000a\uffff\u0001"+
            "\u007c\u0001\uffff\u0001\u007f\u0001\uffff\u0001\u0072\u000a\uffff\u0001"+
            "\u0012\u0003\uffff\u0001\u0031\u0004\uffff\u0001\u006e\u000d\uffff\u0001"+
            "\u0060\u0001\u004c\u0001\u004f\u0002\uffff\u0001\u0086\u0001\u002f\u0001"+
            "\u007a\u0006\uffff\u0001\u0080\u0003\uffff\u0001\u0045\u000b\uffff\u0001"+
            "\u003a\u0001\uffff\u0001\u0008\u0001\uffff\u0001\u003e\u0002\uffff\u0001"+
            "\u000d\u0006\uffff\u0001\u002b\u0009\uffff\u0001\u0063\u0005\uffff\u0001"+
            "\u009a\u0001\uffff\u0001\u009a\u0001\uffff\u0001\u0048\u0003\uffff\u0001"+
            "\u0034\u0001\u0040\u001b\uffff\u0001\u009a\u0005\uffff\u0001\u0073\u0001"+
            "\uffff\u0001\u0047\u0001\u002a\u0002\uffff\u0001\u0019\u0001\u001d\u0001"+
            "\u003b\u0003\uffff\u0001\u0044\u0001\u006d\u0001\u0052\u000e\uffff\u0001"+
            "\u0013\u0001\u0049\u0003\uffff\u0001\u004e\u0001\uffff\u0001\u003d\u0001"+
            "\uffff\u0001\u0041\u0008\uffff\u0001\u0071\u0013\uffff\u0001\u0032\u0008"+
            "\uffff\u0001\u0042\u000f\uffff\u0001\u0024\u0001\uffff\u0001\u0029\u0001"+
            "\u005e\u0009\uffff\u0001\u0035\u0004\uffff\u0001\u0036\u0009\uffff\u0001"+
            "\u003c\u000c\uffff\u0001\u0051\u001b\uffff\u0001\u0059\u0001\uffff\u0001"+
            "\u0053\u0013\uffff\u0001\u0056\u0011\uffff\u0001\u0054\u000f\uffff\u0001"+
            "\u0057\u0004\uffff\u0001\u0055\u0001\uffff\u0001\u005b\u0001\uffff\u0001"+
            "\u005a\u0001\uffff\u0001\u005c\u0001\u0058",
        DFA18_specialS:
            "\u0022\uffff\u0001\u0003\u0001\u0001\u0055\uffff\u0001\u0012\u0001"+
            "\uffff\u0001\u0016\u0068\uffff\u0001\u0011\u0001\u0017\u0067\uffff\u0001"+
            "\u000f\u0001\u0019\u0062\uffff\u0001\u0013\u0001\u0015\u005a\uffff\u0001"+
            "\u000e\u0001\u0018\u0056\uffff\u0001\u000d\u0001\u0020\u004e\uffff\u0001"+
            "\u0010\u0001\u001a\u0043\uffff\u0001\u000c\u0001\u0021\u0035\uffff\u0001"+
            "\u000b\u0001\u001e\u002b\uffff\u0001\u0006\u0001\u0007\u0025\uffff\u0001"+
            "\u001c\u0001\uffff\u0001\u0027\u0022\uffff\u0001\u000a\u0001\uffff\u0001"+
            "\u0022\u001f\uffff\u0001\u0000\u0001\u0002\u0017\uffff\u0001\u001f\u0001"+
            "\u0026\u0011\uffff\u0001\u0009\u0001\u001b\u0011\uffff\u0001\u0005\u0001"+
            "\u0004\u0010\uffff\u0001\u0023\u0001\u0025\u000c\uffff\u0001\u0008\u0001"+
            "\u001d\u000a\uffff\u0001\u0014\u0001\u0024\u005e\uffff}>",
        DFA18_transitionS: [
            "\u0001\u0002\u0001\u0001\u0002\uffff\u0001\u0001\u0012\uffff"+
            "\u0001\u0002\u0001\u0018\u0001\u0022\u0004\uffff\u0001\u0023"+
            "\u0001\u0025\u0001\u0026\u0002\uffff\u0001\u0027\u0001\u001e"+
            "\u0001\uffff\u0001\u0028\u0002\u001f\u0001\u001a\u0007\u001f"+
            "\u0002\uffff\u0001\u0016\u0001\u0017\u0001\u0015\u0001\uffff"+
            "\u0001\u0024\u0001\u0004\u0001\u0006\u0001\u0008\u0001\u0010"+
            "\u0001\u000f\u0001\u000b\u0001\u0012\u0001\u0014\u0001\u0011"+
            "\u0002\u002b\u0001\u000d\u0001\u0009\u0001\u0021\u0001\u0003"+
            "\u0001\u000a\u0001\u001c\u0001\u0005\u0001\u0007\u0001\u000c"+
            "\u0001\u000e\u0001\u0020\u0001\u001b\u0001\u002b\u0001\u001d"+
            "\u0001\u002b\u0001\u0029\u0001\uffff\u0001\u002a\u0001\uffff"+
            "\u0001\u002b\u0001\uffff\u0001\u0004\u0001\u0006\u0001\u0008"+
            "\u0001\u0010\u0001\u000f\u0001\u000b\u0001\u0012\u0001\u0014"+
            "\u0001\u0011\u0002\u002b\u0001\u000d\u0001\u0009\u0001\u0019"+
            "\u0001\u0003\u0001\u000a\u0001\u001c\u0001\u0005\u0001\u0007"+
            "\u0001\u000c\u0001\u000e\u0001\u0013\u0001\u001b\u0001\u002b"+
            "\u0001\u001d\u0001\u002b",
            "",
            "",
            "\u0001\u002e\u0003\uffff\u0001\u002c\u0001\uffff\u0001\u002d"+
            "\u0019\uffff\u0001\u002e\u0003\uffff\u0001\u002c\u0001\uffff"+
            "\u0001\u002d",
            "\u0001\u0030\u0002\uffff\u0001\u0035\u0005\uffff\u0001\u0032"+
            "\u0001\uffff\u0001\u002f\u0004\uffff\u0001\u0033\u0001\uffff"+
            "\u0001\u0031\u0001\u0034\u000c\uffff\u0001\u0030\u0002\uffff"+
            "\u0001\u0035\u0005\uffff\u0001\u0032\u0001\uffff\u0001\u002f"+
            "\u0004\uffff\u0001\u0033\u0001\uffff\u0001\u0031\u0001\u0034",
            "\u0001\u0037\u0003\uffff\u0001\u0036\u001b\uffff\u0001\u0037"+
            "\u0003\uffff\u0001\u0036",
            "\u0001\u0039\u000c\uffff\u0001\u0038\u0012\uffff\u0001\u0039"+
            "\u000c\uffff\u0001\u0038",
            "\u0001\u003f\u0001\uffff\u0001\u003e\u0001\uffff\u0001\u003a"+
            "\u0003\uffff\u0001\u003b\u0005\uffff\u0001\u003d\u0001\u0040"+
            "\u0003\uffff\u0001\u003c\u000c\uffff\u0001\u003f\u0001\uffff"+
            "\u0001\u003e\u0001\uffff\u0001\u003a\u0003\uffff\u0001\u003b"+
            "\u0005\uffff\u0001\u003d\u0001\u0040\u0003\uffff\u0001\u003c",
            "\u0001\u0043\u0005\uffff\u0001\u0042\u0002\uffff\u0001\u0041"+
            "\u0016\uffff\u0001\u0043\u0005\uffff\u0001\u0042\u0002\uffff"+
            "\u0001\u0041",
            "\u0001\u0045\u0003\uffff\u0001\u0044\u0009\uffff\u0001\u0046"+
            "\u0011\uffff\u0001\u0045\u0003\uffff\u0001\u0044\u0009\uffff"+
            "\u0001\u0046",
            "\u0001\u004a\u0006\uffff\u0001\u0048\u0001\u0049\u0008\uffff"+
            "\u0001\u0047\u0002\uffff\u0001\u004b\u000b\uffff\u0001\u004a"+
            "\u0006\uffff\u0001\u0048\u0001\u0049\u0008\uffff\u0001\u0047"+
            "\u0002\uffff\u0001\u004b",
            "\u0001\u004e\u0003\uffff\u0001\u004c\u0009\uffff\u0001\u004d"+
            "\u0011\uffff\u0001\u004e\u0003\uffff\u0001\u004c\u0009\uffff"+
            "\u0001\u004d",
            "\u0001\u0050\u0007\uffff\u0001\u004f\u0005\uffff\u0001\u0051"+
            "\u0002\uffff\u0001\u0053\u0004\uffff\u0001\u0052\u0009\uffff"+
            "\u0001\u0050\u0007\uffff\u0001\u004f\u0005\uffff\u0001\u0051"+
            "\u0002\uffff\u0001\u0053\u0004\uffff\u0001\u0052",
            "\u0001\u0055\u0007\uffff\u0001\u0054\u0005\uffff\u0001\u0056"+
            "\u0011\uffff\u0001\u0055\u0007\uffff\u0001\u0054\u0005\uffff"+
            "\u0001\u0056",
            "\u0001\u005a\u000a\uffff\u0001\u0059\u0001\uffff\u0001\u0057"+
            "\u0001\uffff\u0001\u0058\u0010\uffff\u0001\u005a\u000a\uffff"+
            "\u0001\u0059\u0001\uffff\u0001\u0057\u0001\uffff\u0001\u0058",
            "\u0001\u005c\u0001\uffff\u0001\u005d\u0007\uffff\u0001\u005b"+
            "\u0015\uffff\u0001\u005c\u0001\uffff\u0001\u005d\u0007\uffff"+
            "\u0001\u005b",
            "\u0001\u0061\u0003\uffff\u0001\u0062\u0003\uffff\u0001\u005e"+
            "\u0005\uffff\u0001\u005f\u0005\uffff\u0001\u0060\u000b\uffff"+
            "\u0001\u0061\u0003\uffff\u0001\u0062\u0003\uffff\u0001\u005e"+
            "\u0005\uffff\u0001\u005f\u0005\uffff\u0001\u0060",
            "\u0001\u0063\u0009\uffff\u0001\u0064\u0003\uffff\u0001\u0066"+
            "\u0001\u0065\u0010\uffff\u0001\u0063\u0009\uffff\u0001\u0064"+
            "\u0003\uffff\u0001\u0066\u0001\u0065",
            "\u0001\u0068\u000c\uffff\u0001\u0067\u0012\uffff\u0001\u0068"+
            "\u000c\uffff\u0001\u0067",
            "\u000a\u006b\u000b\uffff\u0001\u006a\u0003\uffff\u0001\u0069"+
            "\u001b\uffff\u0001\u006a\u0003\uffff\u0001\u0069",
            "\u0001\u006c\u000d\uffff\u0001\u006d\u0011\uffff\u0001\u006c"+
            "\u000d\uffff\u0001\u006d",
            "\u0001\u006e",
            "\u0001\u0070",
            "",
            "",
            "\u000a\u006b\u0015\uffff\u0001\u0072\u001f\uffff\u0001\u0072",
            "\u0001\u0075\u0001\uffff\u0004\u001f\u0001\u0073\u0005\u001f",
            "\u0001\u0076\u001f\uffff\u0001\u0076",
            "\u0001\u0077\u001f\uffff\u0001\u0077",
            "\u0001\u0078\u001f\uffff\u0001\u0078",
            "\u000a\u001f",
            "\u0001\u0075\u0001\uffff\u000a\u001f",
            "\u0001\u006a\u0003\uffff\u0001\u0069\u001b\uffff\u0001\u006a"+
            "\u0003\uffff\u0001\u0069",
            "\u0001\u0072\u001f\uffff\u0001\u0072",
            "\u0030\u007a\u000a\u0079\uffc6\u007a",
            "\u0030\u007a\u000a\u007b\uffc6\u007a",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u007e\u000a\uffff\u0001\u007d\u0014\uffff\u0001\u007e"+
            "\u000a\uffff\u0001\u007d",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0080\u001f\uffff\u0001\u0080",
            "\u0001\u0081\u001f\uffff\u0001\u0081",
            "\u0001\u0082\u001f\uffff\u0001\u0082",
            "\u0001\u0083\u001f\uffff\u0001\u0083",
            "\u0001\u0085\u000f\uffff\u0001\u0084\u000f\uffff\u0001\u0085"+
            "\u000f\uffff\u0001\u0084",
            "\u0001\u0086\u001f\uffff\u0001\u0086",
            "\u0001\u0087\u001f\uffff\u0001\u0087",
            "\u0001\u008c\u0005\uffff\u0001\u0089\u0004\uffff\u0001\u0088"+
            "\u0003\uffff\u0001\u008a\u0002\uffff\u0001\u008b\u000d\uffff"+
            "\u0001\u008c\u0005\uffff\u0001\u0089\u0004\uffff\u0001\u0088"+
            "\u0003\uffff\u0001\u008a\u0002\uffff\u0001\u008b",
            "\u0001\u008d\u001f\uffff\u0001\u008d",
            "\u0001\u008e\u001f\uffff\u0001\u008e",
            "\u0001\u008f\u0001\u0090\u001e\uffff\u0001\u008f\u0001\u0090",
            "\u0001\u0092\u0006\uffff\u0001\u0091\u0018\uffff\u0001\u0092"+
            "\u0006\uffff\u0001\u0091",
            "\u0001\u0093\u001f\uffff\u0001\u0093",
            "\u0001\u0094\u001f\uffff\u0001\u0094",
            "\u0001\u0095\u000e\uffff\u0001\u0096\u0010\uffff\u0001\u0095"+
            "\u000e\uffff\u0001\u0096",
            "\u0001\u0097\u001f\uffff\u0001\u0097",
            "\u0001\u0098\u001f\uffff\u0001\u0098",
            "\u0001\u0099\u001f\uffff\u0001\u0099",
            "\u0001\u009a\u0009\uffff\u0001\u009b\u0015\uffff\u0001\u009a"+
            "\u0009\uffff\u0001\u009b",
            "\u0001\u009c\u0006\uffff\u0001\u009d\u0018\uffff\u0001\u009c"+
            "\u0006\uffff\u0001\u009d",
            "\u0001\u009e\u001f\uffff\u0001\u009e",
            "\u0001\u009f\u0009\uffff\u0001\u00a0\u0015\uffff\u0001\u009f"+
            "\u0009\uffff\u0001\u00a0",
            "\u0001\u00a2\u0007\uffff\u0001\u00a1\u0017\uffff\u0001\u00a2"+
            "\u0007\uffff\u0001\u00a1",
            "\u0001\u00a3\u001f\uffff\u0001\u00a3",
            "\u0001\u00a5\u0009\uffff\u0001\u00a4\u0015\uffff\u0001\u00a5"+
            "\u0009\uffff\u0001\u00a4",
            "\u0001\u00a6\u001f\uffff\u0001\u00a6",
            "\u0001\u00a7\u001f\uffff\u0001\u00a7",
            "\u0001\u00a8\u001f\uffff\u0001\u00a8",
            "\u0001\u00a9\u001f\uffff\u0001\u00a9",
            "\u0001\u00aa\u0007\uffff\u0001\u00ab\u0017\uffff\u0001\u00aa"+
            "\u0007\uffff\u0001\u00ab",
            "\u0001\u00ac\u0005\uffff\u0001\u00ad\u0019\uffff\u0001\u00ac"+
            "\u0005\uffff\u0001\u00ad",
            "\u0001\u00ae\u0008\uffff\u0001\u00af\u0016\uffff\u0001\u00ae"+
            "\u0008\uffff\u0001\u00af",
            "\u0001\u00b1\u0010\uffff\u0001\u00b0\u000e\uffff\u0001\u00b1"+
            "\u0010\uffff\u0001\u00b0",
            "\u0001\u00b2\u001f\uffff\u0001\u00b2",
            "\u0001\u00b7\u0003\uffff\u0001\u00b5\u0004\uffff\u0001\u00b6"+
            "\u0001\u00b4\u0001\uffff\u0001\u00b3\u0013\uffff\u0001\u00b7"+
            "\u0003\uffff\u0001\u00b5\u0004\uffff\u0001\u00b6\u0001\u00b4"+
            "\u0001\uffff\u0001\u00b3",
            "\u0001\u00b8\u001f\uffff\u0001\u00b8",
            "\u0001\u00b9\u001f\uffff\u0001\u00b9",
            "\u0001\u00ba\u001f\uffff\u0001\u00ba",
            "\u0001\u00bb\u001f\uffff\u0001\u00bb",
            "\u0001\u00bc\u001f\uffff\u0001\u00bc",
            "\u0001\u00bd\u001f\uffff\u0001\u00bd",
            "\u0001\u00be\u001f\uffff\u0001\u00be",
            "\u0001\u00bf\u0008\uffff\u0001\u00c2\u0006\uffff\u0001\u00c1"+
            "\u0001\u00c0\u000e\uffff\u0001\u00bf\u0008\uffff\u0001\u00c2"+
            "\u0006\uffff\u0001\u00c1\u0001\u00c0",
            "\u0001\u00c3\u001f\uffff\u0001\u00c3",
            "\u0001\u00c4\u001f\uffff\u0001\u00c4",
            "\u0001\u00c6\u0002\uffff\u0001\u00c5\u000c\uffff\u0001\u00c7"+
            "\u000f\uffff\u0001\u00c6\u0002\uffff\u0001\u00c5\u000c\uffff"+
            "\u0001\u00c7",
            "\u0001\u00c8\u001f\uffff\u0001\u00c8",
            "\u0001\u00ca\u0001\u00c9\u001e\uffff\u0001\u00ca\u0001\u00c9",
            "\u0001\u00cb\u001f\uffff\u0001\u00cb",
            "\u0001\u00cc\u001f\uffff\u0001\u00cc",
            "\u0001\u00cd\u001f\uffff\u0001\u00cd",
            "\u0001\u00ce\u001f\uffff\u0001\u00ce",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u0013\u002b\u0001\u00d1\u0006\u002b"+
            "\u0004\uffff\u0001\u002b\u0001\uffff\u0013\u002b\u0001\u00d1"+
            "\u0006\u002b",
            "\u000a\u002b\u0007\uffff\u000d\u002b\u0001\u00d3\u0001\u00d4"+
            "\u000b\u002b\u0004\uffff\u0001\u002b\u0001\uffff\u000d\u002b"+
            "\u0001\u00d3\u0001\u00d4\u000b\u002b",
            "\u0001\u00d5\u001f\uffff\u0001\u00d5",
            "\u0001\u00d6\u001f\uffff\u0001\u00d6",
            "\u0001\u00d7\u001f\uffff\u0001\u00d7",
            "\u0001\u00d8\u001f\uffff\u0001\u00d8",
            "\u0001\u00d9\u001f\uffff\u0001\u00d9",
            "\u000a\u006b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u00dc\u0004\uffff\u0001\u00db\u001a\uffff\u0001\u00dc"+
            "\u0004\uffff\u0001\u00db",
            "\u0001\u00dd\u001f\uffff\u0001\u00dd",
            "",
            "",
            "",
            "",
            "\u0001\u00df\u0005\uffff\u0001\u00de\u0019\uffff\u0001\u00df"+
            "\u0005\uffff\u0001\u00de",
            "\u0001\u0075\u0001\uffff\u000a\u001f\u000e\uffff\u0001\u00e0"+
            "\u001f\uffff\u0001\u00e0",
            "",
            "",
            "\u0001\u00e1\u001f\uffff\u0001\u00e1",
            "\u0001\u00e2\u001f\uffff\u0001\u00e2",
            "\u0001\u00e3\u001f\uffff\u0001\u00e3",
            "\u0030\u007a\u000a\u00e4\uffc6\u007a",
            "",
            "\u0030\u007a\u000a\u00e5\uffc6\u007a",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u00e7\u001f\uffff\u0001\u00e7",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u00e9\u001f\uffff\u0001\u00e9",
            "\u0001\u00ea\u001f\uffff\u0001\u00ea",
            "\u0001\u00eb\u001f\uffff\u0001\u00eb",
            "\u0001\u00ec\u001f\uffff\u0001\u00ec",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u00ef\u001f\uffff\u0001\u00ef",
            "\u0001\u00f0\u001f\uffff\u0001\u00f0",
            "\u0001\u00f1\u001f\uffff\u0001\u00f1",
            "\u0001\u00f2\u001f\uffff\u0001\u00f2",
            "\u0001\u00f3\u0006\uffff\u0001\u00f5\u0001\u00f4\u0017\uffff"+
            "\u0001\u00f3\u0006\uffff\u0001\u00f5\u0001\u00f4",
            "\u0001\u00f6\u001f\uffff\u0001\u00f6",
            "\u0001\u00f7\u001f\uffff\u0001\u00f7",
            "\u0001\u00f8\u001f\uffff\u0001\u00f8",
            "\u0001\u00f9\u001f\uffff\u0001\u00f9",
            "\u0001\u00fa\u001f\uffff\u0001\u00fa",
            "\u0001\u00fb\u001f\uffff\u0001\u00fb",
            "\u0001\u00fc\u001f\uffff\u0001\u00fc",
            "\u0001\u00fd\u001f\uffff\u0001\u00fd",
            "\u0001\u00fe\u001f\uffff\u0001\u00fe",
            "\u0001\u00ff\u001f\uffff\u0001\u00ff",
            "\u0001\u0100\u001f\uffff\u0001\u0100",
            "\u0001\u0101\u001f\uffff\u0001\u0101",
            "\u0001\u0102\u001f\uffff\u0001\u0102",
            "\u0001\u0103\u001f\uffff\u0001\u0103",
            "\u0001\u0104\u001f\uffff\u0001\u0104",
            "\u0001\u0105\u001f\uffff\u0001\u0105",
            "\u0001\u0108\u0001\u0106\u0001\uffff\u0001\u0107\u001c\uffff"+
            "\u0001\u0108\u0001\u0106\u0001\uffff\u0001\u0107",
            "\u0001\u0109\u001f\uffff\u0001\u0109",
            "\u0001\u010a\u001f\uffff\u0001\u010a",
            "\u0001\u010b\u001f\uffff\u0001\u010b",
            "\u0001\u010c\u001f\uffff\u0001\u010c",
            "\u0001\u010d\u001f\uffff\u0001\u010d",
            "\u0001\u010e\u001f\uffff\u0001\u010e",
            "\u0001\u010f\u001f\uffff\u0001\u010f",
            "\u0001\u0110\u001f\uffff\u0001\u0110",
            "\u0001\u0111\u001f\uffff\u0001\u0111",
            "\u0001\u0112\u001f\uffff\u0001\u0112",
            "\u0001\u0113\u001f\uffff\u0001\u0113",
            "\u0001\u0114\u001f\uffff\u0001\u0114",
            "\u0001\u0115\u001f\uffff\u0001\u0115",
            "\u0001\u0116\u001f\uffff\u0001\u0116",
            "\u0001\u0117\u001f\uffff\u0001\u0117",
            "\u0001\u0118\u001f\uffff\u0001\u0118",
            "\u0001\u0119\u001f\uffff\u0001\u0119",
            "\u0001\u011a\u001f\uffff\u0001\u011a",
            "\u0001\u011b\u001f\uffff\u0001\u011b",
            "\u0001\u011c\u001f\uffff\u0001\u011c",
            "\u0001\u011d\u001f\uffff\u0001\u011d",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u011f\u001f\uffff\u0001\u011f",
            "\u0001\u0120\u001f\uffff\u0001\u0120",
            "\u0001\u0121\u001f\uffff\u0001\u0121",
            "\u0001\u0122\u001f\uffff\u0001\u0122",
            "\u0001\u0123\u001f\uffff\u0001\u0123",
            "\u0001\u0124\u001f\uffff\u0001\u0124",
            "\u0001\u0125\u001f\uffff\u0001\u0125",
            "\u0001\u0126\u001f\uffff\u0001\u0126",
            "\u0001\u0127\u001f\uffff\u0001\u0127",
            "\u0001\u0128\u001f\uffff\u0001\u0128",
            "\u0001\u0129\u001f\uffff\u0001\u0129",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u012b\u001f\uffff\u0001\u012b",
            "\u0001\u012c\u001f\uffff\u0001\u012c",
            "\u0001\u012d\u001f\uffff\u0001\u012d",
            "\u0001\u012e\u001f\uffff\u0001\u012e",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0130\u001f\uffff\u0001\u0130",
            "\u0001\u0131\u001f\uffff\u0001\u0131",
            "\u0001\u0132\u001f\uffff\u0001\u0132",
            "\u0001\u0133\u001f\uffff\u0001\u0133",
            "\u0001\u0134\u001f\uffff\u0001\u0134",
            "\u0001\u0135\u0010\uffff\u0001\u0136\u000e\uffff\u0001\u0135"+
            "\u0010\uffff\u0001\u0136",
            "\u0001\u0137\u001f\uffff\u0001\u0137",
            "\u0001\u0138\u001f\uffff\u0001\u0138",
            "\u0001\u0139\u001f\uffff\u0001\u0139",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u013b\u001f\uffff\u0001\u013b",
            "",
            "",
            "\u0001\u013c\u0002\uffff\u0001\u013d\u001c\uffff\u0001\u013c"+
            "\u0002\uffff\u0001\u013d",
            "",
            "\u0001\u013e\u001f\uffff\u0001\u013e",
            "\u0001\u013f\u001f\uffff\u0001\u013f",
            "\u0001\u0140\u001f\uffff\u0001\u0140",
            "\u0001\u0141\u001f\uffff\u0001\u0141",
            "\u0001\u0142\u001f\uffff\u0001\u0142",
            "\u0001\u0143\u001f\uffff\u0001\u0143",
            "\u0001\u0144\u001f\uffff\u0001\u0144",
            "",
            "\u0001\u0145\u001f\uffff\u0001\u0145",
            "\u0001\u0146\u001f\uffff\u0001\u0146",
            "\u0001\u0147\u001f\uffff\u0001\u0147",
            "\u0001\u0148\u001f\uffff\u0001\u0148",
            "\u0001\u0149\u001f\uffff\u0001\u0149",
            "",
            "\u0001\u014a\u001f\uffff\u0001\u014a",
            "\u0001\u014b\u001f\uffff\u0001\u014b",
            "\u0001\u014c\u001f\uffff\u0001\u014c",
            "\u0030\u007a\u000a\u014d\uffc6\u007a",
            "\u0030\u007a\u000a\u014e\uffc6\u007a",
            "",
            "\u0001\u014f\u001f\uffff\u0001\u014f",
            "",
            "\u0001\u0150\u001f\uffff\u0001\u0150",
            "\u0001\u0151\u001f\uffff\u0001\u0151",
            "\u0001\u0152\u001f\uffff\u0001\u0152",
            "\u0001\u0153\u001f\uffff\u0001\u0153",
            "",
            "",
            "\u0001\u0154\u001f\uffff\u0001\u0154",
            "\u0001\u0155\u001f\uffff\u0001\u0155",
            "\u0001\u0156\u001f\uffff\u0001\u0156",
            "\u0001\u0157\u001f\uffff\u0001\u0157",
            "\u0001\u0158\u001f\uffff\u0001\u0158",
            "\u0001\u0159\u001f\uffff\u0001\u0159",
            "\u0001\u015a\u001f\uffff\u0001\u015a",
            "\u0001\u015b\u001f\uffff\u0001\u015b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u015d\u001f\uffff\u0001\u015d",
            "\u0001\u015e\u001f\uffff\u0001\u015e",
            "\u0001\u015f\u001f\uffff\u0001\u015f",
            "\u0001\u0160\u001f\uffff\u0001\u0160",
            "\u0001\u0161\u001f\uffff\u0001\u0161",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0163\u001f\uffff\u0001\u0163",
            "\u0001\u0164\u001f\uffff\u0001\u0164",
            "\u0001\u0165\u001f\uffff\u0001\u0165",
            "\u0001\u0166\u001f\uffff\u0001\u0166",
            "\u0001\u0167\u001f\uffff\u0001\u0167",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0169\u001f\uffff\u0001\u0169",
            "\u0001\u016a\u001f\uffff\u0001\u016a",
            "\u0001\u016c\u0003\uffff\u0001\u016b\u001b\uffff\u0001\u016c"+
            "\u0003\uffff\u0001\u016b",
            "\u0001\u016d\u001f\uffff\u0001\u016d",
            "\u0001\u016e\u001f\uffff\u0001\u016e",
            "\u0001\u016f\u001f\uffff\u0001\u016f",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0171\u001f\uffff\u0001\u0171",
            "\u0001\u0172\u001f\uffff\u0001\u0172",
            "\u0001\u0173\u001f\uffff\u0001\u0173",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0175\u001f\uffff\u0001\u0175",
            "\u0001\u0176\u001f\uffff\u0001\u0176",
            "\u0001\u0177\u001f\uffff\u0001\u0177",
            "\u0001\u0178\u001f\uffff\u0001\u0178",
            "\u0001\u0179\u001f\uffff\u0001\u0179",
            "\u0001\u017a\u001f\uffff\u0001\u017a",
            "\u0001\u017b\u001f\uffff\u0001\u017b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u017d\u001f\uffff\u0001\u017d",
            "\u0001\u017e\u001f\uffff\u0001\u017e",
            "\u0001\u017f\u001f\uffff\u0001\u017f",
            "\u0001\u0180\u001f\uffff\u0001\u0180",
            "\u0001\u0181\u001f\uffff\u0001\u0181",
            "\u0001\u0182\u001f\uffff\u0001\u0182",
            "\u0001\u0183\u001f\uffff\u0001\u0183",
            "",
            "\u0001\u0184\u001f\uffff\u0001\u0184",
            "\u0001\u0185\u001f\uffff\u0001\u0185",
            "\u0001\u0186\u001f\uffff\u0001\u0186",
            "\u0001\u0187\u001f\uffff\u0001\u0187",
            "\u0001\u0188\u001f\uffff\u0001\u0188",
            "\u0001\u0189\u001f\uffff\u0001\u0189",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u0004\u002b\u0001\u018c\u0015\u002b"+
            "\u0004\uffff\u0001\u002b\u0001\uffff\u0004\u002b\u0001\u018c"+
            "\u0015\u002b",
            "\u0001\u018d\u001f\uffff\u0001\u018d",
            "\u0001\u018e\u001f\uffff\u0001\u018e",
            "\u0001\u018f\u001f\uffff\u0001\u018f",
            "",
            "\u0001\u0190\u001f\uffff\u0001\u0190",
            "\u0001\u0191\u001f\uffff\u0001\u0191",
            "\u0001\u0192\u001f\uffff\u0001\u0192",
            "\u0001\u0193\u001f\uffff\u0001\u0193",
            "",
            "\u0001\u0194\u001f\uffff\u0001\u0194",
            "\u0001\u0195\u001f\uffff\u0001\u0195",
            "\u0001\u0196\u001f\uffff\u0001\u0196",
            "\u0001\u0197\u001f\uffff\u0001\u0197",
            "\u0001\u0198\u001f\uffff\u0001\u0198",
            "\u0001\u0199\u001f\uffff\u0001\u0199",
            "\u0001\u019a\u001f\uffff\u0001\u019a",
            "\u0001\u019b\u001f\uffff\u0001\u019b",
            "\u0001\u019c\u001f\uffff\u0001\u019c",
            "\u0001\u019d\u001f\uffff\u0001\u019d",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u019f\u001f\uffff\u0001\u019f",
            "\u0001\u01a0\u001f\uffff\u0001\u01a0",
            "\u000a\u002b\u0007\uffff\u000d\u002b\u0001\u01a2\u000c\u002b"+
            "\u0004\uffff\u0001\u002b\u0001\uffff\u000d\u002b\u0001\u01a2"+
            "\u000c\u002b",
            "\u0001\u01a3\u001f\uffff\u0001\u01a3",
            "\u0001\u01a4\u001f\uffff\u0001\u01a4",
            "\u0001\u01a5\u001f\uffff\u0001\u01a5",
            "\u0001\u01a6\u001f\uffff\u0001\u01a6",
            "\u0001\u01a7\u001f\uffff\u0001\u01a7",
            "\u0001\u01a8\u001f\uffff\u0001\u01a8",
            "\u0001\u01a9\u001f\uffff\u0001\u01a9",
            "\u0001\u01aa\u001f\uffff\u0001\u01aa",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u01ac\u001f\uffff\u0001\u01ac",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u01af\u001f\uffff\u0001\u01af",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0030\u007a\u000a\u01b1\uffc6\u007a",
            "\u0030\u007a\u000a\u01b2\uffc6\u007a",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u01b4\u001f\uffff\u0001\u01b4",
            "\u0001\u01b5\u001f\uffff\u0001\u01b5",
            "\u0001\u01b6\u001f\uffff\u0001\u01b6",
            "\u0001\u01b7\u001f\uffff\u0001\u01b7",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u01b9\u001f\uffff\u0001\u01b9",
            "\u0001\u01ba\u001f\uffff\u0001\u01ba",
            "\u0001\u01bc\u000b\uffff\u0001\u01bd\u0004\uffff\u0001\u01bb"+
            "\u000e\uffff\u0001\u01bc\u000b\uffff\u0001\u01bd\u0004\uffff"+
            "\u0001\u01bb",
            "\u0001\u01be\u001f\uffff\u0001\u01be",
            "\u0001\u01bf\u001f\uffff\u0001\u01bf",
            "\u0001\u01c0\u001f\uffff\u0001\u01c0",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u01c3\u001f\uffff\u0001\u01c3",
            "\u0001\u01c4\u001f\uffff\u0001\u01c4",
            "\u0001\u01c5\u001f\uffff\u0001\u01c5",
            "\u0001\u01c6\u001f\uffff\u0001\u01c6",
            "",
            "\u0001\u01c7\u001f\uffff\u0001\u01c7",
            "\u0001\u01c8\u001f\uffff\u0001\u01c8",
            "\u0001\u01c9\u001f\uffff\u0001\u01c9",
            "\u0001\u01ca\u001f\uffff\u0001\u01ca",
            "\u0001\u01cb\u001f\uffff\u0001\u01cb",
            "",
            "\u0001\u01cc\u001f\uffff\u0001\u01cc",
            "\u0001\u01ce\u0008\uffff\u0001\u01cf\u0003\uffff\u0001\u01cd"+
            "\u0012\uffff\u0001\u01ce\u0008\uffff\u0001\u01cf\u0003\uffff"+
            "\u0001\u01cd",
            "\u0001\u01d0\u001f\uffff\u0001\u01d0",
            "\u0001\u01d1\u001f\uffff\u0001\u01d1",
            "\u0001\u01d2\u001f\uffff\u0001\u01d2",
            "\u0001\u01d3\u001f\uffff\u0001\u01d3",
            "\u000a\u002b\u0007\uffff\u0011\u002b\u0001\u01d5\u0008\u002b"+
            "\u0004\uffff\u0001\u002b\u0001\uffff\u0011\u002b\u0001\u01d5"+
            "\u0008\u002b",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u01d7\u001f\uffff\u0001\u01d7",
            "\u0001\u01d8\u001f\uffff\u0001\u01d8",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u01da\u001f\uffff\u0001\u01da",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u01dc\u001f\uffff\u0001\u01dc",
            "\u0001\u01dd\u001f\uffff\u0001\u01dd",
            "\u0001\u01de\u001f\uffff\u0001\u01de",
            "\u0001\u01df\u001f\uffff\u0001\u01df",
            "",
            "\u0001\u01e0\u001f\uffff\u0001\u01e0",
            "\u0001\u01e1\u001f\uffff\u0001\u01e1",
            "\u0001\u01e2\u001f\uffff\u0001\u01e2",
            "\u0001\u01e3\u001f\uffff\u0001\u01e3",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u01e6\u001f\uffff\u0001\u01e6",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u01e8\u001f\uffff\u0001\u01e8",
            "\u0001\u01e9\u001f\uffff\u0001\u01e9",
            "\u0001\u01ea\u001f\uffff\u0001\u01ea",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u01ec\u001f\uffff\u0001\u01ec",
            "",
            "",
            "\u0001\u01ed\u001f\uffff\u0001\u01ed",
            "\u0001\u01ee\u001f\uffff\u0001\u01ee",
            "\u0001\u01ef\u001f\uffff\u0001\u01ef",
            "\u0001\u01f0\u001f\uffff\u0001\u01f0",
            "\u0001\u01f1\u001f\uffff\u0001\u01f1",
            "\u0001\u01f2\u001f\uffff\u0001\u01f2",
            "\u0001\u01f3\u001f\uffff\u0001\u01f3",
            "\u0001\u01f4\u001f\uffff\u0001\u01f4",
            "\u0001\u01f5\u001f\uffff\u0001\u01f5",
            "\u0001\u01f6\u001f\uffff\u0001\u01f6",
            "\u0001\u01f7\u001f\uffff\u0001\u01f7",
            "\u0001\u01f8\u001f\uffff\u0001\u01f8",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u01fa\u001f\uffff\u0001\u01fa",
            "\u0001\u01fb\u001f\uffff\u0001\u01fb",
            "\u0001\u01fc\u001f\uffff\u0001\u01fc",
            "\u0001\u01fd\u001f\uffff\u0001\u01fd",
            "\u0001\u01fe\u001f\uffff\u0001\u01fe",
            "",
            "\u0001\u01ff\u001f\uffff\u0001\u01ff",
            "\u0001\u0200\u001f\uffff\u0001\u0200",
            "",
            "\u0001\u0201\u001f\uffff\u0001\u0201",
            "\u0001\u0202\u001f\uffff\u0001\u0202",
            "\u0001\u0203\u001f\uffff\u0001\u0203",
            "\u0001\u0205\u000b\uffff\u0001\u0204\u0013\uffff\u0001\u0205"+
            "\u000b\uffff\u0001\u0204",
            "\u0001\u0206\u001f\uffff\u0001\u0206",
            "\u0001\u0207\u001f\uffff\u0001\u0207",
            "\u0001\u0208\u001f\uffff\u0001\u0208",
            "\u0001\u0209\u001f\uffff\u0001\u0209",
            "\u0001\u020a\u001f\uffff\u0001\u020a",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "",
            "\u0001\u020c\u001f\uffff\u0001\u020c",
            "",
            "\u002d\u007a\u0001\u020d\u0001\u007a\u0001\u020d\uffd0\u007a",
            "\u002d\u007a\u0001\u020e\u0001\u007a\u0001\u020e\uffd0\u007a",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u0001\u002b\u0001\u0215\u0005\u002b"+
            "\u0001\u0214\u0001\u0213\u0002\u002b\u0001\u0212\u0001\u002b"+
            "\u0001\u0211\u000c\u002b\u0004\uffff\u0001\u002b\u0001\uffff"+
            "\u0001\u002b\u0001\u0215\u0005\u002b\u0001\u0214\u0001\u0213"+
            "\u0002\u002b\u0001\u0212\u0001\u002b\u0001\u0211\u000c\u002b",
            "\u0001\u0216\u001f\uffff\u0001\u0216",
            "\u0001\u0217\u001f\uffff\u0001\u0217",
            "",
            "\u0001\u0218\u001f\uffff\u0001\u0218",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u021a\u001f\uffff\u0001\u021a",
            "\u0001\u021b\u001f\uffff\u0001\u021b",
            "\u0001\u021c\u001f\uffff\u0001\u021c",
            "\u0001\u021d\u001f\uffff\u0001\u021d",
            "\u0001\u021e\u001f\uffff\u0001\u021e",
            "\u0001\u021f\u001f\uffff\u0001\u021f",
            "",
            "",
            "\u000a\u002b\u0007\uffff\u0013\u002b\u0001\u0221\u0006\u002b"+
            "\u0004\uffff\u0001\u002b\u0001\uffff\u0013\u002b\u0001\u0221"+
            "\u0006\u002b",
            "\u0001\u0222\u001f\uffff\u0001\u0222",
            "\u0001\u0223\u001f\uffff\u0001\u0223",
            "\u0001\u0224\u001f\uffff\u0001\u0224",
            "\u0001\u0225\u001f\uffff\u0001\u0225",
            "\u0001\u0226\u001f\uffff\u0001\u0226",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0228\u001f\uffff\u0001\u0228",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u022a\u001f\uffff\u0001\u022a",
            "\u0001\u022b\u001f\uffff\u0001\u022b",
            "\u0001\u022c\u001f\uffff\u0001\u022c",
            "\u0001\u022d\u001f\uffff\u0001\u022d",
            "\u0001\u022e\u001f\uffff\u0001\u022e",
            "\u0001\u022f\u001f\uffff\u0001\u022f",
            "\u0001\u0230\u001f\uffff\u0001\u0230",
            "\u0001\u0231\u001f\uffff\u0001\u0231",
            "",
            "\u0001\u0232\u001f\uffff\u0001\u0232",
            "",
            "\u0001\u0233\u001f\uffff\u0001\u0233",
            "\u0001\u0234\u001f\uffff\u0001\u0234",
            "",
            "\u0001\u0235\u001f\uffff\u0001\u0235",
            "",
            "\u000a\u002b\u0007\uffff\u0002\u002b\u0001\u0237\u0009\u002b"+
            "\u0001\u0238\u000d\u002b\u0004\uffff\u0001\u002b\u0001\uffff"+
            "\u0002\u002b\u0001\u0237\u0009\u002b\u0001\u0238\u000d\u002b",
            "\u0001\u0239\u001f\uffff\u0001\u0239",
            "\u0001\u023a\u001f\uffff\u0001\u023a",
            "\u0001\u023b\u001f\uffff\u0001\u023b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u023d\u0003\uffff\u0001\u023e\u001b\uffff\u0001\u023d"+
            "\u0003\uffff\u0001\u023e",
            "\u0001\u023f\u001f\uffff\u0001\u023f",
            "\u0001\u0240\u001f\uffff\u0001\u0240",
            "",
            "",
            "\u0001\u0241\u001f\uffff\u0001\u0241",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0243\u001f\uffff\u0001\u0243",
            "\u0001\u0244\u001f\uffff\u0001\u0244",
            "",
            "\u0001\u0245\u001f\uffff\u0001\u0245",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0247\u001f\uffff\u0001\u0247",
            "\u0001\u0248\u001f\uffff\u0001\u0248",
            "\u0001\u0249\u001f\uffff\u0001\u0249",
            "\u0001\u024a\u001f\uffff\u0001\u024a",
            "\u0001\u024b\u001f\uffff\u0001\u024b",
            "\u0001\u024c\u001f\uffff\u0001\u024c",
            "\u0001\u024d\u001f\uffff\u0001\u024d",
            "\u0001\u024e\u001f\uffff\u0001\u024e",
            "\u0001\u024f\u001f\uffff\u0001\u024f",
            "\u0001\u0250\u001f\uffff\u0001\u0250",
            "\u0001\u0251\u001f\uffff\u0001\u0251",
            "",
            "\u0001\u0252\u001f\uffff\u0001\u0252",
            "\u0001\u0253\u001f\uffff\u0001\u0253",
            "\u0001\u0254\u0001\uffff\u0001\u0255\u001d\uffff\u0001\u0254"+
            "\u0001\uffff\u0001\u0255",
            "\u0001\u0256\u001f\uffff\u0001\u0256",
            "\u0001\u0257\u001f\uffff\u0001\u0257",
            "\u0001\u0258\u001f\uffff\u0001\u0258",
            "\u0001\u0259\u001f\uffff\u0001\u0259",
            "\u0001\u025a\u001f\uffff\u0001\u025a",
            "\u0001\u025b\u001f\uffff\u0001\u025b",
            "\u0001\u025c\u001f\uffff\u0001\u025c",
            "\u0001\u025d\u001f\uffff\u0001\u025d",
            "\u0001\u025e\u001f\uffff\u0001\u025e",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0260\u001f\uffff\u0001\u0260",
            "\u0001\u0261\u001f\uffff\u0001\u0261",
            "\u0001\u0262\u001f\uffff\u0001\u0262",
            "\u0001\u0263\u001f\uffff\u0001\u0263",
            "",
            "\u0001\u0264\u001f\uffff\u0001\u0264",
            "\u0030\u007a\u000a\u0265\uffc6\u007a",
            "\u0030\u007a\u000a\u0266\uffc6\u007a",
            "",
            "",
            "\u0001\u0267\u001f\uffff\u0001\u0267",
            "\u0001\u0268\u001f\uffff\u0001\u0268",
            "\u0001\u0269\u001f\uffff\u0001\u0269",
            "\u0001\u026a\u001f\uffff\u0001\u026a",
            "\u0001\u026b\u001f\uffff\u0001\u026b",
            "\u0001\u026c\u001f\uffff\u0001\u026c",
            "\u0001\u026d\u001f\uffff\u0001\u026d",
            "\u0001\u026e\u0010\uffff\u0001\u026f\u000e\uffff\u0001\u026e"+
            "\u0010\uffff\u0001\u026f",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0271\u001f\uffff\u0001\u0271",
            "\u0001\u0272\u001f\uffff\u0001\u0272",
            "\u0001\u0274\u000b\uffff\u0001\u0273\u0013\uffff\u0001\u0274"+
            "\u000b\uffff\u0001\u0273",
            "\u0001\u0275\u001f\uffff\u0001\u0275",
            "\u0001\u0276\u001f\uffff\u0001\u0276",
            "",
            "\u0001\u0277\u001f\uffff\u0001\u0277",
            "\u0001\u0278\u001f\uffff\u0001\u0278",
            "\u0001\u0279\u001f\uffff\u0001\u0279",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u027b\u001f\uffff\u0001\u027b",
            "\u0001\u027c\u001f\uffff\u0001\u027c",
            "",
            "\u0001\u027d\u001f\uffff\u0001\u027d",
            "",
            "\u0001\u027e\u001f\uffff\u0001\u027e",
            "\u0001\u027f\u001f\uffff\u0001\u027f",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0281\u001f\uffff\u0001\u0281",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0283\u001f\uffff\u0001\u0283",
            "\u0001\u0284\u001f\uffff\u0001\u0284",
            "\u0001\u0285\u001f\uffff\u0001\u0285",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0287\u001f\uffff\u0001\u0287",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u0001\u028a\u001f\uffff\u0001\u028a",
            "\u0001\u028b\u001f\uffff\u0001\u028b",
            "\u0001\u028c\u001f\uffff\u0001\u028c",
            "\u0001\u028d\u001f\uffff\u0001\u028d",
            "\u0001\u028e\u001f\uffff\u0001\u028e",
            "",
            "\u0001\u028f\u001f\uffff\u0001\u028f",
            "\u0001\u0290\u001f\uffff\u0001\u0290",
            "\u0001\u0291\u001f\uffff\u0001\u0291",
            "\u0001\u0292\u001f\uffff\u0001\u0292",
            "\u0001\u0293\u001f\uffff\u0001\u0293",
            "",
            "\u0001\u0294\u001f\uffff\u0001\u0294",
            "\u0001\u0295\u001f\uffff\u0001\u0295",
            "\u0001\u0296\u001f\uffff\u0001\u0296",
            "",
            "\u0001\u0297\u001f\uffff\u0001\u0297",
            "\u0001\u0298\u001f\uffff\u0001\u0298",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u029a\u001f\uffff\u0001\u029a",
            "\u0001\u029b\u001f\uffff\u0001\u029b",
            "\u0001\u029c\u001f\uffff\u0001\u029c",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u029f\u001f\uffff\u0001\u029f",
            "\u0001\u02a0\u001f\uffff\u0001\u02a0",
            "\u0001\u02a1\u001f\uffff\u0001\u02a1",
            "\u0001\u02a2\u001f\uffff\u0001\u02a2",
            "\u0001\u02a3\u001f\uffff\u0001\u02a3",
            "\u0001\u02a4\u001f\uffff\u0001\u02a4",
            "\u0001\u02a5\u001f\uffff\u0001\u02a5",
            "\u0001\u02a6\u001f\uffff\u0001\u02a6",
            "\u0001\u02a7\u001f\uffff\u0001\u02a7",
            "\u0001\u02a8\u001f\uffff\u0001\u02a8",
            "\u0001\u02a9\u001f\uffff\u0001\u02a9",
            "\u0001\u02aa\u001f\uffff\u0001\u02aa",
            "\u0001\u02ab\u001f\uffff\u0001\u02ab",
            "\u0001\u02ac\u001f\uffff\u0001\u02ac",
            "\u0001\u02ad\u0002\uffff\u0001\u02ae\u001c\uffff\u0001\u02ad"+
            "\u0002\uffff\u0001\u02ae",
            "\u0001\u02af\u001f\uffff\u0001\u02af",
            "",
            "\u0001\u02b0\u001f\uffff\u0001\u02b0",
            "\u0001\u02b1\u001f\uffff\u0001\u02b1",
            "\u0001\u02b2\u001f\uffff\u0001\u02b2",
            "\u0001\u02b3\u001f\uffff\u0001\u02b3",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0030\u007a\u000a\u02b5\uffc6\u007a",
            "\u0030\u007a\u000a\u02b6\uffc6\u007a",
            "\u0001\u02b7\u001f\uffff\u0001\u02b7",
            "\u0001\u02b8\u001f\uffff\u0001\u02b8",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u02ba\u001f\uffff\u0001\u02ba",
            "\u0001\u02bb\u001f\uffff\u0001\u02bb",
            "\u0001\u02bc\u001f\uffff\u0001\u02bc",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u02be\u001f\uffff\u0001\u02be",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u0001\u02c0\u001f\uffff\u0001\u02c0",
            "\u0001\u02c1\u001f\uffff\u0001\u02c1",
            "\u0001\u02c2\u001f\uffff\u0001\u02c2",
            "\u0001\u02c3\u001f\uffff\u0001\u02c3",
            "\u0001\u02c4\u001f\uffff\u0001\u02c4",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u02c6\u001f\uffff\u0001\u02c6",
            "\u0001\u02c7\u001f\uffff\u0001\u02c7",
            "\u0001\u02c8\u001f\uffff\u0001\u02c8",
            "",
            "\u0001\u02c9\u001f\uffff\u0001\u02c9",
            "\u0001\u02ca\u001f\uffff\u0001\u02ca",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u02cc\u001f\uffff\u0001\u02cc",
            "\u0001\u02cd\u001f\uffff\u0001\u02cd",
            "",
            "\u0001\u02ce\u001f\uffff\u0001\u02ce",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u02d0\u001f\uffff\u0001\u02d0",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u0001\u02d2\u001f\uffff\u0001\u02d2",
            "",
            "",
            "\u0001\u02d3\u001f\uffff\u0001\u02d3",
            "\u0001\u02d4\u001f\uffff\u0001\u02d4",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u02d7\u001f\uffff\u0001\u02d7",
            "\u0001\u02d8\u001f\uffff\u0001\u02d8",
            "\u0001\u02d9\u001f\uffff\u0001\u02d9",
            "\u0001\u02da\u001f\uffff\u0001\u02da",
            "\u0001\u02db\u001f\uffff\u0001\u02db",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u0008\u002b\u0001\u02de\u0011\u002b"+
            "\u0004\uffff\u0001\u002b\u0001\uffff\u0008\u002b\u0001\u02de"+
            "\u0011\u002b",
            "\u0001\u02df\u001f\uffff\u0001\u02df",
            "\u0001\u02e0\u001f\uffff\u0001\u02e0",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u0001\u02e2\u001f\uffff\u0001\u02e2",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u02e4\u001f\uffff\u0001\u02e4",
            "",
            "",
            "\u0001\u02e5\u001f\uffff\u0001\u02e5",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u02e7\u001f\uffff\u0001\u02e7",
            "\u0001\u02e8\u001f\uffff\u0001\u02e8",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u02ea\u001f\uffff\u0001\u02ea",
            "\u0001\u02eb\u001f\uffff\u0001\u02eb",
            "\u0001\u02ec\u001f\uffff\u0001\u02ec",
            "\u0001\u02ed\u001f\uffff\u0001\u02ed",
            "\u0001\u02ee\u001f\uffff\u0001\u02ee",
            "\u0001\u02ef\u001f\uffff\u0001\u02ef",
            "\u0001\u02f0\u001f\uffff\u0001\u02f0",
            "\u0001\u02f1\u001f\uffff\u0001\u02f1",
            "\u0001\u02f2\u001f\uffff\u0001\u02f2",
            "\u0001\u02f3\u001f\uffff\u0001\u02f3",
            "\u0001\u02f4\u001f\uffff\u0001\u02f4",
            "\u0001\u02f5\u001f\uffff\u0001\u02f5",
            "\u0001\u02f6\u001f\uffff\u0001\u02f6",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u02f8\u001f\uffff\u0001\u02f8",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u002d\u007a\u0001\u02fa\u0001\u007a\u0001\u02fa\uffd0\u007a",
            "\u002d\u007a\u0001\u02fb\u0001\u007a\u0001\u02fb\uffd0\u007a",
            "\u0001\u02fc\u001f\uffff\u0001\u02fc",
            "\u0001\u02fd\u001f\uffff\u0001\u02fd",
            "",
            "\u0001\u02fe\u001f\uffff\u0001\u02fe",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u000a\u002b\u0007\uffff\u0015\u002b\u0001\u0302\u0004\u002b"+
            "\u0004\uffff\u0001\u002b\u0001\uffff\u0015\u002b\u0001\u0302"+
            "\u0004\u002b",
            "",
            "\u0001\u0303\u001f\uffff\u0001\u0303",
            "\u0001\u0304\u001f\uffff\u0001\u0304",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0306\u001f\uffff\u0001\u0306",
            "\u0001\u0307\u001f\uffff\u0001\u0307",
            "",
            "\u0001\u0308\u001f\uffff\u0001\u0308",
            "\u0001\u0309\u001f\uffff\u0001\u0309",
            "\u000a\u002b\u0007\uffff\u0015\u002b\u0001\u030b\u0004\u002b"+
            "\u0004\uffff\u0001\u002b\u0001\uffff\u0015\u002b\u0001\u030b"+
            "\u0004\u002b",
            "\u0001\u030c\u001f\uffff\u0001\u030c",
            "\u0001\u030d\u001f\uffff\u0001\u030d",
            "",
            "\u0001\u030e\u001f\uffff\u0001\u030e",
            "\u0001\u030f\u001f\uffff\u0001\u030f",
            "\u0001\u0310\u001f\uffff\u0001\u0310",
            "",
            "\u0001\u0311\u001f\uffff\u0001\u0311",
            "",
            "\u0001\u0312\u001f\uffff\u0001\u0312",
            "\u0001\u0313\u001f\uffff\u0001\u0313",
            "\u0001\u0314\u001f\uffff\u0001\u0314",
            "",
            "",
            "\u000a\u002b\u0007\uffff\u0013\u002b\u0001\u0316\u0006\u002b"+
            "\u0004\uffff\u0001\u002b\u0001\uffff\u0013\u002b\u0001\u0316"+
            "\u0006\u002b",
            "\u0001\u0317\u001f\uffff\u0001\u0317",
            "\u0001\u0318\u001f\uffff\u0001\u0318",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u031a\u001f\uffff\u0001\u031a",
            "",
            "",
            "\u0001\u031b\u001f\uffff\u0001\u031b",
            "\u0001\u031c\u001f\uffff\u0001\u031c",
            "\u0001\u031d\u001f\uffff\u0001\u031d",
            "",
            "\u0001\u031e\u001f\uffff\u0001\u031e",
            "",
            "\u0001\u031f\u001f\uffff\u0001\u031f",
            "\u0001\u0320\u001f\uffff\u0001\u0320",
            "",
            "\u0001\u0321\u001f\uffff\u0001\u0321",
            "\u0001\u0322\u001f\uffff\u0001\u0322",
            "",
            "\u0001\u0323\u001f\uffff\u0001\u0323",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0325\u001f\uffff\u0001\u0325",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0327\u001f\uffff\u0001\u0327",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0329\u001f\uffff\u0001\u0329",
            "\u0001\u032a\u001f\uffff\u0001\u032a",
            "\u0001\u032b\u001f\uffff\u0001\u032b",
            "\u0001\u032c\u001f\uffff\u0001\u032c",
            "\u0001\u032d\u001f\uffff\u0001\u032d",
            "\u0001\u032e\u001f\uffff\u0001\u032e",
            "\u0001\u032f\u001f\uffff\u0001\u032f",
            "",
            "\u0001\u0330\u001f\uffff\u0001\u0330",
            "",
            "\u0030\u007a\u000a\u0331\uffc6\u007a",
            "\u0030\u007a\u000a\u0332\uffc6\u007a",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0334\u001f\uffff\u0001\u0334",
            "\u0001\u0335\u001f\uffff\u0001\u0335",
            "",
            "",
            "",
            "\u0001\u0336\u001f\uffff\u0001\u0336",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0338\u001f\uffff\u0001\u0338",
            "",
            "\u0001\u0339\u001f\uffff\u0001\u0339",
            "\u0001\u033a\u001f\uffff\u0001\u033a",
            "\u0001\u033b\u001f\uffff\u0001\u033b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u0001\u033d\u001f\uffff\u0001\u033d",
            "\u0001\u033e\u001f\uffff\u0001\u033e",
            "\u0001\u033f\u001f\uffff\u0001\u033f",
            "\u0001\u0340\u001f\uffff\u0001\u0340",
            "\u0001\u0341\u001f\uffff\u0001\u0341",
            "\u0001\u0342\u001f\uffff\u0001\u0342",
            "\u0001\u0343\u001f\uffff\u0001\u0343",
            "\u0001\u0344\u001f\uffff\u0001\u0344",
            "\u0001\u0345\u001f\uffff\u0001\u0345",
            "\u0001\u0346\u001f\uffff\u0001\u0346",
            "",
            "\u0001\u0347\u001f\uffff\u0001\u0347",
            "\u0001\u0348\u001f\uffff\u0001\u0348",
            "\u0001\u0349\u001f\uffff\u0001\u0349",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u034d\u001f\uffff\u0001\u034d",
            "\u0001\u034e\u001f\uffff\u0001\u034e",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0352\u001f\uffff\u0001\u0352",
            "\u0001\u0353\u001f\uffff\u0001\u0353",
            "",
            "\u0001\u0354\u001f\uffff\u0001\u0354",
            "",
            "\u0001\u0355\u001f\uffff\u0001\u0355",
            "",
            "\u0001\u0356\u001f\uffff\u0001\u0356",
            "\u0001\u0357\u001f\uffff\u0001\u0357",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0359\u001f\uffff\u0001\u0359",
            "\u0001\u035a\u001f\uffff\u0001\u035a",
            "\u0001\u035b\u001f\uffff\u0001\u035b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u035d\u001f\uffff\u0001\u035d",
            "\u0030\u007a\u000a\u035e\uffc6\u007a",
            "\u0030\u007a\u000a\u035f\uffc6\u007a",
            "",
            "\u0001\u0360\u001f\uffff\u0001\u0360",
            "\u0001\u0361\u001f\uffff\u0001\u0361",
            "\u0001\u0362\u001f\uffff\u0001\u0362",
            "",
            "\u0001\u0363\u001f\uffff\u0001\u0363",
            "\u0001\u0364\u001f\uffff\u0001\u0364",
            "\u0001\u0365\u001f\uffff\u0001\u0365",
            "\u0001\u0366\u001f\uffff\u0001\u0366",
            "",
            "\u0001\u0367\u001f\uffff\u0001\u0367",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0369\u001f\uffff\u0001\u0369",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u036b\u001f\uffff\u0001\u036b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u036d\u001f\uffff\u0001\u036d",
            "\u0001\u036e\u001f\uffff\u0001\u036e",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0370\u001f\uffff\u0001\u0370",
            "\u0001\u0371\u001f\uffff\u0001\u0371",
            "\u0001\u0372\u001f\uffff\u0001\u0372",
            "\u0001\u0373\u001f\uffff\u0001\u0373",
            "",
            "",
            "",
            "\u0001\u0374\u001f\uffff\u0001\u0374",
            "\u0001\u0375\u001f\uffff\u0001\u0375",
            "",
            "",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0377\u001f\uffff\u0001\u0377",
            "\u0001\u0378\u001f\uffff\u0001\u0378",
            "\u0001\u037b\u0001\uffff\u0001\u037d\u0001\u0379\u0002\uffff"+
            "\u0001\u037e\u0005\uffff\u0001\u037a\u0004\uffff\u0001\u037c"+
            "\u000e\uffff\u0001\u037b\u0001\uffff\u0001\u037d\u0001\u0379"+
            "\u0002\uffff\u0001\u037e\u0005\uffff\u0001\u037a\u0004\uffff"+
            "\u0001\u037c",
            "\u0001\u037f\u001f\uffff\u0001\u037f",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u0001\u0381\u001f\uffff\u0001\u0381",
            "\u0001\u0382\u001f\uffff\u0001\u0382",
            "\u0001\u0383\u001f\uffff\u0001\u0383",
            "",
            "\u0001\u0384\u001f\uffff\u0001\u0384",
            "\u0020\u007a\u0001\u0385\u0001\u007a\u0001\u0386\uffdd\u007a",
            "\u0020\u007a\u0001\u0387\u0006\u007a\u0001\u0388\uffd8\u007a",
            "\u0001\u0389\u001f\uffff\u0001\u0389",
            "\u000a\u002b\u0007\uffff\u0008\u002b\u0001\u038b\u0011\u002b"+
            "\u0004\uffff\u0001\u002b\u0001\uffff\u0008\u002b\u0001\u038b"+
            "\u0011\u002b",
            "\u0001\u038c\u001f\uffff\u0001\u038c",
            "\u0001\u038d\u001f\uffff\u0001\u038d",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0390\u001f\uffff\u0001\u0390",
            "\u0001\u0391\u001f\uffff\u0001\u0391",
            "",
            "\u0001\u0392\u001f\uffff\u0001\u0392",
            "",
            "\u0001\u0393\u001f\uffff\u0001\u0393",
            "",
            "\u0001\u0394\u001f\uffff\u0001\u0394",
            "\u0001\u0395\u001f\uffff\u0001\u0395",
            "",
            "\u0001\u0396\u001f\uffff\u0001\u0396",
            "\u0001\u0397\u001f\uffff\u0001\u0397",
            "\u0001\u0398\u001f\uffff\u0001\u0398",
            "\u0001\u0399\u001f\uffff\u0001\u0399",
            "\u0001\u039a\u001f\uffff\u0001\u039a",
            "\u0001\u039b\u001f\uffff\u0001\u039b",
            "",
            "\u0001\u039c\u001f\uffff\u0001\u039c",
            "\u0001\u039d\u001f\uffff\u0001\u039d",
            "\u0001\u039e\u001f\uffff\u0001\u039e",
            "\u0001\u039f\u001f\uffff\u0001\u039f",
            "\u0001\u03a0\u0005\uffff\u0001\u03a1\u0019\uffff\u0001\u03a0"+
            "\u0005\uffff\u0001\u03a1",
            "\u0001\u03a2\u001f\uffff\u0001\u03a2",
            "\u0001\u03a3\u001f\uffff\u0001\u03a3",
            "\u0001\u03a4\u001f\uffff\u0001\u03a4",
            "\u0001\u03a5\u001f\uffff\u0001\u03a5",
            "",
            "\u0001\u03a6\u001f\uffff\u0001\u03a6",
            "\u0001\u03a7\u001f\uffff\u0001\u03a7",
            "\u0001\u03a8\u001f\uffff\u0001\u03a8",
            "\u0001\u03a9\u001f\uffff\u0001\u03a9",
            "\u0030\u007a\u000a\u03aa\uffc6\u007a",
            "",
            "\u0030\u007a\u000a\u03ac\uffc6\u007a",
            "",
            "\u0001\u03ad\u001f\uffff\u0001\u03ad",
            "",
            "\u0001\u03ae\u001f\uffff\u0001\u03ae",
            "\u0001\u03af\u001f\uffff\u0001\u03af",
            "\u0001\u03b0\u001f\uffff\u0001\u03b0",
            "",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u03b2\u001f\uffff\u0001\u03b2",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u03b5\u001f\uffff\u0001\u03b5",
            "\u0001\u03b6\u001f\uffff\u0001\u03b6",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u03ba\u001f\uffff\u0001\u03ba",
            "\u0001\u03bb\u001f\uffff\u0001\u03bb",
            "\u0001\u03bc\u001f\uffff\u0001\u03bc",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u03c0\u001f\uffff\u0001\u03c0",
            "\u0001\u03c1\u001f\uffff\u0001\u03c1",
            "\u0001\u03c2\u001f\uffff\u0001\u03c2",
            "\u0001\u03c4\u000b\uffff\u0001\u03c3\u0013\uffff\u0001\u03c4"+
            "\u000b\uffff\u0001\u03c3",
            "\u0001\u03c5\u001f\uffff\u0001\u03c5",
            "\u0001\u03c6\u001f\uffff\u0001\u03c6",
            "\u0001\u03c7\u001f\uffff\u0001\u03c7",
            "\u0001\u03c8\u001f\uffff\u0001\u03c8",
            "\u0001\u03c9\u001f\uffff\u0001\u03c9",
            "\u0001\u03ca\u001f\uffff\u0001\u03ca",
            "\u0001\u03cb\u001f\uffff\u0001\u03cb",
            "\u0030\u007a\u000a\u03cc\uffc6\u007a",
            "",
            "\u0030\u007a\u000a\u03cd\uffc6\u007a",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u03d0\u001f\uffff\u0001\u03d0",
            "\u0001\u03d1\u001f\uffff\u0001\u03d1",
            "",
            "\u0001\u03d2\u001f\uffff\u0001\u03d2",
            "",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u03d4\u001f\uffff\u0001\u03d4",
            "",
            "",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u03d6\u001f\uffff\u0001\u03d6",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "",
            "",
            "\u0001\u03d8\u001f\uffff\u0001\u03d8",
            "\u0001\u03d9\u001f\uffff\u0001\u03d9",
            "\u0001\u03da\u001f\uffff\u0001\u03da",
            "\u0001\u03db\u001f\uffff\u0001\u03db",
            "\u0001\u03dc\u0005\uffff\u0001\u03dd\u0019\uffff\u0001\u03dc"+
            "\u0005\uffff\u0001\u03dd",
            "\u0001\u03de\u001f\uffff\u0001\u03de",
            "\u0001\u03df\u001f\uffff\u0001\u03df",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u03e1\u001f\uffff\u0001\u03e1",
            "\u0001\u03e2\u001f\uffff\u0001\u03e2",
            "\u0001\u03e3\u001f\uffff\u0001\u03e3",
            "\u0001\u03e4\u001f\uffff\u0001\u03e4",
            "\u003a\u007a\u0001\u03e5\uffc5\u007a",
            "\u003a\u007a\u0001\u03e6\uffc5\u007a",
            "",
            "",
            "\u0001\u03e7\u001f\uffff\u0001\u03e7",
            "\u0001\u03e8\u001f\uffff\u0001\u03e8",
            "\u0001\u03e9\u001f\uffff\u0001\u03e9",
            "",
            "\u0001\u03ea\u001f\uffff\u0001\u03ea",
            "",
            "\u0001\u03eb\u001f\uffff\u0001\u03eb",
            "",
            "\u0001\u03ec\u001f\uffff\u0001\u03ec",
            "\u0001\u03ed\u001f\uffff\u0001\u03ed",
            "\u0001\u03ee\u001f\uffff\u0001\u03ee",
            "\u0001\u03ef\u001f\uffff\u0001\u03ef",
            "\u0001\u03f0\u001f\uffff\u0001\u03f0",
            "\u0001\u03f1\u001f\uffff\u0001\u03f1",
            "\u0001\u03f2\u001f\uffff\u0001\u03f2",
            "\u0001\u03f3\u001f\uffff\u0001\u03f3",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u03f5\u001f\uffff\u0001\u03f5",
            "\u0001\u03f6\u001f\uffff\u0001\u03f6",
            "\u0001\u03f7\u001f\uffff\u0001\u03f7",
            "\u0030\u007a\u000a\u03f8\uffc6\u007a",
            "\u0030\u007a\u000a\u03f9\uffc6\u007a",
            "\u0001\u03fa\u001f\uffff\u0001\u03fa",
            "\u0001\u03fb\u001f\uffff\u0001\u03fb",
            "\u0001\u03fc\u001f\uffff\u0001\u03fc",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u03fe\u001f\uffff\u0001\u03fe",
            "\u0001\u03ff\u001f\uffff\u0001\u03ff",
            "\u0001\u0401\u0004\uffff\u0001\u0400\u001a\uffff\u0001\u0401"+
            "\u0004\uffff\u0001\u0400",
            "\u0001\u0402\u001f\uffff\u0001\u0402",
            "\u0001\u0403\u001f\uffff\u0001\u0403",
            "\u0001\u0404\u001f\uffff\u0001\u0404",
            "\u0001\u0405\u001f\uffff\u0001\u0405",
            "\u0001\u0406\u001f\uffff\u0001\u0406",
            "\u0001\u0407\u001f\uffff\u0001\u0407",
            "",
            "\u0001\u0408\u001f\uffff\u0001\u0408",
            "\u0001\u0409\u001f\uffff\u0001\u0409",
            "\u0001\u040a\u001f\uffff\u0001\u040a",
            "\u0030\u007a\u000a\u040b\uffc6\u007a",
            "\u0030\u007a\u000a\u040c\uffc6\u007a",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u040e\u001f\uffff\u0001\u040e",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0411\u001f\uffff\u0001\u0411",
            "\u0001\u0412\u001f\uffff\u0001\u0412",
            "\u0001\u0413\u001f\uffff\u0001\u0413",
            "\u0001\u0414\u001f\uffff\u0001\u0414",
            "\u0001\u0415\u001f\uffff\u0001\u0415",
            "\u0001\u0416\u001f\uffff\u0001\u0416",
            "\u0001\u0417\u001f\uffff\u0001\u0417",
            "\u0001\u0418\u001f\uffff\u0001\u0418",
            "\u0001\u0419\u001f\uffff\u0001\u0419",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u041b\u001f\uffff\u0001\u041b",
            "\u0001\u041c\u001f\uffff\u0001\u041c",
            "\u0022\u007a\u0001\u0386\u0017\u007a\u0001\u041d\uffc5\u007a",
            "\u0027\u007a\u0001\u0388\u0012\u007a\u0001\u041e\uffc5\u007a",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "",
            "\u0001\u0420\u001f\uffff\u0001\u0420",
            "\u0001\u0421\u001f\uffff\u0001\u0421",
            "\u0001\u0422\u001f\uffff\u0001\u0422",
            "\u0001\u0423\u001f\uffff\u0001\u0423",
            "\u0001\u0424\u001f\uffff\u0001\u0424",
            "\u0001\u0425\u001f\uffff\u0001\u0425",
            "\u0001\u0426\u001f\uffff\u0001\u0426",
            "\u0001\u0427\u001f\uffff\u0001\u0427",
            "\u0001\u0428\u001f\uffff\u0001\u0428",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u042a\u001f\uffff\u0001\u042a",
            "\u0030\u007a\u000a\u042b\uffc6\u007a",
            "\u0030\u007a\u000a\u042c\uffc6\u007a",
            "",
            "\u0001\u042d\u001f\uffff\u0001\u042d",
            "\u0001\u042e\u001f\uffff\u0001\u042e",
            "\u0001\u042f\u001f\uffff\u0001\u042f",
            "\u0001\u0430\u001f\uffff\u0001\u0430",
            "\u0001\u0431\u001f\uffff\u0001\u0431",
            "\u0001\u0432\u001f\uffff\u0001\u0432",
            "\u0001\u0433\u001f\uffff\u0001\u0433",
            "\u0001\u0434\u001f\uffff\u0001\u0434",
            "\u0001\u0435\u001f\uffff\u0001\u0435",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0030\u007a\u000a\u0437\uffc6\u007a",
            "\u0030\u007a\u000a\u0438\uffc6\u007a",
            "\u0001\u0439\u001f\uffff\u0001\u0439",
            "\u0001\u043a\u001f\uffff\u0001\u043a",
            "\u0001\u043b\u001f\uffff\u0001\u043b",
            "\u0001\u043c\u001f\uffff\u0001\u043c",
            "\u0001\u043d\u001f\uffff\u0001\u043d",
            "\u0001\u043e\u001f\uffff\u0001\u043e",
            "\u0001\u043f\u001f\uffff\u0001\u043f",
            "\u0001\u0440\u001f\uffff\u0001\u0440",
            "\u0001\u0441\u001f\uffff\u0001\u0441",
            "",
            "\u0022\u007a\u0001\u0386\uffdd\u007a",
            "\u0027\u007a\u0001\u0388\uffd8\u007a",
            "\u0001\u0442\u001f\uffff\u0001\u0442",
            "\u0001\u0443\u001f\uffff\u0001\u0443",
            "\u0001\u0444\u001f\uffff\u0001\u0444",
            "\u0001\u0445\u001f\uffff\u0001\u0445",
            "\u0001\u0446\u001f\uffff\u0001\u0446",
            "\u0001\u0447\u001f\uffff\u0001\u0447",
            "\u0001\u0448\u001f\uffff\u0001\u0448",
            "\u0001\u0449\u001f\uffff\u0001\u0449",
            "\u0001\u044a\u001f\uffff\u0001\u044a",
            "\u0001\u044b\u001f\uffff\u0001\u044b",
            "\u0001\u044c\u001f\uffff\u0001\u044c",
            "\u0001\u044d\u001f\uffff\u0001\u044d",
            "\u0001\u044e\u001f\uffff\u0001\u044e",
            "\u0001\u044f\u001f\uffff\u0001\u044f",
            "\u0001\u0450\u001f\uffff\u0001\u0450",
            "\u0001\u0451\u001f\uffff\u0001\u0451",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0453\u001f\uffff\u0001\u0453",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0455\u001f\uffff\u0001\u0455",
            "\u0001\u0456\u001f\uffff\u0001\u0456",
            "\u0001\u0457\u001f\uffff\u0001\u0457",
            "\u0001\u0458\u001f\uffff\u0001\u0458",
            "\u0001\u0459\u001f\uffff\u0001\u0459",
            "\u0001\u045a\u001f\uffff\u0001\u045a",
            "",
            "\u0001\u045b\u001f\uffff\u0001\u045b",
            "",
            "\u0001\u045d\u0003\uffff\u0001\u045c\u001b\uffff\u0001\u045d"+
            "\u0003\uffff\u0001\u045c",
            "\u0001\u045e\u001f\uffff\u0001\u045e",
            "\u0001\u045f\u001f\uffff\u0001\u045f",
            "\u0001\u0460\u001f\uffff\u0001\u0460",
            "\u0001\u0461\u001f\uffff\u0001\u0461",
            "\u0001\u0462\u001f\uffff\u0001\u0462",
            "\u0001\u0463\u001f\uffff\u0001\u0463",
            "\u0001\u0464\u001f\uffff\u0001\u0464",
            "\u0001\u0465\u001f\uffff\u0001\u0465",
            "\u0001\u0466\u001f\uffff\u0001\u0466",
            "\u0001\u0467\u001f\uffff\u0001\u0467",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0469\u001f\uffff\u0001\u0469",
            "\u0001\u046a\u001f\uffff\u0001\u046a",
            "\u0001\u046b\u001f\uffff\u0001\u046b",
            "\u0001\u046c\u001f\uffff\u0001\u046c",
            "\u0001\u046d\u001f\uffff\u0001\u046d",
            "\u0001\u046e\u001f\uffff\u0001\u046e",
            "\u0001\u046f\u001f\uffff\u0001\u046f",
            "",
            "\u0001\u0470\u001f\uffff\u0001\u0470",
            "\u0001\u0471\u001f\uffff\u0001\u0471",
            "\u0001\u0472\u001f\uffff\u0001\u0472",
            "\u0001\u0473\u001f\uffff\u0001\u0473",
            "\u0001\u0474\u001f\uffff\u0001\u0474",
            "\u0001\u0475\u001f\uffff\u0001\u0475",
            "\u0001\u0476\u001f\uffff\u0001\u0476",
            "\u0001\u0477\u001f\uffff\u0001\u0477",
            "\u0001\u0478\u001f\uffff\u0001\u0478",
            "\u0001\u0479\u001f\uffff\u0001\u0479",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u047b\u001f\uffff\u0001\u047b",
            "\u0001\u047c\u001f\uffff\u0001\u047c",
            "\u0001\u047d\u001f\uffff\u0001\u047d",
            "\u0001\u047e\u001f\uffff\u0001\u047e",
            "\u0001\u047f\u001f\uffff\u0001\u047f",
            "\u0001\u0480\u001f\uffff\u0001\u0480",
            "",
            "\u0001\u0481\u001f\uffff\u0001\u0481",
            "\u0001\u0482\u001f\uffff\u0001\u0482",
            "\u0001\u0483\u001f\uffff\u0001\u0483",
            "\u0001\u0484\u001f\uffff\u0001\u0484",
            "\u0001\u0485\u001f\uffff\u0001\u0485",
            "\u0001\u0486\u001f\uffff\u0001\u0486",
            "\u0001\u0487\u001f\uffff\u0001\u0487",
            "\u0001\u0488\u001f\uffff\u0001\u0488",
            "\u0001\u0489\u001f\uffff\u0001\u0489",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u048b\u001f\uffff\u0001\u048b",
            "\u0001\u048c\u001f\uffff\u0001\u048c",
            "\u0001\u048d\u001f\uffff\u0001\u048d",
            "\u0001\u048e\u001f\uffff\u0001\u048e",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u0001\u0490\u001f\uffff\u0001\u0490",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "\u0001\u0492\u001f\uffff\u0001\u0492",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u0001\u0494\u001f\uffff\u0001\u0494",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            "\u000a\u002b\u0007\uffff\u001a\u002b\u0004\uffff\u0001\u002b"+
            "\u0001\uffff\u001a\u002b",
            "",
            ""
        ]
    });

    org.antlr.lang.augmentObject(MentionQLexer, {
        DFA18_eot:
            org.antlr.runtime.DFA.unpackEncodedString(MentionQLexer.DFA18_eotS),
        DFA18_eof:
            org.antlr.runtime.DFA.unpackEncodedString(MentionQLexer.DFA18_eofS),
        DFA18_min:
            org.antlr.runtime.DFA.unpackEncodedStringToUnsignedChars(MentionQLexer.DFA18_minS),
        DFA18_max:
            org.antlr.runtime.DFA.unpackEncodedStringToUnsignedChars(MentionQLexer.DFA18_maxS),
        DFA18_accept:
            org.antlr.runtime.DFA.unpackEncodedString(MentionQLexer.DFA18_acceptS),
        DFA18_special:
            org.antlr.runtime.DFA.unpackEncodedString(MentionQLexer.DFA18_specialS),
        DFA18_transition: (function() {
            var a = [],
                i,
                numStates = MentionQLexer.DFA18_transitionS.length;
            for (i=0; i<numStates; i++) {
                a.push(org.antlr.runtime.DFA.unpackEncodedString(MentionQLexer.DFA18_transitionS[i]));
            }
            return a;
        })()
    });

    MentionQLexer.DFA18 = function(recognizer) {
        this.recognizer = recognizer;
        this.decisionNumber = 18;
        this.eot = MentionQLexer.DFA18_eot;
        this.eof = MentionQLexer.DFA18_eof;
        this.min = MentionQLexer.DFA18_min;
        this.max = MentionQLexer.DFA18_max;
        this.accept = MentionQLexer.DFA18_accept;
        this.special = MentionQLexer.DFA18_special;
        this.transition = MentionQLexer.DFA18_transition;
    };

    org.antlr.lang.extend(MentionQLexer.DFA18, org.antlr.runtime.DFA, {
        getDescription: function() {
            return "1:1: Tokens : ( NEWLINE | WHITESPACE | OR | AND | RELEVANCY | BRAND | SENTIMENT | CREDIBILITY | MEDIA | ACTION | PROCESS | PHRASE | PHRASE_COUNT | FEED | TITLE | LINK | SITE | AUTHOR_NAME | AUTHOR_LOCATION | CONTENT | LANGUAGE | PICKED_UP | UPDATED | LINKED | PHRASE_MATCHES | PAGE_RANK | ALEXA_RANK | PUBLISHED | PUBLISHEDTIME | TAG | TOPIC | SEGMENT | COUNTRY | REGION | CITY | RELEVANCY_VERIFIED | ASSIGNEE | AUTHOR | AUTHOR_ID | EXTRACT | SENTIMENT_VERIFIED | CROWD_VERIFIED | DISCARDED_BY | MENTION_ID | CROWD_ID | URI | ENGAGEMENT | REPLY_TO | REPLY_COUNT | GRAPH_REPLY_COUNT | RESHARE_OF | RESHARE_COUNT | GRAPH_RESHARE_COUNT | REPLY_ORDER_BY_AUTHOR | OTS | AVE | REACH | STATUS_COUNT | FOLLOWER_COUNT | GRAPH_FOLLOWER_COUNT | FOLLOWING_COUNT | CROWD_REGION | GENDER | RESPONSE_TIME | UNBIASED_SAMPLE | MENTIONED_PROFILE | RACE | DIRECT_MESSAGE | VISIBILITY | TICKET_ID | SOCIAL_NETWORK | AUTHOR_HANDLE | AUTHOR_HANDLE_ID | TO_NAME | TO_HANDLE | TO_HANDLE_ID | AUTHOR_BIO | CONVERSATION_ID | TOMBSTONED | SCRUBBED | HAS_REPLY_FROM_PROFILE | INTERACTION_ID | INTERACTION_RESPONSE_TIME | INTERACTION_FIRST_RESPONSE_TIME | INTERACTION_FOLLOWUP_RESPONSE_TIME | INTERACTION_WH_RESPONSE_TIME | INTERACTION_WH_FIRST_RESPONSE_TIME | INTERACTION_WH_FOLLOWUP_RESPONSE_TIME | INTERACTION_HAS_RESPONSE | INTERACTION_FIRST_MENTION_PUBLISHED | INTERACTION_LAST_MENTION_PUBLISHED | INTERACTION_FIRST_RESPONSE_PUBLISHED | UCN | TWITTER_SCREEN_NAME | HANDLE_ID | FACEBOOK_ID | IS | ISNT | ISORCHILDOF | BEFORE | AFTER | GREATERTHAN | GREATERTHANEQUALS | LESSTHAN | LESSTHANEQUALS | EQUALS | NOTEQUALS | CONTAINS | DOESNTCONTAIN | BEGINSWITH | ENDSWITH | MATCHES | ISNTNORCHILDOF | INTHELAST | BEFORETHELAST | ON | IN | NOTIN | DISTINCT | SAMPLE | PRESS | ENTERPRISE | CONSUMER | DIRECTORY | UNSORTED | RELEVANT | DUPLICATE | IRRELEVANT | SPAM | SORTED | VERIFIED | NONE | RESOLVED | UNRESOLVED | TODAY | HOUR | DAY | TWENTY_FOUR_HRS | WEEK | FORTNIGHT | MONTH | QUARTER | YEAR | EPOCH | FALSE | TRUE | MALE | FEMALE | OTHER | UNKNOWN | LONG_LITERAL | TAG_ID_LITERAL | FLOAT_LITERAL | DATE_LITERAL | STRING_LITERAL | ANNOTATION | LPAREN | RPAREN | COMMA | DIVIDE | LSQUARE | RSQUARE | ASC | DESC | COUNT | UNQUOTED_STRING_LITERAL );";
        },
        specialStateTransition: function(s, input) {
            var _s = s;
            /* bind to recognizer so semantic predicates can be evaluated */
            var retval = (function(s, input) {
                switch ( s ) {
                    case 0 :
                        var LA18_972 = input.LA(1);

                        s = -1;
                        if ( (LA18_972==':') ) {s = 997;}

                        else if ( ((LA18_972>='\u0000' && LA18_972<='9')||(LA18_972>=';' && LA18_972<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 1 :
                        var LA18_35 = input.LA(1);

                        s = -1;
                        if ( ((LA18_35>='0' && LA18_35<='9')) ) {s = 123;}

                        else if ( ((LA18_35>='\u0000' && LA18_35<='/')||(LA18_35>=':' && LA18_35<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 2 :
                        var LA18_973 = input.LA(1);

                        s = -1;
                        if ( (LA18_973==':') ) {s = 998;}

                        else if ( ((LA18_973>='\u0000' && LA18_973<='9')||(LA18_973>=';' && LA18_973<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 3 :
                        var LA18_34 = input.LA(1);

                        s = -1;
                        if ( ((LA18_34>='0' && LA18_34<='9')) ) {s = 121;}

                        else if ( ((LA18_34>='\u0000' && LA18_34<='/')||(LA18_34>=':' && LA18_34<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 4 :
                        var LA18_1036 = input.LA(1);

                        s = -1;
                        if ( (LA18_1036==':') ) {s = 1054;}

                        else if ( (LA18_1036=='\'') ) {s = 904;}

                        else if ( ((LA18_1036>='\u0000' && LA18_1036<='&')||(LA18_1036>='(' && LA18_1036<='9')||(LA18_1036>=';' && LA18_1036<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 5 :
                        var LA18_1035 = input.LA(1);

                        s = -1;
                        if ( (LA18_1035==':') ) {s = 1053;}

                        else if ( (LA18_1035=='\"') ) {s = 902;}

                        else if ( ((LA18_1035>='\u0000' && LA18_1035<='!')||(LA18_1035>='#' && LA18_1035<='9')||(LA18_1035>=';' && LA18_1035<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 6 :
                        var LA18_862 = input.LA(1);

                        s = -1;
                        if ( (LA18_862==' ') ) {s = 901;}

                        else if ( (LA18_862=='\"') ) {s = 902;}

                        else if ( ((LA18_862>='\u0000' && LA18_862<='\u001F')||LA18_862=='!'||(LA18_862>='#' && LA18_862<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 7 :
                        var LA18_863 = input.LA(1);

                        s = -1;
                        if ( (LA18_863==' ') ) {s = 903;}

                        else if ( (LA18_863=='\'') ) {s = 904;}

                        else if ( ((LA18_863>='\u0000' && LA18_863<='\u001F')||(LA18_863>='!' && LA18_863<='&')||(LA18_863>='(' && LA18_863<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 8 :
                        var LA18_1067 = input.LA(1);

                        s = -1;
                        if ( ((LA18_1067>='0' && LA18_1067<='9')) ) {s = 1079;}

                        else if ( ((LA18_1067>='\u0000' && LA18_1067<='/')||(LA18_1067>=':' && LA18_1067<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 9 :
                        var LA18_1016 = input.LA(1);

                        s = -1;
                        if ( ((LA18_1016>='0' && LA18_1016<='9')) ) {s = 1035;}

                        else if ( ((LA18_1016>='\u0000' && LA18_1016<='/')||(LA18_1016>=':' && LA18_1016<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 10 :
                        var LA18_938 = input.LA(1);

                        s = -1;
                        if ( ((LA18_938>='0' && LA18_938<='9')) ) {s = 972;}

                        else if ( ((LA18_938>='\u0000' && LA18_938<='/')||(LA18_938>=':' && LA18_938<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 11 :
                        var LA18_817 = input.LA(1);

                        s = -1;
                        if ( ((LA18_817>='0' && LA18_817<='9')) ) {s = 862;}

                        else if ( ((LA18_817>='\u0000' && LA18_817<='/')||(LA18_817>=':' && LA18_817<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 12 :
                        var LA18_762 = input.LA(1);

                        s = -1;
                        if ( ((LA18_762>='0' && LA18_762<='9')) ) {s = 817;}

                        else if ( ((LA18_762>='\u0000' && LA18_762<='/')||(LA18_762>=':' && LA18_762<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 13 :
                        var LA18_613 = input.LA(1);

                        s = -1;
                        if ( ((LA18_613>='0' && LA18_613<='9')) ) {s = 693;}

                        else if ( ((LA18_613>='\u0000' && LA18_613<='/')||(LA18_613>=':' && LA18_613<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 14 :
                        var LA18_525 = input.LA(1);

                        s = -1;
                        if ( ((LA18_525>='0' && LA18_525<='9')) ) {s = 613;}

                        else if ( ((LA18_525>='\u0000' && LA18_525<='/')||(LA18_525>=':' && LA18_525<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 15 :
                        var LA18_333 = input.LA(1);

                        s = -1;
                        if ( ((LA18_333>='0' && LA18_333<='9')) ) {s = 433;}

                        else if ( ((LA18_333>='\u0000' && LA18_333<='/')||(LA18_333>=':' && LA18_333<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 16 :
                        var LA18_693 = input.LA(1);

                        s = -1;
                        if ( (LA18_693=='-'||LA18_693=='/') ) {s = 762;}

                        else if ( ((LA18_693>='\u0000' && LA18_693<=',')||LA18_693=='.'||(LA18_693>='0' && LA18_693<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 17 :
                        var LA18_228 = input.LA(1);

                        s = -1;
                        if ( ((LA18_228>='0' && LA18_228<='9')) ) {s = 333;}

                        else if ( ((LA18_228>='\u0000' && LA18_228<='/')||(LA18_228>=':' && LA18_228<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 18 :
                        var LA18_121 = input.LA(1);

                        s = -1;
                        if ( ((LA18_121>='0' && LA18_121<='9')) ) {s = 228;}

                        else if ( ((LA18_121>='\u0000' && LA18_121<='/')||(LA18_121>=':' && LA18_121<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 19 :
                        var LA18_433 = input.LA(1);

                        s = -1;
                        if ( (LA18_433=='-'||LA18_433=='/') ) {s = 525;}

                        else if ( ((LA18_433>='\u0000' && LA18_433<=',')||LA18_433=='.'||(LA18_433>='0' && LA18_433<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 20 :
                        var LA18_1079 = input.LA(1);

                        s = -1;
                        if ( (LA18_1079=='\"') ) {s = 902;}

                        else if ( ((LA18_1079>='\u0000' && LA18_1079<='!')||(LA18_1079>='#' && LA18_1079<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 21 :
                        var LA18_434 = input.LA(1);

                        s = -1;
                        if ( (LA18_434=='-'||LA18_434=='/') ) {s = 526;}

                        else if ( ((LA18_434>='\u0000' && LA18_434<=',')||LA18_434=='.'||(LA18_434>='0' && LA18_434<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 22 :
                        var LA18_123 = input.LA(1);

                        s = -1;
                        if ( ((LA18_123>='0' && LA18_123<='9')) ) {s = 229;}

                        else if ( ((LA18_123>='\u0000' && LA18_123<='/')||(LA18_123>=':' && LA18_123<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 23 :
                        var LA18_229 = input.LA(1);

                        s = -1;
                        if ( ((LA18_229>='0' && LA18_229<='9')) ) {s = 334;}

                        else if ( ((LA18_229>='\u0000' && LA18_229<='/')||(LA18_229>=':' && LA18_229<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 24 :
                        var LA18_526 = input.LA(1);

                        s = -1;
                        if ( ((LA18_526>='0' && LA18_526<='9')) ) {s = 614;}

                        else if ( ((LA18_526>='\u0000' && LA18_526<='/')||(LA18_526>=':' && LA18_526<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 25 :
                        var LA18_334 = input.LA(1);

                        s = -1;
                        if ( ((LA18_334>='0' && LA18_334<='9')) ) {s = 434;}

                        else if ( ((LA18_334>='\u0000' && LA18_334<='/')||(LA18_334>=':' && LA18_334<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 26 :
                        var LA18_694 = input.LA(1);

                        s = -1;
                        if ( (LA18_694=='-'||LA18_694=='/') ) {s = 763;}

                        else if ( ((LA18_694>='\u0000' && LA18_694<=',')||LA18_694=='.'||(LA18_694>='0' && LA18_694<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 27 :
                        var LA18_1017 = input.LA(1);

                        s = -1;
                        if ( ((LA18_1017>='0' && LA18_1017<='9')) ) {s = 1036;}

                        else if ( ((LA18_1017>='\u0000' && LA18_1017<='/')||(LA18_1017>=':' && LA18_1017<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 28 :
                        var LA18_901 = input.LA(1);

                        s = -1;
                        if ( ((LA18_901>='0' && LA18_901<='9')) ) {s = 938;}

                        else if ( ((LA18_901>='\u0000' && LA18_901<='/')||(LA18_901>=':' && LA18_901<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 29 :
                        var LA18_1068 = input.LA(1);

                        s = -1;
                        if ( ((LA18_1068>='0' && LA18_1068<='9')) ) {s = 1080;}

                        else if ( ((LA18_1068>='\u0000' && LA18_1068<='/')||(LA18_1068>=':' && LA18_1068<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 30 :
                        var LA18_818 = input.LA(1);

                        s = -1;
                        if ( ((LA18_818>='0' && LA18_818<='9')) ) {s = 863;}

                        else if ( ((LA18_818>='\u0000' && LA18_818<='/')||(LA18_818>=':' && LA18_818<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 31 :
                        var LA18_997 = input.LA(1);

                        s = -1;
                        if ( ((LA18_997>='0' && LA18_997<='9')) ) {s = 1016;}

                        else if ( ((LA18_997>='\u0000' && LA18_997<='/')||(LA18_997>=':' && LA18_997<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 32 :
                        var LA18_614 = input.LA(1);

                        s = -1;
                        if ( ((LA18_614>='0' && LA18_614<='9')) ) {s = 694;}

                        else if ( ((LA18_614>='\u0000' && LA18_614<='/')||(LA18_614>=':' && LA18_614<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 33 :
                        var LA18_763 = input.LA(1);

                        s = -1;
                        if ( ((LA18_763>='0' && LA18_763<='9')) ) {s = 818;}

                        else if ( ((LA18_763>='\u0000' && LA18_763<='/')||(LA18_763>=':' && LA18_763<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 34 :
                        var LA18_940 = input.LA(1);

                        s = -1;
                        if ( ((LA18_940>='0' && LA18_940<='9')) ) {s = 973;}

                        else if ( ((LA18_940>='\u0000' && LA18_940<='/')||(LA18_940>=':' && LA18_940<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 35 :
                        var LA18_1053 = input.LA(1);

                        s = -1;
                        if ( ((LA18_1053>='0' && LA18_1053<='9')) ) {s = 1067;}

                        else if ( ((LA18_1053>='\u0000' && LA18_1053<='/')||(LA18_1053>=':' && LA18_1053<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 36 :
                        var LA18_1080 = input.LA(1);

                        s = -1;
                        if ( (LA18_1080=='\'') ) {s = 904;}

                        else if ( ((LA18_1080>='\u0000' && LA18_1080<='&')||(LA18_1080>='(' && LA18_1080<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 37 :
                        var LA18_1054 = input.LA(1);

                        s = -1;
                        if ( ((LA18_1054>='0' && LA18_1054<='9')) ) {s = 1068;}

                        else if ( ((LA18_1054>='\u0000' && LA18_1054<='/')||(LA18_1054>=':' && LA18_1054<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 38 :
                        var LA18_998 = input.LA(1);

                        s = -1;
                        if ( ((LA18_998>='0' && LA18_998<='9')) ) {s = 1017;}

                        else if ( ((LA18_998>='\u0000' && LA18_998<='/')||(LA18_998>=':' && LA18_998<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                    case 39 :
                        var LA18_903 = input.LA(1);

                        s = -1;
                        if ( ((LA18_903>='0' && LA18_903<='9')) ) {s = 940;}

                        else if ( ((LA18_903>='\u0000' && LA18_903<='/')||(LA18_903>=':' && LA18_903<='\uFFFF')) ) {s = 122;}

                        if ( s>=0 ) return s;
                        break;
                }
            }).call(this.recognizer, s, input);
            if (!org.antlr.lang.isUndefined(retval)) {
                return retval;
            }
            var nvae =
                new org.antlr.runtime.NoViableAltException(this.getDescription(), 18, _s, input);
            this.error(nvae);
            throw nvae;
        },
        dummy: null
    });

})();

/**
 * Provides parsing capabilities for the BrandsEye DSLs.
 */

//------------------------------------------------------


function DataItemNode(type, image) {
    this.type = type;
    this.image = image;
    this.descending = false;
}

//------------------------------------------------------

/**
 * Represents a node in which the two children should be
 * ANDed together.
 */
function AndNode(lhs, rhs) {
    this.type = "AndNode";
    this.lhs = lhs;
    this.rhs = rhs;
}

AndNode.prototype.toString = function() {
    var lp = this.lhs && this.lhs.type == 'OrNode';
    var rp = this.rhs && this.rhs.type == 'OrNode';
    return (lp?"(":"") + this.lhs + (lp?")":"") + " AND " + (rp?"(":"") + this.rhs + (rp?")":"");
};

AndNode.prototype.visit = function(visitor) {

    if (this.lhs !== null) {
        this.lhs.visit(visitor);
    }
    if (this.rhs !== null) {
        this.rhs.visit(visitor);
    }

    visitor.acceptAndNode(this);
};

//------------------------------------------------------

/**
 * A node with two children that should be ORed.
 */
function OrNode(lhs, rhs) {
    this.type = "OrNode";
    this.lhs = lhs;
    this.rhs = rhs;
}

OrNode.prototype.toString = function() {
    return this.lhs + " OR " + this.rhs;
};

OrNode.prototype.visit = function(visitor) {

    if (this.lhs !== null) {
        this.lhs.visit(visitor);
    }
    if (this.rhs !== null) {
        this.rhs.visit(visitor);
    }

    visitor.acceptOrNode(this);
};

//------------------------------------------------------


/**
 * An expression node, which is the basic unit of a filter.
 * It contains an operand field name from a mention,
 * a literal value, and a operation (relation) between the two.
 */
function ExpNode(operandType, operandImage,
                 operationType, operationImage,
                 literal, literalImage) {
    this.type = "ExpNode";
    this.operandType = operandType;
    this.operandImage = operandImage;
    this.operationType = operationType;
    this.operationImage = operationImage;
    this.literal = literal;
    this.literalImage = literalImage;
}

ExpNode.prototype.toString = function() {
    if (this.operationType == MentionQLexer.SAMPLE) return this.operationImage + this.literalImage;
    if (this.operationType == MentionQLexer.IN || this.operationType == MentionQLexer.NOTIN) {
        return this.operandImage + " " + this.operationImage + " (" + this.literalImage + ")";
    }
    return this.operandImage + " " + this.operationImage + " " + this.literalImage;
};

ExpNode.prototype.visit = function(visitor) {
    visitor.acceptExpNode(this);
};

function createExpNode(operand, operator, literalTok)  {
    var literal = getLiteralValue(literalTok);

    var type = operand.getType();
    if (type == MentionQLexer.TOPIC || type == MentionQLexer.SEGMENT) {
        type = MentionQLexer.TAG;
    }

    return new ExpNode(type, operand.getText(),
        operator.getType(), operator.getText(),
        literal, literalTok.getText());
}

function createAttrExpNode(operand, literal) {
    if (operand.getType() === MentionQLexer.COUNTRY) {
        literal.setText((literal.getText()).trim().toUpperCase());
    } else if (operand.getType() === MentionQLexer.LANGUAGE || operand.getType() === MentionQLexer.TAG) {
        literal.setText(literal.getText().trim().toLowerCase());
    }

    var operator = new org.antlr.runtime.CommonToken(MentionQLexer.EQUALS, "=");

    return new ExpNode(operand.getType(), operand.getText(),
        operator.getType(), operator.getText(),
        getLiteralValue(literal), literal.getText());
}

function createSampleNode(proportion, seed)  {
    var sa = { proportion: parseFloat(proportion.getText()) };
    if (seed) sa.seed = parseInt(seed.getText());
    sa.toString = function() { return "(" + this.proportion + (this.seed ? "," + this.seed : "") + ")"; };
    return new ExpNode(MentionQLexer.SAMPLE, "sample", MentionQLexer.SAMPLE, "sample", sa, sa.toString());
}

//------------------------------------------------------

function unescape(string, quoteChar) {
    var result = [];

    var n = string.length;
    for (var i = 0; i < n; i++) {
        var c = string.charAt(i);
        if (c === '\\' && i < n - 1) {
            var p = string.charAt(i + 1);
            if (p === quoteChar || p === '\\') {
                c = p;
                i++;
            }
        }
        result.push(c);
    }

    return result.join("");
}

function getAnnotationValue(ann) {
    return ann ? unescape(ann.substring(2, ann.length - 1), ann.charAt(1)) : ann;
}

function getLiteralValue(literalTok) {
    var literal = literalTok.getType();

    if (literalTok.getType() == MentionQLexer.LONG_LITERAL) {
        literal = parseInt(literalTok.getText());
    } else if (literalTok.getType() == MentionQLexer.TAG_ID_LITERAL) {
        literal = parseInt(literalTok.getText().substring(1));
    } else if (literalTok.getType() == MentionQLexer.DATE_LITERAL) {
        literal = literalTok.getText();
    } else if (literalTok.getType() == MentionQLexer.STRING_LITERAL) {
        literal = unescape(literalTok.getText().substring(1, literalTok.getText().length - 1), literalTok.getText().charAt(0));
    } else if (literalTok.getType() == MentionQLexer.TRUE) {
        literal = true;
    } else if (literalTok.getType() == MentionQLexer.FALSE) {
        literal = false;
    } else if (literalTok.getType() == MentionQLexer.UNKNOWN) {
        literal = null;
    }

    return literal;
}

//------------------------------------------------------

function verifyUpdateProperties(node) {

    switch(node.operandType) {
        case MentionQLexer.SENTIMENT:
            var sent = node.literal;
            if (sent < -5) throw new Error("Sentiment cannot be less than -5");
            if (sent > 5) throw new Error("Sentiment cannot be greater than 5");
            if (sent == 0) throw new Error("Sentiment cannot be zero.");
            break;
        case MentionQLexer.CREDIBILITY:
            if (node.literal != null) {
                var cred = node.literal;
                if (cred < 0) throw new Error("Credibility cannot be less than 0");
                if (cred > 9) throw new Error("Credibility cannot be greater than 9");
            }
            break;
    }
}

//------------------------------------------------------

function FilterParser() {}

FilterParser.prototype.parse = function(data) {
    var input = new org.antlr.runtime.ANTLRStringStream(data),
        lexer = new MentionQLexer(input),
        tokens = new org.antlr.runtime.CommonTokenStream(lexer),
        parser = new MentionQAst(tokens),
        tree = parser.filter().getTree(),
        nodes = new org.antlr.runtime.tree.CommonTreeNodeStream(tree),
        walker = new MentionQFilterParser(nodes);

    return walker.filter();
};

function AttributeParser() {}
AttributeParser.prototype.parse = function(data) {
    var input = new org.antlr.runtime.ANTLRStringStream(data),
        lexer = new MentionQLexer(input),
        tokens = new org.antlr.runtime.CommonTokenStream(lexer),
        parser = new MentionQAst(tokens),
        tree = parser.attributes().getTree(),
        nodes = new org.antlr.runtime.tree.CommonTreeNodeStream(tree),
        walker = new MentionQAttributeParser(nodes);

    return walker.attributes();
};



var operand, operation, literal, mre, sf_operand, sf_operation, proportion, seed;

export {
    AndNode,
    OrNode,
    ExpNode,
    FilterParser,
    AttributeParser,
    MentionQLexer,
    MentionQAst
}
